/*! jQuery v1.12.4 | (c) jQuery Foundation | jquery.org/license | WordPress 2019-05-16 */
!(function (a, b) {
  "object" == typeof module && "object" == typeof module.exports
    ? (module.exports = a.document
        ? b(a, !0)
        : function (a) {
            if (!a.document)
              throw new Error("jQuery requires a window with a document");
            return b(a);
          })
    : b(a);
})("undefined" != typeof window ? window : this, function (a, b) {
  var c = [],
    d = a.document,
    e = c.slice,
    f = c.concat,
    g = c.push,
    h = c.indexOf,
    i = {},
    j = i.toString,
    k = i.hasOwnProperty,
    l = {},
    m = "1.12.4",
    n = function (a, b) {
      return new n.fn.init(a, b);
    },
    o = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
    p = /^-ms-/,
    q = /-([\da-z])/gi,
    r = function (a, b) {
      return b.toUpperCase();
    };
  (n.fn = n.prototype =
    {
      jquery: m,
      constructor: n,
      selector: "",
      length: 0,
      toArray: function () {
        return e.call(this);
      },
      get: function (a) {
        return null != a
          ? a < 0
            ? this[a + this.length]
            : this[a]
          : e.call(this);
      },
      pushStack: function (a) {
        var b = n.merge(this.constructor(), a);
        return (b.prevObject = this), (b.context = this.context), b;
      },
      each: function (a) {
        return n.each(this, a);
      },
      map: function (a) {
        return this.pushStack(
          n.map(this, function (b, c) {
            return a.call(b, c, b);
          })
        );
      },
      slice: function () {
        return this.pushStack(e.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      eq: function (a) {
        var b = this.length,
          c = +a + (a < 0 ? b : 0);
        return this.pushStack(c >= 0 && c < b ? [this[c]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: g,
      sort: c.sort,
      splice: c.splice,
    }),
    (n.extend = n.fn.extend =
      function () {
        var a,
          b,
          c,
          d,
          e,
          f,
          g = arguments[0] || {},
          h = 1,
          i = arguments.length,
          j = !1;
        for (
          "boolean" == typeof g && ((j = g), (g = arguments[h] || {}), h++),
            "object" == typeof g || n.isFunction(g) || (g = {}),
            h === i && ((g = this), h--);
          h < i;
          h++
        )
          if (null != (e = arguments[h]))
            for (d in e)
              (a = g[d]),
                (c = e[d]),
                "__proto__" !== d &&
                  g !== c &&
                  (j && c && (n.isPlainObject(c) || (b = n.isArray(c)))
                    ? (b
                        ? ((b = !1), (f = a && n.isArray(a) ? a : []))
                        : (f = a && n.isPlainObject(a) ? a : {}),
                      (g[d] = n.extend(j, f, c)))
                    : void 0 !== c && (g[d] = c));
        return g;
      }),
    n.extend({
      expando: "jQuery" + (m + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function (a) {
        throw new Error(a);
      },
      noop: function () {},
      isFunction: function (a) {
        return "function" === n.type(a);
      },
      isArray:
        Array.isArray ||
        function (a) {
          return "array" === n.type(a);
        },
      isWindow: function (a) {
        return null != a && a == a.window;
      },
      isNumeric: function (a) {
        var b = a && a.toString();
        return !n.isArray(a) && b - parseFloat(b) + 1 >= 0;
      },
      isEmptyObject: function (a) {
        var b;
        for (b in a) return !1;
        return !0;
      },
      isPlainObject: function (a) {
        var b;
        if (!a || "object" !== n.type(a) || a.nodeType || n.isWindow(a))
          return !1;
        try {
          if (
            a.constructor &&
            !k.call(a, "constructor") &&
            !k.call(a.constructor.prototype, "isPrototypeOf")
          )
            return !1;
        } catch (c) {
          return !1;
        }
        if (!l.ownFirst) for (b in a) return k.call(a, b);
        for (b in a);
        return void 0 === b || k.call(a, b);
      },
      type: function (a) {
        return null == a
          ? a + ""
          : "object" == typeof a || "function" == typeof a
          ? i[j.call(a)] || "object"
          : typeof a;
      },
      globalEval: function (b) {
        b &&
          n.trim(b) &&
          (
            a.execScript ||
            function (b) {
              a.eval.call(a, b);
            }
          )(b);
      },
      camelCase: function (a) {
        return a.replace(p, "ms-").replace(q, r);
      },
      nodeName: function (a, b) {
        return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase();
      },
      each: function (a, b) {
        var c,
          d = 0;
        if (s(a)) {
          for (c = a.length; d < c; d++)
            if (!1 === b.call(a[d], d, a[d])) break;
        } else for (d in a) if (!1 === b.call(a[d], d, a[d])) break;
        return a;
      },
      trim: function (a) {
        return null == a ? "" : (a + "").replace(o, "");
      },
      makeArray: function (a, b) {
        var c = b || [];
        return (
          null != a &&
            (s(Object(a))
              ? n.merge(c, "string" == typeof a ? [a] : a)
              : g.call(c, a)),
          c
        );
      },
      inArray: function (a, b, c) {
        var d;
        if (b) {
          if (h) return h.call(b, a, c);
          for (
            d = b.length, c = c ? (c < 0 ? Math.max(0, d + c) : c) : 0;
            c < d;
            c++
          )
            if (c in b && b[c] === a) return c;
        }
        return -1;
      },
      merge: function (a, b) {
        var c = +b.length,
          d = 0,
          e = a.length;
        while (d < c) a[e++] = b[d++];
        if (c !== c) while (void 0 !== b[d]) a[e++] = b[d++];
        return (a.length = e), a;
      },
      grep: function (a, b, c) {
        for (var d, e = [], f = 0, g = a.length, h = !c; f < g; f++)
          (d = !b(a[f], f)) !== h && e.push(a[f]);
        return e;
      },
      map: function (a, b, c) {
        var d,
          e,
          g = 0,
          h = [];
        if (s(a))
          for (d = a.length; g < d; g++)
            null != (e = b(a[g], g, c)) && h.push(e);
        else for (g in a) null != (e = b(a[g], g, c)) && h.push(e);
        return f.apply([], h);
      },
      guid: 1,
      proxy: function (a, b) {
        var c, d, f;
        if (
          ("string" == typeof b && ((f = a[b]), (b = a), (a = f)),
          n.isFunction(a))
        )
          return (
            (c = e.call(arguments, 2)),
            (d = function () {
              return a.apply(b || this, c.concat(e.call(arguments)));
            }),
            (d.guid = a.guid = a.guid || n.guid++),
            d
          );
      },
      now: function () {
        return +new Date();
      },
      support: l,
    }),
    "function" == typeof Symbol && (n.fn[Symbol.iterator] = c[Symbol.iterator]),
    n.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
        " "
      ),
      function (a, b) {
        i["[object " + b + "]"] = b.toLowerCase();
      }
    );
  function s(a) {
    var b = !!a && "length" in a && a.length,
      c = n.type(a);
    return (
      "function" !== c &&
      !n.isWindow(a) &&
      ("array" === c ||
        0 === b ||
        ("number" == typeof b && b > 0 && b - 1 in a))
    );
  }
  var t = (function (a) {
    var b,
      c,
      d,
      e,
      f,
      g,
      h,
      i,
      j,
      k,
      l,
      m,
      n,
      o,
      p,
      q,
      r,
      s,
      t,
      u = "sizzle" + 1 * new Date(),
      v = a.document,
      w = 0,
      x = 0,
      y = fa(),
      z = fa(),
      A = fa(),
      B = function (a, b) {
        return a === b && (l = !0), 0;
      },
      C = 1 << 31,
      D = {}.hasOwnProperty,
      E = [],
      F = E.pop,
      G = E.push,
      H = E.push,
      I = E.slice,
      J = function (a, b) {
        for (var c = 0, d = a.length; c < d; c++) if (a[c] === b) return c;
        return -1;
      },
      K =
        "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
      L = "[\\x20\\t\\r\\n\\f]",
      M = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
      N =
        "\\[" +
        L +
        "*(" +
        M +
        ")(?:" +
        L +
        "*([*^$|!~]?=)" +
        L +
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
        M +
        "))|)" +
        L +
        "*\\]",
      O =
        ":(" +
        M +
        ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
        N +
        ")*)|.*)\\)|)",
      P = new RegExp(L + "+", "g"),
      Q = new RegExp("^" + L + "+|((?:^|[^\\\\])(?:\\\\.)*)" + L + "+$", "g"),
      R = new RegExp("^" + L + "*," + L + "*"),
      S = new RegExp("^" + L + "*([>+~]|" + L + ")" + L + "*"),
      T = new RegExp("=" + L + "*([^\\]'\"]*?)" + L + "*\\]", "g"),
      U = new RegExp(O),
      V = new RegExp("^" + M + "$"),
      W = {
        ID: new RegExp("^#(" + M + ")"),
        CLASS: new RegExp("^\\.(" + M + ")"),
        TAG: new RegExp("^(" + M + "|[*])"),
        ATTR: new RegExp("^" + N),
        PSEUDO: new RegExp("^" + O),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            L +
            "*(even|odd|(([+-]|)(\\d*)n|)" +
            L +
            "*(?:([+-]|)" +
            L +
            "*(\\d+)|))" +
            L +
            "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + K + ")$", "i"),
        needsContext: new RegExp(
          "^" +
            L +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
            L +
            "*((?:-\\d)?\\d*)" +
            L +
            "*\\)|)(?=[^-]|$)",
          "i"
        ),
      },
      X = /^(?:input|select|textarea|button)$/i,
      Y = /^h\d$/i,
      Z = /^[^{]+\{\s*\[native \w/,
      $ = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      _ = /[+~]/,
      aa = /'|\\/g,
      ba = new RegExp("\\\\([\\da-f]{1,6}" + L + "?|(" + L + ")|.)", "ig"),
      ca = function (a, b, c) {
        var d = "0x" + b - 65536;
        return d !== d || c
          ? b
          : d < 0
          ? String.fromCharCode(d + 65536)
          : String.fromCharCode((d >> 10) | 55296, (1023 & d) | 56320);
      },
      da = function () {
        m();
      };
    try {
      H.apply((E = I.call(v.childNodes)), v.childNodes),
        E[v.childNodes.length].nodeType;
    } catch (xa) {
      H = {
        apply: E.length
          ? function (a, b) {
              G.apply(a, I.call(b));
            }
          : function (a, b) {
              var c = a.length,
                d = 0;
              while ((a[c++] = b[d++]));
              a.length = c - 1;
            },
      };
    }
    function ea(a, b, d, e) {
      var f,
        h,
        j,
        k,
        l,
        o,
        r,
        s,
        w = b && b.ownerDocument,
        x = b ? b.nodeType : 9;
      if (
        ((d = d || []),
        "string" != typeof a || !a || (1 !== x && 9 !== x && 11 !== x))
      )
        return d;
      if (
        !e &&
        ((b ? b.ownerDocument || b : v) !== n && m(b), (b = b || n), p)
      ) {
        if (11 !== x && (o = $.exec(a)))
          if ((f = o[1])) {
            if (9 === x) {
              if (!(j = b.getElementById(f))) return d;
              if (j.id === f) return d.push(j), d;
            } else if (w && (j = w.getElementById(f)) && t(b, j) && j.id === f)
              return d.push(j), d;
          } else {
            if (o[2]) return H.apply(d, b.getElementsByTagName(a)), d;
            if (
              (f = o[3]) &&
              c.getElementsByClassName &&
              b.getElementsByClassName
            )
              return H.apply(d, b.getElementsByClassName(f)), d;
          }
        if (c.qsa && !A[a + " "] && (!q || !q.test(a))) {
          if (1 !== x) (w = b), (s = a);
          else if ("object" !== b.nodeName.toLowerCase()) {
            (k = b.getAttribute("id"))
              ? (k = k.replace(aa, "\\$&"))
              : b.setAttribute("id", (k = u)),
              (r = g(a)),
              (h = r.length),
              (l = V.test(k) ? "#" + k : "[id='" + k + "']");
            while (h--) r[h] = l + " " + pa(r[h]);
            (s = r.join(",")), (w = (_.test(a) && na(b.parentNode)) || b);
          }
          if (s)
            try {
              return H.apply(d, w.querySelectorAll(s)), d;
            } catch (y) {
            } finally {
              k === u && b.removeAttribute("id");
            }
        }
      }
      return i(a.replace(Q, "$1"), b, d, e);
    }
    function fa() {
      var a = [];
      function b(c, e) {
        return (
          a.push(c + " ") > d.cacheLength && delete b[a.shift()],
          (b[c + " "] = e)
        );
      }
      return b;
    }
    function ga(a) {
      return (a[u] = !0), a;
    }
    function ha(a) {
      var b = n.createElement("div");
      try {
        return !!a(b);
      } catch (xa) {
        return !1;
      } finally {
        b.parentNode && b.parentNode.removeChild(b), (b = null);
      }
    }
    function ia(a, b) {
      var c = a.split("|"),
        e = c.length;
      while (e--) d.attrHandle[c[e]] = b;
    }
    function ja(a, b) {
      var c = b && a,
        d =
          c &&
          1 === a.nodeType &&
          1 === b.nodeType &&
          (~b.sourceIndex || C) - (~a.sourceIndex || C);
      if (d) return d;
      if (c) while ((c = c.nextSibling)) if (c === b) return -1;
      return a ? 1 : -1;
    }
    function ka(a) {
      return function (b) {
        return "input" === b.nodeName.toLowerCase() && b.type === a;
      };
    }
    function la(a) {
      return function (b) {
        var c = b.nodeName.toLowerCase();
        return ("input" === c || "button" === c) && b.type === a;
      };
    }
    function ma(a) {
      return ga(function (b) {
        return (
          (b = +b),
          ga(function (c, d) {
            var e,
              f = a([], c.length, b),
              g = f.length;
            while (g--) c[(e = f[g])] && (c[e] = !(d[e] = c[e]));
          })
        );
      });
    }
    function na(a) {
      return a && void 0 !== a.getElementsByTagName && a;
    }
    (c = ea.support = {}),
      (f = ea.isXML =
        function (a) {
          var b = a && (a.ownerDocument || a).documentElement;
          return !!b && "HTML" !== b.nodeName;
        }),
      (m = ea.setDocument =
        function (a) {
          var b,
            e,
            g = a ? a.ownerDocument || a : v;
          return g !== n && 9 === g.nodeType && g.documentElement
            ? ((n = g),
              (o = n.documentElement),
              (p = !f(n)),
              (e = n.defaultView) &&
                e.top !== e &&
                (e.addEventListener
                  ? e.addEventListener("unload", da, !1)
                  : e.attachEvent && e.attachEvent("onunload", da)),
              (c.attributes = ha(function (a) {
                return (a.className = "i"), !a.getAttribute("className");
              })),
              (c.getElementsByTagName = ha(function (a) {
                return (
                  a.appendChild(n.createComment("")),
                  !a.getElementsByTagName("*").length
                );
              })),
              (c.getElementsByClassName = Z.test(n.getElementsByClassName)),
              (c.getById = ha(function (a) {
                return (
                  (o.appendChild(a).id = u),
                  !n.getElementsByName || !n.getElementsByName(u).length
                );
              })),
              c.getById
                ? ((d.find.ID = function (a, b) {
                    if (void 0 !== b.getElementById && p) {
                      var c = b.getElementById(a);
                      return c ? [c] : [];
                    }
                  }),
                  (d.filter.ID = function (a) {
                    var b = a.replace(ba, ca);
                    return function (a) {
                      return a.getAttribute("id") === b;
                    };
                  }))
                : (delete d.find.ID,
                  (d.filter.ID = function (a) {
                    var b = a.replace(ba, ca);
                    return function (a) {
                      var c =
                        void 0 !== a.getAttributeNode &&
                        a.getAttributeNode("id");
                      return c && c.value === b;
                    };
                  })),
              (d.find.TAG = c.getElementsByTagName
                ? function (a, b) {
                    return void 0 !== b.getElementsByTagName
                      ? b.getElementsByTagName(a)
                      : c.qsa
                      ? b.querySelectorAll(a)
                      : void 0;
                  }
                : function (a, b) {
                    var c,
                      d = [],
                      e = 0,
                      f = b.getElementsByTagName(a);
                    if ("*" === a) {
                      while ((c = f[e++])) 1 === c.nodeType && d.push(c);
                      return d;
                    }
                    return f;
                  }),
              (d.find.CLASS =
                c.getElementsByClassName &&
                function (a, b) {
                  if (void 0 !== b.getElementsByClassName && p)
                    return b.getElementsByClassName(a);
                }),
              (r = []),
              (q = []),
              (c.qsa = Z.test(n.querySelectorAll)) &&
                (ha(function (a) {
                  (o.appendChild(a).innerHTML =
                    "<a id='" +
                    u +
                    "'></a><select id='" +
                    u +
                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                    a.querySelectorAll("[msallowcapture^='']").length &&
                      q.push("[*^$]=" + L + "*(?:''|\"\")"),
                    a.querySelectorAll("[selected]").length ||
                      q.push("\\[" + L + "*(?:value|" + K + ")"),
                    a.querySelectorAll("[id~=" + u + "-]").length ||
                      q.push("~="),
                    a.querySelectorAll(":checked").length || q.push(":checked"),
                    a.querySelectorAll("a#" + u + "+*").length ||
                      q.push(".#.+[+~]");
                }),
                ha(function (a) {
                  var b = n.createElement("input");
                  b.setAttribute("type", "hidden"),
                    a.appendChild(b).setAttribute("name", "D"),
                    a.querySelectorAll("[name=d]").length &&
                      q.push("name" + L + "*[*^$|!~]?="),
                    a.querySelectorAll(":enabled").length ||
                      q.push(":enabled", ":disabled"),
                    a.querySelectorAll("*,:x"),
                    q.push(",.*:");
                })),
              (c.matchesSelector = Z.test(
                (s =
                  o.matches ||
                  o.webkitMatchesSelector ||
                  o.mozMatchesSelector ||
                  o.oMatchesSelector ||
                  o.msMatchesSelector)
              )) &&
                ha(function (a) {
                  (c.disconnectedMatch = s.call(a, "div")),
                    s.call(a, "[s!='']:x"),
                    r.push("!=", O);
                }),
              (q = q.length && new RegExp(q.join("|"))),
              (r = r.length && new RegExp(r.join("|"))),
              (b = Z.test(o.compareDocumentPosition)),
              (t =
                b || Z.test(o.contains)
                  ? function (a, b) {
                      var c = 9 === a.nodeType ? a.documentElement : a,
                        d = b && b.parentNode;
                      return (
                        a === d ||
                        !(
                          !d ||
                          1 !== d.nodeType ||
                          !(c.contains
                            ? c.contains(d)
                            : a.compareDocumentPosition &&
                              16 & a.compareDocumentPosition(d))
                        )
                      );
                    }
                  : function (a, b) {
                      if (b) while ((b = b.parentNode)) if (b === a) return !0;
                      return !1;
                    }),
              (B = b
                ? function (a, b) {
                    if (a === b) return (l = !0), 0;
                    var d =
                      !a.compareDocumentPosition - !b.compareDocumentPosition;
                    return (
                      d ||
                      ((d =
                        (a.ownerDocument || a) === (b.ownerDocument || b)
                          ? a.compareDocumentPosition(b)
                          : 1),
                      1 & d ||
                      (!c.sortDetached && b.compareDocumentPosition(a) === d)
                        ? a === n || (a.ownerDocument === v && t(v, a))
                          ? -1
                          : b === n || (b.ownerDocument === v && t(v, b))
                          ? 1
                          : k
                          ? J(k, a) - J(k, b)
                          : 0
                        : 4 & d
                        ? -1
                        : 1)
                    );
                  }
                : function (a, b) {
                    if (a === b) return (l = !0), 0;
                    var c,
                      d = 0,
                      e = a.parentNode,
                      f = b.parentNode,
                      g = [a],
                      h = [b];
                    if (!e || !f)
                      return a === n
                        ? -1
                        : b === n
                        ? 1
                        : e
                        ? -1
                        : f
                        ? 1
                        : k
                        ? J(k, a) - J(k, b)
                        : 0;
                    if (e === f) return ja(a, b);
                    c = a;
                    while ((c = c.parentNode)) g.unshift(c);
                    c = b;
                    while ((c = c.parentNode)) h.unshift(c);
                    while (g[d] === h[d]) d++;
                    return d
                      ? ja(g[d], h[d])
                      : g[d] === v
                      ? -1
                      : h[d] === v
                      ? 1
                      : 0;
                  }),
              n)
            : n;
        }),
      (ea.matches = function (a, b) {
        return ea(a, null, null, b);
      }),
      (ea.matchesSelector = function (a, b) {
        if (
          ((a.ownerDocument || a) !== n && m(a),
          (b = b.replace(T, "='$1']")),
          c.matchesSelector &&
            p &&
            !A[b + " "] &&
            (!r || !r.test(b)) &&
            (!q || !q.test(b)))
        )
          try {
            var d = s.call(a, b);
            if (
              d ||
              c.disconnectedMatch ||
              (a.document && 11 !== a.document.nodeType)
            )
              return d;
          } catch (xa) {}
        return ea(b, n, null, [a]).length > 0;
      }),
      (ea.contains = function (a, b) {
        return (a.ownerDocument || a) !== n && m(a), t(a, b);
      }),
      (ea.attr = function (a, b) {
        (a.ownerDocument || a) !== n && m(a);
        var e = d.attrHandle[b.toLowerCase()],
          f = e && D.call(d.attrHandle, b.toLowerCase()) ? e(a, b, !p) : void 0;
        return void 0 !== f
          ? f
          : c.attributes || !p
          ? a.getAttribute(b)
          : (f = a.getAttributeNode(b)) && f.specified
          ? f.value
          : null;
      }),
      (ea.error = function (a) {
        throw new Error("Syntax error, unrecognized expression: " + a);
      }),
      (ea.uniqueSort = function (a) {
        var b,
          d = [],
          e = 0,
          f = 0;
        if (
          ((l = !c.detectDuplicates),
          (k = !c.sortStable && a.slice(0)),
          a.sort(B),
          l)
        ) {
          while ((b = a[f++])) b === a[f] && (e = d.push(f));
          while (e--) a.splice(d[e], 1);
        }
        return (k = null), a;
      }),
      (e = ea.getText =
        function (a) {
          var b,
            c = "",
            d = 0,
            f = a.nodeType;
          if (f) {
            if (1 === f || 9 === f || 11 === f) {
              if ("string" == typeof a.textContent) return a.textContent;
              for (a = a.firstChild; a; a = a.nextSibling) c += e(a);
            } else if (3 === f || 4 === f) return a.nodeValue;
          } else while ((b = a[d++])) c += e(b);
          return c;
        }),
      (d = ea.selectors =
        {
          cacheLength: 50,
          createPseudo: ga,
          match: W,
          attrHandle: {},
          find: {},
          relative: {
            ">": { dir: "parentNode", first: !0 },
            " ": { dir: "parentNode" },
            "+": { dir: "previousSibling", first: !0 },
            "~": { dir: "previousSibling" },
          },
          preFilter: {
            ATTR: function (a) {
              return (
                (a[1] = a[1].replace(ba, ca)),
                (a[3] = (a[3] || a[4] || a[5] || "").replace(ba, ca)),
                "~=" === a[2] && (a[3] = " " + a[3] + " "),
                a.slice(0, 4)
              );
            },
            CHILD: function (a) {
              return (
                (a[1] = a[1].toLowerCase()),
                "nth" === a[1].slice(0, 3)
                  ? (a[3] || ea.error(a[0]),
                    (a[4] = +(a[4]
                      ? a[5] + (a[6] || 1)
                      : 2 * ("even" === a[3] || "odd" === a[3]))),
                    (a[5] = +(a[7] + a[8] || "odd" === a[3])))
                  : a[3] && ea.error(a[0]),
                a
              );
            },
            PSEUDO: function (a) {
              var b,
                c = !a[6] && a[2];
              return W.CHILD.test(a[0])
                ? null
                : (a[3]
                    ? (a[2] = a[4] || a[5] || "")
                    : c &&
                      U.test(c) &&
                      (b = g(c, !0)) &&
                      (b = c.indexOf(")", c.length - b) - c.length) &&
                      ((a[0] = a[0].slice(0, b)), (a[2] = c.slice(0, b))),
                  a.slice(0, 3));
            },
          },
          filter: {
            TAG: function (a) {
              var b = a.replace(ba, ca).toLowerCase();
              return "*" === a
                ? function () {
                    return !0;
                  }
                : function (a) {
                    return a.nodeName && a.nodeName.toLowerCase() === b;
                  };
            },
            CLASS: function (a) {
              var b = y[a + " "];
              return (
                b ||
                ((b = new RegExp("(^|" + L + ")" + a + "(" + L + "|$)")) &&
                  y(a, function (a) {
                    return b.test(
                      ("string" == typeof a.className && a.className) ||
                        (void 0 !== a.getAttribute &&
                          a.getAttribute("class")) ||
                        ""
                    );
                  }))
              );
            },
            ATTR: function (a, b, c) {
              return function (d) {
                var e = ea.attr(d, a);
                return null == e
                  ? "!=" === b
                  : !b ||
                      ((e += ""),
                      "=" === b
                        ? e === c
                        : "!=" === b
                        ? e !== c
                        : "^=" === b
                        ? c && 0 === e.indexOf(c)
                        : "*=" === b
                        ? c && e.indexOf(c) > -1
                        : "$=" === b
                        ? c && e.slice(-c.length) === c
                        : "~=" === b
                        ? (" " + e.replace(P, " ") + " ").indexOf(c) > -1
                        : "|=" === b &&
                          (e === c || e.slice(0, c.length + 1) === c + "-"));
              };
            },
            CHILD: function (a, b, c, d, e) {
              var f = "nth" !== a.slice(0, 3),
                g = "last" !== a.slice(-4),
                h = "of-type" === b;
              return 1 === d && 0 === e
                ? function (a) {
                    return !!a.parentNode;
                  }
                : function (b, c, i) {
                    var j,
                      k,
                      l,
                      m,
                      n,
                      o,
                      p = f !== g ? "nextSibling" : "previousSibling",
                      q = b.parentNode,
                      r = h && b.nodeName.toLowerCase(),
                      s = !i && !h,
                      t = !1;
                    if (q) {
                      if (f) {
                        while (p) {
                          m = b;
                          while ((m = m[p]))
                            if (
                              h
                                ? m.nodeName.toLowerCase() === r
                                : 1 === m.nodeType
                            )
                              return !1;
                          o = p = "only" === a && !o && "nextSibling";
                        }
                        return !0;
                      }
                      if (((o = [g ? q.firstChild : q.lastChild]), g && s)) {
                        (m = q),
                          (l = m[u] || (m[u] = {})),
                          (k = l[m.uniqueID] || (l[m.uniqueID] = {})),
                          (j = k[a] || []),
                          (n = j[0] === w && j[1]),
                          (t = n && j[2]),
                          (m = n && q.childNodes[n]);
                        while (
                          (m = (++n && m && m[p]) || (t = n = 0) || o.pop())
                        )
                          if (1 === m.nodeType && ++t && m === b) {
                            k[a] = [w, n, t];
                            break;
                          }
                      } else if (
                        (s &&
                          ((m = b),
                          (l = m[u] || (m[u] = {})),
                          (k = l[m.uniqueID] || (l[m.uniqueID] = {})),
                          (j = k[a] || []),
                          (n = j[0] === w && j[1]),
                          (t = n)),
                        !1 === t)
                      )
                        while (
                          (m = (++n && m && m[p]) || (t = n = 0) || o.pop())
                        )
                          if (
                            (h
                              ? m.nodeName.toLowerCase() === r
                              : 1 === m.nodeType) &&
                            ++t &&
                            (s &&
                              ((l = m[u] || (m[u] = {})),
                              (k = l[m.uniqueID] || (l[m.uniqueID] = {})),
                              (k[a] = [w, t])),
                            m === b)
                          )
                            break;
                      return (t -= e) === d || (t % d == 0 && t / d >= 0);
                    }
                  };
            },
            PSEUDO: function (a, b) {
              var c,
                e =
                  d.pseudos[a] ||
                  d.setFilters[a.toLowerCase()] ||
                  ea.error("unsupported pseudo: " + a);
              return e[u]
                ? e(b)
                : e.length > 1
                ? ((c = [a, a, "", b]),
                  d.setFilters.hasOwnProperty(a.toLowerCase())
                    ? ga(function (a, c) {
                        var d,
                          f = e(a, b),
                          g = f.length;
                        while (g--) (d = J(a, f[g])), (a[d] = !(c[d] = f[g]));
                      })
                    : function (a) {
                        return e(a, 0, c);
                      })
                : e;
            },
          },
          pseudos: {
            not: ga(function (a) {
              var b = [],
                c = [],
                d = h(a.replace(Q, "$1"));
              return d[u]
                ? ga(function (a, b, c, e) {
                    var f,
                      g = d(a, null, e, []),
                      h = a.length;
                    while (h--) (f = g[h]) && (a[h] = !(b[h] = f));
                  })
                : function (a, e, f) {
                    return (
                      (b[0] = a), d(b, null, f, c), (b[0] = null), !c.pop()
                    );
                  };
            }),
            has: ga(function (a) {
              return function (b) {
                return ea(a, b).length > 0;
              };
            }),
            contains: ga(function (a) {
              return (
                (a = a.replace(ba, ca)),
                function (b) {
                  return (b.textContent || b.innerText || e(b)).indexOf(a) > -1;
                }
              );
            }),
            lang: ga(function (a) {
              return (
                V.test(a || "") || ea.error("unsupported lang: " + a),
                (a = a.replace(ba, ca).toLowerCase()),
                function (b) {
                  var c;
                  do {
                    if (
                      (c = p
                        ? b.lang
                        : b.getAttribute("xml:lang") || b.getAttribute("lang"))
                    )
                      return (
                        (c = c.toLowerCase()) === a || 0 === c.indexOf(a + "-")
                      );
                  } while ((b = b.parentNode) && 1 === b.nodeType);
                  return !1;
                }
              );
            }),
            target: function (b) {
              var c = a.location && a.location.hash;
              return c && c.slice(1) === b.id;
            },
            root: function (a) {
              return a === o;
            },
            focus: function (a) {
              return (
                a === n.activeElement &&
                (!n.hasFocus || n.hasFocus()) &&
                !!(a.type || a.href || ~a.tabIndex)
              );
            },
            enabled: function (a) {
              return !1 === a.disabled;
            },
            disabled: function (a) {
              return !0 === a.disabled;
            },
            checked: function (a) {
              var b = a.nodeName.toLowerCase();
              return (
                ("input" === b && !!a.checked) ||
                ("option" === b && !!a.selected)
              );
            },
            selected: function (a) {
              return (
                a.parentNode && a.parentNode.selectedIndex, !0 === a.selected
              );
            },
            empty: function (a) {
              for (a = a.firstChild; a; a = a.nextSibling)
                if (a.nodeType < 6) return !1;
              return !0;
            },
            parent: function (a) {
              return !d.pseudos.empty(a);
            },
            header: function (a) {
              return Y.test(a.nodeName);
            },
            input: function (a) {
              return X.test(a.nodeName);
            },
            button: function (a) {
              var b = a.nodeName.toLowerCase();
              return ("input" === b && "button" === a.type) || "button" === b;
            },
            text: function (a) {
              var b;
              return (
                "input" === a.nodeName.toLowerCase() &&
                "text" === a.type &&
                (null == (b = a.getAttribute("type")) ||
                  "text" === b.toLowerCase())
              );
            },
            first: ma(function () {
              return [0];
            }),
            last: ma(function (a, b) {
              return [b - 1];
            }),
            eq: ma(function (a, b, c) {
              return [c < 0 ? c + b : c];
            }),
            even: ma(function (a, b) {
              for (var c = 0; c < b; c += 2) a.push(c);
              return a;
            }),
            odd: ma(function (a, b) {
              for (var c = 1; c < b; c += 2) a.push(c);
              return a;
            }),
            lt: ma(function (a, b, c) {
              for (var d = c < 0 ? c + b : c; --d >= 0; ) a.push(d);
              return a;
            }),
            gt: ma(function (a, b, c) {
              for (var d = c < 0 ? c + b : c; ++d < b; ) a.push(d);
              return a;
            }),
          },
        }),
      (d.pseudos.nth = d.pseudos.eq);
    for (b in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
      d.pseudos[b] = ka(b);
    for (b in { submit: !0, reset: !0 }) d.pseudos[b] = la(b);
    function oa() {}
    (oa.prototype = d.filters = d.pseudos),
      (d.setFilters = new oa()),
      (g = ea.tokenize =
        function (a, b) {
          var c,
            e,
            f,
            g,
            h,
            i,
            j,
            k = z[a + " "];
          if (k) return b ? 0 : k.slice(0);
          (h = a), (i = []), (j = d.preFilter);
          while (h) {
            (c && !(e = R.exec(h))) ||
              (e && (h = h.slice(e[0].length) || h), i.push((f = []))),
              (c = !1),
              (e = S.exec(h)) &&
                ((c = e.shift()),
                f.push({ value: c, type: e[0].replace(Q, " ") }),
                (h = h.slice(c.length)));
            for (g in d.filter)
              !(e = W[g].exec(h)) ||
                (j[g] && !(e = j[g](e))) ||
                ((c = e.shift()),
                f.push({ value: c, type: g, matches: e }),
                (h = h.slice(c.length)));
            if (!c) break;
          }
          return b ? h.length : h ? ea.error(a) : z(a, i).slice(0);
        });
    function pa(a) {
      for (var b = 0, c = a.length, d = ""; b < c; b++) d += a[b].value;
      return d;
    }
    function qa(a, b, c) {
      var d = b.dir,
        e = c && "parentNode" === d,
        f = x++;
      return b.first
        ? function (b, c, f) {
            while ((b = b[d])) if (1 === b.nodeType || e) return a(b, c, f);
          }
        : function (b, c, g) {
            var h,
              i,
              j,
              k = [w, f];
            if (g) {
              while ((b = b[d]))
                if ((1 === b.nodeType || e) && a(b, c, g)) return !0;
            } else
              while ((b = b[d]))
                if (1 === b.nodeType || e) {
                  if (
                    ((j = b[u] || (b[u] = {})),
                    (i = j[b.uniqueID] || (j[b.uniqueID] = {})),
                    (h = i[d]) && h[0] === w && h[1] === f)
                  )
                    return (k[2] = h[2]);
                  if (((i[d] = k), (k[2] = a(b, c, g)))) return !0;
                }
          };
    }
    function ra(a) {
      return a.length > 1
        ? function (b, c, d) {
            var e = a.length;
            while (e--) if (!a[e](b, c, d)) return !1;
            return !0;
          }
        : a[0];
    }
    function sa(a, b, c) {
      for (var d = 0, e = b.length; d < e; d++) ea(a, b[d], c);
      return c;
    }
    function ta(a, b, c, d, e) {
      for (var f, g = [], h = 0, i = a.length, j = null != b; h < i; h++)
        (f = a[h]) && ((c && !c(f, d, e)) || (g.push(f), j && b.push(h)));
      return g;
    }
    function ua(a, b, c, d, e, f) {
      return (
        d && !d[u] && (d = ua(d)),
        e && !e[u] && (e = ua(e, f)),
        ga(function (f, g, h, i) {
          var j,
            k,
            l,
            m = [],
            n = [],
            o = g.length,
            p = f || sa(b || "*", h.nodeType ? [h] : h, []),
            q = !a || (!f && b) ? p : ta(p, m, a, h, i),
            r = c ? (e || (f ? a : o || d) ? [] : g) : q;
          if ((c && c(q, r, h, i), d)) {
            (j = ta(r, n)), d(j, [], h, i), (k = j.length);
            while (k--) (l = j[k]) && (r[n[k]] = !(q[n[k]] = l));
          }
          if (f) {
            if (e || a) {
              if (e) {
                (j = []), (k = r.length);
                while (k--) (l = r[k]) && j.push((q[k] = l));
                e(null, (r = []), j, i);
              }
              k = r.length;
              while (k--)
                (l = r[k]) &&
                  (j = e ? J(f, l) : m[k]) > -1 &&
                  (f[j] = !(g[j] = l));
            }
          } else (r = ta(r === g ? r.splice(o, r.length) : r)), e ? e(null, g, r, i) : H.apply(g, r);
        })
      );
    }
    function va(a) {
      for (
        var b,
          c,
          e,
          f = a.length,
          g = d.relative[a[0].type],
          h = g || d.relative[" "],
          i = g ? 1 : 0,
          k = qa(
            function (a) {
              return a === b;
            },
            h,
            !0
          ),
          l = qa(
            function (a) {
              return J(b, a) > -1;
            },
            h,
            !0
          ),
          m = [
            function (a, c, d) {
              var e =
                (!g && (d || c !== j)) ||
                ((b = c).nodeType ? k(a, c, d) : l(a, c, d));
              return (b = null), e;
            },
          ];
        i < f;
        i++
      )
        if ((c = d.relative[a[i].type])) m = [qa(ra(m), c)];
        else {
          if (((c = d.filter[a[i].type].apply(null, a[i].matches)), c[u])) {
            for (e = ++i; e < f; e++) if (d.relative[a[e].type]) break;
            return ua(
              i > 1 && ra(m),
              i > 1 &&
                pa(
                  a
                    .slice(0, i - 1)
                    .concat({ value: " " === a[i - 2].type ? "*" : "" })
                ).replace(Q, "$1"),
              c,
              i < e && va(a.slice(i, e)),
              e < f && va((a = a.slice(e))),
              e < f && pa(a)
            );
          }
          m.push(c);
        }
      return ra(m);
    }
    function wa(a, b) {
      var c = b.length > 0,
        e = a.length > 0,
        f = function (f, g, h, i, k) {
          var l,
            o,
            q,
            r = 0,
            s = "0",
            t = f && [],
            u = [],
            v = j,
            x = f || (e && d.find.TAG("*", k)),
            y = (w += null == v ? 1 : Math.random() || 0.1),
            z = x.length;
          for (
            k && (j = g === n || g || k);
            s !== z && null != (l = x[s]);
            s++
          ) {
            if (e && l) {
              (o = 0), g || l.ownerDocument === n || (m(l), (h = !p));
              while ((q = a[o++]))
                if (q(l, g || n, h)) {
                  i.push(l);
                  break;
                }
              k && (w = y);
            }
            c && ((l = !q && l) && r--, f && t.push(l));
          }
          if (((r += s), c && s !== r)) {
            o = 0;
            while ((q = b[o++])) q(t, u, g, h);
            if (f) {
              if (r > 0) while (s--) t[s] || u[s] || (u[s] = F.call(i));
              u = ta(u);
            }
            H.apply(i, u),
              k && !f && u.length > 0 && r + b.length > 1 && ea.uniqueSort(i);
          }
          return k && ((w = y), (j = v)), t;
        };
      return c ? ga(f) : f;
    }
    return (
      (h = ea.compile =
        function (a, b) {
          var c,
            d = [],
            e = [],
            f = A[a + " "];
          if (!f) {
            b || (b = g(a)), (c = b.length);
            while (c--) (f = va(b[c])), f[u] ? d.push(f) : e.push(f);
            (f = A(a, wa(e, d))), (f.selector = a);
          }
          return f;
        }),
      (i = ea.select =
        function (a, b, e, f) {
          var i,
            j,
            k,
            l,
            m,
            n = "function" == typeof a && a,
            o = !f && g((a = n.selector || a));
          if (((e = e || []), 1 === o.length)) {
            if (
              ((j = o[0] = o[0].slice(0)),
              j.length > 2 &&
                "ID" === (k = j[0]).type &&
                c.getById &&
                9 === b.nodeType &&
                p &&
                d.relative[j[1].type])
            ) {
              if (!(b = (d.find.ID(k.matches[0].replace(ba, ca), b) || [])[0]))
                return e;
              n && (b = b.parentNode), (a = a.slice(j.shift().value.length));
            }
            i = W.needsContext.test(a) ? 0 : j.length;
            while (i--) {
              if (((k = j[i]), d.relative[(l = k.type)])) break;
              if (
                (m = d.find[l]) &&
                (f = m(
                  k.matches[0].replace(ba, ca),
                  (_.test(j[0].type) && na(b.parentNode)) || b
                ))
              ) {
                if ((j.splice(i, 1), !(a = f.length && pa(j))))
                  return H.apply(e, f), e;
                break;
              }
            }
          }
          return (
            (n || h(a, o))(
              f,
              b,
              !p,
              e,
              !b || (_.test(a) && na(b.parentNode)) || b
            ),
            e
          );
        }),
      (c.sortStable = u.split("").sort(B).join("") === u),
      (c.detectDuplicates = !!l),
      m(),
      (c.sortDetached = ha(function (a) {
        return 1 & a.compareDocumentPosition(n.createElement("div"));
      })),
      ha(function (a) {
        return (
          (a.innerHTML = "<a href='#'></a>"),
          "#" === a.firstChild.getAttribute("href")
        );
      }) ||
        ia("type|href|height|width", function (a, b, c) {
          if (!c) return a.getAttribute(b, "type" === b.toLowerCase() ? 1 : 2);
        }),
      (c.attributes &&
        ha(function (a) {
          return (
            (a.innerHTML = "<input/>"),
            a.firstChild.setAttribute("value", ""),
            "" === a.firstChild.getAttribute("value")
          );
        })) ||
        ia("value", function (a, b, c) {
          if (!c && "input" === a.nodeName.toLowerCase()) return a.defaultValue;
        }),
      ha(function (a) {
        return null == a.getAttribute("disabled");
      }) ||
        ia(K, function (a, b, c) {
          var d;
          if (!c)
            return !0 === a[b]
              ? b.toLowerCase()
              : (d = a.getAttributeNode(b)) && d.specified
              ? d.value
              : null;
        }),
      ea
    );
  })(a);
  (n.find = t),
    (n.expr = t.selectors),
    (n.expr[":"] = n.expr.pseudos),
    (n.uniqueSort = n.unique = t.uniqueSort),
    (n.text = t.getText),
    (n.isXMLDoc = t.isXML),
    (n.contains = t.contains);
  var u = function (a, b, c) {
      var d = [],
        e = void 0 !== c;
      while ((a = a[b]) && 9 !== a.nodeType)
        if (1 === a.nodeType) {
          if (e && n(a).is(c)) break;
          d.push(a);
        }
      return d;
    },
    v = function (a, b) {
      for (var c = []; a; a = a.nextSibling)
        1 === a.nodeType && a !== b && c.push(a);
      return c;
    },
    w = n.expr.match.needsContext,
    x = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
    y = /^.[^:#\[\.,]*$/;
  function z(a, b, c) {
    if (n.isFunction(b))
      return n.grep(a, function (a, d) {
        return !!b.call(a, d, a) !== c;
      });
    if (b.nodeType)
      return n.grep(a, function (a) {
        return (a === b) !== c;
      });
    if ("string" == typeof b) {
      if (y.test(b)) return n.filter(b, a, c);
      b = n.filter(b, a);
    }
    return n.grep(a, function (a) {
      return n.inArray(a, b) > -1 !== c;
    });
  }
  (n.filter = function (a, b, c) {
    var d = b[0];
    return (
      c && (a = ":not(" + a + ")"),
      1 === b.length && 1 === d.nodeType
        ? n.find.matchesSelector(d, a)
          ? [d]
          : []
        : n.find.matches(
            a,
            n.grep(b, function (a) {
              return 1 === a.nodeType;
            })
          )
    );
  }),
    n.fn.extend({
      find: function (a) {
        var b,
          c = [],
          d = this,
          e = d.length;
        if ("string" != typeof a)
          return this.pushStack(
            n(a).filter(function () {
              for (b = 0; b < e; b++) if (n.contains(d[b], this)) return !0;
            })
          );
        for (b = 0; b < e; b++) n.find(a, d[b], c);
        return (
          (c = this.pushStack(e > 1 ? n.unique(c) : c)),
          (c.selector = this.selector ? this.selector + " " + a : a),
          c
        );
      },
      filter: function (a) {
        return this.pushStack(z(this, a || [], !1));
      },
      not: function (a) {
        return this.pushStack(z(this, a || [], !0));
      },
      is: function (a) {
        return !!z(this, "string" == typeof a && w.test(a) ? n(a) : a || [], !1)
          .length;
      },
    });
  var A,
    B = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
  ((n.fn.init = function (a, b, c) {
    var e, f;
    if (!a) return this;
    if (((c = c || A), "string" == typeof a)) {
      if (
        !(e =
          "<" === a.charAt(0) && ">" === a.charAt(a.length - 1) && a.length >= 3
            ? [null, a, null]
            : B.exec(a)) ||
        (!e[1] && b)
      )
        return !b || b.jquery ? (b || c).find(a) : this.constructor(b).find(a);
      if (e[1]) {
        if (
          ((b = b instanceof n ? b[0] : b),
          n.merge(
            this,
            n.parseHTML(e[1], b && b.nodeType ? b.ownerDocument || b : d, !0)
          ),
          x.test(e[1]) && n.isPlainObject(b))
        )
          for (e in b)
            n.isFunction(this[e]) ? this[e](b[e]) : this.attr(e, b[e]);
        return this;
      }
      if ((f = d.getElementById(e[2])) && f.parentNode) {
        if (f.id !== e[2]) return A.find(a);
        (this.length = 1), (this[0] = f);
      }
      return (this.context = d), (this.selector = a), this;
    }
    return a.nodeType
      ? ((this.context = this[0] = a), (this.length = 1), this)
      : n.isFunction(a)
      ? void 0 !== c.ready
        ? c.ready(a)
        : a(n)
      : (void 0 !== a.selector &&
          ((this.selector = a.selector), (this.context = a.context)),
        n.makeArray(a, this));
  }).prototype = n.fn),
    (A = n(d));
  var C = /^(?:parents|prev(?:Until|All))/,
    D = { children: !0, contents: !0, next: !0, prev: !0 };
  n.fn.extend({
    has: function (a) {
      var b,
        c = n(a, this),
        d = c.length;
      return this.filter(function () {
        for (b = 0; b < d; b++) if (n.contains(this, c[b])) return !0;
      });
    },
    closest: function (a, b) {
      for (
        var c,
          d = 0,
          e = this.length,
          f = [],
          g = w.test(a) || "string" != typeof a ? n(a, b || this.context) : 0;
        d < e;
        d++
      )
        for (c = this[d]; c && c !== b; c = c.parentNode)
          if (
            c.nodeType < 11 &&
            (g
              ? g.index(c) > -1
              : 1 === c.nodeType && n.find.matchesSelector(c, a))
          ) {
            f.push(c);
            break;
          }
      return this.pushStack(f.length > 1 ? n.uniqueSort(f) : f);
    },
    index: function (a) {
      return a
        ? "string" == typeof a
          ? n.inArray(this[0], n(a))
          : n.inArray(a.jquery ? a[0] : a, this)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (a, b) {
      return this.pushStack(n.uniqueSort(n.merge(this.get(), n(a, b))));
    },
    addBack: function (a) {
      return this.add(null == a ? this.prevObject : this.prevObject.filter(a));
    },
  });
  function E(a, b) {
    do {
      a = a[b];
    } while (a && 1 !== a.nodeType);
    return a;
  }
  n.each(
    {
      parent: function (a) {
        var b = a.parentNode;
        return b && 11 !== b.nodeType ? b : null;
      },
      parents: function (a) {
        return u(a, "parentNode");
      },
      parentsUntil: function (a, b, c) {
        return u(a, "parentNode", c);
      },
      next: function (a) {
        return E(a, "nextSibling");
      },
      prev: function (a) {
        return E(a, "previousSibling");
      },
      nextAll: function (a) {
        return u(a, "nextSibling");
      },
      prevAll: function (a) {
        return u(a, "previousSibling");
      },
      nextUntil: function (a, b, c) {
        return u(a, "nextSibling", c);
      },
      prevUntil: function (a, b, c) {
        return u(a, "previousSibling", c);
      },
      siblings: function (a) {
        return v((a.parentNode || {}).firstChild, a);
      },
      children: function (a) {
        return v(a.firstChild);
      },
      contents: function (a) {
        return n.nodeName(a, "iframe")
          ? a.contentDocument || a.contentWindow.document
          : n.merge([], a.childNodes);
      },
    },
    function (a, b) {
      n.fn[a] = function (c, d) {
        var e = n.map(this, b, c);
        return (
          "Until" !== a.slice(-5) && (d = c),
          d && "string" == typeof d && (e = n.filter(d, e)),
          this.length > 1 &&
            (D[a] || (e = n.uniqueSort(e)), C.test(a) && (e = e.reverse())),
          this.pushStack(e)
        );
      };
    }
  );
  var F = /\S+/g;
  function G(a) {
    var b = {};
    return (
      n.each(a.match(F) || [], function (a, c) {
        b[c] = !0;
      }),
      b
    );
  }
  (n.Callbacks = function (a) {
    a = "string" == typeof a ? G(a) : n.extend({}, a);
    var b,
      c,
      d,
      e,
      f = [],
      g = [],
      h = -1,
      i = function () {
        for (e = a.once, d = b = !0; g.length; h = -1) {
          c = g.shift();
          while (++h < f.length)
            !1 === f[h].apply(c[0], c[1]) &&
              a.stopOnFalse &&
              ((h = f.length), (c = !1));
        }
        a.memory || (c = !1), (b = !1), e && (f = c ? [] : "");
      },
      j = {
        add: function () {
          return (
            f &&
              (c && !b && ((h = f.length - 1), g.push(c)),
              (function b(c) {
                n.each(c, function (c, d) {
                  n.isFunction(d)
                    ? (a.unique && j.has(d)) || f.push(d)
                    : d && d.length && "string" !== n.type(d) && b(d);
                });
              })(arguments),
              c && !b && i()),
            this
          );
        },
        remove: function () {
          return (
            n.each(arguments, function (a, b) {
              var c;
              while ((c = n.inArray(b, f, c)) > -1)
                f.splice(c, 1), c <= h && h--;
            }),
            this
          );
        },
        has: function (a) {
          return a ? n.inArray(a, f) > -1 : f.length > 0;
        },
        empty: function () {
          return f && (f = []), this;
        },
        disable: function () {
          return (e = g = []), (f = c = ""), this;
        },
        disabled: function () {
          return !f;
        },
        lock: function () {
          return (e = !0), c || j.disable(), this;
        },
        locked: function () {
          return !!e;
        },
        fireWith: function (a, c) {
          return (
            e ||
              ((c = c || []),
              (c = [a, c.slice ? c.slice() : c]),
              g.push(c),
              b || i()),
            this
          );
        },
        fire: function () {
          return j.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!d;
        },
      };
    return j;
  }),
    n.extend({
      Deferred: function (a) {
        var b = [
            ["resolve", "done", n.Callbacks("once memory"), "resolved"],
            ["reject", "fail", n.Callbacks("once memory"), "rejected"],
            ["notify", "progress", n.Callbacks("memory")],
          ],
          c = "pending",
          d = {
            state: function () {
              return c;
            },
            always: function () {
              return e.done(arguments).fail(arguments), this;
            },
            then: function () {
              var a = arguments;
              return n
                .Deferred(function (c) {
                  n.each(b, function (b, f) {
                    var g = n.isFunction(a[b]) && a[b];
                    e[f[1]](function () {
                      var a = g && g.apply(this, arguments);
                      a && n.isFunction(a.promise)
                        ? a
                            .promise()
                            .progress(c.notify)
                            .done(c.resolve)
                            .fail(c.reject)
                        : c[f[0] + "With"](
                            this === d ? c.promise() : this,
                            g ? [a] : arguments
                          );
                    });
                  }),
                    (a = null);
                })
                .promise();
            },
            promise: function (a) {
              return null != a ? n.extend(a, d) : d;
            },
          },
          e = {};
        return (
          (d.pipe = d.then),
          n.each(b, function (a, f) {
            var g = f[2],
              h = f[3];
            (d[f[1]] = g.add),
              h &&
                g.add(
                  function () {
                    c = h;
                  },
                  b[1 ^ a][2].disable,
                  b[2][2].lock
                ),
              (e[f[0]] = function () {
                return e[f[0] + "With"](this === e ? d : this, arguments), this;
              }),
              (e[f[0] + "With"] = g.fireWith);
          }),
          d.promise(e),
          a && a.call(e, e),
          e
        );
      },
      when: function (a) {
        var b = 0,
          c = e.call(arguments),
          d = c.length,
          f = 1 !== d || (a && n.isFunction(a.promise)) ? d : 0,
          g = 1 === f ? a : n.Deferred(),
          h = function (a, b, c) {
            return function (d) {
              (b[a] = this),
                (c[a] = arguments.length > 1 ? e.call(arguments) : d),
                c === i ? g.notifyWith(b, c) : --f || g.resolveWith(b, c);
            };
          },
          i,
          j,
          k;
        if (d > 1)
          for (i = new Array(d), j = new Array(d), k = new Array(d); b < d; b++)
            c[b] && n.isFunction(c[b].promise)
              ? c[b]
                  .promise()
                  .progress(h(b, j, i))
                  .done(h(b, k, c))
                  .fail(g.reject)
              : --f;
        return f || g.resolveWith(k, c), g.promise();
      },
    });
  var H;
  (n.fn.ready = function (a) {
    return n.ready.promise().done(a), this;
  }),
    n.extend({
      isReady: !1,
      readyWait: 1,
      holdReady: function (a) {
        a ? n.readyWait++ : n.ready(!0);
      },
      ready: function (a) {
        (!0 === a ? --n.readyWait : n.isReady) ||
          ((n.isReady = !0),
          (!0 !== a && --n.readyWait > 0) ||
            (H.resolveWith(d, [n]),
            n.fn.triggerHandler &&
              (n(d).triggerHandler("ready"), n(d).off("ready"))));
      },
    });
  function I() {
    d.addEventListener
      ? (d.removeEventListener("DOMContentLoaded", J),
        a.removeEventListener("load", J))
      : (d.detachEvent("onreadystatechange", J), a.detachEvent("onload", J));
  }
  function J() {
    (d.addEventListener ||
      "load" === a.event.type ||
      "complete" === d.readyState) &&
      (I(), n.ready());
  }
  (n.ready.promise = function (b) {
    if (!H)
      if (
        ((H = n.Deferred()),
        "complete" === d.readyState ||
          ("loading" !== d.readyState && !d.documentElement.doScroll))
      )
        a.setTimeout(n.ready);
      else if (d.addEventListener)
        d.addEventListener("DOMContentLoaded", J),
          a.addEventListener("load", J);
      else {
        d.attachEvent("onreadystatechange", J), a.attachEvent("onload", J);
        var c = !1;
        try {
          c = null == a.frameElement && d.documentElement;
        } catch (e) {}
        c &&
          c.doScroll &&
          (function b() {
            if (!n.isReady) {
              try {
                c.doScroll("left");
              } catch (e) {
                return a.setTimeout(b, 50);
              }
              I(), n.ready();
            }
          })();
      }
    return H.promise(b);
  }),
    n.ready.promise();
  var K;
  for (K in n(l)) break;
  (l.ownFirst = "0" === K),
    (l.inlineBlockNeedsLayout = !1),
    n(function () {
      var a, b, c, e;
      (c = d.getElementsByTagName("body")[0]) &&
        c.style &&
        ((b = d.createElement("div")),
        (e = d.createElement("div")),
        (e.style.cssText =
          "position:absolute;border:0;width:0;height:0;top:0;left:-9999px"),
        c.appendChild(e).appendChild(b),
        void 0 !== b.style.zoom &&
          ((b.style.cssText =
            "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1"),
          (l.inlineBlockNeedsLayout = a = 3 === b.offsetWidth),
          a && (c.style.zoom = 1)),
        c.removeChild(e));
    }),
    (function () {
      var a = d.createElement("div");
      l.deleteExpando = !0;
      try {
        delete a.test;
      } catch (b) {
        l.deleteExpando = !1;
      }
      a = null;
    })();
  var L = function (a) {
      var b = n.noData[(a.nodeName + " ").toLowerCase()],
        c = +a.nodeType || 1;
      return (
        (1 === c || 9 === c) &&
        (!b || (!0 !== b && a.getAttribute("classid") === b))
      );
    },
    M = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    N = /([A-Z])/g;
  function O(a, b, c) {
    if (void 0 === c && 1 === a.nodeType) {
      var d = "data-" + b.replace(N, "-$1").toLowerCase();
      if ("string" == typeof (c = a.getAttribute(d))) {
        try {
          c =
            "true" === c ||
            ("false" !== c &&
              ("null" === c
                ? null
                : +c + "" === c
                ? +c
                : M.test(c)
                ? n.parseJSON(c)
                : c));
        } catch (e) {}
        n.data(a, b, c);
      } else c = void 0;
    }
    return c;
  }
  function P(a) {
    var b;
    for (b in a)
      if (("data" !== b || !n.isEmptyObject(a[b])) && "toJSON" !== b) return !1;
    return !0;
  }
  function Q(a, b, d, e) {
    if (L(a)) {
      var f,
        g,
        h = n.expando,
        i = a.nodeType,
        j = i ? n.cache : a,
        k = i ? a[h] : a[h] && h;
      if (
        (k && j[k] && (e || j[k].data)) ||
        void 0 !== d ||
        "string" != typeof b
      )
        return (
          k || (k = i ? (a[h] = c.pop() || n.guid++) : h),
          j[k] || (j[k] = i ? {} : { toJSON: n.noop }),
          ("object" != typeof b && "function" != typeof b) ||
            (e
              ? (j[k] = n.extend(j[k], b))
              : (j[k].data = n.extend(j[k].data, b))),
          (g = j[k]),
          e || (g.data || (g.data = {}), (g = g.data)),
          void 0 !== d && (g[n.camelCase(b)] = d),
          "string" == typeof b
            ? null == (f = g[b]) && (f = g[n.camelCase(b)])
            : (f = g),
          f
        );
    }
  }
  function R(a, b, c) {
    if (L(a)) {
      var d,
        e,
        f = a.nodeType,
        g = f ? n.cache : a,
        h = f ? a[n.expando] : n.expando;
      if (g[h]) {
        if (b && (d = c ? g[h] : g[h].data)) {
          n.isArray(b)
            ? (b = b.concat(n.map(b, n.camelCase)))
            : b in d
            ? (b = [b])
            : ((b = n.camelCase(b)), (b = b in d ? [b] : b.split(" "))),
            (e = b.length);
          while (e--) delete d[b[e]];
          if (c ? !P(d) : !n.isEmptyObject(d)) return;
        }
        (c || (delete g[h].data, P(g[h]))) &&
          (f
            ? n.cleanData([a], !0)
            : l.deleteExpando || g != g.window
            ? delete g[h]
            : (g[h] = void 0));
      }
    }
  }
  n.extend({
    cache: {},
    noData: {
      "applet ": !0,
      "embed ": !0,
      "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",
    },
    hasData: function (a) {
      return !!(a = a.nodeType ? n.cache[a[n.expando]] : a[n.expando]) && !P(a);
    },
    data: function (a, b, c) {
      return Q(a, b, c);
    },
    removeData: function (a, b) {
      return R(a, b);
    },
    _data: function (a, b, c) {
      return Q(a, b, c, !0);
    },
    _removeData: function (a, b) {
      return R(a, b, !0);
    },
  }),
    n.fn.extend({
      data: function (a, b) {
        var c,
          d,
          e,
          f = this[0],
          g = f && f.attributes;
        if (void 0 === a) {
          if (
            this.length &&
            ((e = n.data(f)), 1 === f.nodeType && !n._data(f, "parsedAttrs"))
          ) {
            c = g.length;
            while (c--)
              g[c] &&
                ((d = g[c].name),
                0 === d.indexOf("data-") &&
                  ((d = n.camelCase(d.slice(5))), O(f, d, e[d])));
            n._data(f, "parsedAttrs", !0);
          }
          return e;
        }
        return "object" == typeof a
          ? this.each(function () {
              n.data(this, a);
            })
          : arguments.length > 1
          ? this.each(function () {
              n.data(this, a, b);
            })
          : f
          ? O(f, a, n.data(f, a))
          : void 0;
      },
      removeData: function (a) {
        return this.each(function () {
          n.removeData(this, a);
        });
      },
    }),
    n.extend({
      queue: function (a, b, c) {
        var d;
        if (a)
          return (
            (b = (b || "fx") + "queue"),
            (d = n._data(a, b)),
            c &&
              (!d || n.isArray(c)
                ? (d = n._data(a, b, n.makeArray(c)))
                : d.push(c)),
            d || []
          );
      },
      dequeue: function (a, b) {
        b = b || "fx";
        var c = n.queue(a, b),
          d = c.length,
          e = c.shift(),
          f = n._queueHooks(a, b),
          g = function () {
            n.dequeue(a, b);
          };
        "inprogress" === e && ((e = c.shift()), d--),
          e &&
            ("fx" === b && c.unshift("inprogress"),
            delete f.stop,
            e.call(a, g, f)),
          !d && f && f.empty.fire();
      },
      _queueHooks: function (a, b) {
        var c = b + "queueHooks";
        return (
          n._data(a, c) ||
          n._data(a, c, {
            empty: n.Callbacks("once memory").add(function () {
              n._removeData(a, b + "queue"), n._removeData(a, c);
            }),
          })
        );
      },
    }),
    n.fn.extend({
      queue: function (a, b) {
        var c = 2;
        return (
          "string" != typeof a && ((b = a), (a = "fx"), c--),
          arguments.length < c
            ? n.queue(this[0], a)
            : void 0 === b
            ? this
            : this.each(function () {
                var c = n.queue(this, a, b);
                n._queueHooks(this, a),
                  "fx" === a && "inprogress" !== c[0] && n.dequeue(this, a);
              })
        );
      },
      dequeue: function (a) {
        return this.each(function () {
          n.dequeue(this, a);
        });
      },
      clearQueue: function (a) {
        return this.queue(a || "fx", []);
      },
      promise: function (a, b) {
        var c,
          d = 1,
          e = n.Deferred(),
          f = this,
          g = this.length,
          h = function () {
            --d || e.resolveWith(f, [f]);
          };
        "string" != typeof a && ((b = a), (a = void 0)), (a = a || "fx");
        while (g--)
          (c = n._data(f[g], a + "queueHooks")) &&
            c.empty &&
            (d++, c.empty.add(h));
        return h(), e.promise(b);
      },
    }),
    (function () {
      var a;
      l.shrinkWrapBlocks = function () {
        if (null != a) return a;
        a = !1;
        var b, c, e;
        return (c = d.getElementsByTagName("body")[0]) && c.style
          ? ((b = d.createElement("div")),
            (e = d.createElement("div")),
            (e.style.cssText =
              "position:absolute;border:0;width:0;height:0;top:0;left:-9999px"),
            c.appendChild(e).appendChild(b),
            void 0 !== b.style.zoom &&
              ((b.style.cssText =
                "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1"),
              (b.appendChild(d.createElement("div")).style.width = "5px"),
              (a = 3 !== b.offsetWidth)),
            c.removeChild(e),
            a)
          : void 0;
      };
    })();
  var S = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    T = new RegExp("^(?:([+-])=|)(" + S + ")([a-z%]*)$", "i"),
    U = ["Top", "Right", "Bottom", "Left"],
    V = function (a, b) {
      return (
        (a = b || a),
        "none" === n.css(a, "display") || !n.contains(a.ownerDocument, a)
      );
    };
  function W(a, b, c, d) {
    var e,
      f = 1,
      g = 20,
      h = d
        ? function () {
            return d.cur();
          }
        : function () {
            return n.css(a, b, "");
          },
      i = h(),
      j = (c && c[3]) || (n.cssNumber[b] ? "" : "px"),
      k = (n.cssNumber[b] || ("px" !== j && +i)) && T.exec(n.css(a, b));
    if (k && k[3] !== j) {
      (j = j || k[3]), (c = c || []), (k = +i || 1);
      do {
        (f = f || ".5"), (k /= f), n.style(a, b, k + j);
      } while (f !== (f = h() / i) && 1 !== f && --g);
    }
    return (
      c &&
        ((k = +k || +i || 0),
        (e = c[1] ? k + (c[1] + 1) * c[2] : +c[2]),
        d && ((d.unit = j), (d.start = k), (d.end = e))),
      e
    );
  }
  var X = function (a, b, c, d, e, f, g) {
      var h = 0,
        i = a.length,
        j = null == c;
      if ("object" === n.type(c)) {
        e = !0;
        for (h in c) X(a, b, h, c[h], !0, f, g);
      } else if (
        void 0 !== d &&
        ((e = !0),
        n.isFunction(d) || (g = !0),
        j &&
          (g
            ? (b.call(a, d), (b = null))
            : ((j = b),
              (b = function (a, b, c) {
                return j.call(n(a), c);
              }))),
        b)
      )
        for (; h < i; h++) b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)));
      return e ? a : j ? b.call(a) : i ? b(a[0], c) : f;
    },
    Y = /^(?:checkbox|radio)$/i,
    Z = /<([\w:-]+)/,
    $ = /^$|\/(?:java|ecma)script/i,
    _ = /^\s+/,
    aa =
      "abbr|article|aside|audio|bdi|canvas|data|datalist|details|dialog|figcaption|figure|footer|header|hgroup|main|mark|meter|nav|output|picture|progress|section|summary|template|time|video";
  function ba(a) {
    var b = aa.split("|"),
      c = a.createDocumentFragment();
    if (c.createElement) while (b.length) c.createElement(b.pop());
    return c;
  }
  !(function () {
    var a = d.createElement("div"),
      b = d.createDocumentFragment(),
      c = d.createElement("input");
    (a.innerHTML =
      "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"),
      (l.leadingWhitespace = 3 === a.firstChild.nodeType),
      (l.tbody = !a.getElementsByTagName("tbody").length),
      (l.htmlSerialize = !!a.getElementsByTagName("link").length),
      (l.html5Clone =
        "<:nav></:nav>" !== d.createElement("nav").cloneNode(!0).outerHTML),
      (c.type = "checkbox"),
      (c.checked = !0),
      b.appendChild(c),
      (l.appendChecked = c.checked),
      (a.innerHTML = "<textarea>x</textarea>"),
      (l.noCloneChecked = !!a.cloneNode(!0).lastChild.defaultValue),
      b.appendChild(a),
      (c = d.createElement("input")),
      c.setAttribute("type", "radio"),
      c.setAttribute("checked", "checked"),
      c.setAttribute("name", "t"),
      a.appendChild(c),
      (l.checkClone = a.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (l.noCloneEvent = !!a.addEventListener),
      (a[n.expando] = 1),
      (l.attributes = !a.getAttribute(n.expando));
  })();
  var ca = {
    option: [1, "<select multiple='multiple'>", "</select>"],
    legend: [1, "<fieldset>", "</fieldset>"],
    area: [1, "<map>", "</map>"],
    param: [1, "<object>", "</object>"],
    thead: [1, "<table>", "</table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: l.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"],
  };
  (ca.optgroup = ca.option),
    (ca.tbody = ca.tfoot = ca.colgroup = ca.caption = ca.thead),
    (ca.th = ca.td);
  function da(a, b) {
    var c,
      d,
      e = 0,
      f =
        void 0 !== a.getElementsByTagName
          ? a.getElementsByTagName(b || "*")
          : void 0 !== a.querySelectorAll
          ? a.querySelectorAll(b || "*")
          : void 0;
    if (!f)
      for (f = [], c = a.childNodes || a; null != (d = c[e]); e++)
        !b || n.nodeName(d, b) ? f.push(d) : n.merge(f, da(d, b));
    return void 0 === b || (b && n.nodeName(a, b)) ? n.merge([a], f) : f;
  }
  function ea(a, b) {
    for (var c, d = 0; null != (c = a[d]); d++)
      n._data(c, "globalEval", !b || n._data(b[d], "globalEval"));
  }
  var fa = /<|&#?\w+;/,
    ga = /<tbody/i;
  function ha(a) {
    Y.test(a.type) && (a.defaultChecked = a.checked);
  }
  function ia(a, b, c, d, e) {
    for (
      var f, g, h, i, j, k, m, o = a.length, p = ba(b), q = [], r = 0;
      r < o;
      r++
    )
      if ((g = a[r]) || 0 === g)
        if ("object" === n.type(g)) n.merge(q, g.nodeType ? [g] : g);
        else if (fa.test(g)) {
          (i = i || p.appendChild(b.createElement("div"))),
            (j = (Z.exec(g) || ["", ""])[1].toLowerCase()),
            (m = ca[j] || ca._default),
            (i.innerHTML = m[1] + n.htmlPrefilter(g) + m[2]),
            (f = m[0]);
          while (f--) i = i.lastChild;
          if (
            (!l.leadingWhitespace &&
              _.test(g) &&
              q.push(b.createTextNode(_.exec(g)[0])),
            !l.tbody)
          ) {
            (g =
              "table" !== j || ga.test(g)
                ? "<table>" !== m[1] || ga.test(g)
                  ? 0
                  : i
                : i.firstChild),
              (f = g && g.childNodes.length);
            while (f--)
              n.nodeName((k = g.childNodes[f]), "tbody") &&
                !k.childNodes.length &&
                g.removeChild(k);
          }
          n.merge(q, i.childNodes), (i.textContent = "");
          while (i.firstChild) i.removeChild(i.firstChild);
          i = p.lastChild;
        } else q.push(b.createTextNode(g));
    i && p.removeChild(i),
      l.appendChecked || n.grep(da(q, "input"), ha),
      (r = 0);
    while ((g = q[r++]))
      if (d && n.inArray(g, d) > -1) e && e.push(g);
      else if (
        ((h = n.contains(g.ownerDocument, g)),
        (i = da(p.appendChild(g), "script")),
        h && ea(i),
        c)
      ) {
        f = 0;
        while ((g = i[f++])) $.test(g.type || "") && c.push(g);
      }
    return (i = null), p;
  }
  !(function () {
    var b,
      c,
      e = d.createElement("div");
    for (b in { submit: !0, change: !0, focusin: !0 })
      (c = "on" + b),
        (l[b] = c in a) ||
          (e.setAttribute(c, "t"), (l[b] = !1 === e.attributes[c].expando));
    e = null;
  })();
  var ja = /^(?:input|select|textarea)$/i,
    ka = /^key/,
    la = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    ma = /^(?:focusinfocus|focusoutblur)$/,
    na = /^([^.]*)(?:\.(.+)|)/;
  function oa() {
    return !0;
  }
  function pa() {
    return !1;
  }
  function qa() {
    try {
      return d.activeElement;
    } catch (a) {}
  }
  function ra(a, b, c, d, e, f) {
    var g, h;
    if ("object" == typeof b) {
      "string" != typeof c && ((d = d || c), (c = void 0));
      for (h in b) ra(a, h, c, d, b[h], f);
      return a;
    }
    if (
      (null == d && null == e
        ? ((e = c), (d = c = void 0))
        : null == e &&
          ("string" == typeof c
            ? ((e = d), (d = void 0))
            : ((e = d), (d = c), (c = void 0))),
      !1 === e)
    )
      e = pa;
    else if (!e) return a;
    return (
      1 === f &&
        ((g = e),
        (e = function (a) {
          return n().off(a), g.apply(this, arguments);
        }),
        (e.guid = g.guid || (g.guid = n.guid++))),
      a.each(function () {
        n.event.add(this, b, e, d, c);
      })
    );
  }
  (n.event = {
    global: {},
    add: function (a, b, c, d, e) {
      var f,
        g,
        h,
        i,
        j,
        k,
        l,
        m,
        o,
        p,
        q,
        r = n._data(a);
      if (r) {
        c.handler && ((i = c), (c = i.handler), (e = i.selector)),
          c.guid || (c.guid = n.guid++),
          (g = r.events) || (g = r.events = {}),
          (k = r.handle) ||
            ((k = r.handle =
              function (a) {
                return void 0 === n || (a && n.event.triggered === a.type)
                  ? void 0
                  : n.event.dispatch.apply(k.elem, arguments);
              }),
            (k.elem = a)),
          (b = (b || "").match(F) || [""]),
          (h = b.length);
        while (h--)
          (f = na.exec(b[h]) || []),
            (o = q = f[1]),
            (p = (f[2] || "").split(".").sort()),
            o &&
              ((j = n.event.special[o] || {}),
              (o = (e ? j.delegateType : j.bindType) || o),
              (j = n.event.special[o] || {}),
              (l = n.extend(
                {
                  type: o,
                  origType: q,
                  data: d,
                  handler: c,
                  guid: c.guid,
                  selector: e,
                  needsContext: e && n.expr.match.needsContext.test(e),
                  namespace: p.join("."),
                },
                i
              )),
              (m = g[o]) ||
                ((m = g[o] = []),
                (m.delegateCount = 0),
                (j.setup && !1 !== j.setup.call(a, d, p, k)) ||
                  (a.addEventListener
                    ? a.addEventListener(o, k, !1)
                    : a.attachEvent && a.attachEvent("on" + o, k))),
              j.add &&
                (j.add.call(a, l), l.handler.guid || (l.handler.guid = c.guid)),
              e ? m.splice(m.delegateCount++, 0, l) : m.push(l),
              (n.event.global[o] = !0));
        a = null;
      }
    },
    remove: function (a, b, c, d, e) {
      var f,
        g,
        h,
        i,
        j,
        k,
        l,
        m,
        o,
        p,
        q,
        r = n.hasData(a) && n._data(a);
      if (r && (k = r.events)) {
        (b = (b || "").match(F) || [""]), (j = b.length);
        while (j--)
          if (
            ((h = na.exec(b[j]) || []),
            (o = q = h[1]),
            (p = (h[2] || "").split(".").sort()),
            o)
          ) {
            (l = n.event.special[o] || {}),
              (o = (d ? l.delegateType : l.bindType) || o),
              (m = k[o] || []),
              (h =
                h[2] &&
                new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)")),
              (i = f = m.length);
            while (f--)
              (g = m[f]),
                (!e && q !== g.origType) ||
                  (c && c.guid !== g.guid) ||
                  (h && !h.test(g.namespace)) ||
                  (d && d !== g.selector && ("**" !== d || !g.selector)) ||
                  (m.splice(f, 1),
                  g.selector && m.delegateCount--,
                  l.remove && l.remove.call(a, g));
            i &&
              !m.length &&
              ((l.teardown && !1 !== l.teardown.call(a, p, r.handle)) ||
                n.removeEvent(a, o, r.handle),
              delete k[o]);
          } else for (o in k) n.event.remove(a, o + b[j], c, d, !0);
        n.isEmptyObject(k) && (delete r.handle, n._removeData(a, "events"));
      }
    },
    trigger: function (b, c, e, f) {
      var g,
        h,
        i,
        j,
        l,
        m,
        o,
        p = [e || d],
        q = k.call(b, "type") ? b.type : b,
        r = k.call(b, "namespace") ? b.namespace.split(".") : [];
      if (
        ((i = m = e = e || d),
        3 !== e.nodeType &&
          8 !== e.nodeType &&
          !ma.test(q + n.event.triggered) &&
          (q.indexOf(".") > -1 &&
            ((r = q.split(".")), (q = r.shift()), r.sort()),
          (h = q.indexOf(":") < 0 && "on" + q),
          (b = b[n.expando] ? b : new n.Event(q, "object" == typeof b && b)),
          (b.isTrigger = f ? 2 : 3),
          (b.namespace = r.join(".")),
          (b.rnamespace = b.namespace
            ? new RegExp("(^|\\.)" + r.join("\\.(?:.*\\.|)") + "(\\.|$)")
            : null),
          (b.result = void 0),
          b.target || (b.target = e),
          (c = null == c ? [b] : n.makeArray(c, [b])),
          (l = n.event.special[q] || {}),
          f || !l.trigger || !1 !== l.trigger.apply(e, c)))
      ) {
        if (!f && !l.noBubble && !n.isWindow(e)) {
          for (
            j = l.delegateType || q, ma.test(j + q) || (i = i.parentNode);
            i;
            i = i.parentNode
          )
            p.push(i), (m = i);
          m === (e.ownerDocument || d) &&
            p.push(m.defaultView || m.parentWindow || a);
        }
        o = 0;
        while ((i = p[o++]) && !b.isPropagationStopped())
          (b.type = o > 1 ? j : l.bindType || q),
            (g = (n._data(i, "events") || {})[b.type] && n._data(i, "handle")),
            g && g.apply(i, c),
            (g = h && i[h]) &&
              g.apply &&
              L(i) &&
              ((b.result = g.apply(i, c)),
              !1 === b.result && b.preventDefault());
        if (
          ((b.type = q),
          !f &&
            !b.isDefaultPrevented() &&
            (!l._default || !1 === l._default.apply(p.pop(), c)) &&
            L(e) &&
            h &&
            e[q] &&
            !n.isWindow(e))
        ) {
          (m = e[h]), m && (e[h] = null), (n.event.triggered = q);
          try {
            e[q]();
          } catch (s) {}
          (n.event.triggered = void 0), m && (e[h] = m);
        }
        return b.result;
      }
    },
    dispatch: function (a) {
      a = n.event.fix(a);
      var b,
        c,
        d,
        f,
        g,
        h = [],
        i = e.call(arguments),
        j = (n._data(this, "events") || {})[a.type] || [],
        k = n.event.special[a.type] || {};
      if (
        ((i[0] = a),
        (a.delegateTarget = this),
        !k.preDispatch || !1 !== k.preDispatch.call(this, a))
      ) {
        (h = n.event.handlers.call(this, a, j)), (b = 0);
        while ((f = h[b++]) && !a.isPropagationStopped()) {
          (a.currentTarget = f.elem), (c = 0);
          while ((g = f.handlers[c++]) && !a.isImmediatePropagationStopped())
            (a.rnamespace && !a.rnamespace.test(g.namespace)) ||
              ((a.handleObj = g),
              (a.data = g.data),
              void 0 !==
                (d = (
                  (n.event.special[g.origType] || {}).handle || g.handler
                ).apply(f.elem, i)) &&
                !1 === (a.result = d) &&
                (a.preventDefault(), a.stopPropagation()));
        }
        return k.postDispatch && k.postDispatch.call(this, a), a.result;
      }
    },
    handlers: function (a, b) {
      var c,
        d,
        e,
        f,
        g = [],
        h = b.delegateCount,
        i = a.target;
      if (
        h &&
        i.nodeType &&
        ("click" !== a.type || isNaN(a.button) || a.button < 1)
      )
        for (; i != this; i = i.parentNode || this)
          if (1 === i.nodeType && (!0 !== i.disabled || "click" !== a.type)) {
            for (d = [], c = 0; c < h; c++)
              (f = b[c]),
                (e = f.selector + " "),
                void 0 === d[e] &&
                  (d[e] = f.needsContext
                    ? n(e, this).index(i) > -1
                    : n.find(e, this, null, [i]).length),
                d[e] && d.push(f);
            d.length && g.push({ elem: i, handlers: d });
          }
      return h < b.length && g.push({ elem: this, handlers: b.slice(h) }), g;
    },
    fix: function (a) {
      if (a[n.expando]) return a;
      var b,
        c,
        e,
        f = a.type,
        g = a,
        h = this.fixHooks[f];
      h ||
        (this.fixHooks[f] = h =
          la.test(f) ? this.mouseHooks : ka.test(f) ? this.keyHooks : {}),
        (e = h.props ? this.props.concat(h.props) : this.props),
        (a = new n.Event(g)),
        (b = e.length);
      while (b--) (c = e[b]), (a[c] = g[c]);
      return (
        a.target || (a.target = g.srcElement || d),
        3 === a.target.nodeType && (a.target = a.target.parentNode),
        (a.metaKey = !!a.metaKey),
        h.filter ? h.filter(a, g) : a
      );
    },
    props:
      "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(
        " "
      ),
    fixHooks: {},
    keyHooks: {
      props: "char charCode key keyCode".split(" "),
      filter: function (a, b) {
        return (
          null == a.which &&
            (a.which = null != b.charCode ? b.charCode : b.keyCode),
          a
        );
      },
    },
    mouseHooks: {
      props:
        "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(
          " "
        ),
      filter: function (a, b) {
        var c,
          e,
          f,
          g = b.button,
          h = b.fromElement;
        return (
          null == a.pageX &&
            null != b.clientX &&
            ((e = a.target.ownerDocument || d),
            (f = e.documentElement),
            (c = e.body),
            (a.pageX =
              b.clientX +
              ((f && f.scrollLeft) || (c && c.scrollLeft) || 0) -
              ((f && f.clientLeft) || (c && c.clientLeft) || 0)),
            (a.pageY =
              b.clientY +
              ((f && f.scrollTop) || (c && c.scrollTop) || 0) -
              ((f && f.clientTop) || (c && c.clientTop) || 0))),
          !a.relatedTarget &&
            h &&
            (a.relatedTarget = h === a.target ? b.toElement : h),
          a.which ||
            void 0 === g ||
            (a.which = 1 & g ? 1 : 2 & g ? 3 : 4 & g ? 2 : 0),
          a
        );
      },
    },
    special: {
      load: { noBubble: !0 },
      focus: {
        trigger: function () {
          if (this !== qa() && this.focus)
            try {
              return this.focus(), !1;
            } catch (a) {}
        },
        delegateType: "focusin",
      },
      blur: {
        trigger: function () {
          if (this === qa() && this.blur) return this.blur(), !1;
        },
        delegateType: "focusout",
      },
      click: {
        trigger: function () {
          if (
            n.nodeName(this, "input") &&
            "checkbox" === this.type &&
            this.click
          )
            return this.click(), !1;
        },
        _default: function (a) {
          return n.nodeName(a.target, "a");
        },
      },
      beforeunload: {
        postDispatch: function (a) {
          void 0 !== a.result &&
            a.originalEvent &&
            (a.originalEvent.returnValue = a.result);
        },
      },
    },
    simulate: function (a, b, c) {
      var d = n.extend(new n.Event(), c, { type: a, isSimulated: !0 });
      n.event.trigger(d, null, b), d.isDefaultPrevented() && c.preventDefault();
    },
  }),
    (n.removeEvent = d.removeEventListener
      ? function (a, b, c) {
          a.removeEventListener && a.removeEventListener(b, c);
        }
      : function (a, b, c) {
          var d = "on" + b;
          a.detachEvent &&
            (void 0 === a[d] && (a[d] = null), a.detachEvent(d, c));
        }),
    (n.Event = function (a, b) {
      if (!(this instanceof n.Event)) return new n.Event(a, b);
      a && a.type
        ? ((this.originalEvent = a),
          (this.type = a.type),
          (this.isDefaultPrevented =
            a.defaultPrevented ||
            (void 0 === a.defaultPrevented && !1 === a.returnValue)
              ? oa
              : pa))
        : (this.type = a),
        b && n.extend(this, b),
        (this.timeStamp = (a && a.timeStamp) || n.now()),
        (this[n.expando] = !0);
    }),
    (n.Event.prototype = {
      constructor: n.Event,
      isDefaultPrevented: pa,
      isPropagationStopped: pa,
      isImmediatePropagationStopped: pa,
      preventDefault: function () {
        var a = this.originalEvent;
        (this.isDefaultPrevented = oa),
          a && (a.preventDefault ? a.preventDefault() : (a.returnValue = !1));
      },
      stopPropagation: function () {
        var a = this.originalEvent;
        (this.isPropagationStopped = oa),
          a &&
            !this.isSimulated &&
            (a.stopPropagation && a.stopPropagation(), (a.cancelBubble = !0));
      },
      stopImmediatePropagation: function () {
        var a = this.originalEvent;
        (this.isImmediatePropagationStopped = oa),
          a && a.stopImmediatePropagation && a.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    n.each(
      {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout",
      },
      function (a, b) {
        n.event.special[a] = {
          delegateType: b,
          bindType: b,
          handle: function (a) {
            var c,
              d = this,
              e = a.relatedTarget,
              f = a.handleObj;
            return (
              (e && (e === d || n.contains(d, e))) ||
                ((a.type = f.origType),
                (c = f.handler.apply(this, arguments)),
                (a.type = b)),
              c
            );
          },
        };
      }
    ),
    l.submit ||
      (n.event.special.submit = {
        setup: function () {
          if (n.nodeName(this, "form")) return !1;
          n.event.add(this, "click._submit keypress._submit", function (a) {
            var b = a.target,
              c =
                n.nodeName(b, "input") || n.nodeName(b, "button")
                  ? n.prop(b, "form")
                  : void 0;
            c &&
              !n._data(c, "submit") &&
              (n.event.add(c, "submit._submit", function (a) {
                a._submitBubble = !0;
              }),
              n._data(c, "submit", !0));
          });
        },
        postDispatch: function (a) {
          a._submitBubble &&
            (delete a._submitBubble,
            this.parentNode &&
              !a.isTrigger &&
              n.event.simulate("submit", this.parentNode, a));
        },
        teardown: function () {
          if (n.nodeName(this, "form")) return !1;
          n.event.remove(this, "._submit");
        },
      }),
    l.change ||
      (n.event.special.change = {
        setup: function () {
          if (ja.test(this.nodeName))
            return (
              ("checkbox" !== this.type && "radio" !== this.type) ||
                (n.event.add(this, "propertychange._change", function (a) {
                  "checked" === a.originalEvent.propertyName &&
                    (this._justChanged = !0);
                }),
                n.event.add(this, "click._change", function (a) {
                  this._justChanged && !a.isTrigger && (this._justChanged = !1),
                    n.event.simulate("change", this, a);
                })),
              !1
            );
          n.event.add(this, "beforeactivate._change", function (a) {
            var b = a.target;
            ja.test(b.nodeName) &&
              !n._data(b, "change") &&
              (n.event.add(b, "change._change", function (a) {
                !this.parentNode ||
                  a.isSimulated ||
                  a.isTrigger ||
                  n.event.simulate("change", this.parentNode, a);
              }),
              n._data(b, "change", !0));
          });
        },
        handle: function (a) {
          var b = a.target;
          if (
            this !== b ||
            a.isSimulated ||
            a.isTrigger ||
            ("radio" !== b.type && "checkbox" !== b.type)
          )
            return a.handleObj.handler.apply(this, arguments);
        },
        teardown: function () {
          return n.event.remove(this, "._change"), !ja.test(this.nodeName);
        },
      }),
    l.focusin ||
      n.each({ focus: "focusin", blur: "focusout" }, function (a, b) {
        var c = function (a) {
          n.event.simulate(b, a.target, n.event.fix(a));
        };
        n.event.special[b] = {
          setup: function () {
            var d = this.ownerDocument || this,
              e = n._data(d, b);
            e || d.addEventListener(a, c, !0), n._data(d, b, (e || 0) + 1);
          },
          teardown: function () {
            var d = this.ownerDocument || this,
              e = n._data(d, b) - 1;
            e
              ? n._data(d, b, e)
              : (d.removeEventListener(a, c, !0), n._removeData(d, b));
          },
        };
      }),
    n.fn.extend({
      on: function (a, b, c, d) {
        return ra(this, a, b, c, d);
      },
      one: function (a, b, c, d) {
        return ra(this, a, b, c, d, 1);
      },
      off: function (a, b, c) {
        var d, e;
        if (a && a.preventDefault && a.handleObj)
          return (
            (d = a.handleObj),
            n(a.delegateTarget).off(
              d.namespace ? d.origType + "." + d.namespace : d.origType,
              d.selector,
              d.handler
            ),
            this
          );
        if ("object" == typeof a) {
          for (e in a) this.off(e, b, a[e]);
          return this;
        }
        return (
          (!1 !== b && "function" != typeof b) || ((c = b), (b = void 0)),
          !1 === c && (c = pa),
          this.each(function () {
            n.event.remove(this, a, c, b);
          })
        );
      },
      trigger: function (a, b) {
        return this.each(function () {
          n.event.trigger(a, b, this);
        });
      },
      triggerHandler: function (a, b) {
        var c = this[0];
        if (c) return n.event.trigger(a, b, c, !0);
      },
    });
  var sa = / jQuery\d+="(?:null|\d+)"/g,
    ta = new RegExp("<(?:" + aa + ")[\\s/>]", "i"),
    ua =
      /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
    va = /<script|<style|<link/i,
    wa = /checked\s*(?:[^=]|=\s*.checked.)/i,
    xa = /^true\/(.*)/,
    ya = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
    za = ba(d),
    Aa = za.appendChild(d.createElement("div"));
  function Ba(a, b) {
    return n.nodeName(a, "table") &&
      n.nodeName(11 !== b.nodeType ? b : b.firstChild, "tr")
      ? a.getElementsByTagName("tbody")[0] ||
          a.appendChild(a.ownerDocument.createElement("tbody"))
      : a;
  }
  function Ca(a) {
    return (a.type = (null !== n.find.attr(a, "type")) + "/" + a.type), a;
  }
  function Da(a) {
    var b = xa.exec(a.type);
    return b ? (a.type = b[1]) : a.removeAttribute("type"), a;
  }
  function Ea(a, b) {
    if (1 === b.nodeType && n.hasData(a)) {
      var c,
        d,
        e,
        f = n._data(a),
        g = n._data(b, f),
        h = f.events;
      if (h) {
        delete g.handle, (g.events = {});
        for (c in h)
          for (d = 0, e = h[c].length; d < e; d++) n.event.add(b, c, h[c][d]);
      }
      g.data && (g.data = n.extend({}, g.data));
    }
  }
  function Fa(a, b) {
    var c, d, e;
    if (1 === b.nodeType) {
      if (((c = b.nodeName.toLowerCase()), !l.noCloneEvent && b[n.expando])) {
        e = n._data(b);
        for (d in e.events) n.removeEvent(b, d, e.handle);
        b.removeAttribute(n.expando);
      }
      "script" === c && b.text !== a.text
        ? ((Ca(b).text = a.text), Da(b))
        : "object" === c
        ? (b.parentNode && (b.outerHTML = a.outerHTML),
          l.html5Clone &&
            a.innerHTML &&
            !n.trim(b.innerHTML) &&
            (b.innerHTML = a.innerHTML))
        : "input" === c && Y.test(a.type)
        ? ((b.defaultChecked = b.checked = a.checked),
          b.value !== a.value && (b.value = a.value))
        : "option" === c
        ? (b.defaultSelected = b.selected = a.defaultSelected)
        : ("input" !== c && "textarea" !== c) ||
          (b.defaultValue = a.defaultValue);
    }
  }
  function Ga(a, b, c, d) {
    b = f.apply([], b);
    var e,
      g,
      h,
      i,
      j,
      k,
      m = 0,
      o = a.length,
      p = o - 1,
      q = b[0],
      r = n.isFunction(q);
    if (r || (o > 1 && "string" == typeof q && !l.checkClone && wa.test(q)))
      return a.each(function (e) {
        var f = a.eq(e);
        r && (b[0] = q.call(this, e, f.html())), Ga(f, b, c, d);
      });
    if (
      o &&
      ((k = ia(b, a[0].ownerDocument, !1, a, d)),
      (e = k.firstChild),
      1 === k.childNodes.length && (k = e),
      e || d)
    ) {
      for (i = n.map(da(k, "script"), Ca), h = i.length; m < o; m++)
        (g = k),
          m !== p &&
            ((g = n.clone(g, !0, !0)), h && n.merge(i, da(g, "script"))),
          c.call(a[m], g, m);
      if (h)
        for (j = i[i.length - 1].ownerDocument, n.map(i, Da), m = 0; m < h; m++)
          (g = i[m]),
            $.test(g.type || "") &&
              !n._data(g, "globalEval") &&
              n.contains(j, g) &&
              (g.src
                ? n._evalUrl && n._evalUrl(g.src)
                : n.globalEval(
                    (g.text || g.textContent || g.innerHTML || "").replace(
                      ya,
                      ""
                    )
                  ));
      k = e = null;
    }
    return a;
  }
  function Ha(a, b, c) {
    for (var d, e = b ? n.filter(b, a) : a, f = 0; null != (d = e[f]); f++)
      c || 1 !== d.nodeType || n.cleanData(da(d)),
        d.parentNode &&
          (c && n.contains(d.ownerDocument, d) && ea(da(d, "script")),
          d.parentNode.removeChild(d));
    return a;
  }
  n.extend({
    htmlPrefilter: function (a) {
      return a.replace(ua, "<$1></$2>");
    },
    clone: function (a, b, c) {
      var d,
        e,
        f,
        g,
        h,
        i = n.contains(a.ownerDocument, a);
      if (
        (l.html5Clone || n.isXMLDoc(a) || !ta.test("<" + a.nodeName + ">")
          ? (f = a.cloneNode(!0))
          : ((Aa.innerHTML = a.outerHTML), Aa.removeChild((f = Aa.firstChild))),
        !(
          (l.noCloneEvent && l.noCloneChecked) ||
          (1 !== a.nodeType && 11 !== a.nodeType) ||
          n.isXMLDoc(a)
        ))
      )
        for (d = da(f), h = da(a), g = 0; null != (e = h[g]); ++g)
          d[g] && Fa(e, d[g]);
      if (b)
        if (c)
          for (h = h || da(a), d = d || da(f), g = 0; null != (e = h[g]); g++)
            Ea(e, d[g]);
        else Ea(a, f);
      return (
        (d = da(f, "script")),
        d.length > 0 && ea(d, !i && da(a, "script")),
        (d = h = e = null),
        f
      );
    },
    cleanData: function (a, b) {
      for (
        var d,
          e,
          f,
          g,
          h = 0,
          i = n.expando,
          j = n.cache,
          k = l.attributes,
          m = n.event.special;
        null != (d = a[h]);
        h++
      )
        if ((b || L(d)) && ((f = d[i]), (g = f && j[f]))) {
          if (g.events)
            for (e in g.events)
              m[e] ? n.event.remove(d, e) : n.removeEvent(d, e, g.handle);
          j[f] &&
            (delete j[f],
            k || void 0 === d.removeAttribute
              ? (d[i] = void 0)
              : d.removeAttribute(i),
            c.push(f));
        }
    },
  }),
    n.fn.extend({
      domManip: Ga,
      detach: function (a) {
        return Ha(this, a, !0);
      },
      remove: function (a) {
        return Ha(this, a);
      },
      text: function (a) {
        return X(
          this,
          function (a) {
            return void 0 === a
              ? n.text(this)
              : this.empty().append(
                  ((this[0] && this[0].ownerDocument) || d).createTextNode(a)
                );
          },
          null,
          a,
          arguments.length
        );
      },
      append: function () {
        return Ga(this, arguments, function (a) {
          if (
            1 === this.nodeType ||
            11 === this.nodeType ||
            9 === this.nodeType
          ) {
            Ba(this, a).appendChild(a);
          }
        });
      },
      prepend: function () {
        return Ga(this, arguments, function (a) {
          if (
            1 === this.nodeType ||
            11 === this.nodeType ||
            9 === this.nodeType
          ) {
            var b = Ba(this, a);
            b.insertBefore(a, b.firstChild);
          }
        });
      },
      before: function () {
        return Ga(this, arguments, function (a) {
          this.parentNode && this.parentNode.insertBefore(a, this);
        });
      },
      after: function () {
        return Ga(this, arguments, function (a) {
          this.parentNode && this.parentNode.insertBefore(a, this.nextSibling);
        });
      },
      empty: function () {
        for (var a, b = 0; null != (a = this[b]); b++) {
          1 === a.nodeType && n.cleanData(da(a, !1));
          while (a.firstChild) a.removeChild(a.firstChild);
          a.options && n.nodeName(a, "select") && (a.options.length = 0);
        }
        return this;
      },
      clone: function (a, b) {
        return (
          (a = null != a && a),
          (b = null == b ? a : b),
          this.map(function () {
            return n.clone(this, a, b);
          })
        );
      },
      html: function (a) {
        return X(
          this,
          function (a) {
            var b = this[0] || {},
              c = 0,
              d = this.length;
            if (void 0 === a)
              return 1 === b.nodeType ? b.innerHTML.replace(sa, "") : void 0;
            if (
              "string" == typeof a &&
              !va.test(a) &&
              (l.htmlSerialize || !ta.test(a)) &&
              (l.leadingWhitespace || !_.test(a)) &&
              !ca[(Z.exec(a) || ["", ""])[1].toLowerCase()]
            ) {
              a = n.htmlPrefilter(a);
              try {
                for (; c < d; c++)
                  (b = this[c] || {}),
                    1 === b.nodeType &&
                      (n.cleanData(da(b, !1)), (b.innerHTML = a));
                b = 0;
              } catch (e) {}
            }
            b && this.empty().append(a);
          },
          null,
          a,
          arguments.length
        );
      },
      replaceWith: function () {
        var a = [];
        return Ga(
          this,
          arguments,
          function (b) {
            var c = this.parentNode;
            n.inArray(this, a) < 0 &&
              (n.cleanData(da(this)), c && c.replaceChild(b, this));
          },
          a
        );
      },
    }),
    n.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith",
      },
      function (a, b) {
        n.fn[a] = function (a) {
          for (var c, d = 0, e = [], f = n(a), h = f.length - 1; d <= h; d++)
            (c = d === h ? this : this.clone(!0)),
              n(f[d])[b](c),
              g.apply(e, c.get());
          return this.pushStack(e);
        };
      }
    );
  var Ia,
    Ja = { HTML: "block", BODY: "block" };
  function Ka(a, b) {
    var c = n(b.createElement(a)).appendTo(b.body),
      d = n.css(c[0], "display");
    return c.detach(), d;
  }
  function La(a) {
    var b = d,
      c = Ja[a];
    return (
      c ||
        ((c = Ka(a, b)),
        ("none" !== c && c) ||
          ((Ia = (
            Ia || n("<iframe frameborder='0' width='0' height='0'/>")
          ).appendTo(b.documentElement)),
          (b = (Ia[0].contentWindow || Ia[0].contentDocument).document),
          b.write(),
          b.close(),
          (c = Ka(a, b)),
          Ia.detach()),
        (Ja[a] = c)),
      c
    );
  }
  var Ma = /^margin/,
    Na = new RegExp("^(" + S + ")(?!px)[a-z%]+$", "i"),
    Oa = function (a, b, c, d) {
      var e,
        f,
        g = {};
      for (f in b) (g[f] = a.style[f]), (a.style[f] = b[f]);
      e = c.apply(a, d || []);
      for (f in b) a.style[f] = g[f];
      return e;
    },
    Pa = d.documentElement;
  !(function () {
    var b,
      c,
      e,
      f,
      g,
      h,
      i = d.createElement("div"),
      j = d.createElement("div");
    function k() {
      var k,
        l,
        m = d.documentElement;
      m.appendChild(i),
        (j.style.cssText =
          "-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%"),
        (b = e = h = !1),
        (c = g = !0),
        a.getComputedStyle &&
          ((l = a.getComputedStyle(j)),
          (b = "1%" !== (l || {}).top),
          (h = "2px" === (l || {}).marginLeft),
          (e = "4px" === (l || { width: "4px" }).width),
          (j.style.marginRight = "50%"),
          (c = "4px" === (l || { marginRight: "4px" }).marginRight),
          (k = j.appendChild(d.createElement("div"))),
          (k.style.cssText = j.style.cssText =
            "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0"),
          (k.style.marginRight = k.style.width = "0"),
          (j.style.width = "1px"),
          (g = !parseFloat((a.getComputedStyle(k) || {}).marginRight)),
          j.removeChild(k)),
        (j.style.display = "none"),
        (f = 0 === j.getClientRects().length),
        f &&
          ((j.style.display = ""),
          (j.innerHTML = "<table><tr><td></td><td>t</td></tr></table>"),
          (j.childNodes[0].style.borderCollapse = "separate"),
          (k = j.getElementsByTagName("td")),
          (k[0].style.cssText = "margin:0;border:0;padding:0;display:none"),
          (f = 0 === k[0].offsetHeight) &&
            ((k[0].style.display = ""),
            (k[1].style.display = "none"),
            (f = 0 === k[0].offsetHeight))),
        m.removeChild(i);
    }
    j.style &&
      ((j.style.cssText = "float:left;opacity:.5"),
      (l.opacity = "0.5" === j.style.opacity),
      (l.cssFloat = !!j.style.cssFloat),
      (j.style.backgroundClip = "content-box"),
      (j.cloneNode(!0).style.backgroundClip = ""),
      (l.clearCloneStyle = "content-box" === j.style.backgroundClip),
      (i = d.createElement("div")),
      (i.style.cssText =
        "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute"),
      (j.innerHTML = ""),
      i.appendChild(j),
      (l.boxSizing =
        "" === j.style.boxSizing ||
        "" === j.style.MozBoxSizing ||
        "" === j.style.WebkitBoxSizing),
      n.extend(l, {
        reliableHiddenOffsets: function () {
          return null == b && k(), f;
        },
        boxSizingReliable: function () {
          return null == b && k(), e;
        },
        pixelMarginRight: function () {
          return null == b && k(), c;
        },
        pixelPosition: function () {
          return null == b && k(), b;
        },
        reliableMarginRight: function () {
          return null == b && k(), g;
        },
        reliableMarginLeft: function () {
          return null == b && k(), h;
        },
      }));
  })();
  var Qa,
    Ra,
    Sa = /^(top|right|bottom|left)$/;
  a.getComputedStyle
    ? ((Qa = function (b) {
        var c = b.ownerDocument.defaultView;
        return (c && c.opener) || (c = a), c.getComputedStyle(b);
      }),
      (Ra = function (a, b, c) {
        var d,
          e,
          f,
          g,
          h = a.style;
        return (
          (c = c || Qa(a)),
          (g = c ? c.getPropertyValue(b) || c[b] : void 0),
          ("" !== g && void 0 !== g) ||
            n.contains(a.ownerDocument, a) ||
            (g = n.style(a, b)),
          c &&
            !l.pixelMarginRight() &&
            Na.test(g) &&
            Ma.test(b) &&
            ((d = h.width),
            (e = h.minWidth),
            (f = h.maxWidth),
            (h.minWidth = h.maxWidth = h.width = g),
            (g = c.width),
            (h.width = d),
            (h.minWidth = e),
            (h.maxWidth = f)),
          void 0 === g ? g : g + ""
        );
      }))
    : Pa.currentStyle &&
      ((Qa = function (a) {
        return a.currentStyle;
      }),
      (Ra = function (a, b, c) {
        var d,
          e,
          f,
          g,
          h = a.style;
        return (
          (c = c || Qa(a)),
          (g = c ? c[b] : void 0),
          null == g && h && h[b] && (g = h[b]),
          Na.test(g) &&
            !Sa.test(b) &&
            ((d = h.left),
            (e = a.runtimeStyle),
            (f = e && e.left),
            f && (e.left = a.currentStyle.left),
            (h.left = "fontSize" === b ? "1em" : g),
            (g = h.pixelLeft + "px"),
            (h.left = d),
            f && (e.left = f)),
          void 0 === g ? g : g + "" || "auto"
        );
      }));
  function Ta(a, b) {
    return {
      get: function () {
        return a()
          ? void delete this.get
          : (this.get = b).apply(this, arguments);
      },
    };
  }
  var Ua = /alpha\([^)]*\)/i,
    Va = /opacity\s*=\s*([^)]*)/i,
    Wa = /^(none|table(?!-c[ea]).+)/,
    Xa = new RegExp("^(" + S + ")(.*)$", "i"),
    Ya = { position: "absolute", visibility: "hidden", display: "block" },
    Za = { letterSpacing: "0", fontWeight: "400" },
    $a = ["Webkit", "O", "Moz", "ms"],
    _a = d.createElement("div").style;
  function ab(a) {
    if (a in _a) return a;
    var b = a.charAt(0).toUpperCase() + a.slice(1),
      c = $a.length;
    while (c--) if ((a = $a[c] + b) in _a) return a;
  }
  function bb(a, b) {
    for (var c, d, e, f = [], g = 0, h = a.length; g < h; g++)
      (d = a[g]),
        d.style &&
          ((f[g] = n._data(d, "olddisplay")),
          (c = d.style.display),
          b
            ? (f[g] || "none" !== c || (d.style.display = ""),
              "" === d.style.display &&
                V(d) &&
                (f[g] = n._data(d, "olddisplay", La(d.nodeName))))
            : ((e = V(d)),
              ((c && "none" !== c) || !e) &&
                n._data(d, "olddisplay", e ? c : n.css(d, "display"))));
    for (g = 0; g < h; g++)
      (d = a[g]),
        d.style &&
          ((b && "none" !== d.style.display && "" !== d.style.display) ||
            (d.style.display = b ? f[g] || "" : "none"));
    return a;
  }
  function cb(a, b, c) {
    var d = Xa.exec(b);
    return d ? Math.max(0, d[1] - (c || 0)) + (d[2] || "px") : b;
  }
  function db(a, b, c, d, e) {
    for (
      var f = c === (d ? "border" : "content") ? 4 : "width" === b ? 1 : 0,
        g = 0;
      f < 4;
      f += 2
    )
      "margin" === c && (g += n.css(a, c + U[f], !0, e)),
        d
          ? ("content" === c && (g -= n.css(a, "padding" + U[f], !0, e)),
            "margin" !== c && (g -= n.css(a, "border" + U[f] + "Width", !0, e)))
          : ((g += n.css(a, "padding" + U[f], !0, e)),
            "padding" !== c &&
              (g += n.css(a, "border" + U[f] + "Width", !0, e)));
    return g;
  }
  function eb(a, b, c) {
    var d = !0,
      e = "width" === b ? a.offsetWidth : a.offsetHeight,
      f = Qa(a),
      g = l.boxSizing && "border-box" === n.css(a, "boxSizing", !1, f);
    if (e <= 0 || null == e) {
      if (
        ((e = Ra(a, b, f)),
        (e < 0 || null == e) && (e = a.style[b]),
        Na.test(e))
      )
        return e;
      (d = g && (l.boxSizingReliable() || e === a.style[b])),
        (e = parseFloat(e) || 0);
    }
    return e + db(a, b, c || (g ? "border" : "content"), d, f) + "px";
  }
  n.extend({
    cssHooks: {
      opacity: {
        get: function (a, b) {
          if (b) {
            var c = Ra(a, "opacity");
            return "" === c ? "1" : c;
          }
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
    },
    cssProps: { float: l.cssFloat ? "cssFloat" : "styleFloat" },
    style: function (a, b, c, d) {
      if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
        var e,
          f,
          g,
          h = n.camelCase(b),
          i = a.style;
        if (
          ((b = n.cssProps[h] || (n.cssProps[h] = ab(h) || h)),
          (g = n.cssHooks[b] || n.cssHooks[h]),
          void 0 === c)
        )
          return g && "get" in g && void 0 !== (e = g.get(a, !1, d)) ? e : i[b];
        if (
          ((f = typeof c),
          "string" === f &&
            (e = T.exec(c)) &&
            e[1] &&
            ((c = W(a, b, e)), (f = "number")),
          null != c &&
            c === c &&
            ("number" === f &&
              (c += (e && e[3]) || (n.cssNumber[h] ? "" : "px")),
            l.clearCloneStyle ||
              "" !== c ||
              0 !== b.indexOf("background") ||
              (i[b] = "inherit"),
            !(g && "set" in g && void 0 === (c = g.set(a, c, d)))))
        )
          try {
            i[b] = c;
          } catch (j) {}
      }
    },
    css: function (a, b, c, d) {
      var e,
        f,
        g,
        h = n.camelCase(b);
      return (
        (b = n.cssProps[h] || (n.cssProps[h] = ab(h) || h)),
        (g = n.cssHooks[b] || n.cssHooks[h]),
        g && "get" in g && (f = g.get(a, !0, c)),
        void 0 === f && (f = Ra(a, b, d)),
        "normal" === f && b in Za && (f = Za[b]),
        "" === c || c
          ? ((e = parseFloat(f)), !0 === c || isFinite(e) ? e || 0 : f)
          : f
      );
    },
  }),
    n.each(["height", "width"], function (a, b) {
      n.cssHooks[b] = {
        get: function (a, c, d) {
          if (c)
            return Wa.test(n.css(a, "display")) && 0 === a.offsetWidth
              ? Oa(a, Ya, function () {
                  return eb(a, b, d);
                })
              : eb(a, b, d);
        },
        set: function (a, c, d) {
          var e = d && Qa(a);
          return cb(
            a,
            c,
            d
              ? db(
                  a,
                  b,
                  d,
                  l.boxSizing && "border-box" === n.css(a, "boxSizing", !1, e),
                  e
                )
              : 0
          );
        },
      };
    }),
    l.opacity ||
      (n.cssHooks.opacity = {
        get: function (a, b) {
          return Va.test(
            (b && a.currentStyle ? a.currentStyle.filter : a.style.filter) || ""
          )
            ? 0.01 * parseFloat(RegExp.$1) + ""
            : b
            ? "1"
            : "";
        },
        set: function (a, b) {
          var c = a.style,
            d = a.currentStyle,
            e = n.isNumeric(b) ? "alpha(opacity=" + 100 * b + ")" : "",
            f = (d && d.filter) || c.filter || "";
          (c.zoom = 1),
            ((b >= 1 || "" === b) &&
              "" === n.trim(f.replace(Ua, "")) &&
              c.removeAttribute &&
              (c.removeAttribute("filter"), "" === b || (d && !d.filter))) ||
              (c.filter = Ua.test(f) ? f.replace(Ua, e) : f + " " + e);
        },
      }),
    (n.cssHooks.marginRight = Ta(l.reliableMarginRight, function (a, b) {
      if (b) return Oa(a, { display: "inline-block" }, Ra, [a, "marginRight"]);
    })),
    (n.cssHooks.marginLeft = Ta(l.reliableMarginLeft, function (a, b) {
      if (b)
        return (
          (parseFloat(Ra(a, "marginLeft")) ||
            (n.contains(a.ownerDocument, a)
              ? a.getBoundingClientRect().left -
                Oa(a, { marginLeft: 0 }, function () {
                  return a.getBoundingClientRect().left;
                })
              : 0)) + "px"
        );
    })),
    n.each(
      {
        margin: "",
        padding: "",
        border: "Width",
      },
      function (a, b) {
        (n.cssHooks[a + b] = {
          expand: function (c) {
            for (
              var d = 0, e = {}, f = "string" == typeof c ? c.split(" ") : [c];
              d < 4;
              d++
            )
              e[a + U[d] + b] = f[d] || f[d - 2] || f[0];
            return e;
          },
        }),
          Ma.test(a) || (n.cssHooks[a + b].set = cb);
      }
    ),
    n.fn.extend({
      css: function (a, b) {
        return X(
          this,
          function (a, b, c) {
            var d,
              e,
              f = {},
              g = 0;
            if (n.isArray(b)) {
              for (d = Qa(a), e = b.length; g < e; g++)
                f[b[g]] = n.css(a, b[g], !1, d);
              return f;
            }
            return void 0 !== c ? n.style(a, b, c) : n.css(a, b);
          },
          a,
          b,
          arguments.length > 1
        );
      },
      show: function () {
        return bb(this, !0);
      },
      hide: function () {
        return bb(this);
      },
      toggle: function (a) {
        return "boolean" == typeof a
          ? a
            ? this.show()
            : this.hide()
          : this.each(function () {
              V(this) ? n(this).show() : n(this).hide();
            });
      },
    });
  function fb(a, b, c, d, e) {
    return new fb.prototype.init(a, b, c, d, e);
  }
  (n.Tween = fb),
    (fb.prototype = {
      constructor: fb,
      init: function (a, b, c, d, e, f) {
        (this.elem = a),
          (this.prop = c),
          (this.easing = e || n.easing._default),
          (this.options = b),
          (this.start = this.now = this.cur()),
          (this.end = d),
          (this.unit = f || (n.cssNumber[c] ? "" : "px"));
      },
      cur: function () {
        var a = fb.propHooks[this.prop];
        return a && a.get ? a.get(this) : fb.propHooks._default.get(this);
      },
      run: function (a) {
        var b,
          c = fb.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = b =
                n.easing[this.easing](
                  a,
                  this.options.duration * a,
                  0,
                  1,
                  this.options.duration
                ))
            : (this.pos = b = a),
          (this.now = (this.end - this.start) * b + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          c && c.set ? c.set(this) : fb.propHooks._default.set(this),
          this
        );
      },
    }),
    (fb.prototype.init.prototype = fb.prototype),
    (fb.propHooks = {
      _default: {
        get: function (a) {
          var b;
          return 1 !== a.elem.nodeType ||
            (null != a.elem[a.prop] && null == a.elem.style[a.prop])
            ? a.elem[a.prop]
            : ((b = n.css(a.elem, a.prop, "")), b && "auto" !== b ? b : 0);
        },
        set: function (a) {
          n.fx.step[a.prop]
            ? n.fx.step[a.prop](a)
            : 1 !== a.elem.nodeType ||
              (null == a.elem.style[n.cssProps[a.prop]] && !n.cssHooks[a.prop])
            ? (a.elem[a.prop] = a.now)
            : n.style(a.elem, a.prop, a.now + a.unit);
        },
      },
    }),
    (fb.propHooks.scrollTop = fb.propHooks.scrollLeft =
      {
        set: function (a) {
          a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now);
        },
      }),
    (n.easing = {
      linear: function (a) {
        return a;
      },
      swing: function (a) {
        return 0.5 - Math.cos(a * Math.PI) / 2;
      },
      _default: "swing",
    }),
    (n.fx = fb.prototype.init),
    (n.fx.step = {});
  var gb,
    hb,
    ib = /^(?:toggle|show|hide)$/,
    jb = /queueHooks$/;
  function kb() {
    return (
      a.setTimeout(function () {
        gb = void 0;
      }),
      (gb = n.now())
    );
  }
  function lb(a, b) {
    var c,
      d = { height: a },
      e = 0;
    for (b = b ? 1 : 0; e < 4; e += 2 - b)
      (c = U[e]), (d["margin" + c] = d["padding" + c] = a);
    return b && (d.opacity = d.width = a), d;
  }
  function mb(a, b, c) {
    for (
      var d,
        e = (pb.tweeners[b] || []).concat(pb.tweeners["*"]),
        f = 0,
        g = e.length;
      f < g;
      f++
    )
      if ((d = e[f].call(c, b, a))) return d;
  }
  function nb(a, b, c) {
    var d,
      e,
      f,
      g,
      h,
      i,
      j,
      k,
      m = this,
      o = {},
      p = a.style,
      q = a.nodeType && V(a),
      r = n._data(a, "fxshow");
    c.queue ||
      ((h = n._queueHooks(a, "fx")),
      null == h.unqueued &&
        ((h.unqueued = 0),
        (i = h.empty.fire),
        (h.empty.fire = function () {
          h.unqueued || i();
        })),
      h.unqueued++,
      m.always(function () {
        m.always(function () {
          h.unqueued--, n.queue(a, "fx").length || h.empty.fire();
        });
      })),
      1 === a.nodeType &&
        ("height" in b || "width" in b) &&
        ((c.overflow = [p.overflow, p.overflowX, p.overflowY]),
        (j = n.css(a, "display")),
        "inline" ===
          (k = "none" === j ? n._data(a, "olddisplay") || La(a.nodeName) : j) &&
          "none" === n.css(a, "float") &&
          (l.inlineBlockNeedsLayout && "inline" !== La(a.nodeName)
            ? (p.zoom = 1)
            : (p.display = "inline-block"))),
      c.overflow &&
        ((p.overflow = "hidden"),
        l.shrinkWrapBlocks() ||
          m.always(function () {
            (p.overflow = c.overflow[0]),
              (p.overflowX = c.overflow[1]),
              (p.overflowY = c.overflow[2]);
          }));
    for (d in b)
      if (((e = b[d]), ib.exec(e))) {
        if (
          (delete b[d], (f = f || "toggle" === e), e === (q ? "hide" : "show"))
        ) {
          if ("show" !== e || !r || void 0 === r[d]) continue;
          q = !0;
        }
        o[d] = (r && r[d]) || n.style(a, d);
      } else j = void 0;
    if (n.isEmptyObject(o))
      "inline" === ("none" === j ? La(a.nodeName) : j) && (p.display = j);
    else {
      r ? "hidden" in r && (q = r.hidden) : (r = n._data(a, "fxshow", {})),
        f && (r.hidden = !q),
        q
          ? n(a).show()
          : m.done(function () {
              n(a).hide();
            }),
        m.done(function () {
          var b;
          n._removeData(a, "fxshow");
          for (b in o) n.style(a, b, o[b]);
        });
      for (d in o)
        (g = mb(q ? r[d] : 0, d, m)),
          d in r ||
            ((r[d] = g.start),
            q &&
              ((g.end = g.start),
              (g.start = "width" === d || "height" === d ? 1 : 0)));
    }
  }
  function ob(a, b) {
    var c, d, e, f, g;
    for (c in a)
      if (
        ((d = n.camelCase(c)),
        (e = b[d]),
        (f = a[c]),
        n.isArray(f) && ((e = f[1]), (f = a[c] = f[0])),
        c !== d && ((a[d] = f), delete a[c]),
        (g = n.cssHooks[d]) && "expand" in g)
      ) {
        (f = g.expand(f)), delete a[d];
        for (c in f) c in a || ((a[c] = f[c]), (b[c] = e));
      } else b[d] = e;
  }
  function pb(a, b, c) {
    var d,
      e,
      f = 0,
      g = pb.prefilters.length,
      h = n.Deferred().always(function () {
        delete i.elem;
      }),
      i = function () {
        if (e) return !1;
        for (
          var b = gb || kb(),
            c = Math.max(0, j.startTime + j.duration - b),
            d = c / j.duration || 0,
            f = 1 - d,
            g = 0,
            i = j.tweens.length;
          g < i;
          g++
        )
          j.tweens[g].run(f);
        return (
          h.notifyWith(a, [j, f, c]),
          f < 1 && i ? c : (h.resolveWith(a, [j]), !1)
        );
      },
      j = h.promise({
        elem: a,
        props: n.extend({}, b),
        opts: n.extend(!0, { specialEasing: {}, easing: n.easing._default }, c),
        originalProperties: b,
        originalOptions: c,
        startTime: gb || kb(),
        duration: c.duration,
        tweens: [],
        createTween: function (b, c) {
          var d = n.Tween(
            a,
            j.opts,
            b,
            c,
            j.opts.specialEasing[b] || j.opts.easing
          );
          return j.tweens.push(d), d;
        },
        stop: function (b) {
          var c = 0,
            d = b ? j.tweens.length : 0;
          if (e) return this;
          for (e = !0; c < d; c++) j.tweens[c].run(1);
          return (
            b
              ? (h.notifyWith(a, [j, 1, 0]), h.resolveWith(a, [j, b]))
              : h.rejectWith(a, [j, b]),
            this
          );
        },
      }),
      k = j.props;
    for (ob(k, j.opts.specialEasing); f < g; f++)
      if ((d = pb.prefilters[f].call(j, a, k, j.opts)))
        return (
          n.isFunction(d.stop) &&
            (n._queueHooks(j.elem, j.opts.queue).stop = n.proxy(d.stop, d)),
          d
        );
    return (
      n.map(k, mb, j),
      n.isFunction(j.opts.start) && j.opts.start.call(a, j),
      n.fx.timer(n.extend(i, { elem: a, anim: j, queue: j.opts.queue })),
      j
        .progress(j.opts.progress)
        .done(j.opts.done, j.opts.complete)
        .fail(j.opts.fail)
        .always(j.opts.always)
    );
  }
  (n.Animation = n.extend(pb, {
    tweeners: {
      "*": [
        function (a, b) {
          var c = this.createTween(a, b);
          return W(c.elem, a, T.exec(b), c), c;
        },
      ],
    },
    tweener: function (a, b) {
      n.isFunction(a) ? ((b = a), (a = ["*"])) : (a = a.match(F));
      for (var c, d = 0, e = a.length; d < e; d++)
        (c = a[d]),
          (pb.tweeners[c] = pb.tweeners[c] || []),
          pb.tweeners[c].unshift(b);
    },
    prefilters: [nb],
    prefilter: function (a, b) {
      b ? pb.prefilters.unshift(a) : pb.prefilters.push(a);
    },
  })),
    (n.speed = function (a, b, c) {
      var d =
        a && "object" == typeof a
          ? n.extend({}, a)
          : {
              complete: c || (!c && b) || (n.isFunction(a) && a),
              duration: a,
              easing: (c && b) || (b && !n.isFunction(b) && b),
            };
      return (
        (d.duration = n.fx.off
          ? 0
          : "number" == typeof d.duration
          ? d.duration
          : d.duration in n.fx.speeds
          ? n.fx.speeds[d.duration]
          : n.fx.speeds._default),
        (null != d.queue && !0 !== d.queue) || (d.queue = "fx"),
        (d.old = d.complete),
        (d.complete = function () {
          n.isFunction(d.old) && d.old.call(this),
            d.queue && n.dequeue(this, d.queue);
        }),
        d
      );
    }),
    n.fn.extend({
      fadeTo: function (a, b, c, d) {
        return this.filter(V)
          .css("opacity", 0)
          .show()
          .end()
          .animate({ opacity: b }, a, c, d);
      },
      animate: function (a, b, c, d) {
        var e = n.isEmptyObject(a),
          f = n.speed(b, c, d),
          g = function () {
            var b = pb(this, n.extend({}, a), f);
            (e || n._data(this, "finish")) && b.stop(!0);
          };
        return (
          (g.finish = g),
          e || !1 === f.queue ? this.each(g) : this.queue(f.queue, g)
        );
      },
      stop: function (a, b, c) {
        var d = function (a) {
          var b = a.stop;
          delete a.stop, b(c);
        };
        return (
          "string" != typeof a && ((c = b), (b = a), (a = void 0)),
          b && !1 !== a && this.queue(a || "fx", []),
          this.each(function () {
            var b = !0,
              e = null != a && a + "queueHooks",
              f = n.timers,
              g = n._data(this);
            if (e) g[e] && g[e].stop && d(g[e]);
            else for (e in g) g[e] && g[e].stop && jb.test(e) && d(g[e]);
            for (e = f.length; e--; )
              f[e].elem !== this ||
                (null != a && f[e].queue !== a) ||
                (f[e].anim.stop(c), (b = !1), f.splice(e, 1));
            (!b && c) || n.dequeue(this, a);
          })
        );
      },
      finish: function (a) {
        return (
          !1 !== a && (a = a || "fx"),
          this.each(function () {
            var b,
              c = n._data(this),
              d = c[a + "queue"],
              e = c[a + "queueHooks"],
              f = n.timers,
              g = d ? d.length : 0;
            for (
              c.finish = !0,
                n.queue(this, a, []),
                e && e.stop && e.stop.call(this, !0),
                b = f.length;
              b--;

            )
              f[b].elem === this &&
                f[b].queue === a &&
                (f[b].anim.stop(!0), f.splice(b, 1));
            for (b = 0; b < g; b++)
              d[b] && d[b].finish && d[b].finish.call(this);
            delete c.finish;
          })
        );
      },
    }),
    n.each(["toggle", "show", "hide"], function (a, b) {
      var c = n.fn[b];
      n.fn[b] = function (a, d, e) {
        return null == a || "boolean" == typeof a
          ? c.apply(this, arguments)
          : this.animate(lb(b, !0), a, d, e);
      };
    }),
    n.each(
      {
        slideDown: lb("show"),
        slideUp: lb("hide"),
        slideToggle: lb("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" },
      },
      function (a, b) {
        n.fn[a] = function (a, c, d) {
          return this.animate(b, a, c, d);
        };
      }
    ),
    (n.timers = []),
    (n.fx.tick = function () {
      var a,
        b = n.timers,
        c = 0;
      for (gb = n.now(); c < b.length; c++)
        (a = b[c])() || b[c] !== a || b.splice(c--, 1);
      b.length || n.fx.stop(), (gb = void 0);
    }),
    (n.fx.timer = function (a) {
      n.timers.push(a), a() ? n.fx.start() : n.timers.pop();
    }),
    (n.fx.interval = 13),
    (n.fx.start = function () {
      hb || (hb = a.setInterval(n.fx.tick, n.fx.interval));
    }),
    (n.fx.stop = function () {
      a.clearInterval(hb), (hb = null);
    }),
    (n.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (n.fn.delay = function (b, c) {
      return (
        (b = n.fx ? n.fx.speeds[b] || b : b),
        (c = c || "fx"),
        this.queue(c, function (c, d) {
          var e = a.setTimeout(c, b);
          d.stop = function () {
            a.clearTimeout(e);
          };
        })
      );
    }),
    (function () {
      var a,
        b = d.createElement("input"),
        c = d.createElement("div"),
        e = d.createElement("select"),
        f = e.appendChild(d.createElement("option"));
      (c = d.createElement("div")),
        c.setAttribute("className", "t"),
        (c.innerHTML =
          "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"),
        (a = c.getElementsByTagName("a")[0]),
        b.setAttribute("type", "checkbox"),
        c.appendChild(b),
        (a = c.getElementsByTagName("a")[0]),
        (a.style.cssText = "top:1px"),
        (l.getSetAttribute = "t" !== c.className),
        (l.style = /top/.test(a.getAttribute("style"))),
        (l.hrefNormalized = "/a" === a.getAttribute("href")),
        (l.checkOn = !!b.value),
        (l.optSelected = f.selected),
        (l.enctype = !!d.createElement("form").enctype),
        (e.disabled = !0),
        (l.optDisabled = !f.disabled),
        (b = d.createElement("input")),
        b.setAttribute("value", ""),
        (l.input = "" === b.getAttribute("value")),
        (b.value = "t"),
        b.setAttribute("type", "radio"),
        (l.radioValue = "t" === b.value);
    })();
  var qb = /\r/g,
    rb = /[\x20\t\r\n\f]+/g;
  n.fn.extend({
    val: function (a) {
      var b,
        c,
        d,
        e = this[0];
      {
        if (arguments.length)
          return (
            (d = n.isFunction(a)),
            this.each(function (c) {
              var e;
              1 === this.nodeType &&
                ((e = d ? a.call(this, c, n(this).val()) : a),
                null == e
                  ? (e = "")
                  : "number" == typeof e
                  ? (e += "")
                  : n.isArray(e) &&
                    (e = n.map(e, function (a) {
                      return null == a ? "" : a + "";
                    })),
                ((b =
                  n.valHooks[this.type] ||
                  n.valHooks[this.nodeName.toLowerCase()]) &&
                  "set" in b &&
                  void 0 !== b.set(this, e, "value")) ||
                  (this.value = e));
            })
          );
        if (e)
          return (b =
            n.valHooks[e.type] || n.valHooks[e.nodeName.toLowerCase()]) &&
            "get" in b &&
            void 0 !== (c = b.get(e, "value"))
            ? c
            : ((c = e.value),
              "string" == typeof c ? c.replace(qb, "") : null == c ? "" : c);
      }
    },
  }),
    n.extend({
      valHooks: {
        option: {
          get: function (a) {
            var b = n.find.attr(a, "value");
            return null != b ? b : n.trim(n.text(a)).replace(rb, " ");
          },
        },
        select: {
          get: function (a) {
            for (
              var b,
                c,
                d = a.options,
                e = a.selectedIndex,
                f = "select-one" === a.type || e < 0,
                g = f ? null : [],
                h = f ? e + 1 : d.length,
                i = e < 0 ? h : f ? e : 0;
              i < h;
              i++
            )
              if (
                ((c = d[i]),
                (c.selected || i === e) &&
                  (l.optDisabled
                    ? !c.disabled
                    : null === c.getAttribute("disabled")) &&
                  (!c.parentNode.disabled ||
                    !n.nodeName(c.parentNode, "optgroup")))
              ) {
                if (((b = n(c).val()), f)) return b;
                g.push(b);
              }
            return g;
          },
          set: function (a, b) {
            var c,
              d,
              e = a.options,
              f = n.makeArray(b),
              g = e.length;
            while (g--)
              if (((d = e[g]), n.inArray(n.valHooks.option.get(d), f) > -1))
                try {
                  d.selected = c = !0;
                } catch (h) {
                  d.scrollHeight;
                }
              else d.selected = !1;
            return c || (a.selectedIndex = -1), e;
          },
        },
      },
    }),
    n.each(["radio", "checkbox"], function () {
      (n.valHooks[this] = {
        set: function (a, b) {
          if (n.isArray(b)) return (a.checked = n.inArray(n(a).val(), b) > -1);
        },
      }),
        l.checkOn ||
          (n.valHooks[this].get = function (a) {
            return null === a.getAttribute("value") ? "on" : a.value;
          });
    });
  var sb,
    tb,
    ub = n.expr.attrHandle,
    vb = /^(?:checked|selected)$/i,
    wb = l.getSetAttribute,
    xb = l.input;
  n.fn.extend({
    attr: function (a, b) {
      return X(this, n.attr, a, b, arguments.length > 1);
    },
    removeAttr: function (a) {
      return this.each(function () {
        n.removeAttr(this, a);
      });
    },
  }),
    n.extend({
      attr: function (a, b, c) {
        var d,
          e,
          f = a.nodeType;
        if (3 !== f && 8 !== f && 2 !== f)
          return void 0 === a.getAttribute
            ? n.prop(a, b, c)
            : ((1 === f && n.isXMLDoc(a)) ||
                ((b = b.toLowerCase()),
                (e = n.attrHooks[b] || (n.expr.match.bool.test(b) ? tb : sb))),
              void 0 !== c
                ? null === c
                  ? void n.removeAttr(a, b)
                  : e && "set" in e && void 0 !== (d = e.set(a, c, b))
                  ? d
                  : (a.setAttribute(b, c + ""), c)
                : e && "get" in e && null !== (d = e.get(a, b))
                ? d
                : ((d = n.find.attr(a, b)), null == d ? void 0 : d));
      },
      attrHooks: {
        type: {
          set: function (a, b) {
            if (!l.radioValue && "radio" === b && n.nodeName(a, "input")) {
              var c = a.value;
              return a.setAttribute("type", b), c && (a.value = c), b;
            }
          },
        },
      },
      removeAttr: function (a, b) {
        var c,
          d,
          e = 0,
          f = b && b.match(F);
        if (f && 1 === a.nodeType)
          while ((c = f[e++]))
            (d = n.propFix[c] || c),
              n.expr.match.bool.test(c)
                ? (xb && wb) || !vb.test(c)
                  ? (a[d] = !1)
                  : (a[n.camelCase("default-" + c)] = a[d] = !1)
                : n.attr(a, c, ""),
              a.removeAttribute(wb ? c : d);
      },
    }),
    (tb = {
      set: function (a, b, c) {
        return (
          !1 === b
            ? n.removeAttr(a, c)
            : (xb && wb) || !vb.test(c)
            ? a.setAttribute((!wb && n.propFix[c]) || c, c)
            : (a[n.camelCase("default-" + c)] = a[c] = !0),
          c
        );
      },
    }),
    n.each(n.expr.match.bool.source.match(/\w+/g), function (a, b) {
      var c = ub[b] || n.find.attr;
      (xb && wb) || !vb.test(b)
        ? (ub[b] = function (a, b, d) {
            var e, f;
            return (
              d ||
                ((f = ub[b]),
                (ub[b] = e),
                (e = null != c(a, b, d) ? b.toLowerCase() : null),
                (ub[b] = f)),
              e
            );
          })
        : (ub[b] = function (a, b, c) {
            if (!c)
              return a[n.camelCase("default-" + b)] ? b.toLowerCase() : null;
          });
    }),
    (xb && wb) ||
      (n.attrHooks.value = {
        set: function (a, b, c) {
          if (!n.nodeName(a, "input")) return sb && sb.set(a, b, c);
          a.defaultValue = b;
        },
      }),
    wb ||
      ((sb = {
        set: function (a, b, c) {
          var d = a.getAttributeNode(c);
          if (
            (d || a.setAttributeNode((d = a.ownerDocument.createAttribute(c))),
            (d.value = b += ""),
            "value" === c || b === a.getAttribute(c))
          )
            return b;
        },
      }),
      (ub.id =
        ub.name =
        ub.coords =
          function (a, b, c) {
            var d;
            if (!c)
              return (d = a.getAttributeNode(b)) && "" !== d.value
                ? d.value
                : null;
          }),
      (n.valHooks.button = {
        get: function (a, b) {
          var c = a.getAttributeNode(b);
          if (c && c.specified) return c.value;
        },
        set: sb.set,
      }),
      (n.attrHooks.contenteditable = {
        set: function (a, b, c) {
          sb.set(a, "" !== b && b, c);
        },
      }),
      n.each(["width", "height"], function (a, b) {
        n.attrHooks[b] = {
          set: function (a, c) {
            if ("" === c) return a.setAttribute(b, "auto"), c;
          },
        };
      })),
    l.style ||
      (n.attrHooks.style = {
        get: function (a) {
          return a.style.cssText || void 0;
        },
        set: function (a, b) {
          return (a.style.cssText = b + "");
        },
      });
  var yb = /^(?:input|select|textarea|button|object)$/i,
    zb = /^(?:a|area)$/i;
  n.fn.extend({
    prop: function (a, b) {
      return X(this, n.prop, a, b, arguments.length > 1);
    },
    removeProp: function (a) {
      return (
        (a = n.propFix[a] || a),
        this.each(function () {
          try {
            (this[a] = void 0), delete this[a];
          } catch (b) {}
        })
      );
    },
  }),
    n.extend({
      prop: function (a, b, c) {
        var d,
          e,
          f = a.nodeType;
        if (3 !== f && 8 !== f && 2 !== f)
          return (
            (1 === f && n.isXMLDoc(a)) ||
              ((b = n.propFix[b] || b), (e = n.propHooks[b])),
            void 0 !== c
              ? e && "set" in e && void 0 !== (d = e.set(a, c, b))
                ? d
                : (a[b] = c)
              : e && "get" in e && null !== (d = e.get(a, b))
              ? d
              : a[b]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (a) {
            var b = n.find.attr(a, "tabindex");
            return b
              ? parseInt(b, 10)
              : yb.test(a.nodeName) || (zb.test(a.nodeName) && a.href)
              ? 0
              : -1;
          },
        },
      },
      propFix: { for: "htmlFor", class: "className" },
    }),
    l.hrefNormalized ||
      n.each(["href", "src"], function (a, b) {
        n.propHooks[b] = {
          get: function (a) {
            return a.getAttribute(b, 4);
          },
        };
      }),
    l.optSelected ||
      (n.propHooks.selected = {
        get: function (a) {
          var b = a.parentNode;
          return (
            b && (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex),
            null
          );
        },
        set: function (a) {
          var b = a.parentNode;
          b && (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex);
        },
      }),
    n.each(
      [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable",
      ],
      function () {
        n.propFix[this.toLowerCase()] = this;
      }
    ),
    l.enctype || (n.propFix.enctype = "encoding");
  var Ab = /[\t\r\n\f]/g;
  function Bb(a) {
    return n.attr(a, "class") || "";
  }
  n.fn.extend({
    addClass: function (a) {
      var b,
        c,
        d,
        e,
        f,
        g,
        h,
        i = 0;
      if (n.isFunction(a))
        return this.each(function (b) {
          n(this).addClass(a.call(this, b, Bb(this)));
        });
      if ("string" == typeof a && a) {
        b = a.match(F) || [];
        while ((c = this[i++]))
          if (
            ((e = Bb(c)),
            (d = 1 === c.nodeType && (" " + e + " ").replace(Ab, " ")))
          ) {
            g = 0;
            while ((f = b[g++])) d.indexOf(" " + f + " ") < 0 && (d += f + " ");
            (h = n.trim(d)), e !== h && n.attr(c, "class", h);
          }
      }
      return this;
    },
    removeClass: function (a) {
      var b,
        c,
        d,
        e,
        f,
        g,
        h,
        i = 0;
      if (n.isFunction(a))
        return this.each(function (b) {
          n(this).removeClass(a.call(this, b, Bb(this)));
        });
      if (!arguments.length) return this.attr("class", "");
      if ("string" == typeof a && a) {
        b = a.match(F) || [];
        while ((c = this[i++]))
          if (
            ((e = Bb(c)),
            (d = 1 === c.nodeType && (" " + e + " ").replace(Ab, " ")))
          ) {
            g = 0;
            while ((f = b[g++]))
              while (d.indexOf(" " + f + " ") > -1)
                d = d.replace(" " + f + " ", " ");
            (h = n.trim(d)), e !== h && n.attr(c, "class", h);
          }
      }
      return this;
    },
    toggleClass: function (a, b) {
      var c = typeof a;
      return "boolean" == typeof b && "string" === c
        ? b
          ? this.addClass(a)
          : this.removeClass(a)
        : n.isFunction(a)
        ? this.each(function (c) {
            n(this).toggleClass(a.call(this, c, Bb(this), b), b);
          })
        : this.each(function () {
            var b, d, e, f;
            if ("string" === c) {
              (d = 0), (e = n(this)), (f = a.match(F) || []);
              while ((b = f[d++]))
                e.hasClass(b) ? e.removeClass(b) : e.addClass(b);
            } else (void 0 !== a && "boolean" !== c) || ((b = Bb(this)), b && n._data(this, "__className__", b), n.attr(this, "class", b || !1 === a ? "" : n._data(this, "__className__") || ""));
          });
    },
    hasClass: function (a) {
      var b,
        c,
        d = 0;
      b = " " + a + " ";
      while ((c = this[d++]))
        if (
          1 === c.nodeType &&
          (" " + Bb(c) + " ").replace(Ab, " ").indexOf(b) > -1
        )
          return !0;
      return !1;
    },
  }),
    n.each(
      "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(
        " "
      ),
      function (a, b) {
        n.fn[b] = function (a, c) {
          return arguments.length > 0
            ? this.on(b, null, a, c)
            : this.trigger(b);
        };
      }
    ),
    n.fn.extend({
      hover: function (a, b) {
        return this.mouseenter(a).mouseleave(b || a);
      },
    });
  var Cb = a.location,
    Db = n.now(),
    Eb = /\?/,
    Fb =
      /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
  (n.parseJSON = function (b) {
    if (a.JSON && a.JSON.parse) return a.JSON.parse(b + "");
    var c,
      d = null,
      e = n.trim(b + "");
    return e &&
      !n.trim(
        e.replace(Fb, function (a, b, e, f) {
          return (
            c && b && (d = 0), 0 === d ? a : ((c = e || b), (d += !f - !e), "")
          );
        })
      )
      ? Function("return " + e)()
      : n.error("Invalid JSON: " + b);
  }),
    (n.parseXML = function (b) {
      var c, d;
      if (!b || "string" != typeof b) return null;
      try {
        a.DOMParser
          ? ((d = new a.DOMParser()), (c = d.parseFromString(b, "text/xml")))
          : ((c = new a.ActiveXObject("Microsoft.XMLDOM")),
            (c.async = "false"),
            c.loadXML(b));
      } catch (e) {
        c = void 0;
      }
      return (
        (c &&
          c.documentElement &&
          !c.getElementsByTagName("parsererror").length) ||
          n.error("Invalid XML: " + b),
        c
      );
    });
  var Gb = /#.*$/,
    Hb = /([?&])_=[^&]*/,
    Ib = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
    Jb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    Kb = /^(?:GET|HEAD)$/,
    Lb = /^\/\//,
    Mb = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
    Nb = {},
    Ob = {},
    Pb = "*/".concat("*"),
    Qb = Cb.href,
    Rb = Mb.exec(Qb.toLowerCase()) || [];
  function Sb(a) {
    return function (b, c) {
      "string" != typeof b && ((c = b), (b = "*"));
      var d,
        e = 0,
        f = b.toLowerCase().match(F) || [];
      if (n.isFunction(c))
        while ((d = f[e++]))
          "+" === d.charAt(0)
            ? ((d = d.slice(1) || "*"), (a[d] = a[d] || []).unshift(c))
            : (a[d] = a[d] || []).push(c);
    };
  }
  function Tb(a, b, c, d) {
    var e = {},
      f = a === Ob;
    function g(h) {
      var i;
      return (
        (e[h] = !0),
        n.each(a[h] || [], function (a, h) {
          var j = h(b, c, d);
          return "string" != typeof j || f || e[j]
            ? f
              ? !(i = j)
              : void 0
            : (b.dataTypes.unshift(j), g(j), !1);
        }),
        i
      );
    }
    return g(b.dataTypes[0]) || (!e["*"] && g("*"));
  }
  function Ub(a, b) {
    var c,
      d,
      e = n.ajaxSettings.flatOptions || {};
    for (d in b) void 0 !== b[d] && ((e[d] ? a : c || (c = {}))[d] = b[d]);
    return c && n.extend(!0, a, c), a;
  }
  function Vb(a, b, c) {
    var d,
      e,
      f,
      g,
      h = a.contents,
      i = a.dataTypes;
    while ("*" === i[0])
      i.shift(),
        void 0 === e && (e = a.mimeType || b.getResponseHeader("Content-Type"));
    if (e)
      for (g in h)
        if (h[g] && h[g].test(e)) {
          i.unshift(g);
          break;
        }
    if (i[0] in c) f = i[0];
    else {
      for (g in c) {
        if (!i[0] || a.converters[g + " " + i[0]]) {
          f = g;
          break;
        }
        d || (d = g);
      }
      f = f || d;
    }
    if (f) return f !== i[0] && i.unshift(f), c[f];
  }
  function Wb(a, b, c, d) {
    var e,
      f,
      g,
      h,
      i,
      j = {},
      k = a.dataTypes.slice();
    if (k[1]) for (g in a.converters) j[g.toLowerCase()] = a.converters[g];
    f = k.shift();
    while (f)
      if (
        (a.responseFields[f] && (c[a.responseFields[f]] = b),
        !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)),
        (i = f),
        (f = k.shift()))
      )
        if ("*" === f) f = i;
        else if ("*" !== i && i !== f) {
          if (!(g = j[i + " " + f] || j["* " + f]))
            for (e in j)
              if (
                ((h = e.split(" ")),
                h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]]))
              ) {
                !0 === g
                  ? (g = j[e])
                  : !0 !== j[e] && ((f = h[0]), k.unshift(h[1]));
                break;
              }
          if (!0 !== g)
            if (g && a.throws) b = g(b);
            else
              try {
                b = g(b);
              } catch (l) {
                return {
                  state: "parsererror",
                  error: g ? l : "No conversion from " + i + " to " + f,
                };
              }
        }
    return { state: "success", data: b };
  }
  n.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: Qb,
      type: "GET",
      isLocal: Jb.test(Rb[1]),
      global: !0,
      processData: !0,
      async: !0,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      accepts: {
        "*": Pb,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript",
      },
      contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON",
      },
      converters: {
        "* text": String,
        "text html": !0,
        "text json": n.parseJSON,
        "text xml": n.parseXML,
      },
      flatOptions: { url: !0, context: !0 },
    },
    ajaxSetup: function (a, b) {
      return b ? Ub(Ub(a, n.ajaxSettings), b) : Ub(n.ajaxSettings, a);
    },
    ajaxPrefilter: Sb(Nb),
    ajaxTransport: Sb(Ob),
    ajax: function (b, c) {
      "object" == typeof b && ((c = b), (b = void 0)), (c = c || {});
      var d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        l = n.ajaxSetup({}, c),
        m = l.context || l,
        o = l.context && (m.nodeType || m.jquery) ? n(m) : n.event,
        p = n.Deferred(),
        q = n.Callbacks("once memory"),
        r = l.statusCode || {},
        s = {},
        t = {},
        u = 0,
        v = "canceled",
        w = {
          readyState: 0,
          getResponseHeader: function (a) {
            var b;
            if (2 === u) {
              if (!k) {
                k = {};
                while ((b = Ib.exec(g))) k[b[1].toLowerCase()] = b[2];
              }
              b = k[a.toLowerCase()];
            }
            return null == b ? null : b;
          },
          getAllResponseHeaders: function () {
            return 2 === u ? g : null;
          },
          setRequestHeader: function (a, b) {
            var c = a.toLowerCase();
            return u || ((a = t[c] = t[c] || a), (s[a] = b)), this;
          },
          overrideMimeType: function (a) {
            return u || (l.mimeType = a), this;
          },
          statusCode: function (a) {
            var b;
            if (a)
              if (u < 2) for (b in a) r[b] = [r[b], a[b]];
              else w.always(a[w.status]);
            return this;
          },
          abort: function (a) {
            var b = a || v;
            return j && j.abort(b), x(0, b), this;
          },
        };
      if (
        ((p.promise(w).complete = q.add),
        (w.success = w.done),
        (w.error = w.fail),
        (l.url = ((b || l.url || Qb) + "")
          .replace(Gb, "")
          .replace(Lb, Rb[1] + "//")),
        (l.type = c.method || c.type || l.method || l.type),
        (l.dataTypes = n
          .trim(l.dataType || "*")
          .toLowerCase()
          .match(F) || [""]),
        null == l.crossDomain &&
          ((d = Mb.exec(l.url.toLowerCase())),
          (l.crossDomain = !(
            !d ||
            (d[1] === Rb[1] &&
              d[2] === Rb[2] &&
              (d[3] || ("http:" === d[1] ? "80" : "443")) ===
                (Rb[3] || ("http:" === Rb[1] ? "80" : "443")))
          ))),
        l.data &&
          l.processData &&
          "string" != typeof l.data &&
          (l.data = n.param(l.data, l.traditional)),
        Tb(Nb, l, c, w),
        2 === u)
      )
        return w;
      (i = n.event && l.global),
        i && 0 == n.active++ && n.event.trigger("ajaxStart"),
        (l.type = l.type.toUpperCase()),
        (l.hasContent = !Kb.test(l.type)),
        (f = l.url),
        l.hasContent ||
          (l.data &&
            ((f = l.url += (Eb.test(f) ? "&" : "?") + l.data), delete l.data),
          !1 === l.cache &&
            (l.url = Hb.test(f)
              ? f.replace(Hb, "$1_=" + Db++)
              : f + (Eb.test(f) ? "&" : "?") + "_=" + Db++)),
        l.ifModified &&
          (n.lastModified[f] &&
            w.setRequestHeader("If-Modified-Since", n.lastModified[f]),
          n.etag[f] && w.setRequestHeader("If-None-Match", n.etag[f])),
        ((l.data && l.hasContent && !1 !== l.contentType) || c.contentType) &&
          w.setRequestHeader("Content-Type", l.contentType),
        w.setRequestHeader(
          "Accept",
          l.dataTypes[0] && l.accepts[l.dataTypes[0]]
            ? l.accepts[l.dataTypes[0]] +
                ("*" !== l.dataTypes[0] ? ", " + Pb + "; q=0.01" : "")
            : l.accepts["*"]
        );
      for (e in l.headers) w.setRequestHeader(e, l.headers[e]);
      if (l.beforeSend && (!1 === l.beforeSend.call(m, w, l) || 2 === u))
        return w.abort();
      v = "abort";
      for (e in { success: 1, error: 1, complete: 1 }) w[e](l[e]);
      if ((j = Tb(Ob, l, c, w))) {
        if (((w.readyState = 1), i && o.trigger("ajaxSend", [w, l]), 2 === u))
          return w;
        l.async &&
          l.timeout > 0 &&
          (h = a.setTimeout(function () {
            w.abort("timeout");
          }, l.timeout));
        try {
          (u = 1), j.send(s, x);
        } catch (y) {
          if (!(u < 2)) throw y;
          x(-1, y);
        }
      } else x(-1, "No Transport");
      function x(b, c, d, e) {
        var k,
          s,
          t,
          v,
          x,
          y = c;
        2 !== u &&
          ((u = 2),
          h && a.clearTimeout(h),
          (j = void 0),
          (g = e || ""),
          (w.readyState = b > 0 ? 4 : 0),
          (k = (b >= 200 && b < 300) || 304 === b),
          d && (v = Vb(l, w, d)),
          (v = Wb(l, v, w, k)),
          k
            ? (l.ifModified &&
                ((x = w.getResponseHeader("Last-Modified")),
                x && (n.lastModified[f] = x),
                (x = w.getResponseHeader("etag")) && (n.etag[f] = x)),
              204 === b || "HEAD" === l.type
                ? (y = "nocontent")
                : 304 === b
                ? (y = "notmodified")
                : ((y = v.state), (s = v.data), (t = v.error), (k = !t)))
            : ((t = y), (!b && y) || ((y = "error"), b < 0 && (b = 0))),
          (w.status = b),
          (w.statusText = (c || y) + ""),
          k ? p.resolveWith(m, [s, y, w]) : p.rejectWith(m, [w, y, t]),
          w.statusCode(r),
          (r = void 0),
          i && o.trigger(k ? "ajaxSuccess" : "ajaxError", [w, l, k ? s : t]),
          q.fireWith(m, [w, y]),
          i &&
            (o.trigger("ajaxComplete", [w, l]),
            --n.active || n.event.trigger("ajaxStop")));
      }
      return w;
    },
    getJSON: function (a, b, c) {
      return n.get(a, b, c, "json");
    },
    getScript: function (a, b) {
      return n.get(a, void 0, b, "script");
    },
  }),
    n.each(["get", "post"], function (a, b) {
      n[b] = function (a, c, d, e) {
        return (
          n.isFunction(c) && ((e = e || d), (d = c), (c = void 0)),
          n.ajax(
            n.extend(
              { url: a, type: b, dataType: e, data: c, success: d },
              n.isPlainObject(a) && a
            )
          )
        );
      };
    }),
    (n._evalUrl = function (a) {
      return n.ajax({
        url: a,
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        throws: !0,
      });
    }),
    n.fn.extend({
      wrapAll: function (a) {
        if (n.isFunction(a))
          return this.each(function (b) {
            n(this).wrapAll(a.call(this, b));
          });
        if (this[0]) {
          var b = n(a, this[0].ownerDocument).eq(0).clone(!0);
          this[0].parentNode && b.insertBefore(this[0]),
            b
              .map(function () {
                var a = this;
                while (a.firstChild && 1 === a.firstChild.nodeType)
                  a = a.firstChild;
                return a;
              })
              .append(this);
        }
        return this;
      },
      wrapInner: function (a) {
        return n.isFunction(a)
          ? this.each(function (b) {
              n(this).wrapInner(a.call(this, b));
            })
          : this.each(function () {
              var b = n(this),
                c = b.contents();
              c.length ? c.wrapAll(a) : b.append(a);
            });
      },
      wrap: function (a) {
        var b = n.isFunction(a);
        return this.each(function (c) {
          n(this).wrapAll(b ? a.call(this, c) : a);
        });
      },
      unwrap: function () {
        return this.parent()
          .each(function () {
            n.nodeName(this, "body") || n(this).replaceWith(this.childNodes);
          })
          .end();
      },
    });
  function Xb(a) {
    return (a.style && a.style.display) || n.css(a, "display");
  }
  function Yb(a) {
    if (!n.contains(a.ownerDocument || d, a)) return !0;
    while (a && 1 === a.nodeType) {
      if ("none" === Xb(a) || "hidden" === a.type) return !0;
      a = a.parentNode;
    }
    return !1;
  }
  (n.expr.filters.hidden = function (a) {
    return l.reliableHiddenOffsets()
      ? a.offsetWidth <= 0 && a.offsetHeight <= 0 && !a.getClientRects().length
      : Yb(a);
  }),
    (n.expr.filters.visible = function (a) {
      return !n.expr.filters.hidden(a);
    });
  var Zb = /%20/g,
    $b = /\[\]$/,
    _b = /\r?\n/g,
    ac = /^(?:submit|button|image|reset|file)$/i,
    bc = /^(?:input|select|textarea|keygen)/i;
  function cc(a, b, c, d) {
    var e;
    if (n.isArray(b))
      n.each(b, function (b, e) {
        c || $b.test(a)
          ? d(a, e)
          : cc(
              a + "[" + ("object" == typeof e && null != e ? b : "") + "]",
              e,
              c,
              d
            );
      });
    else if (c || "object" !== n.type(b)) d(a, b);
    else for (e in b) cc(a + "[" + e + "]", b[e], c, d);
  }
  (n.param = function (a, b) {
    var c,
      d = [],
      e = function (a, b) {
        (b = n.isFunction(b) ? b() : null == b ? "" : b),
          (d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(b));
      };
    if (
      (void 0 === b && (b = n.ajaxSettings && n.ajaxSettings.traditional),
      n.isArray(a) || (a.jquery && !n.isPlainObject(a)))
    )
      n.each(a, function () {
        e(this.name, this.value);
      });
    else for (c in a) cc(c, a[c], b, e);
    return d.join("&").replace(Zb, "+");
  }),
    n.fn.extend({
      serialize: function () {
        return n.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var a = n.prop(this, "elements");
          return a ? n.makeArray(a) : this;
        })
          .filter(function () {
            var a = this.type;
            return (
              this.name &&
              !n(this).is(":disabled") &&
              bc.test(this.nodeName) &&
              !ac.test(a) &&
              (this.checked || !Y.test(a))
            );
          })
          .map(function (a, b) {
            var c = n(this).val();
            return null == c
              ? null
              : n.isArray(c)
              ? n.map(c, function (a) {
                  return { name: b.name, value: a.replace(_b, "\r\n") };
                })
              : { name: b.name, value: c.replace(_b, "\r\n") };
          })
          .get();
      },
    }),
    (n.ajaxSettings.xhr =
      void 0 !== a.ActiveXObject
        ? function () {
            return this.isLocal
              ? hc()
              : d.documentMode > 8
              ? gc()
              : (/^(get|post|head|put|delete|options)$/i.test(this.type) &&
                  gc()) ||
                hc();
          }
        : gc);
  var dc = 0,
    ec = {},
    fc = n.ajaxSettings.xhr();
  a.attachEvent &&
    a.attachEvent("onunload", function () {
      for (var a in ec) ec[a](void 0, !0);
    }),
    (l.cors = !!fc && "withCredentials" in fc),
    (fc = l.ajax = !!fc) &&
      n.ajaxTransport(function (b) {
        if (!b.crossDomain || l.cors) {
          var c;
          return {
            send: function (d, e) {
              var f,
                g = b.xhr(),
                h = ++dc;
              if (
                (g.open(b.type, b.url, b.async, b.username, b.password),
                b.xhrFields)
              )
                for (f in b.xhrFields) g[f] = b.xhrFields[f];
              b.mimeType &&
                g.overrideMimeType &&
                g.overrideMimeType(b.mimeType),
                b.crossDomain ||
                  d["X-Requested-With"] ||
                  (d["X-Requested-With"] = "XMLHttpRequest");
              for (f in d) void 0 !== d[f] && g.setRequestHeader(f, d[f] + "");
              g.send((b.hasContent && b.data) || null),
                (c = function (a, d) {
                  var f, i, j;
                  if (c && (d || 4 === g.readyState))
                    if (
                      (delete ec[h],
                      (c = void 0),
                      (g.onreadystatechange = n.noop),
                      d)
                    )
                      4 !== g.readyState && g.abort();
                    else {
                      (j = {}),
                        (f = g.status),
                        "string" == typeof g.responseText &&
                          (j.text = g.responseText);
                      try {
                        i = g.statusText;
                      } catch (k) {
                        i = "";
                      }
                      f || !b.isLocal || b.crossDomain
                        ? 1223 === f && (f = 204)
                        : (f = j.text ? 200 : 404);
                    }
                  j && e(f, i, j, g.getAllResponseHeaders());
                }),
                b.async
                  ? 4 === g.readyState
                    ? a.setTimeout(c)
                    : (g.onreadystatechange = ec[h] = c)
                  : c();
            },
            abort: function () {
              c && c(void 0, !0);
            },
          };
        }
      });
  function gc() {
    try {
      return new a.XMLHttpRequest();
    } catch (b) {}
  }
  function hc() {
    try {
      return new a.ActiveXObject("Microsoft.XMLHTTP");
    } catch (b) {}
  }
  n.ajaxSetup({
    accepts: {
      script:
        "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
    },
    contents: { script: /\b(?:java|ecma)script\b/ },
    converters: {
      "text script": function (a) {
        return n.globalEval(a), a;
      },
    },
  }),
    n.ajaxPrefilter("script", function (a) {
      void 0 === a.cache && (a.cache = !1),
        a.crossDomain && ((a.type = "GET"), (a.global = !1));
    }),
    n.ajaxTransport("script", function (a) {
      if (a.crossDomain) {
        var b,
          c = d.head || n("head")[0] || d.documentElement;
        return {
          send: function (e, f) {
            (b = d.createElement("script")),
              (b.async = !0),
              a.scriptCharset && (b.charset = a.scriptCharset),
              (b.src = a.url),
              (b.onload = b.onreadystatechange =
                function (a, c) {
                  (c ||
                    !b.readyState ||
                    /loaded|complete/.test(b.readyState)) &&
                    ((b.onload = b.onreadystatechange = null),
                    b.parentNode && b.parentNode.removeChild(b),
                    (b = null),
                    c || f(200, "success"));
                }),
              c.insertBefore(b, c.firstChild);
          },
          abort: function () {
            b && b.onload(void 0, !0);
          },
        };
      }
    });
  var ic = [],
    jc = /(=)\?(?=&|$)|\?\?/;
  n.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function () {
      var a = ic.pop() || n.expando + "_" + Db++;
      return (this[a] = !0), a;
    },
  }),
    n.ajaxPrefilter("json jsonp", function (b, c, d) {
      var e,
        f,
        g,
        h =
          !1 !== b.jsonp &&
          (jc.test(b.url)
            ? "url"
            : "string" == typeof b.data &&
              0 ===
                (b.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              jc.test(b.data) &&
              "data");
      if (h || "jsonp" === b.dataTypes[0])
        return (
          (e = b.jsonpCallback =
            n.isFunction(b.jsonpCallback)
              ? b.jsonpCallback()
              : b.jsonpCallback),
          h
            ? (b[h] = b[h].replace(jc, "$1" + e))
            : !1 !== b.jsonp &&
              (b.url += (Eb.test(b.url) ? "&" : "?") + b.jsonp + "=" + e),
          (b.converters["script json"] = function () {
            return g || n.error(e + " was not called"), g[0];
          }),
          (b.dataTypes[0] = "json"),
          (f = a[e]),
          (a[e] = function () {
            g = arguments;
          }),
          d.always(function () {
            void 0 === f ? n(a).removeProp(e) : (a[e] = f),
              b[e] && ((b.jsonpCallback = c.jsonpCallback), ic.push(e)),
              g && n.isFunction(f) && f(g[0]),
              (g = f = void 0);
          }),
          "script"
        );
    }),
    (n.parseHTML = function (a, b, c) {
      if (!a || "string" != typeof a) return null;
      "boolean" == typeof b && ((c = b), (b = !1)), (b = b || d);
      var e = x.exec(a),
        f = !c && [];
      return e
        ? [b.createElement(e[1])]
        : ((e = ia([a], b, f)),
          f && f.length && n(f).remove(),
          n.merge([], e.childNodes));
    });
  var kc = n.fn.load;
  (n.fn.load = function (a, b, c) {
    if ("string" != typeof a && kc) return kc.apply(this, arguments);
    var d,
      e,
      f,
      g = this,
      h = a.indexOf(" ");
    return (
      h > -1 && ((d = n.trim(a.slice(h, a.length))), (a = a.slice(0, h))),
      n.isFunction(b)
        ? ((c = b), (b = void 0))
        : b && "object" == typeof b && (e = "POST"),
      g.length > 0 &&
        n
          .ajax({ url: a, type: e || "GET", dataType: "html", data: b })
          .done(function (a) {
            (f = arguments),
              g.html(d ? n("<div>").append(n.parseHTML(a)).find(d) : a);
          })
          .always(
            c &&
              function (a, b) {
                g.each(function () {
                  c.apply(this, f || [a.responseText, b, a]);
                });
              }
          ),
      this
    );
  }),
    n.each(
      [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend",
      ],
      function (a, b) {
        n.fn[b] = function (a) {
          return this.on(b, a);
        };
      }
    ),
    (n.expr.filters.animated = function (a) {
      return n.grep(n.timers, function (b) {
        return a === b.elem;
      }).length;
    });
  function lc(a) {
    return n.isWindow(a)
      ? a
      : 9 === a.nodeType && (a.defaultView || a.parentWindow);
  }
  (n.offset = {
    setOffset: function (a, b, c) {
      var d,
        e,
        f,
        g,
        h,
        i,
        j,
        k = n.css(a, "position"),
        l = n(a),
        m = {};
      "static" === k && (a.style.position = "relative"),
        (h = l.offset()),
        (f = n.css(a, "top")),
        (i = n.css(a, "left")),
        (j =
          ("absolute" === k || "fixed" === k) &&
          n.inArray("auto", [f, i]) > -1),
        j
          ? ((d = l.position()), (g = d.top), (e = d.left))
          : ((g = parseFloat(f) || 0), (e = parseFloat(i) || 0)),
        n.isFunction(b) && (b = b.call(a, c, n.extend({}, h))),
        null != b.top && (m.top = b.top - h.top + g),
        null != b.left && (m.left = b.left - h.left + e),
        "using" in b ? b.using.call(a, m) : l.css(m);
    },
  }),
    n.fn.extend({
      offset: function (a) {
        if (arguments.length)
          return void 0 === a
            ? this
            : this.each(function (b) {
                n.offset.setOffset(this, a, b);
              });
        var b,
          c,
          d = { top: 0, left: 0 },
          e = this[0],
          f = e && e.ownerDocument;
        if (f)
          return (
            (b = f.documentElement),
            n.contains(b, e)
              ? (void 0 !== e.getBoundingClientRect &&
                  (d = e.getBoundingClientRect()),
                (c = lc(f)),
                {
                  top:
                    d.top + (c.pageYOffset || b.scrollTop) - (b.clientTop || 0),
                  left:
                    d.left +
                    (c.pageXOffset || b.scrollLeft) -
                    (b.clientLeft || 0),
                })
              : d
          );
      },
      position: function () {
        if (this[0]) {
          var a,
            b,
            c = { top: 0, left: 0 },
            d = this[0];
          return (
            "fixed" === n.css(d, "position")
              ? (b = d.getBoundingClientRect())
              : ((a = this.offsetParent()),
                (b = this.offset()),
                n.nodeName(a[0], "html") || (c = a.offset()),
                (c.top += n.css(a[0], "borderTopWidth", !0)),
                (c.left += n.css(a[0], "borderLeftWidth", !0))),
            {
              top: b.top - c.top - n.css(d, "marginTop", !0),
              left: b.left - c.left - n.css(d, "marginLeft", !0),
            }
          );
        }
      },
      offsetParent: function () {
        return this.map(function () {
          var a = this.offsetParent;
          while (
            a &&
            !n.nodeName(a, "html") &&
            "static" === n.css(a, "position")
          )
            a = a.offsetParent;
          return a || Pa;
        });
      },
    }),
    n.each(
      { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
      function (a, b) {
        var c = /Y/.test(b);
        n.fn[a] = function (d) {
          return X(
            this,
            function (a, d, e) {
              var f = lc(a);
              if (void 0 === e)
                return f
                  ? b in f
                    ? f[b]
                    : f.document.documentElement[d]
                  : a[d];
              f
                ? f.scrollTo(
                    c ? n(f).scrollLeft() : e,
                    c ? e : n(f).scrollTop()
                  )
                : (a[d] = e);
            },
            a,
            d,
            arguments.length,
            null
          );
        };
      }
    ),
    n.each(["top", "left"], function (a, b) {
      n.cssHooks[b] = Ta(l.pixelPosition, function (a, c) {
        if (c)
          return (c = Ra(a, b)), Na.test(c) ? n(a).position()[b] + "px" : c;
      });
    }),
    n.each({ Height: "height", Width: "width" }, function (a, b) {
      n.each(
        { padding: "inner" + a, content: b, "": "outer" + a },
        function (c, d) {
          n.fn[d] = function (d, e) {
            var f = arguments.length && (c || "boolean" != typeof d),
              g = c || (!0 === d || !0 === e ? "margin" : "border");
            return X(
              this,
              function (b, c, d) {
                var e;
                return n.isWindow(b)
                  ? b.document.documentElement["client" + a]
                  : 9 === b.nodeType
                  ? ((e = b.documentElement),
                    Math.max(
                      b.body["scroll" + a],
                      e["scroll" + a],
                      b.body["offset" + a],
                      e["offset" + a],
                      e["client" + a]
                    ))
                  : void 0 === d
                  ? n.css(b, c, g)
                  : n.style(b, c, d, g);
              },
              b,
              f ? d : void 0,
              f,
              null
            );
          };
        }
      );
    }),
    n.fn.extend({
      bind: function (a, b, c) {
        return this.on(a, null, b, c);
      },
      unbind: function (a, b) {
        return this.off(a, null, b);
      },
      delegate: function (a, b, c, d) {
        return this.on(b, a, c, d);
      },
      undelegate: function (a, b, c) {
        return 1 === arguments.length
          ? this.off(a, "**")
          : this.off(b, a || "**", c);
      },
    }),
    (n.fn.size = function () {
      return this.length;
    }),
    (n.fn.andSelf = n.fn.addBack),
    "function" == typeof define &&
      define.amd &&
      define("jquery", [], function () {
        return n;
      });
  var mc = a.jQuery,
    nc = a.$;
  return (
    (n.noConflict = function (b) {
      return a.$ === n && (a.$ = nc), b && a.jQuery === n && (a.jQuery = mc), n;
    }),
    b || (a.jQuery = a.$ = n),
    n
  );
});
jQuery.noConflict();
/*! jQuery Migrate v1.4.1 | (c) jQuery Foundation and other contributors | jquery.org/license */
"undefined" == typeof jQuery.migrateMute && (jQuery.migrateMute = !0),
  (function (a, b, c) {
    function d(c) {
      var d = b.console;
      f[c] ||
        ((f[c] = !0),
        a.migrateWarnings.push(c),
        d &&
          d.warn &&
          !a.migrateMute &&
          (d.warn("JQMIGRATE: " + c), a.migrateTrace && d.trace && d.trace()));
    }
    function e(b, c, e, f) {
      if (Object.defineProperty)
        try {
          return void Object.defineProperty(b, c, {
            configurable: !0,
            enumerable: !0,
            get: function () {
              return d(f), e;
            },
            set: function (a) {
              d(f), (e = a);
            },
          });
        } catch (g) {}
      (a._definePropertyBroken = !0), (b[c] = e);
    }
    a.migrateVersion = "1.4.1";
    var f = {};
    (a.migrateWarnings = []),
      b.console &&
        b.console.log &&
        b.console.log(
          "JQMIGRATE: Migrate is installed" +
            (a.migrateMute ? "" : " with logging active") +
            ", version " +
            a.migrateVersion
        ),
      a.migrateTrace === c && (a.migrateTrace = !0),
      (a.migrateReset = function () {
        (f = {}), (a.migrateWarnings.length = 0);
      }),
      "BackCompat" === document.compatMode &&
        d("jQuery is not compatible with Quirks Mode");
    var g = a("<input/>", { size: 1 }).attr("size") && a.attrFn,
      h = a.attr,
      i =
        (a.attrHooks.value && a.attrHooks.value.get) ||
        function () {
          return null;
        },
      j =
        (a.attrHooks.value && a.attrHooks.value.set) ||
        function () {
          return c;
        },
      k = /^(?:input|button)$/i,
      l = /^[238]$/,
      m =
        /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
      n = /^(?:checked|selected)$/i;
    e(a, "attrFn", g || {}, "jQuery.attrFn is deprecated"),
      (a.attr = function (b, e, f, i) {
        var j = e.toLowerCase(),
          o = b && b.nodeType;
        return i &&
          (h.length < 4 && d("jQuery.fn.attr( props, pass ) is deprecated"),
          b && !l.test(o) && (g ? e in g : a.isFunction(a.fn[e])))
          ? a(b)[e](f)
          : ("type" === e &&
              f !== c &&
              k.test(b.nodeName) &&
              b.parentNode &&
              d("Can't change the 'type' of an input or button in IE 6/7/8"),
            !a.attrHooks[j] &&
              m.test(j) &&
              ((a.attrHooks[j] = {
                get: function (b, d) {
                  var e,
                    f = a.prop(b, d);
                  return f === !0 ||
                    ("boolean" != typeof f &&
                      (e = b.getAttributeNode(d)) &&
                      e.nodeValue !== !1)
                    ? d.toLowerCase()
                    : c;
                },
                set: function (b, c, d) {
                  var e;
                  return (
                    c === !1
                      ? a.removeAttr(b, d)
                      : ((e = a.propFix[d] || d),
                        e in b && (b[e] = !0),
                        b.setAttribute(d, d.toLowerCase())),
                    d
                  );
                },
              }),
              n.test(j) &&
                d(
                  "jQuery.fn.attr('" +
                    j +
                    "') might use property instead of attribute"
                )),
            h.call(a, b, e, f));
      }),
      (a.attrHooks.value = {
        get: function (a, b) {
          var c = (a.nodeName || "").toLowerCase();
          return "button" === c
            ? i.apply(this, arguments)
            : ("input" !== c &&
                "option" !== c &&
                d("jQuery.fn.attr('value') no longer gets properties"),
              b in a ? a.value : null);
        },
        set: function (a, b) {
          var c = (a.nodeName || "").toLowerCase();
          return "button" === c
            ? j.apply(this, arguments)
            : ("input" !== c &&
                "option" !== c &&
                d("jQuery.fn.attr('value', val) no longer sets properties"),
              void (a.value = b));
        },
      });
    var o,
      p,
      q = a.fn.init,
      r = a.find,
      s = a.parseJSON,
      t = /^\s*</,
      u = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/,
      v = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/g,
      w = /^([^<]*)(<[\w\W]+>)([^>]*)$/;
    (a.fn.init = function (b, e, f) {
      var g, h;
      return b &&
        "string" == typeof b &&
        !a.isPlainObject(e) &&
        (g = w.exec(a.trim(b))) &&
        g[0] &&
        (t.test(b) || d("$(html) HTML strings must start with '<' character"),
        g[3] && d("$(html) HTML text after last tag is ignored"),
        "#" === g[0].charAt(0) &&
          (d("HTML string cannot start with a '#' character"),
          a.error("JQMIGRATE: Invalid selector string (XSS)")),
        e && e.context && e.context.nodeType && (e = e.context),
        a.parseHTML)
        ? q.call(
            this,
            a.parseHTML(g[2], (e && e.ownerDocument) || e || document, !0),
            e,
            f
          )
        : ((h = q.apply(this, arguments)),
          b && b.selector !== c
            ? ((h.selector = b.selector), (h.context = b.context))
            : ((h.selector = "string" == typeof b ? b : ""),
              b && (h.context = b.nodeType ? b : e || document)),
          h);
    }),
      (a.fn.init.prototype = a.fn),
      (a.find = function (a) {
        var b = Array.prototype.slice.call(arguments);
        if ("string" == typeof a && u.test(a))
          try {
            document.querySelector(a);
          } catch (c) {
            a = a.replace(v, function (a, b, c, d) {
              return "[" + b + c + '"' + d + '"]';
            });
            try {
              document.querySelector(a),
                d("Attribute selector with '#' must be quoted: " + b[0]),
                (b[0] = a);
            } catch (e) {
              d("Attribute selector with '#' was not fixed: " + b[0]);
            }
          }
        return r.apply(this, b);
      });
    var x;
    for (x in r)
      Object.prototype.hasOwnProperty.call(r, x) && (a.find[x] = r[x]);
    (a.parseJSON = function (a) {
      return a
        ? s.apply(this, arguments)
        : (d("jQuery.parseJSON requires a valid JSON string"), null);
    }),
      (a.uaMatch = function (a) {
        a = a.toLowerCase();
        var b =
          /(chrome)[ \/]([\w.]+)/.exec(a) ||
          /(webkit)[ \/]([\w.]+)/.exec(a) ||
          /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(a) ||
          /(msie) ([\w.]+)/.exec(a) ||
          (a.indexOf("compatible") < 0 &&
            /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(a)) ||
          [];
        return { browser: b[1] || "", version: b[2] || "0" };
      }),
      a.browser ||
        ((o = a.uaMatch(navigator.userAgent)),
        (p = {}),
        o.browser && ((p[o.browser] = !0), (p.version = o.version)),
        p.chrome ? (p.webkit = !0) : p.webkit && (p.safari = !0),
        (a.browser = p)),
      e(a, "browser", a.browser, "jQuery.browser is deprecated"),
      (a.boxModel = a.support.boxModel = "CSS1Compat" === document.compatMode),
      e(a, "boxModel", a.boxModel, "jQuery.boxModel is deprecated"),
      e(
        a.support,
        "boxModel",
        a.support.boxModel,
        "jQuery.support.boxModel is deprecated"
      ),
      (a.sub = function () {
        function b(a, c) {
          return new b.fn.init(a, c);
        }
        a.extend(!0, b, this),
          (b.superclass = this),
          (b.fn = b.prototype = this()),
          (b.fn.constructor = b),
          (b.sub = this.sub),
          (b.fn.init = function (d, e) {
            var f = a.fn.init.call(this, d, e, c);
            return f instanceof b ? f : b(f);
          }),
          (b.fn.init.prototype = b.fn);
        var c = b(document);
        return d("jQuery.sub() is deprecated"), b;
      }),
      (a.fn.size = function () {
        return (
          d("jQuery.fn.size() is deprecated; use the .length property"),
          this.length
        );
      });
    var y = !1;
    a.swap &&
      a.each(["height", "width", "reliableMarginRight"], function (b, c) {
        var d = a.cssHooks[c] && a.cssHooks[c].get;
        d &&
          (a.cssHooks[c].get = function () {
            var a;
            return (y = !0), (a = d.apply(this, arguments)), (y = !1), a;
          });
      }),
      (a.swap = function (a, b, c, e) {
        var f,
          g,
          h = {};
        y || d("jQuery.swap() is undocumented and deprecated");
        for (g in b) (h[g] = a.style[g]), (a.style[g] = b[g]);
        f = c.apply(a, e || []);
        for (g in b) a.style[g] = h[g];
        return f;
      }),
      a.ajaxSetup({ converters: { "text json": a.parseJSON } });
    var z = a.fn.data;
    a.fn.data = function (b) {
      var e,
        f,
        g = this[0];
      return !g ||
        "events" !== b ||
        1 !== arguments.length ||
        ((e = a.data(g, b)),
        (f = a._data(g, b)),
        (e !== c && e !== f) || f === c)
        ? z.apply(this, arguments)
        : (d("Use of jQuery.fn.data('events') is deprecated"), f);
    };
    var A = /\/(java|ecma)script/i;
    a.clean ||
      (a.clean = function (b, c, e, f) {
        (c = c || document),
          (c = (!c.nodeType && c[0]) || c),
          (c = c.ownerDocument || c),
          d("jQuery.clean() is deprecated");
        var g,
          h,
          i,
          j,
          k = [];
        if ((a.merge(k, a.buildFragment(b, c).childNodes), e))
          for (
            i = function (a) {
              return !a.type || A.test(a.type)
                ? f
                  ? f.push(a.parentNode ? a.parentNode.removeChild(a) : a)
                  : e.appendChild(a)
                : void 0;
            },
              g = 0;
            null != (h = k[g]);
            g++
          )
            (a.nodeName(h, "script") && i(h)) ||
              (e.appendChild(h),
              "undefined" != typeof h.getElementsByTagName &&
                ((j = a.grep(a.merge([], h.getElementsByTagName("script")), i)),
                k.splice.apply(k, [g + 1, 0].concat(j)),
                (g += j.length)));
        return k;
      });
    var B = a.event.add,
      C = a.event.remove,
      D = a.event.trigger,
      E = a.fn.toggle,
      F = a.fn.live,
      G = a.fn.die,
      H = a.fn.load,
      I = "ajaxStart|ajaxStop|ajaxSend|ajaxComplete|ajaxError|ajaxSuccess",
      J = new RegExp("\\b(?:" + I + ")\\b"),
      K = /(?:^|\s)hover(\.\S+|)\b/,
      L = function (b) {
        return "string" != typeof b || a.event.special.hover
          ? b
          : (K.test(b) &&
              d(
                "'hover' pseudo-event is deprecated, use 'mouseenter mouseleave'"
              ),
            b && b.replace(K, "mouseenter$1 mouseleave$1"));
      };
    a.event.props &&
      "attrChange" !== a.event.props[0] &&
      a.event.props.unshift(
        "attrChange",
        "attrName",
        "relatedNode",
        "srcElement"
      ),
      a.event.dispatch &&
        e(
          a.event,
          "handle",
          a.event.dispatch,
          "jQuery.event.handle is undocumented and deprecated"
        ),
      (a.event.add = function (a, b, c, e, f) {
        a !== document &&
          J.test(b) &&
          d("AJAX events should be attached to document: " + b),
          B.call(this, a, L(b || ""), c, e, f);
      }),
      (a.event.remove = function (a, b, c, d, e) {
        C.call(this, a, L(b) || "", c, d, e);
      }),
      a.each(["load", "unload", "error"], function (b, c) {
        a.fn[c] = function () {
          var a = Array.prototype.slice.call(arguments, 0);
          return "load" === c && "string" == typeof a[0]
            ? H.apply(this, a)
            : (d("jQuery.fn." + c + "() is deprecated"),
              a.splice(0, 0, c),
              arguments.length
                ? this.bind.apply(this, a)
                : (this.triggerHandler.apply(this, a), this));
        };
      }),
      (a.fn.toggle = function (b, c) {
        if (!a.isFunction(b) || !a.isFunction(c))
          return E.apply(this, arguments);
        d("jQuery.fn.toggle(handler, handler...) is deprecated");
        var e = arguments,
          f = b.guid || a.guid++,
          g = 0,
          h = function (c) {
            var d = (a._data(this, "lastToggle" + b.guid) || 0) % g;
            return (
              a._data(this, "lastToggle" + b.guid, d + 1),
              c.preventDefault(),
              e[d].apply(this, arguments) || !1
            );
          };
        for (h.guid = f; g < e.length; ) e[g++].guid = f;
        return this.click(h);
      }),
      (a.fn.live = function (b, c, e) {
        return (
          d("jQuery.fn.live() is deprecated"),
          F
            ? F.apply(this, arguments)
            : (a(this.context).on(b, this.selector, c, e), this)
        );
      }),
      (a.fn.die = function (b, c) {
        return (
          d("jQuery.fn.die() is deprecated"),
          G
            ? G.apply(this, arguments)
            : (a(this.context).off(b, this.selector || "**", c), this)
        );
      }),
      (a.event.trigger = function (a, b, c, e) {
        return (
          c || J.test(a) || d("Global events are undocumented and deprecated"),
          D.call(this, a, b, c || document, e)
        );
      }),
      a.each(I.split("|"), function (b, c) {
        a.event.special[c] = {
          setup: function () {
            var b = this;
            return (
              b !== document &&
                (a.event.add(document, c + "." + a.guid, function () {
                  a.event.trigger(
                    c,
                    Array.prototype.slice.call(arguments, 1),
                    b,
                    !0
                  );
                }),
                a._data(this, c, a.guid++)),
              !1
            );
          },
          teardown: function () {
            return (
              this !== document &&
                a.event.remove(document, c + "." + a._data(this, c)),
              !1
            );
          },
        };
      }),
      (a.event.special.ready = {
        setup: function () {
          this === document && d("'ready' event is deprecated");
        },
      });
    var M = a.fn.andSelf || a.fn.addBack,
      N = a.fn.find;
    if (
      ((a.fn.andSelf = function () {
        return (
          d("jQuery.fn.andSelf() replaced by jQuery.fn.addBack()"),
          M.apply(this, arguments)
        );
      }),
      (a.fn.find = function (a) {
        var b = N.apply(this, arguments);
        return (
          (b.context = this.context),
          (b.selector = this.selector ? this.selector + " " + a : a),
          b
        );
      }),
      a.Callbacks)
    ) {
      var O = a.Deferred,
        P = [
          [
            "resolve",
            "done",
            a.Callbacks("once memory"),
            a.Callbacks("once memory"),
            "resolved",
          ],
          [
            "reject",
            "fail",
            a.Callbacks("once memory"),
            a.Callbacks("once memory"),
            "rejected",
          ],
          ["notify", "progress", a.Callbacks("memory"), a.Callbacks("memory")],
        ];
      a.Deferred = function (b) {
        var c = O(),
          e = c.promise();
        return (
          (c.pipe = e.pipe =
            function () {
              var b = arguments;
              return (
                d("deferred.pipe() is deprecated"),
                a
                  .Deferred(function (d) {
                    a.each(P, function (f, g) {
                      var h = a.isFunction(b[f]) && b[f];
                      c[g[1]](function () {
                        var b = h && h.apply(this, arguments);
                        b && a.isFunction(b.promise)
                          ? b
                              .promise()
                              .done(d.resolve)
                              .fail(d.reject)
                              .progress(d.notify)
                          : d[g[0] + "With"](
                              this === e ? d.promise() : this,
                              h ? [b] : arguments
                            );
                      });
                    }),
                      (b = null);
                  })
                  .promise()
              );
            }),
          (c.isResolved = function () {
            return (
              d("deferred.isResolved is deprecated"), "resolved" === c.state()
            );
          }),
          (c.isRejected = function () {
            return (
              d("deferred.isRejected is deprecated"), "rejected" === c.state()
            );
          }),
          b && b.call(c, c),
          c
        );
      };
    }
  })(jQuery, window);
/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-applicationcache-audio-backgroundsize-borderimage-borderradius-boxshadow-canvas-canvastext-cssanimations-csscolumns-cssgradients-csspositionsticky-cssreflections-csstransforms-csstransforms3d-csstransitions-flexbox-flexboxlegacy-fontface-generatedcontent-geolocation-hashchange-history-hsla-indexeddb-inlinesvg-input-inputtypes-localstorage-multiplebgs-opacity-postmessage-rgba-sessionstorage-smil-svg-svgclippaths-textshadow-video-webgl-websockets-websqldatabase-webworkers-domprefixes-hasevent-prefixed-prefixes-setclasses-shiv-testallprops-testprop-teststyles !*/
!(function (e, t, n) {
  function r(e, t) {
    return typeof e === t;
  }
  function a() {
    var e, t, n, a, o, i, s;
    for (var c in b)
      if (b.hasOwnProperty(c)) {
        if (
          ((e = []),
          (t = b[c]),
          t.name &&
            (e.push(t.name.toLowerCase()),
            t.options && t.options.aliases && t.options.aliases.length))
        )
          for (n = 0; n < t.options.aliases.length; n++)
            e.push(t.options.aliases[n].toLowerCase());
        for (a = r(t.fn, "function") ? t.fn() : t.fn, o = 0; o < e.length; o++)
          (i = e[o]),
            (s = i.split(".")),
            1 === s.length
              ? (Modernizr[s[0]] = a)
              : (!Modernizr[s[0]] ||
                  Modernizr[s[0]] instanceof Boolean ||
                  (Modernizr[s[0]] = new Boolean(Modernizr[s[0]])),
                (Modernizr[s[0]][s[1]] = a)),
            y.push((a ? "" : "no-") + s.join("-"));
      }
  }
  function o(e) {
    var t = C.className,
      n = Modernizr._config.classPrefix || "";
    if ((E && (t = t.baseVal), Modernizr._config.enableJSClass)) {
      var r = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
      t = t.replace(r, "$1" + n + "js$2");
    }
    Modernizr._config.enableClasses &&
      ((t += " " + n + e.join(" " + n)),
      E ? (C.className.baseVal = t) : (C.className = t));
  }
  function i() {
    return "function" != typeof t.createElement
      ? t.createElement(arguments[0])
      : E
      ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0])
      : t.createElement.apply(t, arguments);
  }
  function s(e) {
    return e
      .replace(/([a-z])-([a-z])/g, function (e, t, n) {
        return t + n.toUpperCase();
      })
      .replace(/^-/, "");
  }
  function c(e, t) {
    return !!~("" + e).indexOf(t);
  }
  function d() {
    var e = t.body;
    return e || ((e = i(E ? "svg" : "body")), (e.fake = !0)), e;
  }
  function l(e, n, r, a) {
    var o,
      s,
      c,
      l,
      u = "modernizr",
      f = i("div"),
      p = d();
    if (parseInt(r, 10))
      for (; r--; )
        (c = i("div")), (c.id = a ? a[r] : u + (r + 1)), f.appendChild(c);
    return (
      (o = i("style")),
      (o.type = "text/css"),
      (o.id = "s" + u),
      (p.fake ? p : f).appendChild(o),
      p.appendChild(f),
      o.styleSheet
        ? (o.styleSheet.cssText = e)
        : o.appendChild(t.createTextNode(e)),
      (f.id = u),
      p.fake &&
        ((p.style.background = ""),
        (p.style.overflow = "hidden"),
        (l = C.style.overflow),
        (C.style.overflow = "hidden"),
        C.appendChild(p)),
      (s = n(f, e)),
      p.fake
        ? (p.parentNode.removeChild(p), (C.style.overflow = l), C.offsetHeight)
        : f.parentNode.removeChild(f),
      !!s
    );
  }
  function u(e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }
  function f(e, t, n) {
    var a;
    for (var o in e)
      if (e[o] in t)
        return n === !1
          ? e[o]
          : ((a = t[e[o]]), r(a, "function") ? u(a, n || t) : a);
    return !1;
  }
  function p(e) {
    return e
      .replace(/([A-Z])/g, function (e, t) {
        return "-" + t.toLowerCase();
      })
      .replace(/^ms-/, "-ms-");
  }
  function m(t, r) {
    var a = t.length;
    if ("CSS" in e && "supports" in e.CSS) {
      for (; a--; ) if (e.CSS.supports(p(t[a]), r)) return !0;
      return !1;
    }
    if ("CSSSupportsRule" in e) {
      for (var o = []; a--; ) o.push("(" + p(t[a]) + ":" + r + ")");
      return (
        (o = o.join(" or ")),
        l(
          "@supports (" + o + ") { #modernizr { position: absolute; } }",
          function (e) {
            return "absolute" == getComputedStyle(e, null).position;
          }
        )
      );
    }
    return n;
  }
  function g(e, t, a, o) {
    function d() {
      u && (delete W.style, delete W.modElem);
    }
    if (((o = r(o, "undefined") ? !1 : o), !r(a, "undefined"))) {
      var l = m(e, a);
      if (!r(l, "undefined")) return l;
    }
    for (
      var u, f, p, g, h, v = ["modernizr", "tspan", "samp"];
      !W.style && v.length;

    )
      (u = !0), (W.modElem = i(v.shift())), (W.style = W.modElem.style);
    for (p = e.length, f = 0; p > f; f++)
      if (
        ((g = e[f]),
        (h = W.style[g]),
        c(g, "-") && (g = s(g)),
        W.style[g] !== n)
      ) {
        if (o || r(a, "undefined")) return d(), "pfx" == t ? g : !0;
        try {
          W.style[g] = a;
        } catch (y) {}
        if (W.style[g] != h) return d(), "pfx" == t ? g : !0;
      }
    return d(), !1;
  }
  function h(e, t, n, a, o) {
    var i = e.charAt(0).toUpperCase() + e.slice(1),
      s = (e + " " + B.join(i + " ") + i).split(" ");
    return r(t, "string") || r(t, "undefined")
      ? g(s, t, a, o)
      : ((s = (e + " " + P.join(i + " ") + i).split(" ")), f(s, t, n));
  }
  function v(e, t, r) {
    return h(e, n, n, t, r);
  }
  var y = [],
    b = [],
    x = {
      _version: "3.3.1",
      _config: {
        classPrefix: "",
        enableClasses: !0,
        enableJSClass: !0,
        usePrefixes: !0,
      },
      _q: [],
      on: function (e, t) {
        var n = this;
        setTimeout(function () {
          t(n[e]);
        }, 0);
      },
      addTest: function (e, t, n) {
        b.push({ name: e, fn: t, options: n });
      },
      addAsyncTest: function (e) {
        b.push({ name: null, fn: e });
      },
    },
    Modernizr = function () {};
  (Modernizr.prototype = x),
    (Modernizr = new Modernizr()),
    Modernizr.addTest("applicationcache", "applicationCache" in e),
    Modernizr.addTest("geolocation", "geolocation" in navigator),
    Modernizr.addTest("history", function () {
      var t = navigator.userAgent;
      return (-1 === t.indexOf("Android 2.") &&
        -1 === t.indexOf("Android 4.0")) ||
        -1 === t.indexOf("Mobile Safari") ||
        -1 !== t.indexOf("Chrome") ||
        -1 !== t.indexOf("Windows Phone")
        ? e.history && "pushState" in e.history
        : !1;
    }),
    Modernizr.addTest("postmessage", "postMessage" in e),
    Modernizr.addTest(
      "svg",
      !!t.createElementNS &&
        !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect
    );
  var T = !1;
  try {
    T = "WebSocket" in e && 2 === e.WebSocket.CLOSING;
  } catch (w) {}
  Modernizr.addTest("websockets", T),
    Modernizr.addTest("localstorage", function () {
      var e = "modernizr";
      try {
        return localStorage.setItem(e, e), localStorage.removeItem(e), !0;
      } catch (t) {
        return !1;
      }
    }),
    Modernizr.addTest("sessionstorage", function () {
      var e = "modernizr";
      try {
        return sessionStorage.setItem(e, e), sessionStorage.removeItem(e), !0;
      } catch (t) {
        return !1;
      }
    }),
    Modernizr.addTest("websqldatabase", "openDatabase" in e),
    Modernizr.addTest("webworkers", "Worker" in e);
  var S = x._config.usePrefixes
    ? " -webkit- -moz- -o- -ms- ".split(" ")
    : ["", ""];
  x._prefixes = S;
  var C = t.documentElement,
    E = "svg" === C.nodeName.toLowerCase();
  E ||
    !(function (e, t) {
      function n(e, t) {
        var n = e.createElement("p"),
          r = e.getElementsByTagName("head")[0] || e.documentElement;
        return (
          (n.innerHTML = "x<style>" + t + "</style>"),
          r.insertBefore(n.lastChild, r.firstChild)
        );
      }
      function r() {
        var e = b.elements;
        return "string" == typeof e ? e.split(" ") : e;
      }
      function a(e, t) {
        var n = b.elements;
        "string" != typeof n && (n = n.join(" ")),
          "string" != typeof e && (e = e.join(" ")),
          (b.elements = n + " " + e),
          d(t);
      }
      function o(e) {
        var t = y[e[h]];
        return t || ((t = {}), v++, (e[h] = v), (y[v] = t)), t;
      }
      function i(e, n, r) {
        if ((n || (n = t), u)) return n.createElement(e);
        r || (r = o(n));
        var a;
        return (
          (a = r.cache[e]
            ? r.cache[e].cloneNode()
            : g.test(e)
            ? (r.cache[e] = r.createElem(e)).cloneNode()
            : r.createElem(e)),
          !a.canHaveChildren || m.test(e) || a.tagUrn
            ? a
            : r.frag.appendChild(a)
        );
      }
      function s(e, n) {
        if ((e || (e = t), u)) return e.createDocumentFragment();
        n = n || o(e);
        for (
          var a = n.frag.cloneNode(), i = 0, s = r(), c = s.length;
          c > i;
          i++
        )
          a.createElement(s[i]);
        return a;
      }
      function c(e, t) {
        t.cache ||
          ((t.cache = {}),
          (t.createElem = e.createElement),
          (t.createFrag = e.createDocumentFragment),
          (t.frag = t.createFrag())),
          (e.createElement = function (n) {
            return b.shivMethods ? i(n, e, t) : t.createElem(n);
          }),
          (e.createDocumentFragment = Function(
            "h,f",
            "return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&(" +
              r()
                .join()
                .replace(/[\w\-:]+/g, function (e) {
                  return (
                    t.createElem(e), t.frag.createElement(e), 'c("' + e + '")'
                  );
                }) +
              ");return n}"
          )(b, t.frag));
      }
      function d(e) {
        e || (e = t);
        var r = o(e);
        return (
          !b.shivCSS ||
            l ||
            r.hasCSS ||
            (r.hasCSS = !!n(
              e,
              "article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}"
            )),
          u || c(e, r),
          e
        );
      }
      var l,
        u,
        f = "3.7.3",
        p = e.html5 || {},
        m =
          /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,
        g =
          /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,
        h = "_html5shiv",
        v = 0,
        y = {};
      !(function () {
        try {
          var e = t.createElement("a");
          (e.innerHTML = "<xyz></xyz>"),
            (l = "hidden" in e),
            (u =
              1 == e.childNodes.length ||
              (function () {
                t.createElement("a");
                var e = t.createDocumentFragment();
                return (
                  "undefined" == typeof e.cloneNode ||
                  "undefined" == typeof e.createDocumentFragment ||
                  "undefined" == typeof e.createElement
                );
              })());
        } catch (n) {
          (l = !0), (u = !0);
        }
      })();
      var b = {
        elements:
          p.elements ||
          "abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",
        version: f,
        shivCSS: p.shivCSS !== !1,
        supportsUnknownElements: u,
        shivMethods: p.shivMethods !== !1,
        type: "default",
        shivDocument: d,
        createElement: i,
        createDocumentFragment: s,
        addElements: a,
      };
      (e.html5 = b),
        d(t),
        "object" == typeof module && module.exports && (module.exports = b);
    })("undefined" != typeof e ? e : this, t);
  var k = "Moz O ms Webkit",
    P = x._config.usePrefixes ? k.toLowerCase().split(" ") : [];
  x._domPrefixes = P;
  var _ = (function () {
    function e(e, t) {
      var a;
      return e
        ? ((t && "string" != typeof t) || (t = i(t || "div")),
          (e = "on" + e),
          (a = e in t),
          !a &&
            r &&
            (t.setAttribute || (t = i("div")),
            t.setAttribute(e, ""),
            (a = "function" == typeof t[e]),
            t[e] !== n && (t[e] = n),
            t.removeAttribute(e)),
          a)
        : !1;
    }
    var r = !("onblur" in t.documentElement);
    return e;
  })();
  (x.hasEvent = _),
    Modernizr.addTest("hashchange", function () {
      return _("hashchange", e) === !1
        ? !1
        : t.documentMode === n || t.documentMode > 7;
    }),
    Modernizr.addTest("audio", function () {
      var e = i("audio"),
        t = !1;
      try {
        (t = !!e.canPlayType) &&
          ((t = new Boolean(t)),
          (t.ogg = e
            .canPlayType('audio/ogg; codecs="vorbis"')
            .replace(/^no$/, "")),
          (t.mp3 = e
            .canPlayType('audio/mpeg; codecs="mp3"')
            .replace(/^no$/, "")),
          (t.opus =
            e.canPlayType('audio/ogg; codecs="opus"') ||
            e.canPlayType('audio/webm; codecs="opus"').replace(/^no$/, "")),
          (t.wav = e.canPlayType('audio/wav; codecs="1"').replace(/^no$/, "")),
          (t.m4a = (
            e.canPlayType("audio/x-m4a;") || e.canPlayType("audio/aac;")
          ).replace(/^no$/, "")));
      } catch (n) {}
      return t;
    }),
    Modernizr.addTest("canvas", function () {
      var e = i("canvas");
      return !(!e.getContext || !e.getContext("2d"));
    }),
    Modernizr.addTest("canvastext", function () {
      return Modernizr.canvas === !1
        ? !1
        : "function" == typeof i("canvas").getContext("2d").fillText;
    }),
    Modernizr.addTest("video", function () {
      var e = i("video"),
        t = !1;
      try {
        (t = !!e.canPlayType) &&
          ((t = new Boolean(t)),
          (t.ogg = e
            .canPlayType('video/ogg; codecs="theora"')
            .replace(/^no$/, "")),
          (t.h264 = e
            .canPlayType('video/mp4; codecs="avc1.42E01E"')
            .replace(/^no$/, "")),
          (t.webm = e
            .canPlayType('video/webm; codecs="vp8, vorbis"')
            .replace(/^no$/, "")),
          (t.vp9 = e
            .canPlayType('video/webm; codecs="vp9"')
            .replace(/^no$/, "")),
          (t.hls = e
            .canPlayType('application/x-mpegURL; codecs="avc1.42E01E"')
            .replace(/^no$/, "")));
      } catch (n) {}
      return t;
    }),
    Modernizr.addTest("webgl", function () {
      var t = i("canvas"),
        n =
          "probablySupportsContext" in t
            ? "probablySupportsContext"
            : "supportsContext";
      return n in t
        ? t[n]("webgl") || t[n]("experimental-webgl")
        : "WebGLRenderingContext" in e;
    }),
    Modernizr.addTest("cssgradients", function () {
      for (
        var e,
          t = "background-image:",
          n = "gradient(linear,left top,right bottom,from(#9f9),to(white));",
          r = "",
          a = 0,
          o = S.length - 1;
        o > a;
        a++
      )
        (e = 0 === a ? "to " : ""),
          (r += t + S[a] + "linear-gradient(" + e + "left top, #9f9, white);");
      Modernizr._config.usePrefixes && (r += t + "-webkit-" + n);
      var s = i("a"),
        c = s.style;
      return (c.cssText = r), ("" + c.backgroundImage).indexOf("gradient") > -1;
    }),
    Modernizr.addTest("multiplebgs", function () {
      var e = i("a").style;
      return (
        (e.cssText =
          "background:url(https://),url(https://),red url(https://)"),
        /(url\s*\(.*?){3}/.test(e.background)
      );
    }),
    Modernizr.addTest("opacity", function () {
      var e = i("a").style;
      return (e.cssText = S.join("opacity:.55;")), /^0.55$/.test(e.opacity);
    }),
    Modernizr.addTest("rgba", function () {
      var e = i("a").style;
      return (
        (e.cssText = "background-color:rgba(150,255,150,.5)"),
        ("" + e.backgroundColor).indexOf("rgba") > -1
      );
    }),
    Modernizr.addTest("inlinesvg", function () {
      var e = i("div");
      return (
        (e.innerHTML = "<svg/>"),
        "http://www.w3.org/2000/svg" ==
          ("undefined" != typeof SVGRect &&
            e.firstChild &&
            e.firstChild.namespaceURI)
      );
    }),
    Modernizr.addTest("csspositionsticky", function () {
      var e = "position:",
        t = "sticky",
        n = i("a"),
        r = n.style;
      return (
        (r.cssText = e + S.join(t + ";" + e).slice(0, -e.length)),
        -1 !== r.position.indexOf(t)
      );
    });
  var N = i("input"),
    R =
      "autocomplete autofocus list placeholder max min multiple pattern required step".split(
        " "
      ),
    z = {};
  Modernizr.input = (function (t) {
    for (var n = 0, r = t.length; r > n; n++) z[t[n]] = !!(t[n] in N);
    return z.list && (z.list = !(!i("datalist") || !e.HTMLDataListElement)), z;
  })(R);
  var $ =
      "search tel url email datetime date month week time datetime-local number range color".split(
        " "
      ),
    A = {};
  (Modernizr.inputtypes = (function (e) {
    for (var r, a, o, i = e.length, s = "1)", c = 0; i > c; c++)
      N.setAttribute("type", (r = e[c])),
        (o = "text" !== N.type && "style" in N),
        o &&
          ((N.value = s),
          (N.style.cssText = "position:absolute;visibility:hidden;"),
          /^range$/.test(r) && N.style.WebkitAppearance !== n
            ? (C.appendChild(N),
              (a = t.defaultView),
              (o =
                a.getComputedStyle &&
                "textfield" !== a.getComputedStyle(N, null).WebkitAppearance &&
                0 !== N.offsetHeight),
              C.removeChild(N))
            : /^(search|tel)$/.test(r) ||
              (o = /^(url|email)$/.test(r)
                ? N.checkValidity && N.checkValidity() === !1
                : N.value != s)),
        (A[e[c]] = !!o);
    return A;
  })($)),
    Modernizr.addTest("hsla", function () {
      var e = i("a").style;
      return (
        (e.cssText = "background-color:hsla(120,40%,100%,.5)"),
        c(e.backgroundColor, "rgba") || c(e.backgroundColor, "hsla")
      );
    });
  var O = "CSS" in e && "supports" in e.CSS,
    L = "supportsCSS" in e;
  Modernizr.addTest("supports", O || L);
  var j = {}.toString;
  Modernizr.addTest("svgclippaths", function () {
    return (
      !!t.createElementNS &&
      /SVGClipPath/.test(
        j.call(t.createElementNS("http://www.w3.org/2000/svg", "clipPath"))
      )
    );
  }),
    Modernizr.addTest("smil", function () {
      return (
        !!t.createElementNS &&
        /SVGAnimate/.test(
          j.call(t.createElementNS("http://www.w3.org/2000/svg", "animate"))
        )
      );
    });
  var B = x._config.usePrefixes ? k.split(" ") : [];
  x._cssomPrefixes = B;
  var F = function (t) {
    var r,
      a = S.length,
      o = e.CSSRule;
    if ("undefined" == typeof o) return n;
    if (!t) return !1;
    if (
      ((t = t.replace(/^@/, "")),
      (r = t.replace(/-/g, "_").toUpperCase() + "_RULE"),
      r in o)
    )
      return "@" + t;
    for (var i = 0; a > i; i++) {
      var s = S[i],
        c = s.toUpperCase() + "_" + r;
      if (c in o) return "@-" + s.toLowerCase() + "-" + t;
    }
    return !1;
  };
  x.atRule = F;
  var M = (x.testStyles = l),
    D = (function () {
      var e = navigator.userAgent,
        t = e.match(/applewebkit\/([0-9]+)/gi) && parseFloat(RegExp.$1),
        n = e.match(/w(eb)?osbrowser/gi),
        r =
          e.match(/windows phone/gi) &&
          e.match(/iemobile\/([0-9])+/gi) &&
          parseFloat(RegExp.$1) >= 9,
        a = 533 > t && e.match(/android/gi);
      return n || a || r;
    })();
  D
    ? Modernizr.addTest("fontface", !1)
    : M('@font-face {font-family:"font";src:url("https://")}', function (e, n) {
        var r = t.getElementById("smodernizr"),
          a = r.sheet || r.styleSheet,
          o = a
            ? a.cssRules && a.cssRules[0]
              ? a.cssRules[0].cssText
              : a.cssText || ""
            : "",
          i = /src/i.test(o) && 0 === o.indexOf(n.split(" ")[0]);
        Modernizr.addTest("fontface", i);
      }),
    M(
      '#modernizr{font:0/0 a}#modernizr:after{content:":)";visibility:hidden;font:7px/1 a}',
      function (e) {
        Modernizr.addTest("generatedcontent", e.offsetHeight >= 7);
      }
    );
  var I = { elem: i("modernizr") };
  Modernizr._q.push(function () {
    delete I.elem;
  });
  var W = { style: I.elem.style };
  Modernizr._q.unshift(function () {
    delete W.style;
  });
  var V = (x.testProp = function (e, t, r) {
    return g([e], n, t, r);
  });
  Modernizr.addTest("textshadow", V("textShadow", "1px 1px")),
    (x.testAllProps = h);
  var H,
    U = (x.prefixed = function (e, t, n) {
      return 0 === e.indexOf("@")
        ? F(e)
        : (-1 != e.indexOf("-") && (e = s(e)), t ? h(e, t, n) : h(e, "pfx"));
    });
  try {
    H = U("indexedDB", e);
  } catch (w) {}
  Modernizr.addTest("indexeddb", !!H),
    H && Modernizr.addTest("indexeddb.deletedatabase", "deleteDatabase" in H),
    (x.testAllProps = v),
    Modernizr.addTest("cssanimations", v("animationName", "a", !0)),
    Modernizr.addTest("backgroundsize", v("backgroundSize", "100%", !0)),
    Modernizr.addTest("borderimage", v("borderImage", "url() 1", !0)),
    Modernizr.addTest("borderradius", v("borderRadius", "0px", !0)),
    Modernizr.addTest("boxshadow", v("boxShadow", "1px 1px", !0)),
    (function () {
      Modernizr.addTest("csscolumns", function () {
        var e = !1,
          t = v("columnCount");
        try {
          (e = !!t) && (e = new Boolean(e));
        } catch (n) {}
        return e;
      });
      for (
        var e,
          t,
          n = [
            "Width",
            "Span",
            "Fill",
            "Gap",
            "Rule",
            "RuleColor",
            "RuleStyle",
            "RuleWidth",
            "BreakBefore",
            "BreakAfter",
            "BreakInside",
          ],
          r = 0;
        r < n.length;
        r++
      )
        (e = n[r].toLowerCase()),
          (t = v("column" + n[r])),
          ("breakbefore" === e || "breakafter" === e || "breakinside" == e) &&
            (t = t || v(n[r])),
          Modernizr.addTest("csscolumns." + e, t);
    })(),
    Modernizr.addTest("flexbox", v("flexBasis", "1px", !0)),
    Modernizr.addTest("flexboxlegacy", v("boxDirection", "reverse", !0)),
    Modernizr.addTest("cssreflections", v("boxReflect", "above", !0)),
    Modernizr.addTest("csstransforms", function () {
      return (
        -1 === navigator.userAgent.indexOf("Android 2.") &&
        v("transform", "scale(1)", !0)
      );
    }),
    Modernizr.addTest("csstransforms3d", function () {
      var e = !!v("perspective", "1px", !0),
        t = Modernizr._config.usePrefixes;
      if (e && (!t || "webkitPerspective" in C.style)) {
        var n,
          r = "#modernizr{width:0;height:0}";
        Modernizr.supports
          ? (n = "@supports (perspective: 1px)")
          : ((n = "@media (transform-3d)"),
            t && (n += ",(-webkit-transform-3d)")),
          (n +=
            "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}"),
          M(r + n, function (t) {
            e = 7 === t.offsetWidth && 18 === t.offsetHeight;
          });
      }
      return e;
    }),
    Modernizr.addTest("csstransitions", v("transition", "all", !0)),
    a(),
    o(y),
    delete x.addTest,
    delete x.addAsyncTest;
  for (var q = 0; q < Modernizr._q.length; q++) Modernizr._q[q]();
  e.Modernizr = Modernizr;
})(window, document);

(function (a, b) {
  a._EPYT_ = a._EPYT_ || {
    ajaxurl: "/wp-admin/admin-ajax.php",
    security: "",
    gallery_scrolloffset: 100,
    eppathtoscripts: "/wp-content/plugins/youtube-embed-plus/scripts/",
    eppath: "/wp-content/plugins/youtube-embed-plus/",
    epresponsiveselector: ["iframe.__youtube_prefs_widget__"],
    epdovol: true,
    evselector:
      'iframe.__youtube_prefs__[src], iframe[src*="youtube.com/embed/"], iframe[src*="youtube-nocookie.com/embed/"]',
    stopMobileBuffer: true,
    ajax_compat: false,
    usingdefault: true,
    ytapi_load: "light",
  };
  if (a.location.toString().indexOf("https://") === 0) {
    a._EPYT_.ajaxurl = a._EPYT_.ajaxurl.replace("http://", "https://");
  }
  a._EPYT_.pageLoaded = false;
  b(a).on("load._EPYT_", function () {
    a._EPYT_.pageLoaded = true;
  });
  if (!document.querySelectorAll) {
    document.querySelectorAll = function (d) {
      var f = document,
        e = f.documentElement.firstChild,
        c = f.createElement("STYLE");
      e.appendChild(c);
      f.__qsaels = [];
      c.styleSheet.cssText = d + "{x:expression(document.__qsaels.push(this))}";
      a.scrollBy(0, 0);
      return f.__qsaels;
    };
  }
  if (typeof a._EPADashboard_ === "undefined") {
    a._EPADashboard_ = {
      initStarted: false,
      checkCount: 0,
      onPlayerReady: function (f) {
        try {
          if (typeof _EPYT_.epdovol !== "undefined" && _EPYT_.epdovol) {
            var d = parseInt(f.target.getIframe().getAttribute("data-vol"));
            if (!isNaN(d)) {
              if (d === 0) {
                f.target.mute();
              } else {
                if (f.target.isMuted()) {
                  f.target.unMute();
                }
                f.target.setVolume(d);
              }
            }
          }
          var c = parseInt(
            f.target.getIframe().getAttribute("data-epautoplay")
          );
          if (!isNaN(c) && c === 1) {
            f.target.playVideo();
          }
        } catch (e) {}
      },
      onPlayerStateChange: function (f) {
        var e = f.target.getIframe();
        if (
          f.data === a.YT.PlayerState.PLAYING &&
          f.target.ponce !== true &&
          e.src.indexOf("autoplay=1") === -1
        ) {
          f.target.ponce = true;
        }
        if (
          f.data === a.YT.PlayerState.ENDED &&
          b(e).data("relstop") == "1" &&
          typeof f.target.stopVideo === "function"
        ) {
          f.target.stopVideo();
        }
        var c = b(e).closest(".epyt-gallery");
        if (!c.length) {
          c = b("#" + b(e).data("epytgalleryid"));
        }
        if (c.length) {
          var d = c.find(".epyt-pagebutton").first().data("autonext") == "1";
          if (d && f.data === a.YT.PlayerState.ENDED) {
            var g = c.find(".epyt-current-video");
            if (!g.length) {
              g = c.find(".epyt-gallery-thumb").first();
            }
            var h = g.find(" ~ .epyt-gallery-thumb").first();
            if (h.length) {
              h.click();
            } else {
              c.find(
                '.epyt-pagebutton.epyt-next[data-pagetoken!=""][data-pagetoken]'
              )
                .first()
                .click();
            }
          }
        }
      },
      justid: function (c) {
        return new RegExp("[\\?&]v=([^&#]*)").exec(c)[1];
      },
      setupevents: function (d) {
        if (typeof a.YT !== "undefined" && a.YT !== null && a.YT.loaded) {
          var c = document.getElementById(d);
          if (!c.epytsetupdone) {
            a._EPADashboard_.log("Setting up YT API events: " + d);
            c.epytsetupdone = true;
            return new a.YT.Player(d, {
              events: {
                onReady: a._EPADashboard_.onPlayerReady,
                onStateChange: a._EPADashboard_.onPlayerStateChange,
              },
            });
          }
        }
      },
      apiInit: function () {
        if (typeof a.YT !== "undefined") {
          a._EPADashboard_.initStarted = true;
          var c = document.querySelectorAll(_EPYT_.evselector);
          for (var d = 0; d < c.length; d++) {
            if (!c[d].hasAttribute("id")) {
              c[d].id = "_dytid_" + Math.round(Math.random() * 8999 + 1000);
            }
            a._EPADashboard_.setupevents(c[d].id);
          }
        }
      },
      log: function (d) {
        try {
          console.log(d);
        } catch (c) {}
      },
      doubleCheck: function () {
        a._EPADashboard_.checkInterval = setInterval(function () {
          a._EPADashboard_.checkCount++;
          if (
            a._EPADashboard_.checkCount >= 5 ||
            a._EPADashboard_.initStarted
          ) {
            clearInterval(a._EPADashboard_.checkInterval);
          } else {
            a._EPADashboard_.apiInit();
            a._EPADashboard_.log("YT API init check");
          }
        }, 1000);
      },
      selectText: function (e) {
        if (document.selection) {
          var c = document.body.createTextRange();
          c.moveToElementText(e);
          c.select();
        } else {
          if (a.getSelection) {
            var d = a.getSelection();
            var c = document.createRange();
            c.selectNode(e);
            d.removeAllRanges();
            d.addRange(c);
          }
        }
      },
      setVidSrc: function (c, d) {
        c.attr("src", d);
        c.get(0).epytsetupdone = false;
        a._EPADashboard_.setupevents(c.attr("id"));
      },
      loadYTAPI: function () {
        if (typeof a.YT === "undefined") {
          if (
            a._EPYT_.ytapi_load !== "never" &&
            (a._EPYT_.ytapi_load === "always" ||
              b('iframe[src*="youtube.com/embed/"]').length)
          ) {
            var c = document.createElement("script");
            c.src = "https://www.youtube.com/iframe_api";
            c.type = "text/javascript";
            document.getElementsByTagName("head")[0].appendChild(c);
          }
        } else {
          if (a.YT.loaded) {
            if (a._EPYT_.pageLoaded) {
              a._EPADashboard_.apiInit();
              a._EPADashboard_.log("YT API available");
            } else {
              b(a).on("load._EPYT_", function () {
                a._EPADashboard_.apiInit();
                a._EPADashboard_.log("YT API available 2");
              });
            }
          }
        }
      },
      pageReady: function () {
        b(".epyt-gallery").each(function () {
          var f = b(this);
          if (
            !f.data("epytevents") ||
            !b("body").hasClass("block-editor-page")
          ) {
            f.data("epytevents", "1");
            var e = b(this).find("iframe, div.__youtube_prefs_gdpr__").first();
            var c = e.attr("src");
            if (!c) {
              c = e.data("ep-src");
            }
            var d = b(this)
              .find(".epyt-gallery-list .epyt-gallery-thumb")
              .first()
              .data("videoid");
            if (typeof c !== "undefined") {
              c = c.replace(d, "GALLERYVIDEOID");
              e.data("ep-gallerysrc", c);
            } else {
              if (e.hasClass("__youtube_prefs_gdpr__")) {
                e.data("ep-gallerysrc", "");
              }
            }
            f.on(
              "click",
              ".epyt-gallery-list .epyt-gallery-thumb",
              function () {
                f.find(".epyt-gallery-list .epyt-gallery-thumb").removeClass(
                  "epyt-current-video"
                );
                b(this).addClass("epyt-current-video");
                var g = b(this).data("videoid");
                f.data("currvid", g);
                var k = e.data("ep-gallerysrc").replace("GALLERYVIDEOID", g);
                var j = f.find(".epyt-pagebutton").first().data("thumbplay");
                if (j !== "0" && j !== 0) {
                  if (k.indexOf("autoplay") > 0) {
                    k = k.replace("autoplay=0", "autoplay=1");
                  } else {
                    k += "&autoplay=1";
                  }
                  e.addClass("epyt-thumbplay");
                }
                var h = Math.max(b("body").scrollTop(), b("html").scrollTop());
                var i = e.offset().top - parseInt(_EPYT_.gallery_scrolloffset);
                if (h > i) {
                  b("html, body").animate({ scrollTop: i }, 500, function () {
                    a._EPADashboard_.setVidSrc(e, k);
                  });
                } else {
                  a._EPADashboard_.setVidSrc(e, k);
                }
              }
            ).on(
              "keydown",
              ".epyt-gallery-list .epyt-gallery-thumb, .epyt-pagebutton",
              function (h) {
                var g = h.which;
                if (g === 13 || g === 32) {
                  h.preventDefault();
                  b(this).click();
                }
              }
            );
            f.on(
              "mouseenter",
              ".epyt-gallery-list .epyt-gallery-thumb",
              function () {
                b(this).addClass("hover");
              }
            );
            f.on(
              "mouseleave",
              ".epyt-gallery-list .epyt-gallery-thumb",
              function () {
                b(this).removeClass("hover");
              }
            );
            f.on("click", ".epyt-pagebutton", function () {
              var i = {
                action: "my_embedplus_gallery_page",
                security: _EPYT_.security,
                options: {
                  playlistId: b(this).data("playlistid"),
                  pageToken: b(this).data("pagetoken"),
                  pageSize: b(this).data("pagesize"),
                  columns: b(this).data("epcolumns"),
                  showTitle: b(this).data("showtitle"),
                  showPaging: b(this).data("showpaging"),
                  autonext: b(this).data("autonext"),
                  thumbplay: b(this).data("thumbplay"),
                },
              };
              var g = b(this).hasClass("epyt-next");
              var h = parseInt(f.data("currpage") + "");
              h += g ? 1 : -1;
              f.data("currpage", h);
              f.find(".epyt-gallery-list").addClass("epyt-loading");
              b.post(_EPYT_.ajaxurl, i, function (j) {
                f.find(".epyt-gallery-list").html(j);
                f.find(".epyt-current").each(function () {
                  b(this).text(f.data("currpage"));
                });
                f.find(
                  '.epyt-gallery-thumb[data-videoid="' +
                    f.data("currvid") +
                    '"]'
                ).addClass("epyt-current-video");
                if (
                  f.find(".epyt-pagebutton").first().data("autonext") == "1"
                ) {
                  f.find(".epyt-gallery-thumb").first().click();
                }
              })
                .fail(function () {
                  alert("Sorry, there was an error loading the next page.");
                })
                .always(function () {
                  f.find(".epyt-gallery-list").removeClass("epyt-loading");
                  if (
                    f.find(".epyt-pagebutton").first().data("autonext") != "1"
                  ) {
                    var j = Math.max(
                      b("body").scrollTop(),
                      b("html").scrollTop()
                    );
                    var k =
                      f.find(".epyt-gallery-list").offset().top -
                      parseInt(_EPYT_.gallery_scrolloffset);
                    if (j > k) {
                      b("html, body").animate({ scrollTop: k }, 500);
                    }
                  }
                });
            });
          }
        });
        b("button.__youtube_prefs_gdpr__").on("click", function (c) {
          c.preventDefault();
          if (b.cookie) {
            b.cookie("ytprefs_gdpr_consent", "1", { expires: 30, path: "/" });
            a.top.location.reload();
          }
        });
      },
    };
  }
  a.onYouTubeIframeAPIReady =
    typeof a.onYouTubeIframeAPIReady !== "undefined"
      ? a.onYouTubeIframeAPIReady
      : function () {
          if (a._EPYT_.pageLoaded) {
            a._EPADashboard_.apiInit();
            a._EPADashboard_.log("YT API ready");
          } else {
            b(a).on("load._EPYT_", function () {
              a._EPADashboard_.apiInit();
              a._EPADashboard_.log("YT API ready 2");
            });
          }
        };
  a._EPADashboard_.loadYTAPI();
  if (a._EPYT_.pageLoaded) {
    a._EPADashboard_.doubleCheck();
  } else {
    b(a).on("load._EPYT_", function () {
      a._EPADashboard_.doubleCheck();
    });
  }
  b(document).ready(function () {
    a._EPADashboard_.pageReady();
    a._EPADashboard_.loadYTAPI();
    if (a._EPYT_.ajax_compat) {
      b(a).on("load._EPYT_", function () {
        b(document).ajaxSuccess(function (d, f, c) {
          if (
            f &&
            f.responseText &&
            f.responseText.indexOf("<iframe ") !== -1
          ) {
            a._EPADashboard_.loadYTAPI();
            a._EPADashboard_.apiInit();
            a._EPADashboard_.log("YT API AJAX");
            a._EPADashboard_.pageReady();
          }
        });
      });
    }
  });
})(window, jQuery);
/*! Magnific Popup - v1.0.0 - 2015-09-17
 * http://dimsemenov.com/plugins/magnific-popup/
 * Copyright (c) 2015 Dmitry Semenov; */
(function (factory) {
  if (typeof define === "function" && define.amd) {
    // AMD. Register as an anonymous module.
    define(["jquery"], factory);
  } else if (typeof exports === "object") {
    // Node/CommonJS
    factory(require("jquery"));
  } else {
    // Browser globals
    factory(window.jQuery || window.Zepto);
  }
})(function ($) {
  /*>>core*/
  /**
   *
   * Magnific Popup Core JS file
   *
   */

  /**
   * Private static constants
   */
  var CLOSE_EVENT = "Close",
    BEFORE_CLOSE_EVENT = "BeforeClose",
    AFTER_CLOSE_EVENT = "AfterClose",
    BEFORE_APPEND_EVENT = "BeforeAppend",
    MARKUP_PARSE_EVENT = "MarkupParse",
    OPEN_EVENT = "Open",
    CHANGE_EVENT = "Change",
    NS = "mfp",
    EVENT_NS = "." + NS,
    READY_CLASS = "mfp-ready",
    REMOVING_CLASS = "mfp-removing",
    PREVENT_CLOSE_CLASS = "mfp-prevent-close";

  /**
   * Private vars
   */
  /*jshint -W079 */
  var mfp, // As we have only one instance of MagnificPopup object, we define it locally to not to use 'this'
    MagnificPopup = function () {},
    _isJQ = !!window.jQuery,
    _prevStatus,
    _window = $(window),
    _document,
    _prevContentType,
    _wrapClasses,
    _currPopupType;

  /**
   * Private functions
   */
  var _mfpOn = function (name, f) {
      mfp.ev.on(NS + name + EVENT_NS, f);
    },
    _getEl = function (className, appendTo, html, raw) {
      var el = document.createElement("div");
      el.className = "mfp-" + className;
      if (html) {
        el.innerHTML = html;
      }
      if (!raw) {
        el = $(el);
        if (appendTo) {
          el.appendTo(appendTo);
        }
      } else if (appendTo) {
        appendTo.appendChild(el);
      }
      return el;
    },
    _mfpTrigger = function (e, data) {
      mfp.ev.triggerHandler(NS + e, data);

      if (mfp.st.callbacks) {
        // converts "mfpEventName" to "eventName" callback and triggers it if it's present
        e = e.charAt(0).toLowerCase() + e.slice(1);
        if (mfp.st.callbacks[e]) {
          mfp.st.callbacks[e].apply(mfp, $.isArray(data) ? data : [data]);
        }
      }
    },
    _getCloseBtn = function (type) {
      if (type !== _currPopupType || !mfp.currTemplate.closeBtn) {
        mfp.currTemplate.closeBtn = $(
          mfp.st.closeMarkup.replace("%title%", mfp.st.tClose)
        );
        _currPopupType = type;
      }
      return mfp.currTemplate.closeBtn;
    },
    // Initialize Magnific Popup only when called at least once
    _checkInstance = function () {
      if (!$.magnificPopup.instance) {
        /*jshint -W020 */
        mfp = new MagnificPopup();
        mfp.init();
        $.magnificPopup.instance = mfp;
      }
    },
    // CSS transition detection, http://stackoverflow.com/questions/7264899/detect-css-transitions-using-javascript-and-without-modernizr
    supportsTransitions = function () {
      var s = document.createElement("p").style, // 's' for style. better to create an element if body yet to exist
        v = ["ms", "O", "Moz", "Webkit"]; // 'v' for vendor

      if (s["transition"] !== undefined) {
        return true;
      }

      while (v.length) {
        if (v.pop() + "Transition" in s) {
          return true;
        }
      }

      return false;
    };

  /**
   * Public functions
   */
  MagnificPopup.prototype = {
    constructor: MagnificPopup,

    /**
     * Initializes Magnific Popup plugin.
     * This function is triggered only once when $.fn.magnificPopup or $.magnificPopup is executed
     */
    init: function () {
      var appVersion = navigator.appVersion;
      mfp.isIE7 = appVersion.indexOf("MSIE 7.") !== -1;
      mfp.isIE8 = appVersion.indexOf("MSIE 8.") !== -1;
      mfp.isLowIE = mfp.isIE7 || mfp.isIE8;
      mfp.isAndroid = /android/gi.test(appVersion);
      mfp.isIOS = /iphone|ipad|ipod/gi.test(appVersion);
      mfp.supportsTransition = supportsTransitions();

      // We disable fixed positioned lightbox on devices that don't handle it nicely.
      // If you know a better way of detecting this - let me know.
      mfp.probablyMobile =
        mfp.isAndroid ||
        mfp.isIOS ||
        /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
          navigator.userAgent
        );
      _document = $(document);

      mfp.popupsCache = {};
    },

    /**
     * Opens popup
     * @param  data [description]
     */
    open: function (data) {
      var i;

      if (data.isObj === false) {
        // convert jQuery collection to array to avoid conflicts later
        mfp.items = data.items.toArray();

        mfp.index = 0;
        var items = data.items,
          item;
        for (i = 0; i < items.length; i++) {
          item = items[i];
          if (item.parsed) {
            item = item.el[0];
          }
          if (item === data.el[0]) {
            mfp.index = i;
            break;
          }
        }
      } else {
        mfp.items = $.isArray(data.items) ? data.items : [data.items];
        mfp.index = data.index || 0;
      }

      // if popup is already opened - we just update the content
      if (mfp.isOpen) {
        mfp.updateItemHTML();
        return;
      }

      mfp.types = [];
      _wrapClasses = "";
      if (data.mainEl && data.mainEl.length) {
        mfp.ev = data.mainEl.eq(0);
      } else {
        mfp.ev = _document;
      }

      if (data.key) {
        if (!mfp.popupsCache[data.key]) {
          mfp.popupsCache[data.key] = {};
        }
        mfp.currTemplate = mfp.popupsCache[data.key];
      } else {
        mfp.currTemplate = {};
      }

      mfp.st = $.extend(true, {}, $.magnificPopup.defaults, data);
      mfp.fixedContentPos =
        mfp.st.fixedContentPos === "auto"
          ? !mfp.probablyMobile
          : mfp.st.fixedContentPos;

      if (mfp.st.modal) {
        mfp.st.closeOnContentClick = false;
        mfp.st.closeOnBgClick = false;
        mfp.st.showCloseBtn = false;
        mfp.st.enableEscapeKey = false;
      }

      // Building markup
      // main containers are created only once
      if (!mfp.bgOverlay) {
        // Dark overlay
        mfp.bgOverlay = _getEl("bg").on("click" + EVENT_NS, function () {
          mfp.close();
        });

        mfp.wrap = _getEl("wrap")
          .attr("tabindex", -1)
          .on("click" + EVENT_NS, function (e) {
            if (mfp._checkIfClose(e.target)) {
              mfp.close();
            }
          });

        mfp.container = _getEl("container", mfp.wrap);
      }

      mfp.contentContainer = _getEl("content");
      if (mfp.st.preloader) {
        mfp.preloader = _getEl("preloader", mfp.container, mfp.st.tLoading);
      }

      // Initializing modules
      var modules = $.magnificPopup.modules;
      for (i = 0; i < modules.length; i++) {
        var n = modules[i];
        n = n.charAt(0).toUpperCase() + n.slice(1);
        mfp["init" + n].call(mfp);
      }
      _mfpTrigger("BeforeOpen");

      if (mfp.st.showCloseBtn) {
        // Close button
        if (!mfp.st.closeBtnInside) {
          mfp.wrap.append(_getCloseBtn());
        } else {
          _mfpOn(MARKUP_PARSE_EVENT, function (e, template, values, item) {
            values.close_replaceWith = _getCloseBtn(item.type);
          });
          _wrapClasses += " mfp-close-btn-in";
        }
      }

      if (mfp.st.alignTop) {
        _wrapClasses += " mfp-align-top";
      }

      if (mfp.fixedContentPos) {
        mfp.wrap.css({
          overflow: mfp.st.overflowY,
          overflowX: "hidden",
          overflowY: mfp.st.overflowY,
        });
      } else {
        mfp.wrap.css({
          top: _window.scrollTop() - parseInt($("html").css("margin-top")),
          position: "absolute",
        });
      }
      if (
        mfp.st.fixedBgPos === false ||
        (mfp.st.fixedBgPos === "auto" && !mfp.fixedContentPos)
      ) {
        mfp.bgOverlay.css({
          height: _document.height(),
          position: "absolute",
        });
      }

      if (mfp.st.enableEscapeKey) {
        // Close on ESC key
        _document.on("keyup" + EVENT_NS, function (e) {
          if (e.keyCode === 27) {
            mfp.close();
          }
        });
      }

      _window.on("resize" + EVENT_NS, function () {
        mfp.updateSize();
      });

      if (!mfp.st.closeOnContentClick) {
        _wrapClasses += " mfp-auto-cursor";
      }

      if (_wrapClasses) mfp.wrap.addClass(_wrapClasses);

      // this triggers recalculation of layout, so we get it once to not to trigger twice
      var windowHeight = (mfp.wH = _window.height());

      var windowStyles = {};

      if (mfp.fixedContentPos) {
        if (mfp._hasScrollBar(windowHeight)) {
          var s = mfp._getScrollbarSize();
          if (s) {
            windowStyles.marginRight = s;
          }
        }
      }

      if (mfp.fixedContentPos) {
        if (!mfp.isIE7) {
          windowStyles.overflow = "hidden";
        } else {
          // ie7 double-scroll bug
          $("body, html").css("overflow", "hidden");
        }
      }

      var classesToadd = mfp.st.mainClass;
      if (mfp.isIE7) {
        classesToadd += " mfp-ie7";
      }
      if (classesToadd) {
        mfp._addClassToMFP(classesToadd);
      }

      // add content
      mfp.updateItemHTML();

      _mfpTrigger("BuildControls");

      // remove scrollbar, add margin e.t.c
      $("html").css(windowStyles);

      // add everything to DOM
      mfp.bgOverlay
        .add(mfp.wrap)
        .prependTo(mfp.st.prependTo || $(document.body));

      // Save last focused element
      mfp._lastFocusedEl = document.activeElement;

      // Wait for next cycle to allow CSS transition
      setTimeout(function () {
        if (mfp.content) {
          mfp._addClassToMFP(READY_CLASS);
          mfp._setFocus();
        } else {
          // if content is not defined (not loaded e.t.c) we add class only for BG
          mfp.bgOverlay.addClass(READY_CLASS);
        }

        // Trap the focus in popup
        _document.on("focusin" + EVENT_NS, mfp._onFocusIn);
      }, 16);

      mfp.isOpen = true;
      mfp.updateSize(windowHeight);
      _mfpTrigger(OPEN_EVENT);

      return data;
    },

    /**
     * Closes the popup
     */
    close: function () {
      if (!mfp.isOpen) return;
      _mfpTrigger(BEFORE_CLOSE_EVENT);

      mfp.isOpen = false;
      // for CSS3 animation
      if (mfp.st.removalDelay && !mfp.isLowIE && mfp.supportsTransition) {
        mfp._addClassToMFP(REMOVING_CLASS);
        setTimeout(function () {
          mfp._close();
        }, mfp.st.removalDelay);
      } else {
        mfp._close();
      }
    },

    /**
     * Helper for close() function
     */
    _close: function () {
      _mfpTrigger(CLOSE_EVENT);

      var classesToRemove = REMOVING_CLASS + " " + READY_CLASS + " ";

      mfp.bgOverlay.detach();
      mfp.wrap.detach();
      mfp.container.empty();

      if (mfp.st.mainClass) {
        classesToRemove += mfp.st.mainClass + " ";
      }

      mfp._removeClassFromMFP(classesToRemove);

      if (mfp.fixedContentPos) {
        var windowStyles = { marginRight: "" };
        if (mfp.isIE7) {
          $("body, html").css("overflow", "");
        } else {
          windowStyles.overflow = "";
        }
        $("html").css(windowStyles);
      }

      _document.off("keyup" + EVENT_NS + " focusin" + EVENT_NS);
      mfp.ev.off(EVENT_NS);

      // clean up DOM elements that aren't removed
      mfp.wrap.attr("class", "mfp-wrap").removeAttr("style");
      mfp.bgOverlay.attr("class", "mfp-bg");
      mfp.container.attr("class", "mfp-container");

      // remove close button from target element
      if (
        mfp.st.showCloseBtn &&
        (!mfp.st.closeBtnInside || mfp.currTemplate[mfp.currItem.type] === true)
      ) {
        if (mfp.currTemplate.closeBtn) mfp.currTemplate.closeBtn.detach();
      }

      if (mfp._lastFocusedEl) {
        //$(mfp._lastFocusedEl).focus(); // put tab focus back
      }
      mfp.currItem = null;
      mfp.content = null;
      mfp.currTemplate = null;
      mfp.prevHeight = 0;

      _mfpTrigger(AFTER_CLOSE_EVENT);
    },

    updateSize: function (winHeight) {
      if (mfp.isIOS) {
        // fixes iOS nav bars https://github.com/dimsemenov/Magnific-Popup/issues/2
        var zoomLevel =
          document.documentElement.clientWidth / window.innerWidth;
        var height = window.innerHeight * zoomLevel;
        mfp.wrap.css("height", height);
        mfp.wH = height;
      } else {
        mfp.wH = winHeight || _window.height();
      }
      // Fixes #84: popup incorrectly positioned with position:relative on body
      if (!mfp.fixedContentPos) {
        mfp.wrap.css("height", mfp.wH);
      }

      _mfpTrigger("Resize");
    },

    /**
     * Set content of popup based on current index
     */
    updateItemHTML: function () {
      var item = mfp.items[mfp.index];

      // Detach and perform modifications
      mfp.contentContainer.detach();

      if (mfp.content) mfp.content.detach();

      if (!item.parsed) {
        item = mfp.parseEl(mfp.index);
      }

      var type = item.type;

      _mfpTrigger("BeforeChange", [
        mfp.currItem ? mfp.currItem.type : "",
        type,
      ]);
      // BeforeChange event works like so:
      // _mfpOn('BeforeChange', function(e, prevType, newType) { });

      mfp.currItem = item;

      if (!mfp.currTemplate[type]) {
        var markup = mfp.st[type] ? mfp.st[type].markup : false;

        // allows to modify markup
        _mfpTrigger("FirstMarkupParse", markup);

        if (markup) {
          mfp.currTemplate[type] = $(markup);
        } else {
          // if there is no markup found we just define that template is parsed
          mfp.currTemplate[type] = true;
        }
      }

      if (_prevContentType && _prevContentType !== item.type) {
        mfp.container.removeClass("mfp-" + _prevContentType + "-holder");
      }

      var newContent = mfp[
        "get" + type.charAt(0).toUpperCase() + type.slice(1)
      ](item, mfp.currTemplate[type]);
      mfp.appendContent(newContent, type);

      item.preloaded = true;

      _mfpTrigger(CHANGE_EVENT, item);
      _prevContentType = item.type;

      // Append container back after its content changed
      mfp.container.prepend(mfp.contentContainer);

      _mfpTrigger("AfterChange");
    },

    /**
     * Set HTML content of popup
     */
    appendContent: function (newContent, type) {
      mfp.content = newContent;

      if (newContent) {
        if (
          mfp.st.showCloseBtn &&
          mfp.st.closeBtnInside &&
          mfp.currTemplate[type] === true
        ) {
          // if there is no markup, we just append close button element inside
          if (!mfp.content.find(".mfp-close").length) {
            mfp.content.append(_getCloseBtn());
          }
        } else {
          mfp.content = newContent;
        }
      } else {
        mfp.content = "";
      }

      _mfpTrigger(BEFORE_APPEND_EVENT);
      mfp.container.addClass("mfp-" + type + "-holder");

      mfp.contentContainer.append(mfp.content);
    },

    /**
     * Creates Magnific Popup data object based on given data
     * @param  {int} index Index of item to parse
     */
    parseEl: function (index) {
      var item = mfp.items[index],
        type;

      if (item.tagName) {
        item = { el: $(item) };
      } else {
        type = item.type;
        item = { data: item, src: item.src };
      }

      if (item.el) {
        var types = mfp.types;

        // check for 'mfp-TYPE' class
        for (var i = 0; i < types.length; i++) {
          if (item.el.hasClass("mfp-" + types[i])) {
            type = types[i];
            break;
          }
        }

        item.src = item.el.attr("data-mfp-src");
        if (!item.src) {
          item.src = item.el.attr("href");
        }
      }

      item.type = type || mfp.st.type || "inline";
      item.index = index;
      item.parsed = true;
      mfp.items[index] = item;
      _mfpTrigger("ElementParse", item);

      return mfp.items[index];
    },

    /**
     * Initializes single popup or a group of popups
     */
    addGroup: function (el, options) {
      var eHandler = function (e) {
        e.mfpEl = this;
        mfp._openClick(e, el, options);
      };

      if (!options) {
        options = {};
      }

      var eName = "click.magnificPopup";
      options.mainEl = el;

      if (options.items) {
        options.isObj = true;
        el.off(eName).on(eName, eHandler);
      } else {
        options.isObj = false;
        if (options.delegate) {
          el.off(eName).on(eName, options.delegate, eHandler);
        } else {
          options.items = el;
          el.off(eName).on(eName, eHandler);
        }
      }
    },
    _openClick: function (e, el, options) {
      var midClick =
        options.midClick !== undefined
          ? options.midClick
          : $.magnificPopup.defaults.midClick;

      if (
        !midClick &&
        (e.which === 2 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey)
      ) {
        return;
      }

      var disableOn =
        options.disableOn !== undefined
          ? options.disableOn
          : $.magnificPopup.defaults.disableOn;

      if (disableOn) {
        if ($.isFunction(disableOn)) {
          if (!disableOn.call(mfp)) {
            return true;
          }
        } else {
          // else it's number
          if (_window.width() < disableOn) {
            return true;
          }
        }
      }

      if (e.type) {
        e.preventDefault();

        // This will prevent popup from closing if element is inside and popup is already opened
        if (mfp.isOpen) {
          e.stopPropagation();
        }
      }

      options.el = $(e.mfpEl);
      if (options.delegate) {
        options.items = el.find(options.delegate);
      }
      mfp.open(options);
    },

    /**
     * Updates text on preloader
     */
    updateStatus: function (status, text) {
      if (mfp.preloader) {
        if (_prevStatus !== status) {
          mfp.container.removeClass("mfp-s-" + _prevStatus);
        }

        if (!text && status === "loading") {
          text = mfp.st.tLoading;
        }

        var data = {
          status: status,
          text: text,
        };
        // allows to modify status
        _mfpTrigger("UpdateStatus", data);

        status = data.status;
        text = data.text;

        mfp.preloader.html(text);

        mfp.preloader.find("a").on("click", function (e) {
          e.stopImmediatePropagation();
        });

        mfp.container.addClass("mfp-s-" + status);
        _prevStatus = status;
      }
    },

    /*
		"Private" helpers that aren't private at all
	 */
    // Check to close popup or not
    // "target" is an element that was clicked
    _checkIfClose: function (target) {
      if ($(target).hasClass(PREVENT_CLOSE_CLASS)) {
        return;
      }

      var closeOnContent = mfp.st.closeOnContentClick;
      var closeOnBg = mfp.st.closeOnBgClick;

      if (closeOnContent && closeOnBg) {
        return true;
      } else {
        // We close the popup if click is on close button or on preloader. Or if there is no content.
        if (
          !mfp.content ||
          $(target).hasClass("mfp-close") ||
          (mfp.preloader && target === mfp.preloader[0])
        ) {
          return true;
        }

        // if click is outside the content
        if (target !== mfp.content[0] && !$.contains(mfp.content[0], target)) {
          if (closeOnBg) {
            // last check, if the clicked element is in DOM, (in case it's removed onclick)
            if ($.contains(document, target)) {
              return true;
            }
          }
        } else if (closeOnContent) {
          return true;
        }
      }
      return false;
    },
    _addClassToMFP: function (cName) {
      mfp.bgOverlay.addClass(cName);
      mfp.wrap.addClass(cName);
    },
    _removeClassFromMFP: function (cName) {
      this.bgOverlay.removeClass(cName);
      mfp.wrap.removeClass(cName);
    },
    _hasScrollBar: function (winHeight) {
      return (
        (mfp.isIE7 ? _document.height() : document.body.scrollHeight) >
        (winHeight || _window.height())
      );
    },
    _setFocus: function () {
      (mfp.st.focus ? mfp.content.find(mfp.st.focus).eq(0) : mfp.wrap).focus();
    },
    _onFocusIn: function (e) {
      if (e.target !== mfp.wrap[0] && !$.contains(mfp.wrap[0], e.target)) {
        mfp._setFocus();
        return false;
      }
    },
    _parseMarkup: function (template, values, item) {
      var arr;
      if (item.data) {
        values = $.extend(item.data, values);
      }
      _mfpTrigger(MARKUP_PARSE_EVENT, [template, values, item]);

      $.each(values, function (key, value) {
        if (value === undefined || value === false) {
          return true;
        }
        arr = key.split("_");
        if (arr.length > 1) {
          var el = template.find(EVENT_NS + "-" + arr[0]);

          if (el.length > 0) {
            var attr = arr[1];
            if (attr === "replaceWith") {
              if (el[0] !== value[0]) {
                el.replaceWith(value);
              }
            } else if (attr === "img") {
              if (el.is("img")) {
                el.attr("src", value);
              } else {
                el.replaceWith(
                  '<img src="' + value + '" class="' + el.attr("class") + '" />'
                );
              }
            } else {
              el.attr(arr[1], value);
            }
          }
        } else {
          template.find(EVENT_NS + "-" + key).html(value);
        }
      });
    },

    _getScrollbarSize: function () {
      // thx David
      if (mfp.scrollbarSize === undefined) {
        var scrollDiv = document.createElement("div");
        scrollDiv.style.cssText =
          "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;";
        document.body.appendChild(scrollDiv);
        mfp.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
      }
      return mfp.scrollbarSize;
    },
  }; /* MagnificPopup core prototype end */

  /**
   * Public static functions
   */
  $.magnificPopup = {
    instance: null,
    proto: MagnificPopup.prototype,
    modules: [],

    open: function (options, index) {
      _checkInstance();

      if (!options) {
        options = {};
      } else {
        options = $.extend(true, {}, options);
      }

      options.isObj = true;
      options.index = index || 0;
      return this.instance.open(options);
    },

    close: function () {
      return $.magnificPopup.instance && $.magnificPopup.instance.close();
    },

    registerModule: function (name, module) {
      if (module.options) {
        $.magnificPopup.defaults[name] = module.options;
      }
      $.extend(this.proto, module.proto);
      this.modules.push(name);
    },

    defaults: {
      // Info about options is in docs:
      // http://dimsemenov.com/plugins/magnific-popup/documentation.html#options

      disableOn: 0,

      key: null,

      midClick: false,

      mainClass: "",

      preloader: true,

      focus: "", // CSS selector of input to focus after popup is opened

      closeOnContentClick: false,

      closeOnBgClick: true,

      closeBtnInside: true,

      showCloseBtn: true,

      enableEscapeKey: true,

      modal: false,

      alignTop: false,

      removalDelay: 0,

      prependTo: null,

      fixedContentPos: "auto",

      fixedBgPos: "auto",

      overflowY: "auto",

      closeMarkup:
        '<button title="%title%" type="button" class="mfp-close"></button>',

      tClose: "Close (Esc)",

      tLoading: "Loading...",
    },
  };

  $.fn.magnificPopup = function (options) {
    _checkInstance();

    var jqEl = $(this);

    // We call some API method of first param is a string
    if (typeof options === "string") {
      if (options === "open") {
        var items,
          itemOpts = _isJQ ? jqEl.data("magnificPopup") : jqEl[0].magnificPopup,
          index = parseInt(arguments[1], 10) || 0;

        if (itemOpts.items) {
          items = itemOpts.items[index];
        } else {
          items = jqEl;
          if (itemOpts.delegate) {
            items = items.find(itemOpts.delegate);
          }
          items = items.eq(index);
        }
        mfp._openClick({ mfpEl: items }, jqEl, itemOpts);
      } else {
        if (mfp.isOpen)
          mfp[options].apply(mfp, Array.prototype.slice.call(arguments, 1));
      }
    } else {
      // clone options obj
      options = $.extend(true, {}, options);

      /*
       * As Zepto doesn't support .data() method for objects
       * and it works only in normal browsers
       * we assign "options" object directly to the DOM element. FTW!
       */
      if (_isJQ) {
        jqEl.data("magnificPopup", options);
      } else {
        jqEl[0].magnificPopup = options;
      }

      mfp.addGroup(jqEl, options);
    }
    return jqEl;
  };

  //Quick benchmark
  /*
var start = performance.now(),
	i,
	rounds = 1000;

for(i = 0; i < rounds; i++) {

}
console.log('Test #1:', performance.now() - start);

start = performance.now();
for(i = 0; i < rounds; i++) {

}
console.log('Test #2:', performance.now() - start);
*/

  /*>>core*/

  /*>>inline*/

  var INLINE_NS = "inline",
    _hiddenClass,
    _inlinePlaceholder,
    _lastInlineElement,
    _putInlineElementsBack = function () {
      if (_lastInlineElement) {
        _inlinePlaceholder
          .after(_lastInlineElement.addClass(_hiddenClass))
          .detach();
        _lastInlineElement = null;
      }
    };

  $.magnificPopup.registerModule(INLINE_NS, {
    options: {
      hiddenClass: "hide", // will be appended with `mfp-` prefix
      markup: "",
      tNotFound: "Content not found",
    },
    proto: {
      initInline: function () {
        mfp.types.push(INLINE_NS);

        _mfpOn(CLOSE_EVENT + "." + INLINE_NS, function () {
          _putInlineElementsBack();
        });
      },

      getInline: function (item, template) {
        _putInlineElementsBack();

        if (item.src) {
          var inlineSt = mfp.st.inline,
            el = $(item.src);

          if (el.length) {
            // If target element has parent - we replace it with placeholder and put it back after popup is closed
            var parent = el[0].parentNode;
            if (parent && parent.tagName) {
              if (!_inlinePlaceholder) {
                _hiddenClass = inlineSt.hiddenClass;
                _inlinePlaceholder = _getEl(_hiddenClass);
                _hiddenClass = "mfp-" + _hiddenClass;
              }
              // replace target inline element with placeholder
              _lastInlineElement = el
                .after(_inlinePlaceholder)
                .detach()
                .removeClass(_hiddenClass);
            }

            mfp.updateStatus("ready");
          } else {
            mfp.updateStatus("error", inlineSt.tNotFound);
            el = $("<div>");
          }

          item.inlineElement = el;
          return el;
        }

        mfp.updateStatus("ready");
        mfp._parseMarkup(template, {}, item);
        return template;
      },
    },
  });

  /*>>inline*/

  /*>>ajax*/
  var AJAX_NS = "ajax",
    _ajaxCur,
    _removeAjaxCursor = function () {
      if (_ajaxCur) {
        $(document.body).removeClass(_ajaxCur);
      }
    },
    _destroyAjaxRequest = function () {
      _removeAjaxCursor();
      if (mfp.req) {
        mfp.req.abort();
      }
    };

  $.magnificPopup.registerModule(AJAX_NS, {
    options: {
      settings: null,
      cursor: "mfp-ajax-cur",
      tError: '<a href="%url%">The content</a> could not be loaded.',
    },

    proto: {
      initAjax: function () {
        mfp.types.push(AJAX_NS);
        _ajaxCur = mfp.st.ajax.cursor;

        _mfpOn(CLOSE_EVENT + "." + AJAX_NS, _destroyAjaxRequest);
        _mfpOn("BeforeChange." + AJAX_NS, _destroyAjaxRequest);
      },
      getAjax: function (item) {
        if (_ajaxCur) {
          $(document.body).addClass(_ajaxCur);
        }

        mfp.updateStatus("loading");

        var opts = $.extend(
          {
            url: item.src,
            success: function (data, textStatus, jqXHR) {
              var temp = {
                data: data,
                xhr: jqXHR,
              };

              _mfpTrigger("ParseAjax", temp);

              mfp.appendContent($(temp.data), AJAX_NS);

              item.finished = true;

              _removeAjaxCursor();

              mfp._setFocus();

              setTimeout(function () {
                mfp.wrap.addClass(READY_CLASS);
              }, 16);

              mfp.updateStatus("ready");

              _mfpTrigger("AjaxContentAdded");
            },
            error: function () {
              _removeAjaxCursor();
              item.finished = item.loadError = true;
              mfp.updateStatus(
                "error",
                mfp.st.ajax.tError.replace("%url%", item.src)
              );
            },
          },
          mfp.st.ajax.settings
        );

        mfp.req = $.ajax(opts);

        return "";
      },
    },
  });

  /*>>ajax*/

  /*>>image*/
  var _imgInterval,
    _getTitle = function (item) {
      if (item.data && item.data.title !== undefined) return item.data.title;

      var src = mfp.st.image.titleSrc;

      if (src) {
        if ($.isFunction(src)) {
          return src.call(mfp, item);
        } else if (item.el) {
          return item.el.attr(src) || "";
        }
      }
      return "";
    };

  $.magnificPopup.registerModule("image", {
    options: {
      markup:
        '<div class="mfp-figure">' +
        '<div class="mfp-close"></div>' +
        "<figure>" +
        '<div class="mfp-img"></div>' +
        "<figcaption>" +
        '<div class="mfp-bottom-bar">' +
        '<div class="mfp-title"></div>' +
        '<div class="mfp-counter"></div>' +
        "</div>" +
        "</figcaption>" +
        "</figure>" +
        "</div>",
      cursor: "mfp-zoom-out-cur",
      titleSrc: "title",
      verticalFit: true,
      tError: '<a href="%url%">The image</a> could not be loaded.',
    },

    proto: {
      initImage: function () {
        var imgSt = mfp.st.image,
          ns = ".image";

        mfp.types.push("image");

        _mfpOn(OPEN_EVENT + ns, function () {
          if (mfp.currItem.type === "image" && imgSt.cursor) {
            $(document.body).addClass(imgSt.cursor);
          }
        });

        _mfpOn(CLOSE_EVENT + ns, function () {
          if (imgSt.cursor) {
            $(document.body).removeClass(imgSt.cursor);
          }
          _window.off("resize" + EVENT_NS);
        });

        _mfpOn("Resize" + ns, mfp.resizeImage);
        if (mfp.isLowIE) {
          _mfpOn("AfterChange", mfp.resizeImage);
        }
      },
      resizeImage: function () {
        var item = mfp.currItem;
        if (!item || !item.img) return;

        if (mfp.st.image.verticalFit) {
          var decr = 0;
          // fix box-sizing in ie7/8
          if (mfp.isLowIE) {
            decr =
              parseInt(item.img.css("padding-top"), 10) +
              parseInt(item.img.css("padding-bottom"), 10);
          }
          item.img.css("max-height", mfp.wH - decr);
        }
      },
      _onImageHasSize: function (item) {
        if (item.img) {
          item.hasSize = true;

          if (_imgInterval) {
            clearInterval(_imgInterval);
          }

          item.isCheckingImgSize = false;

          _mfpTrigger("ImageHasSize", item);

          if (item.imgHidden) {
            if (mfp.content) mfp.content.removeClass("mfp-loading");

            item.imgHidden = false;
          }
        }
      },

      /**
       * Function that loops until the image has size to display elements that rely on it asap
       */
      findImageSize: function (item) {
        var counter = 0,
          img = item.img[0],
          mfpSetInterval = function (delay) {
            if (_imgInterval) {
              clearInterval(_imgInterval);
            }
            // decelerating interval that checks for size of an image
            _imgInterval = setInterval(function () {
              if (img.naturalWidth > 0) {
                mfp._onImageHasSize(item);
                return;
              }

              if (counter > 200) {
                clearInterval(_imgInterval);
              }

              counter++;
              if (counter === 3) {
                mfpSetInterval(10);
              } else if (counter === 40) {
                mfpSetInterval(50);
              } else if (counter === 100) {
                mfpSetInterval(500);
              }
            }, delay);
          };

        mfpSetInterval(1);
      },

      getImage: function (item, template) {
        var guard = 0,
          // image load complete handler
          onLoadComplete = function () {
            if (item) {
              if (item.img[0].complete) {
                item.img.off(".mfploader");

                if (item === mfp.currItem) {
                  mfp._onImageHasSize(item);

                  mfp.updateStatus("ready");
                }

                item.hasSize = true;
                item.loaded = true;

                _mfpTrigger("ImageLoadComplete");
              } else {
                // if image complete check fails 200 times (20 sec), we assume that there was an error.
                guard++;
                if (guard < 200) {
                  setTimeout(onLoadComplete, 100);
                } else {
                  onLoadError();
                }
              }
            }
          },
          // image error handler
          onLoadError = function () {
            if (item) {
              item.img.off(".mfploader");
              if (item === mfp.currItem) {
                mfp._onImageHasSize(item);
                mfp.updateStatus(
                  "error",
                  imgSt.tError.replace("%url%", item.src)
                );
              }

              item.hasSize = true;
              item.loaded = true;
              item.loadError = true;
            }
          },
          imgSt = mfp.st.image;

        var el = template.find(".mfp-img");
        if (el.length) {
          var img = document.createElement("img");
          img.className = "mfp-img";
          if (item.el && item.el.find("img").length) {
            img.alt = item.el.find("img").attr("alt");
          }
          item.img = $(img)
            .on("load.mfploader", onLoadComplete)
            .on("error.mfploader", onLoadError);
          img.src = item.src;

          // without clone() "error" event is not firing when IMG is replaced by new IMG
          // TODO: find a way to avoid such cloning
          if (el.is("img")) {
            item.img = item.img.clone();
          }

          img = item.img[0];
          if (img.naturalWidth > 0) {
            item.hasSize = true;
          } else if (!img.width) {
            item.hasSize = false;
          }
        }

        mfp._parseMarkup(
          template,
          {
            title: _getTitle(item),
            img_replaceWith: item.img,
          },
          item
        );

        mfp.resizeImage();

        if (item.hasSize) {
          if (_imgInterval) clearInterval(_imgInterval);

          if (item.loadError) {
            template.addClass("mfp-loading");
            mfp.updateStatus("error", imgSt.tError.replace("%url%", item.src));
          } else {
            template.removeClass("mfp-loading");
            mfp.updateStatus("ready");
          }
          return template;
        }

        mfp.updateStatus("loading");
        item.loading = true;

        if (!item.hasSize) {
          item.imgHidden = true;
          template.addClass("mfp-loading");
          mfp.findImageSize(item);
        }

        return template;
      },
    },
  });

  /*>>image*/

  /*>>zoom*/
  var hasMozTransform,
    getHasMozTransform = function () {
      if (hasMozTransform === undefined) {
        hasMozTransform =
          document.createElement("p").style.MozTransform !== undefined;
      }
      return hasMozTransform;
    };

  $.magnificPopup.registerModule("zoom", {
    options: {
      enabled: false,
      easing: "ease-in-out",
      duration: 300,
      opener: function (element) {
        return element.is("img") ? element : element.find("img");
      },
    },

    proto: {
      initZoom: function () {
        var zoomSt = mfp.st.zoom,
          ns = ".zoom",
          image;

        if (!zoomSt.enabled || !mfp.supportsTransition) {
          return;
        }

        var duration = zoomSt.duration,
          getElToAnimate = function (image) {
            var newImg = image
                .clone()
                .removeAttr("style")
                .removeAttr("class")
                .addClass("mfp-animated-image"),
              transition =
                "all " + zoomSt.duration / 1000 + "s " + zoomSt.easing,
              cssObj = {
                position: "fixed",
                zIndex: 9999,
                left: 0,
                top: 0,
                "-webkit-backface-visibility": "hidden",
              },
              t = "transition";

            cssObj["-webkit-" + t] =
              cssObj["-moz-" + t] =
              cssObj["-o-" + t] =
              cssObj[t] =
                transition;

            newImg.css(cssObj);
            return newImg;
          },
          showMainContent = function () {
            mfp.content.css("visibility", "visible");
          },
          openTimeout,
          animatedImg;

        _mfpOn("BuildControls" + ns, function () {
          if (mfp._allowZoom()) {
            clearTimeout(openTimeout);
            mfp.content.css("visibility", "hidden");

            // Basically, all code below does is clones existing image, puts in on top of the current one and animated it

            image = mfp._getItemToZoom();

            if (!image) {
              showMainContent();
              return;
            }

            animatedImg = getElToAnimate(image);

            animatedImg.css(mfp._getOffset());

            mfp.wrap.append(animatedImg);

            openTimeout = setTimeout(function () {
              animatedImg.css(mfp._getOffset(true));
              openTimeout = setTimeout(function () {
                showMainContent();

                setTimeout(function () {
                  animatedImg.remove();
                  image = animatedImg = null;
                  _mfpTrigger("ZoomAnimationEnded");
                }, 16); // avoid blink when switching images
              }, duration); // this timeout equals animation duration
            }, 16); // by adding this timeout we avoid short glitch at the beginning of animation

            // Lots of timeouts...
          }
        });
        _mfpOn(BEFORE_CLOSE_EVENT + ns, function () {
          if (mfp._allowZoom()) {
            clearTimeout(openTimeout);

            mfp.st.removalDelay = duration;

            if (!image) {
              image = mfp._getItemToZoom();
              if (!image) {
                return;
              }
              animatedImg = getElToAnimate(image);
            }

            animatedImg.css(mfp._getOffset(true));
            mfp.wrap.append(animatedImg);
            mfp.content.css("visibility", "hidden");

            setTimeout(function () {
              animatedImg.css(mfp._getOffset());
            }, 16);
          }
        });

        _mfpOn(CLOSE_EVENT + ns, function () {
          if (mfp._allowZoom()) {
            showMainContent();
            if (animatedImg) {
              animatedImg.remove();
            }
            image = null;
          }
        });
      },

      _allowZoom: function () {
        return mfp.currItem.type === "image";
      },

      _getItemToZoom: function () {
        if (mfp.currItem.hasSize) {
          return mfp.currItem.img;
        } else {
          return false;
        }
      },

      // Get element postion relative to viewport
      _getOffset: function (isLarge) {
        var el;
        if (isLarge) {
          el = mfp.currItem.img;
        } else {
          el = mfp.st.zoom.opener(mfp.currItem.el || mfp.currItem);
        }

        var offset = el.offset();
        var paddingTop = parseInt(el.css("padding-top"), 10);
        var paddingBottom = parseInt(el.css("padding-bottom"), 10);
        offset.top -= $(window).scrollTop() - paddingTop;

        /*
			
			Animating left + top + width/height looks glitchy in Firefox, but perfect in Chrome. And vice-versa.

			 */
        var obj = {
          width: el.width(),
          // fix Zepto height+padding issue
          height:
            (_isJQ ? el.innerHeight() : el[0].offsetHeight) -
            paddingBottom -
            paddingTop,
        };

        // I hate to do this, but there is no another option
        if (getHasMozTransform()) {
          obj["-moz-transform"] = obj["transform"] =
            "translate(" + offset.left + "px," + offset.top + "px)";
        } else {
          obj.left = offset.left;
          obj.top = offset.top;
        }
        return obj;
      },
    },
  });

  /*>>zoom*/

  /*>>iframe*/

  var IFRAME_NS = "iframe",
    _emptyPage = "//about:blank",
    _fixIframeBugs = function (isShowing) {
      if (mfp.currTemplate[IFRAME_NS]) {
        var el = mfp.currTemplate[IFRAME_NS].find("iframe");
        if (el.length) {
          // reset src after the popup is closed to avoid "video keeps playing after popup is closed" bug
          if (!isShowing) {
            el[0].src = _emptyPage;
          }

          // IE8 black screen bug fix
          if (mfp.isIE8) {
            el.css("display", isShowing ? "block" : "none");
          }
        }
      }
    };

  $.magnificPopup.registerModule(IFRAME_NS, {
    options: {
      markup:
        '<div class="mfp-iframe-scaler">' +
        '<div class="mfp-close"></div>' +
        '<iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe>' +
        "</div>",

      srcAction: "iframe_src",

      // we don't care and support only one default type of URL by default
      patterns: {
        youtube: {
          index: "youtube.com",
          id: "v=",
          src: "//www.youtube.com/embed/%id%?autoplay=1",
        },
        vimeo: {
          index: "vimeo.com/",
          id: "/",
          src: "//player.vimeo.com/video/%id%?autoplay=1",
        },
        gmaps: {
          index: "//maps.google.",
          src: "%id%&output=embed",
        },
      },
    },

    proto: {
      initIframe: function () {
        mfp.types.push(IFRAME_NS);

        _mfpOn("BeforeChange", function (e, prevType, newType) {
          if (prevType !== newType) {
            if (prevType === IFRAME_NS) {
              _fixIframeBugs(); // iframe if removed
            } else if (newType === IFRAME_NS) {
              _fixIframeBugs(true); // iframe is showing
            }
          } // else {
          // iframe source is switched, don't do anything
          //}
        });

        _mfpOn(CLOSE_EVENT + "." + IFRAME_NS, function () {
          _fixIframeBugs();
        });
      },

      getIframe: function (item, template) {
        var embedSrc = item.src;
        var iframeSt = mfp.st.iframe;

        $.each(iframeSt.patterns, function () {
          if (embedSrc.indexOf(this.index) > -1) {
            if (this.id) {
              if (typeof this.id === "string") {
                embedSrc = embedSrc.substr(
                  embedSrc.lastIndexOf(this.id) + this.id.length,
                  embedSrc.length
                );
              } else {
                embedSrc = this.id.call(this, embedSrc);
              }
            }
            embedSrc = this.src.replace("%id%", embedSrc);
            return false; // break;
          }
        });

        var dataObj = {};
        if (iframeSt.srcAction) {
          dataObj[iframeSt.srcAction] = embedSrc;
        }
        mfp._parseMarkup(template, dataObj, item);

        mfp.updateStatus("ready");

        return template;
      },
    },
  });

  /*>>iframe*/

  /*>>gallery*/
  /**
   * Get looped index depending on number of slides
   */
  var _getLoopedId = function (index) {
      var numSlides = mfp.items.length;
      if (index > numSlides - 1) {
        return index - numSlides;
      } else if (index < 0) {
        return numSlides + index;
      }
      return index;
    },
    _replaceCurrTotal = function (text, curr, total) {
      return text.replace(/%curr%/gi, curr + 1).replace(/%total%/gi, total);
    };

  $.magnificPopup.registerModule("gallery", {
    options: {
      enabled: false,
      arrowMarkup:
        '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
      preload: [0, 2],
      navigateByImgClick: true,
      arrows: true,

      tPrev: "Previous (Left arrow key)",
      tNext: "Next (Right arrow key)",
      tCounter: "%curr% of %total%",
    },

    proto: {
      initGallery: function () {
        var gSt = mfp.st.gallery,
          ns = ".mfp-gallery",
          supportsFastClick = Boolean($.fn.mfpFastClick);

        mfp.direction = true; // true - next, false - prev

        if (!gSt || !gSt.enabled) return false;

        _wrapClasses += " mfp-gallery";

        _mfpOn(OPEN_EVENT + ns, function () {
          if (gSt.navigateByImgClick) {
            mfp.wrap.on("click" + ns, ".mfp-img", function () {
              if (mfp.items.length > 1) {
                mfp.next();
                return false;
              }
            });
          }

          _document.on("keydown" + ns, function (e) {
            if (e.keyCode === 37) {
              mfp.prev();
            } else if (e.keyCode === 39) {
              mfp.next();
            }
          });
        });

        _mfpOn("UpdateStatus" + ns, function (e, data) {
          if (data.text) {
            data.text = _replaceCurrTotal(
              data.text,
              mfp.currItem.index,
              mfp.items.length
            );
          }
        });

        _mfpOn(MARKUP_PARSE_EVENT + ns, function (e, element, values, item) {
          var l = mfp.items.length;
          values.counter =
            l > 1 ? _replaceCurrTotal(gSt.tCounter, item.index, l) : "";
        });

        _mfpOn("BuildControls" + ns, function () {
          if (mfp.items.length > 1 && gSt.arrows && !mfp.arrowLeft) {
            var markup = gSt.arrowMarkup,
              arrowLeft = (mfp.arrowLeft = $(
                markup
                  .replace(/%title%/gi, gSt.tPrev)
                  .replace(/%dir%/gi, "left")
              ).addClass(PREVENT_CLOSE_CLASS)),
              arrowRight = (mfp.arrowRight = $(
                markup
                  .replace(/%title%/gi, gSt.tNext)
                  .replace(/%dir%/gi, "right")
              ).addClass(PREVENT_CLOSE_CLASS));

            var eName = supportsFastClick ? "mfpFastClick" : "click";
            arrowLeft[eName](function () {
              mfp.prev();
            });
            arrowRight[eName](function () {
              mfp.next();
            });

            // Polyfill for :before and :after (adds elements with classes mfp-a and mfp-b)
            if (mfp.isIE7) {
              _getEl("b", arrowLeft[0], false, true);
              _getEl("a", arrowLeft[0], false, true);
              _getEl("b", arrowRight[0], false, true);
              _getEl("a", arrowRight[0], false, true);
            }

            mfp.container.append(arrowLeft.add(arrowRight));
          }
        });

        _mfpOn(CHANGE_EVENT + ns, function () {
          if (mfp._preloadTimeout) clearTimeout(mfp._preloadTimeout);

          mfp._preloadTimeout = setTimeout(function () {
            mfp.preloadNearbyImages();
            mfp._preloadTimeout = null;
          }, 16);
        });

        _mfpOn(CLOSE_EVENT + ns, function () {
          _document.off(ns);
          mfp.wrap.off("click" + ns);

          if (mfp.arrowLeft && supportsFastClick) {
            mfp.arrowLeft.add(mfp.arrowRight).destroyMfpFastClick();
          }
          mfp.arrowRight = mfp.arrowLeft = null;
        });
      },
      next: function () {
        mfp.direction = true;
        mfp.index = _getLoopedId(mfp.index + 1);
        mfp.updateItemHTML();
      },
      prev: function () {
        mfp.direction = false;
        mfp.index = _getLoopedId(mfp.index - 1);
        mfp.updateItemHTML();
      },
      goTo: function (newIndex) {
        mfp.direction = newIndex >= mfp.index;
        mfp.index = newIndex;
        mfp.updateItemHTML();
      },
      preloadNearbyImages: function () {
        var p = mfp.st.gallery.preload,
          preloadBefore = Math.min(p[0], mfp.items.length),
          preloadAfter = Math.min(p[1], mfp.items.length),
          i;

        for (i = 1; i <= (mfp.direction ? preloadAfter : preloadBefore); i++) {
          mfp._preloadItem(mfp.index + i);
        }
        for (i = 1; i <= (mfp.direction ? preloadBefore : preloadAfter); i++) {
          mfp._preloadItem(mfp.index - i);
        }
      },
      _preloadItem: function (index) {
        index = _getLoopedId(index);

        if (mfp.items[index].preloaded) {
          return;
        }

        var item = mfp.items[index];
        if (!item.parsed) {
          item = mfp.parseEl(index);
        }

        _mfpTrigger("LazyLoad", item);

        if (item.type === "image") {
          item.img = $('<img class="mfp-img" />')
            .on("load.mfploader", function () {
              item.hasSize = true;
            })
            .on("error.mfploader", function () {
              item.hasSize = true;
              item.loadError = true;
              _mfpTrigger("LazyLoadError", item);
            })
            .attr("src", item.src);
        }

        item.preloaded = true;
      },
    },
  });

  /*
Touch Support that might be implemented some day

addSwipeGesture: function() {
	var startX,
		moved,
		multipleTouches;

		return;

	var namespace = '.mfp',
		addEventNames = function(pref, down, move, up, cancel) {
			mfp._tStart = pref + down + namespace;
			mfp._tMove = pref + move + namespace;
			mfp._tEnd = pref + up + namespace;
			mfp._tCancel = pref + cancel + namespace;
		};

	if(window.navigator.msPointerEnabled) {
		addEventNames('MSPointer', 'Down', 'Move', 'Up', 'Cancel');
	} else if('ontouchstart' in window) {
		addEventNames('touch', 'start', 'move', 'end', 'cancel');
	} else {
		return;
	}
	_window.on(mfp._tStart, function(e) {
		var oE = e.originalEvent;
		multipleTouches = moved = false;
		startX = oE.pageX || oE.changedTouches[0].pageX;
	}).on(mfp._tMove, function(e) {
		if(e.originalEvent.touches.length > 1) {
			multipleTouches = e.originalEvent.touches.length;
		} else {
			//e.preventDefault();
			moved = true;
		}
	}).on(mfp._tEnd + ' ' + mfp._tCancel, function(e) {
		if(moved && !multipleTouches) {
			var oE = e.originalEvent,
				diff = startX - (oE.pageX || oE.changedTouches[0].pageX);

			if(diff > 20) {
				mfp.next();
			} else if(diff < -20) {
				mfp.prev();
			}
		}
	});
},
*/

  /*>>gallery*/

  /*>>retina*/

  var RETINA_NS = "retina";

  $.magnificPopup.registerModule(RETINA_NS, {
    options: {
      replaceSrc: function (item) {
        return item.src.replace(/\.\w+$/, function (m) {
          return "@2x" + m;
        });
      },
      ratio: 1, // Function or number.  Set to 1 to disable.
    },
    proto: {
      initRetina: function () {
        if (window.devicePixelRatio > 1) {
          var st = mfp.st.retina,
            ratio = st.ratio;

          ratio = !isNaN(ratio) ? ratio : ratio();

          if (ratio > 1) {
            _mfpOn("ImageHasSize" + "." + RETINA_NS, function (e, item) {
              item.img.css({
                "max-width": item.img[0].naturalWidth / ratio,
                width: "100%",
              });
            });
            _mfpOn("ElementParse" + "." + RETINA_NS, function (e, item) {
              item.src = st.replaceSrc(item, ratio);
            });
          }
        }
      },
    },
  });

  /*>>retina*/

  /*>>fastclick*/
  /**
   * FastClick event implementation. (removes 300ms delay on touch devices)
   * Based on https://developers.google.com/mobile/articles/fast_buttons
   *
   * You may use it outside the Magnific Popup by calling just:
   *
   * $('.your-el').mfpFastClick(function() {
   *     console.log('Clicked!');
   * });
   *
   * To unbind:
   * $('.your-el').destroyMfpFastClick();
   *
   *
   * Note that it's a very basic and simple implementation, it blocks ghost click on the same element where it was bound.
   * If you need something more advanced, use plugin by FT Labs https://github.com/ftlabs/fastclick
   *
   */

  (function () {
    var ghostClickDelay = 1000,
      supportsTouch = "ontouchstart" in window,
      unbindTouchMove = function () {
        _window.off("touchmove" + ns + " touchend" + ns);
      },
      eName = "mfpFastClick",
      ns = "." + eName;

    // As Zepto.js doesn't have an easy way to add custom events (like jQuery), so we implement it in this way
    $.fn.mfpFastClick = function (callback) {
      return $(this).each(function () {
        var elem = $(this),
          lock;

        if (supportsTouch) {
          var timeout, startX, startY, pointerMoved, point, numPointers;

          elem.on("touchstart" + ns, function (e) {
            pointerMoved = false;
            numPointers = 1;

            point = e.originalEvent ? e.originalEvent.touches[0] : e.touches[0];
            startX = point.clientX;
            startY = point.clientY;

            _window
              .on("touchmove" + ns, function (e) {
                point = e.originalEvent ? e.originalEvent.touches : e.touches;
                numPointers = point.length;
                point = point[0];
                if (
                  Math.abs(point.clientX - startX) > 10 ||
                  Math.abs(point.clientY - startY) > 10
                ) {
                  pointerMoved = true;
                  unbindTouchMove();
                }
              })
              .on("touchend" + ns, function (e) {
                unbindTouchMove();
                if (pointerMoved || numPointers > 1) {
                  return;
                }
                lock = true;
                e.preventDefault();
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                  lock = false;
                }, ghostClickDelay);
                callback();
              });
          });
        }

        elem.on("click" + ns, function () {
          if (!lock) {
            callback();
          }
        });
      });
    };

    $.fn.destroyMfpFastClick = function () {
      $(this).off("touchstart" + ns + " click" + ns);
      if (supportsTouch) _window.off("touchmove" + ns + " touchend" + ns);
    };
  })();

  /*>>fastclick*/
  _checkInstance();
});
/*
 * jQuery Superfish Menu Plugin - v1.7.4
 * Copyright (c) 2013 Joel Birch
 *
 * Dual licensed under the MIT and GPL licenses:
 *	http://www.opensource.org/licenses/mit-license.php
 *	http://www.gnu.org/licenses/gpl.html
 */

(function ($) {
  "use strict";

  var methods = (function () {
    // private properties and methods go here
    var c = {
        bcClass: "sf-breadcrumb",
        menuClass: "sf-js-enabled",
        anchorClass: "sf-with-ul",
        menuArrowClass: "sf-arrows",
      },
      ios = (function () {
        var ios = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        if (ios) {
          // iOS clicks only bubble as far as body children
          $(window).load(function () {
            $("body").children().on("click", $.noop);
          });
        }
        return ios;
      })(),
      wp7 = (function () {
        var style = document.documentElement.style;
        return (
          "behavior" in style &&
          "fill" in style &&
          /iemobile/i.test(navigator.userAgent)
        );
      })(),
      toggleMenuClasses = function ($menu, o) {
        var classes = c.menuClass;
        if (o.cssArrows) {
          classes += " " + c.menuArrowClass;
        }
        $menu.toggleClass(classes);
      },
      setPathToCurrent = function ($menu, o) {
        return $menu
          .find("li." + o.pathClass)
          .slice(0, o.pathLevels)
          .addClass(o.hoverClass + " " + c.bcClass)
          .filter(function () {
            return $(this).children(o.popUpSelector).hide().show().length;
          })
          .removeClass(o.pathClass);
      },
      toggleAnchorClass = function ($li) {
        $li.children("a").toggleClass(c.anchorClass);
      },
      toggleTouchAction = function ($menu) {
        var touchAction = $menu.css("ms-touch-action");
        touchAction = touchAction === "pan-y" ? "auto" : "pan-y";
        $menu.css("ms-touch-action", touchAction);
      },
      applyHandlers = function ($menu, o) {
        var targets = "li:has(" + o.popUpSelector + ")";
        if ($.fn.hoverIntent && !o.disableHI) {
          $menu.hoverIntent(over, out, targets);
        } else {
          $menu
            .on("mouseenter.superfish", targets, over)
            .on("mouseleave.superfish", targets, out);
        }
        var touchevent = "MSPointerDown.superfish";
        if (!ios) {
          touchevent += " touchend.superfish";
        }
        if (wp7) {
          touchevent += " mousedown.superfish";
        }
        $menu
          .on("focusin.superfish", "li", over)
          .on("focusout.superfish", "li", out)
          .on(touchevent, "a", o, touchHandler);
      },
      touchHandler = function (e) {
        var $this = $(this),
          $ul = $this.siblings(e.data.popUpSelector);

        if ($ul.length > 0 && $ul.is(":hidden")) {
          $this.one("click.superfish", false);
          if (e.type === "MSPointerDown") {
            $this.trigger("focus");
          } else {
            $.proxy(over, $this.parent("li"))();
          }
        }
      },
      over = function () {
        var $this = $(this),
          o = getOptions($this);

        if ($(this).parents(".megamenu").length > 0) return;

        clearTimeout(o.sfTimer);
        $this.siblings().superfish("hide").end().superfish("show");
      },
      out = function () {
        var $this = $(this),
          o = getOptions($this);
        if (ios) {
          $.proxy(close, $this, o)();
        } else {
          clearTimeout(o.sfTimer);
          o.sfTimer = setTimeout($.proxy(close, $this, o), o.delay);
        }
      },
      close = function (o) {
        o.retainPath = $.inArray(this[0], o.$path) > -1;
        this.superfish("hide");

        if (!this.parents("." + o.hoverClass).length) {
          o.onIdle.call(getMenu(this));
          if (o.$path.length) {
            $.proxy(over, o.$path)();
          }
        }
      },
      getMenu = function ($el) {
        return $el.closest("." + c.menuClass);
      },
      getOptions = function ($el) {
        return getMenu($el).data("sf-options");
      };

    return {
      // public methods
      hide: function (instant) {
        if (this.length) {
          var $this = this,
            o = getOptions($this);
          if (!o) {
            return this;
          }

          if (
            $(this).hasClass("menu-item-over") &&
            $(this).hasClass("megamenu")
          ) {
            return true;
          }

          var not = o.retainPath === true ? o.$path : "",
            $ul = $this
              .find("li." + o.hoverClass)
              .add(this)
              .not(not)
              .removeClass(o.hoverClass)
              .children(o.popUpSelector),
            speed = o.speedOut;

          if (instant) {
            $ul.show();
            speed = 0;
          }
          o.retainPath = false;
          o.onBeforeHide.call($ul);

          if (o.dropdownStyle == "minimal") {
            var $this = $(this);
            o.onHide.call($this);
          } else {
            $ul.stop(true, true).animate(o.animationOut, speed, function () {
              var $this = $(this);
              o.onHide.call($this);
            });
          }

          if ($(this).parents(".megamenu").length > 0) return;

          //megamenu removes transparent option
          if (
            $('#header-outer[data-megamenu-rt="1"]').length > 0 &&
            $('#header-outer[data-transparent-header="true"]').length > 0
          ) {
            if (
              $("#header-outer.scrolled-down").length == 0 &&
              $("#header-outer.small-nav").length == 0 &&
              $("#header-outer.detached").length == 0
            ) {
              $("#header-outer").addClass("transparent");
            }
          }
        }
        return this;
      },
      show: function () {
        if ($(this).parents(".megamenu").length > 0) return;

        var o = getOptions(this);
        if (!o) {
          return this;
        }
        var $this = this.addClass(o.hoverClass),
          $ul = $this.children(o.popUpSelector);

        //megamenu removes transparent option
        if (
          $('#header-outer[data-megamenu-rt="1"]').length > 0 &&
          $(this).hasClass("megamenu")
        ) {
          $("#header-outer").addClass("no-transition");
          $("#header-outer").removeClass("transparent");
        }

        o.onBeforeShow.call($ul);

        //make sure the ul has space
        if (
          !$($ul).parents("li").hasClass("megamenu") &&
          !$($ul).parents("ul").hasClass("sub-menu") &&
          $ul.offset()
        ) {
          $ul.addClass("temp-hidden-display");
          var docW = $("#top .container").width();
          var elm = $ul;
          var off = elm.offset();
          var l = off.left - ($(window).width() - docW) / 2;
          var w = elm.width();
          var isEntirelyVisible = l + w <= $(window).width() - 100;

          if (!isEntirelyVisible) {
            $ul.parents("li").addClass("edge");
          } else {
            $ul.parents("li").removeClass("edge");
          }
          $ul.removeClass("temp-hidden-display");
        }

        if (o.dropdownStyle == "minimal") {
          o.onShow.call($ul);
        } else {
          $ul.stop(true, true).animate(o.animation, o.speed, function () {
            o.onShow.call($ul);
          });
        }

        //show on left class
        if (
          $ul.length > 0 &&
          $ul.parents(".sub-menu").length > 0 &&
          $ul.parent().parent().parent().parent().hasClass("sf-menu")
        ) {
          if ($ul.offset().left + $ul.outerWidth() > $(window).width()) {
            $ul.addClass("on-left-side");
            $ul.find("ul").addClass("on-left-side");
          }
        }

        return this;
      },
      destroy: function () {
        return this.each(function () {
          var $this = $(this),
            o = $this.data("sf-options"),
            $hasPopUp;
          if (!o) {
            return false;
          }
          $hasPopUp = $this.find(o.popUpSelector).parent("li");
          clearTimeout(o.sfTimer);
          toggleMenuClasses($this, o);
          toggleAnchorClass($hasPopUp);
          toggleTouchAction($this);
          // remove event handlers
          $this.off(".superfish").off(".hoverIntent");
          // clear animation's inline display style
          $hasPopUp
            .children(o.popUpSelector)
            .attr("style", function (i, style) {
              return style.replace(/display[^;]+;?/g, "");
            });
          // reset 'current' path classes
          o.$path
            .removeClass(o.hoverClass + " " + c.bcClass)
            .addClass(o.pathClass);
          $this.find("." + o.hoverClass).removeClass(o.hoverClass);
          o.onDestroy.call($this);
          $this.removeData("sf-options");
        });
      },
      init: function (op) {
        return this.each(function () {
          var $this = $(this);
          if ($this.data("sf-options")) {
            return false;
          }
          var o = $.extend({}, $.fn.superfish.defaults, op),
            $hasPopUp = $this.find(o.popUpSelector).parent("li");
          o.$path = setPathToCurrent($this, o);

          $this.data("sf-options", o);

          toggleMenuClasses($this, o);
          toggleAnchorClass($hasPopUp);
          toggleTouchAction($this);
          applyHandlers($this, o);

          $hasPopUp.not("." + c.bcClass).superfish("hide", true);

          o.onInit.call(this);
        });
      },
    };
  })();

  $.fn.superfish = function (method, args) {
    if (methods[method]) {
      return methods[method].apply(
        this,
        Array.prototype.slice.call(arguments, 1)
      );
    } else if (typeof method === "object" || !method) {
      return methods.init.apply(this, arguments);
    } else {
      return $.error(
        "Method " + method + " does not exist on jQuery.fn.superfish"
      );
    }
  };

  $.fn.superfish.defaults = {
    popUpSelector: "ul,.sf-mega", // within menu context
    hoverClass: "sfHover",
    pathClass: "overrideThisToUse",
    pathLevels: 1,
    delay: 800,
    animation: { opacity: "show" },
    animationOut: { opacity: "hide" },
    speed: "normal",
    speedOut: "fast",
    cssArrows: true,
    disableHI: false,
    onInit: $.noop,
    onBeforeShow: $.noop,
    onShow: $.noop,
    onBeforeHide: $.noop,
    onHide: $.noop,
    onIdle: $.noop,
    onDestroy: $.noop,
    dropdownStyle:
      $('body[data-dropdown-style="minimal"]').length > 0
        ? "minimal"
        : "classic",
  };

  // soon to be deprecated
  $.fn.extend({
    hideSuperfishUl: methods.hide,
    showSuperfishUl: methods.show,
  });
})(jQuery);

/*-------------------------------------------------------------------------

	1.	Plugin Init
	2.	Helper Functions
	3.	Shortcode Stuff
	4.	Header + Search
	5.	Page Specific
	6.  Scroll to top 
	7.	Cross Browser Fixes


-------------------------------------------------------------------------*/

/*-------------------------------------------------------------------------*/
/*	1.	Plugin Init
/*-------------------------------------------------------------------------*/

/*!
 * imagesLoaded PACKAGED v3.1.1
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

(function () {
  function e() {}
  function t(e, t) {
    for (var n = e.length; n--; ) if (e[n].listener === t) return n;
    return -1;
  }
  function n(e) {
    return function () {
      return this[e].apply(this, arguments);
    };
  }
  var i = e.prototype,
    r = this,
    o = r.EventEmitter;
  (i.getListeners = function (e) {
    var t,
      n,
      i = this._getEvents();
    if ("object" == typeof e) {
      t = {};
      for (n in i) i.hasOwnProperty(n) && e.test(n) && (t[n] = i[n]);
    } else t = i[e] || (i[e] = []);
    return t;
  }),
    (i.flattenListeners = function (e) {
      var t,
        n = [];
      for (t = 0; e.length > t; t += 1) n.push(e[t].listener);
      return n;
    }),
    (i.getListenersAsObject = function (e) {
      var t,
        n = this.getListeners(e);
      return n instanceof Array && ((t = {}), (t[e] = n)), t || n;
    }),
    (i.addListener = function (e, n) {
      var i,
        r = this.getListenersAsObject(e),
        o = "object" == typeof n;
      for (i in r)
        r.hasOwnProperty(i) &&
          -1 === t(r[i], n) &&
          r[i].push(o ? n : { listener: n, once: !1 });
      return this;
    }),
    (i.on = n("addListener")),
    (i.addOnceListener = function (e, t) {
      return this.addListener(e, { listener: t, once: !0 });
    }),
    (i.once = n("addOnceListener")),
    (i.defineEvent = function (e) {
      return this.getListeners(e), this;
    }),
    (i.defineEvents = function (e) {
      for (var t = 0; e.length > t; t += 1) this.defineEvent(e[t]);
      return this;
    }),
    (i.removeListener = function (e, n) {
      var i,
        r,
        o = this.getListenersAsObject(e);
      for (r in o)
        o.hasOwnProperty(r) &&
          ((i = t(o[r], n)), -1 !== i && o[r].splice(i, 1));
      return this;
    }),
    (i.off = n("removeListener")),
    (i.addListeners = function (e, t) {
      return this.manipulateListeners(!1, e, t);
    }),
    (i.removeListeners = function (e, t) {
      return this.manipulateListeners(!0, e, t);
    }),
    (i.manipulateListeners = function (e, t, n) {
      var i,
        r,
        o = e ? this.removeListener : this.addListener,
        s = e ? this.removeListeners : this.addListeners;
      if ("object" != typeof t || t instanceof RegExp)
        for (i = n.length; i--; ) o.call(this, t, n[i]);
      else
        for (i in t)
          t.hasOwnProperty(i) &&
            (r = t[i]) &&
            ("function" == typeof r ? o.call(this, i, r) : s.call(this, i, r));
      return this;
    }),
    (i.removeEvent = function (e) {
      var t,
        n = typeof e,
        i = this._getEvents();
      if ("string" === n) delete i[e];
      else if ("object" === n)
        for (t in i) i.hasOwnProperty(t) && e.test(t) && delete i[t];
      else delete this._events;
      return this;
    }),
    (i.removeAllListeners = n("removeEvent")),
    (i.emitEvent = function (e, t) {
      var n,
        i,
        r,
        o,
        s = this.getListenersAsObject(e);
      for (r in s)
        if (s.hasOwnProperty(r))
          for (i = s[r].length; i--; )
            (n = s[r][i]),
              n.once === !0 && this.removeListener(e, n.listener),
              (o = n.listener.apply(this, t || [])),
              o === this._getOnceReturnValue() &&
                this.removeListener(e, n.listener);
      return this;
    }),
    (i.trigger = n("emitEvent")),
    (i.emit = function (e) {
      var t = Array.prototype.slice.call(arguments, 1);
      return this.emitEvent(e, t);
    }),
    (i.setOnceReturnValue = function (e) {
      return (this._onceReturnValue = e), this;
    }),
    (i._getOnceReturnValue = function () {
      return this.hasOwnProperty("_onceReturnValue")
        ? this._onceReturnValue
        : !0;
    }),
    (i._getEvents = function () {
      return this._events || (this._events = {});
    }),
    (e.noConflict = function () {
      return (r.EventEmitter = o), e;
    }),
    "function" == typeof define && define.amd
      ? define("eventEmitter/EventEmitter", [], function () {
          return e;
        })
      : "object" == typeof module && module.exports
      ? (module.exports = e)
      : (this.EventEmitter = e);
}).call(this),
  (function (e) {
    function t(t) {
      var n = e.event;
      return (n.target = n.target || n.srcElement || t), n;
    }
    var n = document.documentElement,
      i = function () {};
    n.addEventListener
      ? (i = function (e, t, n) {
          e.addEventListener(t, n, !1);
        })
      : n.attachEvent &&
        (i = function (e, n, i) {
          (e[n + i] = i.handleEvent
            ? function () {
                var n = t(e);
                i.handleEvent.call(i, n);
              }
            : function () {
                var n = t(e);
                i.call(e, n);
              }),
            e.attachEvent("on" + n, e[n + i]);
        });
    var r = function () {};
    n.removeEventListener
      ? (r = function (e, t, n) {
          e.removeEventListener(t, n, !1);
        })
      : n.detachEvent &&
        (r = function (e, t, n) {
          e.detachEvent("on" + t, e[t + n]);
          try {
            delete e[t + n];
          } catch (i) {
            e[t + n] = void 0;
          }
        });
    var o = { bind: i, unbind: r };
    "function" == typeof define && define.amd
      ? define("eventie/eventie", o)
      : (e.eventie = o);
  })(this),
  (function (e) {
    function t(e, t) {
      for (var n in t) e[n] = t[n];
      return e;
    }
    function n(e) {
      return "[object Array]" === f.call(e);
    }
    function i(e) {
      var t = [];
      if (n(e)) t = e;
      else if ("number" == typeof e.length)
        for (var i = 0, r = e.length; r > i; i++) t.push(e[i]);
      else t.push(e);
      return t;
    }
    function r(e, n) {
      function r(e, n, s) {
        if (!(this instanceof r)) return new r(e, n);
        "string" == typeof e && (e = document.querySelectorAll(e)),
          (this.elements = i(e)),
          (this.options = t({}, this.options)),
          "function" == typeof n ? (s = n) : t(this.options, n),
          s && this.on("always", s),
          this.getImages(),
          o && (this.jqDeferred = new o.Deferred());
        var c = this;
        setTimeout(function () {
          c.check();
        });
      }
      function f(e) {
        this.img = e;
      }
      function a(e) {
        (this.src = e), (h[e] = this);
      }
      (r.prototype = new e()),
        (r.prototype.options = {}),
        (r.prototype.getImages = function () {
          this.images = [];
          for (var e = 0, t = this.elements.length; t > e; e++) {
            var n = this.elements[e];
            "IMG" === n.nodeName && this.addImage(n);
            for (
              var i = n.querySelectorAll("img"), r = 0, o = i.length;
              o > r;
              r++
            ) {
              var s = i[r];
              this.addImage(s);
            }
          }
        }),
        (r.prototype.addImage = function (e) {
          var t = new f(e);
          this.images.push(t);
        }),
        (r.prototype.check = function () {
          function e(e, r) {
            return (
              t.options.debug && c && s.log("confirm", e, r),
              t.progress(e),
              n++,
              n === i && t.complete(),
              !0
            );
          }
          var t = this,
            n = 0,
            i = this.images.length;
          if (((this.hasAnyBroken = !1), !i)) return this.complete(), void 0;
          for (var r = 0; i > r; r++) {
            var o = this.images[r];
            o.on("confirm", e), o.check();
          }
        }),
        (r.prototype.progress = function (e) {
          this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded;
          var t = this;
          setTimeout(function () {
            t.emit("progress", t, e), t.jqDeferred && t.jqDeferred.notify(t, e);
          });
        }),
        (r.prototype.complete = function () {
          var e = this.hasAnyBroken ? "fail" : "done";
          this.isComplete = !0;
          var t = this;
          setTimeout(function () {
            if ((t.emit(e, t), t.emit("always", t), t.jqDeferred)) {
              var n = t.hasAnyBroken ? "reject" : "resolve";
              t.jqDeferred[n](t);
            }
          });
        }),
        o &&
          (o.fn.imagesLoaded = function (e, t) {
            var n = new r(this, e, t);
            return n.jqDeferred.promise(o(this));
          }),
        (f.prototype = new e()),
        (f.prototype.check = function () {
          var e = h[this.img.src] || new a(this.img.src);
          if (e.isConfirmed)
            return this.confirm(e.isLoaded, "cached was confirmed"), void 0;
          if (this.img.complete && void 0 !== this.img.naturalWidth)
            return (
              this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), void 0
            );
          var t = this;
          e.on("confirm", function (e, n) {
            return t.confirm(e.isLoaded, n), !0;
          }),
            e.check();
        }),
        (f.prototype.confirm = function (e, t) {
          (this.isLoaded = e), this.emit("confirm", this, t);
        });
      var h = {};
      return (
        (a.prototype = new e()),
        (a.prototype.check = function () {
          if (!this.isChecked) {
            var e = new Image();
            n.bind(e, "load", this),
              n.bind(e, "error", this),
              (e.src = this.src),
              (this.isChecked = !0);
          }
        }),
        (a.prototype.handleEvent = function (e) {
          var t = "on" + e.type;
          this[t] && this[t](e);
        }),
        (a.prototype.onload = function (e) {
          this.confirm(!0, "onload"), this.unbindProxyEvents(e);
        }),
        (a.prototype.onerror = function (e) {
          this.confirm(!1, "onerror"), this.unbindProxyEvents(e);
        }),
        (a.prototype.confirm = function (e, t) {
          (this.isConfirmed = !0),
            (this.isLoaded = e),
            this.emit("confirm", this, t);
        }),
        (a.prototype.unbindProxyEvents = function (e) {
          n.unbind(e.target, "load", this), n.unbind(e.target, "error", this);
        }),
        r
      );
    }
    var o = e.jQuery,
      s = e.console,
      c = s !== void 0,
      f = Object.prototype.toString;
    "function" == typeof define && define.amd
      ? define(["eventEmitter/EventEmitter", "eventie/eventie"], r)
      : (e.imagesLoaded = r(e.EventEmitter, e.eventie));
  })(window);

/*!
Waypoints - 4.0.1
*/
!(function () {
  "use strict";
  function t(o) {
    if (!o) throw new Error("No options passed to Waypoint constructor");
    if (!o.element)
      throw new Error("No element option passed to Waypoint constructor");
    if (!o.handler)
      throw new Error("No handler option passed to Waypoint constructor");
    (this.key = "waypoint-" + e),
      (this.options = t.Adapter.extend({}, t.defaults, o)),
      (this.element = this.options.element),
      (this.adapter = new t.Adapter(this.element)),
      (this.callback = o.handler),
      (this.axis = this.options.horizontal ? "horizontal" : "vertical"),
      (this.enabled = this.options.enabled),
      (this.triggerPoint = null),
      (this.group = t.Group.findOrCreate({
        name: this.options.group,
        axis: this.axis,
      })),
      (this.context = t.Context.findOrCreateByElement(this.options.context)),
      t.offsetAliases[this.options.offset] &&
        (this.options.offset = t.offsetAliases[this.options.offset]),
      this.group.add(this),
      this.context.add(this),
      (i[this.key] = this),
      (e += 1);
  }
  var e = 0,
    i = {};
  (t.prototype.queueTrigger = function (t) {
    this.group.queueTrigger(this, t);
  }),
    (t.prototype.trigger = function (t) {
      this.enabled && this.callback && this.callback.apply(this, t);
    }),
    (t.prototype.destroy = function () {
      this.context.remove(this), this.group.remove(this), delete i[this.key];
    }),
    (t.prototype.disable = function () {
      return (this.enabled = !1), this;
    }),
    (t.prototype.enable = function () {
      return this.context.refresh(), (this.enabled = !0), this;
    }),
    (t.prototype.next = function () {
      return this.group.next(this);
    }),
    (t.prototype.previous = function () {
      return this.group.previous(this);
    }),
    (t.invokeAll = function (t) {
      var e = [];
      for (var o in i) e.push(i[o]);
      for (var n = 0, r = e.length; r > n; n++) e[n][t]();
    }),
    (t.destroyAll = function () {
      t.invokeAll("destroy");
    }),
    (t.disableAll = function () {
      t.invokeAll("disable");
    }),
    (t.enableAll = function () {
      t.Context.refreshAll();
      for (var e in i) i[e].enabled = !0;
      return this;
    }),
    (t.refreshAll = function () {
      t.Context.refreshAll();
    }),
    (t.viewportHeight = function () {
      return window.innerHeight || document.documentElement.clientHeight;
    }),
    (t.viewportWidth = function () {
      return document.documentElement.clientWidth;
    }),
    (t.adapters = []),
    (t.defaults = {
      context: window,
      continuous: !0,
      enabled: !0,
      group: "default",
      horizontal: !1,
      offset: 0,
    }),
    (t.offsetAliases = {
      "bottom-in-view": function () {
        return this.context.innerHeight() - this.adapter.outerHeight();
      },
      "right-in-view": function () {
        return this.context.innerWidth() - this.adapter.outerWidth();
      },
    }),
    (window.Waypoint = t);
})(),
  (function () {
    "use strict";
    function t(t) {
      window.setTimeout(t, 1e3 / 60);
    }
    function e(t) {
      (this.element = t),
        (this.Adapter = n.Adapter),
        (this.adapter = new this.Adapter(t)),
        (this.key = "waypoint-context-" + i),
        (this.didScroll = !1),
        (this.didResize = !1),
        (this.oldScroll = {
          x: this.adapter.scrollLeft(),
          y: this.adapter.scrollTop(),
        }),
        (this.waypoints = { vertical: {}, horizontal: {} }),
        (t.waypointContextKey = this.key),
        (o[t.waypointContextKey] = this),
        (i += 1),
        n.windowContext ||
          ((n.windowContext = !0), (n.windowContext = new e(window))),
        this.createThrottledScrollHandler(),
        this.createThrottledResizeHandler();
    }
    var i = 0,
      o = {},
      n = window.Waypoint,
      r = window.onload;
    (e.prototype.add = function (t) {
      var e = t.options.horizontal ? "horizontal" : "vertical";
      (this.waypoints[e][t.key] = t), this.refresh();
    }),
      (e.prototype.checkEmpty = function () {
        var t = this.Adapter.isEmptyObject(this.waypoints.horizontal),
          e = this.Adapter.isEmptyObject(this.waypoints.vertical),
          i = this.element == this.element.window;
        t && e && !i && (this.adapter.off(".waypoints"), delete o[this.key]);
      }),
      (e.prototype.createThrottledResizeHandler = function () {
        function t() {
          e.handleResize(), (e.didResize = !1);
        }
        var e = this;
        this.adapter.on("resize.waypoints", function () {
          e.didResize || ((e.didResize = !0), n.requestAnimationFrame(t));
        });
      }),
      (e.prototype.createThrottledScrollHandler = function () {
        function t() {
          e.handleScroll(), (e.didScroll = !1);
        }
        var e = this;
        this.adapter.on("scroll.waypoints", function () {
          (!e.didScroll || n.isTouch) &&
            ((e.didScroll = !0), n.requestAnimationFrame(t));
        });
      }),
      (e.prototype.handleResize = function () {
        n.Context.refreshAll();
      }),
      (e.prototype.handleScroll = function () {
        var t = {},
          e = {
            horizontal: {
              newScroll: this.adapter.scrollLeft(),
              oldScroll: this.oldScroll.x,
              forward: "right",
              backward: "left",
            },
            vertical: {
              newScroll: this.adapter.scrollTop(),
              oldScroll: this.oldScroll.y,
              forward: "down",
              backward: "up",
            },
          };
        for (var i in e) {
          var o = e[i],
            n = o.newScroll > o.oldScroll,
            r = n ? o.forward : o.backward;
          for (var s in this.waypoints[i]) {
            var a = this.waypoints[i][s];
            if (null !== a.triggerPoint) {
              var l = o.oldScroll < a.triggerPoint,
                h = o.newScroll >= a.triggerPoint,
                p = l && h,
                u = !l && !h;
              (p || u) && (a.queueTrigger(r), (t[a.group.id] = a.group));
            }
          }
        }
        for (var c in t) t[c].flushTriggers();
        this.oldScroll = { x: e.horizontal.newScroll, y: e.vertical.newScroll };
      }),
      (e.prototype.innerHeight = function () {
        return this.element == this.element.window
          ? n.viewportHeight()
          : this.adapter.innerHeight();
      }),
      (e.prototype.remove = function (t) {
        delete this.waypoints[t.axis][t.key], this.checkEmpty();
      }),
      (e.prototype.innerWidth = function () {
        return this.element == this.element.window
          ? n.viewportWidth()
          : this.adapter.innerWidth();
      }),
      (e.prototype.destroy = function () {
        var t = [];
        for (var e in this.waypoints)
          for (var i in this.waypoints[e]) t.push(this.waypoints[e][i]);
        for (var o = 0, n = t.length; n > o; o++) t[o].destroy();
      }),
      (e.prototype.refresh = function () {
        var t,
          e = this.element == this.element.window,
          i = e ? void 0 : this.adapter.offset(),
          o = {};
        this.handleScroll(),
          (t = {
            horizontal: {
              contextOffset: e ? 0 : i.left,
              contextScroll: e ? 0 : this.oldScroll.x,
              contextDimension: this.innerWidth(),
              oldScroll: this.oldScroll.x,
              forward: "right",
              backward: "left",
              offsetProp: "left",
            },
            vertical: {
              contextOffset: e ? 0 : i.top,
              contextScroll: e ? 0 : this.oldScroll.y,
              contextDimension: this.innerHeight(),
              oldScroll: this.oldScroll.y,
              forward: "down",
              backward: "up",
              offsetProp: "top",
            },
          });
        for (var r in t) {
          var s = t[r];
          for (var a in this.waypoints[r]) {
            var l,
              h,
              p,
              u,
              c,
              d = this.waypoints[r][a],
              f = d.options.offset,
              w = d.triggerPoint,
              y = 0,
              g = null == w;
            d.element !== d.element.window &&
              (y = d.adapter.offset()[s.offsetProp]),
              "function" == typeof f
                ? (f = f.apply(d))
                : "string" == typeof f &&
                  ((f = parseFloat(f)),
                  d.options.offset.indexOf("%") > -1 &&
                    (f = Math.ceil((s.contextDimension * f) / 100))),
              (l = s.contextScroll - s.contextOffset),
              (d.triggerPoint = Math.floor(y + l - f)),
              (h = w < s.oldScroll),
              (p = d.triggerPoint >= s.oldScroll),
              (u = h && p),
              (c = !h && !p),
              !g && u
                ? (d.queueTrigger(s.backward), (o[d.group.id] = d.group))
                : !g && c
                ? (d.queueTrigger(s.forward), (o[d.group.id] = d.group))
                : g &&
                  s.oldScroll >= d.triggerPoint &&
                  (d.queueTrigger(s.forward), (o[d.group.id] = d.group));
          }
        }
        return (
          n.requestAnimationFrame(function () {
            for (var t in o) o[t].flushTriggers();
          }),
          this
        );
      }),
      (e.findOrCreateByElement = function (t) {
        return e.findByElement(t) || new e(t);
      }),
      (e.refreshAll = function () {
        for (var t in o) o[t].refresh();
      }),
      (e.findByElement = function (t) {
        return o[t.waypointContextKey];
      }),
      (window.onload = function () {
        r && r(), e.refreshAll();
      }),
      (n.requestAnimationFrame = function (e) {
        var i =
          window.requestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          t;
        i.call(window, e);
      }),
      (n.Context = e);
  })(),
  (function () {
    "use strict";
    function t(t, e) {
      return t.triggerPoint - e.triggerPoint;
    }
    function e(t, e) {
      return e.triggerPoint - t.triggerPoint;
    }
    function i(t) {
      (this.name = t.name),
        (this.axis = t.axis),
        (this.id = this.name + "-" + this.axis),
        (this.waypoints = []),
        this.clearTriggerQueues(),
        (o[this.axis][this.name] = this);
    }
    var o = { vertical: {}, horizontal: {} },
      n = window.Waypoint;
    (i.prototype.add = function (t) {
      this.waypoints.push(t);
    }),
      (i.prototype.clearTriggerQueues = function () {
        this.triggerQueues = { up: [], down: [], left: [], right: [] };
      }),
      (i.prototype.flushTriggers = function () {
        for (var i in this.triggerQueues) {
          var o = this.triggerQueues[i],
            n = "up" === i || "left" === i;
          o.sort(n ? e : t);
          for (var r = 0, s = o.length; s > r; r += 1) {
            var a = o[r];
            (a.options.continuous || r === o.length - 1) && a.trigger([i]);
          }
        }
        this.clearTriggerQueues();
      }),
      (i.prototype.next = function (e) {
        this.waypoints.sort(t);
        var i = n.Adapter.inArray(e, this.waypoints),
          o = i === this.waypoints.length - 1;
        return o ? null : this.waypoints[i + 1];
      }),
      (i.prototype.previous = function (e) {
        this.waypoints.sort(t);
        var i = n.Adapter.inArray(e, this.waypoints);
        return i ? this.waypoints[i - 1] : null;
      }),
      (i.prototype.queueTrigger = function (t, e) {
        this.triggerQueues[e].push(t);
      }),
      (i.prototype.remove = function (t) {
        var e = n.Adapter.inArray(t, this.waypoints);
        e > -1 && this.waypoints.splice(e, 1);
      }),
      (i.prototype.first = function () {
        return this.waypoints[0];
      }),
      (i.prototype.last = function () {
        return this.waypoints[this.waypoints.length - 1];
      }),
      (i.findOrCreate = function (t) {
        return o[t.axis][t.name] || new i(t);
      }),
      (n.Group = i);
  })(),
  (function () {
    "use strict";
    function t(t) {
      this.$element = e(t);
    }
    var e = window.jQuery,
      i = window.Waypoint;
    e.each(
      [
        "innerHeight",
        "innerWidth",
        "off",
        "offset",
        "on",
        "outerHeight",
        "outerWidth",
        "scrollLeft",
        "scrollTop",
      ],
      function (e, i) {
        t.prototype[i] = function () {
          var t = Array.prototype.slice.call(arguments);
          return this.$element[i].apply(this.$element, t);
        };
      }
    ),
      e.each(["extend", "inArray", "isEmptyObject"], function (i, o) {
        t[o] = e[o];
      }),
      i.adapters.push({ name: "jquery", Adapter: t }),
      (i.Adapter = t);
  })(),
  (function () {
    "use strict";
    function t(t) {
      return function () {
        var i = [],
          o = arguments[0];
        return (
          t.isFunction(arguments[0]) &&
            ((o = t.extend({}, arguments[1])), (o.handler = arguments[0])),
          this.each(function () {
            var n = t.extend({}, o, { element: this });
            "string" == typeof n.context &&
              (n.context = t(this).closest(n.context)[0]),
              i.push(new e(n));
          }),
          i
        );
      };
    }
    var e = window.Waypoint;
    window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)),
      window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto));
  })();

//visible
!(function (t) {
  var i = t(window);
  t.fn.visible = function (t, e, o) {
    if (!(this.length < 1)) {
      var r = this.length > 1 ? this.eq(0) : this,
        n = r.get(0),
        f = i.width(),
        h = i.height(),
        o = o ? o : "both",
        l = e === !0 ? n.offsetWidth * n.offsetHeight : !0;
      if ("function" == typeof n.getBoundingClientRect) {
        var g = n.getBoundingClientRect(),
          u = g.top >= 0 && g.top < h,
          s = g.bottom > 0 && g.bottom <= h,
          c = g.left >= 0 && g.left < f,
          a = g.right > 0 && g.right <= f,
          v = t ? u || s : u && s,
          b = t ? c || a : c && a;
        if ("both" === o) return l && v && b;
        if ("vertical" === o) return l && v;
        if ("horizontal" === o) return l && b;
      } else {
        var d = i.scrollTop(),
          p = d + h,
          w = i.scrollLeft(),
          m = w + f,
          y = r.offset(),
          z = y.top,
          B = z + r.height(),
          C = y.left,
          R = C + r.width(),
          j = t === !0 ? B : z,
          q = t === !0 ? z : B,
          H = t === !0 ? R : C,
          L = t === !0 ? C : R;
        if ("both" === o) return !!l && p >= q && j >= d && m >= L && H >= w;
        if ("vertical" === o) return !!l && p >= q && j >= d;
        if ("horizontal" === o) return !!l && m >= L && H >= w;
      }
    }
  };
})(jQuery);

/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 */
jQuery.easing["jswing"] = jQuery.easing["swing"];
jQuery.extend(jQuery.easing, {
  def: "easeOutQuad",
  swing: function (a, b, c, d, e) {
    return jQuery.easing[jQuery.easing.def](a, b, c, d, e);
  },
  easeInQuad: function (a, b, c, d, e) {
    return d * (b /= e) * b + c;
  },
  easeOutQuad: function (a, b, c, d, e) {
    return -d * (b /= e) * (b - 2) + c;
  },
  easeInOutQuad: function (a, b, c, d, e) {
    if ((b /= e / 2) < 1) return (d / 2) * b * b + c;
    return (-d / 2) * (--b * (b - 2) - 1) + c;
  },
  easeInCubic: function (a, b, c, d, e) {
    return d * (b /= e) * b * b + c;
  },
  easeOutCubic: function (a, b, c, d, e) {
    return d * ((b = b / e - 1) * b * b + 1) + c;
  },
  easeInOutCubic: function (a, b, c, d, e) {
    if ((b /= e / 2) < 1) return (d / 2) * b * b * b + c;
    return (d / 2) * ((b -= 2) * b * b + 2) + c;
  },
  easeInQuart: function (a, b, c, d, e) {
    return d * (b /= e) * b * b * b + c;
  },
  easeOutQuart: function (a, b, c, d, e) {
    return -d * ((b = b / e - 1) * b * b * b - 1) + c;
  },
  easeInOutQuart: function (a, b, c, d, e) {
    if ((b /= e / 2) < 1) return (d / 2) * b * b * b * b + c;
    return (-d / 2) * ((b -= 2) * b * b * b - 2) + c;
  },
  easeInQuint: function (a, b, c, d, e) {
    return d * (b /= e) * b * b * b * b + c;
  },
  easeOutQuint: function (a, b, c, d, e) {
    return d * ((b = b / e - 1) * b * b * b * b + 1) + c;
  },
  easeInOutQuint: function (a, b, c, d, e) {
    if ((b /= e / 2) < 1) return (d / 2) * b * b * b * b * b + c;
    return (d / 2) * ((b -= 2) * b * b * b * b + 2) + c;
  },
  easeInSine: function (a, b, c, d, e) {
    return -d * Math.cos((b / e) * (Math.PI / 2)) + d + c;
  },
  easeOutSine: function (a, b, c, d, e) {
    return d * Math.sin((b / e) * (Math.PI / 2)) + c;
  },
  easeInOutSine: function (a, b, c, d, e) {
    return (-d / 2) * (Math.cos((Math.PI * b) / e) - 1) + c;
  },
  easeInExpo: function (a, b, c, d, e) {
    return b == 0 ? c : d * Math.pow(2, 10 * (b / e - 1)) + c;
  },
  easeOutExpo: function (a, b, c, d, e) {
    return b == e ? c + d : d * (-Math.pow(2, (-10 * b) / e) + 1) + c;
  },
  easeInOutExpo: function (a, b, c, d, e) {
    if (b == 0) return c;
    if (b == e) return c + d;
    if ((b /= e / 2) < 1) return (d / 2) * Math.pow(2, 10 * (b - 1)) + c;
    return (d / 2) * (-Math.pow(2, -10 * --b) + 2) + c;
  },
  easeInCirc: function (a, b, c, d, e) {
    return -d * (Math.sqrt(1 - (b /= e) * b) - 1) + c;
  },
  easeOutCirc: function (a, b, c, d, e) {
    return d * Math.sqrt(1 - (b = b / e - 1) * b) + c;
  },
  easeInOutCirc: function (a, b, c, d, e) {
    if ((b /= e / 2) < 1) return (-d / 2) * (Math.sqrt(1 - b * b) - 1) + c;
    return (d / 2) * (Math.sqrt(1 - (b -= 2) * b) + 1) + c;
  },
  easeInElastic: function (a, b, c, d, e) {
    var f = 1.70158;
    var g = 0;
    var h = d;
    if (b == 0) return c;
    if ((b /= e) == 1) return c + d;
    if (!g) g = e * 0.3;
    if (h < Math.abs(d)) {
      h = d;
      var f = g / 4;
    } else var f = (g / (2 * Math.PI)) * Math.asin(d / h);
    return (
      -(
        h *
        Math.pow(2, 10 * (b -= 1)) *
        Math.sin(((b * e - f) * 2 * Math.PI) / g)
      ) + c
    );
  },
  easeOutElastic: function (a, b, c, d, e) {
    var f = 1.70158;
    var g = 0;
    var h = d;
    if (b == 0) return c;
    if ((b /= e) == 1) return c + d;
    if (!g) g = e * 0.3;
    if (h < Math.abs(d)) {
      h = d;
      var f = g / 4;
    } else var f = (g / (2 * Math.PI)) * Math.asin(d / h);
    return (
      h * Math.pow(2, -10 * b) * Math.sin(((b * e - f) * 2 * Math.PI) / g) +
      d +
      c
    );
  },
  easeInOutElastic: function (a, b, c, d, e) {
    var f = 1.70158;
    var g = 0;
    var h = d;
    if (b == 0) return c;
    if ((b /= e / 2) == 2) return c + d;
    if (!g) g = e * 0.3 * 1.5;
    if (h < Math.abs(d)) {
      h = d;
      var f = g / 4;
    } else var f = (g / (2 * Math.PI)) * Math.asin(d / h);
    if (b < 1)
      return (
        -0.5 *
          h *
          Math.pow(2, 10 * (b -= 1)) *
          Math.sin(((b * e - f) * 2 * Math.PI) / g) +
        c
      );
    return (
      h *
        Math.pow(2, -10 * (b -= 1)) *
        Math.sin(((b * e - f) * 2 * Math.PI) / g) *
        0.5 +
      d +
      c
    );
  },
  easeInBack: function (a, b, c, d, e, f) {
    if (f == undefined) f = 1.70158;
    return d * (b /= e) * b * ((f + 1) * b - f) + c;
  },
  easeOutBack: function (a, b, c, d, e, f) {
    if (f == undefined) f = 1.70158;
    return d * ((b = b / e - 1) * b * ((f + 1) * b + f) + 1) + c;
  },
  easeInOutBack: function (a, b, c, d, e, f) {
    if (f == undefined) f = 1.70158;
    if ((b /= e / 2) < 1)
      return (d / 2) * b * b * (((f *= 1.525) + 1) * b - f) + c;
    return (d / 2) * ((b -= 2) * b * (((f *= 1.525) + 1) * b + f) + 2) + c;
  },
  easeInBounce: function (a, b, c, d, e) {
    return d - jQuery.easing.easeOutBounce(a, e - b, 0, d, e) + c;
  },
  easeOutBounce: function (a, b, c, d, e) {
    if ((b /= e) < 1 / 2.75) {
      return d * 7.5625 * b * b + c;
    } else if (b < 2 / 2.75) {
      return d * (7.5625 * (b -= 1.5 / 2.75) * b + 0.75) + c;
    } else if (b < 2.5 / 2.75) {
      return d * (7.5625 * (b -= 2.25 / 2.75) * b + 0.9375) + c;
    } else {
      return d * (7.5625 * (b -= 2.625 / 2.75) * b + 0.984375) + c;
    }
  },
  easeInOutBounce: function (a, b, c, d, e) {
    if (b < e / 2)
      return jQuery.easing.easeInBounce(a, b * 2, 0, d, e) * 0.5 + c;
    return (
      jQuery.easing.easeOutBounce(a, b * 2 - e, 0, d, e) * 0.5 + d * 0.5 + c
    );
  },
});

/*! Mousewheel by Brandon Aaron (http://brandon.aaron.sh) */
!(function (a) {
  "function" == typeof define && define.amd
    ? define(["jquery"], a)
    : "object" == typeof exports
    ? (module.exports = a)
    : a(jQuery);
})(function (a) {
  function b(b) {
    var g = b || window.event,
      h = i.call(arguments, 1),
      j = 0,
      l = 0,
      m = 0,
      n = 0,
      o = 0,
      p = 0;
    if (
      ((b = a.event.fix(g)),
      (b.type = "mousewheel"),
      "detail" in g && (m = -1 * g.detail),
      "wheelDelta" in g && (m = g.wheelDelta),
      "wheelDeltaY" in g && (m = g.wheelDeltaY),
      "wheelDeltaX" in g && (l = -1 * g.wheelDeltaX),
      "axis" in g && g.axis === g.HORIZONTAL_AXIS && ((l = -1 * m), (m = 0)),
      (j = 0 === m ? l : m),
      "deltaY" in g && ((m = -1 * g.deltaY), (j = m)),
      "deltaX" in g && ((l = g.deltaX), 0 === m && (j = -1 * l)),
      0 !== m || 0 !== l)
    ) {
      if (1 === g.deltaMode) {
        var q = a.data(this, "mousewheel-line-height");
        (j *= q), (m *= q), (l *= q);
      } else if (2 === g.deltaMode) {
        var r = a.data(this, "mousewheel-page-height");
        (j *= r), (m *= r), (l *= r);
      }
      if (
        ((n = Math.max(Math.abs(m), Math.abs(l))),
        (!f || f > n) && ((f = n), d(g, n) && (f /= 40)),
        d(g, n) && ((j /= 40), (l /= 40), (m /= 40)),
        (j = Math[j >= 1 ? "floor" : "ceil"](j / f)),
        (l = Math[l >= 1 ? "floor" : "ceil"](l / f)),
        (m = Math[m >= 1 ? "floor" : "ceil"](m / f)),
        k.settings.normalizeOffset && this.getBoundingClientRect)
      ) {
        var s = this.getBoundingClientRect();
        (o = b.clientX - s.left), (p = b.clientY - s.top);
      }
      return (
        (b.deltaX = l),
        (b.deltaY = m),
        (b.deltaFactor = f),
        (b.offsetX = o),
        (b.offsetY = p),
        (b.deltaMode = 0),
        h.unshift(b, j, l, m),
        e && clearTimeout(e),
        (e = setTimeout(c, 200)),
        (a.event.dispatch || a.event.handle).apply(this, h)
      );
    }
  }
  function c() {
    f = null;
  }
  function d(a, b) {
    return (
      k.settings.adjustOldDeltas && "mousewheel" === a.type && b % 120 === 0
    );
  }
  var e,
    f,
    g = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
    h =
      "onwheel" in document || document.documentMode >= 9
        ? ["wheel"]
        : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
    i = Array.prototype.slice;
  if (a.event.fixHooks)
    for (var j = g.length; j; ) a.event.fixHooks[g[--j]] = a.event.mouseHooks;
  var k = (a.event.special.mousewheel = {
    version: "3.1.12",
    setup: function () {
      if (this.addEventListener)
        for (var c = h.length; c; ) this.addEventListener(h[--c], b, !1);
      else this.onmousewheel = b;
      a.data(this, "mousewheel-line-height", k.getLineHeight(this)),
        a.data(this, "mousewheel-page-height", k.getPageHeight(this));
    },
    teardown: function () {
      if (this.removeEventListener)
        for (var c = h.length; c; ) this.removeEventListener(h[--c], b, !1);
      else this.onmousewheel = null;
      a.removeData(this, "mousewheel-line-height"),
        a.removeData(this, "mousewheel-page-height");
    },
    getLineHeight: function (b) {
      var c = a(b),
        d = c["offsetParent" in a.fn ? "offsetParent" : "parent"]();
      return (
        d.length || (d = a("body")),
        parseInt(d.css("fontSize"), 10) || parseInt(c.css("fontSize"), 10) || 16
      );
    },
    getPageHeight: function (b) {
      return a(b).height();
    },
    settings: { adjustOldDeltas: !0, normalizeOffset: !0 },
  });
  a.fn.extend({
    mousewheel: function (a) {
      return a ? this.bind("mousewheel", a) : this.trigger("mousewheel");
    },
    unmousewheel: function (a) {
      return this.unbind("mousewheel", a);
    },
  });
});

(function ($, window, document) {
  jQuery(document).ready(function ($) {
    /***************** Pretty Photo ******************/

    function prettyPhotoInit() {
      //add galleries to portfolios
      $(".portfolio-items").each(function () {
        var $unique_id = Math.floor(Math.random() * 10000);
        $(this)
          .find(".pretty_photo")
          .attr("rel", "prettyPhoto[" + $unique_id + "_gal]")
          .removeClass("pretty_photo");
      });

      $(
        "a[data-rel='prettyPhoto[product-gallery]'], a[data-rel='prettyPhoto']"
      ).each(function () {
        $(this).attr("rel", $(this).attr("data-rel"));
        $(this).removeAttr("data-rel");
      });

      //image gallery basic/nectar
      $(".wpb_gallery .wpb_flexslider").each(function () {
        var $unique_id = Math.floor(Math.random() * 10000);
        $(this)
          .find(".slides li a")
          .attr("rel", "prettyPhoto[" + $unique_id + "_gal]");
      });
      $(".wpb_gallery .wpb_gallery_slidesnectarslider_style").each(function () {
        var $unique_id = Math.floor(Math.random() * 10000);
        $(this)
          .find(".swiper-slide a:not(.ext-url-link)")
          .attr("rel", "prettyPhoto[" + $unique_id + "_gal]");
      });

      $(".wpb_gallery .wpb_gallery_slidesflickity_style").each(function () {
        var $unique_id = Math.floor(Math.random() * 10000);
        $(this)
          .find(".cell > a:not(.ext-url-link)")
          .attr("rel", "prettyPhoto[" + $unique_id + "_gal]");
      });

      $(".wpb_gallery .wpb_gallery_slidesparallax_image_grid").each(
        function () {
          var $unique_id = Math.floor(Math.random() * 10000);
          $(this)
            .find(".parallaxImg-layer a.pretty_photo:not(.ext-url-link)")
            .attr("rel", "prettyPhoto[" + $unique_id + "_gal]");
        }
      );

      //nectar auto lightbox
      if ($("body").hasClass("nectar-auto-lightbox")) {
        $(".gallery").each(function () {
          if ($(this).find('.gallery-icon a[rel^="prettyPhoto"]').length == 0) {
            var $unique_id = Math.floor(Math.random() * 10000);
            $(this)
              .find(
                '.gallery-item .gallery-icon a[href*=".jpg"], .gallery-item .gallery-icon a[href*=".png"], .gallery-item .gallery-icon a[href*=".gif"], .gallery-item .gallery-icon a[href*=".jpeg"]'
              )
              .attr("rel", "prettyPhoto[" + $unique_id + "_gal]")
              .removeClass("pretty_photo");
          }
        });
        $(".main-content img").each(function () {
          if (
            $(this).parent().is("[href]") &&
            !$(this).parent().is("[rel*='prettyPhoto']") &&
            $(this).parents(".product-image").length == 0 &&
            $(this).parents(".iosSlider.product-slider").length == 0
          ) {
            var match = $(this)
              .parent()
              .attr("href")
              .match(/\.(jpg|png|gif)\b/);
            if (match) $(this).parent().attr("rel", "prettyPhoto");
          }
        });
      }

      //convert class usage into rel
      $("a.pp").removeClass("pp").attr("rel", "prettyPhoto");

      var loading_animation =
        $("body[data-loading-animation]").attr("data-loading-animation") !=
        "none"
          ? $("body").attr("data-loading-animation")
          : null;
      var ascend_loader = $("body").hasClass("ascend")
        ? '<span class="default-loading-icon spin"></span>'
        : "";
      var ascend_loader_class = $("body").hasClass("ascend")
        ? "default_loader "
        : "";
      $("a[rel^='prettyPhoto']").prettyPhoto({
        theme: "dark_rounded",
        allow_resize: true,
        default_width: 1024,
        opacity: 0.85,
        animation_speed: "normal",
        deeplinking: false,
        default_height: 576,
        social_tools: "",
        markup:
          '<div class="pp_pic_holder"> \
						   <div class="ppt">&nbsp;</div> \
							<div class="pp_details"> \
								<div class="pp_nav"> \
								    <a href="#" class="pp_arrow_previous"> <i class="icon-salient-left-arrow-thin icon-default-style"></i> </a> \
									<a href="#" class="pp_arrow_next"> <i class="icon-salient-right-arrow-thin icon-default-style"></i> </a> \
									<p class="currentTextHolder">0/0</p> \
								</div> \
								<a class="pp_close" href="#"><span class="icon-salient-x icon-default-style"></span></a> \
							</div> \
							<div class="pp_content_container"> \
								<div class="pp_left"> \
								<div class="pp_right"> \
									<div class="pp_content"> \
										<div class="pp_fade"> \
											<div class="pp_hoverContainer"> \
											</div> \
											<div id="pp_full_res"></div> \
											<p class="pp_description"></p> \
										</div> \
									</div> \
								</div> \
								</div> \
							</div> \
						</div> \
						<div class="pp_loaderIcon ' +
          ascend_loader_class +
          loading_animation +
          '"> ' +
          ascend_loader +
          ' </div> \
						<div class="pp_overlay"></div>',
      });
    }

    function magnificInit() {
      //convert old pp links
      $("a.pp").removeClass("pp").addClass("magnific-popup");
      $(
        "a[rel^='prettyPhoto']:not([rel*='_gal']):not([rel*='product-gallery']):not([rel*='prettyPhoto['])"
      )
        .removeAttr("rel")
        .addClass("magnific-popup");

      //image gallery nectar
      $(".wpb_gallery .wpb_gallery_slidesnectarslider_style").each(function () {
        var $unique_id = Math.floor(Math.random() * 10000);
        $(this)
          .find(".swiper-slide a:not(.ext-url-link)")
          .addClass("pretty_photo");
      });

      //flex
      $(".wpb_gallery_slides.wpb_flexslider").each(function () {
        var $unique_id = Math.floor(Math.random() * 10000);
        $(this).find(".slides > li > a").addClass("pretty_photo");
      });
      //touch enabled gal
      $(".wpb_gallery_slidesflickity_style").each(function () {
        var $unique_id = Math.floor(Math.random() * 10000);
        $(this).find(".cell > a:not(.ext-url-link)").addClass("pretty_photo");
      });

      //add galleries to portfolios
      $(
        ".portfolio-items, .wpb_gallery .swiper-slide, .wpb_gallery_slidesflickity_style .cell, .wpb_gallery_slides.wpb_flexslider ul > li,  .wpb_gallery .parallax-grid-item"
      ).each(function () {
        if ($(this).find(".pretty_photo").length > 0) {
          $(this)
            .find(".pretty_photo")
            .removeClass("pretty_photo")
            .addClass("gallery")
            .addClass("magnific");
        } else if ($(this).find('a[rel*="prettyPhoto["]').length > 0) {
          $(this)
            .find('a[rel*="prettyPhoto["]')
            .removeAttr("rel")
            .addClass("gallery")
            .addClass("magnific");
        }
      });

      $("a[data-rel='prettyPhoto[product-gallery]']").each(function () {
        $(this).removeAttr("data-rel").addClass("magnific").addClass("gallery");
      });

      //nectar auto lightbox
      if ($("body").hasClass("nectar-auto-lightbox")) {
        $(".gallery").each(function () {
          if ($(this).find('.gallery-icon a[rel^="prettyPhoto"]').length == 0) {
            var $unique_id = Math.floor(Math.random() * 10000);
            $(this)
              .find(
                '.gallery-item .gallery-icon a[href*=".jpg"], .gallery-item .gallery-icon a[href*=".png"], .gallery-item .gallery-icon a[href*=".gif"], .gallery-item .gallery-icon a[href*=".jpeg"]'
              )
              .addClass("magnific")
              .addClass("gallery")
              .removeClass("pretty_photo");
          }
        });
        $(".main-content img").each(function () {
          if (
            $(this).parent().is("[href]") &&
            !$(this).parent().is(".magnific-popup") &&
            $(this).parents(".product-image").length == 0 &&
            $(this).parents(".iosSlider.product-slider").length == 0
          ) {
            var match = $(this)
              .parent()
              .attr("href")
              .match(/\.(jpg|png|gif)\b/);
            if (match)
              $(this)
                .parent()
                .addClass("magnific-popup")
                .addClass("image-link");
          }
        });
      }

      //regular
      $(
        "a.magnific-popup:not(.gallery):not(.nectar_video_lightbox)"
      ).magnificPopup({
        type: "image",
        callbacks: {
          imageLoadComplete: function () {
            var $that = this;
            setTimeout(function () {
              $that.wrap.addClass("mfp-image-loaded");
            }, 10);
          },
          beforeOpen: function () {
            this.st.image.markup = this.st.image.markup.replace(
              "mfp-figure",
              "mfp-figure mfp-with-anim"
            );
          },
          open: function () {
            $.magnificPopup.instance.next = function () {
              var $that = this;

              this.wrap.removeClass("mfp-image-loaded");
              setTimeout(function () {
                $.magnificPopup.proto.next.call($that);
              }, 100);
            };

            $.magnificPopup.instance.prev = function () {
              var $that = this;

              this.wrap.removeClass("mfp-image-loaded");
              setTimeout(function () {
                $.magnificPopup.proto.prev.call($that);
              }, 100);
            };
          },
        },
        fixedContentPos: false,
        mainClass: "mfp-zoom-in",
        removalDelay: 400,
      });

      //video
      $(
        "a.magnific-popup.nectar_video_lightbox, .swiper-slide a[href*=youtube], .swiper-slide a[href*=vimeo], .nectar-video-box > a.full-link.magnific-popup"
      ).magnificPopup({
        type: "iframe",
        fixedContentPos: false,
        mainClass: "mfp-zoom-in",
        removalDelay: 400,
      });

      //galleries
      $("a.magnific.gallery").each(function () {
        var $parentRow =
          $(this).closest(".wpb_column").length > 0
            ? $(this).closest(".wpb_column")
            : $(this).parents(".row");
        if ($parentRow.length > 0 && !$parentRow.hasClass("lightbox-col")) {
          $parentRow.magnificPopup({
            type: "image",
            delegate: "a.magnific",
            mainClass: "mfp-zoom-in",
            fixedContentPos: false,
            callbacks: {
              elementParse: function (item) {
                if (
                  $(item.el.context).is("[href]") &&
                  $(item.el.context).attr("href").indexOf("iframe=true") != -1
                ) {
                  item.type = "iframe";
                } else {
                  item.type = "image";
                }
              },

              imageLoadComplete: function () {
                var $that = this;
                setTimeout(function () {
                  $that.wrap.addClass("mfp-image-loaded");
                }, 10);
              },

              beforeOpen: function () {
                this.st.image.markup = this.st.image.markup.replace(
                  "mfp-figure",
                  "mfp-figure mfp-with-anim"
                );
              },

              open: function () {
                $.magnificPopup.instance.next = function () {
                  var $that = this;

                  this.wrap.removeClass("mfp-image-loaded");
                  setTimeout(function () {
                    $.magnificPopup.proto.next.call($that);
                  }, 100);
                };

                $.magnificPopup.instance.prev = function () {
                  var $that = this;

                  this.wrap.removeClass("mfp-image-loaded");
                  setTimeout(function () {
                    $.magnificPopup.proto.prev.call($that);
                  }, 100);
                };
              },
            },
            removalDelay: 400,
            gallery: {
              enabled: true,
            },
          });

          $parentRow.addClass("lightbox-col");
        }
      });
    }

    function lightBoxInit() {
      if ($('body[data-ls="pretty_photo"]').length > 0) {
        prettyPhotoInit();
      } else if ($('body[data-ls="magnific"]').length > 0) {
        magnificInit();
      }
    }

    lightBoxInit();
    //check for late links
    setTimeout(lightBoxInit, 500);

    /*!
     * jQuery Transit - CSS3 transitions and transformations
     * (c) 2011-2012 Rico Sta. Cruz <rico@ricostacruz.com>
     * MIT Licensed.
     *
     * http://ricostacruz.com/jquery.transit
     * http://github.com/rstacruz/jquery.transit
     */
    (function (k) {
      k.transit = {
        version: "0.9.9",
        propertyMap: {
          marginLeft: "margin",
          marginRight: "margin",
          marginBottom: "margin",
          marginTop: "margin",
          paddingLeft: "padding",
          paddingRight: "padding",
          paddingBottom: "padding",
          paddingTop: "padding",
        },
        enabled: true,
        useTransitionEnd: false,
      };
      var d = document.createElement("div");
      var q = {};
      function b(v) {
        if (v in d.style) {
          return v;
        }
        var u = ["Moz", "Webkit", "O", "ms"];
        var r = v.charAt(0).toUpperCase() + v.substr(1);
        if (v in d.style) {
          return v;
        }
        for (var t = 0; t < u.length; ++t) {
          var s = u[t] + r;
          if (s in d.style) {
            return s;
          }
        }
      }
      function e() {
        d.style[q.transform] = "";
        d.style[q.transform] = "rotateY(90deg)";
        return d.style[q.transform] !== "";
      }
      var a = navigator.userAgent.toLowerCase().indexOf("chrome") > -1;
      q.transition = b("transition");
      q.transitionDelay = b("transitionDelay");
      q.transform = b("transform");
      q.transformOrigin = b("transformOrigin");
      q.transform3d = e();
      var i = {
        transition: "transitionEnd",
        MozTransition: "transitionend",
        OTransition: "oTransitionEnd",
        WebkitTransition: "webkitTransitionEnd",
        msTransition: "MSTransitionEnd",
      };
      var f = (q.transitionEnd = i[q.transition] || null);
      for (var p in q) {
        if (q.hasOwnProperty(p) && typeof k.support[p] === "undefined") {
          k.support[p] = q[p];
        }
      }
      d = null;
      k.cssEase = {
        _default: "ease",
        in: "ease-in",
        out: "ease-out",
        "in-out": "ease-in-out",
        snap: "cubic-bezier(0,1,.5,1)",
        easeOutCubic: "cubic-bezier(.215,.61,.355,1)",
        easeInOutCubic: "cubic-bezier(.645,.045,.355,1)",
        easeInCirc: "cubic-bezier(.6,.04,.98,.335)",
        easeOutCirc: "cubic-bezier(.075,.82,.165,1)",
        easeInOutCirc: "cubic-bezier(.785,.135,.15,.86)",
        easeInExpo: "cubic-bezier(.95,.05,.795,.035)",
        easeOutExpo: "cubic-bezier(.19,1,.22,1)",
        easeInOutExpo: "cubic-bezier(1,0,0,1)",
        easeInQuad: "cubic-bezier(.55,.085,.68,.53)",
        easeOutQuad: "cubic-bezier(.25,.46,.45,.94)",
        easeInOutQuad: "cubic-bezier(.455,.03,.515,.955)",
        easeInQuart: "cubic-bezier(.895,.03,.685,.22)",
        easeOutQuart: "cubic-bezier(.165,.84,.44,1)",
        easeInOutQuart: "cubic-bezier(.77,0,.175,1)",
        easeInQuint: "cubic-bezier(.755,.05,.855,.06)",
        easeOutQuint: "cubic-bezier(.23,1,.32,1)",
        easeInOutQuint: "cubic-bezier(.86,0,.07,1)",
        easeInSine: "cubic-bezier(.47,0,.745,.715)",
        easeOutSine: "cubic-bezier(.39,.575,.565,1)",
        easeInOutSine: "cubic-bezier(.445,.05,.55,.95)",
        easeInBack: "cubic-bezier(.6,-.28,.735,.045)",
        easeOutBack: "cubic-bezier(.175, .885,.32,1.275)",
        easeInOutBack: "cubic-bezier(.68,-.55,.265,1.55)",
      };
      k.cssHooks["transit:transform"] = {
        get: function (r) {
          return k(r).data("transform") || new j();
        },
        set: function (s, r) {
          var t = r;
          if (!(t instanceof j)) {
            t = new j(t);
          }
          if (q.transform === "WebkitTransform" && !a) {
            s.style[q.transform] = t.toString(true);
          } else {
            s.style[q.transform] = t.toString();
          }
          k(s).data("transform", t);
        },
      };
      k.cssHooks.transform = { set: k.cssHooks["transit:transform"].set };
      if (k.fn.jquery < "1.8") {
        k.cssHooks.transformOrigin = {
          get: function (r) {
            return r.style[q.transformOrigin];
          },
          set: function (r, s) {
            r.style[q.transformOrigin] = s;
          },
        };
        k.cssHooks.transition = {
          get: function (r) {
            return r.style[q.transition];
          },
          set: function (r, s) {
            r.style[q.transition] = s;
          },
        };
      }
      n("scale");
      n("translate");
      n("rotate");
      n("rotateX");
      n("rotateY");
      n("rotate3d");
      n("perspective");
      n("skewX");
      n("skewY");
      n("x", true);
      n("y", true);
      function j(r) {
        if (typeof r === "string") {
          this.parse(r);
        }
        return this;
      }
      j.prototype = {
        setFromString: function (t, s) {
          var r =
            typeof s === "string"
              ? s.split(",")
              : s.constructor === Array
              ? s
              : [s];
          r.unshift(t);
          j.prototype.set.apply(this, r);
        },
        set: function (s) {
          var r = Array.prototype.slice.apply(arguments, [1]);
          if (this.setter[s]) {
            this.setter[s].apply(this, r);
          } else {
            this[s] = r.join(",");
          }
        },
        get: function (r) {
          if (this.getter[r]) {
            return this.getter[r].apply(this);
          } else {
            return this[r] || 0;
          }
        },
        setter: {
          rotate: function (r) {
            this.rotate = o(r, "deg");
          },
          rotateX: function (r) {
            this.rotateX = o(r, "deg");
          },
          rotateY: function (r) {
            this.rotateY = o(r, "deg");
          },
          scale: function (r, s) {
            if (s === undefined) {
              s = r;
            }
            this.scale = r + "," + s;
          },
          skewX: function (r) {
            this.skewX = o(r, "deg");
          },
          skewY: function (r) {
            this.skewY = o(r, "deg");
          },
          perspective: function (r) {
            this.perspective = o(r, "px");
          },
          x: function (r) {
            this.set("translate", r, null);
          },
          y: function (r) {
            this.set("translate", null, r);
          },
          translate: function (r, s) {
            if (this._translateX === undefined) {
              this._translateX = 0;
            }
            if (this._translateY === undefined) {
              this._translateY = 0;
            }
            if (r !== null && r !== undefined) {
              this._translateX = o(r, "px");
            }
            if (s !== null && s !== undefined) {
              this._translateY = o(s, "px");
            }
            this.translate = this._translateX + "," + this._translateY;
          },
        },
        getter: {
          x: function () {
            return this._translateX || 0;
          },
          y: function () {
            return this._translateY || 0;
          },
          scale: function () {
            var r = (this.scale || "1,1").split(",");
            if (r[0]) {
              r[0] = parseFloat(r[0]);
            }
            if (r[1]) {
              r[1] = parseFloat(r[1]);
            }
            return r[0] === r[1] ? r[0] : r;
          },
          rotate3d: function () {
            var t = (this.rotate3d || "0,0,0,0deg").split(",");
            for (var r = 0; r <= 3; ++r) {
              if (t[r]) {
                t[r] = parseFloat(t[r]);
              }
            }
            if (t[3]) {
              t[3] = o(t[3], "deg");
            }
            return t;
          },
        },
        parse: function (s) {
          var r = this;
          s.replace(/([a-zA-Z0-9]+)\((.*?)\)/g, function (t, v, u) {
            r.setFromString(v, u);
          });
        },
        toString: function (t) {
          var s = [];
          for (var r in this) {
            if (this.hasOwnProperty(r)) {
              if (
                !q.transform3d &&
                (r === "rotateX" ||
                  r === "rotateY" ||
                  r === "perspective" ||
                  r === "transformOrigin")
              ) {
                continue;
              }
              if (r[0] !== "_") {
                if (t && r === "scale") {
                  s.push(r + "3d(" + this[r] + ",1)");
                } else {
                  if (t && r === "translate") {
                    s.push(r + "3d(" + this[r] + ",0)");
                  } else {
                    s.push(r + "(" + this[r] + ")");
                  }
                }
              }
            }
          }
          return s.join(" ");
        },
      };
      function m(s, r, t) {
        if (r === true) {
          s.queue(t);
        } else {
          if (r) {
            s.queue(r, t);
          } else {
            t();
          }
        }
      }
      function h(s) {
        var r = [];
        k.each(s, function (t) {
          t = k.camelCase(t);
          t = k.transit.propertyMap[t] || k.cssProps[t] || t;
          t = c(t);
          if (k.inArray(t, r) === -1) {
            r.push(t);
          }
        });
        return r;
      }
      function g(s, v, x, r) {
        var t = h(s);
        if (k.cssEase[x]) {
          x = k.cssEase[x];
        }
        var w = "" + l(v) + " " + x;
        if (parseInt(r, 10) > 0) {
          w += " " + l(r);
        }
        var u = [];
        k.each(t, function (z, y) {
          u.push(y + " " + w);
        });
        return u.join(", ");
      }
      k.fn.transition = k.fn.transit = function (z, s, y, C) {
        var D = this;
        var u = 0;
        var w = true;
        if (typeof s === "function") {
          C = s;
          s = undefined;
        }
        if (typeof y === "function") {
          C = y;
          y = undefined;
        }
        if (typeof z.easing !== "undefined") {
          y = z.easing;
          delete z.easing;
        }
        if (typeof z.duration !== "undefined") {
          s = z.duration;
          delete z.duration;
        }
        if (typeof z.complete !== "undefined") {
          C = z.complete;
          delete z.complete;
        }
        if (typeof z.queue !== "undefined") {
          w = z.queue;
          delete z.queue;
        }
        if (typeof z.delay !== "undefined") {
          u = z.delay;
          delete z.delay;
        }
        if (typeof s === "undefined") {
          s = k.fx.speeds._default;
        }
        if (typeof y === "undefined") {
          y = k.cssEase._default;
        }
        s = l(s);
        var E = g(z, s, y, u);
        var B = k.transit.enabled && q.transition;
        var t = B ? parseInt(s, 10) + parseInt(u, 10) : 0;
        if (t === 0) {
          var A = function (F) {
            D.css(z);
            if (C) {
              C.apply(D);
            }
            if (F) {
              F();
            }
          };
          m(D, w, A);
          return D;
        }
        var x = {};
        var r = function (H) {
          var G = false;
          var F = function () {
            if (G) {
              D.unbind(f, F);
            }
            if (t > 0) {
              D.each(function () {
                this.style[q.transition] = x[this] || null;
              });
            }
            if (typeof C === "function") {
              C.apply(D);
            }
            if (typeof H === "function") {
              H();
            }
          };
          if (t > 0 && f && k.transit.useTransitionEnd) {
            G = true;
            D.bind(f, F);
          } else {
            window.setTimeout(F, t);
          }
          D.each(function () {
            if (t > 0) {
              this.style[q.transition] = E;
            }
            k(this).css(z);
          });
        };
        var v = function (F) {
          this.offsetWidth;
          r(F);
        };
        m(D, w, v);
        return this;
      };
      function n(s, r) {
        if (!r) {
          k.cssNumber[s] = true;
        }
        k.transit.propertyMap[s] = q.transform;
        k.cssHooks[s] = {
          get: function (v) {
            var u = k(v).css("transit:transform");
            return u.get(s);
          },
          set: function (v, w) {
            var u = k(v).css("transit:transform");
            u.setFromString(s, w);
            k(v).css({ "transit:transform": u });
          },
        };
      }
      function c(r) {
        return r.replace(/([A-Z])/g, function (s) {
          return "-" + s.toLowerCase();
        });
      }
      function o(s, r) {
        if (typeof s === "string" && !s.match(/^[\-0-9\.]+$/)) {
          return s;
        } else {
          return "" + s + r;
        }
      }
      function l(s) {
        var r = s;
        if (k.fx.speeds[r]) {
          r = k.fx.speeds[r];
        }
        return o(r, "ms");
      }
      k.transit.getTransitionValue = g;
    })(jQuery);

    // ========================= smartresize ===============================

    /*
     * smartresize: debounced resize event for jQuery
     *
     * latest version and complete README available on Github:
     * https://github.com/louisremi/jquery.smartresize.js
     *
     * Copyright 2011 @louis_remi
     * Licensed under the MIT license.
     */

    var $event = $.event,
      dispatchMethod = $.event.handle ? "handle" : "dispatch",
      resizeTimeout;

    $event.special.smartresize = {
      setup: function () {
        $(this).bind("resize", $event.special.smartresize.handler);
      },
      teardown: function () {
        $(this).unbind("resize", $event.special.smartresize.handler);
      },
      handler: function (event, execAsap) {
        // Save the context
        var context = this,
          args = arguments;

        // set correct event type
        event.type = "smartresize";

        if (resizeTimeout) {
          clearTimeout(resizeTimeout);
        }
        resizeTimeout = setTimeout(
          function () {
            $event[dispatchMethod].apply(context, args);
          },
          execAsap === "execAsap" ? 0 : 100
        );
      },
    };

    $.fn.smartresize = function (fn) {
      return fn
        ? this.bind("smartresize", fn)
        : this.trigger("smartresize", ["execAsap"]);
    };

    /***************** Global vars ******************/
    var $standAnimatedColTimeout = [];
    var $animatedSVGIconTimeout = [];
    var $svg_icons = [];

    /***************** Smooth Scrolling ******************/

    function niceScrollInit() {
      $("html").niceScroll({
        scrollspeed: 60,
        mousescrollstep: 40,
        cursorwidth: 15,
        cursorborder: 0,
        cursorcolor: "#303030",
        cursorborderradius: 6,
        autohidemode: false,
        horizrailenabled: false,
      });

      if ($("#boxed").length == 0) {
        $(
          "body, body #header-outer, body #header-secondary-outer, body #search-outer"
        ).css("padding-right", "16px");
      } else if ($('body[data-ext-responsive="true"]').length == 0) {
        $("body").css("padding-right", "16px");
      }

      $("html").addClass("no-overflow-y");
    }

    var $smoothActive = $("body").attr("data-smooth-scrolling");
    var $smoothCache = $smoothActive == 1 ? true : false;

    if (
      $smoothActive == 1 &&
      $(window).width() > 690 &&
      $("body").outerHeight(true) > $(window).height() &&
      Modernizr.csstransforms3d &&
      !navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/
      )
    ) {
      niceScrollInit();
    } else {
      $("body").attr("data-smooth-scrolling", "0");
    }

    //chrome ss
    if (
      $smoothCache == false &&
      navigator.platform.toUpperCase().indexOf("MAC") === -1 &&
      !navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/
      ) &&
      $(window).width() > 690 &&
      $("#nectar_fullscreen_rows").length == 0
    ) {
      !(function () {
        function e() {
          var e = !1;
          e && c("keydown", r), v.keyboardSupport && !e && u("keydown", r);
        }
        function t() {
          if (document.body) {
            var t = document.body,
              n = document.documentElement,
              o = window.innerHeight,
              r = t.scrollHeight;
            if (
              ((S = document.compatMode.indexOf("CSS") >= 0 ? n : t),
              (w = t),
              e(),
              (x = !0),
              top != self)
            )
              y = !0;
            else if (r > o && (t.offsetHeight <= o || n.offsetHeight <= o)) {
              var a = !1,
                i = function () {
                  a ||
                    n.scrollHeight == document.height ||
                    ((a = !0),
                    setTimeout(function () {
                      (n.style.height = document.height + "px"), (a = !1);
                    }, 500));
                };
              if (
                ((n.style.height = "auto"),
                setTimeout(i, 10),
                S.offsetHeight <= o)
              ) {
                var l = document.createElement("div");
                (l.style.clear = "both"), t.appendChild(l);
              }
            }
            v.fixedBackground ||
              b ||
              ((t.style.backgroundAttachment = "scroll"),
              (n.style.backgroundAttachment = "scroll"));
          }
        }
        function n(e, t, n, o) {
          if ((o || (o = 1e3), d(t, n), 1 != v.accelerationMax)) {
            var r = +new Date(),
              a = r - C;
            if (a < v.accelerationDelta) {
              var i = (1 + 30 / a) / 2;
              i > 1 &&
                ((i = Math.min(i, v.accelerationMax)), (t *= i), (n *= i));
            }
            C = +new Date();
          }
          if (
            (M.push({
              x: t,
              y: n,
              lastX: 0 > t ? 0.99 : -0.99,
              lastY: 0 > n ? 0.99 : -0.99,
              start: +new Date(),
            }),
            !T)
          ) {
            var l = e === document.body,
              u = function () {
                for (
                  var r = +new Date(), a = 0, i = 0, c = 0;
                  c < M.length;
                  c++
                ) {
                  var s = M[c],
                    d = r - s.start,
                    f = d >= v.animationTime,
                    h = f ? 1 : d / v.animationTime;
                  v.pulseAlgorithm && (h = p(h));
                  var m = (s.x * h - s.lastX) >> 0,
                    w = (s.y * h - s.lastY) >> 0;
                  (a += m),
                    (i += w),
                    (s.lastX += m),
                    (s.lastY += w),
                    f && (M.splice(c, 1), c--);
                }
                l
                  ? window.scrollBy(a, i)
                  : (a && (e.scrollLeft += a), i && (e.scrollTop += i)),
                  t || n || (M = []),
                  M.length ? N(u, e, o / v.frameRate + 1) : (T = !1);
              };
            N(u, e, 0), (T = !0);
          }
        }
        function o(e) {
          x || t();
          var o = e.target,
            r = l(o);
          if (
            !r ||
            e.defaultPrevented ||
            s(w, "embed") ||
            (s(o, "embed") && /\.pdf/i.test(o.src))
          )
            return !0;
          var a = e.wheelDeltaX || 0,
            i = e.wheelDeltaY || 0;
          return (
            a || i || (i = e.wheelDelta || 0),
            !v.touchpadSupport && f(i)
              ? !0
              : (Math.abs(a) > 1.2 && (a *= v.stepSize / 120),
                Math.abs(i) > 1.2 && (i *= v.stepSize / 120),
                n(r, -a, -i),
                void e.preventDefault())
          );
        }
        function r(e) {
          var t = e.target,
            o =
              e.ctrlKey ||
              e.altKey ||
              e.metaKey ||
              (e.shiftKey && e.keyCode !== H.spacebar);
          if (
            /input|textarea|select|embed/i.test(t.nodeName) ||
            t.isContentEditable ||
            e.defaultPrevented ||
            o
          )
            return !0;
          if (s(t, "button") && e.keyCode === H.spacebar) return !0;
          var r,
            a = 0,
            i = 0,
            u = l(w),
            c = u.clientHeight;
          switch ((u == document.body && (c = window.innerHeight), e.keyCode)) {
            case H.up:
              i = -v.arrowScroll;
              break;
            case H.down:
              i = v.arrowScroll;
              break;
            case H.spacebar:
              (r = e.shiftKey ? 1 : -1), (i = -r * c * 0.9);
              break;
            case H.pageup:
              i = 0.9 * -c;
              break;
            case H.pagedown:
              i = 0.9 * c;
              break;
            case H.home:
              i = -u.scrollTop;
              break;
            case H.end:
              var d = u.scrollHeight - u.scrollTop - c;
              i = d > 0 ? d + 10 : 0;
              break;
            case H.left:
              a = -v.arrowScroll;
              break;
            case H.right:
              a = v.arrowScroll;
              break;
            default:
              return !0;
          }
          n(u, a, i), e.preventDefault();
        }
        function a(e) {
          w = e.target;
        }
        function i(e, t) {
          for (var n = e.length; n--; ) E[A(e[n])] = t;
          return t;
        }
        function l(e) {
          var t = [],
            n = S.scrollHeight;
          do {
            var o = E[A(e)];
            if (o) return i(t, o);
            if ((t.push(e), n === e.scrollHeight)) {
              if (!y || S.clientHeight + 10 < n) return i(t, document.body);
            } else if (
              e.clientHeight + 10 < e.scrollHeight &&
              ((overflow = getComputedStyle(e, "").getPropertyValue(
                "overflow-y"
              )),
              "scroll" === overflow || "auto" === overflow)
            )
              return i(t, e);
          } while ((e = e.parentNode));
        }
        function u(e, t, n) {
          window.addEventListener(e, t, n || !1);
        }
        function c(e, t, n) {
          window.removeEventListener(e, t, n || !1);
        }
        function s(e, t) {
          return (e.nodeName || "").toLowerCase() === t.toLowerCase();
        }
        function d(e, t) {
          (e = e > 0 ? 1 : -1),
            (t = t > 0 ? 1 : -1),
            (k.x !== e || k.y !== t) &&
              ((k.x = e), (k.y = t), (M = []), (C = 0));
        }
        function f(e) {
          if (e) {
            (e = Math.abs(e)), D.push(e), D.shift(), clearTimeout(z);
            var t = h(D[0], 120) && h(D[1], 120) && h(D[2], 120);
            return !t;
          }
        }
        function h(e, t) {
          return Math.floor(e / t) == e / t;
        }
        function m(e) {
          var t, n, o;
          return (
            (e *= v.pulseScale),
            1 > e
              ? (t = e - (1 - Math.exp(-e)))
              : ((n = Math.exp(-1)),
                (e -= 1),
                (o = 1 - Math.exp(-e)),
                (t = n + o * (1 - n))),
            t * v.pulseNormalize
          );
        }
        function p(e) {
          return e >= 1
            ? 1
            : 0 >= e
            ? 0
            : (1 == v.pulseNormalize && (v.pulseNormalize /= m(1)), m(e));
        }
        var w,
          g = {
            frameRate: 150,
            animationTime: 500,
            stepSize: 120,
            pulseAlgorithm: !0,
            pulseScale: 8,
            pulseNormalize: 1,
            accelerationDelta: 20,
            accelerationMax: 1,
            keyboardSupport: !0,
            arrowScroll: 50,
            touchpadSupport: !0,
            fixedBackground: !0,
            excluded: "",
          },
          v = g,
          b = !1,
          y = !1,
          k = { x: 0, y: 0 },
          x = !1,
          S = document.documentElement,
          D = [120, 120, 120],
          H = {
            left: 37,
            up: 38,
            right: 39,
            down: 40,
            spacebar: 32,
            pageup: 33,
            pagedown: 34,
            end: 35,
            home: 36,
          },
          v = g,
          M = [],
          T = !1,
          C = +new Date(),
          E = {};
        setInterval(function () {
          E = {};
        }, 1e4);
        var z,
          A = (function () {
            var e = 0;
            return function (t) {
              return t.uniqueID || (t.uniqueID = e++);
            };
          })(),
          N = (function () {
            return (
              window.requestAnimationFrame ||
              window.webkitRequestAnimationFrame ||
              function (e, t, n) {
                window.setTimeout(e, n || 1e3 / 60);
              }
            );
          })(),
          K = /chrome/i.test(window.navigator.userAgent),
          L = null;
        "onwheel" in document.createElement("div")
          ? (L = "wheel")
          : "onmousewheel" in document.createElement("div") &&
            (L = "mousewheel"),
          L && K && (u(L, o), u("mousedown", a), u("load", t));
      })();
    }

    /***************** Sliders ******************/

    //gallery
    function flexsliderInit() {
      $(".flex-gallery").each(function () {
        var $that = $(this);

        imagesLoaded($(this), function (instance) {
          $that.flexslider({
            animation: "fade",
            smoothHeight: false,
            animationSpeed: 500,
            useCSS: false,
            touch: true,
          });

          ////gallery slider add arrows
          $(".flex-gallery .flex-direction-nav li a.flex-next").html(
            '<i class="fa fa-angle-right"></i>'
          );
          $(".flex-gallery .flex-direction-nav li a.flex-prev").html(
            '<i class="fa fa-angle-left"></i>'
          );
        });
      });
    }
    flexsliderInit();

    function flickityInit() {
      if ($(".nectar-flickity:not(.masonry)").length == 0) return false;

      var $flickitySliders = [];

      $(".nectar-flickity:not(.masonry)").each(function (i) {
        var $freeScrollBool =
          $(this).is("[data-free-scroll]") &&
          $(this).attr("data-free-scroll") == "true"
            ? true
            : false;
        var $groupCellsBool = true;

        if ($freeScrollBool == true) {
          $groupCellsBool = false;
        }

        if (
          $(this).attr("data-controls").length > 0 &&
          $(this).attr("data-controls") == "next_prev_arrows"
        ) {
          var $paginationBool = false;
          var $nextPrevArrowBool = true;
        } else {
          var $paginationBool = true;
          var $nextPrevArrowBool = false;
        }

        if (
          $(this).attr("data-controls").length > 0 &&
          $(this).attr("data-controls") == "none"
        ) {
          var $paginationBool = false;
          var $nextPrevArrowBool = false;
        }

        var $flickity_autoplay = false;
        var $selectedAttraction = 0.025;

        if (
          $(this).is("[data-autoplay]") &&
          $(this).attr("data-autoplay") == "true"
        ) {
          $flickity_autoplay = true;
          $selectedAttraction = 0.019;

          if (
            $(this).is("[data-autoplay-dur]") &&
            $(this).attr("data-autoplay-dur").length > 0
          ) {
            if (
              parseInt($(this).attr("data-autoplay-dur")) > 100 &&
              parseInt($(this).attr("data-autoplay-dur")) < 30000
            ) {
              $flickity_autoplay = parseInt($(this).attr("data-autoplay-dur"));
            }
          }
        }

        var $that = $(this);

        $flickitySliders[i] = $(this).flickity({
          contain: true,
          draggable: true,
          lazyLoad: false,
          imagesLoaded: true,
          percentPosition: true,
          selectedAttraction: $selectedAttraction,
          groupCells: $groupCellsBool,
          prevNextButtons: $nextPrevArrowBool,
          freeScroll: $freeScrollBool,
          pageDots: $paginationBool,
          resize: true,
          autoPlay: $flickity_autoplay,
          pauseAutoPlayOnHover: false,
          setGallerySize: true,
          wrapAround: true,
          accessibility: false,
          arrowShape: {
            x0: 20,
            x1: 70,
            y1: 30,
            x2: 70,
            y2: 25,
            x3: 70,
          },
        });

        var $removeHiddenTimeout;

        $flickitySliders[i].on("dragStart.flickity", function () {
          clearTimeout($removeHiddenTimeout);
          $that.find(".flickity-prev-next-button").addClass("hidden");
        });
        $flickitySliders[i].on("dragEnd.flickity", function () {
          $removeHiddenTimeout = setTimeout(function () {
            $that.find(".flickity-prev-next-button").removeClass("hidden");
          }, 600);
        });

        $(".flickity-prev-next-button").on("click", function () {
          clearTimeout($removeHiddenTimeout);
          $(this)
            .parents(".nectar-flickity")
            .find(".flickity-prev-next-button")
            .addClass("hidden");
          $removeHiddenTimeout = setTimeout(function () {
            $that.find(".flickity-prev-next-button").removeClass("hidden");
          }, 600);
        });
      });
    }
    setTimeout(flickityInit, 100);

    function flickityBlogInit() {
      if ($(".nectar-flickity.masonry.not-initialized").length == 0)
        return false;

      $(".nectar-flickity.masonry.not-initialized").each(function () {
        //move pos for large_featured
        if ($(this).parents("article").hasClass("large_featured"))
          $(this).insertBefore(
            $(this).parents("article").find(".content-inner")
          );
      });

      $(".nectar-flickity.masonry.not-initialized").flickity({
        contain: true,
        draggable: false,
        lazyLoad: false,
        imagesLoaded: true,
        percentPosition: true,
        prevNextButtons: true,
        pageDots: false,
        resize: true,
        setGallerySize: true,
        wrapAround: true,
        accessibility: false,
      });

      $(".nectar-flickity.masonry").removeClass("not-initialized");

      //add count
      $(".nectar-flickity.masonry:not(.not-initialized)").each(function () {
        if ($(this).find(".item-count").length == 0) {
          $('<div class="item-count"/>').insertBefore(
            $(this).find(".flickity-prev-next-button.next")
          );
          $(this)
            .find(".item-count")
            .html(
              '<span class="current">1</span>/<span class="total">' +
                $(this).find(".flickity-slider .cell").length +
                "</span>"
            );

          $(this)
            .find(".flickity-prev-next-button, .item-count")
            .wrapAll('<div class="control-wrap" />');

          //move pos for wide_tall
          if ($(this).parents("article").hasClass("wide_tall"))
            $(this).find(".control-wrap").insertBefore($(this));
        }
      });

      //update count
      $(
        ".masonry .flickity-prev-next-button.previous,  .masonry .flickity-prev-next-button.next"
      ).click(function () {
        if ($(this).parents(".wide_tall").length > 0)
          $(this)
            .parent()
            .find(".item-count .current")
            .html(
              $(this)
                .parents("article")
                .find(".nectar-flickity .cell.is-selected")
                .index() + 1
            );
        else
          $(this)
            .parent()
            .find(".item-count .current")
            .html(
              $(this)
                .parents(".nectar-flickity")
                .find(".cell.is-selected")
                .index() + 1
            );
      });

      $("body").on("mouseover", ".flickity-prev-next-button.next", function () {
        $(this)
          .parent()
          .find(".flickity-prev-next-button.previous, .item-count")
          .addClass("next-hovered");
      });
      $("body").on(
        "mouseleave",
        ".flickity-prev-next-button.next",
        function () {
          $(this)
            .parent()
            .find(".flickity-prev-next-button.previous, .item-count")
            .removeClass("next-hovered");
        }
      );
    }
    /****************twenty twenty******************/
    $(".twentytwenty-container").each(function () {
      var $that = $(this);
      $(this).imagesLoaded(function () {
        $that.twentytwenty();
      });
    });

    /****************full page******************/
    var $usingFullScreenRows = false;
    var $fullscreenSelector = "";
    var $disableFPonMobile =
      $("#nectar_fullscreen_rows[data-mobile-disable]").length > 0
        ? $("#nectar_fullscreen_rows").attr("data-mobile-disable")
        : "off";
    var $onMobileBrowser = navigator.userAgent.match(
      /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
    );

    if (!$onMobileBrowser) $disableFPonMobile = "off";

    //change anchor link IDs for when disabled on mobile
    if ($disableFPonMobile == "on" && $("#nectar_fullscreen_rows").length > 0) {
      $("#nectar_fullscreen_rows > .wpb_row[data-fullscreen-anchor-id]").each(
        function () {
          if ($(this).attr("data-fullscreen-anchor-id").length > 0)
            $(this).attr("id", $(this).attr("data-fullscreen-anchor-id"));
        }
      );

      //remove main content row padding
      $(".container-wrap .main-content > .row").css({ "padding-bottom": "0" });

      //extra padding for first row is using transparent header
      if (
        $("#nectar_fullscreen_rows > .wpb_row:nth-child(1)").length > 0 &&
        $('#header-outer[data-transparent-header="true"]').length > 0 &&
        !$("#nectar_fullscreen_rows > .wpb_row:nth-child(1)").hasClass(
          "full-width-content"
        )
      ) {
        $("#nectar_fullscreen_rows > .wpb_row:nth-child(1)").addClass(
          "extra-top-padding"
        );
      }
    }

    if (
      ($("#nectar_fullscreen_rows").length > 0 && $disableFPonMobile != "on") ||
      ($().fullpage && $disableFPonMobile != "on")
    ) {
      function setFPNavColoring(index, direction) {
        if ($("#boxed").length > 0 && overallWidth > 750) return;

        if (
          $("#nectar_fullscreen_rows > .wpb_row:nth-child(" + index + ")").find(
            ".span_12.light"
          ).length > 0
        ) {
          $("#fp-nav").addClass("light-controls");

          if (direction == "up")
            $("#header-outer.dark-slide").removeClass("dark-slide");
          else
            setTimeout(function () {
              $("#header-outer.dark-slide").removeClass("dark-slide");
            }, 520);
        } else {
          $("#fp-nav.light-controls").removeClass("light-controls");

          if (direction == "up") $("#header-outer").addClass("dark-slide");
          else
            setTimeout(function () {
              $("#header-outer").addClass("dark-slide");
            }, 520);
        }
      }

      var $anchors = [];
      var $names = [];

      function setFPNames() {
        $anchors = [];
        $names = [];
        $("#nectar_fullscreen_rows > .wpb_row").each(function (i) {
          $id = $(this).is("[data-fullscreen-anchor-id]")
            ? $(this).attr("data-fullscreen-anchor-id")
            : "";

          //anchor checks
          if ($('#nectar_fullscreen_rows[data-anchors="on"]').length > 0) {
            if ($id.indexOf("fws_") == -1) $anchors.push($id);
            else $anchors.push("section-" + (i + 1));
          }

          //name checks
          if ($(this).find(".full-page-inner-wrap[data-name]").length > 0)
            $names.push(
              $(this).find(".full-page-inner-wrap").attr("data-name")
            );
          else $names.push(" ");
        });
      }
      setFPNames();

      function initFullPageFooter() {
        var $footerPos = $("#nectar_fullscreen_rows").attr("data-footer");

        if ($footerPos == "default") {
          $("#footer-outer")
            .appendTo("#nectar_fullscreen_rows")
            .addClass("fp-auto-height")
            .addClass("fp-section")
            .addClass("wpb_row")
            .attr("data-anchor", " ")
            .wrapInner('<div class="span_12" />')
            .wrapInner('<div class="container" />')
            .wrapInner('<div class="full-page-inner" />')
            .wrapInner('<div class="full-page-inner-wrap" />')
            .wrapInner('<div class="full-page-inner-wrap-outer" />');
        } else if ($footerPos == "last_row") {
          $("#footer-outer").remove();
          $("#nectar_fullscreen_rows > .wpb_row:last-child")
            .attr("id", "footer-outer")
            .addClass("fp-auto-height");
        } else {
          $("#footer-outer").remove();
        }
      }

      if ($("#nectar_fullscreen_rows").length > 0) initFullPageFooter();

      //fullscreen row logic
      function fullscreenRowLogic() {
        $(
          ".full-page-inner-wrap .full-page-inner > .span_12 > .wpb_column"
        ).each(function () {
          if (
            $(this).find("> .vc_column-inner > .wpb_wrapper").find("> .wpb_row")
              .length > 0
          ) {
            //add class for css
            $(this)
              .find("> .vc_column-inner > .wpb_wrapper")
              .addClass("only_rows");

            //set number of rows for css
            $rowNum = $(this)
              .find("> .vc_column-inner > .wpb_wrapper")
              .find("> .wpb_row").length;
            $(this)
              .find("> .vc_column-inner > .wpb_wrapper")
              .attr("data-inner-row-num", $rowNum);
          } else if (
            $(this)
              .find("> .column-inner-wrap > .column-inner > .wpb_wrapper")
              .find("> .wpb_row").length > 0
          ) {
            //add class for css
            $(this)
              .find("> .column-inner-wrap > .column-inner > .wpb_wrapper")
              .addClass("only_rows");

            //set number of rows for css
            $rowNum = $(this)
              .find("> .column-inner-wrap > .column-inner > .wpb_wrapper")
              .find("> .wpb_row").length;
            $(this)
              .find("> .column-inner-wrap > .column-inner > .wpb_wrapper")
              .attr("data-inner-row-num", $rowNum);
          }
        });
      }

      fullscreenRowLogic();

      function fullHeightRowOverflow() {
        //handle rows with full height that are larger than viewport
        if ($(window).width() >= 1000) {
          $(
            '#nectar_fullscreen_rows > .wpb_row .full-page-inner-wrap[data-content-pos="full_height"]'
          ).each(function () {
            //reset mobile calcs incase user plays with window resize
            $(this).find("> .full-page-inner").css("height", "100%");

            var maxHeight = overallHeight;
            var columnPaddingTop = 0;
            var columnPaddingBottom = 0;

            if ($("#nectar_fullscreen_rows").attr("data-animation") == "none")
              $(this)
                .find("> .full-page-inner > .span_12 ")
                .css("height", "100%");
            else
              $(this)
                .find("> .full-page-inner > .span_12 ")
                .css("height", overallHeight);

            $(this)
              .find(
                "> .full-page-inner > .span_12 > .wpb_column > .vc_column-inner > .wpb_wrapper"
              )
              .each(function () {
                columnPaddingTop = parseInt(
                  $(this).parents(".wpb_column").css("padding-top")
                );
                columnPaddingBottom = parseInt(
                  $(this).parents(".wpb_column").css("padding-bottom")
                );

                maxHeight =
                  maxHeight >
                  $(this).height() + columnPaddingTop + columnPaddingBottom
                    ? maxHeight
                    : $(this).height() + columnPaddingTop + columnPaddingBottom;
              });

            if (maxHeight > overallHeight)
              $(this)
                .find("> .full-page-inner > .span_12")
                .height(maxHeight)
                .css("float", "none");
          });
        } else {
          //mobile min height set
          $("#nectar_fullscreen_rows > .wpb_row").each(function () {
            $totalColHeight = 0;
            $(this)
              .find(
                '.fp-scrollable > .fp-scroller > .full-page-inner-wrap-outer > .full-page-inner-wrap[data-content-pos="full_height"] > .full-page-inner > .span_12 > .wpb_column'
              )
              .each(function () {
                $totalColHeight += $(this).outerHeight(true);
              });

            $(this)
              .find(
                ".fp-scrollable > .fp-scroller > .full-page-inner-wrap-outer > .full-page-inner-wrap > .full-page-inner"
              )
              .css("height", "100%");
            if (
              $totalColHeight >
              $(this)
                .find(
                  ".fp-scrollable > .fp-scroller > .full-page-inner-wrap-outer > .full-page-inner-wrap > .full-page-inner"
                )
                .height()
            )
              $(this)
                .find(
                  ".fp-scrollable  > .fp-scroller > .full-page-inner-wrap-outer > .full-page-inner-wrap > .full-page-inner"
                )
                .height($totalColHeight);
          });
        }
      }

      function fullscreenElementSizing() {
        //nectar slider
        $nsSelector =
          '.nectar-slider-wrap[data-fullscreen="true"][data-full-width="true"], .nectar-slider-wrap[data-fullscreen="true"][data-full-width="boxed-full-width"]';
        if (
          $(
            '.nectar-slider-wrap[data-fullscreen="true"][data-full-width="true"]'
          ).length > 0 ||
          $(
            '.nectar-slider-wrap[data-fullscreen="true"][data-full-width="boxed-full-width"]'
          ).length > 0
        ) {
          if ($("#nectar_fullscreen_rows .wpb_row").length > 0)
            $($nsSelector)
              .find(".swiper-container")
              .attr(
                "data-height",
                $("#nectar_fullscreen_rows .wpb_row").height() + 1
              );

          $(window).trigger("resize.nsSliderContent");

          $($nsSelector)
            .parents(".full-page-inner")
            .addClass("only-nectar-slider");
        }
      }

      //kenburns first slide fix
      $(
        '#nectar_fullscreen_rows[data-row-bg-animation="ken_burns"] > .wpb_row:first-child .row-bg.using-image'
      ).addClass("kenburns");
      setTimeout(function () {
        //ken burns first slide fix
        $(
          '#nectar_fullscreen_rows[data-row-bg-animation="ken_burns"] > .wpb_row:first-child .row-bg.using-image'
        ).removeClass("kenburns");
      }, 500);

      //remove kenburns from safari
      if (
        navigator.userAgent.indexOf("Safari") != -1 &&
        navigator.userAgent.indexOf("Chrome") == -1
      )
        $('#nectar_fullscreen_rows[data-row-bg-animation="ken_burns"]').attr(
          "data-row-bg-animation",
          "none"
        );

      var overallHeight = $(window).height();
      var overallWidth = $(window).width();
      var $fpAnimation = $("#nectar_fullscreen_rows").attr("data-animation");
      var $fpAnimationSpeed;
      var $svgResizeTimeout;

      switch ($("#nectar_fullscreen_rows").attr("data-animation-speed")) {
        case "slow":
          $fpAnimationSpeed = 1150;
          break;
        case "medium":
          $fpAnimationSpeed = 850;
          break;
        case "fast":
          $fpAnimationSpeed = 650;
          break;
        default:
          $fpAnimationSpeed = 850;
      }

      function initNectarFP() {
        $usingFullScreenRows = true;
        $fullscreenSelector = ".wpb_row.active ";

        $(".container-wrap, .container-wrap .main-content > .row").css({
          "padding-bottom": "0",
          "margin-bottom": "0",
        });
        $("#nectar_fullscreen_rows").fullpage({
          sectionSelector: "#nectar_fullscreen_rows > .wpb_row",
          navigation: true,
          css3: true,
          scrollingSpeed: $fpAnimationSpeed,
          anchors: $anchors,
          scrollOverflow: true,
          navigationPosition: "right",
          navigationTooltips: $names,
          afterLoad: function (anchorLink, index, slideAnchor, slideIndex) {
            if ($("#nectar_fullscreen_rows").hasClass("afterLoaded")) {
              //reset slim scroll to top
              $(
                ".wpb_row:not(.last-before-footer):not(:nth-child(" +
                  index +
                  ")) .fp-scrollable"
              ).each(function () {
                $scrollable = $(this).data("iscrollInstance");
                $scrollable.scrollTo(0, 0);
              });

              //reset carousel
              $(
                ".wpb_row:not(:nth-child(" + index + ")) .owl-carousel"
              ).trigger("to.owl.carousel", [0]);

              var $row_id = $(
                "#nectar_fullscreen_rows > .wpb_row:nth-child(" + index + ")"
              ).attr("id");

              $("#nectar_fullscreen_rows > .wpb_row")
                .removeClass("transition-out")
                .removeClass("trans");

              $(
                "#nectar_fullscreen_rows > .wpb_row:nth-child(" + index + ")"
              ).removeClass("next-current");
              $(
                "#nectar_fullscreen_rows > .wpb_row:nth-child(" +
                  index +
                  ") .full-page-inner-wrap-outer"
              ).css({ height: "100%" });
              $(
                "#nectar_fullscreen_rows > .wpb_row .full-page-inner-wrap-outer"
              ).css({ transform: "none" });
              //take care of nav/control coloring
              //setFPNavColoring(index,'na');

              //handle waypoints
              if (
                $row_id != "footer-outer" &&
                $(
                  "#nectar_fullscreen_rows > .wpb_row:nth-child(" +
                    index +
                    ").last-before-footer"
                ).length == 0
              ) {
                waypoints();
                if (
                  !navigator.userAgent.match(
                    /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
                  )
                ) {
                  resetWaypoints();
                  Waypoint.destroyAll();
                  startMouseParallax();
                  //portfolioLoadIn();
                }
                responsiveTooltips();
              }

              if ($row_id != "footer-outer") {
                $("#nectar_fullscreen_rows > .wpb_row")
                  .removeClass("last-before-footer")
                  .css("transform", "initial");

                //reset animation attrs
                $(
                  "#nectar_fullscreen_rows > .wpb_row:not(.active):not(#footer-outer)"
                ).css({
                  transform: "translateY(0)",
                  left: "-9999px",
                  transition: "none",
                  opacity: "1",
                  "will-change": "auto",
                });
                $("#nectar_fullscreen_rows > .wpb_row:not(#footer-outer)")
                  .find(".full-page-inner-wrap-outer")
                  .css({
                    transition: "none",
                    transform: "none",
                    "will-change": "auto",
                  });
                $("#nectar_fullscreen_rows > .wpb_row:not(#footer-outer)")
                  .find(".fp-tableCell")
                  .css({
                    transition: "none",
                    transform: "none",
                    "will-change": "auto",
                  });

                //stacking fix
                $("#nectar_fullscreen_rows > .wpb_row:not(#footer-outer)")
                  .find(
                    ".full-page-inner-wrap-outer > .full-page-inner-wrap > .full-page-inner > .container"
                  )
                  .css({ "backface-visibility": "visible", "z-index": "auto" });
              }
            } else {
              fullHeightRowOverflow();
              overallHeight = $("#nectar_fullscreen_rows").height();
              $("#nectar_fullscreen_rows").addClass("afterLoaded");

              //for users that have scrolled down prior to turning on full page
              setTimeout(function () {
                window.scrollTo(0, 0);
              }, 1800);

              //ken burns first slide fix
              $(
                '#nectar_fullscreen_rows[data-row-bg-animation="ken_burns"] > .wpb_row:first-child .row-bg.using-image'
              ).removeClass("kenburns");

              //handle fullscreen elements
              fullscreenElementSizing();
            }

            $("#nectar_fullscreen_rows").removeClass("nextSectionAllowed");
          },
          onLeave: function (index, nextIndex, direction) {
            var $row_id = $(
              "#nectar_fullscreen_rows > .wpb_row:nth-child(" + nextIndex + ")"
            ).attr("id");
            var $indexRow = $(
              "#nectar_fullscreen_rows > .wpb_row:nth-child(" + index + ")"
            );
            var $nextIndexRow = $(
              "#nectar_fullscreen_rows > .wpb_row:nth-child(" + nextIndex + ")"
            );
            var $nextIndexRowInner = $nextIndexRow.find(
              ".full-page-inner-wrap-outer"
            );
            var $nextIndexRowFpTable = $nextIndexRow.find(".fp-tableCell");
            //mobile/safari  fix
            var $transformProp = !navigator.userAgent.match(
              /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
            )
              ? "transform"
              : "all";
            //if(navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) $transformProp = 'all';

            if ($row_id == "footer-outer") {
              $indexRow.addClass("last-before-footer");
              $("#footer-outer").css("opacity", "1");
            } else {
              $("#nectar_fullscreen_rows > .wpb_row.last-before-footer").css(
                "transform",
                "translateY(0px)"
              );
              $("#footer-outer").css("opacity", "0");
            }
            if ($indexRow.attr("id") == "footer-outer") {
              $("#footer-outer").css({
                transition:
                  $transformProp + " 460ms cubic-bezier(0.60, 0.23, 0.2, 0.93)",
                "backface-visibility": "hidden",
              });
              $("#footer-outer").css({
                transform: "translateY(45%) translateZ(0)",
              });
            }

            //stacking fix
            if ($nextIndexRow.attr("id") != "footer-outer") {
              $nextIndexRowFpTable
                .find(
                  ".full-page-inner-wrap-outer > .full-page-inner-wrap > .full-page-inner > .container"
                )
                .css({ "backface-visibility": "hidden", "z-index": "110" });
            }

            //animation
            if (
              $nextIndexRow.attr("id") != "footer-outer" &&
              $indexRow.attr("id") != "footer-outer" &&
              $('#nectar_fullscreen_rows[data-animation="none"]').length == 0
            ) {
              //scrolling down
              if (direction == "down") {
                if ($fpAnimation == "parallax") {
                  $indexRow.css({
                    transition:
                      $transformProp +
                      " " +
                      $fpAnimationSpeed +
                      "ms cubic-bezier(.29,.23,.13,1)",
                    "will-change": "transform",
                    transform: "translateZ(0)",
                    "z-index": "100",
                  });
                  setTimeout(function () {
                    $indexRow.css({
                      transform: "translateY(-50%) translateZ(0)",
                    });
                  }, 60);

                  $nextIndexRow.css({ "z-index": "1000", top: "0", left: "0" });
                  $nextIndexRowFpTable.css({
                    transform: "translateY(100%) translateZ(0)",
                    "will-change": "transform",
                  });
                  $nextIndexRowInner.css({
                    transform: "translateY(-50%) translateZ(0)",
                    "will-change": "transform",
                  });
                } else if ($fpAnimation == "zoom-out-parallax") {
                  $indexRow.css({
                    transition:
                      "opacity " +
                      $fpAnimationSpeed +
                      "ms cubic-bezier(0.37, 0.31, 0.2, 0.85), transform " +
                      $fpAnimationSpeed +
                      "ms cubic-bezier(0.37, 0.31, 0.2, 0.85)",
                    "z-index": "100",
                    "will-change": "transform",
                  });
                  setTimeout(function () {
                    $indexRow.css({
                      transform: "scale(0.77) translateZ(0)",
                      opacity: "0",
                    });
                  }, 60);

                  $nextIndexRow.css({ "z-index": "1000", top: "0", left: "0" });
                  $nextIndexRowFpTable.css({
                    transform: "translateY(100%) translateZ(0)",
                    "will-change": "transform",
                  });
                  $nextIndexRowInner.css({
                    transform: "translateY(-50%) translateZ(0)",
                    "will-change": "transform",
                  });
                }
                /*else if($fpAnimation == 'none') {

	        				$indexRow.css({'transition': $transformProp+' '+$fpAnimationSpeed+'ms cubic-bezier(.29,.23,.13,1)', 'z-index': '100'});
	        				$indexRow.css({'will-change':'transform'});

		        			setTimeout(function() { 
		        				$indexRow.css({'transform': 'translateY(-100%) translateZ(0)'});
		        			}, 80);

		        			$nextIndexRowFpTable.css({'transform':'translateY(100%) translateZ(0)', 'will-change':'transform'});
		        			setTimeout(function() { 
		        				$nextIndexRow.css({'z-index':'1000','top':'0','left':'0'});
		        			}, 30);
	        			}*/
              }

              //scrolling up
              else {
                if ($fpAnimation == "parallax") {
                  $indexRow.css({
                    transition:
                      $transformProp +
                      " " +
                      $fpAnimationSpeed +
                      "ms cubic-bezier(.29,.23,.13,1)",
                    "z-index": "100",
                    "will-change": "transform",
                  });
                  setTimeout(function () {
                    $indexRow.css({
                      transform: "translateY(50%) translateZ(0)",
                    });
                  }, 60);

                  $nextIndexRow.css({ "z-index": "1000", top: "0", left: "0" });
                  $nextIndexRowFpTable.css({
                    transform: "translateY(-100%) translateZ(0)",
                    "will-change": "transform",
                  });
                  $nextIndexRowInner.css({
                    transform: "translateY(50%) translateZ(0)",
                    "will-change": "transform",
                  });
                } else if ($fpAnimation == "zoom-out-parallax") {
                  $indexRow.css({
                    transition:
                      "opacity " +
                      $fpAnimationSpeed +
                      "ms cubic-bezier(0.37, 0.31, 0.2, 0.85), transform " +
                      $fpAnimationSpeed +
                      "ms cubic-bezier(0.37, 0.31, 0.2, 0.85)",
                    "z-index": "100",
                    "will-change": "transform",
                  });
                  setTimeout(function () {
                    $indexRow.css({
                      transform: "scale(0.77) translateZ(0)",
                      opacity: "0",
                    });
                  }, 60);

                  $nextIndexRow.css({ "z-index": "1000", top: "0", left: "0" });
                  $nextIndexRowFpTable.css({
                    transform: "translateY(-100%) translateZ(0)",
                    "will-change": "transform",
                  });
                  $nextIndexRowInner.css({
                    transform: "translateY(50%) translateZ(0)",
                    "will-change": "transform",
                  });
                }
                /*else if($fpAnimation == 'none') {
		        			$indexRow.css({'transition': $transformProp+' '+$fpAnimationSpeed+'ms cubic-bezier(.29,.23,.13,1)', 'z-index': '100'});
		        			$indexRow.css({'will-change':'transform'});

		        			setTimeout(function() { 
		        				$indexRow.css({'transform': 'translateY(100%) translateZ(0)'});
		        			}, 80);

		        			$nextIndexRowFpTable.css({'transform':'translateY(-100%) translateZ(0)', 'will-change':'transform'});
		        			setTimeout(function() { 
		        				$nextIndexRow.css({'z-index':'1000','top':'0','left':'0'});
		        			}, 30);
	        			}*/
              }

              setTimeout(function () {
                $nextIndexRowFpTable.css({
                  transition:
                    $transformProp +
                    " " +
                    $fpAnimationSpeed +
                    "ms cubic-bezier(.29,.23,.13,1) 0ms",
                  transform: "translateY(0%) translateZ(0)",
                });
                if ($fpAnimation != "none")
                  $nextIndexRowInner.css({
                    transition:
                      $transformProp +
                      " " +
                      $fpAnimationSpeed +
                      "ms cubic-bezier(.29,.23,.13,1) 0ms",
                    transform: "translateY(0%) translateZ(0)",
                  });
              }, 60);
            }

            //adjust transform if larger than row height for parallax
            if (
              $('#nectar_fullscreen_rows[data-animation="none"]').length == 0 &&
              $nextIndexRow.find(".fp-scrollable").length > 0
            )
              $nextIndexRow
                .find(".full-page-inner-wrap-outer")
                .css("height", overallHeight);

            setTimeout(function () {
              if ($row_id == "footer-outer") {
                $indexRow.css(
                  "transform",
                  "translateY(-" + ($("#footer-outer").height() - 1) + "px)"
                );

                $("#footer-outer").css({
                  transform: "translateY(45%) translateZ(0)",
                });
                $("#footer-outer").css({
                  "transition-duration": "0s",
                  "backface-visibility": "hidden",
                });
                setTimeout(function () {
                  $("#footer-outer").css({
                    transition:
                      $transformProp +
                      " 500ms cubic-bezier(0.60, 0.23, 0.2, 0.93)",
                    "backface-visibility": "hidden",
                  });
                  $("#footer-outer").css({
                    transform: "translateY(0%) translateZ(0)",
                  });
                }, 30);
              }
            }, 30);

            if ($row_id != "footer-outer") {
              stopMouseParallax();

              //take care of nav/control coloring
              setFPNavColoring(nextIndex, direction);
            }
          },

          afterResize: function () {
            overallHeight = $("#nectar_fullscreen_rows").height();
            overallWidth = $(window).width();
            fullHeightRowOverflow();
            fullscreenElementSizing();
            fullscreenFooterCalcs();

            if ($("#footer-outer.active").length > 0) {
              setTimeout(function () {
                $(".last-before-footer").css(
                  "transform",
                  "translateY(-" + $("#footer-outer").height() + "px)"
                );
              }, 200);
            }

            //fix for svg animations when resizing and iscroll wraps/unwraps
            clearTimeout($svgResizeTimeout);
            $svgResizeTimeout = setTimeout(function () {
              if ($svg_icons.length > 0) {
                $(".svg-icon-holder.animated-in").each(function (i) {
                  $(this).css("opacity", "1");
                  $svg_icons[$(this).attr("id").slice(-1)].finish();
                });
              }
            }, 300);
          },
        });
      }

      if ($("#nectar_fullscreen_rows").length > 0) initNectarFP();

      $(window).smartresize(function () {
        if ($("#nectar_fullscreen_rows").length > 0) {
          setTimeout(function () {
            $(".wpb_row:not(.last-before-footer) .fp-scrollable").each(
              function () {
                $scrollable = $(this).data("iscrollInstance");
                $scrollable.refresh();
              }
            );
          }, 200);

          fullHeightRowOverflow();
        }
      });

      function fullscreenFooterCalcs() {
        if ($("#footer-outer.active").length > 0) {
          $(".last-before-footer")
            .addClass("fp-notransition")
            .css(
              "transform",
              "translateY(-" + $("#footer-outer").height() + "px)"
            );
          setTimeout(function () {
            $(".last-before-footer").removeClass("fp-notransition");
          }, 10);
        }
      }

      function stopMouseParallax() {
        $.each($mouseParallaxScenes, function (k, v) {
          v.parallax("disable");
        });
      }

      function startMouseParallax() {
        if (
          $("#nectar_fullscreen_rows > .wpb_row.active .nectar-parallax-scene")
            .length > 0
        ) {
          $.each($mouseParallaxScenes, function (k, v) {
            v.parallax("enable");
          });
        }
      }

      if ($("#nectar_fullscreen_rows").length > 0) {
        if ($("#fp-nav.tooltip_alt").length == 0) setFPNavColoring(1, "na");
        fullscreenElementSizing();
      }

      function resetWaypoints() {
        //animated columns / imgs
        $(
          'img.img-with-animation.animated-in:not([data-animation="none"])'
        ).css({ transition: "none" });
        $('img.img-with-animation.animated-in:not([data-animation="none"])')
          .css({ opacity: "0", transform: "none" })
          .removeClass("animated-in");
        $(
          '.col.has-animation.animated-in:not([data-animation*="reveal"]), .wpb_column.has-animation.animated-in:not([data-animation*="reveal"])'
        ).css({ transition: "none" });
        $(
          '.col.has-animation.animated-in:not([data-animation*="reveal"]), .wpb_column.has-animation.animated-in:not([data-animation*="reveal"]), .nectar_cascading_images .cascading-image:not([data-animation="none"]) .inner-wrap'
        )
          .css({ opacity: "0", transform: "none", left: "auto", right: "auto" })
          .removeClass("animated-in");
        $(
          '.col.has-animation.boxed:not([data-animation*="reveal"]), .wpb_column.has-animation.boxed:not([data-animation*="reveal"])'
        ).addClass("no-pointer-events");

        //reveal columns
        $(
          '.wpb_column.has-animation[data-animation*="reveal"], .nectar_cascading_images'
        ).removeClass("animated-in");
        if (overallWidth > 1000 && $(".using-mobile-browser").length == 0) {
          $(
            '.wpb_column.has-animation[data-animation="reveal-from-bottom"] > .column-inner-wrap'
          ).css({ transition: "none", transform: "translate(0, 100%)" });
          $(
            '.wpb_column.has-animation[data-animation="reveal-from-bottom"] > .column-inner-wrap > .column-inner'
          ).css({ transition: "none", transform: "translate(0, -90%)" });
          $(
            '.wpb_column.has-animation[data-animation="reveal-from-top"] > .column-inner-wrap'
          ).css({ transition: "none", transform: "translate(0, -100%)" });
          $(
            '.wpb_column.has-animation[data-animation="reveal-from-top"] > .column-inner-wrap > .column-inner'
          ).css({ transition: "none", transform: "translate(0, 90%)" });
          $(
            '.wpb_column.has-animation[data-animation="reveal-from-left"] > .column-inner-wrap'
          ).css({
            "transition-duration": "0s",
            transform: "translate(-100%, 0)",
          });
          $(
            '.wpb_column.has-animation[data-animation="reveal-from-left"] > .column-inner-wrap > .column-inner'
          ).css({
            "transition-duration": "0s",
            transform: "translate(90%, 0)",
          });
          $(
            '.wpb_column.has-animation[data-animation="reveal-from-right"] > .column-inner-wrap'
          ).css({
            "transition-duration": "0s",
            transform: "translate(100%, 0)",
          });
          $(
            '.wpb_column.has-animation[data-animation="reveal-from-right"] > .column-inner-wrap > .column-inner'
          ).css({
            "transition-duration": "0s",
            transform: "translate(-90%, 0)",
          });
        }
        $(
          '.wpb_column.has-animation[data-animation*="reveal"] > .column-inner-wrap, .wpb_column.has-animation[data-animation*="reveal"] > .column-inner-wrap > .column-inner'
        ).removeClass("no-transform");

        //vcwaypoints
        $(".wpb_animate_when_almost_visible.animated")
          .removeClass("wpb_start_animation")
          .removeClass("animated");

        //column borders
        $('.wpb_column[data-border-animation="true"] .border-wrap.animation')
          .removeClass("animation")
          .removeClass("completed");

        //milestone
        $(".nectar-milestone.animated-in")
          .removeClass("animated-in")
          .removeClass("in-sight");
        $(".nectar-milestone .symbol").removeClass("in-sight");

        //fancy ul
        $('.nectar-fancy-ul[data-animation="true"]').removeClass("animated-in");
        $('.nectar-fancy-ul[data-animation="true"] ul li').css({
          opacity: "0",
          left: "-20px",
        });

        //progress bars
        $(".nectar-progress-bar").parent().removeClass("completed");
        $(".nectar-progress-bar .bar-wrap > span").css({ width: "0px" });
        $(".nectar-progress-bar .bar-wrap > span > strong").css({
          opacity: "0",
        });
        $(".nectar-progress-bar .bar-wrap").css({ opacity: "0" });

        //clients
        $(".clients.fade-in-animation").removeClass("animated-in");
        $(".clients.fade-in-animation > div").css("opacity", "0");

        //carousel
        $('.owl-carousel[data-enable-animation="true"]').removeClass(
          "animated-in"
        );
        $(
          '.owl-carousel[data-enable-animation="true"] .owl-stage > .owl-item'
        ).css({
          transition: "none",
          opacity: "0",
          transform: "translate(0, 70px)",
        });
        //dividers
        $(
          '.divider-small-border[data-animate="yes"], .divider-border[data-animate="yes"]'
        )
          .removeClass("completed")
          .css({ transition: "none", transform: "scale(0,1)" });

        //icon list
        $(".nectar-icon-list").removeClass("completed");
        $(".nectar-icon-list-item").removeClass("animated");

        //portfolio
        $(".portfolio-items .col").removeClass("animated-in");

        //split line
        $(".nectar-split-heading").removeClass("animated-in");
        $(".nectar-split-heading .heading-line > div").transit(
          { y: "200%" },
          0
        );

        //image with hotspots
        $('.nectar_image_with_hotspots[data-animation="true"]').removeClass(
          "completed"
        );
        $(
          '.nectar_image_with_hotspots[data-animation="true"] .nectar_hotspot_wrap'
        ).removeClass("animated-in");

        //animated titles
        $(".nectar-animated-title").removeClass("completed");

        if ($(".vc_pie_chart").length > 0) vc_pieChart();

        $(
          '.col.has-animation:not([data-animation*="reveal"]), .wpb_column.has-animation:not([data-animation*="reveal"])'
        ).each(function (i) {
          //clear previous timeout (needed for fullscreen rows)
          clearTimeout($standAnimatedColTimeout[i]);
        });
      }
    } else if (
      ($("#nectar_fullscreen_rows").length > 0 && $disableFPonMobile == "on") ||
      ($().fullpage && $disableFPonMobile == "on")
    ) {
      //remove markup
      //$('#nectar_fullscreen_rows > div.wpb_row .row-bg-wrap').unwrap().unwrap().unwrap();
      //$('#nectar_fullscreen_rows > div.wpb_row:first-child').unwrap();
      $("html,body").css({ height: "auto", "overflow-y": "auto" });
    }

    /***************** Superfish ******************/

    function initSF() {
      if ($('body[data-header-format="left-header"]').length == 0) {
        $disableHI =
          $('body[data-dropdown-style="minimal"]').length > 0 ? true : false;

        $(".sf-menu").superfish({
          delay: 650,
          speed: "fast",
          /*disableHI: $disableHI,*/
          speedOut: "fast",
          animation: { opacity: "show" },
        });

        //handle initial show on left class for minimal styling
        $("#header-outer .sf-menu > li:not(.megamenu) > ul > li > ul").each(
          function () {
            if (
              $(this).offset().left + $(this).outerWidth() >
              $(window).width()
            ) {
              $(this).addClass("on-left-side");
              $(this).find("ul").addClass("on-left-side");
            }
          }
        );

        //megamenu multi section per column title support
        $(
          'body:not([data-header-format="left-header"]) header#top nav > ul > li.megamenu > ul > li > ul > li:has("> ul")'
        ).addClass("has-ul");

        //fullwidth megamenu
        if (
          $('body[data-megamenu-width="full-width"]').length > 0 &&
          $("ul.sub-menu").length > 0
        ) {
          megamenuFullwidth();
          $(window).on("smartresize", megamenuFullwidth);
          $("header#top nav > ul > li.megamenu > .sub-menu").css(
            "box-sizing",
            "content-box"
          );
        }

        //extra hover class for megamenu check
        $("header#top nav > ul.sf-menu > li").on("mouseenter", function () {
          $(this).addClass("menu-item-over");
        });
        $("header#top nav > ul.sf-menu > li").on("mouseleave", function () {
          $(this).removeClass("menu-item-over");
        });

        //remove arrows on mega menu item
        $(
          "header#top nav .megamenu .sub-menu a.sf-with-ul .sf-sub-indicator, header#top .megamenu .sub-menu a .sf-sub-indicator"
        ).remove();

        //blank title megamenu columns
        ////desktop
        $("header#top nav > ul > li.megamenu > ul.sub-menu > li > a").each(
          function () {
            if ($(this).text() == "–") {
              $(this).remove();
            }
          }
        );
      }
    }

    function megamenuFullwidth() {
      var $windowWidth = $(window).width();
      var $headerContainerWidth = $("header#top > .container").width();
      $("header#top nav > ul > li.megamenu > .sub-menu").css({
        "padding-left": ($windowWidth - $headerContainerWidth) / 2 + "px",
        "padding-right": ($windowWidth + 2 - $headerContainerWidth) / 2 + "px",
        width: $headerContainerWidth,
        left: "-" + ($windowWidth - $headerContainerWidth) / 2 + "px",
      });
    }

    var $navLeave;

    function addOrRemoveSF() {
      if (
        window.innerWidth < 1000 &&
        $("body").attr("data-responsive") == "1"
      ) {
        $("body").addClass("mobile");
        $("header#top nav").hide();
      } else {
        $("body").removeClass("mobile");
        $("header#top nav").show();
        $("#mobile-menu").hide();
        $(
          ".slide-out-widget-area-toggle #toggle-nav .lines-button"
        ).removeClass("close");

        //recalc height of dropdown arrow
        $(".sf-sub-indicator").css("height", $("a.sf-with-ul").height());
      }

      //add specific class if on device for better tablet tracking
      if (
        navigator.userAgent.match(
          /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
        )
      )
        $("body").addClass("using-mobile-browser");
    }

    function showOnLeftSubMenu() {
      //show on left class for minimal styling
      $("#header-outer .sf-menu > li:not(.megamenu) > ul > li > ul").each(
        function () {
          $(this).removeClass("on-left-side");

          if (
            $(this).offset().left + $(this).outerWidth() >
            $(window).width()
          ) {
            $(this).addClass("on-left-side");
            $(this).find("ul").addClass("on-left-side");
          } else {
            $(this).removeClass("on-left-side");
            $(this).find("ul").removeClass("on-left-side");
          }
        }
      );
    }

    addOrRemoveSF();
    initSF();

    $(window).resize(addOrRemoveSF);

    function SFArrows() {
      //set height of dropdown arrow
      $(".sf-sub-indicator").css("height", $("a.sf-with-ul").height());
    }

    SFArrows();

    //deactivate hhun on phone
    if (
      navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|IEMobile|BlackBerry|Opera Mini)/
      )
    )
      $("body").attr("data-hhun", "0");

    /***************** Caroufredsel ******************/

    function standardCarouselInit() {
      $('ul.carousel:not(".clients")').each(function () {
        var $that = $(this);
        var maxCols =
          $(this).parents(".carousel-wrap").attr("data-full-width") == "true"
            ? "auto"
            : 3;
        var scrollNum =
          $(this).parents(".carousel-wrap").attr("data-full-width") == "true"
            ? "auto"
            : "";
        var colWidth =
          $(this).parents(".carousel-wrap").attr("data-full-width") == "true"
            ? 500
            : 453;
        var scrollSpeed, easing;
        var $autoplayBool =
          $(this).attr("data-autorotate") == "true" ? true : false;

        if (
          $("body.ascend").length > 0 &&
          $(this).parents(".carousel-wrap").attr("data-full-width") != "true"
        ) {
          if ($(this).find("li").length % 3 === 0) {
            var $themeSkin = true;
            var $themeSkin2 = true;
          } else {
            var $themeSkin = false;
            var $themeSkin2 = true;
          }
        } else {
          var $themeSkin = true;
          var $themeSkin2 = true;
        }

        parseInt($(this).attr("data-scroll-speed"))
          ? (scrollSpeed = parseInt($(this).attr("data-scroll-speed")))
          : (scrollSpeed = 700);
        $(this).is("[data-easing]")
          ? (easing = $(this).attr("data-easing"))
          : (easing = "linear");

        var $element = $that;
        if ($that.find("img").length == 0) $element = $("body");

        imagesLoaded($element, function (instance) {
          $that
            .carouFredSel(
              {
                circular: $themeSkin,
                infinite: $themeSkin2,
                height: "auto",
                responsive: true,
                items: {
                  width: colWidth,
                  visible: {
                    min: 1,
                    max: maxCols,
                  },
                },
                swipe: {
                  onTouch: true,
                  onMouse: true,
                  options: {
                    excludedElements:
                      "button, input, select, textarea, .noSwipe",
                    tap: function (event, target) {
                      if (
                        $(target).attr("href") &&
                        !$(target).is('[target="_blank"]') &&
                        !$(target).is('[rel^="prettyPhoto"]') &&
                        !$(target).is(".magnific-popup") &&
                        !$(target).is(".magnific")
                      )
                        window.open($(target).attr("href"), "_self");
                    },
                  },
                  onBefore: function () {
                    //hover effect fix
                    $that.find(".work-item").trigger("mouseleave");
                    $that.find(".work-item .work-info a").trigger("mouseup");
                  },
                },
                scroll: {
                  items: scrollNum,
                  easing: easing,
                  duration: scrollSpeed,
                  onBefore: function (data) {
                    if (
                      $("body.ascend").length > 0 &&
                      $that.parents(".carousel-wrap").attr("data-full-width") !=
                        "true"
                    ) {
                      $that
                        .parents(".carousel-wrap")
                        .find(".item-count .total")
                        .html(
                          Math.ceil(
                            $that.find("> li").length /
                              $that.triggerHandler("currentVisible").length
                          )
                        );
                    }
                  },
                  onAfter: function (data) {
                    if (
                      $("body.ascend").length > 0 &&
                      $that.parents(".carousel-wrap").attr("data-full-width") !=
                        "true"
                    ) {
                      $that
                        .parents(".carousel-wrap")
                        .find(".item-count .current")
                        .html($that.triggerHandler("currentPage") + 1);
                      $that
                        .parents(".carousel-wrap")
                        .find(".item-count .total")
                        .html(
                          Math.ceil(
                            $that.find("> li").length /
                              $that.triggerHandler("currentVisible").length
                          )
                        );
                    }
                  },
                },
                prev: {
                  button: function () {
                    return $that
                      .parents(".carousel-wrap")
                      .find(".carousel-prev");
                  },
                },
                next: {
                  button: function () {
                    return $that
                      .parents(".carousel-wrap")
                      .find(".carousel-next");
                  },
                },
                auto: {
                  play: $autoplayBool,
                },
              },
              { transition: true }
            )
            .animate({ opacity: 1 }, 1300);

          $that.parents(".carousel-wrap").wrap('<div class="carousel-outer">');

          if ($that.parents(".carousel-wrap").attr("data-full-width") == "true")
            $that.parents(".carousel-outer").css("overflow", "visible");

          //add count for non full width ascend skin
          if (
            $("body.ascend").length > 0 &&
            $that.parents(".carousel-wrap").attr("data-full-width") != "true"
          ) {
            $(
              '<div class="item-count"><span class="current">1</span>/<span class="total">' +
                $that.find("> li").length /
                  $that.triggerHandler("currentVisible").length +
                "</span></div>"
            ).insertAfter(
              $that.parents(".carousel-wrap").find(".carousel-prev")
            );
          }

          $that.addClass("finished-loading");

          carouselHeightCalcs();

          //reinit panr
          if (
            !$("body").hasClass("mobile") &&
            !navigator.userAgent.match(
              /(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/
            )
          ) {
            $(".portfolio-items.carousel .work-item.style-3 img").panr({
              scaleDuration: 0.28,
            });
            $(
              ".portfolio-items:not(.carousel) .work-item.style-3-alt img"
            ).panr({
              scaleDuration: 0.28,
              sensitivity: 12.6,
              scaleTo: 1.08,
              panDuration: 3,
            });
          }
        }); //images loaded
      }); //each
    }
    if ($(".carousel").length > 0) standardCarouselInit();

    function owlCarouselInit() {
      //owl
      $(".owl-carousel").each(function () {
        var $that = $(this);
        var $stagePadding =
          $(window).width() < 1000
            ? 0
            : parseInt($(this).attr("data-column-padding"));
        var $autoRotateBool = $that.attr("data-autorotate");
        var $autoRotateSpeed = $that.attr("data-autorotations-peed");

        $(this).owlCarousel({
          responsive: {
            0: {
              items: $(this).attr("data-mobile-cols"),
            },
            690: {
              items: $(this).attr("data-tablet-cols"),
            },
            1000: {
              items: $(this).attr("data-desktop-small-cols"),
            },
            1300: {
              items: $(this).attr("data-desktop-cols"),
            },
          },
          /*stagePadding: $stagePadding,*/
          autoplay: $autoRotateBool,
          autoplayTimeout: $autoRotateSpeed,
          onTranslate: function () {
            $that.addClass("moving");
          },
          onTranslated: function () {
            $that.removeClass("moving");
          },
        });

        $(this).on("changed.owl.carousel", function (event) {
          if (event.item.count - event.page.size == event.item.index)
            $(event.target)
              .find(".owl-dots div:last")
              .addClass("active")
              .siblings()
              .removeClass("active");
        });
      });
    }

    function owl_carousel_animate() {
      $(
        $fullscreenSelector + '.owl-carousel[data-enable-animation="true"]'
      ).each(function () {
        $owlOffsetPos =
          $("#nectar_fullscreen_rows").length > 0 ? "100%" : "bottom-in-view";

        var $animationDelay =
          $(this).is("[data-animation-delay]") &&
          $(this).attr("data-animation-delay").length > 0 &&
          $(this).attr("data-animation") != "false"
            ? $(this).attr("data-animation-delay")
            : 0;

        var $that = $(this);
        var waypoint = new Waypoint({
          element: $that,
          handler: function (direction) {
            if (
              ($that.parents(".wpb_tab").length > 0 &&
                $that.parents(".wpb_tab").css("visibility") == "hidden") ||
              $that.hasClass("animated-in")
            ) {
              waypoint.destroy();
              return;
            }

            setTimeout(function () {
              $that.find(".owl-stage > .owl-item").each(function (i) {
                var $that = $(this);
                $that.delay(i * 200).transition(
                  {
                    opacity: "1",
                    y: "0",
                  },
                  600,
                  "easeOutQuart"
                );
              });
              $that.addClass("animated-in");
            }, $animationDelay);

            waypoint.destroy();
          },
          offset: $owlOffsetPos,
        });
      });
    }

    function productCarouselInit() {
      $(".products-carousel").each(function () {
        var $that = $(this).find("ul");
        var maxCols = "auto";
        var scrollNum = "auto";
        var colWidth =
          $(this).parents(".full-width-content ").length > 0 ? 400 : 353;
        var scrollSpeed = 800;
        var easing = "easeInOutQuart";

        var $element = $that;
        if ($that.find("img").length == 0) $element = $("body");

        //controls on hover
        $(this).append(
          '<a class="carousel-prev" href="#"><i class="icon-salient-left-arrow"></i></a> <a class="carousel-next" href="#"><i class="icon-salient-right-arrow"></i></a>'
        );

        imagesLoaded($element, function (instance) {
          $that
            .carouFredSel({
              circular: true,
              responsive: true,
              items: {
                width: colWidth,
                visible: {
                  min: 1,
                  max: maxCols,
                },
              },
              swipe: {
                onTouch: true,
                onMouse: true,
                options: {
                  excludedElements: "button, input, select, textarea, .noSwipe",
                  tap: function (event, target) {
                    if (
                      $(target).attr("href") &&
                      !$(target).is('[target="_blank"]') &&
                      !$(target).hasClass("add_to_wishlist") &&
                      !$(target).hasClass("add_to_cart_button") &&
                      !$(target).is('[rel^="prettyPhoto"]')
                    )
                      window.open($(target).attr("href"), "_self");
                    if (
                      $(target).parent().attr("href") &&
                      !$(target).parent().is('[target="_blank"]') &&
                      !$(target).parent().hasClass("add_to_wishlist") &&
                      !$(target).parent().hasClass("add_to_cart_button") &&
                      !$(target).parent().is('[rel^="prettyPhoto"]')
                    )
                      window.open($(target).parent().attr("href"), "_self");
                  },
                },
                onBefore: function () {
                  //hover effect fix
                  $that.find(".product-wrap").trigger("mouseleave");
                  $that.find(".product a").trigger("mouseup");
                },
              },
              scroll: {
                items: scrollNum,
                easing: easing,
                duration: scrollSpeed,
              },
              prev: {
                button: function () {
                  return $that.parents(".carousel-wrap").find(".carousel-prev");
                },
              },
              next: {
                button: function () {
                  return $that.parents(".carousel-wrap").find(".carousel-next");
                },
              },
              auto: {
                play: false,
              },
            })
            .animate({ opacity: 1 }, 1300);

          $that.parents(".carousel-wrap").wrap('<div class="carousel-outer">');

          $that.addClass("finished-loading");
          fullWidthContentColumns();
          $(window).trigger("resize");
        }); //images loaded
      }); //each
    }
    if ($(".products-carousel").length > 0) productCarouselInit();

    //fullwidth carousel swipe link fix
    function fwCarouselLinkFix() {
      var $mousePosStart = 0;
      var $mousePosEnd = 0;
      $(
        ".carousel-wrap .portfolio-items .col .work-item .work-info a, .woocommerce .products-carousel ul.products li.product a"
      ).mousedown(function (e) {
        $mousePosStart = e.clientX;
      });

      $(
        ".carousel-wrap .portfolio-items .col .work-item .work-info a, .woocommerce .products-carousel ul.products li.product a"
      ).mouseup(function (e) {
        $mousePosEnd = e.clientX;
      });

      $(
        ".carousel-wrap .portfolio-items .col .work-item .work-info a, .woocommerce .products-carousel ul.products li.product a"
      ).click(function (e) {
        if (Math.abs($mousePosStart - $mousePosEnd) > 10) return false;
      });
    }
    fwCarouselLinkFix();

    function carouselHeightCalcs() {
      //recent work carousel
      $(".carousel.portfolio-items.finished-loading").each(function () {
        var bottomSpace =
          $(this).parents(".carousel-wrap").attr("data-full-width") == "true" &&
          $(this).find(".style-2, .style-3, .style-4").length > 0
            ? 0
            : 28;

        var tallestMeta = 0;

        $(this)
          .find("> li")
          .each(function () {
            $(this).find(".work-meta").height() > tallestMeta
              ? (tallestMeta = $(this).find(".work-meta").height())
              : (tallestMeta = tallestMeta);
          });

        $(this)
          .parents(".caroufredsel_wrapper")
          .css({
            height:
              $(this).find(".work-item").outerHeight() +
              tallestMeta +
              bottomSpace -
              2 +
              "px",
          });

        if (
          $("body.ascend").length > 0 &&
          $(this).parents(".carousel-wrap").attr("data-full-width") != "true"
        ) {
          $(this)
            .parents(".carousel-wrap")
            .find(".item-count .current")
            .html(
              Math.ceil(
                ($(this).triggerHandler("currentPosition") + 1) /
                  $(this).triggerHandler("currentVisible").length
              )
            );
          $(this)
            .parents(".carousel-wrap")
            .find(".item-count .total")
            .html(
              Math.ceil(
                $(this).find("> li").length /
                  $(this).triggerHandler("currentVisible").length
              )
            );
        }
      });

      //standard carousel
      $(
        '.carousel.finished-loading:not(".portfolio-items, .clients"), .caroufredsel_wrapper .products.finished-loading'
      ).each(function () {
        var tallestColumn = 0;

        $(this)
          .find("> li")
          .each(function () {
            $(this).height() > tallestColumn
              ? (tallestColumn = $(this).height())
              : (tallestColumn = tallestColumn);
          });

        $(this).css("height", tallestColumn + 5);
        $(this)
          .parents(".caroufredsel_wrapper")
          .css("height", tallestColumn + 5);

        if (
          $("body.ascend").length > 0 &&
          $(this).parents(".carousel-wrap").attr("data-full-width") != "true"
        ) {
          $(this)
            .parents(".carousel-wrap")
            .find(".item-count .current")
            .html(
              Math.ceil(
                ($(this).triggerHandler("currentPosition") + 1) /
                  $(this).triggerHandler("currentVisible").length
              )
            );
          $(this)
            .parents(".carousel-wrap")
            .find(".item-count .total")
            .html(
              Math.ceil(
                $(this).find("> li").length /
                  $(this).triggerHandler("currentVisible").length
              )
            );
        }
      });
    }

    function clientsCarouselInit() {
      $(".carousel.clients").each(function () {
        var $that = $(this);
        var columns;
        var $autoRotate = !$(this).hasClass("disable-autorotate")
          ? true
          : false;
        parseInt($(this).attr("data-max"))
          ? (columns = parseInt($(this).attr("data-max")))
          : (columns = 5);
        if (
          $(window).width() < 690 &&
          $("body").attr("data-responsive") == "1"
        ) {
          columns = 2;
          $(this).addClass("phone");
        }

        var $element = $that;
        if ($that.find("img").length == 0) $element = $("body");

        imagesLoaded($element, function (instance) {
          $that
            .carouFredSel({
              circular: true,
              responsive: true,
              items: {
                height: $that.find("> div:first").height(),
                width: $that.find("> div:first").width(),
                visible: {
                  min: 1,
                  max: columns,
                },
              },
              swipe: {
                onTouch: true,
                onMouse: true,
              },
              scroll: {
                items: 1,
                easing: "easeInOutCubic",
                duration: "800",
                pauseOnHover: true,
              },
              auto: {
                play: $autoRotate,
                timeoutDuration: 2700,
              },
            })
            .animate({ opacity: 1 }, 1300);

          $that.addClass("finished-loading");

          $that.parents(".carousel-wrap").wrap('<div class="carousel-outer">');

          $(window).trigger("resize");
        });
      });
    }
    if ($(".carousel").length > 0) clientsCarouselInit();

    function clientsCarouselHeightRecalc() {
      var tallestImage = 0;

      $(".carousel.clients.finished-loading").each(function () {
        $(this)
          .find("> div")
          .each(function () {
            $(this).height() > tallestImage
              ? (tallestImage = $(this).height())
              : (tallestImage = tallestImage);
          });

        $(this).css("height", tallestImage);
        $(this).parent().css("height", tallestImage);
      });
    }

    //carousel grabbing class
    function carouselfGrabbingClass() {
      $("body").on(
        "mousedown",
        '.caroufredsel_wrapper, .carousel-wrap[data-full-width="true"] .portfolio-items .col .work-item .work-info a, .woocommerce .products-carousel ul.products li.product a',
        function () {
          $(this).addClass("active");
        }
      );

      $("body").on(
        "mouseup",
        '.caroufredsel_wrapper, .carousel-wrap[data-full-width="true"] .portfolio-items .col .work-item .work-info a, .woocommerce .products-carousel ul.products li.product a',
        function () {
          $(this).removeClass("active");
        }
      );
    }
    carouselfGrabbingClass();

    //ascend arrow hover class
    $("body.ascend").on("mouseover", ".carousel-next", function () {
      $(this)
        .parent()
        .find(".carousel-prev, .item-count")
        .addClass("next-hovered");
    });
    $("body.ascend").on("mouseleave", ".carousel-next", function () {
      $(this)
        .parent()
        .find(".carousel-prev, .item-count")
        .removeClass("next-hovered");
    });

    //fadein for clients / carousels
    function clientsFadeIn() {
      $clientsOffsetPos =
        $("#nectar_fullscreen_rows").length > 0 ? 100 : "bottom-in-view";
      $($fullscreenSelector + ".clients.fade-in-animation").each(function () {
        var $that = $(this);
        var waypoint = new Waypoint({
          element: $that,
          handler: function (direction) {
            if (
              ($that.parents(".wpb_tab").length > 0 &&
                $that.parents(".wpb_tab").css("visibility") == "hidden") ||
              $that.hasClass("animated-in")
            ) {
              waypoint.destroy();
              return;
            }

            $that.find("> div").each(function (i) {
              $(this)
                .delay(i * 80)
                .transition({ opacity: "1" }, 450);
            });

            //add the css transition class back in after the aniamtion is done
            setTimeout(function () {
              $that.addClass("completed");
            }, $that.find("> div").length * 80 + 450);

            $that.addClass("animated-in");
            waypoint.destroy();
          },
          offset: $clientsOffsetPos,
        });
      });
    }

    //if($('.nectar-box-roll').length == 0) clientsFadeIn();

    /*-------------------------------------------------------------------------*/
    /*	2.	Helper Functions
/*-------------------------------------------------------------------------*/

    jQuery.fn.setCursorPosition = function (position) {
      if (this.lengh == 0) return this;
      return $(this).setSelection(position, position);
    };

    jQuery.fn.setSelection = function (selectionStart, selectionEnd) {
      if (this.lengh == 0) return this;
      input = this[0];

      if (input.createTextRange) {
        var range = input.createTextRange();
        range.collapse(true);
        range.moveEnd("character", selectionEnd);
        range.moveStart("character", selectionStart);
        range.select();
      } else if (input.setSelectionRange) {
        input.focus();
        input.setSelectionRange(selectionStart, selectionEnd);
      }

      return this;
    };

    $.extend($.expr[":"], {
      transparent: function (elem, i, attr) {
        return $(elem).css("opacity") === "0";
      },
    });

    function getQueryParams(qs) {
      qs = qs.split("+").join(" ");
      var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

      while ((tokens = re.exec(qs))) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
      }

      return params;
    }

    var $_GET = getQueryParams(document.location.search);

    //count
    var CountUp = function (
      target,
      startVal,
      endVal,
      decimals,
      duration,
      options
    ) {
      // make sure requestAnimationFrame and cancelAnimationFrame are defined
      // polyfill for browsers without native support
      // by Opera engineer Erik Möller
      var lastTime = 0;
      var vendors = ["webkit", "moz", "ms", "o"];
      for (
        var x = 0;
        x < vendors.length && !window.requestAnimationFrame;
        ++x
      ) {
        window.requestAnimationFrame =
          window[vendors[x] + "RequestAnimationFrame"];
        window.cancelAnimationFrame =
          window[vendors[x] + "CancelAnimationFrame"] ||
          window[vendors[x] + "CancelRequestAnimationFrame"];
      }
      if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function (callback, element) {
          var currTime = new Date().getTime();
          var timeToCall = Math.max(0, 16 - (currTime - lastTime));
          var id = window.setTimeout(function () {
            callback(currTime + timeToCall);
          }, timeToCall);
          lastTime = currTime + timeToCall;
          return id;
        };
      }
      if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = function (id) {
          clearTimeout(id);
        };
      }

      var self = this;

      // default options
      self.options = {
        useEasing: true, // toggle easing
        useGrouping: true, // 1,000,000 vs 1000000
        separator: ",", // character to use as a separator
        decimal: ".", // character to use as a decimal
        easingFn: null, // optional custom easing closure function, default is Robert Penner's easeOutExpo
        formattingFn: null, // optional custom formatting function, default is self.formatNumber below
      };
      // extend default options with passed options object
      for (var key in options) {
        if (options.hasOwnProperty(key)) {
          self.options[key] = options[key];
        }
      }
      if (self.options.separator === "") {
        self.options.useGrouping = false;
      }
      if (!self.options.prefix) self.options.prefix = "";
      if (!self.options.suffix) self.options.suffix = "";

      self.d =
        typeof target === "string" ? document.getElementById(target) : target;
      self.startVal = Number(startVal);
      self.endVal = Number(endVal);
      self.countDown = self.startVal > self.endVal;
      self.frameVal = self.startVal;
      self.decimals = Math.max(0, decimals || 0);
      self.dec = Math.pow(10, self.decimals);
      self.duration = Number(duration) * 1000 || 2000;

      self.formatNumber = function (nStr) {
        nStr = nStr.toFixed(self.decimals);
        nStr += "";
        var x, x1, x2, rgx;
        x = nStr.split(".");
        x1 = x[0];
        x2 = x.length > 1 ? self.options.decimal + x[1] : "";
        rgx = /(\d+)(\d{3})/;
        if (self.options.useGrouping) {
          while (rgx.test(x1)) {
            x1 = x1.replace(rgx, "$1" + self.options.separator + "$2");
          }
        }
        return self.options.prefix + x1 + x2 + self.options.suffix;
      };
      // Robert Penner's easeOutExpo
      self.easeOutExpo = function (t, b, c, d) {
        return (c * (-Math.pow(2, (-10 * t) / d) + 1) * 1024) / 1023 + b;
      };

      self.easingFn = self.options.easingFn
        ? self.options.easingFn
        : self.easeOutExpo;
      self.formattingFn = self.options.formattingFn
        ? self.options.formattingFn
        : self.formatNumber;

      self.version = function () {
        return "1.7.1";
      };

      // Print value to target
      self.printValue = function (value) {
        var result = self.formattingFn(value);

        if (self.d.tagName === "INPUT") {
          this.d.value = result;
        } else if (self.d.tagName === "text" || self.d.tagName === "tspan") {
          this.d.textContent = result;
        } else {
          this.d.innerHTML = result;
        }
      };

      self.count = function (timestamp) {
        if (!self.startTime) {
          self.startTime = timestamp;
        }

        self.timestamp = timestamp;
        var progress = timestamp - self.startTime;
        self.remaining = self.duration - progress;

        // to ease or not to ease
        if (self.options.useEasing) {
          if (self.countDown) {
            self.frameVal =
              self.startVal -
              self.easingFn(
                progress,
                0,
                self.startVal - self.endVal,
                self.duration
              );
          } else {
            self.frameVal = self.easingFn(
              progress,
              self.startVal,
              self.endVal - self.startVal,
              self.duration
            );
          }
        } else {
          if (self.countDown) {
            self.frameVal =
              self.startVal -
              (self.startVal - self.endVal) * (progress / self.duration);
          } else {
            self.frameVal =
              self.startVal +
              (self.endVal - self.startVal) * (progress / self.duration);
          }
        }

        // don't go past endVal since progress can exceed duration in the last frame
        if (self.countDown) {
          self.frameVal =
            self.frameVal < self.endVal ? self.endVal : self.frameVal;
        } else {
          self.frameVal =
            self.frameVal > self.endVal ? self.endVal : self.frameVal;
        }

        // decimal
        self.frameVal = Math.round(self.frameVal * self.dec) / self.dec;

        // format and print value
        self.printValue(self.frameVal);

        // whether to continue
        if (progress < self.duration) {
          self.rAF = requestAnimationFrame(self.count);
        } else {
          if (self.callback) {
            self.callback();
          }
        }
      };
      // start your animation
      self.start = function (callback) {
        self.callback = callback;
        self.rAF = requestAnimationFrame(self.count);
        return false;
      };
      // toggles pause/resume animation
      self.pauseResume = function () {
        if (!self.paused) {
          self.paused = true;
          cancelAnimationFrame(self.rAF);
        } else {
          self.paused = false;
          delete self.startTime;
          self.duration = self.remaining;
          self.startVal = self.frameVal;
          requestAnimationFrame(self.count);
        }
      };
      // reset to startVal so animation can be run again
      self.reset = function () {
        self.paused = false;
        delete self.startTime;
        self.startVal = startVal;
        cancelAnimationFrame(self.rAF);
        self.printValue(self.startVal);
      };
      // pass a new endVal and start animation
      self.update = function (newEndVal) {
        cancelAnimationFrame(self.rAF);
        self.paused = false;
        delete self.startTime;
        self.startVal = self.frameVal;
        self.endVal = Number(newEndVal);
        self.countDown = self.startVal > self.endVal;
        self.rAF = requestAnimationFrame(self.count);
      };

      // format startVal on initialization
      self.printValue(self.startVal);
    };

    var easeOutCubic = function (t, b, c, d) {
      return c * ((t = t / d - 1) * t * t + 1) + b;
    };

    /*-------------------------------------------------------------------------*/
    /*	3.	Shortcode Stuff
/*-------------------------------------------------------------------------*/

    function vcWaypoints() {
      $($fullscreenSelector + " .wpb_animate_when_almost_visible").each(
        function () {
          var $vcOffsetPos =
            $("#nectar_fullscreen_rows").length > 0 ? "200%" : "90%";

          var $that = $(this);
          var waypoint = new Waypoint({
            element: $that,
            handler: function (direction) {
              if (
                ($that.parents(".wpb_tab").length > 0 &&
                  $that.parents(".wpb_tab").css("visibility") == "hidden") ||
                $that.hasClass("animated")
              ) {
                waypoint.destroy();
                return;
              }
              $that.addClass("animated");
              $that.addClass("wpb_start_animation");
              waypoint.destroy();
            },
            offset: $vcOffsetPos,
          });
        }
      );
    }

    /***************** Milestone Counter ******************/

    function milestoneInit() {
      $(".nectar-milestone").each(function () {
        //symbol
        if ($(this).is("[data-symbol]")) {
          if ($(this).find(".symbol-wrap").length == 0) {
            if ($(this).attr("data-symbol-pos") == "before") {
              $(this)
                .find(".number")
                .prepend(
                  '<div class="symbol-wrap"><span class="symbol">' +
                    $(this).attr("data-symbol") +
                    "</span></div>"
                );
            } else {
              $(this)
                .find(".number")
                .append(
                  '<div class="symbol-wrap"><span class="symbol">' +
                    $(this).attr("data-symbol") +
                    "</span></div>"
                );
            }
          }

          $symbol_size =
            $(this).attr("data-symbol-size") ==
              $(this).find(".number").attr("data-number-size") &&
            $(this).attr("data-symbol-alignment") == "superscript"
              ? 32
              : parseInt($(this).attr("data-symbol-size"));

          $(this)
            .find(".symbol-wrap")
            .css({
              "font-size": $symbol_size + "px",
              "line-height": $symbol_size + "px",
            });
        }

        $(this)
          .find(".number")
          .css({
            "font-size":
              $(this).find(".number").attr("data-number-size") + "px",
            "line-height":
              $(this).find(".number").attr("data-number-size") + "px",
          });
      });

      if (!$("body").hasClass("mobile") && $(".nectar-milestone").length > 0) {
        //blur effect
        var $blurCssString = "";
        $($fullscreenSelector + ".nectar-milestone.motion_blur").each(function (
          i
        ) {
          $(this).addClass("instance-" + i);

          var $currentColor = $(this).find(".number").css("color");
          var colorInt = parseInt($currentColor.substring(1), 16);
          var R = (colorInt & 0xff0000) >> 16;
          var G = (colorInt & 0x00ff00) >> 8;
          var B = (colorInt & 0x0000ff) >> 0;

          var $rgbaColorStart = "rgba(" + R + "," + G + "," + B + ",0.2)";
          var $rgbaColorEnd = "rgba(" + R + "," + G + "," + B + ",1)";
          var $numberSize = parseInt(
            $(this).find(".number").attr("data-number-size")
          );

          $blurCssString +=
            "@keyframes motion-blur-number-" +
            i +
            " { " +
            " 0% { " +
            "opacity: 0;" +
            "color: " +
            $rgbaColorStart +
            "; " +
            "text-shadow: 0 " +
            $numberSize / 20 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 " +
            $numberSize / 10 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 " +
            $numberSize / 6 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 " +
            $numberSize / 5 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 " +
            $numberSize / 4 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 -" +
            $numberSize / 20 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 -" +
            $numberSize / 10 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 -" +
            $numberSize / 6 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 -" +
            $numberSize / 5 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 -" +
            $numberSize / 4 +
            "px 0 " +
            $rgbaColorStart +
            "; " +
            "transform: translateZ(0px) translateY(-100%); " +
            "-webkit-transform: translateZ(0px) translateY(-100%); " +
            "} " +
            "33% { opacity: 1 }" +
            "100% { " +
            "color: " +
            $rgbaColorEnd +
            "; " +
            "text-shadow: none; " +
            "transform: translateZ(0px) translateY(0px); " +
            "-webkit-transform: translateZ(0px) translateY(0px); " +
            "} " +
            "} " +
            "@-webkit-keyframes motion-blur-number-" +
            i +
            " { " +
            " 0% { " +
            "opacity: 0;" +
            "color: " +
            $rgbaColorStart +
            "; " +
            "text-shadow: 0 " +
            $numberSize / 20 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 " +
            $numberSize / 10 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 " +
            $numberSize / 6 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 " +
            $numberSize / 5 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 " +
            $numberSize / 4 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 -" +
            $numberSize / 20 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 -" +
            $numberSize / 10 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 -" +
            $numberSize / 6 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 -" +
            $numberSize / 5 +
            "px 0 " +
            $rgbaColorStart +
            ", 0 -" +
            $numberSize / 4 +
            "px 0 " +
            $rgbaColorStart +
            "; " +
            "transform: translateZ(0px) translateY(-100%); " +
            "-webkit-transform: translateZ(0px) translateY(-100%); " +
            "} " +
            "33% { opacity: 1 }" +
            "100% { " +
            "color: " +
            $rgbaColorEnd +
            "; " +
            "text-shadow: none; " +
            "transform: translateZ(0px) translateY(0px); " +
            "-webkit-transform: translateZ(0px) translateY(0px); " +
            "} " +
            "} " +
            ".nectar-milestone.motion_blur.instance-" +
            i +
            " .number span.in-sight { animation: 0.65s cubic-bezier(0, 0, 0.17, 1) 0s normal backwards 1 motion-blur-number-" +
            i +
            "; -webkit-animation: 0.65s cubic-bezier(0, 0, 0.17, 1) 0s normal backwards 1 motion-blur-number-" +
            i +
            "; } ";

          //separate each character into spans
          $symbol = $(this).find(".symbol-wrap").clone();
          $(this).find(".symbol-wrap").remove();
          var characters = $(this).find(".number").text().split("");
          $this = $(this).find(".number");
          $this.empty();
          $.each(characters, function (i, el) {
            $this.append("<span>" + el + "</span");
          });

          //handle symbol
          if ($(this).has("[data-symbol]")) {
            if ($(this).attr("data-symbol-pos") == "after") {
              $this.append($symbol);
            } else {
              $this.prepend($symbol);
            }
          }
        });

        var head = document.head || document.getElementsByTagName("head")[0];
        var style = document.createElement("style");

        style.type = "text/css";
        if (style.styleSheet) {
          style.styleSheet.cssText = $blurCssString;
        } else {
          style.appendChild(document.createTextNode($blurCssString));
        }
        $(style).attr("id", "milestone-blur");
        $("head #milestone-blur").remove();
        head.appendChild(style);

        //activate
        milestoneWaypoint();
      }
    }

    function milestoneWaypoint() {
      $($fullscreenSelector + ".nectar-milestone").each(function () {
        //animation
        var $offset = $(this).hasClass("motion_blur") ? "90%" : "105%";

        var $that = $(this);
        var waypoint = new Waypoint({
          element: $that,
          handler: function (direction) {
            if (
              ($that.parents(".wpb_tab").length > 0 &&
                $that.parents(".wpb_tab").css("visibility") == "hidden") ||
              $that.hasClass("animated-in")
            ) {
              waypoint.destroy();
              return;
            }

            var $endNum = parseInt(
              $that.find(".number span:not(.symbol)").text()
            );
            if (!$that.hasClass("motion_blur")) {
              var countOptions = { easingFn: easeOutCubic };
              var $countEle = $that.find(".number span:not(.symbol)")[0];
              var numAnim = new CountUp(
                $countEle,
                0,
                $endNum,
                0,
                2.2,
                countOptions
              );
              numAnim.start();
            } else {
              $that.find("span").each(function (i) {
                var $that = $(this);
                setTimeout(function () {
                  $that.addClass("in-sight");
                }, 200 * i);
              });
            }

            $that.addClass("animated-in");
            waypoint.destroy();
          },
          offset: "bottom-in-view",
        });
      });
    }

    var $animationOnScrollTimeOut =
      $(".nectar-box-roll").length > 0 ? 850 : 125;
    //if($('.nectar-box-roll').length == 0) setTimeout(function(){  milestoneInit(); },125);

    /***************** Tabbed ******************/

    $tabbedClickCount = 0;
    $("body").on("click", ".tabbed > ul li:not(.cta-button) a", function () {
      var $id = $(this).parents("li").index() + 1;

      if (!$(this).hasClass("active-tab") && !$(this).hasClass("loading")) {
        $(this).parents("ul").find("a").removeClass("active-tab");
        $(this).addClass("active-tab");

        $(this)
          .parents(".tabbed")
          .find("> div:not(.clear)")
          .css({
            visibility: "hidden",
            position: "absolute",
            opacity: "0",
            left: "-9999px",
            display: "none",
          });
        $(this)
          .parents(".tabbed")
          .find("> div:nth-of-type(" + $id + ")")
          .css({
            visibility: "visible",
            position: "relative",
            left: "0",
            display: "block",
          })
          .stop()
          .transition({ opacity: 1 }, 300);

        if (
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ") .iframe-embed").length > 0 ||
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ") .portfolio-items").length > 0
        )
          setTimeout(function () {
            $(window).resize();
          }, 10);
      }

      //waypoint checking
      if ($tabbedClickCount != 0) {
        if (
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find(".nectar-progress-bar").length > 0
        )
          progressBars();
        if (
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find('.divider-small-border [data-animate="yes"]').length > 0 ||
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find('.divider-border [data-animate="yes"]').length > 0
        )
          dividers();
        if (
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find("img.img-with-animation").length > 0 ||
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find(".col.has-animation").length > 0 ||
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find(".nectar_cascading_images").length > 0 ||
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find(".wpb_column.has-animation").length > 0
        ) {
          colAndImgAnimations();
          cascadingImageBGSizing();
        }
        if (
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find(".nectar-milestone").length > 0
        )
          milestoneWaypoint();
        if (
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find('.nectar_image_with_hotspots[data-animation="true"]').length >
          0
        )
          imageWithHotspots();
        if (
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find(".nectar-fancy-ul").length > 0
        )
          nectar_fancy_ul_init();
        if (
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find(".nectar-split-heading").length > 0
        )
          splitLineHeadings();
        if (
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find('.wpb_column[data-border-animation="true"]').length > 0
        ) {
          animatedColBorders();
        }
        if (
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find(".wpb_animate_when_almost_visible").length > 0
        ) {
          vcWaypoints();
        }
        if (
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find(".nectar-animated-title").length > 0
        ) {
          animated_titles();
        }
        if (
          $(this)
            .parents(".tabbed")
            .find("> div:nth-of-type(" + $id + ")")
            .find(".nectar_food_menu_item").length > 0
        ) {
          foodMenuItems();
        }
        if ($(this).parents(".wpb_row").length > 0) {
          if (
            $(this)
              .parents(".tabbed")
              .find("> div:nth-of-type(" + $id + ")")
              .find(".vc_pie_chart").length > 0 ||
            $(this)
              .parents(".tabbed")
              .find("> div:nth-of-type(" + $id + ")")
              .find(".wp-video-shortcode").length > 0 ||
            $(this)
              .parents(".tabbed")
              .find("> div:nth-of-type(" + $id + ")")
              .find(".twentytwenty-container").length > 0 ||
            $(this).parents(".wpb_row").next().hasClass("parallax_section")
          )
            $(window).trigger("resize");

          if (
            $(this)
              .parents(".tabbed")
              .find("> div:nth-of-type(" + $id + ")")
              .find(".nectar-flickity").length > 0
          )
            $(".nectar-flickity:not(.masonry)").flickity("resize");
        }

        //svg icons

        $(this)
          .parents(".tabbed")
          .find("> div:nth-of-type(" + $id + ")")
          .find(".svg-icon-holder")
          .each(function (i) {
            var $that = $(this);

            setTimeout(function () {
              var $animationDelay =
                $(this).is("[data-animation-delay]") &&
                $(this).attr("data-animation-delay").length > 0 &&
                $(this).attr("data-animation") != "false"
                  ? $(this).attr("data-animation-delay")
                  : 0;

              clearTimeout($animatedSVGIconTimeout[i]);

              if ($that.attr("data-animation") == "false") {
                $animationSpeed = 1;
                $that.css("opacity", "1");
                $svg_icons[$that.attr("id").slice(-1)].finish();
              } else {
                $svg_icons[$that.attr("id").slice(-1)].reset();
                $animatedSVGIconTimeout[i] = setTimeout(function () {
                  $svg_icons[$that.attr("id").slice(-1)].play();
                }, $animationDelay);
              }
            }, 150);
          });
      }

      //fix columns inside tabs
      $(this)
        .parents(".tabbed")
        .find(".wpb_row")
        .each(function () {
          if (
            typeof $(this).find('[class*="vc_col-"]').first().offset() !=
            "undefined"
          ) {
            var $firstChildOffset = $(this)
              .find('[class*="vc_col-"]')
              .first()
              .offset().left;
            $(this)
              .find('[class*="vc_col-"]')
              .each(function () {
                $(this).removeClass("no-left-margin");
                if ($(this).offset().left < $firstChildOffset + 15) {
                  $(this).addClass("no-left-margin");
                } else {
                  $(this).removeClass("no-left-margin");
                }
              });
          }
        });

      $tabbedClickCount++;

      //magic line
      if ($(this).parent().parent().find(".magic-line").length > 0) {
        magicLineCalc($(this));
      }

      return false;
    });

    function magicLineCalc($ele) {
      var el, leftPos, ratio;
      el = $ele.parent();
      if (el.length) {
        leftPos = el.position().left;
        ratio = el.width();
      } else {
        leftPos = ratio = 0;
      }

      $ele
        .parent()
        .parent()
        .find(".magic-line")
        .css(
          "transform",
          "translateX(" + leftPos + "px) scaleX(" + ratio + ")"
        );
    }

    //make sure the tabs don't have a nectar slider - we'll init this after the sliders load in that case
    function tabbedInit() {
      $(".tabbed").each(function () {
        if (
          $(this).find(".swiper-container").length == 0 &&
          $(this).find(".testimonial_slider").length == 0 &&
          $(this).find('.portfolio-items:not(".carousel")').length == 0 &&
          $(this).find(".wpb_gallery .portfolio-items").length == 0 &&
          $(this).find("iframe").length == 0
        ) {
          $(this).find("> ul li:first-child a").click();
        }
        if (
          $(this).find(".testimonial_slider").length > 0 ||
          $(this).find('.portfolio-items:not(".carousel")').length > 0 ||
          $(this).find(".wpb_gallery .portfolio-items").length > 0 ||
          $(this).find("iframe").length > 0
        ) {
          var $that = $(this);

          $(this).find(".wpb_tab").show().css({ opacity: 0, height: "1px" });
          $(this).find("> ul li a").addClass("loading");

          setTimeout(function () {
            $that.find(".wpb_tab").hide().css({ opacity: 1, height: "auto" });
            $that.find("> ul li a").removeClass("loading");
            $that.find("> ul li:first-child a").click();
          }, 900);
        }

        var $that = $(this);
        //minimal alt effect
        setTimeout(function () {
          if ($that.is('[data-style="minimal_alt"]')) {
            $that.find("> ul").append('<li class="magic-line" />');
            magicLineCalc($that.find("> ul > li:first-child > a"));
          }
        }, 100);
      });
    }
    tabbedInit();

    //deep linking
    function tabbbedDeepLinking() {
      if (typeof $_GET["tab"] != "undefined") {
        $(".wpb_tabs_nav").each(function () {
          $(this)
            .find("li")
            .each(function () {
              var $currentText = $(this).find("a").text();
              var $getText = $_GET["tab"];
              var $that = $(this);

              $currentText = $currentText.replace(/\s+/g, "-").toLowerCase();
              $getText = $getText
                .replace(/\s+/g, "-")
                .replace(/</g, "&lt;")
                .replace(/"/g, "&quot;")
                .toLowerCase();

              if ($currentText == $getText) {
                $(this).find("a").click();
                setTimeout(function () {
                  $that.find("a").click();
                }, 901);
              }
            });
        });
      }
    }
    tabbbedDeepLinking();

    /***************** Toggle ******************/

    //toggles
    $("body").on("click", ".toggle h3 a", function () {
      if (!$(this).parents(".toggles").hasClass("accordion")) {
        $(this).parents(".toggle").find("> div").slideToggle(300);
        $(this).parents(".toggle").toggleClass("open");

        //switch icon
        if ($(this).parents(".toggle").hasClass("open")) {
          $(this).find("i").attr("class", "icon-minus-sign");
        } else {
          $(this).find("i").attr("class", "icon-plus-sign");
        }

        if (
          $(this).parents(".toggle").find("> div .iframe-embed").length > 0 &&
          $(this)
            .parents(".toggle")
            .find("> div .iframe-embed iframe")
            .height() == "0"
        )
          responsiveVideoIframes();
        if ($(this).parents(".full-width-content").length > 0)
          setTimeout(function () {
            fullWidthContentColumns();
          }, 300);
        if ($("#nectar_fullscreen_rows").length > 0)
          setTimeout(function () {
            $(window).trigger("smartresize");
          }, 300);
        return false;
      }
    });

    //accordion
    $("body").on("click", ".accordion .toggle h3 a", function () {
      if ($(this).parents(".toggle").hasClass("open")) return false;

      $(this).parents(".toggles").find(".toggle > div").slideUp(300);
      $(this)
        .parents(".toggles")
        .find(".toggle h3 a i")
        .attr("class", "icon-plus-sign");
      $(this).parents(".toggles").find(".toggle").removeClass("open");

      $(this).parents(".toggle").find("> div").slideDown(300);
      $(this).parents(".toggle").addClass("open");

      //switch icon
      if ($(this).parents(".toggle").hasClass("open")) {
        $(this).find("i").attr("class", "icon-minus-sign");
      } else {
        $(this).find("i").attr("class", "icon-plus-sign");
      }

      if ($(this).parents(".full-width-content").length > 0) {
        clearTimeout($t);
        var $t = setTimeout(function () {
          fullWidthContentColumns();
        }, 400);
      }
      if ($("#nectar_fullscreen_rows").length > 0) {
        clearTimeout($t);
        var $t = setTimeout(function () {
          $(window).trigger("smartresize");
        }, 400);
      }

      return false;
    });

    //accordion start open
    function accordionInit() {
      $(".accordion").each(function () {
        $(this).find("> .toggle").first().addClass("open").find("> div").show();
        $(this)
          .find("> .toggle")
          .first()
          .find("a i")
          .attr("class", "icon-minus-sign");
      });

      $(".toggles").each(function () {
        var $isAccordion = $(this).hasClass("accordion") ? true : false;

        $(this)
          .find(".toggle")
          .each(function () {
            if (
              $(this).find("> div .testimonial_slider").length > 0 ||
              $(this).find("> div iframe").length > 0
            ) {
              var $that = $(this);
              $(this)
                .find("> div")
                .show()
                .css({ opacity: 0, height: "1px", padding: "0" });

              testimonialHeightResize();

              setTimeout(function () {
                $that
                  .find("> div")
                  .hide()
                  .css({ opacity: 1, height: "auto", padding: "10px 14px" });
                if ($isAccordion == true && $that.index() == 0)
                  $that.find("> div").slideDown(300);
              }, 900);
            }
          });
      });
    }
    accordionInit();

    //deep linking
    function accordionDeepLinking() {
      if (typeof $_GET["toggle"] != "undefined") {
        $(".toggles").each(function () {
          $(this)
            .find(".toggle")
            .each(function () {
              var $currentText = $(this).find("h3 a").clone();
              var $getText = $_GET["toggle"];

              $($currentText).find("i").remove();
              $currentText = $currentText.text();
              $currentText = $currentText.replace(/\s+/g, "-").toLowerCase();
              $getText = $getText
                .replace(/\s+/g, "-")
                .replace(/</g, "&lt;")
                .replace(/"/g, "&quot;")
                .toLowerCase();

              if ($currentText == $getText) $(this).find("h3 a").click();
            });
        });
      }
    }
    accordionDeepLinking();

    /***************** Button ******************/

    $.cssHooks.color = {
      get: function (elem) {
        if (elem.currentStyle) var color = elem.currentStyle["color"];
        else if (window.getComputedStyle)
          var color = document.defaultView
            .getComputedStyle(elem, null)
            .getPropertyValue("color");
        if (color.search("rgb") == -1) return color;
        else {
          color = color.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
          function hex(x) {
            return ("0" + parseInt(x).toString(16)).slice(-2);
          }
          if (color) {
            return "#" + hex(color[1]) + hex(color[2]) + hex(color[3]);
          }
        }
      },
    };

    $.cssHooks.backgroundColor = {
      get: function (elem) {
        if (elem.currentStyle) var bg = elem.currentStyle["backgroundColor"];
        else if (window.getComputedStyle)
          var bg = document.defaultView
            .getComputedStyle(elem, null)
            .getPropertyValue("background-color");
        if (bg.search("rgb") == -1) return bg;
        else {
          bg = bg.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
          function hex(x) {
            return ("0" + parseInt(x).toString(16)).slice(-2);
          }
          if (bg) {
            return "#" + hex(bg[1]) + hex(bg[2]) + hex(bg[3]);
          }
        }
      },
    };

    function shadeColor(hex, lum) {
      // validate hex string
      hex = String(hex).replace(/[^0-9a-f]/gi, "");
      if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      lum = lum || 0;

      // convert to decimal and change luminosity
      var rgb = "#",
        c,
        i;
      for (i = 0; i < 3; i++) {
        c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
        rgb += ("00" + c).substr(c.length);
      }

      return rgb;
    }

    //color
    function coloredButtons() {
      $(
        ".nectar-button.see-through[data-color-override], .nectar-button.see-through-2[data-color-override], .nectar-button.see-through-3[data-color-override]"
      ).each(function () {
        $(this).css("visibility", "visible");

        if (
          $(this).hasClass("see-through-3") &&
          $(this).attr("data-color-override") == "false"
        ) {
          return true;
        }
        //if($(this).attr('data-color-override') != 'false'){

        if ($(this).attr("data-color-override") != "false") {
          var $color = $(this).attr("data-color-override");
        } else {
          if ($(this).parents(".dark").length > 0) var $color = "#000000";
          else var $color = "#ffffff";
        }

        if (!$(this).hasClass("see-through-3")) $(this).css("color", $color);
        $(this).find("i").css("color", $color);

        var colorInt = parseInt($color.substring(1), 16);
        var $hoverColor = $(this).has("[data-hover-color-override]")
          ? $(this).attr("data-hover-color-override")
          : "no-override";
        var $hoverTextColor = $(this).has("[data-hover-text-color-override]")
          ? $(this).attr("data-hover-text-color-override")
          : "#fff";

        var R = (colorInt & 0xff0000) >> 16;
        var G = (colorInt & 0x00ff00) >> 8;
        var B = (colorInt & 0x0000ff) >> 0;

        $opacityStr = $(this).hasClass("see-through-3") ? "1" : "0.75";

        $(this).css(
          "border-color",
          "rgba(" + R + "," + G + "," + B + "," + $opacityStr + ")"
        );

        if ($(this).hasClass("see-through")) {
          $(this).hover(
            function () {
              $(this).css(
                "border-color",
                "rgba(" + R + "," + G + "," + B + ",1)"
              );
            },
            function () {
              $opacityStr = $(this).hasClass("see-through-3") ? "1" : "0.75";
              $(this).css(
                "border-color",
                "rgba(" + R + "," + G + "," + B + "," + $opacityStr + ")"
              );
            }
          );
        } else {
          $(this).find("i").css("color", $hoverTextColor);

          if ($hoverColor != "no-override") {
            $(this).hover(
              function () {
                $(this).css({
                  "border-color": $hoverColor,
                  "background-color": $hoverColor,
                  color: $hoverTextColor,
                });
              },
              function () {
                $opacityStr = $(this).hasClass("see-through-3") ? "1" : "0.75";

                if (!$(this).hasClass("see-through-3")) {
                  $(this).css({
                    "border-color":
                      "rgba(" + R + "," + G + "," + B + "," + $opacityStr + ")",
                    "background-color": "transparent",
                    color: $color,
                  });
                } else {
                  $(this).css({
                    "border-color":
                      "rgba(" + R + "," + G + "," + B + "," + $opacityStr + ")",
                    "background-color": "transparent",
                  });
                }
              }
            );
          } else {
            $(this).hover(
              function () {
                $(this).css({
                  "border-color": $hoverColor,
                  color: $hoverTextColor,
                });
              },
              function () {
                $opacityStr = $(this).hasClass("see-through-3") ? "1" : "0.75";
                $(this).css({
                  "border-color":
                    "rgba(" + R + "," + G + "," + B + "," + $opacityStr + ")",
                  color: $hoverTextColor,
                });
              }
            );
          }
          //	}
        }
      });

      $(
        ".nectar-button:not(.see-through):not(.see-through-2):not(.see-through-3)[data-color-override]"
      ).each(function () {
        $(this).css("visibility", "visible");

        if ($(this).attr("data-color-override") != "false") {
          var $color = $(this).attr("data-color-override");
          $(this)
            .removeClass("accent-color")
            .removeClass("extra-color-1")
            .removeClass("extra-color-2")
            .removeClass("extra-color-3");
          $(this).css("background-color", $color);
        }
      });

      //solid color tilt
      if (
        $(".swiper-slide .solid_color_2").length > 0 ||
        $(".tilt-button-inner").length > 0
      ) {
        var $tiltButtonCssString = "";

        $(".swiper-slide .solid_color_2 a").each(function (i) {
          $(this).addClass("instance-" + i);

          if ($(this).attr("data-color-override") != "false") {
            var $color = $(this).attr("data-color-override");
          } else {
            if ($(this).parents(".dark").length > 0) var $color = "#000000";
            else var $color = "#ffffff";
          }

          $(this).css("color", $color);
          $(this).find("i").css("color", $color);

          var $currentColor = $(this).css("background-color");
          var $topColor = shadeColor($currentColor, 0.13);
          var $bottomColor = shadeColor($currentColor, -0.15);

          $tiltButtonCssString +=
            ".swiper-slide .solid_color_2 a.instance-" +
            i +
            ":after { background-color: " +
            $topColor +
            ";  }" +
            " .swiper-slide .solid_color_2 a.instance-" +
            i +
            ":before { background-color: " +
            $bottomColor +
            "; } ";
        });

        $(".tilt-button-wrap a").each(function (i) {
          $(this).addClass("instance-" + i);

          var $currentColor = $(this).css("background-color");

          if ($(this).attr("data-color-override") != "false") {
            var $color = $(this).attr("data-color-override");
            $(this).css("background-color", $color);
            $currentColor = $color;
          }

          var $topColor = shadeColor($currentColor, 0.13);
          var $bottomColor = shadeColor($currentColor, -0.15);

          $tiltButtonCssString +=
            ".tilt-button-wrap a.instance-" +
            i +
            ":after { background-color: " +
            $topColor +
            ";  }" +
            " .tilt-button-wrap a.instance-" +
            i +
            ":before { background-color: " +
            $bottomColor +
            "; } ";
        });

        var head = document.head || document.getElementsByTagName("head")[0];
        var style = document.createElement("style");

        style.type = "text/css";
        if (style.styleSheet) {
          style.styleSheet.cssText = $tiltButtonCssString;
        } else {
          style.appendChild(document.createTextNode($tiltButtonCssString));
        }

        head.appendChild(style);
      }

      //transparent 3d
      if ($(".nectar-3d-transparent-button").length > 0) {
        var $3dTransButtonCssString = "";
        $(".nectar-3d-transparent-button").each(function (i) {
          var $that = $(this);
          var $size = $that.attr("data-size");
          var $padding = 0;

          //size

          if ($size == "large") {
            $padding = 46;
            $font_size = 16;
          } else if ($size == "medium") {
            $padding = 30;
            $font_size = 16;
          } else if ($size == "small") {
            $padding = 20;
            $font_size = 12;
          } else if ($size == "jumbo") {
            $padding = 54;
            $font_size = 24;
          } else if ($size == "extra_jumbo") {
            $padding = 100;
            $font_size = 64;
          }

          $that.find("svg text").attr("font-size", $font_size);
          $boundingRect = $(this)
            .find(".back-3d .button-text")[0]
            .getBoundingClientRect();

          $text_width = $boundingRect.width;
          $text_height = $font_size * 1.5;

          $extraMult =
            navigator.userAgent.toLowerCase().indexOf("firefox") > -1 ? 0 : 1;

          $that.css({
            width: $text_width + $padding * 1.5 + "px",
            height: $text_height + $padding + "px",
          });
          $that.find("> a").css({ height: $text_height + $padding + "px" });

          $that
            .find(".back-3d svg, .front-3d svg")
            .css({
              width: $text_width + $padding * 1.5 + "px",
              height: $text_height + $padding + "px",
            })
            .attr(
              "viewBox",
              "0 0 " +
                ($text_width + $padding) +
                " " +
                ($text_height + $padding)
            );
          if ($size == "jumbo")
            $that
              .find("svg text")
              .attr(
                "transform",
                "matrix(1 0 0 1 " +
                  ($text_width + $padding * 1.5) / 2 +
                  " " +
                  ($text_height + $padding) / 1.68 +
                  ")"
              );
          else if ($size == "extra_jumbo")
            $that
              .find("svg text")
              .attr(
                "transform",
                "matrix(1 0 0 1 " +
                  ($text_width + $padding * 1.6) / 2 +
                  " " +
                  ($text_height + $padding) / 1.6 +
                  ")"
              );
          else if ($size == "large") {
            $that
              .find("svg text")
              .attr(
                "transform",
                "matrix(1 0 0 1 " +
                  ($text_width + $padding * 1.5) / 2 +
                  " " +
                  ($text_height + $padding) / 1.7 +
                  ")"
              );
          } else {
            $that
              .find("svg text")
              .attr(
                "transform",
                "matrix(1 0 0 1 " +
                  ($text_width + $padding * 1.5) / 2 +
                  " " +
                  ($text_height + $padding) / 1.65 +
                  ")"
              );
          }
          $that
            .find(".front-3d ")
            .css(
              "transform-origin",
              "50% 50% -" + ($text_height + $padding) / 2 + "px"
            );
          $that
            .find(".back-3d")
            .css(
              "transform-origin",
              "50% 50% -" + ($text_height + $padding) / 2 + "px"
            );

          //mask
          $(this)
            .find(".front-3d svg > rect")
            .attr("id", "masked-rect-id-" + i);
          $(this)
            .find(".front-3d defs mask")
            .attr("id", "button-text-mask-" + i);

          $that.css("visibility", "visible");
          $3dTransButtonCssString +=
            "#masked-rect-id-" +
            i +
            " { mask: url(#button-text-mask-" +
            i +
            "); -webkit-mask: url(#button-text-mask-" +
            i +
            ")} ";
        });

        //extra jumbo resize
        function createExtraJumboSize() {
          $(".nectar-3d-transparent-button").each(function (i) {
            if ($(this).css("visibility") != "visible") return;

            var $that = $(this);
            var $size = $that.attr("data-size");
            if ($size == "extra_jumbo") {
              $extraMult =
                navigator.userAgent.toLowerCase().indexOf("firefox") > -1
                  ? 0
                  : 1;

              if (window.innerWidth < 1000 && window.innerWidth > 690) {
                $padding = 64;
                $font_size = 34;
                $that.find(".back-3d rect").attr("stroke-width", "12");
                $vert_height_divider = 1.7;
              } else if (window.innerWidth <= 690) {
                $padding = 46;
                $font_size = 16;
                $that.find(".back-3d rect").attr("stroke-width", "10");
                $vert_height_divider = 1.7;
              } else {
                $padding = 100;
                $font_size = 64;
                $that.find(".back-3d rect").attr("stroke-width", "20");
                $vert_height_divider = 1.6;
              }

              $that.find("svg text").attr("font-size", $font_size);

              $boundingRect = $(this)
                .find(".back-3d .button-text")[0]
                .getBoundingClientRect();
              $text_width = $boundingRect.width;
              $text_height = $font_size * 1.5;

              $that.css({
                width: $text_width + $padding * 1.5 + "px",
                height: $text_height + $padding + "px",
              });
              $that.find("> a").css({ height: $text_height + $padding + "px" });

              $that
                .find(".back-3d svg, .front-3d svg")
                .css({
                  width: $text_width + $padding * 1.5 + "px",
                  height: $text_height + $padding + "px",
                })
                .attr(
                  "viewBox",
                  "0 0 " +
                    ($text_width + $padding) +
                    " " +
                    ($text_height + $padding)
                );

              $that
                .find("svg text")
                .attr(
                  "transform",
                  "matrix(1 0 0 1 " +
                    ($text_width + $padding * 1.6) / 2 +
                    " " +
                    ($text_height + $padding) / $vert_height_divider +
                    ")"
                );

              $that
                .find(".front-3d ")
                .css(
                  "transform-origin",
                  "50% 50% -" + ($text_height + $padding) / 2 + "px"
                );
              $that
                .find(".back-3d")
                .css(
                  "transform-origin",
                  "50% 50% -" + ($text_height + $padding) / 2 + "px"
                );
            }
          });
        }
        createExtraJumboSize();
        $(window).on("smartresize", createExtraJumboSize);

        var head = document.head || document.getElementsByTagName("head")[0];
        var style = document.createElement("style");

        style.type = "text/css";
        if (style.styleSheet) {
          style.styleSheet.cssText = $3dTransButtonCssString;
        } else {
          style.appendChild(document.createTextNode($3dTransButtonCssString));
        }

        head.appendChild(style);
      }

      //gradient btn init
      setTimeout(function () {
        $(
          ".nectar-button.extra-color-gradient-1 .start, .nectar-button.extra-color-gradient-2 .start, .nectar-button.see-through-extra-color-gradient-1 .start, .nectar-button.see-through-extra-color-gradient-2 .start"
        ).removeClass("loading");
      }, 150);
      //no grad for ff
      if (
        navigator.userAgent.toLowerCase().indexOf("firefox") > -1 ||
        navigator.userAgent.indexOf("MSIE ") > -1 ||
        navigator.userAgent.match(/Trident\/7\./)
      ) {
        $(
          ".nectar-button.extra-color-gradient-1, .nectar-button.extra-color-gradient-2, .nectar-button.see-through-extra-color-gradient-1, .nectar-button.see-through-extra-color-gradient-2"
        ).addClass("no-text-grad");
      }
    }

    coloredButtons();

    //large icon hover
    function largeIconHover() {
      $(".icon-3x").each(function () {
        $(this)
          .closest(".col")
          .hover(
            function () {
              $(this).find(".icon-3x").addClass("hovered");
            },
            function () {
              $(".icon-3x").removeClass("hovered");
            }
          );
      });

      //remove gradient from FF
      if (
        navigator.userAgent.toLowerCase().indexOf("firefox") > -1 ||
        navigator.userAgent.indexOf("MSIE ") > -1 ||
        navigator.userAgent.match(/Trident\/7\./)
      )
        $(
          '[class^="icon-"].extra-color-gradient-1, [class^="icon-"].extra-color-gradient-2, [class^="icon-"][data-color="extra-color-gradient-1"], [class^="icon-"][data-color="extra-color-gradient-2"], .nectar_icon_wrap[data-color*="extra-color-gradient"] .nectar_icon, .nectar-gradient-text'
        ).addClass("no-grad");
    }
    largeIconHover();

    /***************** Team Member ******************/
    function teamMemberFullscreen() {
      //open
      $("body").on(
        "click",
        '.team-member[data-style="bio_fullscreen"]',
        function () {
          if ($(".nectar_team_member_overlay").length > 0) return;

          var $usingBoxedClass =
            $("body > #boxed").length > 0 ? "in-boxed" : null;

          $teamMemberMeta = $(this).find(".nectar_team_bio").html();
          $teamMemberImg =
            $(this).find(".nectar_team_bio_img[data-img-src]").length > 0
              ? $(this).find(".nectar_team_bio_img").attr("data-img-src")
              : "";
          $("body").append(
            '<div class="nectar_team_member_overlay ' +
              $usingBoxedClass +
              '"><div class="inner-wrap"><div class="team_member_details"><h2>' +
              $(this).find(".team-meta h3").html() +
              '</h2><div class="title">' +
              $(this).find(".team-meta p").html() +
              '</div><div class="team-desc">' +
              $teamMemberMeta +
              '</div></div><div class="team_member_picture"><div class="team_member_image_bg_cover"></div><div class="team_member_picture_wrap"><div class="team_member_image"></div></div></div></div></div><div class="nectar_team_member_close ' +
              $usingBoxedClass +
              '"><div class="inner"></div></div>'
          );
          if ($teamMemberImg.length > 0) {
            //fadein img on load
            var teamTmpImg = new Image();
            teamTmpImg.src = $teamMemberImg;
            teamTmpImg.onload = function () {
              $(".nectar_team_member_overlay .team_member_image").css(
                "opacity",
                "1"
              );
            };
            $(".nectar_team_member_overlay .team_member_image").css({
              "background-image": 'url("' + $teamMemberImg + '")',
            });
          }

          var $headerNavSpace =
            $('body[data-header-format="left-header"]').length > 0 &&
            $(window).width() > 1000
              ? 0
              : $("#header-outer").height();
          $(".nectar_team_member_overlay .inner-wrap").css({
            top: $headerNavSpace,
          });

          teamFullscreenResize();

          //transition in
          $(".nectar_team_member_overlay")
            .addClass("open")
            .addClass("animating");

          setTimeout(function () {
            $(".nectar_team_member_close").addClass("visible");
            $(".nectar_team_member_overlay").removeClass("animating");
          }, 500);

          //bind close mousemove
          $(document).on("mousemove", teamMousemoveOn);

          if (
            $('.team-member[data-style="bio_fullscreen"]').length > 0 &&
            navigator.userAgent.match(
              /(Android|iPod|iPhone|iPad|IEMobile|BlackBerry|Opera Mini)/
            )
          ) {
            $(".nectar_team_member_overlay").addClass("on-mobile");
          }
        }
      );

      //close
      $("body").on("click", ".nectar_team_member_overlay", function () {
        if (!$(this).hasClass("animating")) {
          $(".nectar_team_member_overlay").removeClass("open");
          $(".nectar_team_member_close").removeClass("visible");

          setTimeout(function () {
            //unbind close mousemove
            $(document).off("mousemove", teamMousemoveOn);

            $(
              ".nectar_team_member_overlay, .nectar_team_member_close"
            ).remove();
          }, 820);
        }
      });

      if ($('.team-member[data-style="bio_fullscreen"]').length > 0) {
        $(window).resize(teamFullscreenResize);
      }
    }

    function teamFullscreenResize() {
      var $leftHeaderSize =
        $('body[data-header-format="left-header"]').length > 0 &&
        $(window).width() > 1000
          ? 275
          : 0;
      $(".nectar_team_member_overlay").css({
        width: $(window).width() - $leftHeaderSize,
        left: $leftHeaderSize,
      });
    }

    function teamMousemoveOn(e) {
      if ($("a:hover").length > 0) {
        $(".nectar_team_member_close .inner").removeClass("visible");
      } else {
        $(".nectar_team_member_close .inner").addClass("visible");
      }
      $(".nectar_team_member_close").css({
        left: e.pageX - 26,
        top: e.pageY - $(window).scrollTop() - 29,
      });
    }

    if ($(".team-member").length > 0) {
      teamMemberFullscreen();
    }

    /***************** Column Hover BG ******************/

    function columnBGColors() {
      var $columnColorCSS = "";

      $(".wpb_column").each(function (i) {
        $(this).addClass("instance-" + i);

        //bg color
        if ($(this).attr("data-has-bg-color") == "true") {
          if (
            $(this).is('[data-animation*="reveal"]') &&
            $(this).hasClass("has-animation")
          )
            $columnColorCSS +=
              ".wpb_column.instance-" +
              i +
              " .column-inner-wrap .column-inner:before { background-color:" +
              $(this).attr("data-bg-color") +
              ";  opacity: " +
              $(this).attr("data-bg-opacity") +
              "; }";
          else
            $columnColorCSS +=
              ".wpb_column.instance-" +
              i +
              ":before { background-color:" +
              $(this).attr("data-bg-color") +
              ";  opacity: " +
              $(this).attr("data-bg-opacity") +
              "; }";
        }

        //hover bg color
        if ($(this).is('[data-hover-bg^="#"]')) {
          if (
            $(this).is('[data-animation*="reveal"]') &&
            $(this).hasClass("has-animation")
          )
            $columnColorCSS +=
              ".wpb_column.instance-" +
              i +
              ":hover .column-inner:before { background-color: " +
              $(this).attr("data-hover-bg") +
              "; opacity: " +
              $(this).attr("data-hover-bg-opacity") +
              "; }";
          else
            $columnColorCSS +=
              ".wpb_column.instance-" +
              i +
              ":hover:before { background-color: " +
              $(this).attr("data-hover-bg") +
              "; opacity: " +
              $(this).attr("data-hover-bg-opacity") +
              "; }";
        }
      });

      if ($columnColorCSS.length > 1) {
        var head = document.head || document.getElementsByTagName("head")[0];
        var style = document.createElement("style");

        style.type = "text/css";
        if (style.styleSheet) {
          style.styleSheet.cssText = $columnColorCSS;
        } else {
          style.appendChild(document.createTextNode($columnColorCSS));
        }

        head.appendChild(style);
      }
    }
    columnBGColors();

    /***************** Row Color Overlay ******************/
    function rowColorOverlay() {
      var $rowOverlayCSS = "";

      $(
        ".row > .wpb_row > .row-bg-wrap .row-bg[data-color_overlay],  #nectar_fullscreen_rows .full-page-inner-wrap > .full-page-inner > .row-bg-wrap .row-bg[data-color_overlay], #portfolio-extra > .wpb_row > .row-bg-wrap .row-bg[data-color_overlay], .single #post-area .content-inner > .wpb_row > .row-bg-wrap .row-bg[data-color_overlay]"
      ).each(function (i) {
        $(this)
          .parents(".row-bg-wrap")
          .addClass("instance-" + i);

        $overlayOpacity =
          $(this).attr("data-overlay_strength").length > 0
            ? $(this).attr("data-overlay_strength")
            : "1";

        var $using_img_trans = false;

        if ($overlayOpacity == "image_trans") {
          $overlayOpacity = "1";
          $using_img_trans = true;
        }

        $overlay1 =
          $(this).attr("data-color_overlay").length > 0
            ? $(this).attr("data-color_overlay")
            : "transparent";
        $overlay2 =
          $(this).attr("data-color_overlay_2").length > 0
            ? $(this).attr("data-color_overlay_2")
            : "transparent";
        $gradientDirection =
          $(this).attr("data-gradient_direction").length > 0
            ? $(this).attr("data-gradient_direction")
            : "left_t_right";
        switch ($gradientDirection) {
          case "left_to_right":
            var $gradientDirectionDeg = "90deg";
            break;
          case "left_t_to_right_b":
            var $gradientDirectionDeg = "135deg";
            break;
          case "left_b_to_right_t":
            var $gradientDirectionDeg = "45deg";
            break;
          case "top_to_bottom":
            var $gradientDirectionDeg = "to bottom";
            break;
        }
        $enableGradient =
          $(this).attr("data-enable_gradient") == "true" ? true : false;

        if ($enableGradient) {
          //safari transparent white fix
          if ($overlay1 == "#ffffff" && $overlay2 == "transparent")
            $overlay2 = "rgba(255,255,255,0.001)";
          if ($overlay1 == "transparent" && $overlay2 == "#ffffff")
            $overlay1 = "rgba(255,255,255,0.001)";

          if ($gradientDirection == "top_to_bottom") {
            if (
              $overlay2 == "transparent" ||
              $overlay2 == "rgba(255,255,255,0.001)"
            ) {
              $rowOverlayCSS +=
                ".row-bg-wrap.instance-" +
                i +
                ":after { background: linear-gradient(" +
                $gradientDirectionDeg +
                "," +
                $overlay1 +
                " 0%," +
                $overlay2 +
                " 75%);  opacity: " +
                $overlayOpacity +
                "; }";
            }

            if (
              $overlay1 == "transparent" ||
              $overlay1 == "rgba(255,255,255,0.001)"
            ) {
              $rowOverlayCSS +=
                ".row-bg-wrap.instance-" +
                i +
                ":after { background: linear-gradient(" +
                $gradientDirectionDeg +
                "," +
                $overlay1 +
                " 25%," +
                $overlay2 +
                " 100%);  opacity: " +
                $overlayOpacity +
                "; }";
            }

            if ($overlay1 != "transparent" && $overlay2 != "transparent") {
              $rowOverlayCSS +=
                ".row-bg-wrap.instance-" +
                i +
                ":after {  background: " +
                $overlay1 +
                "; background: linear-gradient(" +
                $gradientDirectionDeg +
                "," +
                $overlay1 +
                " 0%," +
                $overlay2 +
                " 100%);  opacity: " +
                $overlayOpacity +
                "; }";
            }
          } else if ($gradientDirection == "left_to_right") {
            if (
              $overlay1 == "transparent" ||
              $overlay1 == "rgba(255,255,255,0.001)"
            ) {
              $rowOverlayCSS +=
                ".row-bg-wrap.instance-" +
                i +
                ":after { background: " +
                $overlay1 +
                "; background: linear-gradient(" +
                $gradientDirectionDeg +
                "," +
                $overlay1 +
                " 25%," +
                $overlay2 +
                " 100%);  opacity: " +
                $overlayOpacity +
                "; }";
            }

            if ($overlay1 != "transparent" && $overlay2 != "transparent") {
              $rowOverlayCSS +=
                ".row-bg-wrap.instance-" +
                i +
                ":after { background: " +
                $overlay1 +
                "; background: linear-gradient(" +
                $gradientDirectionDeg +
                "," +
                $overlay1 +
                " 0%," +
                $overlay2 +
                " 100%);  opacity: " +
                $overlayOpacity +
                "; }";
            }
          } else {
            $rowOverlayCSS +=
              ".row-bg-wrap.instance-" +
              i +
              ":after { background: " +
              $overlay1 +
              "; background: linear-gradient(" +
              $gradientDirectionDeg +
              "," +
              $overlay1 +
              " 0%," +
              $overlay2 +
              " 100%);  opacity: " +
              $overlayOpacity +
              "; }";
          }
        } else {
          if ($(this).attr("data-color_overlay").length > 0) {
            $rowOverlayCSS +=
              ".row-bg-wrap.instance-" +
              i +
              ":after { background-color:" +
              $overlay1 +
              ";  opacity: " +
              $overlayOpacity +
              "; }";
          }
        }
      });

      if ($rowOverlayCSS.length > 1) {
        var head = document.head || document.getElementsByTagName("head")[0];
        var style = document.createElement("style");

        style.type = "text/css";
        if (style.styleSheet) {
          style.styleSheet.cssText = $rowOverlayCSS;
        } else {
          style.appendChild(document.createTextNode($rowOverlayCSS));
        }

        head.appendChild(style);
      }
    }

    rowColorOverlay();

    /***************** morphing button ******************/

    function morphingOutlines() {
      if ($(".morphing-outline").length > 0) {
        $morphingOutlineCSS = "";

        $(".morphing-outline").each(function (i) {
          $(this)
            .addClass("instance-" + i)
            .css({ visibility: "visible" });
          var $width = $(this).find(".inner").width();
          var $height = $(this).find(".inner").height();
          var $border = parseInt($(this).attr("data-border-thickness"));
          var $hover =
            $('body[data-button-style*="rounded"]').length > 0 ? ":hover" : "";
          var $hover2 =
            $('body[data-button-style*="rounded"]').length > 0 ? "" : ":hover";

          $morphingOutlineCSS +=
            "body .morphing-outline.instance-" +
            i +
            " .inner > * { color: " +
            $(this).attr("data-starting-color") +
            "; } ";
          $morphingOutlineCSS +=
            "body .morphing-outline.instance-" +
            i +
            " .inner:after  { border-width:" +
            $(this).attr("data-border-thickness") +
            "px ; border-color: " +
            $(this).attr("data-starting-color") +
            "; } ";

          $morphingOutlineCSS +=
            "body .wpb_column:hover > .wpb_wrapper > .morphing-outline.instance-" +
            i +
            " .inner > *, body .wpb_column:hover > .vc_column-inner > .wpb_wrapper > .morphing-outline.instance-" +
            i +
            " .inner > * { color: " +
            $(this).attr("data-hover-color") +
            "; } ";
          $morphingOutlineCSS +=
            "body .wpb_column:hover > .wpb_wrapper > .morphing-outline.instance-" +
            i +
            " .inner:after, body .wpb_column:hover > .vc_column-inner > .wpb_wrapper > .morphing-outline.instance-" +
            i +
            " .inner:after  { border-color: " +
            $(this).attr("data-hover-color") +
            "; } ";
          //padding calcs
          $morphingOutlineCSS +=
            "body .wpb_column" +
            $hover2 +
            " > .wpb_wrapper > .morphing-outline.instance-" +
            i +
            " .inner:after, body .wpb_column" +
            $hover2 +
            " > .vc_column-inner > .wpb_wrapper > .morphing-outline.instance-" +
            i +
            " .inner:after { padding: " +
            (($width + 100 + $border * 2 - $height) / 2 - $border) +
            "px 50px}";
          $morphingOutlineCSS +=
            ".morphing-outline.instance-" +
            i +
            " { padding: " +
            (30 + ($width + 80 + $border * 2 - $height) / 2 - $border) +
            "px 50px}"; //extra space on the outer for mobile/close elements
          $morphingOutlineCSS +=
            "body .wpb_column" +
            $hover2 +
            " > .wpb_wrapper > .morphing-outline.instance-" +
            i +
            " .inner:after, body .wpb_column" +
            $hover2 +
            " > .vc_column-inner > .wpb_wrapper > .morphing-outline.instance-" +
            i +
            " .inner:after { top: -" +
            parseInt(
              ($width + 100 + $border * 2 - $height) / 2 - $border + $border
            ) +
            "px }";

          $morphingOutlineCSS +=
            "body .wpb_column > .wpb_wrapper > .morphing-outline.instance-" +
            i +
            " .inner:after, body .wpb_column > .vc_column-inner > .wpb_wrapper > .morphing-outline.instance-" +
            i +
            " .inner:after { left: -" +
            parseInt(50 + $border) +
            "px }";
          ////hover
          $morphingOutlineCSS +=
            "body .wpb_column" +
            $hover +
            " > .wpb_wrapper > .morphing-outline.instance-" +
            i +
            " .inner:after, body .wpb_column" +
            $hover +
            " > .vc_column-inner > .wpb_wrapper > .morphing-outline.instance-" +
            i +
            " .inner:after { padding: 50px 50px}";
          $morphingOutlineCSS +=
            "body .wpb_column" +
            $hover +
            " > .wpb_wrapper > .morphing-outline.instance-" +
            i +
            " .inner:after, body .wpb_column" +
            $hover +
            " > .vc_column-inner > .wpb_wrapper > .morphing-outline.instance-" +
            i +
            " .inner:after { top: -" +
            parseInt(50 + $border) +
            "px }";
        });

        var head = document.head || document.getElementsByTagName("head")[0];
        var style = document.createElement("style");

        style.type = "text/css";
        style.id = "morphing-outlines";
        if (style.styleSheet) {
          style.styleSheet.cssText = $morphingOutlineCSS;
        } else {
          style.appendChild(document.createTextNode($morphingOutlineCSS));
        }

        $("#morphing-outlines").remove();
        head.appendChild(style);
      }
    }

    setTimeout(morphingOutlines, 100);
    setTimeout(fullWidthContentColumns, 126);

    /***************** svg icons *******************/

    var $svg_icons = [];
    function svgAnimations() {
      $svgOffsetPos =
        $("#nectar_fullscreen_rows").length > 0 ? "200%" : "bottom-in-view";

      if ($svg_icons.length == 0) {
        $(".svg-icon-holder:not(.animated-in)").each(function (i) {
          var $that = $(this);

          if (
            navigator.userAgent.match(
              /(Android|iPod|iPhone|iPad|IEMobile|BlackBerry|Opera Mini)/
            )
          )
            $that.attr("data-animation", "false");

          //size
          $that.css({
            height: parseInt($that.attr("data-size")) + "px",
            width: parseInt($that.attr("data-size")) + "px",
          });

          //animation
          $(this).attr("id", "nectar-svg-animation-instance-" + i);
          var $animationSpeed =
            $that.is("[data-animation-speed]") &&
            $that.attr("data-animation-speed").length > 0
              ? $that.attr("data-animation-speed")
              : 200;
          if ($that.attr("data-animation") == "false") {
            $animationSpeed = 1;
            $that.css("opacity", "1");
          }

          if (!$that.hasClass("bound")) {
            $svg_icons[i] = new Vivus($that.attr("id"), {
              type: "delayed",
              pathTimingFunction: Vivus.EASE_OUT,
              animTimingFunction: Vivus.LINEAR,
              duration: $animationSpeed,
              file: $that.text(),
              onReady: svgInit,
            });
          }

          $that.find("span").remove();
          if ($animationSpeed !== 1) {
            var $that = $(this);
            var waypoint = new Waypoint({
              element: $that,
              handler: function (direction) {
                if ($that.hasClass("animated-in")) {
                  waypoint.destroy();
                  return;
                }

                checkIfReady();
                $that.addClass("animated-in");
                waypoint.destroy();
              },
              offset: $svgOffsetPos,
            });
          } else {
            checkIfReady();
          }

          function checkIfReady() {
            var $animationDelay =
              $that.is("[data-animation-delay]") &&
              $that.attr("data-animation-delay").length > 0 &&
              $that.attr("data-animation") != "false"
                ? $that.attr("data-animation-delay")
                : 0;

            var $iconID = $that.attr("id").replace(/[^0-9]/g, "");

            if ($svg_icons[$iconID].isReady == true) {
              $that.css("opacity", "1");
              setTimeout(function () {
                $svg_icons[$iconID].reset().play();
              }, $animationDelay);
            } else {
              setTimeout(checkIfReady, 50);
            }
          }

          function svgInit() {
            //set size
            $that
              .find("object")
              .css({
                height: parseInt($that.attr("data-size")) + "px",
                width: parseInt($that.attr("data-size")) + "px",
              });

            var $iconID = $that.attr("id").replace(/[^0-9]/g, "");

            //stop animation until user scrolls to it
            $svg_icons[$iconID].reset().stop();

            //set color
            var svgDoc = $that.find("object")[0].contentDocument;

            var styleElement = svgDoc.createElementNS(
              "http://www.w3.org/2000/svg",
              "style"
            );
            styleElement.textContent =
              "svg, svg path { stroke: " +
              $that.css("color") +
              "; fill: none; }";
            svgDoc.getElementById("Layer_1").appendChild(styleElement);
          }

          $that.addClass("bound");
        });
      } else {
        $(".svg-icon-holder").addClass("animated-in").css("opacity", "1");
      }

      //full vc row support
      $("#nectar_fullscreen_rows .svg-icon-holder.animated-in").each(function (
        i
      ) {
        var $animationDelay =
          $(this).is("[data-animation-delay]") &&
          $(this).attr("data-animation-delay").length > 0 &&
          $(this).attr("data-animation") != "false"
            ? $(this).attr("data-animation-delay")
            : 0;
        var $that = $(this);

        var $iconID = $that.attr("id").replace(/[^0-9]/g, "");

        clearTimeout($animatedSVGIconTimeout[i]);

        if ($that.attr("data-animation") == "false") {
          $animationSpeed = 1;
          $that.css("opacity", "1");
          $svg_icons[$iconID].finish();
        } else {
          if (
            $(this).parents(".active").length > 0 ||
            $(this).parents("#footer-outer").length > 0 ||
            $("body.mobile").length > 0
          ) {
            $svg_icons[$iconID].reset();
            $animatedSVGIconTimeout[i] = setTimeout(function () {
              $svg_icons[$iconID].play();
            }, $animationDelay);
          } else {
            $svg_icons[$iconID].reset().stop();
          }
        }
      });
    }
    //svg in equal height column resize
    if (
      $('.vc_row-o-equal-height .svg-icon-holder[data-animation="true"]')
        .length > 0 &&
      $("#nectar_fullscreen_rows").length == 0
    ) {
      $(window).on("smartresize", function () {
        clearTimeout($svgResizeTimeout);
        $svgResizeTimeout = setTimeout(function () {
          if ($svg_icons.length > 0) {
            $(".svg-icon-holder.animated-in").each(function (i) {
              $(this).css("opacity", "1");
              var $iconID = $(this)
                .attr("id")
                .replace(/[^0-9]/g, "");
              $svg_icons[$iconID].finish();
            });
          }
        }, 300);
      });
    }

    //if($('.nectar-box-roll').length == 0 || $('body.mobile').length > 0) setTimeout(svgAnimations,100);

    /***************** fancy ul ******************/

    function nectar_fancy_ul_init() {
      $($fullscreenSelector + ".nectar-fancy-ul").each(function () {
        var $icon = $(this).attr("data-list-icon");
        var $color = $(this).attr("data-color");
        var $animation = $(this).attr("data-animation");
        var $animationDelay =
          $(this).is("[data-animation-delay]") &&
          $(this).attr("data-animation-delay").length > 0 &&
          $(this).attr("data-animation") != "false"
            ? $(this).attr("data-animation-delay")
            : 0;

        $(this)
          .find("li")
          .each(function () {
            if ($(this).find("> i").length == 0)
              $(this).prepend(
                '<i class="icon-default-style ' +
                  $icon +
                  " " +
                  $color +
                  '"></i> '
              );
          });

        if ($animation == "true") {
          var $that = $(this);
          var waypoint = new Waypoint({
            element: $that,
            handler: function (direction) {
              if (
                ($that.parents(".wpb_tab").length > 0 &&
                  $that.parents(".wpb_tab").css("visibility") == "hidden") ||
                $that.hasClass("animated-in")
              ) {
                waypoint.destroy();
                return;
              }

              setTimeout(function () {
                $that.find("li").each(function (i) {
                  var $that = $(this);
                  $that.delay(i * 220).transition(
                    {
                      opacity: "1",
                      left: "0",
                    },
                    220,
                    "easeOutCubic"
                  );
                });
              }, $animationDelay);

              $that.addClass("animated-in");
              waypoint.destroy();
            },
            offset: "bottom-in-view",
          });
        }
      });
    }
    setTimeout(function () {
      //if($('.nectar-box-roll').length == 0) nectar_fancy_ul_init();
    }, $animationOnScrollTimeOut);

    /***************** flip box min heights ******************/
    //if content height exceeds min height change it
    function flipBoxHeights() {
      $(".nectar-flip-box").each(function () {
        var $flipBoxMinHeight = parseInt($(this).attr("data-min-height"));
        var $flipBoxHeight =
          $(this).find(".flip-box-back .inner").height() >
          $(this).find(".flip-box-front .inner").height()
            ? $(this).find(".flip-box-back .inner").height()
            : $(this).find(".flip-box-front .inner").height();

        if ($flipBoxHeight >= $flipBoxMinHeight - 80) {
          $(this)
            .find("> div")
            .css("height", $flipBoxHeight + 80);
        } else $(this).find("> div").css("height", "auto");
      });
    }
    flipBoxHeights();

    if (
      navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|IEMobile|BlackBerry|Opera Mini)/
      )
    ) {
      $("body").on("click", ".nectar-flip-box", function () {
        $(this).toggleClass("flipped");
      });
    }

    /***************** PARALLAX SECTIONS ******************/

    // Create cross browser requestAnimationFrame method:
    window.requestAnimationFrame =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (f) {
        setTimeout(f, 1000 / 60);
      };

    var $window = $(window);
    var windowHeight = $window.height();

    $window.unbind("scroll.parallaxSections").unbind("resize.parallaxSections");
    $window.unbind("resize.parallaxSectionsUpdateHeight");
    $window.unbind("load.parallaxSectionsOffsetL");
    $window.unbind("resize.parallaxSectionsOffsetR");

    $window.on("resize.parallaxSectionsUpdateHeight", psUpdateWindowHeight);

    function psUpdateWindowHeight() {
      windowHeight = $window.height();
    }

    function psUpdateOffset($this) {
      $this.each(function () {
        firstTop = $this.offset().top;
      });
    }

    $.fn.parallaxScroll = function (xpos, speedFactor, outerHeight) {
      var $this = $(this);
      var getHeight;
      var firstTop;
      var paddingTop = 0;

      //get the starting position of each element to have parallax applied to it
      $this.each(function () {
        firstTop = $this.offset().top;
      });

      $window.on("resize.parallaxSectionsOffsetR", psUpdateOffset($this));
      $window.on("load.parallaxSectionsOffsetL", psUpdateOffset($this));

      getHeight = function (jqo) {
        return jqo.outerHeight(true);
      };

      // setup defaults if arguments aren't specified
      if (arguments.length < 1 || xpos === null) xpos = "50%";
      if (arguments.length < 2 || speedFactor === null) speedFactor = 0.1;
      if (arguments.length < 3 || outerHeight === null) outerHeight = true;

      // function to be called whenever the window is scrolled or resized

      var $element, top, height, pos;

      function update() {
        pos = $window.scrollTop();

        $this.each(function () {
          firstTop = $this.offset().top;

          $element = $(this);
          top = $element.offset().top;
          height = getHeight($element);

          // Check if totally above or totally below viewport
          if (top + height < pos || top > pos + windowHeight) {
            return;
          }

          var ua = window.navigator.userAgent;
          var msie = ua.indexOf("MSIE ");

          //for IE, Safari or any setup using the styled scrollbar default to animating the BG pos
          if (
            msie > 0 ||
            !!navigator.userAgent.match(/Trident.*rv\:11\./) ||
            $smoothCache == true ||
            (navigator.userAgent.indexOf("Safari") != -1 &&
              navigator.userAgent.indexOf("Chrome") == -1)
          ) {
            $this
              .find(".row-bg.using-image")
              .css(
                "backgroundPosition",
                xpos + " " + Math.round((firstTop - pos) * speedFactor) + "px"
              );
          }
          //for Firefox/Chrome use a higher performing method
          else {
            var $ifFast =
              $this.find('.row-bg[data-parallax-speed="fast"]').length > 0
                ? ($element.find(".row-bg").height() - height) / 2.5
                : 0;
            $this
              .find(".row-bg.using-image")
              .addClass("translate")
              .css({
                transform:
                  "translate3d(0, " +
                  Math.round(
                    (window.innerHeight + pos - firstTop) * speedFactor -
                      $ifFast
                  ) +
                  "px, 0), scale(1.005)",
              });
          }
        });
      }

      if (window.addEventListener) {
        window.addEventListener(
          "scroll",
          function () {
            requestAnimationFrame(update);
          },
          false
        );
      }

      $window.on("resize.parallaxSections", update);

      update();
    };

    /***************** Full Width Section ******************/

    //nectar slider in container but fullwidth fix
    $(
      '.wpb_row .vc_col-sm-12 .nectar-slider-wrap[data-full-width="true"]'
    ).each(function () {
      if (
        $(this).parents(".wpb_row.full-width-section").length == 0 &&
        $(this).parents(".wpb_row.full-width-content").length == 0
      ) {
        $(this).parents(".wpb_row").addClass("full-width-section");
      }
    });

    function fullWidthSections() {
      var $windowInnerWidth = window.innerWidth;
      var $scrollBar =
        $("#ascrail2000").length > 0 && $windowInnerWidth > 1000 ? -13 : 0;
      var $bodyBorderWidth =
        $(".body-border-right").length > 0 && $windowInnerWidth > 1000
          ? parseInt($(".body-border-right").width()) * 2
          : 0;

      if ($("#boxed").length == 1) {
        $justOutOfSight =
          (parseInt($(".container-wrap").width()) -
            parseInt($(".main-content").width())) /
            2 +
          4;
      } else {
        //if the ext responsive mode is on - add the extra padding into the calcs
        var $extResponsivePadding =
          $('body[data-ext-responsive="true"]').length > 0 &&
          $windowInnerWidth >= 1000
            ? 180
            : 0;
        var $leftHeaderSize =
          $('#header-outer[data-format="left-header"]').length > 0 &&
          $windowInnerWidth >= 1000
            ? parseInt($('#header-outer[data-format="left-header"]').width())
            : 0;
        if (
          $(window).width() - $leftHeaderSize - $bodyBorderWidth <=
          parseInt($(".main-content").css("max-width"))
        ) {
          var $windowWidth = parseInt($(".main-content").css("max-width"));

          //no need for the scrollbar calcs with ext responsive on desktop views
          if ($extResponsivePadding == 180)
            $windowWidth = $windowWidth - $scrollBar;
        } else {
          var $windowWidth =
            $(window).width() - $leftHeaderSize - $bodyBorderWidth;
        }

        $contentWidth = parseInt($(".main-content").css("max-width"));

        //single post fullwidth
        if (
          $('body.single-post[data-ext-responsive="true"]').length > 0 &&
          $(".container-wrap.no-sidebar").length > 0
        ) {
          $contentWidth = $("#post-area").width();
          $extResponsivePadding = 0;
        }

        $justOutOfSight = Math.ceil(
          ($windowWidth + $extResponsivePadding + $scrollBar - $contentWidth) /
            2
        );
      }

      $(".full-width-section").each(function () {
        if (
          !$(this).parents(".span_9").length > 0 &&
          !$(this).parent().hasClass("span_3") &&
          $(this).parent().attr("id") != "sidebar-inner" &&
          $(this).parent().attr("id") != "portfolio-extra" &&
          !$(this).hasClass("non-fw")
        ) {
          $(this).css({
            "margin-left": -$justOutOfSight,
            "padding-left": $justOutOfSight,
            "padding-right": $justOutOfSight,
            visibility: "visible",
          });

          if ($("#boxed").length > 0 && $("#nectar_fullscreen_rows").length > 0)
            $(this).css({ "padding-left": 0, "padding-right": 0 });
        } else if (
          $(this).parent().attr("id") == "portfolio-extra" &&
          $("#full_width_portfolio").length != 0
        ) {
          $(this).css({
            "margin-left": -$justOutOfSight,
            "padding-left": $justOutOfSight,
            "padding-right": $justOutOfSight,
            visibility: "visible",
          });
        } else {
          $(this).css({
            "margin-left": 0,
            "padding-left": 0,
            "padding-right": 0,
            visibility: "visible",
          });
        }
      });

      //full width content sections
      $(".carousel-outer")
        .has('.carousel-wrap[data-full-width="true"]')
        .css("overflow", "visible");

      $(
        '.carousel-wrap[data-full-width="true"], .portfolio-items[data-col-num="elastic"]:not(.fullwidth-constrained), .full-width-content'
      ).each(function () {
        var $leftHeaderSize =
          $('#header-outer[data-format="left-header"]').length > 0 &&
          $windowInnerWidth >= 1000
            ? parseInt($('#header-outer[data-format="left-header"]').width())
            : 0;
        var $bodyBorderWidth =
          $(".body-border-right").length > 0 && $windowInnerWidth > 1000
            ? parseInt($(".body-border-right").width()) * 2
            : 0;

        //single post fullwidth
        if ($("#boxed").length == 1) {
          var $mainContentWidth =
            $("#nectar_fullscreen_rows").length == 0
              ? parseInt($(".main-content").width())
              : parseInt($(this).parents(".container").width());

          if (
            $('body.single-post[data-ext-responsive="true"]').length > 0 &&
            $(".container-wrap.no-sidebar").length > 0 &&
            $(this).parents("#post-area").length > 0
          ) {
            $contentWidth = $("#post-area").width();
            $extResponsivePadding = 0;
            $windowWidth = $(window).width() - $bodyBorderWidth;
            $justOutOfSight = Math.ceil(
              ($windowWidth +
                $extResponsivePadding +
                $scrollBar -
                $contentWidth) /
                2
            );
          } else {
            if ($(this).parents(".page-submenu").length > 0)
              $justOutOfSight =
                (parseInt($(".container-wrap").width()) - $mainContentWidth) /
                2;
            else
              $justOutOfSight =
                (parseInt($(".container-wrap").width()) - $mainContentWidth) /
                  2 +
                4;
          }
        } else {
          if (
            $('body.single-post[data-ext-responsive="true"]').length > 0 &&
            $(".container-wrap.no-sidebar").length > 0 &&
            $(this).parents("#post-area").length > 0
          ) {
            $contentWidth = $("#post-area").width();
            $extResponsivePadding = 0;
            $windowWidth =
              $(window).width() - $leftHeaderSize - $bodyBorderWidth;
          } else {
            var $mainContentMaxWidth =
              $("#nectar_fullscreen_rows").length == 0
                ? parseInt($(".main-content").css("max-width"))
                : parseInt($(this).parents(".container").css("max-width"));

            //when using gutter on portfolio don't add extra space for scroll bar
            if (
              $("#boxed").length == 0 &&
              $(this).hasClass("portfolio-items") &&
              $(this).is('[data-gutter*="px"]') &&
              $(this).attr("data-gutter").length > 0 &&
              $(this).attr("data-gutter") != "none"
            ) {
              $scrollBar =
                $("#ascrail2000").length > 0 && $windowInnerWidth > 1000
                  ? -13
                  : 0;
            }

            if (
              $(window).width() - $leftHeaderSize - $bodyBorderWidth <=
              $mainContentMaxWidth
            ) {
              $windowWidth = $mainContentMaxWidth;
              //no need for the scrollbar calcs with ext responsive on desktop views
              if ($extResponsivePadding == 180)
                $windowWidth = $windowWidth - $scrollBar;
            }
            $contentWidth = $mainContentMaxWidth;
            $extResponsivePadding =
              $('body[data-ext-responsive="true"]').length > 0 &&
              window.innerWidth >= 1000
                ? 180
                : 0;
            if ($leftHeaderSize > 0)
              $extResponsivePadding =
                $('body[data-ext-responsive="true"]').length > 0 &&
                window.innerWidth >= 1000
                  ? 120
                  : 0;
          }

          $justOutOfSight = Math.ceil(
            ($windowWidth +
              $extResponsivePadding +
              $scrollBar -
              $contentWidth) /
              2
          );
        }

        $extraSpace = 0;
        if ($(this).hasClass("carousel-wrap")) $extraSpace = 1;
        if ($(this).hasClass("portfolio-items")) $extraSpace = 5;

        $carouselWidth =
          $("#boxed").length == 1
            ? $mainContentWidth + parseInt($justOutOfSight * 2)
            : $(window).width() -
              $leftHeaderSize -
              $bodyBorderWidth +
              $extraSpace +
              $scrollBar;

        //when using gutter on portfolio don't add extra space
        if (
          $("#boxed").length == 0 &&
          $(this).hasClass("portfolio-items") &&
          $(this).is('[data-gutter*="px"]') &&
          $(this).attr("data-gutter").length > 0 &&
          $(this).attr("data-gutter") != "none"
        ) {
          if ($(window).width() > 1000)
            $carouselWidth =
              $(window).width() -
              $leftHeaderSize -
              $bodyBorderWidth +
              $scrollBar +
              3;
          else
            $carouselWidth =
              $(window).width() -
              $leftHeaderSize -
              $bodyBorderWidth +
              $scrollBar;
        }

        if ($(this).parent().hasClass("default-style")) {
          var $mainContentWidth =
            $("#nectar_fullscreen_rows").length == 0
              ? parseInt($(".main-content").width())
              : parseInt($(this).parents(".container").width());

          if ($("#boxed").length != 0) {
            $carouselWidth =
              $("#boxed").length == 1
                ? $mainContentWidth + parseInt($justOutOfSight * 2)
                : $(window).width() -
                  $leftHeaderSize +
                  $extraSpace +
                  $scrollBar;
          } else {
            $carouselWidth =
              $("#boxed").length == 1
                ? $mainContentWidth + parseInt($justOutOfSight * 2)
                : $(window).width() -
                  $leftHeaderSize -
                  $bodyBorderWidth -
                  ($(window).width() - $leftHeaderSize - $bodyBorderWidth) *
                    0.025 +
                  $extraSpace +
                  $scrollBar;
            $windowWidth =
              $(window).width() - $leftHeaderSize - $bodyBorderWidth <=
              $mainContentWidth
                ? $mainContentWidth
                : $(window).width() -
                  $leftHeaderSize -
                  $bodyBorderWidth -
                  ($(window).width() - $leftHeaderSize - $bodyBorderWidth) *
                    0.025;
            $justOutOfSight = Math.ceil(
              ($windowWidth + $scrollBar - $mainContentWidth) / 2
            );
          }
        } else if ($(this).parent().hasClass("spaced")) {
          var $mainContentWidth =
            $("#nectar_fullscreen_rows").length == 0
              ? parseInt($(".main-content").width())
              : parseInt($(this).parents(".container").width());

          if ($("#boxed").length != 0) {
            $carouselWidth =
              $("#boxed").length == 1
                ? $mainContentWidth +
                  parseInt($justOutOfSight * 2) -
                  $(window).width() * 0.02
                : $(window).width() + $extraSpace + $scrollBar;
          } else {
            $carouselWidth =
              $("#boxed").length == 1
                ? $mainContentWidth + parseInt($justOutOfSight * 2)
                : $(window).width() -
                  $leftHeaderSize -
                  $bodyBorderWidth -
                  Math.ceil(
                    ($(window).width() - $leftHeaderSize - $bodyBorderWidth) *
                      0.02
                  ) +
                  $extraSpace +
                  $scrollBar;
            var $windowWidth2 =
              $(window).width() - $leftHeaderSize - $bodyBorderWidth <=
              $mainContentWidth
                ? $mainContentWidth
                : $(window).width() -
                  $leftHeaderSize -
                  $bodyBorderWidth -
                  ($(window).width() - $leftHeaderSize - $bodyBorderWidth) *
                    0.02;
            $justOutOfSight = Math.ceil(
              ($windowWidth2 + $scrollBar - $mainContentWidth) / 2 + 2
            );
          }
        }

        if (
          !$(this).parents(".span_9").length > 0 &&
          !$(this).parent().hasClass("span_3") &&
          $(this).parent().attr("id") != "sidebar-inner" &&
          $(this).parent().attr("id") != "portfolio-extra" &&
          !$(this).find('.carousel-wrap[data-full-width="true"]').length > 0 &&
          !$(this).find(
            '.portfolio-items:not(".carousel")[data-col-num="elastic"]'
          ).length > 0
        ) {
          //escape if inside woocoommerce page and not using applicable layout
          if (
            $(".single-product").length > 0 &&
            $(this).parents("#tab-description").length > 0 &&
            $(this).parents(".full-width-tabs").length == 0
          ) {
            $(this).css({
              visibility: "visible",
            });
          } else {
            if ($(this).hasClass("portfolio-items")) {
              $(this).css({
                transform: "translateX(-" + $justOutOfSight + "px)",
                "margin-left": 0,
                width: $carouselWidth,
                visibility: "visible",
              });
            } else {
              $(this).css({
                "margin-left": -$justOutOfSight,
                width: $carouselWidth,
                visibility: "visible",
              });
            }
          }
        } else if (
          $(this).parent().attr("id") == "portfolio-extra" &&
          $("#full_width_portfolio").length != 0
        ) {
          $(this).css({
            "margin-left": -$justOutOfSight,
            width: $carouselWidth,
            visibility: "visible",
          });
        } else {
          $(this).css({
            "margin-left": 0,
            visibility: "visible",
          });
        }
      });
    }

    var $contentElementsNum =
      $("#portfolio-extra").length == 0
        ? $(".main-content > .row > *").length
        : $(".main-content > .row #portfolio-extra > *").length;

    function parallaxSrollSpeed(speedString) {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      var speed;

      //not as modern browsers
      if (
        msie > 0 ||
        !!navigator.userAgent.match(/Trident.*rv\:11\./) ||
        $smoothCache == true ||
        (navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1)
      ) {
        switch (speedString) {
          case "slow":
            speed = 0.2;
            break;
          case "medium":
            speed = 0.4;
            break;
          case "fast":
            speed = 0.6;
            break;
        }
      }
      //chrome/ff
      else {
        switch (speedString) {
          case "slow":
            speed = 0.6;
            break;
          case "medium":
            speed = 0.4;
            break;
          case "fast":
            speed = 0.25;
            break;
        }
      }

      return speed;
    }

    function parallaxScrollInit() {
      parallaxRowsBGCals();
      $(
        ".full-width-section.parallax_section, .full-width-content.parallax_section"
      ).each(function () {
        var $id = $(this).attr("id");

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (
          msie > 0 ||
          !!navigator.userAgent.match(/Trident.*rv\:11\./) ||
          $smoothCache == true ||
          (navigator.userAgent.indexOf("Safari") != -1 &&
            navigator.userAgent.indexOf("Chrome") == -1)
        ) {
          if ($(this).find('[data-parallax-speed="fixed"]').length == 0)
            $("#" + $id + ".parallax_section").parallaxScroll(
              "50%",
              parallaxSrollSpeed(
                $(this).find(".row-bg").attr("data-parallax-speed")
              )
            );
        } else if ($(this).find('[data-parallax-speed="fixed"]').length == 0) {
          $("#" + $id + ".parallax_section").parallaxScroll(
            "50%",
            parallaxSrollSpeed(
              $(this).find(".row-bg").attr("data-parallax-speed")
            )
          );
        }
      });
    }

    if (
      !navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|IEMobile|BlackBerry|Opera Mini)/
      )
    ) {
      parallaxScrollInit();
      $(window).load(parallaxRowsBGCals);
      setTimeout(parallaxRowsBGCals, 100);
    }

    function parallaxRowsBGCals() {
      $(
        ".full-width-section.parallax_section, .full-width-content.parallax_section"
      ).each(function () {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (
          msie > 0 ||
          !!navigator.userAgent.match(/Trident.*rv\:11\./) ||
          $smoothCache == true ||
          (navigator.userAgent.indexOf("Safari") != -1 &&
            navigator.userAgent.indexOf("Chrome") == -1)
        ) {
          $(this)
            .find(".row-bg")
            .css({
              height: $(this).outerHeight(true) * 2.8,
              "margin-top": "-" + ($(this).outerHeight(true) * 2.8) / 2 + "px",
            });
        } else {
          $(this)
            .find(".row-bg")
            .css({
              height:
                Math.ceil(
                  $(window).height() *
                    parallaxSrollSpeed(
                      $(this).find(".row-bg").attr("data-parallax-speed")
                    )
                ) + $(this).outerHeight(true),
            });
        }
      });
    }

    //if fullwidth section is first or last, remove the margins so it fits flush against header/footer
    function fwsClasses() {
      $('.wpb_wrapper > .nectar-slider-wrap[data-full-width="true"]').each(
        function () {
          if (
            !$(this).parent().hasClass("span_9") &&
            !$(this).parent().hasClass("span_3") &&
            $(this).parent().attr("id") != "sidebar-inner"
          ) {
            if ($(this).parents(".wpb_row").index() == "0") {
              $(this).addClass("first-nectar-slider");
            }
          }
        }
      );

      if ($("#portfolio-extra").length == 0) {
        $contentElementsNum =
          $(".main-content > .row > .wpb_row").length > 0
            ? $(".main-content > .row > .wpb_row").length
            : $(".main-content > .row > *").length;
      } else {
        $contentElementsNum = $(
          ".main-content > .row #portfolio-extra > *"
        ).length;
      }

      $(
        '.full-width-section, .full-width-content:not(.page-submenu .full-width-content), .row > .nectar-slider-wrap[data-full-width="true"], .wpb_wrapper > .nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer, .portfolio-items[data-col-num="elastic"]'
      ).each(function () {
        if (
          !$(this).parent().hasClass("span_9") &&
          !$(this).parent().hasClass("span_3") &&
          $(this).parent().attr("id") != "sidebar-inner"
        ) {
          if ($(this).parents(".wpb_row").length > 0) {
            if (
              $(this).parents("#portfolio-extra").length > 0 &&
              $("#full_width_portfolio").length == 0
            )
              return false;

            ////first
            if (
              ($(this).parents(".wpb_row").index() == "0" &&
                $("#page-header-bg").length != 0) ||
              ($(this).parents(".wpb_row").index() == "0" &&
                $(".parallax_slider_outer").length != 0)
            ) {
              //$(this).css('margin-top','-2.1em').addClass('first-section nder-page-header');
            } else if (
              $(this).parents(".wpb_row").index() == "0" &&
              $("#page-header-bg").length == 0 &&
              $(".page-header-no-bg").length == 0 &&
              $(".project-title").length == 0 &&
              $(this).parents(".wpb_row").index() == "0" &&
              $(".parallax_slider_outer").length == 0 &&
              $(".project-title").length == 0 &&
              $('body[data-bg-header="true"]').length == 0
            ) {
              if (
                $('body[data-header-resize="0"]').length == 1 &&
                $(".single").length == 0
              ) {
                $(".container-wrap").css("padding-top", "0px");
              } else {
                $(this).css("margin-top", "-70px").addClass("first-section");
              }
            }

            //check if it's also last (i.e. the only fws)
            if (
              $(this).parents(".wpb_row").index() == $contentElementsNum - 1 &&
              $("#respond").length == 0
            ) {
              if ($(this).attr("id") != "portfolio-filters-inline") {
                $(".container-wrap").css("padding-bottom", "0px");
                $("#call-to-action .triangle").remove();
              }
            }
          } else {
            if (
              $(this).parents("#portfolio-extra").length > 0 &&
              $("#full_width_portfolio").length == 0
            )
              return false;

            if (
              $(this).find(".portfolio-filters-inline").length == 0 &&
              $(this).attr("id") != "post-area"
            ) {
              ////first
              if (
                ($(this).index() == "0" && $("#page-header-bg").length != 0) ||
                ($(this).index() == "0" &&
                  $(".parallax_slider_outer").length != 0)
              ) {
                //$(this).css('margin-top','-2.1em').addClass('first-section nder-page-header');
              } else if (
                $(this).index() == "0" &&
                $("#page-header-bg").length == 0 &&
                $(this).index() == "0" &&
                $(".page-header-no-bg").length == 0 &&
                $(this).index() == "0" &&
                $(".parallax_slider_outer").length == 0 &&
                !$(this).hasClass("blog_next_prev_buttons")
              ) {
                if (
                  $('body[data-header-resize="0"]').length == 1 &&
                  $(".single").length == 0
                ) {
                  $(".container-wrap").css("padding-top", "0px");
                } else {
                  $(this).css("margin-top", "-70px").addClass("first-section");
                }
              }

              //check if it's also last (i.e. the only fws)
              if (
                $(this).index() == $contentElementsNum - 1 &&
                $("#respond").length == 0
              ) {
                $(".container-wrap").css("padding-bottom", "0px");
                $(".bottom_controls").css("margin-top", "0px");
                $("#call-to-action .triangle").remove();
              }
            }
          }
        }
      });

      //add first class for rows for page header trans effect (zoom only as of now)
      $(".full-width-section.wpb_row, .full-width-content.wpb_row").each(
        function () {
          if (
            !$(this).parent().hasClass("span_9") &&
            !$(this).parent().hasClass("span_3") &&
            $(this).parent().attr("id") != "sidebar-inner"
          ) {
            if (
              $(this).parents("#portfolio-extra").length > 0 &&
              $("#full_width_portfolio").length == 0
            )
              return false;

            if (
              $(this).index() == "0" &&
              $("#page-header-bg").length == 0 &&
              $(".page-header-no-bg").length == 0 &&
              $(".project-title").length == 0 &&
              $("body.single").length == 0 &&
              $(".parallax_slider_outer").length == 0 &&
              $(".project-title").length == 0
            ) {
              $(this).addClass("first-section");
              var $that = $(this);
              setTimeout(function () {
                $that.addClass("loaded");
              }, 50);
            }
          }
        }
      );

      $(
        '#portfolio-extra > .nectar-slider-wrap[data-full-width="true"], .portfolio-wrap'
      ).each(function () {
        //check if it's last
        if (
          $(this).index() == $contentElementsNum - 1 &&
          $("#commentform").length == 0 &&
          $("#pagination").length == 0
        ) {
          if (parseInt($(".container-wrap").css("padding-bottom")) > 0)
            $(this).css("margin-bottom", "-40px");
          $("#call-to-action .triangle").remove();
        }
      });

      $(".portfolio-filters").each(function () {
        ////first
        if (
          ($(this).index() == "0" && $("#page-header-bg").length != 0) ||
          ($(this).index() == "0" && $(".parallax_slider_outer").length != 0)
        ) {
          $(this)
            .css({ "margin-top": "-2.1em" })
            .addClass("first-section nder-page-header");
        } else if (
          ($(this).index() == "0" && $("#page-header-bg").length == 0) ||
          ($(this).index() == "0" && $(".parallax_slider_outer").length == 0)
        ) {
          $(this).css({ "margin-top": "0px" }).addClass("first-section");
        }
      });

      $(".portfolio-filters-inline").each(function () {
        ////first
        if ($(this).parents(".wpb_row").length > 0) {
          if (
            ($(this).parents(".wpb_row").index() == "0" &&
              $("#page-header-bg").length != 0) ||
            ($(this).parents(".wpb_row").index() == "0" &&
              $(".parallax_slider_outer").length != 0)
          ) {
            if ($('body[data-header-resize="0"]').length == 0)
              $(this)
                .css({ "margin-top": "-2.1em", "padding-top": "19px" })
                .addClass("first-section nder-page-header");
          } else if (
            ($(this).parents(".wpb_row").index() == "0" &&
              $("#page-header-bg").length == 0) ||
            ($(this).parents(".wpb_row").index() == "0" &&
              $(".parallax_slider_outer").length == 0)
          ) {
            if ($('body[data-header-resize="0"]').length == 1) {
              // $(this).css({'margin-top':'-30px', 'padding-top' : '50px'}).addClass('first-section');
            } else {
              $(this)
                .css({ "margin-top": "-70px", "padding-top": "50px" })
                .addClass("first-section");
            }
          }
        } else {
          if (
            ($(this).index() == "0" && $("#page-header-bg").length != 0) ||
            ($(this).index() == "0" && $(".parallax_slider_outer").length != 0)
          ) {
            $(this)
              .css({ "margin-top": "-2.1em", "padding-top": "19px" })
              .addClass("first-section nder-page-header");
          } else if (
            ($(this).index() == "0" && $("#page-header-bg").length == 0) ||
            ($(this).index() == "0" && $(".parallax_slider_outer").length == 0)
          ) {
            if ($('body[data-header-resize="0"]').length == 1) {
              $(this)
                .css({ "margin-top": "-30px", "padding-top": "50px" })
                .addClass("first-section");
            } else {
              $(this)
                .css({ "margin-top": "-70px", "padding-top": "50px" })
                .addClass("first-section");
            }
          }
        }
      });

      $(".parallax_slider_outer").each(function () {
        if (
          !$(this).parent().hasClass("span_9") &&
          !$(this).parent().hasClass("span_3") &&
          $(this).parent().attr("id") != "sidebar-inner"
        ) {
          if (
            $(this).parents("#portfolio-extra").length > 0 &&
            $("#full_width_portfolio").length == 0
          )
            return false;
          ////first
          if (
            $(this).parent().index() == "0" &&
            $("#page-header-bg").length != 0
          ) {
            $(this).addClass("first-section nder-page-header");
          } else if (
            $(this).parent().index() == "0" &&
            $("#page-header-bg").length == 0
          ) {
            $(this).css("margin-top", "-40px").addClass("first-section");
            if (!$("body").hasClass("single-post"))
              $(".container-wrap").css("padding-top", "0px");
          }

          //check if it's also last (i.e. the only fws)
          if (
            $(this).parent().index() == $contentElementsNum - 1 &&
            $("#post-area").length == 0
          ) {
            $("#call-to-action .triangle").remove();
            $(".container-wrap").hide();
          }
        }
      });
    }

    //if not using a fullwidth slider first, ajdust the top padding
    //if( $('.nectar-slider-wrap.first-section').length > 0 && $('.nectar-slider-wrap.first-section').attr('data-full-width') != 'true' || $('.nectar-slider-wrap.first-section').length > 0 && $('.nectar-slider-wrap.first-section').attr('data-full-width') != 'boxed-full-width' ) $('body').attr('data-bg-header','false');
    //if( $('.wpb_row.first-section:not(".full-width-content") .nectar-slider-wrap').length > 0 && $('.wpb_row.first-section:not(".full-width-content") .nectar-slider-wrap').attr('data-full-width') != 'true' || $('.wpb_row.first-section:not(".full-width-content") .nectar-slider-wrap').length > 0 && $('.wpb_row.first-section:not(".full-width-content") .nectar-slider-wrap').attr('data-full-width') != 'boxed-full-width' ) $('body').attr('data-bg-header','false');

    //set sizes
    fullWidthSections();
    fwsClasses();

    //sizing for fullwidth sections that are image only

    function fullwidthImgOnlySizingInit() {
      ////set inital sizes
      $(".full-width-section:not(.custom-skip)").each(function () {
        var $fwsHeight = $(this).outerHeight(true);

        //make sure it's empty and also not being used as a small dvider
        if (
          $(this).find(".span_12 *").length == 0 &&
          $.trim($(this).find(".span_12").text()).length == 0 &&
          $fwsHeight > 40
        ) {
          $(this).addClass("bg-only");
          $(this).css({
            height: $fwsHeight,
            "padding-top": "0px",
            "padding-bottom": "0px",
          });
          $(this).attr("data-image-height", $fwsHeight);
        }
      });
    }

    function fullwidthImgOnlySizing() {
      $(".full-width-section.bg-only").each(function () {
        var $initialHeight = $(this).attr("data-image-height");

        if (window.innerWidth < 1000 && window.innerWidth > 690) {
          $(this).css("height", $initialHeight - $initialHeight * 0.6);
        } else if (window.innerWidth <= 690) {
          $(this).css("height", $initialHeight - $initialHeight * 0.78);
        } else if (window.innerWidth < 1300 && window.innerWidth >= 1000) {
          $(this).css("height", $initialHeight - $initialHeight * 0.33);
        } else {
          $(this).css("height", $initialHeight);
        }
      });
    }

    fullwidthImgOnlySizingInit();
    fullwidthImgOnlySizing();

    //change % padding on rows to be relative to screen
    function fullWidthRowPaddingAdjustInit() {
      if ($("#boxed").length == 0) {
        $(".full-width-section, .full-width-content").each(function () {
          var $topPadding = $(this)[0].style.paddingTop;
          var $bottomPadding = $(this)[0].style.paddingBottom;

          if ($topPadding.indexOf("%") >= 0)
            $(this).attr("data-top-percent", $topPadding);
          if ($bottomPadding.indexOf("%") >= 0)
            $(this).attr("data-bottom-percent", $bottomPadding);
        });
      }
    }

    function fullWidthRowPaddingAdjustCalc() {
      if ($("#boxed").length == 0) {
        $(
          ".full-width-section[data-top-percent], .full-width-section[data-bottom-percent], .full-width-content[data-top-percent],  .full-width-content[data-bottom-percent]"
        ).each(function () {
          var $windowHeight = $(window).width();
          var $topPadding = $(this).attr("data-top-percent")
            ? $(this).attr("data-top-percent")
            : "skip";
          var $bottomPadding = $(this).attr("data-bottom-percent")
            ? $(this).attr("data-bottom-percent")
            : "skip";

          //top
          if ($topPadding != "skip") {
            $(this).css(
              "padding-top",
              $windowHeight * (parseInt($topPadding) / 100)
            );
          }

          //bottom
          if ($bottomPadding != "skip") {
            $(this).css(
              "padding-bottom",
              $windowHeight * (parseInt($bottomPadding) / 100)
            );
          }
        });
      }
    }
    fullWidthRowPaddingAdjustInit();
    fullWidthRowPaddingAdjustCalc();

    //full width content column sizing
    function fullWidthContentColumns() {
      //standard carousel
      $(
        ".main-content > .row > .full-width-content, #portfolio-extra > .full-width-content, .woocommerce-tabs #tab-description > .full-width-content, #post-area.span_12 article .content-inner > .full-width-content"
      ).each(function () {
        //only set the height if more than one column
        if ($(this).find("> .span_12 > .col").length > 1) {
          var tallestColumn = 0;
          var $columnInnerHeight = 0;

          $(this)
            .find("> .span_12 > .col")
            .each(function () {
              $column_inner_selector =
                $(this).find("> .vc_column-inner > .wpb_wrapper").length > 0
                  ? ".vc_column-inner"
                  : ".column-inner-wrap > .column-inner";

              var $padding = parseInt($(this).css("padding-top"));
              //var $padding = (!$(this).is('[data-animation*="reveal"]')) ? parseInt($(this).css('padding-top')) : parseInt($(this).find('> .column-inner-wrap > .column-inner').css('padding-top')); start to reveal fix
              $(this)
                .find("> " + $column_inner_selector + " > .wpb_wrapper")
                .height() +
                $padding * 2 >
              tallestColumn
                ? (tallestColumn =
                    $(this)
                      .find("> " + $column_inner_selector + " > .wpb_wrapper")
                      .height() +
                    $padding * 2)
                : (tallestColumn = tallestColumn);
            });

          $(this)
            .find("> .span_12 > .col")
            .each(function () {
              $column_inner_selector =
                $(this).find("> .vc_column-inner > .wpb_wrapper").length > 0
                  ? ".vc_column-inner"
                  : ".column-inner-wrap > .column-inner";

              //columns with content
              if (
                $(this).find(
                  "> " + $column_inner_selector + " > .wpb_wrapper > *"
                ).length > 0
              ) {
                //added in 7.6 to fix equal height columns
                if (
                  !$(this).parent().parent().hasClass("vc_row-o-equal-height")
                )
                  $(this).css("height", tallestColumn);
              }
              //empty columns
              else {
                $(this).css("min-height", tallestColumn);
                if ($(this).is('[data-animation*="reveal"]'))
                  $(this)
                    .find(".column-inner")
                    .css("min-height", tallestColumn);
              }
            });

          //nested column height
          var $childRows = $(this).find("> .span_12 > .col .wpb_row").length;
          if (window.innerWidth > 1000) {
            var $padding = parseInt(
              $(this).find("> .span_12 > .col").css("padding-top")
            );

            //$(this).find('> .span_12 > .col .wpb_row .col').css('min-height',(tallestColumn-($padding*2))/$childRows + 'px');
          } else {
            $(this)
              .find("> .span_12 > .col .wpb_row .col")
              .css("min-height", "0px");
          }

          //vertically center
          if (
            $(this).hasClass("vertically-align-columns") &&
            window.innerWidth > 1000 &&
            !$(this).hasClass("vc_row-o-equal-height")
          ) {
            //parent columns
            $(this)
              .find("> .span_12 > .col")
              .each(function () {
                $column_inner_selector =
                  $(this).find("> .vc_column-inner > .wpb_wrapper").length > 0
                    ? ".vc_column-inner"
                    : ".column-inner-wrap > .column-inner";

                $columnInnerHeight = $(this)
                  .find("> " + $column_inner_selector + " > .wpb_wrapper")
                  .height();
                var $marginCalc = $(this).height() / 2 - $columnInnerHeight / 2;
                if ($marginCalc <= 0) $marginCalc = 0;

                $(this)
                  .find("> " + $column_inner_selector + " > .wpb_wrapper")
                  .css("margin-top", $marginCalc);
                $(this)
                  .find("> " + $column_inner_selector + " > .wpb_wrapper")
                  .css("margin-bottom", $marginCalc);
              });
          }
        }
      });

      //requal height columns in container type with reveal columns
      $(
        ".main-content > .row > .wpb_row:not(.full-width-content).vc_row-o-equal-height"
      ).each(function () {
        if (
          $(this).find('>.span_12>.wpb_column[data-animation*="reveal"]')
            .length > 0
        ) {
          var tallestColumn = 0;
          var $columnInnerHeight = 0;

          $(this)
            .find("> .span_12 > .col")
            .each(function () {
              var $padding = parseInt(
                $(this)
                  .find("> .column-inner-wrap > .column-inner")
                  .css("padding-top")
              );
              $(this).find("> .column-inner-wrap > .column-inner").height() +
                $padding * 2 >
              tallestColumn
                ? (tallestColumn =
                    $(this)
                      .find("> .column-inner-wrap > .column-inner")
                      .height() +
                    $padding * 2)
                : (tallestColumn = tallestColumn);
            });

          $(this)
            .find("> .span_12 > .col")
            .each(function () {
              //columns with content
              if (
                $(this).find(
                  "> .column-inner-wrap > .column-inner .wpb_wrapper > *"
                ).length > 0
              ) {
                $(this)
                  .find("> .column-inner-wrap")
                  .css("height", tallestColumn);
              }
              //empty columns
              else {
                $(this).css("min-height", tallestColumn);
                if ($(this).is('[data-animation*="reveal"]'))
                  $(this)
                    .find(".column-inner")
                    .css("min-height", tallestColumn);
              }
            });
        }
      });

      //using equal height option, top/bottom padding % needs to be convered into px for cross browser (flex bug)
      $(
        '.vc_row.vc_row-o-equal-height>.span_12>.wpb_column[class*="padding-"][data-padding-pos="all"]'
      ).each(function () {
        $(this).css({
          "padding-top": $(this).css("padding-left"),
          "padding-bottom": $(this).css("padding-left"),
        });
      });
    }

    fullWidthContentColumns();
    if ($(".owl-carousel").length > 0) owlCarouselInit();

    var $mouseParallaxScenes = [];
    function mouseParallaxInit() {
      $(".wpb_row:has(.nectar-parallax-scene)").each(function (i) {
        var $headerNavSpace =
          $('body[data-header-format="left-header"]').length > 0 &&
          $(window).width() > 1000
            ? 0
            : $("#header-space").height();

        if ($(this).hasClass("first-section")) {
          $(
            'body #header-outer[data-transparent-header="true"] .ns-loading-cover'
          ).show();

          if (
            $('body #header-outer[data-transparent-header="true"]').length > 0
          ) {
            $(this).css("overflow", "hidden");
            $(this).find(".nectar-slider-loading").css({
              top: $headerNavSpace,
              "margin-top": "-1px",
            });
            $(this)
              .find(".nectar-slider-loading .loading-icon")
              .css({
                height:
                  $(".first-section .nectar-parallax-scene").height() -
                  $headerNavSpace +
                  "px",
                opacity: "1",
              });
          }
        }

        var $strength = parseInt(
          $(this).find(".nectar-parallax-scene").attr("data-scene-strength")
        );

        $mouseParallaxScenes[i] = $(this)
          .find(".nectar-parallax-scene")
          .parallax({
            scalarX: $strength,
            scalarY: $strength,
          });

        //wait until the images in the scene have loaded
        var images = $(this).find(".nectar-parallax-scene li");

        $.each(images, function () {
          if ($(this).find("div").length > 0) {
            var el = $(this).find("div"),
              image = el
                .css("background-image")
                .replace(/"/g, "")
                .replace(/url\(|\)$/gi, "");
            if (image && image !== "" && image !== "none")
              images = images.add($("<img>").attr("src", image));
          }
        });

        var $that = $(this);
        images.imagesLoaded(function () {
          $that
            .find(
              "> .nectar-slider-loading, .full-page-inner > .nectar-slider-loading"
            )
            .fadeOut(800, "easeInOutExpo");
          if ($that.hasClass("first-section")) {
            $(
              'body #header-outer[data-transparent-header="true"] .ns-loading-cover'
            ).fadeOut(800, "easeInOutExpo", function () {
              $(this).remove();
            });
          }
        });
      });
    }
    mouseParallaxInit();

    /***************** Checkmarks ******************/

    function ulChecks() {
      $("ul.checks li").prepend('<i class="icon-ok-sign"></i>');
    }
    ulChecks();

    /***************** Image with Animation / Col Animation *******************/

    function colAndImgAnimations() {
      $colAndImgOffsetPos =
        $("#nectar_fullscreen_rows").length > 0 ? "200%" : "88%";
      $colAndImgOffsetPos2 =
        $("#nectar_fullscreen_rows").length > 0 ? "200%" : "70%";

      $($fullscreenSelector + "img.img-with-animation").each(function () {
        var $that = $(this);
        var $animationEasing =
          $("body[data-cae]").length > 0
            ? $("body").attr("data-cae")
            : "easeOutSine";
        var $animationDuration =
          $("body[data-cad]").length > 0 ? $("body").attr("data-cad") : "650";

        var waypoint = new Waypoint({
          element: $that,
          handler: function (direction) {
            if (
              ($that.parents(".wpb_tab").length > 0 &&
                $that.parents(".wpb_tab").css("visibility") == "hidden") ||
              $that.hasClass("animated-in")
            ) {
              waypoint.destroy();
              return;
            }

            if (
              !navigator.userAgent.match(
                /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
              ) ||
              $('body[data-responsive="0"]').length > 0
            ) {
              if ($that.attr("data-animation") == "fade-in-from-left") {
                $that.delay($that.attr("data-delay")).transition(
                  {
                    opacity: 1,
                    x: "0px",
                  },
                  $animationDuration,
                  $animationEasing
                );
              } else if ($that.attr("data-animation") == "fade-in-from-right") {
                $that.delay($that.attr("data-delay")).transition(
                  {
                    opacity: 1,
                    x: "0px",
                  },
                  $animationDuration,
                  $animationEasing
                );
              } else if (
                $that.attr("data-animation") == "fade-in-from-bottom"
              ) {
                $that.delay($that.attr("data-delay")).transition(
                  {
                    opacity: 1,
                    y: "0px",
                  },
                  $animationDuration,
                  $animationEasing
                );
              } else if ($that.attr("data-animation") == "fade-in") {
                $that.delay($that.attr("data-delay")).transition(
                  {
                    opacity: 1,
                  },
                  $animationDuration,
                  $animationEasing
                );
              } else if ($that.attr("data-animation") == "grow-in") {
                setTimeout(function () {
                  $that.transition(
                    { scale: 1, opacity: 1 },
                    $animationDuration,
                    $animationEasing
                  );
                }, $that.attr("data-delay"));
              } else if ($that.attr("data-animation") == "flip-in") {
                setTimeout(function () {
                  $that.transition(
                    { rotateY: 0, opacity: 1 },
                    $animationDuration,
                    $animationEasing
                  );
                }, $that.attr("data-delay"));
              } else if ($that.attr("data-animation") == "flip-in-vertical") {
                setTimeout(function () {
                  $that.transition(
                    { rotateX: 0, opacity: 1 },
                    $animationDuration,
                    $animationEasing
                  );
                }, $that.attr("data-delay"));
              }

              $that.addClass("animated-in");
            }

            waypoint.destroy();
          },
          offset: $colAndImgOffsetPos,
        });
      });

      $($fullscreenSelector + ".nectar_cascading_images").each(function () {
        var $that = $(this);
        var $animationEasing =
          $("body[data-cae]").length > 0
            ? $("body").attr("data-cae")
            : "easeOutSine";
        var $animationDuration =
          $("body[data-cad]").length > 0 ? $("body").attr("data-cad") : "650";
        var $animationDelay = $(this).is("[data-animation-timing]")
          ? $(this).attr("data-animation-timing")
          : 175;
        $animationDelay = parseInt($animationDelay);

        var waypoint = new Waypoint({
          element: $that,
          handler: function (direction) {
            if (
              ($that.parents(".wpb_tab").length > 0 &&
                $that.parents(".wpb_tab").css("visibility") == "hidden") ||
              $that.hasClass("animated-in")
            ) {
              waypoint.destroy();
              return;
            }

            if (
              !navigator.userAgent.match(
                /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
              ) ||
              $('body[data-responsive="0"]').length > 0
            ) {
              $that.find(".cascading-image").each(function (i) {
                var $that2 = $(this);

                if (
                  $that2.attr("data-animation") == "flip-in" ||
                  $that2.attr("data-animation") == "flip-in-vertical"
                ) {
                  setTimeout(function () {
                    $that2.find(".inner-wrap").css({
                      opacity: 1,
                      transform: "rotate(0deg) translateZ(0px)",
                    });
                  }, i * $animationDelay);
                } else {
                  setTimeout(function () {
                    $that2.find(".inner-wrap").css({
                      opacity: 1,
                      transform:
                        "translateX(0px) translateY(0px) scale(1,1) translateZ(0px)",
                    });
                  }, i * $animationDelay);
                }
              });

              $that.addClass("animated-in");
            }

            waypoint.destroy();
          },
          offset: $colAndImgOffsetPos,
        });
      });

      $(
        $fullscreenSelector +
          '.col.has-animation:not([data-animation*="reveal"]), ' +
          $fullscreenSelector +
          '.wpb_column.has-animation:not([data-animation*="reveal"])'
      ).each(function (i) {
        var $that = $(this);
        var $animationEasing =
          $("body[data-cae]").length > 0
            ? $("body").attr("data-cae")
            : "easeOutSine";
        var $animationDuration =
          $("body[data-cad]").length > 0 ? $("body").attr("data-cad") : "650";

        //set perspective for vertical flip
        if ($that.is('[data-animation="flip-in-vertical"]')) {
          $that.parents(".col.span_12").addClass("flip-in-vertical-wrap");
        }

        var waypoint = new Waypoint({
          element: $that,
          handler: function (direction) {
            if (
              ($that.parents(".wpb_tab").length > 0 &&
                $that.parents(".wpb_tab").css("visibility") == "hidden") ||
              $that.hasClass("animated-in")
            ) {
              waypoint.destroy();
              return;
            }

            if (
              !navigator.userAgent.match(
                /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
              ) ||
              $('body[data-responsive="0"]').length > 0
            ) {
              if ($that.attr("data-animation") == "fade-in-from-left") {
                $standAnimatedColTimeout[i] = setTimeout(function () {
                  $that.transition(
                    {
                      opacity: 1,
                      x: "0px",
                    },
                    $animationDuration,
                    $animationEasing
                  );
                }, $that.attr("data-delay"));
              } else if ($that.attr("data-animation") == "fade-in-from-right") {
                $standAnimatedColTimeout[i] = setTimeout(function () {
                  $that.transition(
                    {
                      opacity: 1,
                      x: "0px",
                    },
                    $animationDuration,
                    $animationEasing
                  );
                }, $that.attr("data-delay"));
              } else if (
                $that.attr("data-animation") == "fade-in-from-bottom"
              ) {
                $standAnimatedColTimeout[i] = setTimeout(function () {
                  $that.transition(
                    {
                      opacity: 1,
                      y: "0px",
                    },
                    $animationDuration,
                    $animationEasing
                  );
                }, $that.attr("data-delay"));
              } else if ($that.attr("data-animation") == "fade-in") {
                $standAnimatedColTimeout[i] = setTimeout(function () {
                  $that.transition(
                    {
                      opacity: 1,
                    },
                    $animationDuration,
                    $animationEasing
                  );
                }, $that.attr("data-delay"));
              } else if ($that.attr("data-animation") == "grow-in") {
                $standAnimatedColTimeout[i] = setTimeout(function () {
                  $that.transition(
                    { scale: 1, opacity: 1 },
                    $animationDuration,
                    $animationEasing
                  );
                }, $that.attr("data-delay"));
              } else if ($that.attr("data-animation") == "flip-in") {
                $standAnimatedColTimeout[i] = setTimeout(function () {
                  $that.transition(
                    { rotateY: 0, opacity: 1 },
                    $animationDuration,
                    $animationEasing
                  );
                }, $that.attr("data-delay"));
              } else if ($that.attr("data-animation") == "flip-in-vertical") {
                $standAnimatedColTimeout[i] = setTimeout(function () {
                  $that.transition(
                    { rotateX: 0, y: 0, opacity: 1 },
                    $animationDuration,
                    $animationEasing
                  );
                }, $that.attr("data-delay"));
              }

              //boxed column hover fix
              if ($that.hasClass("boxed")) {
                $that.addClass("no-pointer-events");
                setTimeout(function () {
                  $that.removeClass("no-pointer-events");
                }, parseInt($animationDuration) +
                  parseInt($that.attr("data-delay")) +
                  30);
              }

              $that.addClass("animated-in");
            }

            waypoint.destroy();
          },
          offset: $colAndImgOffsetPos,
        });
      });

      $(
        $fullscreenSelector +
          '.wpb_column.has-animation[data-animation*="reveal"]'
      ).each(function () {
        var $that = $(this);
        var $animationEasing =
          $("body[data-cae]").length > 0
            ? $("body").attr("data-cae")
            : "easeOutSine";
        var $animationDuration =
          $("body[data-cad]").length > 0 ? $("body").attr("data-cad") : "650";

        var waypoint = new Waypoint({
          element: $that,
          handler: function (direction) {
            if (
              ($that.parents(".wpb_tab").length > 0 &&
                $that.parents(".wpb_tab").css("visibility") == "hidden") ||
              $that.hasClass("animated-in")
            ) {
              waypoint.destroy();
              return;
            }

            if (
              !navigator.userAgent.match(
                /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
              ) ||
              $('body[data-responsive="0"]').length > 0
            ) {
              if (
                $that.attr("data-animation") == "reveal-from-bottom" ||
                $that.attr("data-animation") == "reveal-from-top"
              ) {
                setTimeout(function () {
                  if ($that.hasClass("animated-in"))
                    $that
                      .find(".column-inner-wrap, .column-inner")
                      .transition(
                        { y: 0 },
                        $animationDuration,
                        $animationEasing,
                        function () {
                          if ($that.hasClass("animated-in"))
                            $that
                              .find(".column-inner-wrap, .column-inner")
                              .addClass("no-transform");
                        }
                      );
                }, $that.attr("data-delay"));
              } else if (
                $that.attr("data-animation") == "reveal-from-right" ||
                $that.attr("data-animation") == "reveal-from-left"
              ) {
                setTimeout(function () {
                  if ($that.hasClass("animated-in"))
                    $that
                      .find(".column-inner-wrap, .column-inner")
                      .transition(
                        { x: 0 },
                        $animationDuration,
                        $animationEasing,
                        function () {
                          if ($that.hasClass("animated-in"))
                            $that
                              .find(".column-inner-wrap, .column-inner")
                              .addClass("no-transform");
                        }
                      );
                }, $that.attr("data-delay"));
              }

              $that.addClass("animated-in");
            }

            waypoint.destroy();
          },
          offset: $colAndImgOffsetPos2,
        });
      });
    }

    setTimeout(function () {
      //if($('.nectar-box-roll').length == 0) colAndImgAnimations();
    }, $animationOnScrollTimeOut);

    function cascadingImageBGSizing() {
      $(".nectar_cascading_images").each(function () {
        //handle max width for cascading images in equal height columns
        if (
          $(this).parents(".vc_row-o-equal-height").length > 0 &&
          $(this).parents(".wpb_column").length > 0
        )
          $(this).css("max-width", $(this).parents(".wpb_column").width());

        //set size for layers with no images
        $(this)
          .find(".bg-color")
          .each(function () {
            var $bgColorHeight = 0;
            var $bgColorWidth = 0;
            if ($(this).parent().find(".img-wrap").length == 0) {
              $firstSibling = $(this)
                .parents(".cascading-image")
                .siblings('.cascading-image[data-has-img="true"]')
                .first();

              $firstSibling.css({ position: "relative", visiblity: "hidden" });
              $bgColorHeight = $firstSibling.find(".img-wrap").height();
              $bgColorWidth = $firstSibling.find(".img-wrap").width();
              if ($firstSibling.index() == 0) {
                $firstSibling.css({ visiblity: "visible" });
              } else {
                $firstSibling.css({
                  position: "absolute",
                  visiblity: "visible",
                });
              }
            } else {
              $bgColorHeight = $(this).parent().find(".img-wrap").height();
              $bgColorWidth = $(this).parent().find(".img-wrap").width();
            }

            $(this).css({ height: $bgColorHeight, width: $bgColorWidth });
          });
      });
    }
    imagesLoaded($(".nectar_cascading_images"), function (instance) {
      cascadingImageBGSizing();
    });

    function splitLineHeadings() {
      $splitLineOffsetPos =
        $("#nectar_fullscreen_rows").length > 0 ? "100%" : "bottom-in-view";
      $($fullscreenSelector + ".nectar-split-heading").each(function () {
        var $that = $(this);
        var $animationEasing =
          $("body[data-cae]").length > 0
            ? $("body").attr("data-cae")
            : "easeOutSine";
        var $animationDuration =
          $("body[data-cad]").length > 0 ? $("body").attr("data-cad") : "650";

        var waypoint = new Waypoint({
          element: $that,
          handler: function (direction) {
            if (
              ($that.parents(".wpb_tab").length > 0 &&
                $that.parents(".wpb_tab").css("visibility") == "hidden") ||
              $that.hasClass("animated-in")
            ) {
              waypoint.destroy();
              return;
            }

            if (
              !navigator.userAgent.match(
                /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
              ) ||
              $('body[data-responsive="0"]').length > 0
            ) {
              $that.find(".heading-line").each(function (i) {
                //if($that.parents('.first-section').length > 0 && $('body[data-aie="zoom-out"]').length > 0) i = i+4;
                $(this)
                  .find("> div")
                  .delay(i * 70)
                  .transition(
                    {
                      y: "0px",
                    },
                    $animationDuration,
                    $animationEasing
                  );
              });

              $that.addClass("animated-in");
            }

            waypoint.destroy();
          },
          offset: $splitLineOffsetPos,
        });
      });
    }

    /***************** 4 Col Grid in iPad ******************/

    //add one-fourth class
    function oneFourthClasses() {
      $(".col.span_3, .vc_span3, .vc_col-sm-3").each(function () {
        var $currentDiv = $(this);
        var $nextDiv = $(this).next("div");
        if (
          ($nextDiv.hasClass("span_3") &&
            !$currentDiv.hasClass("one-fourths")) ||
          ($nextDiv.hasClass("vc_span3") &&
            !$currentDiv.hasClass("one-fourths")) ||
          ($nextDiv.hasClass("vc_col-sm-3") &&
            !$currentDiv.hasClass("one-fourths"))
        ) {
          $currentDiv.addClass("one-fourths clear-both");
          $nextDiv.addClass("one-fourths right-edge");
        }
      });

      /*$('.vc_span4').each(function(){
			if($(this).find('.team-member').length > 0 && $(this).parents('.full-width-content').length > 0) {
				var $currentDiv = $(this);
				var $nextDiv = $(this).next('div');
				if( !$currentDiv.hasClass('one-fourths')) {
					$currentDiv.addClass('one-fourths clear-both');
					$nextDiv.addClass('one-fourths right-edge');
				}
			}
		});*/

      //make empty second 1/2 half columsn display right on iPad
      $(".span_12 .col.span_6").each(function () {
        if (
          $(this).next("div").hasClass("span_6") &&
          $.trim($(this).next("div").html()).length == 0
        ) {
          $(this).addClass("empty-second");
        }
      });
    }
    oneFourthClasses();

    /***************** Bar Graph ******************/
    function progressBars() {
      $progressBarsOffsetPos =
        $("#nectar_fullscreen_rows").length > 0 ? "100%" : "bottom-in-view";
      $($fullscreenSelector + ".nectar-progress-bar")
        .parent()
        .each(function (i) {
          var $that = $(this);
          var waypoint = new Waypoint({
            element: $that,
            handler: function (direction) {
              if (
                ($that.parents(".wpb_tab").length > 0 &&
                  $that.parents(".wpb_tab").css("visibility") == "hidden") ||
                $that.hasClass("completed")
              ) {
                waypoint.destroy();
                return;
              }

              if ($progressBarsOffsetPos == "100%")
                $that
                  .find(".nectar-progress-bar .bar-wrap")
                  .css("opacity", "1");

              $that.find(".nectar-progress-bar").each(function (i) {
                var percent = $(this).find("span").attr("data-width");
                var $endNum = parseInt($(this).find("span strong i").text());
                var $that = $(this);

                $that
                  .find("span")
                  .delay(i * 90)
                  .transition(
                    {
                      width: percent + "%",
                    },
                    1050,
                    "easeInOutQuint",
                    function () {}
                  );

                setTimeout(function () {
                  var countOptions = { useEasing: false };
                  var $countEle = $that.find("span strong i")[0];
                  var numAnim = new CountUp(
                    $countEle,
                    0,
                    $endNum,
                    0,
                    1,
                    countOptions
                  );
                  numAnim.start();

                  $that.find("span strong").transition(
                    {
                      opacity: 1,
                    },
                    550,
                    "easeInCirc"
                  );
                }, i * 90);

                ////100% progress bar
                if (percent == "100") {
                  $that.find("span strong").addClass("full");
                }
              });

              $that.addClass("completed");

              waypoint.destroy();
            },
            offset: $progressBarsOffsetPos,
          });
        });
    }

    /***************** Column Borders ******************/
    function animatedColBorders() {
      $progressBarsOffsetPos =
        $("#nectar_fullscreen_rows").length > 0 ? "100%" : "75%";
      $($fullscreenSelector + '.wpb_column[data-border-animation="true"]').each(
        function (i) {
          var $that = $(this);
          var waypoint = new Waypoint({
            element: $that,
            handler: function (direction) {
              if (
                ($that.parents(".wpb_tab").length > 0 &&
                  $that.parents(".wpb_tab").css("visibility") == "hidden") ||
                $that.hasClass("completed")
              ) {
                waypoint.destroy();
                return;
              }

              $borderDelay =
                $that.attr("data-border-animation-delay").length > 0
                  ? parseInt($that.attr("data-border-animation-delay"))
                  : 0;
              setTimeout(function () {
                $that.find(".border-wrap").addClass("animation");
                $that.find(".border-wrap").addClass("completed");
              }, $borderDelay);

              waypoint.destroy();
            },
            offset: $progressBarsOffsetPos,
          });
        }
      );
    }

    /***************** Food Menu Item ******************/
    function foodMenuItems() {
      $foodItemOffsetPos =
        $("#nectar_fullscreen_rows").length > 0 ? "100%" : "80%";
      $($fullscreenSelector + ".nectar_food_menu_item")
        .parent()
        .each(function (i) {
          var $that = $(this);
          var waypoint = new Waypoint({
            element: $that,
            handler: function (direction) {
              if (
                ($that.parents(".wpb_tab").length > 0 &&
                  $that.parents(".wpb_tab").css("visibility") == "hidden") ||
                $that.hasClass("completed")
              ) {
                waypoint.destroy();
                return;
              }

              $that.find(".nectar_food_menu_item").each(function (i) {
                var $that = $(this);

                setTimeout(function () {
                  $that.addClass("animated-in");
                }, i * 150);
              });

              waypoint.destroy();
            },
            offset: $foodItemOffsetPos,
          });
        });
    }

    /***************** Dividers ******************/
    function dividers() {
      $dividerOffsetPos =
        $("#nectar_fullscreen_rows").length > 0 ? "100%" : "bottom-in-view";

      $(
        $fullscreenSelector +
          '.divider-small-border[data-animate="yes"], ' +
          $fullscreenSelector +
          '.divider-border[data-animate="yes"]'
      ).each(function (i) {
        var $lineDur = $(this).hasClass("divider-small-border") ? 1300 : 1500;
        var $that = $(this);
        var waypoint = new Waypoint({
          element: $that,
          handler: function (direction) {
            if (
              ($that.parents(".wpb_tab").length > 0 &&
                $that.parents(".wpb_tab").css("visibility") == "hidden") ||
              $that.hasClass("completed")
            ) {
              waypoint.destroy();
              return;
            }

            $that.each(function (i) {
              $(this).css({ transform: "scale(0,1)", visibility: "visible" });
              var $that = $(this);

              $that.delay($that.attr("data-animation-delay")).transition(
                {
                  transform: "scale(1, 1)",
                },
                $lineDur,
                "cubic-bezier(.18,1,.22,1)"
              );
            });

            $that.addClass("completed");

            waypoint.destroy();
          },
          offset: $dividerOffsetPos,
        });
      });
    }

    //if($('.nectar-box-roll').length == 0) dividers();

    /***************** Icon List ******************/
    function iconList() {
      $iconListOffsetPos =
        $("#nectar_fullscreen_rows").length > 0 ? "100%" : "75%";

      $($fullscreenSelector + '.nectar-icon-list[data-animate="true"]').each(
        function (i) {
          var $that = $(this);
          var waypoint = new Waypoint({
            element: $that,
            handler: function (direction) {
              if (
                ($that.parents(".wpb_tab").length > 0 &&
                  $that.parents(".wpb_tab").css("visibility") == "hidden") ||
                $that.hasClass("completed")
              ) {
                waypoint.destroy();
                return;
              }

              $that.each(function (i) {
                $(this)
                  .find(".nectar-icon-list-item")
                  .each(function (i) {
                    var $thatt = $(this);
                    setTimeout(function () {
                      $thatt.addClass("animated");
                    }, i * 300);
                  });
              });

              $that.addClass("completed");

              waypoint.destroy();
            },
            offset: $iconListOffsetPos,
          });
        }
      );
    }

    //bg color match
    var nectarIconBGCss = "";

    $(
      '.nectar-icon-list[data-icon-style="border"], .nectar_icon_wrap[data-style="border-animation"][data-color*="extra-color-gradient-"]'
    ).each(function (i) {
      if (
        $(this).parents('.wpb_column[data-bg-color*="#"]').length > 0 &&
        $(this).parents('.wpb_column[data-bg-opacity="1"]').length > 0
      ) {
        var $bgColorToSet = $(this)
          .parents(".wpb_column")
          .attr("data-bg-color");
      } else if (
        $(this).parents(".wpb_row").length > 0 &&
        $(this).parents(".wpb_row").find(".row-bg.using-bg-color").length > 0
      ) {
        var $bgColorToSet = $(this)
          .parents(".wpb_row")
          .find(".row-bg.using-bg-color")
          .css("background-color");
      } else {
        if ($("#nectar_fullscreen_rows").length > 0)
          var $bgColorToSet = $(
            "#nectar_fullscreen_rows > .wpb_row .full-page-inner-wrap"
          ).css("background-color");
        else var $bgColorToSet = $(".container-wrap").css("background-color");
      }

      if ($(this).hasClass("nectar-icon-list"))
        $(this)
          .find(".list-icon-holder")
          .css("background-color", $bgColorToSet);
      else {
        //must be set in css, can't manip pseudo
        $(this).addClass("instance-" + i);
        nectarIconBGCss +=
          ".nectar_icon_wrap.instance-" +
          i +
          " .nectar_icon:before { background-color: " +
          $bgColorToSet +
          "!important; }";
      }
    });

    if (nectarIconBGCss.length > 0) {
      var head = document.head || document.getElementsByTagName("head")[0];
      var style = document.createElement("style");

      style.type = "text/css";
      if (style.styleSheet) {
        style.styleSheet.cssText = nectarIconBGCss;
      } else {
        style.appendChild(document.createTextNode(nectarIconBGCss));
      }

      head.appendChild(style);
    }

    /***************** Hotspot ******************/
    //add pulse animation
    $('.nectar_image_with_hotspots[data-hotspot-icon="numerical"]').each(
      function () {
        $(this)
          .find(".nectar_hotspot_wrap")
          .each(function (i) {
            var $that = $(this);
            setTimeout(function () {
              $that.find(".nectar_hotspot").addClass("pulse");
            }, i * 300);
          });
      }
    );

    function hotSpotHoverBind() {
      var hotSpotHoverTimeout = [];

      $(
        '.nectar_image_with_hotspots:not([data-tooltip-func="click"]) .nectar_hotspot'
      ).each(function (i) {
        hotSpotHoverTimeout[i] = "";

        $(this).on("mouseover", function () {
          clearTimeout(hotSpotHoverTimeout[i]);
          $(this)
            .parent()
            .css({ "z-index": "400", height: "auto", width: "auto" });
        });

        $(this).on("mouseleave", function () {
          var $that = $(this);
          $that.parent().css({ "z-index": "auto" });

          hotSpotHoverTimeout[i] = setTimeout(function () {
            $that.parent().css({ height: "30px", width: "30px" });
          }, 300);
        });
      });
    }

    hotSpotHoverBind();

    function responsiveTooltips() {
      $(".nectar_image_with_hotspots").each(function () {
        $(this)
          .find(".nectar_hotspot_wrap")
          .each(function (i) {
            if ($(window).width() > 690) {
              //remove click if applicable
              if (
                $(this).parents(
                  '.nectar_image_with_hotspots[data-tooltip-func="hover"]'
                ).length > 0
              ) {
                $(this).find(".nectar_hotspot").removeClass("click");
                $(this).find(".nttip").removeClass("open");
              }
              $(this).find(".nttip .inner a.tipclose").remove();
              $(".nttip").css("height", "auto");

              //reset for positioning
              $(this).css({ width: "auto", height: "auto" });
              $(this)
                .find(".nttip")
                .removeClass("force-right")
                .removeClass("force-left")
                .removeClass("force-top")
                .css("width", "auto");

              var $tipOffset = $(this).find(".nttip").offset();

              //against right side fix
              if (
                $tipOffset.left >
                $(this).parents(".nectar_image_with_hotspots").width() - 200
              )
                $(this).find(".nttip").css("width", "250px");
              else $(this).find(".nttip").css("width", "auto");

              //responsive
              if ($tipOffset.left < 0)
                $(this).find(".nttip").addClass("force-right");
              else if (
                $tipOffset.left + $(this).find(".nttip").outerWidth(true) >
                $(window).width()
              )
                $(this)
                  .find(".nttip")
                  .addClass("force-left")
                  .css("width", "250px");
              else if (
                $tipOffset.top + $(this).find(".nttip").height() + 35 >
                  $(window).height() &&
                $("#nectar_fullscreen_rows").length > 0
              )
                $(this).find(".nttip").addClass("force-top");

              if ($(this).find("> .open").length == 0)
                $(this).css({ width: "30px", height: "30px" });
            } else {
              //fixed position
              $(this)
                .find(".nttip")
                .removeClass("force-left")
                .removeClass("force-right")
                .removeClass("force-top");
              $(this).find(".nectar_hotspot").addClass("click");

              if ($(this).find(".nttip a.tipclose").length == 0)
                $(this)
                  .find(".nttip .inner")
                  .append('<a href="#" class="tipclose"><span></span></a>');

              //change height of fixed
              $(".nttip").css("height", $(window).height());
            }
          });
      });
    }
    responsiveTooltips();

    function imageWithHotspotClickEvents() {
      //click
      $("body").on("click", ".nectar_hotspot.click", function () {
        $(this)
          .parents(".nectar_image_with_hotspots")
          .find(".nttip")
          .removeClass("open");
        $(this).parent().find(".nttip").addClass("open");

        $(this)
          .parents(".nectar_image_with_hotspots")
          .find(".nectar_hotspot")
          .removeClass("open");
        $(this).parent().find(".nectar_hotspot").addClass("open");

        if ($(window).width() > 690) {
          $(this)
            .parent()
            .css({ "z-index": "10", height: "auto", width: "auto" });

          var $that = $(this);

          setTimeout(function () {
            $that
              .parents(".nectar_image_with_hotspots")
              .find(".nectar_hotspot_wrap")
              .each(function () {
                if ($(this).find("> .open").length == 0)
                  $(this).css({
                    height: "30px",
                    width: "30px",
                    "z-index": "auto",
                  });
              });
          }, 300);
        }

        if ($(window).width() <= 690)
          $(this).parents('.wpb_row, [class*="vc_col-"]').css("z-index", "200");

        return false;
      });

      $("body").on("click", ".nectar_hotspot.open", function () {
        $(this).parent().find(".nttip").removeClass("open");
        $(this).parent().find(".nectar_hotspot").removeClass("open");

        $(this).parents(".wpb_row").css("z-index", "auto");

        return false;
      });

      $("body").on("click", ".nttip.open", function () {
        $(this)
          .parents(".nectar_image_with_hotspots")
          .find(".nttip")
          .removeClass("open");

        $(this).parents(".wpb_row").css("z-index", "auto");
        return false;
      });
    }
    imageWithHotspotClickEvents();

    function imageWithHotspots() {
      $imageWithHotspotsOffsetPos =
        $("#nectar_fullscreen_rows").length > 0 ? "100%" : "50%";

      $(
        $fullscreenSelector +
          '.nectar_image_with_hotspots[data-animation="true"]'
      ).each(function (i) {
        var $that = $(this);
        var waypoint = new Waypoint({
          element: $that,
          handler: function (direction) {
            if (
              ($that.parents(".wpb_tab").length > 0 &&
                $that.parents(".wpb_tab").css("visibility") == "hidden") ||
              $that.hasClass("completed")
            ) {
              waypoint.destroy();
              return;
            }

            $that.addClass("completed");
            $that.find(".nectar_hotspot_wrap").each(function (i) {
              var $that2 = $(this);
              var $extrai =
                $that2.parents(".col.has-animation").length > 0 ? 1 : 0;
              setTimeout(function () {
                $that2.addClass("animated-in");
              }, 175 * (i + $extrai));
            });

            waypoint.destroy();
          },
          offset: $imageWithHotspotsOffsetPos,
        });
      });
    }

    /***************** Animated Title ******************/
    function animated_titles() {
      $animatedTitlesOffsetPos =
        $("#nectar_fullscreen_rows").length > 0 ? "100%" : "bottom-in-view";

      $($fullscreenSelector + ".nectar-animated-title").each(function (i) {
        var $that = $(this);
        var waypoint = new Waypoint({
          element: $that,
          handler: function (direction) {
            if (
              ($that.parents(".wpb_tab").length > 0 &&
                $that.parents(".wpb_tab").css("visibility") == "hidden") ||
              $that.hasClass("completed")
            ) {
              waypoint.destroy();
              return;
            }

            $that.addClass("completed");

            waypoint.destroy();
          },
          offset: $animatedTitlesOffsetPos,
        });
      });
    }

    //if($('.nectar-box-roll').length == 0) animated_titles();

    /***************** Pricing Tables ******************/

    var $tallestCol;

    function pricingTableHeight() {
      $('.pricing-table[data-style="default"]').each(function () {
        $tallestCol = 0;

        $(this)
          .find("> div ul")
          .each(function () {
            $(this).height() > $tallestCol
              ? ($tallestCol = $(this).height())
              : ($tallestCol = $tallestCol);
          });

        //safety net incase pricing tables height couldn't be determined
        if ($tallestCol == 0) $tallestCol = "auto";

        //set even height
        $(this).find("> div ul").css("height", $tallestCol);
      });
    }

    pricingTableHeight();

    /***************** Testimonial Slider ******************/

    //testimonial slider controls

    //non minimal
    $("body").on(
      "click",
      '.testimonial_slider:not([data-style*="multiple_visible"]):not([data-style="minimal"]) .controls li',
      function () {
        if ($(this).find("span").hasClass("active")) return false;

        var $index = $(this).index();
        var currentHeight = $(this)
          .parents(".testimonial_slider")
          .find(".slides blockquote")
          .eq($index)
          .height();

        $(this)
          .parents(".testimonial_slider")
          .find("li span")
          .removeClass("active");
        $(this).find("span").addClass("active");

        $(this)
          .parents(".testimonial_slider")
          .find(".slides blockquote")
          .addClass("no-trans");
        $(this)
          .parents(".testimonial_slider")
          .find(".slides blockquote")
          .css({
            opacity: "0",
            transform: "translateX(-25px)",
            "z-index": "1",
          });
        $(this)
          .parents(".testimonial_slider")
          .find(".slides blockquote")
          .eq($index)
          .removeClass("no-trans")
          .css({ opacity: "1", transform: "translateX(0px)" })
          .css("z-index", "20");
        $(this)
          .parents(".testimonial_slider:not(.disable-height-animation)")
          .find(".slides")
          .stop(true, true)
          .animate({ height: currentHeight + 40 + "px" }, 450, "easeOutCubic");

        resizeVideoToCover();
      }
    );

    //minimal
    $("body").on(
      "click",
      '.testimonial_slider[data-style="minimal"] .testimonial-next-prev a',
      function () {
        var $index = $(this)
          .parents(".testimonial_slider")
          .find(".slides blockquote.active")
          .index();
        var $actualIndex = $index;

        $(this)
          .parents(".testimonial_slider")
          .find(".slides blockquote")
          .addClass("no-trans");
        $(this)
          .parents(".testimonial_slider")
          .find(".slides blockquote")
          .css({
            opacity: "0",
            transform: "translateX(-25px)",
            "z-index": "1",
          });

        $(this)
          .parents(".testimonial_slider")
          .find(".slides blockquote")
          .eq($index)
          .removeClass("active");

        if ($(this).hasClass("next")) {
          if (
            $index + 1 >=
            $(this).parents(".testimonial_slider").find(".slides blockquote")
              .length
          ) {
            $actualIndex = 0;
          } else {
            $actualIndex = $index + 1;
          }
          var currentHeight = $(this)
            .parents(".testimonial_slider")
            .find(".slides blockquote")
            .eq($actualIndex)
            .height();
          //show slide
          $(this)
            .parents(".testimonial_slider")
            .find(".slides blockquote")
            .eq($actualIndex)
            .addClass("active")
            .removeClass("no-trans")
            .css({ opacity: "1", transform: "translateX(0px)" })
            .css("z-index", "20");
          //change pag #
          $(this)
            .parents(".testimonial_slider")
            .find(".control-wrap ul")
            .css({ transform: "translateX(-" + 20 * $actualIndex + "px)" });
        } else {
          if ($index - 1 == -1) {
            $actualIndex =
              $(this).parents(".testimonial_slider").find(".slides blockquote")
                .length - 1;
          } else {
            $actualIndex = $index - 1;
          }
          var currentHeight = $(this)
            .parents(".testimonial_slider")
            .find(".slides blockquote")
            .eq($index - 1)
            .height();
          //show slide
          $(this)
            .parents(".testimonial_slider")
            .find(".slides blockquote")
            .eq($index - 1)
            .addClass("active")
            .removeClass("no-trans")
            .css({ opacity: "1", transform: "translateX(0px)" })
            .css("z-index", "20");
          //change pag #
          $(this)
            .parents(".testimonial_slider")
            .find(".control-wrap ul")
            .css({ transform: "translateX(-" + 20 * $actualIndex + "px)" });
        }

        $(this)
          .parents(".testimonial_slider:not(.disable-height-animation)")
          .find(".slides")
          .stop(true, true)
          .animate({ height: currentHeight + 40 + "px" }, 450, "easeOutCubic");

        resizeVideoToCover();

        return false;
      }
    );

    var $tallestQuote;

    //create controls
    function createTestimonialControls() {
      //fadeIn
      $('.testimonial_slider:not([data-style*="multiple_visible"])').animate(
        { opacity: "1" },
        800
      );

      $('.testimonial_slider:not([data-style*="multiple_visible"])').each(
        function (i) {
          if (
            $(this).find("blockquote").length > 1 &&
            $(this).find(".controls").length == 0
          ) {
            $(this).append('<div class="controls"><ul></ul></div>');

            var slideNum = $(this).find("blockquote").length;
            var $that = $(this);

            for (var i = 0; i < slideNum; i++) {
              if (!$(this).is('[data-style="minimal"]')) {
                $that
                  .find(".controls ul")
                  .append('<li><span class="pagination-switch"></span></li>');
              } else {
                $that.find(".controls ul").append("<li>" + (i + 1) + "</li>");
              }
            }

            //minimal
            if ($(this).is('[data-style="minimal"]')) {
              //add next/prev
              $(this).append(
                '<div class="testimonial-next-prev"><a href="#" class="prev fa fa-angle-left"></a><a href="#" class="next fa fa-angle-right"></a></div>'
              );

              //start on first
              $(this)
                .find(".slides blockquote:first-child")
                .addClass("active")
                .css({ opacity: "1", transform: "translateX(0px)" })
                .css("z-index", "20");
              if (!$(this).hasClass("disable-height-animation")) {
                $(this)
                  .find(".slides")
                  .css({
                    height:
                      $(this).find(".slides blockquote:first-child").height() +
                      40 +
                      "px",
                  });
              }

              //autorotate
              if ($(this).attr("data-autorotate").length > 0) {
                slide_interval =
                  parseInt($(this).attr("data-autorotate")) < 100
                    ? 4000
                    : parseInt($(this).attr("data-autorotate"));
                var $that = $(this);
                var $rotate = setInterval(function () {
                  testimonialRotate($that);
                }, slide_interval);
              }
              $(this)
                .find(".testimonial-next-prev a")
                .click(function (e) {
                  if (typeof e.clientX != "undefined") clearInterval($rotate);
                });

              //wrap bullets
              $(this).find(".controls ul").wrap('<div class="control-wrap" />');
              $(this)
                .find(".controls ul")
                .css(
                  "width",
                  $(this).find(".controls ul li").length * 20 + 1 + "px"
                );
              $(this)
                .find(".controls")
                .append(
                  '<span class="out-of">/</span><span class="total">' +
                    $(this).find("blockquote").length +
                    "</span>"
                );

              ////swipe for testimonials
              $(this).swipe({
                swipeLeft: function (e) {
                  $(this).find(".testimonial-next-prev .next").trigger("click");
                  e.stopImmediatePropagation();
                  clearInterval($rotate);
                  return false;
                },
                swipeRight: function (e) {
                  $(this).find(".testimonial-next-prev .prev").trigger("click");
                  e.stopImmediatePropagation();
                  clearInterval($rotate);
                  return false;
                },
              });
            }

            //non minimal
            if (!$(this).is('[data-style="minimal"]')) {
              //activate first slide
              $(this).find(".controls ul li").first().click();

              //autorotate
              if ($(this).attr("data-autorotate").length > 0) {
                slide_interval =
                  parseInt($(this).attr("data-autorotate")) < 100
                    ? 4000
                    : parseInt($(this).attr("data-autorotate"));
                var $that = $(this);
                var $rotate = setInterval(function () {
                  testimonialRotate($that);
                }, slide_interval);
              }

              $(this)
                .find(".controls li")
                .click(function (e) {
                  if (typeof e.clientX != "undefined") clearInterval($rotate);
                });

              ////swipe for testimonials
              $(this).swipe({
                swipeLeft: function (e) {
                  $(this)
                    .find(".controls ul li span.active")
                    .parent()
                    .next("li")
                    .find("span")
                    .trigger("click");
                  e.stopImmediatePropagation();
                  clearInterval($rotate);
                  return false;
                },
                swipeRight: function (e) {
                  $(this)
                    .find(".controls ul li span.active")
                    .parent()
                    .prev("li")
                    .find("span")
                    .trigger("click");
                  e.stopImmediatePropagation();
                  clearInterval($rotate);
                  return false;
                },
              });
            }
          }
          //only one testimonial
          else if ($(this).find(".controls").length == 0) {
            var currentHeight = $(this).find(".slides blockquote").height();
            $(this)
              .find(".slides blockquote")
              .css({
                opacity: "0",
                transform: "translateX(-25px)",
                "z-index": "1",
              });
            $(this)
              .find(".slides blockquote")
              .css({ opacity: "1", transform: "translateX(0px)" })
              .css("z-index", "20");
            $(this)
              .find(".slides")
              .stop(true, true)
              .animate(
                { height: currentHeight + 20 + "px" },
                450,
                "easeOutCubic"
              );
          }
        }
      );

      $('.testimonial_slider[data-style*="multiple_visible"] .slides').each(
        function () {
          var $that = $(this);
          var $element = $that;
          var $autoplay =
            $that.parents(".testimonial_slider").attr("data-autorotate")
              .length > 1 &&
            parseInt(
              $that.parents(".testimonial_slider").attr("data-autorotate")
            ) > 100
              ? parseInt(
                  $that.parents(".testimonial_slider").attr("data-autorotate")
                )
              : 4000;
          if ($that.find("img").length == 0) $element = $("body");

          //move img pos
          if (
            $(this).parents(".testimonial_slider").attr("data-style") !=
            "multiple_visible_minimal"
          ) {
            $(this)
              .find("blockquote")
              .each(function () {
                $(this).find(".image-icon").insertAfter($(this).find("p"));
              });
          } else {
            //has alf class
            if ($(this).find("blockquote").length > 4) {
              $(this).parents(".testimonial_slider").addClass("has-alf");
            }
          }

          var $testimonialGroupCells =
            $(this).parents(".testimonial_slider").attr("data-style") ==
            "multiple_visible_minimal"
              ? true
              : false;

          imagesLoaded($element, function (instance) {
            $that.flickity({
              contain: true,
              draggable: true,
              groupCells: $testimonialGroupCells,
              lazyLoad: false,
              imagesLoaded: true,
              percentPosition: true,
              prevNextButtons: false,
              pageDots: true,
              resize: true,
              setGallerySize: true,
              wrapAround: true,
              autoPlay: $autoplay,
              accessibility: false,
            });

            $that.parents(".testimonial_slider").css("opacity", "1");
          }); //images loaded
        }
      ); //each
    }
    createTestimonialControls();

    function testimonialRotate(slider) {
      var $testimonialLength = slider.find("li").length;
      var $currentTestimonial = slider
        .find(".pagination-switch.active")
        .parent()
        .index();

      //stop the rotation when toggles are closed
      if (
        slider.parents(".toggle").length > 0 &&
        slider.parents(".toggle").hasClass("open")
      ) {
        if (!slider.is('[data-style="minimal"]')) {
          if ($currentTestimonial + 1 == $testimonialLength) {
            slider.find("ul li:first-child").click();
          } else {
            slider
              .find(".pagination-switch.active")
              .parent()
              .next("li")
              .click();
          }
        } else {
          slider.find(".testimonial-next-prev .next").click();
        }
      } else {
        if (!slider.is('[data-style="minimal"]')) {
          if ($currentTestimonial + 1 == $testimonialLength) {
            slider.find("ul li:first-child").click();
          } else {
            slider
              .find(".pagination-switch.active")
              .parent()
              .next("li")
              .click();
          }
        } else {
          slider.find(".testimonial-next-prev .next").click();
        }
      }
    }

    function testimonialHeightResize() {
      $(
        '.testimonial_slider:not(.disable-height-animation):not([data-style*="multiple_visible"])'
      ).each(function () {
        var $index = $(this)
          .find(".controls ul li span.active")
          .parent()
          .index();
        var currentHeight = $(this)
          .find(".slides blockquote")
          .eq($index)
          .height();
        $(this)
          .find(".slides")
          .stop(true, true)
          .css({ height: currentHeight + 40 + "px" });
      });
    }

    function testimonialSliderHeight() {
      $(
        '.testimonial_slider.disable-height-animation:not([data-style*="multiple_visible"])'
      ).each(function () {
        $tallestQuote = 0;

        $(this)
          .find("blockquote")
          .each(function () {
            $(this).height() > $tallestQuote
              ? ($tallestQuote = $(this).height())
              : ($tallestQuote = $tallestQuote);
          });

        //safety net incase height couldn't be determined
        if ($tallestQuote == 0) $tallestQuote = 100;

        //set even height
        $(this)
          .find(".slides")
          .css("height", $tallestQuote + 40 + "px");

        //show the slider once height is set
        $(this).animate({ opacity: "1" });

        fullWidthContentColumns();
      });
    }

    function testimonialSliderHeightMinimalMult() {
      $('.testimonial_slider[data-style="multiple_visible_minimal"]').each(
        function () {
          $tallestQuote = 0;

          $(this).find("blockquote > .inner p").css("height", "auto");

          $(this)
            .find("blockquote > .inner p")
            .each(function () {
              $(this).height() > $tallestQuote
                ? ($tallestQuote = $(this).height())
                : ($tallestQuote = $tallestQuote);
            });

          //safety net incase height couldn't be determined
          if ($tallestQuote == 0) $tallestQuote = 200;

          //set even height
          $(this)
            .find("blockquote > .inner p")
            .css("height", $tallestQuote + "px");
        }
      );
    }

    if (
      $(
        '.testimonial_slider.disable-height-animation:not([data-style*="multiple_visible"])'
      ).length > 0
    ) {
      testimonialSliderHeight();
      setTimeout(testimonialSliderHeight, 500);
    }

    if (
      $('.testimonial_slider[data-style="multiple_visible_minimal"]').length > 0
    ) {
      testimonialSliderHeightMinimalMult();
      setTimeout(testimonialSliderHeightMinimalMult, 500);
    }

    /***************** WP Media Embed / External Embed ******************/

    //this isn't the for the video shortcode* This is to help any external iframe embed fit & resize correctly
    function responsiveVideoIframesInit() {
      $("iframe").each(function () {
        //make sure the iframe has a src (things like adsense don't)
        if (
          typeof $(this).attr("src") != "undefined" &&
          !$(this).parent().hasClass("iframe-embed") &&
          $(this).parents(".ult_modal").length == 0 &&
          $(this).parents(".ls-slide").length == 0 &&
          $(this).parents(".esg-entry-media").length == 0
        ) {
          if (
            $(this).attr("src").toLowerCase().indexOf("youtube") >= 0 ||
            $(this).attr("src").toLowerCase().indexOf("vimeo") >= 0 ||
            $(this).attr("src").toLowerCase().indexOf("twitch.tv") >= 0 ||
            $(this).attr("src").toLowerCase().indexOf("kickstarter") >= 0 ||
            $(this).attr("src").toLowerCase().indexOf("embed-ssl.ted") >= 0 ||
            $(this).attr("src").toLowerCase().indexOf("dailymotion") >= 0
          ) {
            $(this).wrap('<div class="iframe-embed"/>');

            $(this)
              .attr("data-aspectRatio", this.height / this.width)
              .removeAttr("height")
              .removeAttr("width");

            //add wmode=transparent to all youytube embeds to fix z-index issues in IE
            if ($(this).attr("src").indexOf("wmode=transparent") == -1) {
              if ($(this).attr("src").indexOf("?") == -1) {
                $(this).attr("src", $(this).attr("src") + "?wmode=transparent");
              } else {
                $(this).attr("src", $(this).attr("src") + "&wmode=transparent");
              }
            }
          }
        } else {
          //if($(this).parents('ins').length == 0){
          //	$(this).wrap('<div class="iframe-embed-standard"/>');
          //}
        }
      });
    }

    function responsiveVideoIframes() {
      $("iframe[data-aspectRatio]").each(function () {
        var newWidth = $(this).parent().width();

        var $el = $(this);

        //in nectar slider
        if ($(this).parents(".swiper-slide").length > 0) {
          if ($(this).is(":visible"))
            $el.width(newWidth).height(newWidth * $el.attr("data-aspectRatio"));
        }
        //all others
        else {
          $el.width(newWidth).height(newWidth * $el.attr("data-aspectRatio"));
        }
      });
    }

    function videoshortcodeSize() {
      $(".wp-video").each(function () {
        $(this).attr(
          "data-aspectRatio",
          parseInt($(this).find(".mejs-overlay").height()) /
            parseInt($(this).find(".wp-video-shortcode").css("width"))
        );

        var newWidth = $(this).width();

        var $el = $(this).find(".wp-video-shortcode");
        $(this)
          .width(newWidth)
          .height(newWidth * $(this).attr("data-aspectRatio"));
      });
    }

    responsiveVideoIframesInit();
    responsiveVideoIframes();
    videoshortcodeSize();

    //unwrap post and protfolio videos
    $(".video-wrap iframe").unwrap();
    $("#sidebar iframe[src]").unwrap();

    $("video:not(.slider-video)").attr("width", "100%");
    $("video:not(.slider-video)").attr("height", "100%");

    $("audio").attr("width", "100%");
    $("audio").attr("height", "100%");

    $("audio").css("visibility", "visible");

    if ($("body").hasClass("mobile")) {
      $("video").css("visibility", "hidden");
    } else {
      $("video").css("visibility", "visible");
    }

    $(window).load(function () {
      $("video").css("visibility", "visible");
      showLateIframes();
      videoshortcodeSize();
    });

    $(".wp-video").each(function () {
      video = $(this).find("video").get(0);
      video.addEventListener(
        "loadeddata",
        function () {
          videoshortcodeSize();
          $(window).trigger("resize");
        },
        false
      );
    });

    //webkit video back button fix
    $(".main-content iframe[src]").each(function () {
      $(this).attr("src", $(this).attr("src"));
      $(this).css({ opacity: "1", visibility: "visible" });
    });

    showLateIframes();

    function showLateIframes() {
      $("iframe[src]").css("opacity", "1");
      setTimeout(function () {
        $("iframe[src]").css("opacity", "1");
      }, 100);
      setTimeout(function () {
        $("iframe[src]").css("opacity", "1");
      }, 500);
      setTimeout(function () {
        $("iframe[src]").css("opacity", "1");
      }, 1000);
      setTimeout(function () {
        $("iframe[src]").css("opacity", "1");
      }, 1500);
      setTimeout(function () {
        $("iframe[src]").css("opacity", "1");
      }, 2500);
    }

    /***************** Nectar Video BG ******************/

    $('.wpb_row:has(".nectar-video-wrap"):not(.fp-section)').each(function (i) {
      $(this).css("z-index", 100 + i);
    });

    var min_w = 1200; // minimum video width allowed
    var vid_w_orig; // original video dimensions
    var vid_h_orig;

    vid_w_orig = 1280;
    vid_h_orig = 720;

    function resizeVideoToCover() {
      $(".nectar-video-wrap").each(function (i) {
        if ($(this).find("video").length == 0) return;

        if ($(this).parents("#page-header-bg").length > 0) {
          if ($(".container-wrap.auto-height").length > 0) return false;
          var $containerHeight = $(this)
            .parents("#page-header-bg")
            .outerHeight();
          var $containerWidth = $(this).parents("#page-header-bg").outerWidth();
        } else {
          var $containerHeight = $(this).parents(".wpb_row").outerHeight();
          var $containerWidth = $(this).parents(".wpb_row").outerWidth();
        }

        // set the video viewport to the window size
        $(this).width($containerWidth);
        $(this).height($containerHeight);

        // use largest scale factor of horizontal/vertical
        var scale_h = $containerWidth / vid_w_orig;
        var scale_v = ($containerHeight - $containerHeight) / vid_h_orig;
        var scale = scale_h > scale_v ? scale_h : scale_v;

        //update minium width to never allow excess space
        min_w = (1280 / 720) * ($containerHeight + 40);

        // don't allow scaled width < minimum video width
        if (scale * vid_w_orig < min_w) {
          scale = min_w / vid_w_orig;
        }

        // now scale the video
        $(this)
          .find("video, .mejs-overlay, .mejs-poster")
          .width(Math.ceil(scale * vid_w_orig + 0));
        $(this)
          .find("video, .mejs-overlay, .mejs-poster")
          .height(Math.ceil(scale * vid_h_orig + 0));

        // and center it by scrolling the video viewport
        $(this).scrollLeft(
          ($(this).find("video").width() - $containerWidth) / 2
        );
        $(this).scrollTop(
          ($(this).find("video").height() - $containerHeight) / 2
        );
        $(this)
          .find(".mejs-overlay, .mejs-poster")
          .scrollTop(($(this).find("video").height() - $containerHeight) / 2);

        //align bottom
        if (
          $(this).attr("data-bg-alignment") == "center bottom" ||
          $(this).attr("data-bg-alignment") == "bottom"
        ) {
          $(this).scrollTop(
            $(this).find("video").height() - ($containerHeight + 6)
          );
        }
        //align top
        else if (
          $(this).attr("data-bg-alignment") == "center top" ||
          $(this).attr("data-bg-alignment") == "top"
        ) {
          $(this).scrollTop(0);
        }
      });
    }

    //init
    function videoBGInit() {
      setTimeout(function () {
        resizeVideoToCover();
        $(".video-color-overlay").each(function () {
          $(this).css("background-color", $(this).attr("data-color"));
        });
        $(".nectar-video-wrap").each(function (i) {
          if ($(this).find("video").length == 0) return;

          var $headerVideo =
            $(this).parents("#page-header-bg").length > 0 ? true : false;
          var $that = $(this);

          var videoReady = setInterval(function () {
            if ($that.find("video").get(0).readyState > 3) {
              $that.transition({ opacity: "1" }, 400);
              $that.find("video").transition({ opacity: "1" }, 400);
              $that
                .parent()
                .find(".video-color-overlay")
                .transition({ opacity: "0.7" }, 400);

              if ($headerVideo == true) {
                pageHeaderTextEffect();
              }

              //remove page loading screen
              $("#ajax-loading-screen").addClass("loaded");
              setTimeout(function () {
                $("#ajax-loading-screen").addClass("hidden");
              }, 1000);

              clearInterval(videoReady);
            }
          }, 60);
        });
      }, 300);

      if (
        navigator.userAgent.match(
          /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
        )
      ) {
        $(
          ".wpb_row .mobile-video-image, #page-header-wrap .mobile-video-image, .fullscreen-header .mobile-video-image"
        ).show();
        $(".nectar-video-wrap").remove();
      }

      if (
        navigator.userAgent.indexOf("Chrome") > 0 &&
        !/Edge\/12./i.test(navigator.userAgent) &&
        !/Edge\/\d./i.test(navigator.userAgent)
      ) {
        $(".nectar-video-wrap").each(function (i) {
          if (jQuery(this).find('video source[type="video/webm"]').length > 0) {
            var webmSource =
              jQuery(this).find('video source[type="video/webm"]').attr("src") +
              "?id=" +
              Math.ceil(Math.random() * 10000);
            var firstVideo = jQuery(this).find("video").get(0);
            firstVideo.src = webmSource;
            firstVideo.load();
          }
        });
      }

      jQuery(".vc_row").each(function () {
        var youtubeUrl,
          youtubeId,
          $row = jQuery(this);
        $row.find(".nectar-youtube-bg").length > 0
          ? ((youtubeUrl = $row.find(".nectar-youtube-bg span").text()),
            (youtubeId = nectarExtractYoutubeId(youtubeUrl)),
            youtubeId &&
              ($row.find(".vc_video-bg").remove(),
              nectarInsertYoutubeVideoAsBackground(
                $row.find(".nectar-youtube-bg"),
                youtubeId
              )))
          : $row.find(".nectar-youtube-bg").remove();

        //remove yt url
        $row.find(".nectar-youtube-bg span").remove();
        $row
          .find(".nectar-video-wrap, .nectar-youtube-bg")
          .css({ opacity: "1", width: "100%", height: "100%" });
        $row.find(".video-color-overlay").transition({ opacity: "0.7" }, 400);
      });

      function nectarInsertYoutubeVideoAsBackground(
        $element,
        youtubeId,
        counter
      ) {
        if ("undefined" == typeof YT.Player)
          return (
            (counter = "undefined" == typeof counter ? 0 : counter),
            counter > 100
              ? void console.warn("Too many attempts to load YouTube api")
              : void setTimeout(function () {
                  nectarInsertYoutubeVideoAsBackground(
                    $element,
                    youtubeId,
                    counter++
                  );
                }, 100)
          );
        var $container = $element
          .prepend('<div class="vc_video-bg"><div class="inner"></div></div>')
          .find(".inner");
        new YT.Player($container[0], {
          width: "100%",
          height: "100%",
          videoId: youtubeId,
          playerVars: {
            playlist: youtubeId,
            iv_load_policy: 3,
            enablejsapi: 1,
            disablekb: 1,
            autoplay: 1,
            controls: 0,
            showinfo: 0,
            rel: 0,
            loop: 1,
          },
          events: {
            onReady: function (event) {
              event.target.mute().setLoop(!0);
            },
          },
        }),
          nectarResizeVideoBackground($element),
          jQuery(window).bind("resize", function () {
            nectarResizeVideoBackground($element);
          });
      }

      function nectarResizeVideoBackground($element) {
        var iframeW,
          iframeH,
          marginLeft,
          marginTop,
          containerW = $element.innerWidth(),
          containerH = $element.innerHeight(),
          ratio1 = 16,
          ratio2 = 9;
        ratio1 / ratio2 > containerW / containerH
          ? ((iframeW = containerH * (ratio1 / ratio2)),
            (iframeH = containerH),
            (marginLeft = -Math.round((iframeW - containerW) / 2) + "px"),
            (marginTop = -Math.round((iframeH - containerH) / 2) + "px"),
            (iframeW += "px"),
            (iframeH += "px"))
          : ((iframeW = containerW),
            (iframeH = containerW * (ratio2 / ratio1)),
            (marginTop = -Math.round((iframeH - containerH) / 2) + "px"),
            (marginLeft = -Math.round((iframeW - containerW) / 2) + "px"),
            (iframeW += "px"),
            (iframeH += "px")),
          $element.find(".vc_video-bg iframe").css({
            maxWidth: "1000%",
            marginLeft: marginLeft,
            marginTop: marginTop,
            width: iframeW,
            height: iframeH,
          });
      }

      function nectarExtractYoutubeId(url) {
        if ("undefined" == typeof url) return !1;
        var id = url.match(
          /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/
        );
        return null !== id ? id[1] : !1;
      }
    }

    if (
      $(".nectar-video-wrap").length > 0 ||
      $(".nectar-youtube-bg").length > 0
    ) {
      videoBGInit();
    }

    /*-------------------------------------------------------------------------*/
    /*	4.	Header + Search
/*-------------------------------------------------------------------------*/

    ////mobile megamenus without titles / nested groupings
    $mobileNavSelector =
      $(".off-canvas-menu-container.mobile-only").length > 0
        ? ".off-canvas-menu-container.mobile-only "
        : "#mobile-menu .container ";
    $($mobileNavSelector + ".megamenu > ul > li > a").each(function () {
      if ($(this).text() == "–") {
        $navLIs = $(this).parent().find("> ul > li").clone();
        $(this).parent().find("ul").remove();
        $(this).parent().parent().append($navLIs);
        $(this).parent().remove();
      }
    });

    /***************** Slide Out Widget Area **********/

    var $bodyBorderHeaderColorMatch =
      ($(".body-border-top").css("background-color") == "#ffffff" &&
        $("body").attr("data-header-color") == "light") ||
      $(".body-border-top").css("background-color") ==
        $("#header-outer").attr("data-user-set-bg")
        ? true
        : false;
    var $bodyBorderWidth =
      $(".body-border-right").length > 0 ? $(".body-border-right").width() : 0;
    var $resetHeader;

    function mobileBreakPointCheck() {
      var $mobileBreakpoint =
        $("body[data-header-breakpoint]").length > 0 &&
        $("body").attr("data-header-breakpoint") != "1000"
          ? parseInt($("body").attr("data-header-breakpoint"))
          : 1000;
      var $withinCustomBreakpoint = false;

      if ($mobileBreakpoint != 1000) {
        if (
          $(
            'body[data-user-set-ocm="1"][data-slide-out-widget-area-style="slide-out-from-right-hover"]'
          ).length == 0 &&
          window.innerWidth > 1000 &&
          window.innerWidth <= $mobileBreakpoint
        ) {
          $withinCustomBreakpoint = true;
        }
      }

      return $withinCustomBreakpoint;
    }

    //icon effect html creation
    if ($("#slide-out-widget-area.slide-out-from-right-hover").length > 0) {
      if ($("#ajax-content-wrap > .slide-out-widget-area-toggle").length == 0) {
        $(
          '<div class="slide-out-widget-area-toggle slide-out-hover-icon-effect" data-icon-animation="simple-transform"><div> <a href="#sidewidgetarea" class="closed"> <span> <i class="lines-button x2"> <i class="lines"></i> </i> </span> </a> </div> </div>'
        ).insertAfter("#slide-out-widget-area");
        if (
          $('#header-outer[data-has-menu="true"]').length > 0 ||
          $('body[data-header-search="true"]').length > 0
        )
          $("#ajax-content-wrap > .slide-out-widget-area-toggle").addClass(
            "small"
          );
      }

      function calculateHoverNavMinHeight() {
        $widgetHeights = 0;
        $("#slide-out-widget-area > .widget").each(function () {
          $widgetHeights += $(this).height();
        });
        $menuHeight =
          $("#slide-out-widget-area").height() -
            25 -
            $(".bottom-meta-wrap").outerHeight(true) -
            $widgetHeights >
          $(
            "#slide-out-widget-area .off-canvas-menu-container:last-child"
          ).height()
            ? $("#slide-out-widget-area").height() -
              25 -
              $(".bottom-meta-wrap").outerHeight(true) -
              $widgetHeights
            : $(
                "#slide-out-widget-area .off-canvas-menu-container:last-child"
              ).height();

        $("#slide-out-widget-area .inner").css({
          height: "auto",
          "min-height": $menuHeight,
        });

        $(
          "#slide-out-widget-area.slide-out-from-right-hover > .inner .off-canvas-menu-container"
        ).transition(
          {
            y:
              "-" +
              $(
                "#slide-out-widget-area.slide-out-from-right-hover > .inner .off-canvas-menu-container:last-child"
              ).height() /
                2 +
              "px",
          },
          0
        );
      }

      function openRightHoverNav() {
        calculateHoverNavMinHeight();

        if (
          navigator.userAgent.match(
            /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
          ) &&
          $("#slide-out-widget-area.open").length > 0
        ) {
          mobileCloseNavCheck();
          return;
        }

        $("#slide-out-widget-area")
          .css({ transform: "translate3d(0,0,0)" })
          .addClass("open");

        var $bodyBorderHeaderColorMatch =
          ($(".body-border-top").length > 0 &&
            $(".body-border-top").css("background-color") == "#ffffff" &&
            $("body").attr("data-header-color") == "light") ||
          ($(".body-border-top").length > 0 &&
            $(".body-border-top").css("background-color") ==
              $("#header-outer").attr("data-user-set-bg"))
            ? true
            : false;

        //icon effect
        ////set pos
        if (
          $("header#top .container .span_9 > .slide-out-widget-area-toggle")
            .length > 0
        ) {
          var adminBarHeight =
            $("#wpadminbar").length > 0 ? $("#wpadminbar").height() : 0; //admin bar

          var secondaryBarHeight =
            $("#header-secondary-outer").length > 0
              ? $("#header-secondary-outer").height()
              : 0;

          if ($("body.mobile").length > 0) {
            $(".slide-out-hover-icon-effect").css({
              top:
                $(
                  "header#top .span_9 > .slide-out-widget-area-toggle a"
                ).offset().top - $(window).scrollTop(),
              right:
                parseInt(
                  $("#header-outer header > .container").css("padding-right")
                ) + 1,
            });
          } else {
            if ($bodyBorderHeaderColorMatch) {
              var $extraCushion =
                $('#header-outer[data-has-menu="false"]').length > 0 ? 2 : 1;
              $(".slide-out-hover-icon-effect").css({
                top:
                  adminBarHeight +
                  secondaryBarHeight +
                  parseInt(
                    $("header#top nav >ul .slide-out-widget-area-toggle a").css(
                      "padding-top"
                    )
                  ),
                right: 29 + $extraCushion,
              });
            } else {
              var $withinCustomBreakpoint = mobileBreakPointCheck();

              if (
                $("body.ascend").length > 0 &&
                $withinCustomBreakpoint != true
              ) {
                var $extraCushion =
                  $('#header-outer[data-has-menu="false"]').length > 0 ? 2 : 1;
                $(".slide-out-hover-icon-effect").css({
                  top:
                    adminBarHeight +
                    secondaryBarHeight +
                    parseInt(
                      $(
                        "header#top nav >ul .slide-out-widget-area-toggle a"
                      ).css("padding-top")
                    ),
                  right:
                    parseInt(
                      $("#header-outer header >.container").css("padding-right")
                    ) + $extraCushion,
                });
              } else {
                $menuToggleSelector =
                  $("header#top nav > ul .slide-out-widget-area-toggle")
                    .length > 0 &&
                  $("header#top nav > ul .slide-out-widget-area-toggle").css(
                    "display"
                  ) != "none"
                    ? $("header#top nav > ul .slide-out-widget-area-toggle")
                    : $(
                        "body header#top .span_9 >.slide-out-widget-area-toggle"
                      );
                $(".slide-out-hover-icon-effect").css({
                  top:
                    adminBarHeight +
                    secondaryBarHeight +
                    parseInt($menuToggleSelector.css("padding-top")) +
                    parseInt($("#header-outer").css("padding-top")),
                  right:
                    parseInt(
                      $("#header-outer header >.container").css("padding-right")
                    ) +
                    1 +
                    parseInt($menuToggleSelector.css("margin-right")),
                });
              }
            }
          }
        }

        ////open

        $(".slide-out-hover-icon-effect .lines-button")
          .removeClass("no-delay")
          .addClass("unhidden-line");

        if (
          $('#header-outer[data-permanent-transparent="1"]').length == 0 &&
          $("#nectar_fullscreen_rows").length == 0
        ) {
          if (
            !(
              $(window).scrollTop() == 0 &&
              $("#header-outer.transparent").length > 0
            )
          ) {
            if ($("body.mobile").length == 0 && $bodyBorderHeaderColorMatch) {
              $("#header-outer")
                .attr("data-transparent", "true")
                .addClass("no-bg-color")
                .addClass("slide-out-hover");
              $("#header-outer header, #header-outer > .cart-outer").addClass(
                "all-hidden"
              );
            }
          }

          if (
            $('#header-outer[data-remove-fixed="1"]').length == 0 &&
            $("body.mobile").length == 0 &&
            $bodyBorderHeaderColorMatch
          ) {
            var headerResize = $("#header-outer").attr("data-header-resize");
            if (headerResize == 1) {
              $(window).off("scroll", bigNav);
              $(window).off("scroll", smallNav);
            } else {
              $(window).off("scroll", opaqueCheck);
              $(window).off("scroll", transparentCheck);
            }
          }
        }

        if (
          !navigator.userAgent.match(
            /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
          )
        ) {
          $(window).on("mousemove.rightOffsetCheck", closeNavCheck);
        }
      }

      function closeNavCheck(e) {
        var $windowWidth = $(window).width();
        if (e.clientX < $windowWidth - 340 - $bodyBorderWidth) {
          $(window).off("mousemove.rightOffsetCheck", closeNavCheck);

          $("#slide-out-widget-area")
            .css({ transform: "translate3d(341px,0,0)" })
            .removeClass("open");

          $("#header-outer").removeClass("style-slide-out-from-right");

          $(".slide-out-hover-icon-effect .lines-button")
            .removeClass("unhidden-line")
            .addClass("no-delay");

          var $bodyBorderHeaderColorMatch =
            ($(".body-border-top").length > 0 &&
              $(".body-border-top").css("background-color") == "#ffffff" &&
              $("body").attr("data-header-color") == "light") ||
            ($(".body-border-top").length > 0 &&
              $(".body-border-top").css("background-color") ==
                $("#header-outer").attr("data-user-set-bg"))
              ? true
              : false;

          if ($('#header-outer[data-permanent-transparent="1"]').length == 0) {
            if (
              $('#header-outer[data-remove-fixed="1"]').length == 0 &&
              $("body.mobile").length == 0 &&
              $bodyBorderHeaderColorMatch
            ) {
              if ($("body.mobile").length == 0) {
                $("#header-outer").removeClass("no-bg-color");
                $(
                  "#header-outer header, #header-outer > .cart-outer"
                ).removeClass("all-hidden");
              }
            }

            if (
              $('#header-outer[data-remove-fixed="1"]').length == 0 &&
              $("body.mobile").length == 0 &&
              $bodyBorderHeaderColorMatch
            ) {
              var headerResize = $("#header-outer").attr("data-header-resize");
              if (headerResize == 1) {
                $(window).off("scroll.headerResizeEffect");
                if ($(window).scrollTop() == 0) {
                  $(window).on("scroll.headerResizeEffect", smallNav);

                  if (
                    $(
                      '#header-outer[data-full-width="true"][data-transparent-header="true"]'
                    ).length > 0 &&
                    $(".body-border-top").length > 0 &&
                    $bodyBorderHeaderColorMatch == true &&
                    $("#header-outer.pseudo-data-transparent").length > 0
                  ) {
                    $(
                      '#header-outer[data-full-width="true"] header > .container'
                    )
                      .stop(true, true)
                      .animate(
                        {
                          padding: "0",
                        },
                        { queue: false, duration: 250, easing: "easeOutCubic" }
                      );
                  }
                } else {
                  $(window).on("scroll.headerResizeEffect", bigNav);
                }
              } else {
                $(window).off("scroll.headerResizeEffectOpaque");
                $(window).on("scroll.headerResizeEffectOpaque", opaqueCheck);
              }
            }
          }
        }
      }

      function mobileCloseNavCheck(e) {
        $("#slide-out-widget-area")
          .css({ transform: "translate3d(341px,0,0)" })
          .removeClass("open");

        $("#header-outer").removeClass("style-slide-out-from-right");

        $(".slide-out-hover-icon-effect .lines-button")
          .removeClass("unhidden-line")
          .addClass("no-delay");

        if ($('#header-outer[data-permanent-transparent="1"]').length == 0) {
          $("#header-outer").removeClass("no-bg-color");
          $("#header-outer header").removeClass("all-hidden");
        }

        var $bodyBorderHeaderColorMatch =
          ($(".body-border-top").length > 0 &&
            $(".body-border-top").css("background-color") == "#ffffff" &&
            $("body").attr("data-header-color") == "light") ||
          ($(".body-border-top").length > 0 &&
            $(".body-border-top").css("background-color") ==
              $("#header-outer").attr("data-user-set-bg"))
            ? true
            : false;

        if (
          $('#header-outer[data-remove-fixed="1"]').length == 0 &&
          $("body.mobile").length == 0 &&
          $bodyBorderHeaderColorMatch
        ) {
          var headerResize = $("#header-outer").attr("data-header-resize");
          if (headerResize == 1) {
            $(window).off("scroll.headerResizeEffect");
            if ($(window).scrollTop() == 0) {
              $(window).on("scroll.headerResizeEffect", smallNav);

              if (
                $(
                  '#header-outer[data-full-width="true"][data-transparent-header="true"]'
                ).length > 0 &&
                $(".body-border-top").length > 0 &&
                $bodyBorderHeaderColorMatch == true &&
                $("#header-outer.pseudo-data-transparent").length > 0
              ) {
                $('#header-outer[data-full-width="true"] header > .container')
                  .stop(true, true)
                  .animate(
                    {
                      padding: "0",
                    },
                    { queue: false, duration: 250, easing: "easeOutCubic" }
                  );
              }
            } else {
              $(window).on("scroll.headerResizeEffect", bigNav);
            }
          } else {
            $(window).off("scroll.headerResizeEffectOpaque");
            $(window).on("scroll.headerResizeEffectOpaque", opaqueCheck);
          }
        }
      }

      //hover triggered
      if (
        !navigator.userAgent.match(
          /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
        )
      )
        $("body").on(
          "mouseenter",
          "#header-outer .slide-out-widget-area-toggle:not(.std-menu) a",
          openRightHoverNav
        );
      else
        $("body").on(
          "click",
          ".slide-out-widget-area-toggle:not(.std-menu) a",
          openRightHoverNav
        );

      $(window).on("smartresize", calculateHoverNavMinHeight);
    }

    //click triggered
    $("body").on(
      "click",
      ".slide-out-widget-area-toggle:not(.std-menu) a.closed:not(.animating)",
      function () {
        if (animating == "true" || $(".slide-out-from-right-hover").length > 0)
          return false;
        var $that = $(this);

        $("#header-outer").removeClass("no-transition");

        //slide out from right
        if ($("#slide-out-widget-area").hasClass("slide-out-from-right")) {
          $slideOutAmount =
            $(".body-border-top").length > 0 && $("body.mobile").length == 0
              ? $(".body-border-top").height()
              : 0;

          //calc height if used bottom meta
          $("#slide-out-widget-area .inner").css({
            height: "auto",
            "min-height":
              $("#slide-out-widget-area").height() -
              25 -
              $(".bottom-meta-wrap").height(),
          });

          if ($("#boxed").length == 0) {
            $(
              ".container-wrap, .home-wrap, #header-secondary-outer, #footer-outer:not(#nectar_fullscreen_rows #footer-outer), .nectar-box-roll, .parallax_slider_outer .swiper-slide .image-bg, .parallax_slider_outer .swiper-slide .video-wrap, .parallax_slider_outer .swiper-slide .mobile-video-image, .parallax_slider_outer .swiper-slide .container, #page-header-wrap .page-header-bg-image,  #page-header-wrap .nectar-video-wrap, #page-header-wrap .mobile-video-image, #page-header-wrap #page-header-bg > .container, .page-header-no-bg, div:not(.container) > .project-title"
            )
              .stop(true)
              .transition({ x: "-300px" }, 700, "easeInOutCubic");

            var $withinCustomBreakpoint = mobileBreakPointCheck();

            if (
              $('#header-outer[data-format="centered-logo-between-menu"]')
                .length == 0 ||
              $withinCustomBreakpoint
            ) {
              if (
                $('#header-outer[data-transparency-option="1"]').length == 0 ||
                ($('#header-outer[data-transparency-option="1"]').length > 0 &&
                  $('#header-outer[data-full-width="true"]').length == 0) ||
                $("body.mobile").length > 0
              ) {
                $("#header-outer")
                  .stop(true)
                  .css("transform", "translateY(0)")
                  .transition(
                    { x: "-" + (300 + $slideOutAmount) + "px" },
                    700,
                    "easeInOutCubic"
                  );
              } else {
                $("#header-outer")
                  .stop(true)
                  .css("transform", "translateY(0)")
                  .transition(
                    {
                      x: "-" + (300 + $slideOutAmount) + "px",
                      "background-color": "transparent",
                      "border-bottom": "1px solid rgba(255,255,255,0.22)",
                    },
                    700,
                    "easeInOutCubic"
                  );
              }
            } else {
              $(
                "#header-outer header#top nav > ul.buttons, #header-outer .cart-outer .cart-menu-wrap"
              ).transition({ x: "-300px" }, 700, "easeInOutCubic");
            }

            $("#ascrail2000").transition(
              { x: "-" + (300 + $slideOutAmount) + "px" },
              700,
              "easeInOutCubic"
            );
            $("body:not(.ascend) #header-outer .cart-menu")
              .stop(true)
              .transition({ x: "300px" }, 700, "easeInOutCubic");
          }

          $("#slide-out-widget-area")
            .stop(true)
            .transition(
              { x: "-" + $slideOutAmount + "px" },
              700,
              "easeInOutCubic"
            )
            .addClass("open");

          if ($("#boxed").length == 0) {
            //full width menu adjustments
            if (
              $('#header-outer[data-full-width="true"]').length > 0 &&
              !$("body").hasClass("mobile")
            ) {
              $("#header-outer").addClass("highzI");
              $("#ascrail2000").addClass("z-index-adj");

              if (
                $('#header-outer[data-format="centered-logo-between-menu"]')
                  .length == 0
              ) {
                if ($bodyBorderWidth == 0)
                  $("header#top #logo")
                    .stop(true)
                    .transition(
                      { x: 300 + $slideOutAmount + "px" },
                      700,
                      "easeInOutCubic"
                    );

                //$('header#top nav > ul > li.megamenu > ul.sub-menu').stop(true).transition({'width': $(window).width() - 360, 'left': '300px' },700,'easeInOutCubic');
              }

              $(
                "header#top .slide-out-widget-area-toggle .lines-button"
              ).addClass("close");

              if ($('#header-outer[data-remove-border="true"]').length > 0) {
                $(
                  'body:not(.ascend) #header-outer[data-full-width="true"] header#top nav > ul.product_added'
                )
                  .stop(true)
                  .transition({ x: "64px" }, 700, "easeInOutCubic");
              } else {
                $(
                  'body:not(.ascend) #header-outer[data-full-width="true"] header#top nav > ul.product_added'
                )
                  .stop(true)
                  .transition({ x: "89px" }, 700, "easeInOutCubic");
              }

              $("body #header-outer nav > ul > li > a").css({
                "margin-bottom": "0",
              });
            }
          }

          $("#header-outer").addClass("style-slide-out-from-right");

          //fade In BG Overlay
          $("#slide-out-widget-area-bg")
            .css({ height: "100%", width: "100%" })
            .stop(true)
            .transition(
              {
                opacity: 1,
              },
              700,
              "easeInOutCubic",
              function () {
                $(
                  ".slide-out-widget-area-toggle:not(.std-menu) > div > a"
                ).removeClass("animating");
              }
            );

          //hide menu if no space
          if (
            $('#header-outer[data-format="centered-logo-between-menu"]')
              .length == 0
          ) {
            $logoWidth =
              $("#logo img:visible").length > 0
                ? $("#logo img:visible").width()
                : $("#logo").width();
            if (
              $("header#top nav > .sf-menu").offset().left - $logoWidth - 300 <
              20
            )
              $("#header-outer").addClass("hidden-menu");
          } else {
            $("#header-outer").addClass("hidden-menu-items");
          }

          var headerResize = $("#header-outer").attr("data-header-resize");

          if ($('#header-outer[data-remove-fixed="1"]').length == 0) {
            if ($bodyBorderHeaderColorMatch == true && headerResize == 1) {
              $("#header-outer")
                .stop(true)
                .transition({ y: "0" }, 0)
                .addClass("transparent")
                .css("transition", "transform");
              if (
                $("#header-outer").attr("data-transparent-header") != "true"
              ) {
                $("#header-outer")
                  .attr("data-transparent-header", "true")
                  .addClass("pseudo-data-transparent");
              }

              $(window).off("scroll", bigNav);
              //if($('.small-nav').length > 0 || $('#header-outer').hasClass('pseudo-data-transparent')) bigNav();
              $(window).off("scroll", smallNav);
            } else if ($bodyBorderHeaderColorMatch == true) {
              $("#header-outer").addClass("transparent");
              $(window).off("scroll", opaqueCheck);
              $(window).off("scroll", transparentCheck);

              if (
                $("#header-outer").attr("data-transparent-header") != "true"
              ) {
                $("#header-outer")
                  .attr("data-transparent-header", "true")
                  .addClass("pseudo-data-transparent");
              }
            }
          }
        } else if ($("#slide-out-widget-area").hasClass("fullscreen")) {
          //scroll away from fixed reveal footer if shown (firefox bug with bluring over it)
          var $scrollDelay = 0;
          var $scrollDelay2 = 0;

          if (
            $(window).scrollTop() + $(window).height() >
              $(".blurred-wrap").height() &&
            $("#nectar_fullscreen_rows").length == 0
          ) {
            $("body,html")
              .stop()
              .animate(
                {
                  scrollTop: $(".blurred-wrap").height() - $(window).height(),
                },
                600,
                "easeInOutCubic"
              );
            $scrollDelay = 550;
            $scrollDelay2 = 200;
          }

          $(
            "header#top .slide-out-widget-area-toggle:not(.std-menu) .lines-button"
          ).addClass("close");
          setTimeout(function () {
            $(".blurred-wrap").addClass("blurred");
          }, $scrollDelay);
          $("#slide-out-widget-area.fullscreen").show().addClass("open");

          if ($(".nectar-social-sharing-fixed").length == 0) {
            hideToTop();
          }

          //remove box shadow incase at the top of the page with nectar box roll above
          $(".container-wrap").addClass("no-shadow");
          $("#header-outer").stop(true).css("transform", "translateY(0)");

          setTimeout(function () {
            $(".off-canvas-menu-container .menu > li").each(function (i) {
              $(this)
                .delay(i * 50)
                .transition({ y: 0, opacity: 1 }, 800, "easeOutExpo");
            });

            $("#slide-out-widget-area.fullscreen .widget").each(function (i) {
              $(this)
                .delay(i * 100)
                .transition({ y: 0, opacity: 1 }, 800, "easeOutExpo");
            });
          }, 370 + $scrollDelay2);

          setTimeout(function () {
            $("#slide-out-widget-area .off-canvas-social-links").addClass(
              "line-shown"
            );

            $("#slide-out-widget-area .off-canvas-social-links li").each(
              function (i) {
                $(this)
                  .delay(i * 50)
                  .transition({ scale: 1 }, 400, "easeOutCubic");
              }
            );
            $("#slide-out-widget-area .bottom-text").transition(
              { opacity: 0.7 },
              400,
              "easeOutCubic"
            );
          }, 750 + $scrollDelay2);

          //fade In BG Overlay
          setTimeout(function () {
            $easing =
              $("body.mobile").length > 0 ? "easeOutCubic" : "easeInOutQuint";
            $("#slide-out-widget-area-bg")
              .css({ height: "100%", width: "100%" })
              .show()
              .stop(true)
              .transition(
                {
                  y: "0%",
                },
                920,
                $easing,
                function () {
                  $(".slide-out-widget-area-toggle > div > a").removeClass(
                    "animating"
                  );
                }
              );
          }, 50 + $scrollDelay2);

          //overflow state
          slideOutWidgetOverflowState();
          if (
            $('.mobile #header-outer[data-permanent-transparent="false"]')
              .length > 0 &&
            $(".container-wrap").hasClass("no-scroll")
          )
            $("#ajax-content-wrap").addClass("at-content");
          if (
            $('.mobile #header-outer[data-permanent-transparent="false"]')
              .length > 0 ||
            ($(".mobile").length == 0 &&
              $("#header-outer.transparent").length == 0)
          )
            $("#slide-out-widget-area.fullscreen .inner-wrap").css(
              "padding-top",
              $("#header-outer").height()
            );
        } else if ($("#slide-out-widget-area").hasClass("fullscreen-alt")) {
          $(
            "header#top .slide-out-widget-area-toggle:not(.std-menu) .lines-button"
          ).addClass("close");
          $("#slide-out-widget-area.fullscreen-alt").show().addClass("open");
          $("#slide-out-widget-area-bg").addClass("open");

          $('body > div[class*="body-border"]').css("z-index", "9995");

          $(".off-canvas-menu-container .menu").transition(
            { y: "0px", opacity: 1 },
            0
          );

          if ($(".nectar-social-sharing-fixed").length == 0) {
            hideToTop();
          }

          //if($('#header-outer-bg-only').length == 0 ) {
          //$('body').prepend($('<div id="header-outer-bg-only"/>'));
          //$('#header-outer-bg-only').css({'height':$('#header-outer').outerHeight(true), 'background-color': $('#header-outer').css('background-color')});
          //}

          if ($("#header-outer.transparent").length == 0) {
            //$('#header-outer-bg-only').show();
            //$('#header-outer-bg-only').css({'height':$('#header-outer').outerHeight(true), 'background-color': $('#header-outer').css('background-color')});
            //if($('.body-border-top').length > 0) {
            //$('.admin-bar #slide-out-widget-area-bg.fullscreen-alt').addClass('no-transition').css({'padding-top': ($('#header-outer').outerHeight(true)+32) + 'px'});
            //$('body:not(.admin-bar) #slide-out-widget-area-bg.fullscreen-alt').addClass('no-transition').css({'padding-top': ($('#header-outer').outerHeight(true))+ 'px'});
            //}
          } else {
            //$('#header-outer-bg-only').hide();
            if ($(".body-border-top").length > 0) {
              $(".admin-bar #slide-out-widget-area-bg.fullscreen-alt").css({
                "padding-top":
                  $(".body-border-top").outerHeight(true) + 32 + "px",
              });
              $(
                "body:not(.admin-bar) #slide-out-widget-area-bg.fullscreen-alt"
              ).css({
                "padding-top": $(".body-border-top").outerHeight(true) + "px",
              });
            }
          }

          if (
            $("#logo .starting-logo").length > 0 &&
            $(window).width() > 1000
          ) {
            //$('#header-outer').addClass('no-transition').addClass('no-bg-color');

            $("#header-outer")
              .stop(true)
              .css("transform", "translateY(0)")
              .addClass("transparent");
            if ($("#header-outer").attr("data-transparent-header") != "true") {
              $("#header-outer")
                .attr("data-transparent-header", "true")
                .addClass("pseudo-data-transparent");
            }
          }

          $(".off-canvas-menu-container .clip-wrap").css(
            "transition-duration",
            "0s"
          );

          setTimeout(function () {
            $(".off-canvas-menu-container .menu > li").each(function (i) {
              $(this)
                .delay(i * 50)
                .transition({ y: 0, opacity: 1 }, 750, "easeOutCubic")
                .addClass("no-pointer-events");
            });

            setTimeout(function () {
              $(".off-canvas-menu-container .menu > li").removeClass(
                "no-pointer-events"
              );
              $(".off-canvas-menu-container .clip-wrap").css(
                "transition-duration",
                ".45s"
              );
            }, 500);

            $("#slide-out-widget-area.fullscreen-alt .widget").each(function (
              i
            ) {
              $(this)
                .delay(i * 100)
                .transition({ y: 0, opacity: 1 }, 650, "easeOutCubic");
            });
          }, 200);

          setTimeout(function () {
            $("#slide-out-widget-area .off-canvas-social-links").addClass(
              "line-shown"
            );

            $("#slide-out-widget-area .off-canvas-social-links li")
              .css("opacity", "1")
              .each(function (i) {
                $(this)
                  .delay(i * 50)
                  .transition({ scale: 1 }, 400, "easeOutCubic");
              });
            $("#slide-out-widget-area .bottom-text").transition(
              { opacity: 1 },
              600,
              "easeOutCubic"
            );
          }, 200);

          //fade In BG Overlay
          if ($("#slide-out-widget-area-bg").hasClass("solid")) $opacity = 1;
          if ($("#slide-out-widget-area-bg").hasClass("dark")) $opacity = 0.97;
          if ($("#slide-out-widget-area-bg").hasClass("medium")) $opacity = 0.6;
          if ($("#slide-out-widget-area-bg").hasClass("light")) $opacity = 0.4;
          $("#slide-out-widget-area-bg").removeClass("no-transition");

          $("#slide-out-widget-area-bg")
            .addClass("padding-removed")
            .css({
              height: "100%",
              width: "100%",
              left: "0",
              opacity: $opacity,
            });

          setTimeout(function () {
            $(".slide-out-widget-area-toggle > div > a").removeClass(
              "animating"
            );
          }, 600);

          //overflow state
          slideOutWidgetOverflowState();
          if (
            $('.mobile #header-outer[data-permanent-transparent="false"]')
              .length > 0 &&
            $(".container-wrap").hasClass("no-scroll")
          )
            $("#ajax-content-wrap").addClass("at-content");
          if (
            $('.mobile #header-outer[data-permanent-transparent="false"]')
              .length > 0 ||
            ($(".mobile").length == 0 &&
              $("#header-outer.transparent").length == 0)
          )
            $("#slide-out-widget-area.fullscreen-alt .inner-wrap").css(
              "padding-top",
              $("#header-outer").height()
            );
        }

        //add open class
        $("#header-outer")
          .removeClass("side-widget-closed")
          .addClass("side-widget-open");

        //give header transparent state
        if (
          $('#header-outer[data-transparency-option="1"]').length > 0 &&
          $("#boxed").length == 0 &&
          $('#header-outer[data-full-width="true"]').length > 0
        ) {
          $("#header-outer").addClass("transparent");
        }

        //dark slide transparent nav
        if (
          $("#header-outer.dark-slide.transparent").length > 0 &&
          $("#boxed").length == 0
        )
          $("#header-outer")
            .removeClass("dark-slide")
            .addClass("temp-removed-dark-slide");

        $(".slide-out-widget-area-toggle > div > a")
          .removeClass("closed")
          .addClass("open");
        $(".slide-out-widget-area-toggle > div > a").addClass("animating");

        return false;
      }
    );

    $("body").on(
      "click",
      ".slide-out-widget-area-toggle:not(.std-menu) a.open:not(.animating), #slide-out-widget-area .slide_out_area_close, #slide-out-widget-area-bg.slide-out-from-right",
      function () {
        if (
          $(".slide-out-widget-area-toggle:not(.std-menu) a.animating").length >
          0
        )
          return;

        $("#header-outer").removeClass("no-transition");

        var $that = $(this);

        $(".slide-out-widget-area-toggle:not(.std-menu) a")
          .removeClass("open")
          .addClass("closed");
        $(".slide-out-widget-area-toggle:not(.std-menu) a").addClass(
          "animating"
        );

        //slide out from right
        if ($("#slide-out-widget-area").hasClass("slide-out-from-right")) {
          $(
            ".container-wrap, .home-wrap, #header-secondary-outer, #footer-outer:not(#nectar_fullscreen_rows #footer-outer), .nectar-box-roll, .parallax_slider_outer .swiper-slide .image-bg, .parallax_slider_outer .swiper-slide .container, .parallax_slider_outer .swiper-slide .video-wrap, .parallax_slider_outer .swiper-slide .mobile-video-image, #page-header-wrap .page-header-bg-image,  #page-header-wrap .nectar-video-wrap, #page-header-wrap .mobile-video-image, #page-header-wrap #page-header-bg > .container, .page-header-no-bg, div:not(.container) > .project-title"
          )
            .stop(true)
            .transition({ x: "0px" }, 700, "easeInOutCubic");

          if (
            $('#header-outer[data-transparency-option="1"]').length > 0 &&
            $("#boxed").length == 0
          ) {
            $currentRowBG =
              $("#header-outer[data-current-row-bg-color]").length > 0
                ? $("#header-outer").attr("data-current-row-bg-color")
                : $("#header-outer").attr("data-user-set-bg");
            $("#header-outer")
              .stop(true)
              .transition(
                { x: "0px", "background-color": $currentRowBG },
                700,
                "easeInOutCubic"
              );
          } else {
            $("#header-outer")
              .stop(true)
              .transition({ x: "0px" }, 700, "easeInOutCubic");
          }

          $("#ascrail2000")
            .stop(true)
            .transition({ x: "0px" }, 700, "easeInOutCubic");
          $("body:not(.ascend) #header-outer .cart-menu")
            .stop(true)
            .transition({ x: "0px" }, 700, "easeInOutCubic");

          $("#slide-out-widget-area")
            .stop(true)
            .transition({ x: "301px" }, 700, "easeInOutCubic")
            .removeClass("open");

          if ($("#boxed").length == 0) {
            if ($('#header-outer[data-full-width="true"]').length > 0) {
              $("#header-outer").removeClass("highzI");
              $("header#top #logo")
                .stop(true)
                .transition({ x: "0px" }, 700, "easeInOutCubic");
              //$('header#top nav > ul > li.megamenu > ul.sub-menu').stop(true).transition({'width': '100%', 'left': '0' },700,'easeInOutCubic');
              $(".lines-button").removeClass("close");

              $(
                'body:not(.ascend) #header-outer[data-full-width="true"] header#top nav > ul.product_added'
              )
                .stop(true)
                .transition({ x: "0px" }, 700, "easeInOutCubic");
            }
          }

          if (
            $('#header-outer[data-format="centered-logo-between-menu"]')
              .length > 0
          ) {
            $(
              "#header-outer header#top nav > ul.buttons, #header-outer .cart-outer .cart-menu-wrap"
            )
              .stop(true)
              .transition({ x: "0px" }, 700, "easeInOutCubic");
          }

          //fade out overlay
          $("#slide-out-widget-area-bg")
            .stop(true)
            .transition(
              {
                opacity: 0,
              },
              700,
              "easeInOutCubic",
              function () {
                $(".slide-out-widget-area-toggle a").removeClass("animating");
                $(this).css({ height: "1px", width: "1px" });

                if ($('#header-outer[data-remove-fixed="1"]').length == 0) {
                  //hide menu if transparent, user has scrolled down and hhun is on
                  if (
                    $("#header-outer").hasClass("parallax-contained") &&
                    $(window).scrollTop() > 0 &&
                    $('#header-outer[data-permanent-transparent="1"]').length ==
                      0
                  ) {
                    $("#header-outer")
                      .removeClass("parallax-contained")
                      .addClass("detached")
                      .removeClass("transparent");
                  } else if (
                    ($(window).scrollTop() == 0 &&
                      $('body[data-hhun="1"]').length > 0 &&
                      $('#page-header-bg[data-parallax="1"]').length > 0) ||
                    ($(window).scrollTop() == 0 &&
                      $('body[data-hhun="1"]').length > 0 &&
                      $(".parallax_slider_outer").length > 0)
                  ) {
                    if (
                      $('#header-outer[data-transparency-option="1"]').length >
                      0
                    )
                      $("#header-outer").addClass("transparent");
                    $("#header-outer")
                      .addClass("parallax-contained")
                      .removeClass("detached");
                  }
                }

                //fix for fixed subpage menu
                $(".container-wrap").css("transform", "none");
              }
            );

          $("#header-outer").removeClass("style-slide-out-from-right");

          var headerResize = $("#header-outer").attr("data-header-resize");
          if ($('#header-outer[data-remove-fixed="1"]').length == 0) {
            if ($bodyBorderHeaderColorMatch == true && headerResize == 1) {
              $(window).off("scroll.headerResizeEffect");
              if ($(window).scrollTop() == 0) {
                $(window).on("scroll.headerResizeEffect", smallNav);

                if (
                  $(
                    '#header-outer[data-full-width="true"][data-transparent-header="true"]'
                  ).length > 0 &&
                  $(".body-border-top").length > 0 &&
                  $bodyBorderHeaderColorMatch == true &&
                  $("#header-outer.pseudo-data-transparent").length > 0
                ) {
                  $('#header-outer[data-full-width="true"] header > .container')
                    .stop(true, true)
                    .animate(
                      {
                        padding: "0",
                      },
                      { queue: false, duration: 250, easing: "easeOutCubic" }
                    );
                }
              } else $(window).on("scroll.headerResizeEffect", bigNav);
              //smallNav();

              if ($("#header-outer").hasClass("pseudo-data-transparent")) {
                $("#header-outer")
                  .attr("data-transparent-header", "false")
                  .removeClass("pseudo-data-transparent")
                  .removeClass("transparent");
              }

              $("#header-outer").css("transition", "transform");
            } else if ($bodyBorderHeaderColorMatch == true) {
              $(window).off("scroll.headerResizeEffectOpaque");
              $(window).on("scroll.headerResizeEffectOpaque", opaqueCheck);

              $("#header-outer").css("transition", "transform");

              if ($("#header-outer").hasClass("pseudo-data-transparent")) {
                $("#header-outer")
                  .attr("data-transparent-header", "false")
                  .removeClass("pseudo-data-transparent")
                  .removeClass("transparent");
              }
            }
          }
        } else if ($("#slide-out-widget-area").hasClass("fullscreen")) {
          $(
            ".slide-out-widget-area-toggle:not(.std-menu) .lines-button"
          ).removeClass("close");
          //$('.slide-out-widget-area-toggle a').removeClass('animating');
          $(".blurred-wrap").removeClass("blurred");
          $("#slide-out-widget-area.fullscreen")
            .transition({ opacity: 0 }, 700, "easeOutQuad", function () {
              $("#slide-out-widget-area.fullscreen").hide().css("opacity", "1");
            })
            .removeClass("open");
          $("#slide-out-widget-area.fullscreen .widget").transition(
            { opacity: 0 },
            700,
            "easeOutQuad",
            function () {
              $(this).transition({ y: "110px" }, 0);
            }
          );

          setTimeout(function () {
            $(".off-canvas-menu-container .menu > li").transition(
              { y: "80px", opacity: 0 },
              0
            );
            $("#slide-out-widget-area .off-canvas-social-links li").transition(
              { scale: 0 },
              0
            );
            $("#slide-out-widget-area .off-canvas-social-links").removeClass(
              "line-shown"
            );
            $("#slide-out-widget-area .bottom-text").transition(
              { opacity: 0 },
              0
            );

            //close submenu items
            $("#slide-out-widget-area .menuwrapper .menu").removeClass(
              "subview"
            );
            $("#slide-out-widget-area .menuwrapper .menu li").removeClass(
              "subview subviewopen"
            );
            $(
              "#slide-out-widget-area.fullscreen .inner .off-canvas-menu-container"
            ).css("height", "auto");
          }, 800);

          setTimeout(function () {
            if ($(".nectar-social-sharing-fixed").length == 0) {
              showToTop();
            }
            $(".container-wrap").removeClass("no-shadow");
          }, 500);

          //fade out overlay
          $("#slide-out-widget-area-bg")
            .stop(true)
            .transition({ opacity: 0 }, 900, "easeOutQuad", function () {
              if (
                $('.mobile #header-outer[data-permanent-transparent="false"]')
                  .length > 0 &&
                $(".container-wrap").hasClass("no-scroll")
              )
                $("#ajax-content-wrap").removeClass("at-content");
              if (
                $('.mobile #header-outer[data-permanent-transparent="false"]')
                  .length == 0
              )
                $("#slide-out-widget-area.fullscreen .inner-wrap").css(
                  "padding-top",
                  "0"
                );
              $(".slide-out-widget-area-toggle a").removeClass("animating");
              if ($("#slide-out-widget-area-bg").hasClass("solid"))
                $opacity = 1;
              if ($("#slide-out-widget-area-bg").hasClass("dark"))
                $opacity = 0.93;
              if ($("#slide-out-widget-area-bg").hasClass("medium"))
                $opacity = 0.6;
              if ($("#slide-out-widget-area-bg").hasClass("light"))
                $opacity = 0.4;
              $(this)
                .css({ height: "1px", width: "1px", opacity: $opacity })
                .transition({ y: "-100%" }, 0);
            });
        } else if ($("#slide-out-widget-area").hasClass("fullscreen-alt")) {
          $(
            ".slide-out-widget-area-toggle:not(.std-menu) .lines-button"
          ).removeClass("close");
          //$('.slide-out-widget-area-toggle a').removeClass('animating');
          $(".blurred-wrap").removeClass("blurred");
          $("#slide-out-widget-area-bg").removeClass("open");

          $("#slide-out-widget-area.fullscreen-alt .widget").transition(
            { opacity: 0 },
            500,
            "easeOutQuad",
            function () {
              $(this).transition({ y: "40px" }, 0);
            }
          );
          $(
            "#slide-out-widget-area .bottom-text, #slide-out-widget-area .off-canvas-social-links li"
          ).transition({ opacity: 0 }, 250, "easeOutQuad");
          $("#slide-out-widget-area .off-canvas-social-links").removeClass(
            "line-shown"
          );

          $(".off-canvas-menu-container .menu").transition(
            { y: "-13px", opacity: 0 },
            400
          );

          setTimeout(function () {
            $(".off-canvas-menu-container .menu > li")
              .stop(true, true)
              .transition({ y: "40px", opacity: 0 }, 0);
            $("#slide-out-widget-area .off-canvas-social-links li").transition(
              { scale: 0 },
              0
            );
            $("#slide-out-widget-area .off-canvas-social-links").removeClass(
              "line-shown"
            );

            //close submenu items
            $("#slide-out-widget-area .menuwrapper .menu").removeClass(
              "subview"
            );
            $("#slide-out-widget-area .menuwrapper .menu li").removeClass(
              "subview subviewopen"
            );
            $(
              "#slide-out-widget-area.fullscreen-alt .inner .off-canvas-menu-container"
            ).css("height", "auto");

            if (
              $('.mobile #header-outer[data-permanent-transparent="false"]')
                .length > 0 &&
              $(".container-wrap").hasClass("no-scroll")
            )
              $("#ajax-content-wrap").removeClass("at-content");
            if (
              $('.mobile #header-outer[data-permanent-transparent="false"]')
                .length == 0
            )
              $("#slide-out-widget-area.fullscreen-alt .inner-wrap").css(
                "padding-top",
                "0"
              );
            $(".slide-out-widget-area-toggle a").removeClass("animating");
            $("#slide-out-widget-area-bg").css({
              height: "1px",
              width: "1px",
              left: "-100%",
            });
            $("#slide-out-widget-area.fullscreen-alt")
              .hide()
              .removeClass("open");
          }, 550);

          setTimeout(function () {
            if ($(".nectar-social-sharing-fixed").length == 0) {
              showToTop();
            }
          }, 600);

          //fade out overlay
          setTimeout(function () {
            $("#slide-out-widget-area-bg").removeClass("padding-removed");
          }, 50);

          var borderDelay = $bodyBorderHeaderColorMatch == true ? 150 : 50;

          setTimeout(function () {
            $("#slide-out-widget-area-bg").stop(true).css({ opacity: 0 });
            if ($('[data-transparent-header="true"]').length > 0)
              $('body > div[class*="body-border"]').css("z-index", "10000");
          }, borderDelay);

          setTimeout(function () {
            $(
              "#header-outer.transparent.small-nav, #header-outer.transparent.detached, #header-outer.transparent.scrolled-down"
            ).removeClass("transparent");

            if ($("#header-outer").hasClass("pseudo-data-transparent")) {
              $("#header-outer")
                .attr("data-transparent-header", "false")
                .removeClass("pseudo-data-transparent")
                .removeClass("transparent");
            }

            /*setTimeout(function(){
					$('#header-outer').removeClass('no-bg-color');
					$('#header-outer-bg-only').hide();
					setTimeout(function(){
						$('#header-outer').removeClass('no-transition');
					},50);
				},250);*/
          }, 100);
        }

        //dark slide transparent nav
        if (
          $("#header-outer.temp-removed-dark-slide.transparent").length > 0 &&
          $("#boxed").length == 0
        )
          $("#header-outer")
            .removeClass("temp-removed-dark-slide")
            .addClass("dark-slide");

        //remove header transparent state

        if (
          $('#header-outer[data-permanent-transparent="1"]').length == 0 &&
          $("#slide-out-widget-area.fullscreen-alt").length == 0
        ) {
          if ($(".nectar-box-roll").length == 0) {
            if (
              $("#header-outer.small-nav").length > 0 ||
              $("#header-outer.scrolled-down").length > 0 ||
              $("#header-outer.detached").length > 0
            )
              $("#header-outer").removeClass("transparent");
          } else {
            if (
              $("#header-outer.small-nav").length > 0 ||
              $("#header-outer.scrolled-down").length > 0 ||
              $(".container-wrap.auto-height").length > 0
            )
              $("#header-outer").removeClass("transparent");
          }
        }

        //remove hidden menu
        $("#header-outer").removeClass("hidden-menu");

        $("#header-outer")
          .removeClass("side-widget-open")
          .addClass("side-widget-closed");

        return false;
      }
    );

    function slideOutWidgetOverflowState() {
      //switch position of social media/extra info based on screen size
      if (window.innerWidth < 1000 || $("body > #boxed").length > 0) {
        $(
          "#slide-out-widget-area.fullscreen .off-canvas-social-links, #slide-out-widget-area.fullscreen-alt .off-canvas-social-links"
        ).appendTo("#slide-out-widget-area .inner");
        $(
          "#slide-out-widget-area.fullscreen .bottom-text, #slide-out-widget-area.fullscreen-alt .bottom-text"
        ).appendTo("#slide-out-widget-area .inner");
      } else {
        $(
          "#slide-out-widget-area.fullscreen .off-canvas-social-links,#slide-out-widget-area.fullscreen-alt .off-canvas-social-links"
        ).appendTo("#slide-out-widget-area .inner-wrap");
        $(
          "#slide-out-widget-area.fullscreen .bottom-text, #slide-out-widget-area.fullscreen-alt .bottom-text"
        ).appendTo("#slide-out-widget-area .inner-wrap");
      }

      //add overflow
      if (
        $('#slide-out-widget-area[class*="fullscreen"] .inner').height() >=
        $(window).height() - 100
      ) {
        $(
          '#slide-out-widget-area[class*="fullscreen"] .inner, #slide-out-widget-area[class*="fullscreen"]'
        ).addClass("overflow-state");
      } else {
        $(
          '#slide-out-widget-area[class*="fullscreen"] .inner, #slide-out-widget-area[class*="fullscreen"]'
        ).removeClass("overflow-state");
      }

      $('#slide-out-widget-area[class*="fullscreen"] .inner').transition(
        {
          y:
            "-" +
            $('#slide-out-widget-area[class*="fullscreen"] .inner').height() /
              2 +
            "px",
        },
        0
      );

      //close mobile only slide out widget area if switching back to desktop
      if (
        $(".slide-out-from-right.open .off-canvas-menu-container.mobile-only")
          .length > 0 &&
        $("body.mobile").length == 0
      )
        $("#slide-out-widget-area .slide_out_area_close").trigger("click");
    }

    function fullWidthHeaderSlidingWidgetMenuCalc() {
      $("header#top nav > ul > li.megamenu > ul.sub-menu")
        .stop(true)
        .transition(
          { width: $(window).width() - 360, left: "300px" },
          700,
          "easeInOutCubic"
        );
    }

    //slide out widget area scrolling
    function slideOutWidgetAreaScrolling() {
      $("#slide-out-widget-area").mousewheel(function (event, delta) {
        this.scrollTop -= delta * 30;

        event.preventDefault();
      });
    }
    setTimeout(slideOutWidgetAreaScrolling, 500);

    //handle mobile scrolling
    if (
      navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
      )
    ) {
      $("#slide-out-widget-area").addClass("mobile");
    }

    function closeOCM(item) {
      if ($("#slide-out-widget-area.open").length > 0) {
        var $windowCurrentLocation = window.location.href.split("#")[0];
        var $windowClickedLocation = item
          .find("> a")
          .attr("href")
          .split("#")[0];

        if (
          $windowCurrentLocation == $windowClickedLocation ||
          item.find('a[href^="#"]').length > 0
        )
          $(".slide-out-widget-area-toggle a").trigger("click");
      }
    }

    //left header
    function leftHeaderSubmenus() {
      //remove megamenu class
      $("#header-outer nav li.megamenu").removeClass("megamenu");

      //click
      $("#header-outer li.menu-item-has-children > a").click(function () {
        if ($(this).parent().hasClass("open-submenu")) {
          $(this).parent().find(".sub-menu").css({
            "max-height": "0",
          });
          $(this).parent().removeClass("open-submenu");
        } else {
          //get max height

          var $that = $(this);
          var $maxSubMenuHeight;

          $that.parent().find("> .sub-menu").addClass("no-trans");

          setTimeout(function () {
            $that.parent().find("> .sub-menu").css({
              "max-height": "none",
              position: "absolute",
              visibility: "hidden",
            });

            $maxSubMenuHeight = $that.parent().find("> .sub-menu").height();

            $that.parent().find("> .sub-menu").removeClass("no-trans");
            $that.parent().find("> .sub-menu").css({
              "max-height": "0",
              position: "relative",
              visibility: "visible",
            });
          }, 25);

          setTimeout(function () {
            //reset
            $that
              .closest("ul")
              .find("li.menu-item-has-children")
              .removeClass("open-submenu");
            $that
              .closest("ul")
              .find("li.menu-item-has-children > .sub-menu")
              .css({
                "max-height": "0",
              });

            $that.parent().addClass("open-submenu");

            $that
              .parent()
              .find("> .sub-menu")
              .css("max-height", $maxSubMenuHeight);

            //add height to open parents
            if ($that.parents("ul").length > 0) {
              $that.parents("ul:not(.sf-menu)").each(function () {
                $(this).css("max-height");
                $(this).css(
                  "max-height",
                  parseInt(
                    $(this).height() +
                      parseInt($(this).css("padding-top")) * 2 +
                      $maxSubMenuHeight
                  ) + "px"
                );
              });
            }
          }, 50);
        }
        return false;
      });

      //start open for current page items
      var $maxSubMenuHeightArr = [];

      $(".current-menu-ancestor")
        .find(".current-menu-item")
        .parents("ul.sub-menu")
        .each(function (i) {
          $maxSubMenuHeightArr[i] = $(this)
            .parent()
            .find("> .sub-menu")
            .height();

          var $that = $(this);
          setTimeout(function () {
            var $totalSubMenuHeight = 0;

            for (var $i = 0; $i < $maxSubMenuHeightArr.length; $i++) {
              $totalSubMenuHeight += parseInt($maxSubMenuHeightArr[i]);
            }

            $that.parent().addClass("open-submenu");
            $that.css("max-height", $totalSubMenuHeight);
          }, 40);
        });
    }

    if ($('#header-outer[data-format="left-header"]').length > 0)
      leftHeaderSubmenus();

    //fullscreen submenu

    /**
     * jquery.dlmenu.js v1.0.1
     * http://www.codrops.com
     *
     * Licensed under the MIT license.
     * http://www.opensource.org/licenses/mit-license.php
     *
     * Copyright 2013, Codrops
     * http://www.codrops.com
     */
    (function ($, window, undefined) {
      "use strict";

      // global
      var Modernizr = window.Modernizr,
        $body = $("body");

      $.DLMenu = function (options, element) {
        this.$el = $(element);
        this._init(options);
      };

      // the options
      $.DLMenu.defaults = {
        // classes for the animation effects
        animationClasses: {
          classin: "dl-animate-in-1",
          classout: "dl-animate-out-1",
        },
        // callback: click a link that has a sub menu
        // el is the link element (li); name is the level name
        onLevelClick: function (el, name) {
          return false;
        },
        // callback: click a link that does not have a sub menu
        // el is the link element (li); ev is the event obj
        onLinkClick: function (el, ev) {
          return false;
        },
      };

      $.DLMenu.prototype = {
        _init: function (options) {
          // options
          this.options = $.extend(true, {}, $.DLMenu.defaults, options);
          // cache some elements and initialize some variables
          this._config();

          var animEndEventNames = {
              WebkitAnimation: "webkitAnimationEnd",
              OAnimation: "oAnimationEnd",
              msAnimation: "MSAnimationEnd",
              animation: "animationend",
            },
            transEndEventNames = {
              WebkitTransition: "webkitTransitionEnd",
              MozTransition: "transitionend",
              OTransition: "oTransitionEnd",
              msTransition: "MSTransitionEnd",
              transition: "transitionend",
            };
          // animation end event name
          this.animEndEventName =
            animEndEventNames[Modernizr.prefixed("animation")] + ".menu";
          // transition end event name
          (this.transEndEventName =
            transEndEventNames[Modernizr.prefixed("transition")] + ".menu"),
            // support for css animations and css transitions
            (this.supportAnimations = Modernizr.cssanimations),
            (this.supportTransitions = Modernizr.csstransitions);

          this._initEvents();
        },
        _config: function () {
          this.open = false;
          this.$trigger = this.$el.children(".trigger");
          this.$menu = this.$el.children("ul.menu");
          this.$menuitems = this.$menu.find("li:not(.back) > a");
          this.$el
            .find("ul.sub-menu")
            .prepend(
              '<li class="back"><a href="#"> ' +
                $("#slide-out-widget-area").attr("data-back-txt") +
                " </a></li>"
            );
          this.$back = this.$menu.find("li.back");
        },
        _initEvents: function () {
          var self = this;

          this.$trigger.on("click.menu", function () {
            if (self.open) {
              self._closeMenu();
            } else {
              self._openMenu();
            }
            return false;
          });

          this.$menuitems.on("click.menu", function (event) {
            //event.stopPropagation();

            var $item = $(this).parent("li"),
              $submenu = $item.children("ul.sub-menu");

            $(
              ".fullscreen-alt .off-canvas-menu-container .clip-wrap, .fullscreen-alt .off-canvas-menu-container .clip-wrap span"
            ).css("transition-duration", "0s");

            //exit if clicking on background LI (avoids effect wrongly triggering)
            //if( $item.find('> a').length > 0 && $item.find('> a').css('display') === 'none') return false;

            if ($submenu.length > 0) {
              var $flyin = $submenu
                  .clone()
                  .css("opacity", 0)
                  .insertAfter(self.$menu),
                onAnimationEndFn = function () {
                  self.$menu
                    .off(self.animEndEventName)
                    .removeClass(self.options.animationClasses.classout)
                    .addClass("subview");
                  $item
                    .addClass("subviewopen")
                    .parents(".subviewopen:first")
                    .removeClass("subviewopen")
                    .addClass("subview");
                  $flyin.remove();
                  setTimeout(function () {
                    $(".off-canvas-menu-container .menu > li").removeClass(
                      "no-pointer-events"
                    );
                    $(
                      ".off-canvas-menu-container .clip-wrap, .off-canvas-menu-container .clip-wrap span"
                    ).css("transition-duration", ".45s");
                  }, 300);
                };

              setTimeout(function () {
                $flyin.addClass(self.options.animationClasses.classin);
                self.$menu.addClass(self.options.animationClasses.classout);
                if (self.supportAnimations) {
                  self.$menu.on(self.animEndEventName, onAnimationEndFn);
                } else {
                  onAnimationEndFn.call();
                }

                self.options.onLevelClick(
                  $item,
                  $item.children("a:first").text()
                );
              });

              //adjust height for mobile / widgets below
              $item
                .parents(".off-canvas-menu-container")
                .css(
                  "height",
                  $item
                    .parents(".off-canvas-menu-container")
                    .find(".menuwrapper .menu")
                    .height()
                )
                .transition({ height: $flyin.height() }, 500, "easeInOutQuad");

              return false;
            } else {
              self.options.onLinkClick($item.find("> a"), event);
            }

            closeOCM($item);
          });

          this.$back.on("click.menu", function (event) {
            var $this = $(this),
              $submenu = $this.parents("ul.sub-menu:first"),
              $item = $submenu.parent(),
              $flyin = $submenu.clone().insertAfter(self.$menu);

            var onAnimationEndFn = function () {
              self.$menu
                .off(self.animEndEventName)
                .removeClass(self.options.animationClasses.classin);
              $flyin.remove();
            };

            setTimeout(function () {
              $flyin.addClass(self.options.animationClasses.classout);
              self.$menu.addClass(self.options.animationClasses.classin);
              if (self.supportAnimations) {
                self.$menu.on(self.animEndEventName, onAnimationEndFn);
              } else {
                onAnimationEndFn.call();
              }

              $item.removeClass("subviewopen");

              var $subview = $this.parents(".subview:first");
              if ($subview.is("li")) {
                $subview.addClass("subviewopen");
              }
              $subview.removeClass("subview");
            });

            //adjust height for mobile / widgets below
            $item
              .parents(".off-canvas-menu-container")
              .css(
                "height",
                $item
                  .parents(".off-canvas-menu-container")
                  .find(".menuwrapper .menu")
                  .height()
              );
            setTimeout(function () {
              $item
                .parents(".off-canvas-menu-container")
                .transition(
                  { height: $item.parent().height() },
                  500,
                  "easeInOutQuad"
                );
            }, 50);

            return false;
          });
        },
        closeMenu: function () {
          if (this.open) {
            this._closeMenu();
          }
        },
        _closeMenu: function () {
          var self = this,
            onTransitionEndFn = function () {
              self.$menu.off(self.transEndEventName);
              self._resetMenu();
            };

          this.$menu.removeClass("menuopen");
          this.$menu.addClass("menu-toggle");
          this.$trigger.removeClass("active");

          if (this.supportTransitions) {
            this.$menu.on(this.transEndEventName, onTransitionEndFn);
          } else {
            onTransitionEndFn.call();
          }

          this.open = false;
        },
        openMenu: function () {
          if (!this.open) {
            this._openMenu();
          }
        },
        _openMenu: function () {
          var self = this;
          // clicking somewhere else makes the menu close
          $body.off("click").on("click.menu", function () {
            self._closeMenu();
          });
          this.$menu
            .addClass("menuopen menu-toggle")
            .on(this.transEndEventName, function () {
              $(this).removeClass("menu-toggle");
            });
          this.$trigger.addClass("active");
          this.open = true;
        },
        // resets the menu to its original state (first level of options)
        _resetMenu: function () {
          this.$menu.removeClass("subview");
          this.$menuitems.removeClass("subview subviewopen");
        },
      };

      var logError = function (message) {
        if (window.console) {
          window.console.error(message);
        }
      };

      $.fn.dlmenu = function (options) {
        if (typeof options === "string") {
          var args = Array.prototype.slice.call(arguments, 1);
          this.each(function () {
            var instance = $.data(this, "menu");
            if (!instance) {
              logError(
                "cannot call methods on menu prior to initialization; " +
                  "attempted to call method '" +
                  options +
                  "'"
              );
              return;
            }
            if (!$.isFunction(instance[options]) || options.charAt(0) === "_") {
              logError("no such method '" + options + "' for menu instance");
              return;
            }
            instance[options].apply(instance, args);
          });
        } else {
          this.each(function () {
            var instance = $.data(this, "menu");
            if (instance) {
              instance._init();
            } else {
              instance = $.data(this, "menu", new $.DLMenu(options, this));
            }
          });
        }
        return this;
      };
    })(jQuery, window);

    function fullscreenMenuInit() {
      $("#slide-out-widget-area .off-canvas-menu-container .menu").wrap(
        '<div class="menu-wrap menuwrapper" />'
      );
      $("#slide-out-widget-area .off-canvas-menu-container .menu").addClass(
        "menuopen"
      );
      $ocmAnimationClassNum =
        $("#slide-out-widget-area.fullscreen-alt").length > 0 ? "4" : "5";
      $("#slide-out-widget-area .off-canvas-menu-container .menu-wrap").dlmenu({
        animationClasses: {
          classin: "dl-animate-in-" + $ocmAnimationClassNum,
          classout: "dl-animate-out-" + $ocmAnimationClassNum,
        },
      });

      //for slide out right, verify no link ares multiple lines, if so - remove effect
      $(
        "#slide-out-widget-area.slide-out-from-right-hover .off-canvas-menu-container .menu > li"
      ).each(function () {
        if ($(this).find("a").length > 0) {
          var $ocmLinkHeight = $(this).find("a").height();
          var $ocmLinkLineHeight = parseFloat(
            $(this).find("a").css("line-height")
          );
          var $ocmTextLines = $ocmLinkHeight / $ocmLinkLineHeight;
          if (Math.round($ocmTextLines) > 1) {
            $(this)
              .parents(".slide-out-from-right-hover")
              .addClass("no-text-effect");
            return false;
          }
        }
      });

      //add fullscreen alt text effect
      setTimeout(function () {
        $(
          "#slide-out-widget-area.fullscreen-alt .menu li, #slide-out-widget-area.slide-out-from-right-hover:not(.no-text-effect) .off-canvas-menu-container .menu li"
        ).each(function () {
          var $menuItemText = $(this).find("> a").html();
          $(this).find("> a ").html($menuItemText.replace(/ /g, "&nbsp;"));
          $(this)
            .find("> a")
            .append(
              '<span class="clip-wrap"><span>' +
                $(this).find("> a").text() +
                "</span></span>"
            );
        });
      }, 500);

      $("body").on(
        "mouseover",
        "#slide-out-widget-area.fullscreen-alt .menu li a",
        function () {
          var $that = $(this);

          $(this).find("> .clip-wrap").css({ "transition-duration": "0s" });
          $(this)
            .find("> .clip-wrap span ")
            .css({ "transition-duration": "0s" });

          $that
            .find("> .clip-wrap")
            .css({ width: "0%", transform: "translateX(0%)" });
          $that.find("> .clip-wrap span").css({ transform: "translateX(0%)" });

          setTimeout(function () {
            $that.find("> .clip-wrap").css({ "transition-duration": "0.45s" });

            $that
              .find("> .clip-wrap")
              .css({ width: "100%", left: "0", right: "auto" });
            //$that.find('> .clip-wrap span').css({'transform':'translateX(0%)'});
          }, 50);
        }
      );
      $("body").on(
        "mouseleave",
        "#slide-out-widget-area.fullscreen-alt .menu li a",
        function () {
          var $that = $(this);

          $(this).find("> .clip-wrap").css({ "transition-duration": "0s" });
          $(this)
            .find("> .clip-wrap span ")
            .css({ "transition-duration": "0s" });

          $that
            .find("> .clip-wrap")
            .css({ width: "100%", transform: "translateX(0%)" });
          $that.find("> .clip-wrap span").css({ transform: "translateX(0%)" });

          $that.find("> .clip-wrap").css({ "transition-duration": "0.45s" });
          $that
            .find("> .clip-wrap span")
            .css({ "transition-duration": "0.45s" });

          $that.find("> .clip-wrap").css({ transform: "translateX(100%)" });
          $that
            .find("> .clip-wrap span")
            .css({ transform: "translateX(-100%)" });
        }
      );
    }
    fullscreenMenuInit();

    //submenu link hover fix
    $("body").on(
      "mouseover",
      "#slide-out-widget-area .off-canvas-menu-container .menuwrapper > .sub-menu li > a",
      function () {
        var $currentTxt = $(this).text();
        $(".off-canvas-menu-container .menuwrapper .menu li > a").removeClass(
          "hovered"
        );
        $(
          ".off-canvas-menu-container .menuwrapper .menu li > a:contains(" +
            $currentTxt +
            ")"
        ).addClass("hovered");
      }
    );
    $("body").on(
      "mouseover",
      ".off-canvas-menu-container .menuwrapper .menu li > a",
      function () {
        $(".off-canvas-menu-container .menuwrapper .menu li > a").removeClass(
          "hovered"
        );
      }
    );

    /***************** Page Headers ******************/

    var pageHeaderHeight;
    var pageHeaderHeightCopy;
    var pageHeadingHeight;
    var extraSpaceFromResize =
      $('#header-outer[data-header-resize="1"]').length > 0 &&
      $(".nectar-box-roll").length == 0
        ? 51
        : 1;
    var $headerRemoveStickyness =
      $('body[data-hhun="1"]').length > 0 &&
      $('#header-outer[data-remove-fixed="1"]').length > 0
        ? 1
        : 0;

    //full screen header
    function fullScreenHeaderInit() {
      pageHeaderHeight = parseInt($("#page-header-bg").attr("data-height"));
      pageHeaderHeightCopy = parseInt($("#page-header-bg").attr("data-height"));

      var $headerNavSpace =
        $('body[data-header-format="left-header"]').length > 0 &&
        window.innerWidth > 1000
          ? 0
          : $("#header-outer").height();

      if ($(".fullscreen-header").length > 0) {
        if (
          $("#header-outer[data-transparency-option]").length > 0 &&
          $("#header-outer").attr("data-transparency-option") != "0"
        ) {
          var calculatedNum = !$("body").hasClass("mobile")
            ? $(window).height()
            : $(window).height() - parseInt($headerNavSpace);
        } else {
          var calculatedNum = !$("body").hasClass("mobile")
            ? $(window).height() -
              parseInt($headerNavSpace) +
              extraSpaceFromResize
            : $(window).height() - parseInt($headerNavSpace);
        }
        var extraHeight =
          $("#wpadminbar").length > 0 ? $("#wpadminbar").height() : 0; //admin bar
        if ($(".nectar-box-roll").length > 0) extraHeight = 0;
        pageHeaderHeight = calculatedNum - extraHeight;
        pageHeaderHeightCopy = calculatedNum - extraHeight;
      }

      $("#page-header-bg")
        .css("height", pageHeaderHeight + "px")
        .removeClass("not-loaded");
      setTimeout(function () {
        $("#page-header-bg").css("overflow", "visible");
      }, 800);
    }

    fullScreenHeaderInit();

    function pageHeader() {
      //add loaded class
      $('#page-header-bg[data-animate-in-effect="zoom-out"]').addClass(
        "loaded"
      );

      var $scrollTop = 0;
      var $windowInnerWidth = window.innerWidth;
      var $headerNavSpace =
        $('body[data-header-format="left-header"]').length > 0 &&
        $windowInnerWidth > 1000
          ? 0
          : $("#header-outer").height();
      var $windowHeight = $(window).height();

      //full screen header
      if ($(".fullscreen-header").length > 0) {
        if (
          $("#header-outer[data-transparency-option]").length > 0 &&
          $("#header-outer").attr("data-transparency-option") != "0"
        ) {
          var calculatedNum = !$("body").hasClass("mobile")
            ? $windowHeight
            : $windowHeight - parseInt($headerNavSpace);
          if ($('body[data-permanent-transparent="1"]').length > 0)
            calculatedNum = $windowHeight;
        } else {
          var calculatedNum = !$("body").hasClass("mobile")
            ? $windowHeight - parseInt($headerNavSpace) + extraSpaceFromResize
            : $windowHeight - parseInt($headerNavSpace);
        }
        var extraHeight =
          $("#wpadminbar").length > 0 ? $("#wpadminbar").height() : 0; //admin bar
        if ($(".nectar-box-roll").length > 0) extraHeight = 0;
        pageHeaderHeight = calculatedNum - extraHeight;
        pageHeaderHeightCopy = calculatedNum - extraHeight;
      }

      if (
        $windowInnerWidth < 1000 &&
        $windowInnerWidth > 690 &&
        !$("body").hasClass("salient_non_responsive")
      ) {
        var $multiplier = $(".fullscreen-header").length > 0 ? 1 : 1.6;
        $("#page-header-bg")
          .attr("data-height", pageHeaderHeightCopy / $multiplier)
          .css("height", pageHeaderHeightCopy / $multiplier + "px");
        $("#page-header-wrap").css(
          "height",
          pageHeaderHeightCopy / $multiplier + "px"
        );
      } else if (
        $windowInnerWidth <= 690 &&
        $windowInnerWidth > 480 &&
        !$("body").hasClass("salient_non_responsive")
      ) {
        var $multiplier = $(".fullscreen-header").length > 0 ? 1 : 2.1;
        $("#page-header-bg")
          .attr("data-height", pageHeaderHeightCopy / $multiplier)
          .css("height", pageHeaderHeightCopy / $multiplier + "px");
        $("#page-header-wrap").css(
          "height",
          pageHeaderHeightCopy / $multiplier + "px"
        );
      } else if (
        $windowInnerWidth <= 480 &&
        !$("body").hasClass("salient_non_responsive")
      ) {
        var $multiplier = $(".fullscreen-header").length > 0 ? 1 : 2.5;
        $("#page-header-bg")
          .attr("data-height", pageHeaderHeightCopy / $multiplier)
          .css("height", pageHeaderHeightCopy / $multiplier + "px");
        $("#page-header-wrap").css(
          "height",
          pageHeaderHeightCopy / $multiplier + "px"
        );
      } else {
        $("#page-header-bg")
          .attr("data-height", pageHeaderHeightCopy)
          .css("height", pageHeaderHeightCopy + "px");
        if ($(".fullscreen-header").length > 0) {
          $("#page-header-wrap").css("height", pageHeaderHeightCopy + "px");
        } else {
          $("#page-header-wrap").css("height", pageHeaderHeightCopy + "px");
        }

        if ($('#page-header-bg[data-parallax="1"]').length == 0)
          $("#page-header-wrap").css("height", pageHeaderHeightCopy + "px");
      }

      //handle left header
      if ($('body[data-header-format="left-header"]').length > 0)
        $('#page-header-bg[data-parallax="1"]').css(
          "width",
          $("#ajax-content-wrap").width()
        );

      if (!$("body").hasClass("mobile")) {
        //recalc
        pageHeaderHeight = parseInt($("#page-header-bg").attr("data-height"));
        $("#page-header-bg .container > .row").css("top", 0);
        var $divisionMultipler =
          $('#header-outer[data-remove-border="true"]').length > 0 &&
          $('#header-outer[data-format="centered-menu-under-logo"]').length == 0
            ? 2
            : 1;

        //center the heading
        pageHeadingHeight = $("#page-header-bg .col.span_6").height();

        if (
          $('#header-outer[data-transparent-header="true"]').length > 0 &&
          $(".fullscreen-header").length == 0
        ) {
          $('#page-header-bg:not("[data-parallax=1]") .col.span_6').css(
            "top",
            (pageHeaderHeight +
              $("#header-space").height() / $divisionMultipler) /
              2 -
              pageHeadingHeight / 2
          );
        } else {
          var $extraResizeHeight =
            $('#header-outer[data-header-resize="1"]').length > 0 ? 22 : 0;
          $('#page-header-bg:not("[data-parallax=1]") .col.span_6').css(
            "top",
            pageHeaderHeight / 2 - pageHeadingHeight / 2 + $extraResizeHeight
          );
        }

        //center portfolio filters
        $('#page-header-bg:not("[data-parallax=1]") .portfolio-filters').css(
          "top",
          pageHeaderHeight / 2 + 2
        );

        if ($('#page-header-bg[data-parallax="1"]').length > 0) {
          $scrollTop = $(window).scrollTop();
        }

        if (
          $('#page-header-bg[data-parallax="1"] .span_6').css("opacity") > 0
        ) {
          if (
            $('#header-outer[data-transparent-header="true"]').length > 0 &&
            $("body.single-post .fullscreen-header").length == 0
          ) {
            //center the parallax heading

            if ($headerRemoveStickyness) {
              $('#page-header-bg[data-parallax="1"] .span_6').css({
                top:
                  (pageHeaderHeight +
                    $("#header-space").height() / $divisionMultipler) /
                    2 -
                  pageHeadingHeight / 2 +
                  "px",
              });

              //center parllax portfolio filters
              $('#page-header-bg[data-parallax="1"] .portfolio-filters').css({
                top: $scrollTop * -0.1 + pageHeaderHeight / 2 - 7 + "px",
              });
            } else {
              $('#page-header-bg[data-parallax="1"] .span_6').css({
                opacity:
                  1 -
                  $scrollTop /
                    (pageHeaderHeight -
                      $("#page-header-bg .col.span_6").height() * 2 +
                      60),
                top:
                  (pageHeaderHeight +
                    $("#header-space").height() / $divisionMultipler) /
                    2 -
                  pageHeadingHeight / 2 +
                  "px",
              });

              //center parllax portfolio filters
              $('#page-header-bg[data-parallax="1"] .portfolio-filters').css({
                opacity:
                  1 -
                  $scrollTop /
                    (pageHeaderHeight -
                      $("#page-header-bg .col.span_6").height() * 2 +
                      75),
                top: $scrollTop * -0.1 + pageHeaderHeight / 2 - 7 + "px",
              });
            }
          } else {
            if ($headerRemoveStickyness) {
              //center the parallax heading
              $('#page-header-bg[data-parallax="1"] .span_6').css({
                top: pageHeaderHeight / 2 - pageHeadingHeight / 2 + 10 + "px",
              });

              //center parllax portfolio filters
              $('#page-header-bg[data-parallax="1"] .portfolio-filters').css({
                top: $scrollTop * -0.1 + pageHeaderHeight / 2 - 7 + "px",
              });
            } else {
              //center the parallax heading
              $('#page-header-bg[data-parallax="1"] .span_6').css({
                opacity:
                  1 -
                  $scrollTop /
                    (pageHeaderHeight -
                      $("#page-header-bg .col.span_6").height() * 2 +
                      60),
                top: pageHeaderHeight / 2 - pageHeadingHeight / 2 + 10 + "px",
              });

              //center parllax portfolio filters
              $('#page-header-bg[data-parallax="1"] .portfolio-filters').css({
                opacity:
                  1 -
                  $scrollTop /
                    (pageHeaderHeight -
                      $("#page-header-bg .col.span_6").height() * 2 +
                      75),
                top: $scrollTop * -0.1 + pageHeaderHeight / 2 - 7 + "px",
              });
            }
          }
        }
      } else {
        //recalc
        pageHeaderHeight = parseInt($("#page-header-bg").attr("data-height"));

        //center the heading
        var pageHeadingHeight = $("#page-header-bg .container > .row").height();
        $("#page-header-bg .container > .row").css(
          "top",
          pageHeaderHeight / 2 - pageHeadingHeight / 2 + 5
        );
      }

      $("#page-header-bg .container > .row").css("visibility", "visible");
    }

    var $pt_timeout =
      $('body[data-ajax-transitions="true"]').length > 0 &&
      $('#page-header-bg[data-animate-in-effect="slide-down"]').length > 0
        ? 350
        : 0;

    if ($("#page-header-bg").length > 0) {
      setTimeout(function () {
        pageHeader();
      }, $pt_timeout);
    }

    if (
      $("#header-outer").attr("data-header-resize") == "" ||
      $("#header-outer").attr("data-header-resize") == "0"
    ) {
      $("#page-header-wrap").css("margin-top", "0");
    }

    function extractUrl(input) {
      return input.replace(/"/g, "").replace(/url\(|\)$/gi, "");
    }

    /***************** Parallax Page Headers ******************/
    if ($('#page-header-bg[data-parallax="1"]').length > 0) {
      //fadeIn

      var img = new Image();

      var imgX, imgY, aspectRatio;
      var diffX, diffY;
      var pageHeadingHeight = $("#page-header-bg .col.span_6").height();
      var pageHeaderHeight = parseInt($("#page-header-bg").attr("data-height"));
      var headerPadding2 =
        parseInt($("#header-outer").attr("data-padding")) * 2;
      var wooCommerceHeader = $(".demo_store").length > 0 ? 32 : 0;

      var $initialImgCheck = extractUrl(
        $('#page-header-bg[data-parallax="1"]').css("background-image")
      );

      if ($initialImgCheck && $initialImgCheck.indexOf(".") !== -1) {
        img.onload = function () {
          pageHeaderInit();
        };

        img.src = extractUrl(
          $('#page-header-bg[data-parallax="1"]').css("background-image")
        );
      } else {
        pageHeaderInit();
      }

      var extraHeight =
        $("#wpadminbar").length > 0 ? $("#wpadminbar").height() : 0; //admin bar

      if (
        $('body[data-hhun="1"]').length > 0 &&
        !$('#header-outer[data-remove-fixed="1"]').length > 0
      )
        $("#header-outer").addClass("parallax-contained");

      window.addEventListener(
        "scroll",
        function () {
          window.requestAnimationFrame(bindHeaderParallax);
        },
        false
      );
    }

    function bindHeaderParallax() {
      var $scrollTop = $(window).scrollTop();
      var pageHeadingHeight = $("#page-header-bg .col.span_6").height();

      if (
        !$("body").hasClass("mobile") &&
        navigator.userAgent.match(/iPad/i) == null
      ) {
        var $multiplier1 = $('body[data-hhun="1"]').length > 0 ? 0.4 : 0.2;
        var $multiplier2 = $('body[data-hhun="1"]').length > 0 ? 0.09 : 0.14;
        var $parallaxHeaderHUN =
          $('#header-outer[data-transparency-option="1"]').length > 0
            ? 0.49
            : 0.4;

        //calc bg pos
        //$('#page-header-bg[data-parallax="1"]').css({'top': ((- $scrollTop / 5)+logoHeight+headerPadding+headerResizeOffExtra+extraHeight-extraDef+secondaryHeader)  + 'px' });
        if ($("#page-header-bg.out-of-sight").length == 0) {
          if ($headerRemoveStickyness) {
            $('#page-header-bg[data-parallax="1"]').css({
              transform: "translateY(" + $scrollTop * -0.55 + "px)",
            });
          } else {
            $('#page-header-bg[data-parallax="1"]').css({
              transform: "translateY(" + $scrollTop * -$multiplier1 + "px)",
            });
          }

          var multipler = $("body").hasClass("single") ? 1 : 2;
          if (!$headerRemoveStickyness) {
            $(
              '#page-header-bg[data-parallax="1"] .span_6,  #page-header-bg[data-parallax="1"][data-post-hs="default_minimal"] .author-section'
            ).css({
              opacity: 1 - $scrollTop / (pageHeaderHeight - 60),
            });
          }

          if ($headerRemoveStickyness) {
            $(
              '#page-header-bg[data-parallax="1"] .span_6, body[data-button-style="rounded"] #page-header-bg[data-parallax="1"] .scroll-down-wrap, #page-header-bg[data-parallax="1"][data-post-hs="default_minimal"] .author-section'
            ).css({ transform: "translateY(" + $scrollTop * -0.45 + "px)" });
          } else {
            $(
              '#page-header-bg[data-parallax="1"] .span_6, body[data-button-style="rounded"] #page-header-bg[data-parallax="1"] .section-down-arrow, #page-header-bg[data-parallax="1"][data-post-hs="default_minimal"] .author-section'
            ).css({
              transform: "translateY(" + $scrollTop * -$multiplier2 + "px)",
            });
          }

          if (
            $('#page-header-bg[data-parallax="1"] .span_6').css("opacity") == 0
          ) {
            $(
              '#page-header-bg[data-parallax="1"] .span_6, #page-header-bg[data-parallax="1"] .portfolio-filters'
            ).hide();
          } else {
            $(
              '#page-header-bg[data-parallax="1"] .span_6, #page-header-bg[data-parallax="1"] .portfolio-filters'
            ).show();
          }

          if (
            $('body[data-hhun="1"]').length > 0 &&
            !$("#header-outer").hasClass("side-widget-open") &&
            !$("#header-outer .slide-out-widget-area-toggle a").hasClass(
              "animating"
            )
          ) {
            $("#header-outer.parallax-contained").css({
              transform:
                "translateY(" + $scrollTop * -$parallaxHeaderHUN + "px)",
            });
          }
        } else if ($("#page-header-bg.out-of-sight").length == 0) {
          //alt parallax effect
          var multipler = $("body").hasClass("single") ? 1 : 2;
          $("#page-header-wrap .nectar-particles .fade-out").css({
            opacity:
              0 +
              $scrollTop / (pageHeaderHeight + pageHeaderHeight * $multiplier),
          });
        }

        //hide elements to allow other parallax sections to work in webkit browsers
        if (
          $scrollTop /
            (pageHeaderHeight + $("#header-space").height() + extraHeight) >
          1
        ) {
          $("#page-header-bg, .nectar-particles, #page-header-bg .fade-out")
            .css("visibility", "hidden")
            .hide()
            .addClass("out-of-sight");
        } else {
          $("#page-header-bg, .nectar-particles, #page-header-bg .fade-out")
            .css("visibility", "visible")
            .show()
            .removeClass("out-of-sight");

          //ensure header is centered
          pageHeaderHeight = parseInt($("#page-header-bg").attr("data-height"));
          $("#page-header-bg .container > .row").css("top", 0);
          var $divisionMultipler =
            $('#header-outer[data-remove-border="true"]').length > 0 &&
            $('#header-outer[data-format="centered-menu-under-logo"]').length ==
              0
              ? 2
              : 1;
          pageHeadingHeight = $("#page-header-bg .col.span_6").height();

          if (
            $('#header-outer[data-transparent-header="true"]').length > 0 &&
            $("body.single-post .fullscreen-header").length == 0
          ) {
            //center the parallax heading
            $('#page-header-bg[data-parallax="1"] .span_6').css({
              top:
                (pageHeaderHeight +
                  $("#header-space").height() / $divisionMultipler) /
                  2 -
                pageHeadingHeight / 2 +
                "px",
            });
          } else {
            //center the parallax heading
            $('#page-header-bg[data-parallax="1"] .span_6').css({
              top: pageHeaderHeight / 2 - pageHeadingHeight / 2 + 10 + "px",
            });
          }
        }
      }
    }

    if ($("#page-header-bg").length > 0) {
      var $initialImgCheckAscend = extractUrl(
        $("#page-header-bg").css("background-image")
      );
      if (
        $initialImgCheckAscend &&
        $initialImgCheckAscend.indexOf(".") !== -1
      ) {
        $("#page-header-bg").addClass("has-bg");
      }
    }

    function pageHeaderInit() {
      var wooCommerceHeader = $(".demo_store").length > 0 ? 32 : 0;
      var centeredNavAltSpace =
        $('#header-outer[data-format="centered-menu-under-logo"]').length > 0
          ? $("header#top nav > .sf-menu").height() - 20
          : null;
      //transparent
      if ($('#header-outer[data-transparent-header="true"]').length > 0) {
        $('#page-header-bg[data-parallax="1"]').css({
          top: extraHeight + wooCommerceHeader,
        });
      } else {
        var logoHeight = parseInt($("#header-outer").attr("data-logo-height"));
        var headerPadding = parseInt($("#header-outer").attr("data-padding"));
        var headerPadding2 = parseInt($("#header-outer").attr("data-padding"));
        var extraDef = 10;
        var headerResize = $("body").hasClass("pp-video-function")
          ? "1"
          : $("#header-outer").attr("data-header-resize");
        var headerResizeOffExtra = 0;
        var extraHeight =
          $("#wpadminbar").length > 0 ? $("#wpadminbar").height() : 0; //admin bar
        var usingLogoImage = true;
        var mediaElement = $(".wp-video-shortcode").length > 0 ? 36 : 0;
        var secondaryHeader =
          $("#header-outer").attr("data-using-secondary") == "1" ? 32 : 0;
        if ($('body[data-header-resize="0"]').length == 0)
          $('#page-header-bg[data-parallax="1"]').css({
            top:
              logoHeight +
              headerPadding +
              centeredNavAltSpace +
              headerResizeOffExtra +
              extraHeight -
              extraDef +
              secondaryHeader +
              wooCommerceHeader +
              "px",
          });
      }

      //fade in header
      if (
        $("#ajax-content-wrap").length == 0 ||
        !$("body").hasClass("ajax-loaded")
      ) {
        $('#page-header-bg[data-parallax="1"]').animate(
          { opacity: 1 },
          650,
          "easeInCubic"
        );
      } else if ($("#ajax-content-wrap").length == 1) {
        $('#page-header-bg[data-parallax="1"]').css({ opacity: 1 });
      }

      //$('#page-header-wrap').css({'height' : pageHeaderHeight});

      //verify smooth scorlling
      if (
        $smoothCache == true &&
        $(window).width() > 690 &&
        $("body").outerHeight(true) > $(window).height() &&
        Modernizr.csstransforms3d &&
        !navigator.userAgent.match(
          /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
        )
      ) {
        niceScrollInit();
        $(window).trigger("resize");
      }

      /* $('#page-header-bg[data-parallax="1"] .span_6').css({ 
			'opacity' : 1-($scrollTop/(pageHeaderHeight-($('#page-header-bg .col.span_6').height()*2)+60))
			'top' : ((pageHeaderHeight/2) - (pageHeadingHeight/2)) +10 +"px"
	   });
	   
	   $('#page-header-bg[data-parallax="1"] #portfolio-filters').css({ 
			'opacity' : 1-($scrollTop/(pageHeaderHeight-($('#page-header-bg .col.span_6').height()*2)+75)),
			'top' : ($scrollTop*-0.10) + ((pageHeaderHeight/2)) - 7 +"px"
	   }); */

      $('#page-header-bg[data-parallax="1"] .nectar-particles').append(
        '<div class="fade-out" />'
      );
    }

    function nectarPageHeader() {
      if ($("#page-header-bg").length > 0) {
        fullScreenHeaderInit();
        pageHeader();
      }

      if ($('#page-header-bg[data-parallax="1"]').length > 0) {
        var img = new Image();
        var $initialImgCheck = extractUrl(
          $('#page-header-bg[data-parallax="1"]').css("background-image")
        );

        if ($initialImgCheck && $initialImgCheck.indexOf(".") !== -1) {
          img.onload = function () {
            pageHeaderInit();
          };

          img.src = extractUrl(
            $('#page-header-bg[data-parallax="1"]').css("background-image")
          );
        } else {
          pageHeaderInit();
        }

        //bindHeaderParallax();
        $('#page-header-bg[data-parallax="1"] .span_6').css({
          opacity: 1,
        });

        if (window.addEventListener) {
          window.addEventListener(
            "scroll",
            function () {
              requestAnimationFrame(bindHeaderParallax);
            },
            false
          );
        }
      }

      if ($("#page-header-bg").length > 0) {
        var $initialImgCheckAscend = extractUrl(
          $("#page-header-bg").css("background-image")
        );
        if (
          $initialImgCheckAscend &&
          $initialImgCheckAscend.indexOf(".") !== -1
        ) {
          $("#page-header-bg").addClass("has-bg");
        }
      }
    }

    if (
      (navigator.userAgent.indexOf("Safari") != -1 &&
        navigator.userAgent.indexOf("Chrome") == -1) ||
      navigator.userAgent.match(/(iPod|iPhone|iPad)/)
    ) {
      window.onunload = function () {
        nectarPageHeader();
      };
    }

    /***************** header text effects *****************/

    // rotate in
    function pageHeaderTextEffectInit() {
      $("#page-header-bg").each(function () {
        if ($(this).attr("data-text-effect") == "rotate_in") {
          var $topHeading = "none";

          if ($(this).find(".span_6 h1").length > 0) {
            $topHeading = "h1";
          }
          //else if ($(this).find('.span_6 h2').length > 0) {
          //	$topHeading = 'h2';
          //}

          if ($topHeading != "none") {
            var $selector =
              $(this).find(".nectar-particles").length > 0
                ? ".inner-wrap.shape-1"
                : ".span_6";

            $(this)
              .find($selector)
              .find($topHeading)
              .addClass("top-heading")
              .contents()
              .filter(function () {
                return (
                  this.nodeType === 3 &&
                  typeof this.data != "undefined" &&
                  this.data.replace(/\s+/, "")
                );
              })
              .wrap('<span class="wraped"></span>');

            $(this)
              .find($selector)
              .find(".wraped")
              .each(function () {
                textNode = $(this);

                text = textNode.text().split(" ");
                replace = "";

                $.each(text, function (index, value) {
                  if (value.replace(/\s+/, "")) {
                    replace +=
                      '<span class="wraped"><span>' + value + "</span></span> ";
                  }
                });
                textNode.replaceWith($(replace));
              });
          } //make sure suitable heading was found
        } //tilt
      });
    }
    function pageHeaderTextEffect() {
      if (
        ($("#page-header-bg .nectar-particles").length == 0 &&
          $('#page-header-bg[data-text-effect="none"]').length == 0) ||
        ($(".nectar-box-roll").length > 0 &&
          $("#page-header-bg .nectar-particles").length == 0)
      ) {
        var $selector =
          $(".nectar-box-roll").length == 0
            ? "#page-header-bg .span_6"
            : ".nectar-box-roll .overlaid-content .span_6";

        $($selector)
          .find(".wraped")
          .each(function (i) {
            $(this)
              .find("span")
              .delay(i * 370)
              .transition(
                { rotateX: "0", opacity: 1, y: 0 },
                400,
                "easeOutQuad"
              );
          });

        setTimeout(function () {
          $($selector)
            .find(".inner-wrap > *:not(.top-heading)")
            .each(function (i) {
              $(this)
                .delay(i * 370)
                .transition(
                  { rotateX: "0", opacity: 1, y: 0 },
                  650,
                  "easeOutQuad"
                );
            });

          $(".scroll-down-wrap").removeClass("hidden");
        }, $($selector).find(".wraped").length * 370);
      }
    }
    var $effectTimeout = $("#ajax-loading-screen").length > 0 ? 800 : 0;
    pageHeaderTextEffectInit();
    if ($("#page-header-bg .nectar-video-wrap video").length == 0)
      setTimeout(pageHeaderTextEffect, $effectTimeout);

    //submenu fix
    if ($("header#top nav > ul.sf-menu ul").length > 0) {
      var $midnightSubmenuTimeout;
      $("body").on(
        "mouseover",
        "#header-outer .midnightHeader .sf-with-ul, #header-outer .midnightHeader .cart-menu",
        function () {
          if (
            $(this).parents(".midnightHeader").offset().top -
              $(window).scrollTop() <
            50
          ) {
            $(this)
              .parents(".midnightHeader")
              .css({ "z-index": "9999" })
              .addClass("overflow");
            $(this).parents(".midnightInner").css("overflow", "visible");
          }
        }
      );
      $("body").on("mouseleave", "#header-outer .midnightHeader", function () {
        var $that = $(this);
        clearTimeout($midnightSubmenuTimeout);
        $midnightSubmenuTimeout = setTimeout(function () {
          if (!$that.is(":hover")) {
            $that.css({ "z-index": "auto" }).removeClass("overflow");
            $that.find(".midnightInner").css("overflow", "hidden");
          }
        }, 900);
      });
    }

    function midnightInit() {
      if (
        $('#header-outer[data-permanent-transparent="1"]').length > 0 &&
        $('body[data-bg-header="true"]').length > 0
      ) {
        $("#header-outer").midnight();

        //set width for left aligned menu
        if (
          $('#header-outer[data-format="menu-left-aligned"] #logo img:visible')
            .length > 0
        ) {
          $("#header-outer #logo").css({
            width: $("#header-outer #logo img:visible").width(),
            height: $("#header-outer #logo img:visible").height(),
          });
        }

        //no menu
        if (
          $('#header-outer[data-has-menu="false"]').length > 0 &&
          $('#header-outer[data-format="centered-logo-between-menu"]').length ==
            0
        ) {
          //fix the pointer events
          //var enableHandler = false;

          var $buttonsOffset =
            $("#social-in-menu").length > 0
              ? $("#social-in-menu").position()
              : $("#header-outer header#top nav > ul.buttons").position();
          if ($("#header-outer #logo img:visible").length > 0) {
            var $logoOffset = $("#header-outer #logo img:visible").position();
            var $logoOffsetTop = $("#header-outer #logo img:visible").position()
              .top;
            var $logoMargin = parseInt(
              $("#header-outer #logo img:visible").css("margin-top")
            );
            var $logoWidth = $("#header-outer #logo img:visible").width();
          } else {
            var $logoOffset = $("#header-outer .span_3 #logo:visible").offset();
            var $logoOffsetTop =
              $("#header-outer .span_3 #logo:visible").offset().top -
              $(window).scrollTop();
            var $logoMargin = parseInt(
              $("#header-outer .span_3 #logo:visible").css("margin-top")
            );
            var $logoWidth = $("#header-outer #logo").width();
          }
          var $bodyBorderSize =
            $(".body-border-top").length > 0
              ? $(".body-border-top").height()
              : 0;

          var $containerMargin = parseInt(
            $("#header-outer header > .container").css("padding-left")
          );
          var $headerOffset = $("#header-outer").position();
          //recalc offsets
          $(window).on("smartresize", function () {
            if ($("#header-outer #logo img").length > 0) {
              $logoMargin = parseInt(
                $("#header-outer #logo img:visible").css("margin-top")
              );
              $logoOffset = $("#header-outer #logo img:visible").position();
              $logoOffsetTop = $("#header-outer #logo img:visible").position()
                .top;
              $logoWidth = $("#header-outer #logo img:visible").width();
            } else {
              $logoMargin = parseInt(
                $("#header-outer .span_3 #logo:visible").css("margin-top")
              );
              $logoOffset = $("#header-outer .span_3 #logo:visible").offset();
              $logoOffsetTop =
                $("#header-outer .span_3 #logo:visible").offset().top -
                $(window).scrollTop();
              $logoWidth = $("#header-outer #logo").width();
            }
            $containerMargin = parseInt(
              $("#header-outer header > .container").css("padding-left")
            );
            $buttonsOffset =
              $("#social-in-menu").length > 0
                ? $("#social-in-menu").position()
                : $("#header-outer header#top nav > ul.buttons").position();
            $headerOffset = $("#header-outer").position();
          });

          $("body").mousemove(function (e) {
            if (
              $("body.mobile").length == 0 &&
              $("#header-outer header").length > 0
            ) {
              //hover over buttons || logo check
              if (
                (e.clientX >= $buttonsOffset.left + $containerMargin &&
                  e.clientY >= $buttonsOffset.top + $bodyBorderSize &&
                  e.clientY <=
                    $buttonsOffset.top +
                      $headerOffset.top +
                      $bodyBorderSize +
                      $(
                        "#header-outer header#top nav > ul.buttons"
                      ).height()) ||
                (e.clientX <=
                  $logoOffset.left + $containerMargin + $logoWidth &&
                  e.clientY >= $logoOffsetTop + $bodyBorderSize &&
                  e.clientY <=
                    $logoOffsetTop +
                      $logoMargin +
                      $bodyBorderSize +
                      $headerOffset.top +
                      $("#header-outer #logo img:visible").height())
              ) {
                $(".midnightHeader, #header-outer").removeClass(
                  "no-pointer-events"
                );
              } else {
                $(".midnightHeader, #header-outer").addClass(
                  "no-pointer-events"
                );
              }
            } else {
              $(".midnightHeader, #header-outer").removeClass(
                "no-pointer-events"
              );
            }
          });
        }

        //using menu
        else if ($('#header-outer[data-has-menu="true"]').length > 0) {
          var $headerPos = $("header#top .container").position();
          var $headerOffset = $("header#top .container").offset();
          var $bodyBorderSize =
            $(".body-border-top").length > 0
              ? $(".body-border-top").height()
              : 0;

          //recalc offsets
          $(window).on("smartresize", function () {
            $headerPos = $("header#top .container").position();
            $headerOffset = $("header#top .container").offset();
          });

          $("body").mousemove(function (e) {
            if (
              $("body.mobile").length == 0 &&
              $("#header-outer header").length > 0
            ) {
              //hover over buttons || logo check
              if (
                e.clientX >= $headerOffset.left &&
                e.clientY >= $headerPos.top + $bodyBorderSize &&
                e.clientY <=
                  $("header#top .container .row").height() + $bodyBorderSize
              ) {
                $(".midnightHeader, #header-outer").removeClass(
                  "no-pointer-events"
                );
              } else if ($("li.sfHover").length == 0) {
                $(".midnightHeader, #header-outer").addClass(
                  "no-pointer-events"
                );
              }
            } else {
              $(".midnightHeader, #header-outer").removeClass(
                "no-pointer-events"
              );
            }
          });
        }
      }
    }

    //box roll
    function getScrollbarWidth() {
      var outer = document.createElement("div");
      outer.style.visibility = "hidden";
      outer.style.width = "100px";
      outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

      document.body.appendChild(outer);

      var widthNoScroll = outer.offsetWidth;
      // force scrollbars
      outer.style.overflow = "scroll";

      // add innerdiv
      var inner = document.createElement("div");
      inner.style.width = "100%";
      outer.appendChild(inner);

      var widthWithScroll = inner.offsetWidth;

      // remove divs
      outer.parentNode.removeChild(outer);

      return widthNoScroll - widthWithScroll;
    }

    function boxRollInit() {
      if ($(".nectar-box-roll").length > 0) {
        $("body").attr("data-scrollbar-width", getScrollbarWidth());

        $(
          "body, html, #ajax-content-wrap, .container-wrap, .blurred-wrap"
        ).addClass("no-scroll");
        $("body,html").stop().animate({ scrollTop: 0 }, 0);
        $(".container-wrap")
          .css("opacity", 0)
          .addClass("no-transform-animation-bottom-out")
          .addClass("bottomBoxOut");
        //keep loading icon centered if scrollbar is going away
        if ($(".mobile").length == 0)
          $("#ajax-loading-screen .loading-icon > span").css({
            left: "-" + getScrollbarWidth() / 2 + "px",
          });

        //change content pos
        var $overlaid = $("#page-header-bg .overlaid-content").clone();
        var $scrollDownOverlaid = $(".scroll-down-wrap").clone();
        $("#page-header-bg").removeAttr("data-midnight");
        $(
          "#page-header-bg .overlaid-content, #page-header-bg .scroll-down-wrap"
        ).remove();
        $(".nectar-box-roll").append($overlaid).attr("data-midnight", "light");
        $(".overlaid-content").append($scrollDownOverlaid);

        if ($('.page-submenu[data-sticky="true"]').length > 0) {
          $(".container-wrap").addClass("no-trans");
        }

        nectarBoxRollContentHeight();
        setTimeout(function () {
          pageLoadHash();
        }, 700);
      } else {
        $("#ajax-content-wrap, .blurred-wrap").addClass("at-content");
        $(
          "body, html, #ajax-content-wrap, .container-wrap, .blurred-wrap"
        ).removeClass("no-scroll");
        $(".container-wrap")
          .css("opacity", 1)
          .removeClass("no-transform-animation-bottom-out")
          .removeClass("bottomBoxOut")
          .removeClass("bottomBoxIn");
        perspect = "not-rolled";
      }
    }
    boxRollInit();

    function nectarBoxRollContentHeight() {
      /*if($('#header-outer[data-transparent-header="true"]').length == 0 && $('.mobile').length == 0) {
		$('.nectar-box-roll').css('top',$('#header-space').height());
	} else {
		$('.nectar-box-roll').css('top','0');
	}*/
      var $headerNavSpace =
        $('body[data-header-format="left-header"]').length > 0 &&
        $(window).width() > 1000
          ? 0
          : $("#header-space").height();

      if ($('#header-outer[data-transparent-header="true"]').length == 0) {
        $(
          ".nectar-box-roll .overlaid-content, .nectar-box-roll .canvas-bg, .container-wrap"
        ).css({
          height: window.innerHeight - $headerNavSpace,
          "min-height": window.innerHeight - $headerNavSpace,
        });
        if (
          $(".mobile").length == 0 &&
          $('body[data-header-format="left-header"]').length == 0
        ) {
          $("#ajax-content-wrap").css("margin-top", $headerNavSpace);
          $("#slide-out-widget-area.fullscreen").css(
            "margin-top",
            "-" + $headerNavSpace + "px"
          );
        } else
          $("#ajax-content-wrap, #slide-out-widget-area.fullscreen").css(
            "margin-top",
            "0"
          );
      } else {
        $(
          ".nectar-box-roll .overlaid-content, .nectar-box-roll .canvas-bg, .container-wrap"
        ).css("height", window.innerHeight);
      }
    }

    if ($(".nectar-box-roll").length > 0)
      $(window).on("resize", nectarBoxRollContentHeight);

    var perspect = "not-rolled";
    var animating = "false";
    function boxRoll(e, d) {
      var $headerNavSpace =
        $('body[data-header-format="left-header"]').length > 0 &&
        $(window).width() > 1000
          ? 0
          : $("#header-space").height();

      if ($("#slide-out-widget-area.open").length > 0) return false;
      if (
        $(".nectar-box-roll canvas").length > 0 &&
        $('.nectar-box-roll canvas[data-loaded="true"]').length == 0
      )
        return false;

      if (perspect == "not-rolled" && animating == "false" && d == -1) {
        perspect = "rolled";
        animating = "true";
        $("body")
          .addClass("box-animating")
          .addClass("box-perspective-rolled")
          .addClass("box-rolling");

        $(".nectar-box-roll #page-header-bg")
          .removeClass("topBoxIn")
          .addClass("topBoxOut")
          .css("will-change", "transform");

        $(".nectar-box-roll .overlaid-content")
          .removeClass("topBoxIn2")
          .removeClass("topBoxIn")
          .addClass("topBoxOut2")
          .css("will-change", "transform");

        $(".container-wrap")
          .removeClass("bottomBoxOut")
          .addClass("bottomBoxIn")
          .removeClass("no-transform-animation-bottom-out")
          .addClass("nectar-box-roll-class")
          .css("will-change", "transform");
        if ($('#header-outer[data-transparent-header="true"]').length == 0) {
          $(".container-wrap").css({
            height: $(window).height() - $headerNavSpace,
            opacity: 1,
          });
          $("#slide-out-widget-area.fullscreen").css("margin-top", "0px");
        } else {
          $(".container-wrap").css({ height: $(window).height(), opacity: 1 });
        }

        $(".nectar-slider-wrap").css({ opacity: 0 });

        updateRowRightPadding(d);
        pauseVideoBG();

        //old browser workaround
        var timeout1 = 1220;
        var timeout2 = 1650;
        var timeout3 = 1700;
        var timeout4 = 1350;
        if ($("html.no-cssanimations").length > 0) {
          timeout1 = 1;
          timeout2 = 1;
          timeout3 = 1;
          timeout4 = 1;
        }

        $(".container-wrap").css(
          "padding-right",
          $("body").attr("data-scrollbar-width") + "px"
        );
        setTimeout(function () {
          $(
            "#header-outer, #wpadminbar, .cart-outer .cart-menu, .midnightHeader .midnightInner"
          ).animate(
            { "padding-right": $("body").attr("data-scrollbar-width") },
            250
          );
          $(".nectar-box-roll .canvas-bg").addClass("out-of-sight");
          if ($('#header-outer[data-permanent-transparent="1"]').length == 0)
            $("#header-outer").removeClass("transparent");

          if ($("body.mobile").length > 0)
            $(".nectar-box-roll").css({ "z-index": "1" });
        }, timeout1);
        setTimeout(function () {
          updateRowRightPadding(1);
          $(
            "body,html,#ajax-content-wrap, .container-wrap, .blurred-wrap"
          ).removeClass("no-scroll");
          $("#ajax-content-wrap, .blurred-wrap").addClass("at-content");
          $(".container-wrap, #footer-outer")
            .removeClass("bottomBoxIn")
            .removeClass("nectar-box-roll-class")
            .addClass("auto-height");
          $(
            "#header-outer, #wpadminbar, .container-wrap, .cart-outer .cart-menu, .midnightHeader .midnightInner"
          )
            .stop()
            .css("padding-right", 0);

          if (
            $smoothActive == 1 &&
            $(window).width() > 690 &&
            Modernizr.csstransforms3d &&
            !navigator.userAgent.match(
              /(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/
            )
          ) {
            niceScrollInit();
          }

          $(".nectar-box-roll")
            .css({ "z-index": "-1000" })
            .transition({ y: "-200%" }, 0);
          $(".nectar-box-roll canvas").hide();
          $("body").removeClass("box-rolling");
          $(".nectar-slider-wrap").transition(
            { opacity: 1 },
            600,
            "easeOutCubic"
          );

          $(
            ".nectar-box-roll #page-header-bg, .nectar-box-roll .overlaid-content, .container-wrap"
          ).css("will-change", "auto");
          if ($waypointsBound == false) waypoints();
        }, timeout2);

        //fadeIn
        setTimeout(function () {
          $(
            '.container-wrap .main-content > .row > div > div[class*="col"]'
          ).css({ opacity: 1 });
        }, timeout4);

        setTimeout(function () {
          animating = "false";
          $("body").removeClass("box-animating");
        }, timeout3);

        //header position when transparent nav was used
        if (
          $('#header-outer[data-permanent-transparent="1"]').length == 0 &&
          $(".mobile").length == 0 &&
          $('#header-outer[data-transparent-header="true"]').length != 0
        ) {
          $("#ajax-content-wrap").transition(
            {
              "margin-top":
                $("#header-outer").outerHeight(true) +
                $("#header-outer").offset().top,
            },
            2000,
            "easeInOutQuad"
          );
        }
        /*if($('#header-outer[data-transparent-header="true"]').length == 0 && $('.mobile').length == 0) {
			$('.nectar-box-roll').transition({'top': 0},2000,'easeInOutQuad');
		}*/

        //remove header if not fixed
        if (
          $('.mobile #header-outer[data-permanent-transparent="1"]').length >
            0 &&
          $('.mobile #header-outer[data-mobile-fixed="false"]').length == 1
        )
          $("#header-outer").transition({ y: "-100%" }, 400, "easeOutCubic");
      } else if (
        perspect == "rolled" &&
        animating == "false" &&
        d == 1 &&
        $(window).scrollTop() < 100
      ) {
        $(".container-wrap").removeClass("auto-height");
        if ($('#header-outer[data-transparent-header="true"]').length == 0) {
          $(".container-wrap").css({
            height: $(window).height() - $headerNavSpace,
            opacity: 1,
          });
        } else {
          $(".container-wrap").css({ height: $(window).height(), opacity: 1 });
        }

        $("#footer-outer").removeClass("auto-height");
        $("body").addClass("box-rolling");

        perspect = "not-rolled";
        animating = "true";
        $("body")
          .addClass("box-animating")
          .addClass("box-perspective-not-rolled");

        $(
          "#header-outer, #wpadminbar, .container-wrap, .cart-outer .cart-menu, .midnightHeader .midnightInner"
        ).css("padding-right", $("body").attr("data-scrollbar-width") + "px");
        $(".nectar-slider-wrap").transition(
          { opacity: 0 },
          600,
          "easeOutCubic"
        );
        $('.container-wrap .main-content > .row > div > div[class*="col"]')
          .stop(true)
          .css({ opacity: 0 });
        setTimeout(function () {
          $(
            "#header-outer, #wpadminbar, .cart-outer .cart-menu, .midnightHeader .midnightInner"
          ).animate({ "padding-right": 0 }, 250);
          $(".nectar-box-roll .canvas-bg").removeClass("out-of-sight");
          resizeVideoToCover();
          //header position when transparent nav was used
          if ($('#header-outer[data-transparent-header="true"]').length != 0) {
            $("#ajax-content-wrap")
              .stop(true, true)
              .transition({ "margin-top": 0 }, 2000, "easeInOutCubic");
          } else {
            if ($(".mobile").length == 0)
              $("#slide-out-widget-area.fullscreen").css(
                "margin-top",
                "-" + $headerNavSpace + "px"
              );
          }
          //if($('#header-outer[data-permanent-transparent="1"]').length == 0 && $('.mobile').length == 0 ) $('.nectar-box-roll').transition({'top': $('#header-space').height() },2000,'easeInOutQuad');
        }, 30);

        //old browser workaround
        var timeout1 = 1700;
        var timeout2 = 1600;
        var timeout3 = 1300;
        if ($("html.no-cssanimations").length > 0) {
          timeout1 = 1;
          timeout2 = 1;
          timeout3 = 1;
        }

        if ($("body.mobile").length > 0) {
          setTimeout(function () {
            $(".nectar-box-roll").css("z-index", "1000");
          }, timeout3);
        } else {
          $(".nectar-box-roll").css("z-index", "1000");
        }

        updateRowRightPadding(d);
        removeNiceScroll();
        $(".nectar-box-roll").transition({ y: "0" }, 0);
        $(".nectar-box-roll canvas").show();
        setTimeout(function () {
          updateRowRightPadding(1);
          animating = "false";
          $("body").removeClass("box-animating");
          $("#page-header-bg").removeClass("topBoxIn");
          $(".overlaid-content").removeClass("topBoxIn2");
          $("body").removeClass("box-rolling");
          resumeVideoBG();
          $(
            ".nectar-box-roll #page-header-bg, .nectar-box-roll .overlaid-content, .container-wrap"
          ).css("will-change", "auto");
        }, timeout1);

        setTimeout(function () {
          if (
            $('.mobile #header-outer[data-permanent-transparent="1"]').length >
              0 &&
            $('.mobile #header-outer[data-mobile-fixed="false"]').length == 1
          )
            $("#header-outer").transition({ y: "0%" }, 400, "easeOutCubic");
        }, timeout2);

        $(
          "body,html,#ajax-content-wrap, .container-wrap, .blurred-wrap"
        ).addClass("no-scroll");
        $("#ajax-content-wrap, .blurred-wrap").removeClass("at-content");
        $(".container-wrap").addClass("nectar-box-roll-class");
        $(".nectar-box-roll #page-header-bg")
          .removeClass("topBoxOut")
          .addClass("topBoxIn")
          .css("will-change", "transform");

        $(".container-wrap")
          .removeClass("bottomBoxIn")
          .addClass("bottomBoxOut")
          .css("will-change", "transform");

        if (
          $('#header-outer[data-transparent-header="true"]').length > 0 &&
          $('#header-outer[data-permanent-transparent="1"]').length == 0
        )
          $("#header-outer").addClass("transparent");

        $(".nectar-box-roll .overlaid-content")
          .removeClass("topBoxOut2")
          .removeClass("topBoxOut")
          .addClass("topBoxIn2")
          .css("will-change", "transform");

        if ($('#header-outer[data-header-resize="1"]').length > 0) {
          bigNav();
        }

        $(".nectar-box-roll .trigger-scroll-down").removeClass("hovered");
      }
    }

    function boxScrollEvent(event, delta) {
      if ($("#slide-out-widget-area.open.fullscreen").length > 0) return false;
      boxRoll(event, delta);
    }

    function boxRollMouseWheelInit() {
      if ($(".nectar-box-roll").length > 0) {
        $("body").on("mousewheel", boxScrollEvent);
      } else {
        $("body").off("mousewheel", boxScrollEvent);
      }
    }

    boxRollMouseWheelInit();

    $("body").on("click", ".nectar-box-roll .section-down-arrow", function () {
      boxRoll(null, -1);
      $(this).addClass("hovered");
      setTimeout(function () {
        $(".nectar-box-roll .section-down-arrow").removeClass("hovered");
      }, 2000);
      return false;
    });

    function updateRowRightPadding(d) {
      $(".wpb_row.full-width-section").each(function () {
        if ($(this).hasClass("extraPadding") && d == 1) {
          $(this)
            .css(
              "padding-right",
              parseInt($(this).css("padding-right")) -
                parseInt($("body").attr("data-scrollbar-width")) +
                "px"
            )
            .removeClass("extraPadding");
        } else {
          $(this)
            .css(
              "padding-right",
              parseInt($("body").attr("data-scrollbar-width")) +
                parseInt($(this).css("padding-right")) +
                "px"
            )
            .addClass("extraPadding");
        }
      });
      $(".wpb_row.full-width-content").each(function () {
        if ($(this).find(".row-bg.using-image").length == 0) {
          if ($(this).hasClass("extraPadding") && d == 1) {
            $(this)
              .find(".row-bg")
              .css(
                "width",
                parseInt($(this).width()) -
                  parseInt($("body").attr("data-scrollbar-width")) +
                  "px"
              )
              .removeClass("extraPadding");
          } else {
            $(this)
              .find(".row-bg")
              .css(
                "width",
                parseInt($("body").attr("data-scrollbar-width")) +
                  $(this).width() +
                  "px"
              )
              .addClass("extraPadding");
          }
        }
      });
    }

    function pauseVideoBG() {
      if ($(".nectar-box-roll video").length > 0)
        $(".nectar-box-roll video")[0].pause();
    }
    function resumeVideoBG() {
      if ($(".nectar-box-roll video").length > 0)
        $(".nectar-box-roll video")[0].play();
    }

    //touch
    if (
      navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
      ) &&
      $(".nectar-box-roll").length > 0
    ) {
      $("body").swipe({
        tap: function (event, target) {
          if ($(target).parents(".nectar-flip-box").length > 0)
            $(target).parents(".nectar-flip-box").trigger("click");
          if ($(target).is(".nectar-flip-box")) $(target).trigger("click");
        },
        swipeStatus: function (
          event,
          phase,
          direction,
          distance,
          duration,
          fingers
        ) {
          if ($("#slide-out-widget-area.open").length > 0) return false;
          if (direction == "up") {
            boxRoll(null, -1);
            if ($("#ajax-content-wrap.no-scroll").length == 0)
              $("body").swipe("option", "allowPageScroll", "vertical");
          } else if (direction == "down" && $(window).scrollTop() == 0) {
            boxRoll(null, 1);
            $("body").swipe("option", "allowPageScroll", "auto");
          }
        },
      });
    }

    function removeNiceScroll() {
      if ($().niceScroll && $("html").getNiceScroll()) {
        var nice = $("html").getNiceScroll();
        nice.stop();

        $("html").removeClass("no-overflow-y");
        $(".nicescroll-rails").hide();
        if ($("#boxed").length == 0) {
          $(
            "body, body #header-outer, body #header-secondary-outer, body #search-outer, .midnightHeader .midnightInner"
          ).css("padding-right", "0px");
        } else if ($('body[data-ext-responsive="true"]').length == 0) {
          $("body").css("padding-right", "0px");
        }

        $("body").attr("data-smooth-scrolling", "0");
      }
    }
    //called after box roll
    $waypointsBound = false;
    function waypoints() {
      colAndImgAnimations();
      progressBars();
      dividers();
      iconList();
      animated_titles();
      imageWithHotspots();
      clientsFadeIn();
      splitLineHeadings();
      svgAnimations();
      milestoneInit();
      nectar_fancy_ul_init();
      owl_carousel_animate();
      headerRowColorInheritInit();
      morphingOutlines();
      portfolioLoadIn();
      animatedColBorders();
      foodMenuItems();
      vcWaypoints();
      $waypointsBound = true;
    }

    /***************** WooCommerce Cart *****************/
    var timeout;
    var productToAdd;
    var $dropdownStyle =
      $('body[data-dropdown-style="minimal"]').length > 0
        ? "minimal"
        : "default";
    //notification
    $("body").on("click", ".product .add_to_cart_button", function () {
      var $productHeading =
        $(this).parents("li").find("h2").length > 0 ? "h2" : "h3";

      productToAdd = $(this).parents("li").find($productHeading).text();
      $("#header-outer .cart-notification span.item-name").html(productToAdd);

      //if($('.cart-menu-wrap').hasClass('first-load')) $('.cart-menu-wrap').removeClass('first-load').addClass('static');
    });

    //notification hover
    $("body").on("mouseenter", "#header-outer .cart-notification", function () {
      if ($dropdownStyle == "minimal") {
        $(this).hide();
        $("#header-outer .widget_shopping_cart")
          .addClass("open")
          .stop(true, true)
          .show();
        $("#header-outer .cart_list").stop(true, true).show();
      } else {
        $(this).fadeOut(400);
        $("#header-outer .widget_shopping_cart").stop(true, true).fadeIn(300);
        $("#header-outer .cart_list").stop(true, true).fadeIn(300);
      }

      clearTimeout(timeout);
    });

    //cart dropdown
    $("#header-outer div.cart-outer").hoverIntent(function () {
      if ($dropdownStyle == "minimal") {
        $("#header-outer .widget_shopping_cart")
          .addClass("open")
          .stop(true, true)
          .show();
        $("#header-outer .cart_list").stop(true, true).show();
        clearTimeout(timeout);
        $("#header-outer .cart-notification").hide();
      } else {
        $("#header-outer .widget_shopping_cart")
          .addClass("open")
          .stop(true, true)
          .fadeIn(300);
        $("#header-outer .cart_list").stop(true, true).fadeIn(300);
        clearTimeout(timeout);
        $("#header-outer .cart-notification").fadeOut(300);
      }
    });

    $("body").on("mouseleave", "#header-outer div.cart-outer", function () {
      var $that = $(this);
      setTimeout(function () {
        if (!$that.is(":hover")) {
          $("#header-outer .widget_shopping_cart")
            .removeClass("open")
            .stop(true, true)
            .fadeOut(300);
          $("#header-outer .cart_list").stop(true, true).fadeOut(300);
        }
      }, 100);
    });

    if ($('#header-outer[data-cart="false"]').length == 0) {
      $("body").on("added_to_cart", shopping_cart_dropdown_show);
      $("body").on("added_to_cart", shopping_cart_dropdown);
    }

    function shopping_cart_dropdown() {
      if (
        !$(
          ".widget_shopping_cart .widget_shopping_cart_content .cart_list .empty"
        ).length &&
        $(".widget_shopping_cart .widget_shopping_cart_content .cart_list")
          .length > 0
      ) {
        $(".cart-menu-wrap").addClass("has_products");
        $(
          "header#top nav > ul, #search-outer #search #close a, header#top .span_9 >.slide-out-widget-area-toggle"
        ).addClass("product_added");

        if (!$(".cart-menu-wrap").hasClass("static"))
          $(".cart-menu-wrap").addClass("first-load");

        //nectar slider nav directional effect
        if (
          $("#header-outer").hasClass("directional-nav-effect") &&
          $("#header-outer .cart-icon-wrap .dark").length == 0 &&
          $("body.ascend").length > 0
        ) {
          $("#header-outer .cart-outer .cart-icon-wrap").each(function () {
            $(this)
              .find("> i, > span.light, > span.dark, > span.original")
              .remove();
            $(this).append(
              '<span class="dark"><span><i class="icon-salient-cart"></i></span></span><span class="light"><span><i class="icon-salient-cart"></i></span></span><span class="original"><span><i class="icon-salient-cart"></i></span></span>'
            );
            $(this)
              .find(".original")
              .attr("data-w", $(this).find("span.original").width() + 1);
          });
        }
      }
    }

    function shopping_cart_dropdown_show(e) {
      clearTimeout(timeout);

      if (
        !$(
          ".widget_shopping_cart .widget_shopping_cart_content .cart_list .empty"
        ).length &&
        $(".widget_shopping_cart .widget_shopping_cart_content .cart_list")
          .length > 0 &&
        typeof e.type != "undefined"
      ) {
        //before cart has slide in
        if (!$("#header-outer .cart-menu-wrap").hasClass("has_products")) {
          setTimeout(function () {
            $("#header-outer .cart-notification").fadeIn(400);
          }, 400);
        } else if (!$("#header-outer .cart-notification").is(":visible")) {
          $("#header-outer .cart-notification").fadeIn(400);
        } else {
          $("#header-outer .cart-notification").show();
        }
        timeout = setTimeout(hideCart, 2700);

        $(".cart-menu a, .widget_shopping_cart a").addClass("no-ajaxy");
      }
    }

    function hideCart() {
      $("#header-outer .cart-notification").stop(true, true).fadeOut();
    }

    function checkForWooItems() {
      var checkForCartItems = setInterval(shopping_cart_dropdown, 250);
      setTimeout(function () {
        clearInterval(checkForCartItems);
      }, 4500);
    }
    if ($('#header-outer[data-cart="false"]').length == 0) {
      checkForWooItems();
    }

    var extraHeight =
      $("#wpadminbar").length > 0 ? $("#wpadminbar").height() : 0; //admin bar
    var secondaryHeader =
      $("#header-outer").attr("data-using-secondary") == "1" ? 32 : 0;
    function searchFieldCenter() {
      var $headerHeightSpace =
        $('body[data-header-format="left-header"]').length > 0 &&
        $(window).width() > 1000
          ? 0
          : $("#header-outer").outerHeight();
      $("#search-outer").css(
        "top",
        $headerHeightSpace + extraHeight + secondaryHeader
      );
      $("#search-outer > #search #search-box").css(
        "top",
        $(window).height() / 2 -
          $("#search-outer > #search input").height() / 2 -
          $headerHeightSpace
      );
    }

    //text on hover effect
    $("body").on("mouseover", ".text_on_hover .product-wrap", function () {
      $(this).parent().addClass("hovered");
      //if($(this).find('.star-rating span').length > 0) $(this).find('.star-rating span').stop().animate({ width: $(this).find('.star-rating span').attr('data-width') },400,'easeOutCirc');
    });
    $("body").on("mouseover", ".text_on_hover > a:first-child", function () {
      $(this).parent().addClass("hovered");
    });

    $("body").on("mouseout", ".text_on_hover .product-wrap", function () {
      $(this).parent().removeClass("hovered");
      //if($(this).find('.star-rating span').length > 0) $(this).find('.star-rating span').stop().animate({ width: $(this).find('.star-rating span').attr('data-width') - 40 },500);
    });
    $("body").on("mouseout", ".text_on_hover > a:first-child", function () {
      $(this).parent().removeClass("hovered");
    });

    //material hover effect
    if ($(".material.product").length > 0) {
      $productZindex = 101;
      $("body").on("mouseenter", ".material.product", function () {
        $productZindex++;

        $(this).css("z-index", $productZindex + 1);
      });
      $("body").on("mouseleave", ".material.product", function () {
        var $that = $(this);
        setTimeout(function () {
          if (!$that.is(":hover")) $that.css("z-index", 100);
        }, 280);
      });

      //reset to stop zindex from getting too high
      setInterval(function () {
        $(".material.product:not(:hover)").css("z-index", 100);
        $productZindex = 101;
      }, 10000);
    }

    //mobile widget filters
    $("body").on(
      "click",
      "#sidebar .widget.woocommerce:not(.widget_price_filter) h4",
      function () {
        if ($(window).width() < 1000) {
          $(this).parent().find("> ul").slideToggle();
          $(this).parent().toggleClass("open-filter");
        }
      }
    );

    //slide in cart
    $("body").on(
      "mouseenter",
      '#header-outer [data-cart-style="slide_in"] .cart-menu-wrap',
      openRightCart
    );

    function openRightCart() {
      if ($(".nectar-slide-in-cart ul.cart_list li:not(.empty)").length > 0) {
        $(".nectar-slide-in-cart").addClass("open");

        $(window).on("mousemove.rightCartOffsetCheck", closeCartCheck);
      }
    }

    function closeCartCheck(e) {
      var $windowWidth = $(window).width();
      if (e.clientX < $windowWidth - 370 - $bodyBorderWidth) {
        $(window).off("mousemove.rightCartOffsetCheck", closeNavCheck);

        $(".nectar-slide-in-cart").removeClass("open");
      }
    }

    /***************** Search ******************/
    var $placeholder = $("#search input[type=text]").attr("data-placeholder");
    var logoHeight = parseInt($("#header-outer").attr("data-logo-height"));

    ////search box event
    $("body").on("click", "#search-btn a", function () {
      return false;
    });
    $("body").on("mousedown", "#search-btn a:not(.inactive)", function () {
      if ($(this).hasClass("open-search")) {
        return false;
      }

      if (
        $("body").hasClass("ascend") ||
        $('body[data-header-format="left-header"]').length > 0
      ) {
        $(
          "#search-outer > #search form, #search-outer #search .span_12 span"
        ).css("opacity", 0);
        $("#search-outer > #search form").css("bottom", "10px");
        $("#search-outer #search .span_12 span").css("top", "10px");
        $("#search-outer").show();
        $("#search-outer")
          .stop()
          .transition({ scale: "1,0", opacity: 1 }, 0)
          .transition({ scale: "1,1" }, 400, "easeInOutCubic");

        $("#search-outer > #search form")
          .delay(400)
          .animate({ opacity: 1, bottom: 0 }, "easeOutCirc");
        $("#search-outer #search .span_12 span")
          .delay(470)
          .animate({ opacity: 1, top: 0 }, "easeOutCirc");
      } else {
        $("#search-outer").stop(true).fadeIn(600, "easeOutExpo");
      }

      if ($('body[data-header-format="left-header"]').length == 0) {
        $('body:not(.ascend) #search-outer > #search input[type="text"]').css({
          top:
            $("#search-outer").height() / 2 -
            $('#search-outer > #search input[type="text"]').height() / 2,
        });
      }

      setTimeout(function () {
        $("#search input[type=text]").focus();

        if ($("#search input[type=text]").attr("value") == $placeholder) {
          $("#search input[type=text]").setCursorPosition(0);
        }
      }, 300);

      //ascend
      if (
        $("body").hasClass("ascend") ||
        $('body[data-header-format="left-header"]').length > 0
      ) {
        searchFieldCenter();
      }

      $(this).toggleClass("open-search");

      //close slide out widget area
      $(
        ".slide-out-widget-area-toggle a:not(#toggle-nav).open:not(.animating)"
      ).trigger("click");

      return false;
    });

    $("body").on("keydown", "#search input[type=text]", function () {
      if ($(this).attr("value") == $placeholder) {
        $(this).attr("value", "");
      }
    });

    $("body").on("keyup", "#search input[type=text]", function () {
      if ($(this).attr("value") == "") {
        $(this).attr("value", $placeholder);
        $(this).setCursorPosition(0);
      }
    });

    ////close search btn event
    $("body").on("click", "#close", function () {
      closeSearch();
      $("#search-btn a").removeClass("open-search");
      return false;
    });

    //if user clicks away from the search close it
    $("body").on("blur", "#search-box input[type=text]", function (e) {
      closeSearch();
      $("#search-btn a").removeClass("open-search");
    });

    function closeSearch() {
      if (
        $("body").hasClass("ascend") ||
        $('body[data-header-format="left-header"]').length > 0
      ) {
        $("#search-outer")
          .stop()
          .transition({ opacity: 0 }, 300, "easeOutCubic");
        $("#search-btn a").addClass("inactive");
        setTimeout(function () {
          $("#search-outer").hide();
          $("#search-btn a").removeClass("inactive");
        }, 300);
      } else {
        $("#search-outer").stop(true).fadeOut(450, "easeOutExpo");
      }
    }

    //mobile search
    $("body").on(
      "click",
      "#mobile-menu #mobile-search .container a#show-search",
      function () {
        $("#mobile-menu .container > ul").slideUp(500);
        return false;
      }
    );

    /***************** Nav ******************/

    function centeredLogoMargins() {
      if (
        $('#header-outer[data-format="centered-logo-between-menu"]').length >
          0 &&
        $(window).width() > 1000
      ) {
        $midnightSelector =
          $("#header-outer .midnightHeader").length > 0
            ? "> .midnightHeader:first-child"
            : "";
        var $navItemLength = $(
          '#header-outer[data-format="centered-logo-between-menu"] ' +
            $midnightSelector +
            " nav > .sf-menu > li"
        ).length;
        if ($("#header-outer #social-in-menu").length > 0) $navItemLength--;

        $centerLogoWidth =
          $("#header-outer .row .col.span_3 #logo img:visible").length == 0
            ? parseInt($("#header-outer .row .col.span_3").width())
            : parseInt($("#header-outer .row .col.span_3 img:visible").width());

        $extraMenuSpace =
          $('#header-outer[data-lhe="animated_underline"]').length > 0
            ? parseInt(
                $("#header-outer header#top nav > ul > li:first-child > a").css(
                  "margin-right"
                )
              )
            : parseInt(
                $("#header-outer header#top nav > ul > li:first-child > a").css(
                  "padding-right"
                )
              );

        if ($extraMenuSpace > 30) {
          $extraMenuSpace += 45;
        } else if ($extraMenuSpace > 20) {
          $extraMenuSpace += 40;
        } else {
          $extraMenuSpace += 30;
        }

        $(
          '#header-outer[data-format="centered-logo-between-menu"] nav > .sf-menu > li:nth-child(' +
            Math.floor($navItemLength / 2) +
            ")"
        )
          .css({ "margin-right": $centerLogoWidth + $extraMenuSpace + "px" })
          .addClass("menu-item-with-margin");
        $leftMenuWidth = 0;
        $rightMenuWidth = 0;
        $(
          '#header-outer[data-format="centered-logo-between-menu"] ' +
            $midnightSelector +
            " nav > .sf-menu > li:not(#social-in-menu)"
        ).each(function (i) {
          if (i + 1 <= Math.floor($navItemLength / 2)) {
            $leftMenuWidth += $(this).width();
          } else {
            $rightMenuWidth += $(this).width();
          }
        });

        $menuDiff = Math.abs($rightMenuWidth - $leftMenuWidth);

        if ($leftMenuWidth > $rightMenuWidth)
          $("#header-outer .row > .col.span_9").css("padding-right", $menuDiff);
        else
          $("#header-outer .row > .col.span_9").css("padding-left", $menuDiff);

        $('#header-outer[data-format="centered-logo-between-menu"] nav').css(
          "visibility",
          "visible"
        );
      }
    }

    var logoHeight = parseInt($("#header-outer").attr("data-logo-height"));
    var headerPadding = parseInt($("#header-outer").attr("data-padding"));
    var usingLogoImage = $("#header-outer").attr("data-using-logo");

    if (isNaN(headerPadding) || headerPadding.length == 0) {
      headerPadding = 28;
    }
    if (isNaN(logoHeight) || usingLogoImage.length == 0) {
      usingLogoImage = false;
      logoHeight = 30;
    }

    if ($("header#top nav > ul li#search-btn a").length > 0) {
      $searchBtnHeight = $("header#top nav > ul li#search-btn a").height();
    } else {
      $searchBtnHeight = 24;
    }

    //inital calculations
    function headerInit() {
      if ($('#header-outer[data-format="left-header"]').length > 0) return;

      $("#header-outer #logo img").css({
        height: logoHeight,
      });

      $(
        '#header-outer, .ascend #header-outer[data-full-width="true"][data-using-pr-menu="true"] header#top nav ul.buttons li.menu-item, .ascend #header-outer[data-full-width="true"][data-format="centered-menu"] header#top nav ul.buttons li#social-in-menu'
      ).css({
        "padding-top": headerPadding,
      });

      if ($("body.mobile").length == 0) {
        $("header#top nav > ul > li:not(#social-in-menu) > a").css({
          "padding-bottom": Math.floor(
            logoHeight / 2 -
              $("header#top nav > ul > li > a").height() / 2 +
              headerPadding
          ),
          "padding-top": Math.floor(
            logoHeight / 2 - $("header#top nav > ul > li > a").height() / 2
          ),
        });

        $("header#top nav > ul > li#social-in-menu > a").css({
          "margin-bottom": Math.floor(
            logoHeight / 2 -
              $("header#top nav > ul > li#social-in-menu > a i").height() / 2 +
              headerPadding
          ),
          "margin-top": Math.floor(
            logoHeight / 2 -
              $("header#top nav > ul > li#social-in-menu > a i").height() / 2
          ),
        });
      }

      if (
        $('#header-outer[data-format="centered-menu-under-logo"]').length == 0
      ) {
        $("#header-outer .cart-menu").css({
          "padding-bottom": Math.ceil(
            logoHeight / 2 - $searchBtnHeight / 2 + headerPadding
          ),
          "padding-top": Math.ceil(
            logoHeight / 2 - $searchBtnHeight / 2 + headerPadding
          ),
        });
      }

      $(
        "header#top nav > ul li#search-btn, header#top nav > ul li.slide-out-widget-area-toggle"
      ).css({
        "padding-bottom": logoHeight / 2 - $searchBtnHeight / 2,
        "padding-top": logoHeight / 2 - $searchBtnHeight / 2,
      });

      if (
        $("body.ascend ").length > 0 &&
        $('#header-outer[data-full-width="true"]').length > 0
      ) {
        $(
          "header#top nav > ul li#search-btn, header#top nav > ul li.slide-out-widget-area-toggle"
        ).css({
          "padding-top": 0,
          "padding-bottom": 0,
        });

        $("header#top nav > ul.buttons").css({
          "margin-top": -headerPadding,
          height: Math.floor(logoHeight + headerPadding * 2) - 1,
        });

        $(
          "header#top nav > ul li#search-btn a, header#top nav > ul li.slide-out-widget-area-toggle a"
        ).css({
          visibility: "visible",
          "padding-top": Math.floor(
            logoHeight / 2 - $searchBtnHeight / 2 + headerPadding
          ),
          "padding-bottom": Math.floor(
            logoHeight / 2 - $searchBtnHeight / 2 + headerPadding
          ),
        });
      }

      $(
        "header#top .sf-menu > li > ul, header#top .sf-menu > li.sfHover > ul"
      ).css({
        top: $("header#top nav > ul.sf-menu > li > a").outerHeight(),
      });

      setTimeout(function () {
        $("body:not(.ascend) #search-outer #search-box .ui-autocomplete").css({
          top: parseInt($("#header-outer").outerHeight()) + "px",
        });
      }, 1000);

      $("body:not(.ascend) #search-outer #search-box .ui-autocomplete").css({
        top: parseInt($("#header-outer").outerHeight()) + "px",
      });

      //header space
      if ($(".nectar-parallax-scene.first-section").length == 0) {
        if ($("#header-outer").attr("data-using-secondary") == "1") {
          if (
            $('#header-outer[data-mobile-fixed="false"]').length > 0 ||
            $("body.mobile").length == 0
          ) {
            $("#header-space").css(
              "height",
              parseInt($("#header-outer").outerHeight()) +
                $("#header-secondary-outer").height()
            );
          } else {
            $("#header-space").css(
              "height",
              parseInt($("#header-outer").outerHeight())
            );
          }
        } else {
          $("#header-space").css("height", $("#header-outer").outerHeight());
        }
      }

      $("#header-outer .container, #header-outer .cart-menu").css(
        "visibility",
        "visible"
      );

      centeredLogoMargins();

      if (
        usingLogoImage &&
        $('#header-outer[data-format="centered-logo-between-menu"]').length >
          0 &&
        $("header#top #logo img:first-child[src]").length > 0
      ) {
        //fadein img on load
        var tempLogoImg = new Image();
        tempLogoImg.src = $("header#top #logo img:first-child").attr("src");

        tempLogoImg.onload = function () {
          centeredLogoMargins();
        };
      }

      if (
        $('#header-outer[data-format="centered-menu-under-logo"]').length == 0
      ) {
        $("body:not(.ascend) #search-outer, #search .container").css({
          height: logoHeight + headerPadding * 2,
        });

        $('body:not(.ascend) #search-outer > #search input[type="text"]').css({
          "font-size": 43,
          height: "59px",
          top:
            (logoHeight + headerPadding * 2) / 2 -
            $('#search-outer > #search input[type="text"]').height() / 2,
        });

        $("body:not(.ascend) #search-outer > #search #close a").css({
          top: (logoHeight + headerPadding * 2) / 2 - 8,
        });
      } else {
        $("body:not(.ascend) #search-outer, #search .container").css({
          height: logoHeight + headerPadding * 2 + logoHeight + 17,
        });

        $('body:not(.ascend) #search-outer > #search input[type="text"]').css({
          "font-size": 43,
          height: "59px",
          top:
            (logoHeight + headerPadding * 2) / 2 -
            $('#search-outer > #search input[type="text"]').height() / 2 +
            logoHeight / 2 +
            17,
        });

        $("body:not(.ascend) #search-outer > #search #close a").css({
          top: (logoHeight + headerPadding * 2) / 2 - 8 + logoHeight / 2 + 17,
        });
      }

      //if no image is being used
      //if(usingLogoImage == false) $('header#top #logo').addClass('no-image');
    }

    //one last check to make sure the header space is correct (only if the user hasn't scrolled yet)
    $(window).load(function () {
      if ($(window).scrollTop() == 0) headerSpace();
    });

    //is header resize on scroll enabled?
    var headerResize = $("#header-outer").attr("data-header-resize");
    var headerHideUntilNeeded = $("body").attr("data-hhun");

    //transparent fix

    if ($('#header-outer[data-remove-fixed="1"]').length == 0) {
      if (
        $(window).scrollTop() != 0 &&
        $('#header-outer.transparent[data-permanent-transparent="false"]')
          .length == 1
      )
        $("#header-outer").removeClass("transparent");
    }

    if (headerResize == 1 && headerHideUntilNeeded != "1") {
      headerInit();

      $(window).off("scroll.headerResizeEffect");

      if ($("#nectar_fullscreen_rows").length == 0) {
        $(window).on("scroll.headerResizeEffect", smallNav);
      } else if (
        $('#nectar_fullscreen_rows[data-mobile-disable="on"]').length > 0 &&
        navigator.userAgent.match(
          /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
        )
      ) {
        $(window).on("scroll.headerResizeEffect", smallNav);
      }
    } else if (headerHideUntilNeeded != "1") {
      headerInit();
      $(window).off("scroll.headerResizeEffectOpaque");
      $(window).on("scroll.headerResizeEffectOpaque", opaqueCheck);
    } else if (headerHideUntilNeeded == "1") {
      headerInit();

      if ($(".nectar-box-roll").length > 0)
        $("#header-outer").addClass("at-top-before-box");

      var previousScroll = 0, // previous scroll position
        menuOffset = $("#header-space").height() * 2, // height of menu (once scroll passed it, menu is hidden)
        detachPoint = $("body.mobile").length > 0 ? 150 : 600, // point of detach (after scroll passed it, menu is fixed)
        hideShowOffset = 6; // scrolling value after which triggers hide/show menu

      // on scroll hide/show menu
      function hhunCalcs(e) {
        //stop scrolling while animated anchors
        if (
          $("body.animated-scrolling").length > 0 &&
          $("#header-outer.detached").length > 0
        )
          return false;

        //stop on mobile if not using sticky option
        if (
          $('#header-outer[data-mobile-fixed="false"]').length > 0 &&
          $("body.mobile").length > 0
        ) {
          $("#header-outer").removeClass("detached");
          return false;
        }

        var currentScroll = $(this).scrollTop(), // gets current scroll position
          scrollDifference = Math.abs(currentScroll - previousScroll); // calculates how fast user is scrolling

        if (
          !$("#header-outer").hasClass("side-widget-open") &&
          !$("#header-outer .slide-out-widget-area-toggle a").hasClass(
            "animating"
          )
        ) {
          // if scrolled past menu
          if (currentScroll > menuOffset) {
            // if scrolled past detach point add class to fix menu
            if (currentScroll > detachPoint) {
              if (!$("#header-outer").hasClass("detached"))
                $("#header-outer")
                  .addClass("detached")
                  .removeClass("parallax-contained");
              $("#header-outer").removeClass("no-transition");

              if (
                $('#header-outer[data-permanent-transparent="1"]').length == 0
              )
                $("#header-outer").removeClass("transparent");
            }

            // if scrolling faster than hideShowOffset hide/show menu
            if (scrollDifference >= hideShowOffset) {
              if (currentScroll > previousScroll) {
                // scrolling down; hide menu
                if (!$("#header-outer").hasClass("invisible")) {
                  $("#header-outer")
                    .addClass("invisible")
                    .removeClass("at-top");

                  //close submenus
                  if ($(".sf-menu").length > 0 && $().superfish) {
                    $(".sf-menu").superfish("hide");
                    $(
                      "header#top nav > ul.sf-menu > li.menu-item-over"
                    ).removeClass("menu-item-over");
                  }
                }
                $(".page-submenu.stuck")
                  .css("transform", "translateY(0px)")
                  .addClass("header-not-visible");
              } else {
                // scrolling up; show menu
                if ($("#header-outer").hasClass("invisible"))
                  $("#header-outer").removeClass("invisible");

                if (
                  $(".body-border-top").length > 0 &&
                  $("body.mobile").length == 0
                ) {
                  var $bodyBorderHeaderColorMatch =
                    ($(".body-border-top").css("background-color") ==
                      "#ffffff" &&
                      $("body").attr("data-header-color") == "light") ||
                    $(".body-border-top").css("background-color") ==
                      $("#header-outer").attr("data-user-set-bg")
                      ? true
                      : false;
                  var $bodyBorderSizeToRemove = $bodyBorderHeaderColorMatch
                    ? $(".body-border-top").height()
                    : 0;
                  $(".page-submenu.stuck")
                    .css(
                      "transform",
                      "translateY(" +
                        ($("#header-outer").outerHeight() -
                          $bodyBorderSizeToRemove) +
                        "px)"
                    )
                    .removeClass("header-not-visible");
                } else {
                  $(".page-submenu.stuck")
                    .css(
                      "transform",
                      "translateY(" + $("#header-outer").outerHeight() + "px)"
                    )
                    .removeClass("header-not-visible");
                }
              }
            }
          } else {
            // only remove "detached" class if user is at the top of document (menu jump fix)
            $topDetachNum =
              $('#header-outer[data-using-secondary="1"]').length > 0 ? 32 : 0;
            if ($(".body-border-top").length > 0) {
              $topDetachNum =
                $('#header-outer[data-using-secondary="1"]').length > 0
                  ? 32 + $(".body-border-top").height()
                  : $(".body-border-top").height();
            }

            if (currentScroll <= $topDetachNum) {
              $("#header-outer").removeClass("detached").addClass("at-top");

              if (
                $('#header-outer[data-megamenu-rt="1"]').length > 0 &&
                $('#header-outer[data-transparent-header="true"]').length > 0 &&
                $("#header-outer .megamenu").length > 0
              ) {
                if (
                  $('#header-outer[data-transparent-header="true"]').length >
                    0 &&
                  $(".nectar-box-roll").length == 0 &&
                  $(".megamenu.sfHover").length == 0
                ) {
                  $("#header-outer")
                    .addClass("transparent")
                    .css("transform", "translateY(0)");
                  $("#header-outer").removeClass("no-transition");
                } else if ($(".nectar-box-roll").length > 0)
                  $("#header-outer")
                    .css("transform", "translateY(0)")
                    .addClass("at-top-before-box");
              } else {
                if (
                  $('#header-outer[data-transparent-header="true"]').length >
                    0 &&
                  $(".nectar-box-roll").length == 0
                )
                  $("#header-outer")
                    .addClass("transparent")
                    .css("transform", "translateY(0)");
                else if ($(".nectar-box-roll").length > 0)
                  $("#header-outer")
                    .css("transform", "translateY(0)")
                    .addClass("at-top-before-box");
              }

              if (
                $(".parallax_slider_outer").length > 0 ||
                $('#page-header-bg[data-parallax="1"]').length > 0
              )
                $("#header-outer")
                  .addClass("parallax-contained")
                  .css("transform", "translateY(0)");
            }
          }

          // if user is at the bottom of document show menu
          if (
            window.innerHeight + window.scrollY >=
            document.body.offsetHeight
          ) {
            $("#header-outer").removeClass("invisible");

            if (
              $(".body-border-top").length > 0 &&
              $("body.mobile").length == 0
            ) {
              var $bodyBorderHeaderColorMatch =
                ($(".body-border-top").css("background-color") == "#ffffff" &&
                  $("body").attr("data-header-color") == "light") ||
                $(".body-border-top").css("background-color") ==
                  $("#header-outer").attr("data-user-set-bg")
                  ? true
                  : false;
              var $bodyBorderSizeToRemove = $bodyBorderHeaderColorMatch
                ? $(".body-border-top").height()
                : 0;
              $(".page-submenu.stuck")
                .css(
                  "transform",
                  "translateY(" +
                    ($("#header-outer").outerHeight() -
                      $bodyBorderSizeToRemove) +
                    "px)"
                )
                .removeClass("header-not-visible");
            } else {
              $(".page-submenu.stuck")
                .css(
                  "transform",
                  "translateY(" + $("#header-outer").outerHeight() + "px)"
                )
                .removeClass("header-not-visible");
            }
          }
        }

        // replace previous scroll position with new one
        previousScroll = currentScroll;
      }

      //don't trigger for header remove stickiness
      if ($('#header-outer[data-remove-fixed="1"]').length == 0) {
        hhunCalcs();
        $(window).scroll(hhunCalcs);
      }
    } //end if hhun

    if ($("#nectar_fullscreen_rows").length == 0)
      midnightInit(); //init midnight
    else $("#header-outer").attr("data-permanent-transparent", "false");

    var shrinkNum = 6;
    var extraHeight =
      $("#wpadminbar").length > 0 ? $("#wpadminbar").height() : 0; //admin bar
    var $bodyBorderHeaderColorMatch =
      ($(".body-border-top").css("background-color") == "#ffffff" &&
        $("body").attr("data-header-color") == "light") ||
      $(".body-border-top").css("background-color") ==
        $("#header-outer").attr("data-user-set-bg")
        ? true
        : false;
    if ($("#header-outer[data-shrink-num]").length > 0)
      shrinkNum = $("#header-outer").attr("data-shrink-num");

    function smallNav() {
      var $offset = $(window).scrollTop();
      var $windowWidth = $(window).width();

      if ($offset > 0 && $windowWidth > 1000) {
        if (
          $('#header-outer[data-megamenu-rt="1"]').length > 0 &&
          $('#header-outer[data-transparent-header="true"]').length > 0 &&
          $("#header-outer .megamenu").length > 0
        ) {
          if (
            $("#header-outer").attr("data-transparent-header") == "true" &&
            $("#header-outer.side-widget-open").length == 0 &&
            $('#header-outer[data-permanent-transparent="1"]').length == 0 &&
            $(".megamenu.sfHover").length == 0
          ) {
            $("#header-outer").removeClass("transparent");
            $("#header-outer").removeClass("no-transition");
          }
        } else {
          if (
            $("#header-outer").attr("data-transparent-header") == "true" &&
            $("#header-outer.side-widget-open").length == 0 &&
            $('#header-outer[data-permanent-transparent="1"]').length == 0
          )
            $("#header-outer").removeClass("transparent");
        }

        $(".ns-loading-cover").hide();

        $("#header-outer, #search-outer").addClass("small-nav");

        $("#header-outer #logo img")
          .stop(true, true)
          .animate(
            {
              height: logoHeight - shrinkNum,
            },
            { queue: false, duration: 250, easing: "easeOutCubic" }
          );

        $(
          '#header-outer, .ascend #header-outer[data-full-width="true"][data-using-pr-menu="true"] header#top nav ul.buttons li.menu-item, .ascend #header-outer[data-full-width="true"][data-format="centered-menu"] header#top nav ul.buttons li#social-in-menu'
        )
          .stop(true, true)
          .animate(
            {
              "padding-top": Math.ceil(headerPadding / 1.8),
            },
            { queue: false, duration: 250, easing: "easeOutCubic" }
          );

        if (
          $('#header-outer[data-format="centered-menu-under-logo"]').length > 0
        ) {
          $("#header-outer .row > .span_3")
            .stop(true, true)
            .animate(
              {
                "padding-bottom": Math.ceil(headerPadding / 1.8),
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        }

        $("header#top nav > ul > li:not(#social-in-menu) > a")
          .stop(true, true)
          .animate(
            {
              "padding-bottom": Math.floor(
                (logoHeight - shrinkNum) / 2 -
                  $("header#top nav > ul > li > a").height() / 2 +
                  headerPadding / 1.8
              ),
              "padding-top": Math.floor(
                (logoHeight - shrinkNum) / 2 -
                  $("header#top nav > ul > li > a").height() / 2
              ),
            },
            { queue: false, duration: 250, easing: "easeOutCubic" }
          );

        //body border full width side padding
        if (
          $(
            '#header-outer[data-full-width="true"][data-transparent-header="true"]'
          ).length > 0 &&
          $(".body-border-top").length > 0 &&
          $bodyBorderHeaderColorMatch == true
        ) {
          $('#header-outer[data-full-width="true"] header > .container')
            .stop(true, true)
            .animate(
              {
                padding: "0",
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        }

        $("header#top nav > ul > li#social-in-menu > a")
          .stop(true, true)
          .animate(
            {
              "margin-bottom": Math.floor(
                (logoHeight - shrinkNum) / 2 -
                  $("header#top nav > ul > li#social-in-menu > a").height() /
                    2 +
                  headerPadding / 1.8
              ),
              "margin-top": Math.floor(
                (logoHeight - shrinkNum) / 2 -
                  $("header#top nav > ul > li#social-in-menu > a").height() / 2
              ),
            },
            { queue: false, duration: 250, easing: "easeOutCubic" }
          );

        $("header#top nav > ul > li.menu-item-with-margin")
          .stop(true, true)
          .animate(
            {
              "margin-right":
                parseInt(
                  $("header#top nav > ul > li.menu-item-with-margin").css(
                    "margin-right"
                  )
                ) -
                parseInt(shrinkNum) * 3 +
                "px",
            },
            { queue: false, duration: 250, easing: "easeOutCubic" }
          );

        if ($bodyBorderHeaderColorMatch == true) {
          $(".body-border-top")
            .stop(true, true)
            .animate(
              {
                "margin-top": "-" + $(".body-border-top").height() + "px",
              },
              {
                queue: false,
                duration: 400,
                easing: "easeOutCubic",
                complete: function () {
                  $(this).css("margin-top", 0);
                },
              }
            );
        }

        if (
          $('#header-outer[data-format="centered-menu-under-logo"]').length == 0
        ) {
          $("#header-outer .cart-menu")
            .stop(true, true)
            .animate(
              {
                "padding-top": Math.ceil(
                  (logoHeight - shrinkNum) / 2 -
                    $searchBtnHeight / 2 +
                    headerPadding / 1.7
                ),
                "padding-bottom":
                  Math.ceil(
                    (logoHeight - shrinkNum) / 2 -
                      $searchBtnHeight / 2 +
                      headerPadding / 1.7
                  ) + 1,
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        }

        if (
          $("body.ascend ").length > 0 &&
          $('#header-outer[data-full-width="true"]').length > 0
        ) {
          $("header#top nav > ul.buttons")
            .stop(true, true)
            .animate(
              {
                "margin-top": -Math.ceil(headerPadding / 1.8),
                height: Math.floor(
                  (headerPadding * 2) / 1.8 + logoHeight - shrinkNum
                ),
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );

          $(
            "header#top nav > ul li#search-btn a, header#top nav > ul li.slide-out-widget-area-toggle a"
          )
            .stop(true, true)
            .animate(
              {
                "padding-top": Math.ceil(
                  (logoHeight - shrinkNum) / 2 -
                    $searchBtnHeight / 2 +
                    headerPadding / 1.7
                ),
                "padding-bottom":
                  Math.ceil(
                    (logoHeight - shrinkNum) / 2 -
                      $searchBtnHeight / 2 +
                      headerPadding / 1.7
                  ) + 1,
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        } else {
          $(
            "header#top nav > ul li#search-btn, header#top nav > ul li.slide-out-widget-area-toggle"
          )
            .stop(true, true)
            .animate(
              {
                "padding-bottom": Math.ceil(
                  (logoHeight - shrinkNum) / 2 - $searchBtnHeight / 2
                ),
                "padding-top": Math.ceil(
                  (logoHeight - shrinkNum) / 2 - $searchBtnHeight / 2
                ),
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        }

        if (
          $('#header-outer[data-format="centered-menu-under-logo"]').length > 0
        ) {
          $(
            "header#top .sf-menu > li > ul, header#top .sf-menu > li.sfHover > ul"
          )
            .stop(true, true)
            .animate(
              {
                top: Math.floor(
                  $("header#top nav > ul > li > a").outerHeight()
                ),
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        } else {
          $(
            "header#top .sf-menu > li > ul, header#top .sf-menu > li.sfHover > ul"
          )
            .stop(true, true)
            .animate(
              {
                top: Math.floor(
                  $("header#top nav > ul > li > a").height() +
                    ((logoHeight - shrinkNum) / 2 -
                      $("header#top nav > ul > li > a").height() / 2) *
                      2 +
                    headerPadding / 1.8
                ),
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        }

        $("body:not(.ascend) #search-outer #search-box .ui-autocomplete")
          .stop(true, true)
          .animate(
            {
              top:
                Math.floor(logoHeight - shrinkNum + (headerPadding * 2) / 1.8) +
                "px",
            },
            { queue: false, duration: 250, easing: "easeOutCubic" }
          );

        if (
          $('#header-outer[data-format="centered-menu-under-logo"]').length == 0
        ) {
          $("body:not(.ascend) #search-outer, #search .container")
            .stop(true, true)
            .animate(
              {
                height: Math.floor(
                  logoHeight - shrinkNum + (headerPadding * 2) / 1.8
                ),
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );

          $('body:not(.ascend) #search-outer > #search input[type="text"]')
            .stop(true, true)
            .animate(
              {
                "font-size": 30,
                "line-height": "30px",
                height: "44px",
                top:
                  (logoHeight - shrinkNum + headerPadding + 5) / 2 -
                  ($('#search-outer > #search input[type="text"]').height() -
                    15) /
                    2,
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );

          $("body:not(.ascend) #search-outer > #search #close a")
            .stop(true, true)
            .animate(
              {
                top: (logoHeight - shrinkNum + headerPadding + 5) / 2 - 10,
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        } else {
          $("body:not(.ascend) #search-outer, #search .container")
            .stop(true, true)
            .animate(
              {
                height:
                  Math.floor(
                    logoHeight - shrinkNum + (headerPadding * 2) / 1.8
                  ) +
                  logoHeight -
                  shrinkNum +
                  17,
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );

          $('body:not(.ascend) #search-outer > #search input[type="text"]')
            .stop(true, true)
            .animate(
              {
                "font-size": 30,
                "line-height": "30px",
                height: "44px",
                top:
                  (logoHeight - shrinkNum + headerPadding + 5) / 2 -
                  ($('#search-outer > #search input[type="text"]').height() -
                    15) /
                    2 +
                  (logoHeight - shrinkNum) / 2 +
                  8,
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );

          $("body:not(.ascend) #search-outer > #search #close a")
            .stop(true, true)
            .animate(
              {
                top:
                  (logoHeight - shrinkNum + headerPadding + 5) / 2 -
                  10 +
                  (logoHeight - shrinkNum) / 2 +
                  8,
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        }

        //box roll
        if (
          $(".nectar-box-roll").length > 0 &&
          $('#header-outer[data-permanent-transparent="1"]').length == 0
        )
          $("#ajax-content-wrap").animate(
            {
              "margin-top": Math.floor(
                logoHeight -
                  shrinkNum +
                  (headerPadding * 2) / 1.8 +
                  extraHeight +
                  secondaryHeader
              ),
            },
            { queue: false, duration: 250, easing: "easeOutCubic" }
          );

        if ($("body").hasClass("ascend")) {
          $("#search-outer")
            .stop(true, true)
            .animate(
              {
                top: Math.floor(
                  logoHeight -
                    shrinkNum +
                    (headerPadding * 2) / 1.8 +
                    extraHeight +
                    secondaryHeader
                ),
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        }

        //if no image is being used
        if (usingLogoImage == false)
          $("header#top #logo").stop(true, true).animate(
            {
              "margin-top": 0,
            },
            { queue: false, duration: 450, easing: "easeOutExpo" }
          );

        $(window).off("scroll", smallNav);
        $(window).on("scroll", bigNav);

        //dark slider coloring border fix
        $('#header-outer[data-transparent-header="true"]').css(
          "transition",
          "background-color 0.30s ease, box-shadow 0.30s ease, margin 0.25s ease-out"
        );
        $('#header-outer[data-transparent-header="true"] .cart-menu').css(
          "transition",
          "none"
        );
        setTimeout(function () {
          $('#header-outer[data-transparent-header="true"]').css(
            "transition",
            "background-color 0.30s ease, box-shadow 0.30s ease, border-color 0.30s ease, margin 0.25s ease-out"
          );
          $('#header-outer[data-transparent-header="true"] .cart-menu').css(
            "transition",
            "border-color 0.30s ease"
          );
        }, 300);
      }
    }

    function bigNav() {
      var $offset = $(window).scrollTop();
      var $windowWidth = $(window).width();

      if (
        ($offset == 0 && $windowWidth > 1000) ||
        ($(".small-nav").length > 0 &&
          $("#ajax-content-wrap.no-scroll").length > 0)
      ) {
        $("#header-outer, #search-outer").removeClass("small-nav");

        if (
          $('#header-outer[data-megamenu-rt="1"]').length > 0 &&
          $('#header-outer[data-transparent-header="true"]').length > 0 &&
          $("#header-outer .megamenu").length > 0
        ) {
          if (
            $("#header-outer").attr("data-transparent-header") == "true" &&
            $(".nectar-box-roll").length == 0 &&
            $(".megamenu.sfHover").length == 0
          ) {
            $("#header-outer").addClass("transparent");
            $("#header-outer").removeClass("no-transition");
          }
        } else {
          if (
            $("#header-outer").attr("data-transparent-header") == "true" &&
            $(".nectar-box-roll").length == 0
          )
            $("#header-outer").addClass("transparent");
        }

        $(".ns-loading-cover").show();

        $("#header-outer #logo img").stop(true, true).animate(
          {
            height: logoHeight,
          },
          { queue: false, duration: 250, easing: "easeOutCubic" }
        );

        //body border full width side padding
        if (
          $(
            '#header-outer[data-full-width="true"][data-transparent-header="true"]'
          ).length > 0 &&
          $(".body-border-top").length > 0 &&
          $bodyBorderHeaderColorMatch == true
        ) {
          $('#header-outer[data-full-width="true"] header > .container')
            .stop(true, true)
            .animate(
              {
                padding: "0 28px",
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        }

        $(
          '#header-outer, .ascend #header-outer[data-full-width="true"][data-using-pr-menu="true"] header#top nav ul.buttons li.menu-item, .ascend #header-outer[data-full-width="true"][data-format="centered-menu"] header#top nav ul.buttons li#social-in-menu'
        )
          .stop(true, true)
          .animate(
            {
              "padding-top": headerPadding,
            },
            { queue: false, duration: 250, easing: "easeOutCubic" }
          );

        if (
          $('#header-outer[data-format="centered-menu-under-logo"]').length > 0
        ) {
          $("#header-outer .row > .span_3").stop(true, true).animate(
            {
              "padding-bottom": headerPadding,
            },
            { queue: false, duration: 250, easing: "easeOutCubic" }
          );
        }

        $("header#top nav > ul > li:not(#social-in-menu) > a")
          .stop(true, true)
          .animate(
            {
              "padding-bottom":
                logoHeight / 2 -
                $("header#top nav > ul > li > a").height() / 2 +
                headerPadding,
              "padding-top":
                logoHeight / 2 - $("header#top nav > ul > li > a").height() / 2,
            },
            { queue: false, duration: 250, easing: "easeOutCubic" }
          );

        $("header#top nav > ul > li#social-in-menu > a")
          .stop(true, true)
          .animate(
            {
              "margin-bottom":
                logoHeight / 2 -
                $("header#top nav > ul > li#social-in-menu > a").height() / 2 +
                headerPadding,
              "margin-top":
                logoHeight / 2 -
                $("header#top nav > ul > li#social-in-menu > a").height() / 2,
            },
            { queue: false, duration: 250, easing: "easeOutCubic" }
          );

        $("header#top nav > ul > li.menu-item-with-margin")
          .stop(true, true)
          .animate(
            {
              "margin-right":
                parseInt(
                  $("header#top nav > ul > li.menu-item-with-margin").css(
                    "margin-right"
                  )
                ) +
                parseInt(shrinkNum) * 3 +
                "px",
            },
            { queue: false, duration: 250, easing: "easeOutCubic" }
          );

        if ($bodyBorderHeaderColorMatch == true) {
          $(".body-border-top")
            .css({ "margin-top": "-" + $(".body-border-top").height() + "px" })
            .stop(true, true)
            .animate(
              {
                "margin-top": "0",
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        }

        if (
          $('#header-outer[data-format="centered-menu-under-logo"]').length == 0
        ) {
          $("#header-outer .cart-menu")
            .stop(true, true)
            .animate(
              {
                "padding-bottom": Math.ceil(
                  logoHeight / 2 - $searchBtnHeight / 2 + headerPadding
                ),
                "padding-top": Math.ceil(
                  logoHeight / 2 - $searchBtnHeight / 2 + headerPadding
                ),
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        }

        if (
          $("body.ascend ").length > 0 &&
          $('#header-outer[data-full-width="true"]').length > 0
        ) {
          $("header#top nav > ul.buttons")
            .stop(true, true)
            .animate(
              {
                "margin-top": -Math.ceil(headerPadding),
                height: Math.floor(headerPadding * 2 + logoHeight) - 1,
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );

          $(
            "header#top nav > ul li#search-btn a, header#top nav > ul li.slide-out-widget-area-toggle a"
          )
            .stop(true, true)
            .animate(
              {
                "padding-top": Math.floor(
                  logoHeight / 2 - $searchBtnHeight / 2 + headerPadding
                ),
                "padding-bottom": Math.floor(
                  logoHeight / 2 - $searchBtnHeight / 2 + headerPadding
                ),
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        } else {
          $(
            "header#top nav > ul li#search-btn, header#top nav > ul li.slide-out-widget-area-toggle"
          )
            .stop(true, true)
            .animate(
              {
                "padding-bottom": Math.floor(
                  logoHeight / 2 - $searchBtnHeight / 2
                ),
                "padding-top": Math.ceil(logoHeight / 2 - $searchBtnHeight / 2),
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        }

        if (
          $('#header-outer[data-format="centered-menu-under-logo"]').length > 0
        ) {
          $(
            "header#top .sf-menu > li > ul, header#top .sf-menu > li.sfHover > ul"
          )
            .stop(true, true)
            .animate(
              {
                top: Math.floor(
                  $("header#top nav > ul > li > a").outerHeight()
                ),
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        } else {
          $(
            "header#top .sf-menu > li > ul, header#top .sf-menu > li.sfHover > ul"
          )
            .stop(true, true)
            .animate(
              {
                top: Math.ceil(
                  $("header#top nav > ul > li > a").height() +
                    (logoHeight / 2 -
                      $("header#top nav > ul > li > a").height() / 2) *
                      2 +
                    headerPadding
                ),
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        }

        $("body:not(.ascend) #search-outer #search-box .ui-autocomplete")
          .stop(true, true)
          .animate(
            {
              top: Math.ceil(logoHeight + headerPadding * 2) + "px",
            },
            { queue: false, duration: 250, easing: "easeOutCubic" }
          );

        if (
          $('#header-outer[data-format="centered-menu-under-logo"]').length == 0
        ) {
          $("body:not(.ascend) #search-outer, #search .container")
            .stop(true, true)
            .animate(
              {
                height: Math.ceil(logoHeight + headerPadding * 2),
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );

          $('body:not(.ascend) #search-outer > #search input[type="text"]')
            .stop(true, true)
            .animate(
              {
                "font-size": 43,
                "line-height": "43px",
                height: "59px",
                top: (logoHeight + headerPadding * 2) / 2 - 30,
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );

          $("body:not(.ascend) #search-outer > #search #close a")
            .stop(true, true)
            .animate(
              {
                top: (logoHeight + headerPadding * 2) / 2 - 8,
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        } else {
          $("body:not(.ascend) #search-outer, #search .container")
            .stop(true, true)
            .animate(
              {
                height:
                  Math.ceil(logoHeight + headerPadding * 2) + logoHeight + 17,
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );

          $('body:not(.ascend) #search-outer > #search input[type="text"]')
            .stop(true, true)
            .animate(
              {
                "font-size": 43,
                "line-height": "43px",
                height: "59px",
                top:
                  (logoHeight + headerPadding * 2) / 2 -
                  30 +
                  logoHeight / 2 +
                  8,
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );

          $("body:not(.ascend) #search-outer > #search #close a")
            .stop(true, true)
            .animate(
              {
                top:
                  (logoHeight + headerPadding * 2) / 2 - 8 + logoHeight / 2 + 8,
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        }

        if ($("body").hasClass("ascend")) {
          $("#search-outer")
            .stop(true, true)
            .animate(
              {
                top:
                  logoHeight +
                  headerPadding * 2 +
                  extraHeight +
                  secondaryHeader,
              },
              { queue: false, duration: 250, easing: "easeOutCubic" }
            );
        }

        //if no image is being used
        if (usingLogoImage == false)
          $("header#top #logo").stop(true, true).animate(
            {
              "margin-top": 4,
            },
            { queue: false, duration: 450, easing: "easeOutExpo" }
          );

        //box roll
        if (
          $(".nectar-box-roll").length > 0 &&
          $('#header-outer[data-permanent-transparent="1"]').length == 0
        )
          $("#ajax-content-wrap").animate(
            {
              "margin-top": Math.floor(
                logoHeight + headerPadding * 2 + extraHeight + secondaryHeader
              ),
            },
            { queue: false, duration: 250, easing: "easeOutCubic" }
          );

        $(window).off("scroll", bigNav);
        $(window).on("scroll", smallNav);

        //dark slider coloring border fix
        $('#header-outer[data-transparent-header="true"]').css(
          "transition",
          "background-color 0.30s ease, box-shadow 0.30s ease, margin 0.25s ease-out"
        );
        $('#header-outer[data-transparent-header="true"] .cart-menu').css(
          "transition",
          "none"
        );
        setTimeout(function () {
          $('#header-outer[data-transparent-header="true"]').css(
            "transition",
            "background-color 0.30s ease, box-shadow 0.30s ease, border-color 0.30s ease, margin 0.25s ease-out"
          );
          $('#header-outer[data-transparent-header="true"] .cart-menu').css(
            "transition",
            "border-color 0.30s ease"
          );
        }, 300);
      }
    }

    function headerSpace() {
      if ($(".mobile").length > 0) {
        if (
          window.innerHeight < window.innerWidth &&
          window.innerWidth > 1000
        ) {
          if ($("#header-outer.small-nav").length == 0)
            $("#header-space").css(
              "height",
              $("#header-outer").outerHeight() +
                $("#header-secondary-outer").height()
            );
        } else {
          $("#header-space").css("height", $("#header-outer").outerHeight());
        }
      } else {
        if ($(".nectar-parallax-scene.first-section").length == 0) {
          var shrinkNum = 6;
          var headerPadding = parseInt($("#header-outer").attr("data-padding"));
          if ($("#header-outer[data-shrink-num]").length > 0)
            shrinkNum = $("#header-outer").attr("data-shrink-num");
          var headerPadding2 = headerPadding - headerPadding / 1.8;
          var $headerHeight =
            $('#header-outer[data-header-resize="1"]').length > 0 &&
            $(".small-nav").length > 0
              ? $("#header-outer").outerHeight() +
                (parseInt(shrinkNum) + headerPadding2 * 2)
              : $("#header-outer").outerHeight();

          if ($("#header-outer").attr("data-using-secondary") == "1") {
            $("#header-space").css(
              "height",
              $headerHeight + $("#header-secondary-outer").height()
            );
          } else {
            $("#header-space").css("height", $headerHeight);
          }
        }
      }
    }

    //call immediately on mobile to make sure there's no gap with fixed setups
    if (
      navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|IEMobile|BlackBerry|Opera Mini)/
      ) &&
      $('#header-outer[data-mobile-fixed="1"]').length > 0 &&
      $('#header-outer[data-permanent-transparent="false"]').length > 0
    ) {
      $("#header-space").css("height", $("#header-outer").outerHeight());
    }

    var lastPosition = -1;
    function headerOffsetAdjust() {
      var $scrollTop = $(window).scrollTop();

      if (lastPosition == $scrollTop) {
        requestAnimationFrame(headerOffsetAdjust);
        return false;
      } else lastPosition = $scrollTop;

      headerOffsetAdjustCalc();

      requestAnimationFrame(headerOffsetAdjust);
    }

    function headerOffsetAdjustCalc() {
      if ($("body.mobile").length > 0) {
        var $eleHeight = 0;
        var $endOffset =
          $("#wpadminbar").css("position") == "fixed"
            ? $("#wpadminbar").height()
            : 0;
        if ($("#header-secondary-outer").length > 0)
          $eleHeight += $("#header-secondary-outer").height();
        if ($("#wpadminbar").length > 0)
          $eleHeight += $("#wpadminbar").height();

        if ($eleHeight - $scrollTop > $endOffset) {
          $("#header-outer").css("top", $eleHeight - $scrollTop + "px");
        } else {
          $("#header-outer").css("top", $endOffset);
        }
      } else {
        var $eleHeight = 0;
        if ($("#header-secondary-outer").length > 0)
          $eleHeight += $("#header-secondary-outer").height();
        if ($("#wpadminbar").length > 0)
          $eleHeight += $("#wpadminbar").height();
        $("#header-outer").css("top", $eleHeight + "px");
      }
    }

    if (
      ($('#header-outer[data-mobile-fixed="1"]').length > 0 &&
        $("#wpadminbar").length > 0) ||
      ($('#header-outer[data-mobile-fixed="1"]').length > 0 &&
        $("#header-secondary-outer").length > 0)
    ) {
      if ($("#nectar_fullscreen_rows").length == 0) {
        requestAnimationFrame(headerOffsetAdjust);
      } else if ($("#nectar_fullscreen_rows").length > 0 && $onMobileBrowser) {
        requestAnimationFrame(headerOffsetAdjust);
      }
      $(window).smartresize(headerOffsetAdjustCalc);
    }

    function footerRevealCalcs() {
      var $headerNavSpace =
        $('body[data-header-format="left-header"]').length > 0 &&
        $(window).width() > 1000
          ? 0
          : $("#header-outer").outerHeight();

      if (
        $(window).height() -
          $("#wpadminbar").height() -
          $headerNavSpace -
          $("#footer-outer").height() -
          1 -
          $("#page-header-bg").height() -
          $(".parallax_slider_outer").height() -
          $(".page-header-no-bg").height() >
        0
      ) {
        $resizeExtra =
          $('#header-outer[data-header-resize="1"]').length > 0 ? 55 : 0;
        $(".container-wrap").css({
          "margin-bottom": $("#footer-outer").height() - 1,
          "min-height":
            $(window).height() -
            $("#wpadminbar").height() -
            $headerNavSpace -
            $("#footer-outer").height() -
            1 -
            $(".page-header-no-bg").height() -
            $("#page-header-bg").height() -
            $(".parallax_slider_outer").height() +
            $resizeExtra,
        });
      } else {
        $(".container-wrap").css({
          "margin-bottom": $("#footer-outer").height() - 1,
        });
      }

      if ($(window).width() < 1000)
        $("#footer-outer").attr("data-midnight", "light");
      else $("#footer-outer").removeAttr("data-midnight");
    }
    if ($('body[data-footer-reveal="1"]').length > 0) {
      footerRevealCalcs();
      //set shadow to match BG color if applicable
      if ($('body[data-footer-reveal-shadow="large_2"]').length > 0)
        $(".container-wrap").css({
          boxShadow:
            "0 70px 110px -30px " + $("#footer-outer").css("backgroundColor"),
        });
    }

    function opaqueCheck() {
      var $offset = $(window).scrollTop();
      var $windowWidth = $(window).width();

      if ($offset > 0 && $windowWidth > 1000) {
        if (
          $("#header-outer").attr("data-transparent-header") == "true" &&
          $('#header-outer[data-permanent-transparent="1"]').length == 0
        )
          $("#header-outer")
            .removeClass("transparent")
            .addClass("scrolled-down");
        $(".ns-loading-cover").hide();

        $(window).off("scroll", opaqueCheck);
        $(window).on("scroll", transparentCheck);
      }
    }

    function transparentCheck() {
      var $offset = $(window).scrollTop();
      var $windowWidth = $(window).width();

      if ($offset == 0 && $windowWidth > 1000) {
        if (
          $('#header-outer[data-megamenu-rt="1"]').length > 0 &&
          $('#header-outer[data-transparent-header="true"]').length > 0 &&
          $("#header-outer .megamenu").length > 0
        ) {
          if (
            $("#header-outer").attr("data-transparent-header") == "true" &&
            $(".megamenu.sfHover").length == 0
          ) {
            $("#header-outer")
              .addClass("transparent")
              .removeClass("scrolled-down");
            $("#header-outer").removeClass("no-transition");
          } else if (
            $("#header-outer").attr("data-transparent-header") == "true"
          )
            $("#header-outer").removeClass("scrolled-down");
        } else {
          if ($("#header-outer").attr("data-transparent-header") == "true")
            $("#header-outer")
              .addClass("transparent")
              .removeClass("scrolled-down");
        }

        $(".ns-loading-cover").show();

        $(window).off("scroll", transparentCheck);
        $(window).on("scroll", opaqueCheck);
      }
    }

    var adminBarHeight =
      $("#wpadminbar").length > 0 ? $("#wpadminbar").height() : 0; //admin bar

    //header inherit row color effect
    function headerRowColorInheritInit() {
      if (
        $('body[data-header-inherit-rc="true"]').length > 0 &&
        $(".mobile").length == 0
      ) {
        var headerOffset =
          $('#header-outer[data-permanent-transparent="1"]').length == 0
            ? logoHeight -
              shrinkNum +
              Math.ceil((headerPadding * 2) / 1.8) +
              adminBarHeight
            : logoHeight / 2 + headerPadding + adminBarHeight;

        $(".main-content > .row > .wpb_row").each(function () {
          var $that = $(this);
          var waypoint = new Waypoint({
            element: $that,
            handler: function (direction) {
              if (direction == "down") {
                if ($that.find(".row-bg.using-bg-color").length > 0) {
                  var $textColor =
                    $that.find("> .col.span_12.light").length > 0
                      ? "light-text"
                      : "dark-text";
                  $("#header-outer")
                    .css(
                      "background-color",
                      $that.find(".row-bg").css("background-color")
                    )
                    .removeClass("light-text")
                    .removeClass("dark-text")
                    .addClass($textColor);
                  $("#header-outer").attr(
                    "data-current-row-bg-color",
                    $that.find(".row-bg").css("background-color")
                  );
                } else {
                  $("#header-outer")
                    .css(
                      "background-color",
                      $("#header-outer").attr("data-user-set-bg")
                    )
                    .removeClass("light-text")
                    .removeClass("dark-text");
                  $("#header-outer").attr(
                    "data-current-row-bg-color",
                    $("#header-outer").attr("data-user-set-bg")
                  );
                }
              } else {
                if (
                  $that.prev("div.wpb_row").find(".row-bg.using-bg-color")
                    .length > 0
                ) {
                  var $textColor =
                    $that.prev("div.wpb_row").find("> .col.span_12.light")
                      .length > 0
                      ? "light-text"
                      : "dark-text";
                  $("#header-outer")
                    .css(
                      "background-color",
                      $that
                        .prev("div.wpb_row")
                        .find(".row-bg")
                        .css("background-color")
                    )
                    .removeClass("light-text")
                    .removeClass("dark-text")
                    .addClass($textColor);
                  $("#header-outer").attr(
                    "data-current-row-bg-color",
                    $that
                      .prev("div.wpb_row")
                      .find(".row-bg")
                      .css("background-color")
                  );
                } else {
                  $("#header-outer")
                    .css(
                      "background-color",
                      $("#header-outer").attr("data-user-set-bg")
                    )
                    .removeClass("light-text")
                    .removeClass("dark-text");
                  $("#header-outer").attr(
                    "data-current-row-bg-color",
                    $("#header-outer").attr("data-user-set-bg")
                  );
                }
              }
            },
            offset: headerOffset,
          });
        });
      }
    }

    //if($('.nectar-box-roll').length == 0) headerRowColorInheritInit();

    /****************sticky page submenu******************/
    if (
      $('.page-submenu[data-sticky="true"]').length > 0 &&
      $("#nectar_fullscreen_rows").length == 0
    ) {
      (function () {
        "use strict";

        var $ = window.jQuery;
        var Waypoint = window.Waypoint;
        var $offsetHeight = 0;
        var shrinkNum = 6;
        var headerPadding = parseInt($("#header-outer").attr("data-padding"));

        if ($("#header-outer[data-shrink-num]").length > 0)
          shrinkNum = $("#header-outer").attr("data-shrink-num");
        var headerPadding2 = headerPadding - headerPadding / 1.8;
        var $headerNavSpace =
          $('body[data-header-format="left-header"]').length > 0 &&
          $(window).width() > 1000
            ? 0
            : $("#header-outer").outerHeight();
        var $headerHeight =
          $('#header-outer[data-header-resize="1"]').length > 0 &&
          $("body.mobile").length == 0
            ? $headerNavSpace - (parseInt(shrinkNum) + headerPadding2 * 2)
            : $headerNavSpace;

        if (
          $(".page-template-template-no-header-footer").length > 0 ||
          $(".page-template-template-no-header").length > 0
        ) {
          $headerNavSpace = 0;
          $headerHeight = 0;
        }

        if (
          $("#header-secondary-outer").length > 0 &&
          $("body.mobile").length == 0
        )
          $headerHeight += $("#header-secondary-outer").height();

        $(window).on("smartresize", function () {
          $headerNavSpace =
            $('body[data-header-format="left-header"]').length > 0 &&
            $(window).width() > 1000
              ? 0
              : $("#header-outer").outerHeight();
          $headerHeight =
            $('#header-outer[data-header-resize="1"]').length > 0 &&
            $(".small-nav").length == 0 &&
            $("body.mobile").length == 0
              ? $headerNavSpace - (parseInt(shrinkNum) + headerPadding2 * 2)
              : $headerNavSpace;
          if (
            $("#header-secondary-outer").length > 0 &&
            $("body.mobile").length == 0
          )
            $headerHeight += $("#header-secondary-outer").height();

          $offsetHeight = 0;

          if (
            $("#wpadminbar").length > 0 &&
            $("#wpadminbar").css("position") == "fixed"
          )
            $offsetHeight += $("#wpadminbar").height();
          if (
            $('body[data-hhun="0"] #header-outer').length > 0 &&
            !(
              $("body.mobile").length > 0 &&
              $('#header-outer[data-mobile-fixed="false"]').length > 0
            )
          ) {
            $offsetHeight += $headerHeight;
          }

          if (
            $(".body-border-top").length > 0 &&
            $(window).width() > 1000 &&
            $('body[data-hhun="1"]').length > 0
          )
            $offsetHeight += $(".body-border-top").height();

          // else if($('body[data-hhun="1"] #header-outer.detached:not(.invisible)').length > 0) $offsetHeight += $headerHeight;

          //recalc for resizing (same as stuck/unstuck logic below)
          if ($(".page-submenu.stuck").length > 0) {
            $(".page-submenu.stuck")
              .addClass("no-trans")
              .css("top", $offsetHeight)
              .css("transform", "translateY(0)")
              .addClass("stuck");
            var $that = this;
            setTimeout(function () {
              $(".page-submenu.stuck").removeClass("no-trans");
            }, 50);
            $(".page-submenu.stuck").parents(".wpb_row").css("z-index", 10000);

            //boxed
            if ($("#boxed").length > 0) {
              var $negMargin =
                $(window).width() > 1000
                  ? $(".container-wrap").width() * 0.04
                  : 39;
              $(".page-submenu.stuck").css({
                "margin-left": "-" + $negMargin + "px",
                width: $(".container-wrap").width(),
              });
            }
          } else {
            $(".page-submenu.stuck").css("top", "0").removeClass("stuck");
            $(".page-submenu.stuck").parents(".wpb_row").css("z-index", "auto");

            if ($("#boxed").length > 0)
              $(".page-submenu.stuck").css({
                "margin-left": "0px",
                width: "100%",
              });
          }
        });

        /* http://imakewebthings.com/waypoints/shortcuts/sticky-elements */
        function Sticky(options) {
          this.options = $.extend(
            {},
            Waypoint.defaults,
            Sticky.defaults,
            options
          );
          this.element = this.options.element;
          this.$element = $(this.element);
          this.createWrapper();
          this.createWaypoint();
        }

        /* Private */
        Sticky.prototype.createWaypoint = function () {
          var originalHandler = this.options.handler;

          $offsetHeight = 0;
          if (
            $("#wpadminbar").length > 0 &&
            $("#wpadminbar").css("position") == "fixed"
          )
            $offsetHeight += $("#wpadminbar").height();
          if (
            $('body[data-hhun="0"] #header-outer').length > 0 &&
            !(
              $("body.mobile").length > 0 &&
              $('#header-outer[data-mobile-fixed="false"]').length > 0
            )
          ) {
            $offsetHeight += $headerHeight;
          }
          if (
            $(".body-border-top").length > 0 &&
            $(window).width() > 1000 &&
            $('body[data-hhun="1"]').length > 0
          )
            $offsetHeight += $(".body-border-top").height();

          this.waypoint = new Waypoint(
            $.extend({}, this.options, {
              element: this.wrapper,
              handler: $.proxy(function (direction) {
                var shouldBeStuck =
                  this.options.direction.indexOf(direction) > -1;
                var wrapperHeight = shouldBeStuck
                  ? this.$element.outerHeight(true)
                  : "";

                this.$wrapper.height(wrapperHeight);
                if (shouldBeStuck) {
                  this.$element
                    .addClass("no-trans")
                    .css("top", $offsetHeight)
                    .css("transform", "translateY(0)")
                    .addClass("stuck");
                  var $that = this;
                  setTimeout(function () {
                    $that.$element.removeClass("no-trans");
                  }, 50);
                  this.$element.parents(".wpb_row").css("z-index", 10000);

                  //boxed
                  if ($("#boxed").length > 0) {
                    var $negMargin =
                      $(window).width() > 1000
                        ? $(".container-wrap").width() * 0.04
                        : 39;
                    this.$element.css({
                      "margin-left": "-" + $negMargin + "px",
                      width: $(".container-wrap").width(),
                    });
                  }
                } else {
                  this.$element.css("top", "0").removeClass("stuck");
                  //this.$element.parents('.wpb_row').css('z-index','10000');

                  if ($("#boxed").length > 0)
                    this.$element.css({ "margin-left": "0px", width: "100%" });
                }

                if (originalHandler) {
                  originalHandler.call(this, direction);
                }
              }, this),
              offset: $offsetHeight,
            })
          );

          var $that = this;

          // if($('body[data-hhun="1"]').length > 0 ) {
          setInterval(function () {
            if (
              $('body[data-hhun="1"] #header-outer.detached:not(.invisible)')
                .length > 0
            )
              $that.waypoint.options.offset = $offsetHeight + $headerHeight;
            else $that.waypoint.options.offset = $offsetHeight;
            Waypoint.refreshAll();
          }, 100);
          //}
        };

        /* Private */
        Sticky.prototype.createWrapper = function () {
          if (this.options.wrapper) {
            this.$element.wrap(this.options.wrapper);
          }
          this.$wrapper = this.$element.parent();
          this.wrapper = this.$wrapper[0];
        };

        /* Public */
        Sticky.prototype.destroy = function () {
          if (this.$element.parent()[0] === this.wrapper) {
            this.waypoint.destroy();
            this.$element.removeClass(this.options.stuckClass);
            if (this.options.wrapper) {
              this.$element.unwrap();
            }
          }
        };

        Sticky.defaults = {
          wrapper: '<div class="sticky-wrapper" />',
          stuckClass: "stuck",
          direction: "down right",
        };

        Waypoint.Sticky = Sticky;
      })();

      //remove outside of column setups
      if (
        $(".page-submenu").parents(".span_12").find("> .wpb_column").length > 1
      ) {
        var pageMenu = $(".page-submenu").clone();
        var pageMenuParentRow = $(".page-submenu").parents(".wpb_row");
        $(".page-submenu").remove();
        pageMenuParentRow.before(pageMenu);
      }

      var sticky = new Waypoint.Sticky({
        element: $('.page-submenu[data-sticky="true"]')[0],
      });
    }

    if ($("#nectar_fullscreen_rows").length == 0)
      $(".page-submenu").parents(".wpb_row").css("z-index", 10000);

    $(".page-submenu .mobile-menu-link").on("click", function () {
      $(this).parents(".page-submenu").find("ul").stop(true).slideToggle(350);
      return false;
    });

    $(".page-submenu ul li a").on("click", function () {
      if ($("body.mobile").length > 0)
        $(this).parents(".page-submenu").find("ul").stop(true).slideToggle(350);
    });

    //responsive nav
    $("body").on("click", "#toggle-nav", function () {
      if (window.innerWidth > 1000) {
        window.scrollTo(0, 0);
      }

      $(this).find(".lines-button").toggleClass("close");
      $("#mobile-menu").stop(true, true).slideToggle(500);
      return false;
    });

    //add wpml to mobile menu
    if (
      $("header#top nav > ul > li.menu-item-language").length > 0 &&
      $("#header-secondary-outer ul > li.menu-item-language").length == 0
    ) {
      var $langSelector = $(
        "header#top nav > ul > li.menu-item-language"
      ).clone();
      $langSelector.insertBefore("#mobile-menu ul #mobile-search");
    }

    ////append dropdown indicators / give classes
    $("#mobile-menu .container ul li").each(function () {
      if ($(this).find("> ul").length > 0) {
        $(this).addClass("has-ul");
        $(this)
          .find("> a")
          .append(
            '<span class="sf-sub-indicator"><i class="icon-angle-down"></i></span>'
          );
      }
    });

    ////events
    $('#mobile-menu .container ul li:has(">ul") > a .sf-sub-indicator').click(
      function () {
        $(this).parent().parent().toggleClass("open");
        $(this).parent().parent().find("> ul").stop(true, true).slideToggle();
        return false;
      }
    );

    /*-------------------------------------------------------------------------*/
    /*	5.	Page Specific
/*-------------------------------------------------------------------------*/

    function vcFullHeightRow() {
      var $element = $(".vc_row-o-full-height:first");
      if ($element.length) {
        var $window, windowHeight, offsetTop, fullHeight;
        ($window = $(window)), (windowHeight = $window.height());

        $(".vc_row-o-full-height").each(function () {
          offsetTop = $(this).offset().top;

          var $realRowIndex = $(this).parent().hasClass("vc_ie-flexbox-fixer")
            ? $(this).parent().index()
            : $(this).index();

          if (offsetTop < windowHeight && $realRowIndex == 0) {
            fullHeight = 100 - offsetTop / (windowHeight / 100);
            $(this).css("min-height", fullHeight + "vh");
            $(this)
              .find("> .col.span_12")
              .css("min-height", fullHeight + "vh");
          } else {
            $(this).css("min-height", windowHeight);
            $(this).find("> .col.span_12").css("min-height", windowHeight);
          }
        });
      }
    }
    function fixIeFlexbox() {
      var ua = window.navigator.userAgent,
        msie = ua.indexOf("MSIE ");
      (msie > 0 || navigator.userAgent.match(/Trident.*rv\:11\./)) &&
        $(".vc_row-o-full-height").each(function () {
          "flex" === $(this).find("> .span_12").css("display") &&
            $(this).wrap('<div class="vc_ie-flexbox-fixer"></div>');
        });
    }
    fixIeFlexbox();

    vcFullHeightRow();

    //recent work
    function piVertCenter() {
      $(".portfolio-items  > .col").each(function () {
        //style 4
        $(this)
          .find(".style-4 .work-info .bottom-meta:not(.shown)")
          .stop()
          .animate(
            {
              bottom:
                "-" +
                $(this).find(".work-info .bottom-meta").outerHeight() -
                2 +
                "px",
            },
            420,
            "easeOutCubic"
          );
      });
    }

    $(window).load(function () {
      portfolioCommentOrder();
      fullWidthContentColumns();
      resizeVideoToCover();
    });

    //ie8 width fix
    function ie8Width() {
      if ($(window).width() >= 1300) {
        $(".container").css("max-width", "1100px");
      } else {
        $(".container").css("max-width", "880px");
      }
    }

    if ($(window).width() >= 1300 && $("html").hasClass("no-video")) {
      $(".container").css("max-width", "1100px");
      $(window).resize(ie8Width);
    }

    function smartResizeInit() {
      //carousel height calcs
      carouselHeightCalcs();
      clientsCarouselHeightRecalc();

      //portfolio comment order
      portfolioCommentOrder();

      //testimonial slider height
      testimonialHeightResize(); //animated
      testimonialSliderHeight(); //non-animated

      //full width content columns sizing
      fullWidthContentColumns();

      //parallax BG Calculations
      if (
        !navigator.userAgent.match(
          /(Android|iPod|iPhone|iPad|IEMobile|BlackBerry|Opera Mini)/
        )
      ) {
        parallaxRowsBGCals();
      }
      vcFullHeightRow();
      headerSpace();

      centeredLogoMargins();

      slideOutWidgetOverflowState();
      recentPostHeight();

      morphingOutlines();

      flipBoxHeights();

      showOnLeftSubMenu();

      //minimal alt effect
      if ($('.tabbed[data-style="minimal_alt"]').length > 0) {
        magicLineCalc(
          $('.tabbed[data-style="minimal_alt"] > ul > li > a.active-tab')
        );
      }

      //full width menu megamenu adjust
      //if($('.slide-out-widget-area-toggle a.open').length > 0 && $('#header-outer[data-full-width="true"]').length > 0) fullWidthHeaderSlidingWidgetMenuCalc();
    }

    $(window).off("smartresize.srInit");
    $(window).on("smartresize.srInit", smartResizeInit);

    function resizeInit() {
      portfolioDeviceCheck();

      //fullwidth page section calcs
      fullWidthSections();
      fullwidthImgOnlySizing();
      fullWidthContentColumns();
      fullWidthRowPaddingAdjustCalc();

      //iframe video emebeds
      responsiveVideoIframes();
      videoshortcodeSize();

      testimonialSliderHeightMinimalMult();

      if ($(".nectar-social.full-width").length > 0) {
        nectarLoveFWCenter();
      }

      if ($("body").hasClass("ascend")) {
        searchFieldCenter();
      }

      if ($("body").hasClass("single-post")) centerPostNextButtonImg();

      //fixed sidebar for portfolio
      sidebarPxConversion();

      cascadingImageBGSizing();

      responsiveTooltips();

      //vc mobile columns
      if (
        $('[class*="vc_col-xs-"], [class*="vc_col-md-"], [class*="vc_col-lg-"]')
          .length > 0
      )
        vcMobileColumns();

      if ($('body[data-footer-reveal="1"]').length > 0) footerRevealCalcs();

      if ($("#page-header-bg").length > 0) pageHeader();

      if ($(".nectar-video-bg").length > 0) {
        resizeVideoToCover();
      }
    }

    $(window).off("resize.srInit");
    $(window).on("resize.srInit", resizeInit);

    $(window).on("orientationchange", function () {
      setTimeout(clientsCarouselHeightRecalc, 200);
    });

    //blog next post button
    function postNextButtonEffect() {
      $(".blog_next_prev_buttons").imagesLoaded(function () {
        centerPostNextButtonImg();

        $(".blog_next_prev_buttons img").css("opacity", "1");

        if (
          !$("body").hasClass("mobile") &&
          !navigator.userAgent.match(
            /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
          )
        ) {
          $(".blog_next_prev_buttons img").panr({
            scaleDuration: 0.28,
            sensitivity: 22,
            scaleTo: 1.06,
          });
        }
      });
    }

    function centerPostNextButtonImg() {
      if ($(".blog_next_prev_buttons").length == 0) return false;

      if (
        $(".blog_next_prev_buttons img").height() >=
        $(".blog_next_prev_buttons").height() + 50
      ) {
        var $height = "auto";
        var $width = $(".blog_next_prev_buttons").width();
      } else {
        if (
          $(".blog_next_prev_buttons").width() <
          $(".blog_next_prev_buttons img").width()
        ) {
          var $height = $(".blog_next_prev_buttons").height() + 49;
          var $width = "auto";
        } else {
          var $height = "auto";
          var $width = "100%";
        }
      }

      $(".blog_next_prev_buttons img").css({ height: $height, width: $width });

      $(".blog_next_prev_buttons img").css({
        top:
          $(".blog_next_prev_buttons").height() / 2 -
          $(".blog_next_prev_buttons img").height() / 2 +
          "px",
        left:
          $(".blog_next_prev_buttons").width() / 2 -
          $(".blog_next_prev_buttons img").width() / 2 +
          "px",
      });

      $(".blog_next_prev_buttons .inner").each(function () {
        $(this).css({
          top: $(this).parent().height() / 2 - $(this).height() / 2,
          opacity: "1",
        });
      });
    }

    postNextButtonEffect();

    function recentPostHeight() {
      $('.blog-recent[data-style="title_only"]').each(function () {
        if ($(this).find("> .col").length > 1) return false;
        if (
          $(this).parent().parent().parent().hasClass("vc_col-sm-3") ||
          $(this).parent().parent().parent().hasClass("vc_col-sm-4") ||
          $(this).parent().parent().parent().hasClass("vc_col-sm-6") ||
          $(this).parent().parent().parent().hasClass("vc_col-sm-8") ||
          $(this).parent().parent().parent().hasClass("vc_col-sm-9")
        ) {
          if ($("body.mobile").length == 0 && $(this).next("div").length == 0) {
            var tallestColumn = 0;

            $(this).find("> .col").css("padding", "50px 20px");

            $(this)
              .parents(".span_12")
              .find(" > .wpb_column")
              .each(function () {
                Math.floor($(this).height()) > tallestColumn
                  ? (tallestColumn = Math.floor($(this).height()))
                  : (tallestColumn = tallestColumn);
              });

            if (
              Math.floor($(this).find("> .col").outerHeight(true)) <
              Math.floor($(this).parents(".wpb_row").height()) - 1
            ) {
              $(this)
                .find("> .col")
                .css(
                  "padding-top",
                  (tallestColumn - $(this).find("> .col").height()) / 2 + "px"
                );
              $(this)
                .find("> .col")
                .css(
                  "padding-bottom",
                  (tallestColumn - $(this).find("> .col").height()) / 2 + "px"
                );
            }
          } else {
            $(this).find("> .col").css("padding", "50px 20px");
          }
        }
      });
    }
    recentPostHeight();

    //recent post slider
    function recentPostsFlickityInit() {
      //classic enhanced specific
      $('.blog-recent[data-style="classic_enhanced_alt"] .inner-wrap').each(
        function () {
          $(this)
            .find(".post-featured-img")
            .each(function () {
              var $src = $(this).find("img").attr("src");
              $(this).css("background-image", "url(" + $src + ")");
            });
        }
      );
      $('.blog-recent[data-style="classic_enhanced"]').each(function () {
        if ($(this).find(".inner-wrap.has-post-thumbnail").length == 0) {
          $(this).addClass("no-thumbs");
        }
      });

      if ($(".nectar-recent-posts-slider-inner").length == 0) return false;

      var $rpF = $(".nectar-recent-posts-slider-inner").flickity({
        contain: true,
        draggable: true,
        lazyLoad: false,
        imagesLoaded: true,
        percentPosition: true,
        prevNextButtons: false,
        pageDots: true,
        resize: true,
        setGallerySize: true,
        wrapAround: true,
        accessibility: false,
      });

      setTimeout(function () {
        $(".nectar-recent-posts-slider-inner").addClass("loaded");
      }, 1150);
      var flkty = $rpF.data("flickity");

      $rpF.on("dragStart", function () {
        $(".flickity-viewport").addClass("is-moving");
      });
      $rpF.on("dragEnd", function () {
        $(".flickity-viewport").removeClass("is-moving");
      });

      recentPostSliderHeight();
      $(window).resize(recentPostSliderHeight);

      if (
        !navigator.userAgent.match(
          /(Android|iPod|iPhone|iPad|IEMobile|BlackBerry|Opera Mini)/
        )
      )
        $(window).resize(recentPostSliderParallaxMargins);

      function recentPostSliderHeight() {
        $(".nectar-recent-posts-slider").each(function () {
          var $heightCalc;
          var $minHeight = 250;
          var $windowWidth = $(window).width();
          var $definedHeight = parseInt($(this).attr("data-height"));

          var dif =
            $('body[data-ext-responsive="true"]').length > 0
              ? $(window).width() / 1400
              : $(window).width() / 1100;

          if (window.innerWidth > 1000 && $("#boxed").length == 0) {
            if ($(this).parents(".full-width-content").length == 0) {
              if (
                $('body[data-ext-responsive="true"]').length > 0 &&
                window.innerWidth >= 1400
              ) {
                $(this)
                  .find(".nectar-recent-post-slide, .flickity-viewport")
                  .css("height", Math.ceil($definedHeight));
              } else if (
                $('body[data-ext-responsive="true"]').length == 0 &&
                window.innerWidth >= 1100
              ) {
                $(this)
                  .find(".nectar-recent-post-slide, .flickity-viewport")
                  .css("height", Math.ceil($definedHeight));
              } else {
                $(this)
                  .find(".nectar-recent-post-slide, .flickity-viewport")
                  .css("height", Math.ceil($definedHeight * dif));
              }
            } else {
              $(this)
                .find(".nectar-recent-post-slide, .flickity-viewport")
                .css("height", Math.ceil($definedHeight * dif));
            }
          } else {
            //column sliders
            var $parentCol =
              $(this).parents(".wpb_column").length > 0
                ? $(this).parents(".wpb_column")
                : $(this).parents(".col");
            if ($parentCol.length == 0) $parentCol = $(".main-content");

            if (
              !$parentCol.hasClass("vc_span12") &&
              !$parentCol.hasClass("main-content") &&
              !$parentCol.hasClass("span_12") &&
              !$parentCol.hasClass("vc_col-sm-12")
            ) {
              var $parentColWidth = sliderColumnDesktopWidth($parentCol);
              var $aspectRatio = $definedHeight / $parentColWidth;

              //min height
              if ($aspectRatio * $parentCol.width() <= $minHeight) {
                $(this)
                  .find(".nectar-recent-post-slide, .flickity-viewport")
                  .css("height", $minHeight);
              } else {
                $(this)
                  .find(".nectar-recent-post-slide, .flickity-viewport")
                  .css("height", $aspectRatio * $parentCol.width());
              }
            }

            //regular
            else {
              //min height
              if ($definedHeight * dif <= $minHeight) {
                $(this)
                  .find(".nectar-recent-post-slide, .flickity-viewport")
                  .css("height", $minHeight);
              } else {
                $(this)
                  .find(".nectar-recent-post-slide, .flickity-viewport")
                  .css("height", Math.ceil($definedHeight * dif));
              }
            }
          }
        });
      }

      ////helper function
      function sliderColumnDesktopWidth(parentCol) {
        var $parentColWidth = 1100;
        var $columnNumberParsed = $(parentCol).attr("class").match(/\d+/);

        if ($columnNumberParsed == "2") {
          $parentColWidth = 170;
        } else if ($columnNumberParsed == "3") {
          $parentColWidth = 260;
        } else if ($columnNumberParsed == "4") {
          $parentColWidth = 340;
        } else if ($columnNumberParsed == "6") {
          $parentColWidth = 530;
        } else if ($columnNumberParsed == "8") {
          $parentColWidth = 700;
        } else if ($columnNumberParsed == "9") {
          $parentColWidth = 805;
        } else if ($columnNumberParsed == "10") {
          $parentColWidth = 916.3;
        } else if ($columnNumberParsed == "12") {
          $parentColWidth = 1100;
        }

        return $parentColWidth;
      }
    }

    recentPostsFlickityInit();

    if (
      !navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|IEMobile|BlackBerry|Opera Mini)/
      )
    )
      if ($(".nectar-recent-posts-slider").length > 0)
        window.requestAnimationFrame(recentPostSliderParallax);

    function recentPostSliderParallax() {
      $(".nectar-recent-posts-slider").each(function () {
        var $offset = parseInt(
          $(this).find(".flickity-slider").position().left
        );
        var $slideLength = $(this).find(".nectar-recent-post-slide").length;
        var $lastChildIndex = $(this)
          .find(".nectar-recent-post-slide:last-child")
          .index();
        var $slideWidth = $(this).find(".nectar-recent-post-slide").width();
        //wrapped fix

        ////first going to first
        if ($offset >= -3) {
          $(this)
            .find(".nectar-recent-post-slide:last-child .nectar-recent-post-bg")
            .css("margin-left", parseInt(Math.ceil($slideWidth / 3.5)) + "px");
        } else {
          $(this)
            .find(".nectar-recent-post-slide:last-child .nectar-recent-post-bg")
            .css(
              "margin-left",
              "-" +
                parseInt(Math.ceil(($slideWidth / 3.5) * $lastChildIndex)) +
                "px"
            );
        }
        ////last going to first
        if (Math.abs($offset) >= ($slideLength - 1) * $slideWidth) {
          $(this)
            .find(
              ".nectar-recent-post-slide:first-child .nectar-recent-post-bg"
            )
            .css(
              "margin-left",
              "-" +
                parseInt(Math.ceil(($slideWidth / 3.5) * $slideLength)) +
                "px"
            );
        } else {
          $(this)
            .find(
              ".nectar-recent-post-slide:first-child .nectar-recent-post-bg"
            )
            .css("margin-left", "0px");
        }

        $(this)
          .find(".nectar-recent-post-bg")
          .css(
            "transform",
            "translateX(" +
              Math.ceil(
                $(this).find(".flickity-slider").position().left / -3.5
              ) +
              "px)"
          );
      });
      requestAnimationFrame(recentPostSliderParallax);
    }

    function recentPostSliderParallaxMargins() {
      $(".nectar-recent-posts-slider").each(function () {
        var $slideWidth = $(this).find(".nectar-recent-post-slide").width();
        $(this)
          .find(".nectar-recent-post-slide")
          .each(function (i) {
            $(this)
              .find(".nectar-recent-post-bg")
              .css(
                "margin-left",
                "-" + parseInt(Math.ceil($slideWidth / 3.5) * i) + "px"
              );
          });
      });
    }

    if (
      !navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|IEMobile|BlackBerry|Opera Mini)/
      )
    )
      recentPostSliderParallaxMargins();

    //portfolio item hover effect

    ////desktop event
    function portfolioHoverEffects() {
      if (
        !$("body").hasClass("mobile") &&
        !navigator.userAgent.match(/(iPad|IEMobile)/)
      ) {
        //style 1 & 2
        $(
          '.portfolio-items:not([data-ps="7"]) .col .work-item:not(.style-3-alt):not(.style-3):not([data-custom-content="on"])'
        ).hover(
          function () {
            $(this).find(".work-info .vert-center").css({ "margin-top": 0 });
            $(this)
              .find(".work-info, .work-info .vert-center *, .work-info > i")
              .css({ opacity: 1 });
            $(this).find(".work-info-bg").css({ opacity: 0.9 });
          },
          function () {
            $(this).find(".work-info .vert-center").css({ "margin-top": -20 });
            $(this)
              .find(".work-info, .work-info .vert-center *, .work-info > i")
              .css({ opacity: 0 });
            $(this).find(".work-info-bg").css({ opacity: 0 });
          }
        );

        //style 3
        $(".portfolio-items .col .work-item.style-3").hover(
          function () {
            $(this).find(".work-info-bg").css({ opacity: 0 });
          },
          function () {
            $(this).find(".work-info-bg").css({ opacity: 0.45 });
          }
        );

        //style 4
        $(".portfolio-items .col .work-item.style-4").hover(
          function () {
            $(this)
              .find("img")
              .stop()
              .animate(
                {
                  top:
                    "-" +
                    $(this).find(".work-info .bottom-meta").outerHeight() / 2 +
                    "px",
                },
                250,
                "easeOutCubic"
              );

            $(this)
              .find(".work-info .bottom-meta")
              .addClass("shown")
              .stop()
              .animate(
                {
                  bottom: "0px",
                },
                320,
                "easeOutCubic"
              );
          },
          function () {
            $(this).find("img").stop().animate(
              {
                top: "0px",
              },
              250,
              "easeOutCubic"
            );

            $(this)
              .find(".work-info .bottom-meta")
              .removeClass("shown")
              .stop()
              .animate(
                {
                  bottom:
                    "-" +
                    $(this).find(".work-info .bottom-meta").outerHeight() -
                    2 +
                    "px",
                },
                320,
                "easeOutCubic"
              );
          }
        );
      }
      ////mobile event
      else {
        portfolioDeviceCheck();
      }
    }

    portfolioHoverEffects();

    function style6Img() {
      //change sizer pos
      $(".style-5").each(function () {
        $(this).find(".sizer").insertBefore($(this).find(".parallaxImg"));
      });

      //set parent zindex
      $(".style-5").parents(".wpb_row").css("z-index", "100");

      var d = document,
        de = d.documentElement,
        bd = d.getElementsByTagName("body")[0],
        htm = d.getElementsByTagName("html")[0],
        win = window,
        imgs = d.querySelectorAll(".parallaxImg"),
        totalImgs = imgs.length,
        supportsTouch = "ontouchstart" in win || navigator.msMaxTouchPoints;

      if (totalImgs <= 0) {
        return;
      }

      // build HTML
      for (var l = 0; l < totalImgs; l++) {
        var thisImg = imgs[l],
          layerElems = thisImg.querySelectorAll(".parallaxImg-layer"),
          totalLayerElems = layerElems.length;

        if (totalLayerElems <= 0) {
          continue;
        }

        while (thisImg.firstChild) {
          thisImg.removeChild(thisImg.firstChild);
        }

        var lastMove = 0;

        //throttle performance for all browser other than chrome
        var eventThrottle = $("html").hasClass("cssreflections") ? 1 : 80;
        if (eventThrottle == 80) $("body").addClass("cssreflections");

        var containerHTML = d.createElement("div"),
          shineHTML = d.createElement("div"),
          shadowHTML = d.createElement("div"),
          layersHTML = d.createElement("div"),
          layers = [];

        thisImg.id = "parallaxImg__" + l;
        containerHTML.className = "parallaxImg-container";
        //shineHTML.className = 'parallaxImg-shine';
        shadowHTML.className = "parallaxImg-shadow";
        layersHTML.className = "parallaxImg-layers";

        for (var i = 0; i < totalLayerElems; i++) {
          var layer = d.createElement("div"),
            layerInner = d.createElement("div"),
            imgSrc = layerElems[i].getAttribute("data-img");

          $(layer).html($(layerElems[i]).html());
          layer.className = "parallaxImg-rendered-layer";
          layer.setAttribute("data-layer", i);

          if (i == 0 && $(thisImg).parents(".wpb_gallery").length == 0) {
            layerInner.className = "bg-img";
            layerInner.style.backgroundImage = "url(" + imgSrc + ")";
            layer.appendChild(layerInner);
          }
          layersHTML.appendChild(layer);

          layers.push(layer);
        }

        containerHTML.appendChild(layersHTML);
        //containerHTML.appendChild(shineHTML);
        thisImg.appendChild(containerHTML);
        $(thisImg).wrap('<div class="parallaxImg-wrap" />');
        if (
          !(
            navigator.userAgent.indexOf("Safari") != -1 &&
            navigator.userAgent.indexOf("Chrome") == -1
          )
        ) {
          $(thisImg).parent().append(shadowHTML);
        }

        var w =
          thisImg.clientWidth || thisImg.offsetWidth || thisImg.scrollWidth;
        //thisImg.style.transform = 'perspective('+ w*3 +'px)';

        if (supportsTouch) {
        } else {
          (function (_thisImg, _layers, _totalLayers, _shine) {
            $(thisImg)
              .parents(".style-5")
              .on("mousemove", function (e) {
                var now = Date.now();
                if (now > lastMove + eventThrottle) {
                  lastMove = now;
                  window.requestAnimationFrame(function () {
                    processMovement(
                      e,
                      false,
                      _thisImg,
                      _layers,
                      _totalLayers,
                      _shine
                    );
                  });
                }

                //window.requestAnimationFrame(function(){
                //	processShineMovement(e,false,_thisImg,_layers,_totalLayers,_shine);
                //});
              });
            $(thisImg)
              .parents(".style-5")
              .on("mouseenter", function (e) {
                processEnter(e, _thisImg, _layers, _totalLayers, _shine);
              });
            $(thisImg)
              .parents(".style-5")
              .on("mouseleave", function (e) {
                processExit(e, _thisImg, _layers, _totalLayers, _shine);
              });
          })(thisImg, layers, totalLayerElems, shineHTML);
        }

        //set the depths
        (function (_thisImg, _layers, _totalLayers, _shine) {
          depths(false, _thisImg, _layers, _totalLayers, _shine);
          window.addEventListener("resize", function (e) {
            depths(false, _thisImg, _layers, _totalLayers, _shine);
          });
        })(thisImg, layers, totalLayerElems, shineHTML);
      }

      function processMovement(
        e,
        touchEnabled,
        elem,
        layers,
        totalLayers,
        shine
      ) {
        //stop raf if exit already called
        if (!$(elem.firstChild).hasClass("over")) {
          processExit(e, elem, layers, totalLayers, shine);
          return false;
        }

        //set up multipliers

        if ($(elem).parents(".col.wide").length > 0) {
          var yMult = 0.03;
          var xMult = 0.063;
        } else if (
          $(elem).parents(".col.regular").length > 0 ||
          $(elem).parents(".wpb_gallery").length > 0
        ) {
          var yMult = 0.045;
          var xMult = 0.045;
        } else if ($(elem).parents(".col.tall").length > 0) {
          var yMult = 0.05;
          var xMult = 0.015;
        } else if ($(elem).parents(".col.wide_tall").length > 0) {
          var yMult = 0.04;
          var xMult = 0.04;
        } else {
          var yMult = 0.045;
          var xMult = 0.075;
        }

        var bdst = bd.scrollTop || htm.scrollTop,
          bdsl = bd.scrollLeft,
          pageX = touchEnabled ? e.touches[0].pageX : e.pageX,
          pageY = touchEnabled ? e.touches[0].pageY : e.pageY,
          offsets = elem.getBoundingClientRect(),
          w = elem.clientWidth || elem.offsetWidth || elem.scrollWidth, // width
          h = elem.clientHeight || elem.offsetHeight || elem.scrollHeight, // height
          wMultiple = 320 / w,
          offsetX = 0.52 - (pageX - offsets.left - bdsl) / w, //cursor position X
          offsetY = 0.52 - (pageY - offsets.top - bdst) / h, //cursor position Y
          dy = pageY - offsets.top - bdst - h / 2, //@h/2 = center of container
          dx = pageX - offsets.left - bdsl - w / 2, //@w/2 = center of container
          yRotate = (offsetX - dx) * (yMult * wMultiple), //rotation for container Y
          xRotate = (dy - offsetY) * (xMult * wMultiple); //rotation for container X //old

        //imgCSS = ' rotateX(' + xRotate + 'deg) rotateY(' + yRotate + 'deg) translateZ(0)'; //img transform
        if ($(elem).parents(".wpb_gallery").length > 0) {
          var imgCSS =
            " perspective(" +
            w * 3 +
            "px) rotateX(" +
            -xRotate * 1.9 +
            "deg) rotateY(" +
            -yRotate * 1.3 +
            "deg)"; //img transform
        } else {
          if (
            $(elem).parents(".wide_tall").length == 0 &&
            $(elem).parents(".wide").length == 0 &&
            $(elem).parents(".tall").length == 0
          ) {
            var imgCSS =
              " perspective(" +
              w * 3 +
              "px) rotateX(" +
              xRotate +
              "deg) rotateY(" +
              yRotate +
              "deg)  translateY(" +
              offsetY * -10 +
              "px) translateX(" +
              offsetX * -10 +
              "px) scale(1.03)"; //img transform
          } else {
            var imgCSS =
              " perspective(" +
              w * 3 +
              "px) rotateX(" +
              xRotate +
              "deg) rotateY(" +
              yRotate +
              "deg)  translateY(" +
              offsetY * -10 +
              "px) translateX(" +
              offsetX * -10 +
              "px) scale(1.013)"; //img transform
          }
        }
        //imgCSS2 = 'perspective('+ w*3 +'px) rotateX(' + xRotate + 'deg) rotateY(' + yRotate + 'deg) translateZ(0) translateY('+offsetY*-10+'px) translateX('+offsetX*-10+'px)'; //img transform //old

        //container transform
        if (elem.firstChild.className.indexOf(" over") != -1) {
          if ($(elem).parents(".portfolio-items.masonry-items").length > 0) {
            //imgCSS2 = ' scale3d(1.025,1.025,1.025)';
          } else {
            //imgCSS2 = ' scale3d(1.06,1.06,1.06)';
          }
        }

        //elem.firstChild.style.transform = imgCSS;
        $(elem).find(".parallaxImg-container").css("transform", imgCSS);

        if (
          !(
            navigator.userAgent.indexOf("Safari") != -1 &&
            navigator.userAgent.indexOf("Chrome") == -1
          )
        ) {
          $(elem)
            .parents(".parallaxImg-wrap")
            .find(".parallaxImg-shadow")
            .css("transform", imgCSS);
        }
        //elem.style.transform = imgCSS2;
      }

      function processShineMovement(
        e,
        touchEnabled,
        elem,
        layers,
        totalLayers,
        shine
      ) {
        var bdst = bd.scrollTop || htm.scrollTop,
          bdsl = bd.scrollLeft,
          pageX = touchEnabled ? e.touches[0].pageX : e.pageX,
          pageY = touchEnabled ? e.touches[0].pageY : e.pageY,
          offsets = elem.getBoundingClientRect(),
          w = elem.clientWidth || elem.offsetWidth || elem.scrollWidth, // width
          h = elem.clientHeight || elem.offsetHeight || elem.scrollHeight, // height
          wMultiple = 320 / w,
          offsetX = 0.52 - (pageX - offsets.left - bdsl) / w, //cursor position X
          offsetY = 0.52 - (pageY - offsets.top - bdst) / h, //cursor position Y
          dy = pageY - offsets.top - bdst - h / 2, //@h/2 = center of container
          dx = pageX - offsets.left - bdsl - w / 2, //@w/2 = center of container
          yRotate = (offsetX - dx) * (0.04 * wMultiple), //rotation for container Y
          xRotate = (dy - offsetY) * (0.07 * wMultiple), //rotation for container X
          arad = Math.atan2(dy, dx), //angle between cursor and center of container in RAD
          angle = (arad * 180) / Math.PI - 90; //convert rad in degrees

        //get angle between 0-360
        if (angle < 0) {
          angle = angle + 360;
        }

        //gradient angle and opacity for shine
        shine.style.background =
          "linear-gradient(" +
          angle +
          "deg, rgba(255,255,255," +
          ((pageY - offsets.top - bdst) / h) * 0.3 +
          ") 0%,rgba(255,255,255,0) 80%)";
        shine.style.transform =
          "translateX(" +
          offsetX * totalLayers -
          0.1 +
          "px) translateY(" +
          offsetY * totalLayers -
          0.1 +
          "px) ";
      }

      function processEnter(e, elem, layers, totalLayers, shine) {
        //var sAgent = window.navigator.userAgent;
        //var Idx = sAgent.indexOf("Edge");

        elem.firstChild.className += " over";
        elem.className += " over";

        //if(Idx == -1) {
        //$('body').addClass('cssreflections');
        //$(elem).addClass('transition');
        //	//var $timeout = setTimeout(function(){ $(elem).removeClass('transition'); },150);
        //} else {
        $(elem).addClass("transition");

        if ($(elem).parents(".wpb_gallery").length > 0) {
          var $timeout = setTimeout(function () {
            $(elem).removeClass("transition");
          }, 450);
        } else {
          var $timeout = setTimeout(function () {
            $(elem).removeClass("transition");
          }, 200);
        }
        //}

        //depths(false, elem, layers, totalLayers, shine);
      }

      function processExit(e, elem, layers, totalLayers, shine) {
        var w = elem.clientWidth || elem.offsetWidth || elem.scrollWidth;
        var container = elem.firstChild;

        container.className = container.className.replace(" over", "");
        elem.className = elem.className.replace(" over", "");
        $(container).css(
          "transform",
          "perspective(" +
            w * 3 +
            "px) rotateX(0deg) rotateY(0deg) translateZ(0)"
        );
        $(elem)
          .parents(".parallaxImg-wrap")
          .find(".parallaxImg-shadow")
          .css(
            "transform",
            "perspective(" +
              w * 3 +
              "px) rotateX(0deg) rotateY(0deg) translateZ(0)"
          );
        //elem.style.transform = 'perspective('+ w*3 +'px) rotateX(0deg) rotateY(0deg) translateZ(0) translateX(0) translateY(0)';
        //shine.style.cssText = '';

        //for(var ly=0;ly<totalLayers;ly++){
        //layers[ly].style.transform = '';
        //}

        $(elem).addClass("transition");
        var $timeout = setTimeout(function () {
          $(elem).removeClass("transition");
        }, 200);

        //removeDepths(false, elem, layers, totalLayers, shine);
      }

      function depths(touchEnabled, elem, layers, totalLayers, shine) {
        var w = elem.clientWidth || elem.offsetWidth || elem.scrollWidth;
        var revNum = totalLayers;
        var container = elem.firstChild;

        //set z
        for (var ly = 0; ly < totalLayers; ly++) {
          //layers[ly].style.transform = 'translateX(' + (offsetX * revNum) * ((ly * 2.5) / wMultiple) + 'px) translateY(' + (offsetY * totalLayers) * ((ly * 2.5) / wMultiple) + 'px) translateZ(0)';
          if (ly == 0) $(layers[ly]).css("transform", "translateZ(0px)");
          else
            $(layers[ly]).css(
              "transform",
              "translateZ(" + ((w * 3) / 27) * (ly * 1.1) + "px) "
            );

          revNum--;
        }

        totalLayers = totalLayers + 3;

        //set perspective from beginning
        $(container).css("transform", "perspective(" + w * 3 + "px)");

        //$(elem).parents('.col').find('.parallaxImg-shine').css('transform','translateZ('+(w*3)/70*(totalLayers*1.1) +'px)');
      }

      function removeDepths(touchEnabled, elem, layers, totalLayers, shine) {
        var w = elem.clientWidth || elem.offsetWidth || elem.scrollWidth;
        var revNum = totalLayers;

        //set z
        for (var ly = 0; ly < totalLayers; ly++) {
          if (ly == 0)
            $(layers[ly]).css(
              "transform",
              "translateZ(" + ((w * 3) / 45) * (ly * 1.1) + "px) scale(1)"
            );
          else
            $(layers[ly]).css(
              "transform",
              "translateZ(" + ((w * 3) / 45) * (ly * 1.1) + "px) scale(1)"
            );

          revNum--;
        }

        totalLayers = totalLayers + 3;
      }
    }

    style6Img();

    function portfolioDeviceCheck() {
      if (
        $("body").hasClass("mobile") ||
        navigator.userAgent.match(/(iPad|IEMobile)/)
      ) {
        //if using more details
        if (
          $(".portfolio-items .col .work-item").find('a:not(".pp")').length > 0
        ) {
          $(".portfolio-items .col .work-item")
            .find("a.pp")
            .css("display", "none");
        }

        //if only using pp
        else {
          $(".portfolio-items .col .work-item")
            .find('a:not(".pp")')
            .css("display", "none");
        }
      } else {
        $(".portfolio-items .col .work-item")
          .find("a")
          .css("display", "inline");
      }
    }

    //portfolio fullscreen zoom slider

    //remove outside of column setups
    $(".nectar_fullscreen_zoom_recent_projects").each(function () {
      if ($(this).parents(".span_12").find("> .wpb_column").length > 1) {
        var $zoomProjects = $(this).clone();
        var $zoomProjectsRow = $(this).parents(".span_12");
        $(this).remove();
        $zoomProjectsRow.prepend($zoomProjects);
      }
    });

    $.fn.lines = function (opts) {
      var s = $.extend(
        {
          lineClass: "line",
        },
        opts
      );
      return this.each(function () {
        var self = this,
          $self = $(self),
          $line,
          $prev;
        $self
          .find("." + s.lineClass)
          .contents()
          .unwrap();
        $self.html(function (i, h) {
          return h.replace(
            /(\b[\w']+\b)/g,
            '<span class="' + s.lineClass + '">$1</span>'
          );
        });

        $self.find(".line + .line").each(function (i, el) {
          ($line = $(this)), ($prev = $line.prev(".line"));
          if ($line.offset().top === $prev.offset().top) {
            $prev.append(el.previousSibling, $line.contents());
            $line.remove();
          }
        });
      });
    };

    function portfolioFullScreenText() {
      $(".nectar_fullscreen_zoom_recent_projects").each(function () {
        $(this)
          .find(".project-slide")
          .each(function (i) {
            $(this).find(".project-info h1 > span > span.inner").unwrap();

            $(this)
              .find(".project-info h1 > span")
              .each(function () {
                var spantext = $(this).text();
                $(this).replaceWith(spantext);
              });

            var spanInserted = $(this)
              .find(".project-info h1")
              .html()
              .split(" ")
              .join(" </span> <span>");
            var wrapped = "<span>".concat(spanInserted, "</span>");
            $(this).find(".project-info h1").html(wrapped);
            var refPos = $(this)
              .find(".project-info h1 > span:first-child")
              .position().top;
            var newPos;

            $(this)
              .find(".project-info h1 > span")
              .each(function (index) {
                if ($(this).text().trim().length > 0) {
                  newPos = $(this).position().top;

                  if (index == 0) {
                    return;
                  }
                  if (newPos == refPos) {
                    $(this).prepend($(this).prev().text());
                    $(this).prev().remove();
                  }
                  refPos = newPos;
                } else {
                  //remove empty space spans
                  $(this).remove();
                }
              });

            $(this)
              .find(".project-info h1 > span")
              .wrapInner('<span class="inner" />');
          });
      });
    }

    function portfolioFullScreenSliderCalcs() {
      var $bodyBorderSize =
        $(".body-border-top").length > 0 && $(window).width() > 1000
          ? $(".body-border-top").height()
          : 0;

      $(".nectar_fullscreen_zoom_recent_projects").each(function () {
        if ($(this).parents(".first-section").length > 0) {
          $(this).css(
            "height",
            $(window).height() - $(this).offset().top - $bodyBorderSize
          );
        } else {
          $(this).css("height", $(window).height());
        }
      });
    }

    function portfolioSliderRotate(slider) {
      var $slideLength = slider.find(".dot-nav > span").length;
      var $currentSlide = slider.find(".dot-nav > span.active").index();
      if ($currentSlide + 1 == $slideLength) {
        slider.find(".dot-nav > span:first-child").click();
      } else {
        slider.find(".dot-nav > span.active").next("span").click();
      }
    }

    function portfolioSliderResetRotate(slider) {
      clearInterval($portfolioSliderRotate);

      //reinit autorotate
      if (slider.attr("data-autorotate").length > 0) {
        slide_interval =
          parseInt(slider.attr("data-autorotate")) < 100
            ? 4000
            : parseInt(slider.attr("data-autorotate"));
        $portfolioSliderRotate = setInterval(function () {
          portfolioSliderRotate(slider);
        }, slide_interval);
      }
    }

    var $portfolioSliderRotate;

    if ($(".nectar_fullscreen_zoom_recent_projects").length > 0) {
      portfolioFullScreenSliderCalcs();
      portfolioFullScreenText();
      $(window).resize(portfolioFullScreenText);
      $(window).resize(portfolioFullScreenSliderCalcs);
    }

    $(".nectar_fullscreen_zoom_recent_projects").each(function () {
      var $projLength = $(this).find(".project-slide").length;

      //autorotate
      if ($(this).attr("data-autorotate").length > 0) {
        slide_interval =
          parseInt($(this).attr("data-autorotate")) < 100
            ? 4000
            : parseInt($(this).attr("data-autorotate"));
        var $that = $(this);
        $portfolioSliderRotate = setInterval(function () {
          portfolioSliderRotate($that);
        }, slide_interval);
      }

      //next/prev
      $(this)
        .find(".zoom-slider-controls .next")
        .click(function () {
          //thres

          var $that = $(this);
          if (!$that.parent().hasClass("timeout")) {
            setTimeout(function () {
              $that.parent().removeClass("timeout");
            }, 1150);
          }

          if ($(this).parent().hasClass("timeout")) return false;
          $(this).parent().addClass("timeout");
          //switch logic

          portfolioSliderResetRotate(
            $that.parents(".nectar_fullscreen_zoom_recent_projects")
          );

          var $current = $(this)
            .parents(".nectar_fullscreen_zoom_recent_projects")
            .find(".project-slide.current");
          var $sliderInstance = $(this).parents(
            ".nectar_fullscreen_zoom_recent_projects"
          );

          $sliderInstance
            .find(".project-slide")
            .removeClass("next")
            .removeClass("prev");
          $sliderInstance.find(".project-slide").each(function (i) {
            if (i < $current.index() + 1 && $current.index() + 1 < $projLength)
              $(this).addClass("prev");
            else $(this).addClass("next");
          });

          if ($current.index() + 1 == $projLength) {
            $sliderInstance
              .find(".project-slide:first-child")
              .addClass("no-trans");
          }

          setTimeout(function () {
            if ($current.index() + 1 == $projLength) {
              $sliderInstance
                .find(".project-slide:first-child")
                .removeClass("no-trans")
                .removeClass("next")
                .removeClass("prev")
                .addClass("current");
              $sliderInstance
                .find(".project-slide:last-child")
                .removeClass("next")
                .removeClass("current")
                .addClass("prev");
            } else {
              $current
                .next(".project-slide")
                .removeClass("next")
                .removeClass("prev")
                .addClass("current");
              $current.removeClass("current").addClass("prev");
            }

            //update dot nav
            if ($sliderInstance.find(".dot-nav").length > 0) {
              $sliderInstance
                .find(".dot-nav span.active")
                .removeClass("active");
              $sliderInstance
                .find(
                  ".dot-nav span:nth-child(" +
                    ($sliderInstance.find(".project-slide.current").index() +
                      1) +
                    ")"
                )
                .addClass("active");
            }
          }, 30);

          return false;
        });

      $(this)
        .find(".zoom-slider-controls .prev")
        .click(function () {
          //thres
          var $that = $(this);
          if (!$that.parent().hasClass("timeout")) {
            setTimeout(function () {
              $that.parent().removeClass("timeout");
            }, 1150);
          }

          if ($(this).parent().hasClass("timeout")) return false;
          $(this).parent().addClass("timeout");

          portfolioSliderResetRotate(
            $that.parents(".nectar_fullscreen_zoom_recent_projects")
          );

          //switch logic
          var $current = $(this)
            .parents(".nectar_fullscreen_zoom_recent_projects")
            .find(".project-slide.current");
          var $sliderInstance = $(this).parents(
            ".nectar_fullscreen_zoom_recent_projects"
          );

          $sliderInstance
            .find(".project-slide")
            .removeClass("next")
            .removeClass("prev");
          $sliderInstance.find(".project-slide").each(function (i) {
            if (i < $current.index() || $current.index() == 0)
              $(this).addClass("prev");
            else $(this).addClass("next");
          });

          if ($current.index() == 0)
            $sliderInstance
              .find(".project-slide:last-child")
              .addClass("no-trans");

          setTimeout(function () {
            if ($current.index() == 0) {
              $sliderInstance
                .find(".project-slide:last-child")
                .removeClass("no-trans")
                .removeClass("next")
                .removeClass("prev")
                .addClass("current");
              $sliderInstance
                .find(".project-slide:first-child")
                .removeClass("next")
                .removeClass("prev")
                .removeClass("current")
                .addClass("next");
            } else {
              $current
                .prev(".project-slide")
                .removeClass("next")
                .removeClass("prev")
                .addClass("current");
              $current.removeClass("current").addClass("next");
            }

            //update dot nav
            if ($sliderInstance.find(".dot-nav").length > 0) {
              $sliderInstance
                .find(".dot-nav span.active")
                .removeClass("active");
              $sliderInstance
                .find(
                  ".dot-nav span:nth-child(" +
                    ($sliderInstance.find(".project-slide.current").index() +
                      1) +
                    ")"
                )
                .addClass("active");
            }
          }, 30);

          return false;
        });

      //pagination
      //if($(this).is('[data-slider-controls="both"]') || $(this).is('[data-slider-controls="pagination"]')) {
      $(this).find("> .normal-container").append('<div class="dot-nav"></div>');
      for (var $i = 0; $i < $projLength; $i++) {
        if ($i == 0) {
          $(this)
            .find(".dot-nav")
            .append('<span class="dot active"><span></span></span>');
        } else {
          $(this)
            .find(".dot-nav")
            .append('<span class="dot"><span></span></span>');
        }
      }
      //}

      var $dotIndex = 1;

      $(".nectar_fullscreen_zoom_recent_projects .dot-nav > span").click(
        function () {
          if ($(this).hasClass("active")) return;

          //thres
          var $that = $(this);
          if (!$that.parent().hasClass("timeout")) {
            setTimeout(function () {
              $that.parent().removeClass("timeout");
            }, 1150);
          }

          if ($(this).parent().hasClass("timeout")) return;
          $(this).parent().addClass("timeout");

          portfolioSliderResetRotate(
            $that.parents(".nectar_fullscreen_zoom_recent_projects")
          );

          //switch logic
          $(this).parent().find("span.active").removeClass("active");
          $(this).addClass("active");

          $dotIndex = $(this).index() + 1;

          var $current = $(this)
            .parents(".nectar_fullscreen_zoom_recent_projects")
            .find(".project-slide.current");
          var $sliderInstance = $(this).parents(
            ".nectar_fullscreen_zoom_recent_projects"
          );

          var $prevIndex = $current.index() + 1;

          $sliderInstance
            .find(".project-slide")
            .removeClass("next")
            .removeClass("prev");

          $sliderInstance.find(".project-slide").each(function (i) {
            if (i < $dotIndex - 1) $(this).addClass("prev");
            else $(this).addClass("next");
          });

          //going prev
          if ($prevIndex > $dotIndex) {
            $sliderInstance
              .find(".project-slide")
              .eq($dotIndex - 1)
              .addClass("no-trans")
              .addClass("prev")
              .removeClass("next");
            setTimeout(function () {
              $sliderInstance
                .find(".project-slide")
                .eq($dotIndex - 1)
                .removeClass("no-trans")
                .removeClass("next")
                .removeClass("prev")
                .addClass("current");
              $current.removeClass("current").addClass("next");
            }, 30);
          }

          //going forawrd
          else {
            $sliderInstance
              .find(".project-slide")
              .eq($dotIndex - 1)
              .addClass("no-trans")
              .addClass("next")
              .removeClass("prev");
            setTimeout(function () {
              $sliderInstance
                .find(".project-slide")
                .eq($dotIndex - 1)
                .removeClass("no-trans")
                .removeClass("next")
                .removeClass("prev")
                .addClass("current");
              $current.removeClass("current").addClass("prev");
            }, 30);
          }
        }
      );
    });

    //portfolio accent color
    function portfolioAccentColor() {
      var portfolioSocialColorCss = "";

      $(".portfolio-items .col").each(function () {
        if ($(this).has("[data-project-color]")) {
          $(this)
            .find(".work-info-bg, .bottom-meta")
            .css("background-color", $(this).attr("data-project-color"));

          //style5
          $(this)
            .find(".parallaxImg-rendered-layer .bg-overlay")
            .css("border-color", $(this).attr("data-project-color"));

          var $projColor = $(this).attr("data-project-color");
          if (
            $(this).find(".custom-content .nectar-social").length > 0 &&
            $('body[data-button-style="rounded"]')
          )
            portfolioSocialColorCss +=
              'body[data-button-style="rounded"] .col[data-project-color="' +
              $projColor +
              '"] .custom-content .nectar-social > *:hover i { color: ' +
              $projColor +
              "!important; } ";
        }
      });

      if (portfolioSocialColorCss.length > 1) {
        var head = document.head || document.getElementsByTagName("head")[0];
        var style = document.createElement("style");

        style.type = "text/css";
        if (style.styleSheet) {
          style.styleSheet.cssText = portfolioSocialColorCss;
        } else {
          style.appendChild(document.createTextNode(portfolioSocialColorCss));
        }

        head.appendChild(style);
      }
    }
    portfolioAccentColor();

    //portfolio sort
    $("body").on("mouseenter", ".portfolio-filters", function () {
      $(this).find("> ul").stop(true, true).slideDown(500, "easeOutExpo");
      $(this)
        .find("a#sort-portfolio span")
        .html($(this).find("a#sort-portfolio").attr("data-sortable-label"));
    });

    $("body").on("mouseleave", ".portfolio-filters", function () {
      var $activeCat = $(this).find("a.active").html();
      if (typeof $activeCat == "undefined" || $activeCat.length == 0)
        $activeCat = $(this).attr("data-sortable-label");
      $(this).find("a#sort-portfolio span").html($activeCat);
      $(this).find("> ul").stop(true, true).slideUp(500, "easeOutExpo");
    });

    //portfolio selected category
    $("body").on("click", ".portfolio-filters ul li a", function () {
      $(this)
        .parents(".portfolio-filters")
        .find("#sort-portfolio span")
        .html($(this).html());
    });

    //inline portfolio selected category
    $("body").on("click", ".portfolio-filters-inline ul li a", function () {
      $(this).parents("ul").find("li a").removeClass("active");
      $(this).addClass("active");
      $(this)
        .parents(".portfolio-filters-inline")
        .find("#current-category")
        .html($(this).html());
    });

    function portfolioFiltersInit() {
      //mobile sort menu fix
      if (
        $("body").hasClass("mobile") ||
        navigator.userAgent.match(/(iPad|IEMobile)/)
      ) {
        $(".portfolio-filters").unbind("mouseenter mouseleave");
        $(".portfolio-filters > a, .portfolio-filters ul li a").click(function (
          e
        ) {
          if (e.originalEvent !== undefined)
            $(this)
              .parents(".portfolio-filters")
              .find("> ul")
              .stop(true, true)
              .slideToggle(600, "easeOutCubic");
        });
      }

      if (
        $('.portfolio-filters-inline[data-alignment="left"]').length > 0 ||
        $('.portfolio-filters-inline[data-alignment="center"]').length > 0
      ) {
        $(
          ".portfolio-filters-inline .container > ul > li:nth-child(1) a"
        ).click();
      } else {
        $(
          ".portfolio-filters-inline .container > ul > li:nth-child(2) a"
        ).click();
      }

      //portfolio more details page menu highlight
      $(
        'body.single-portfolio #header-outer nav > ul > li > a:contains("Portfolio")'
      )
        .parents("li")
        .addClass("current-menu-item");

      //blog page highlight
      $('body.single-post #header-outer nav > ul > li > a:contains("Blog")')
        .parents("li")
        .addClass("current-menu-item");
    }

    portfolioFiltersInit();

    //blog love center
    function centerLove() {
      $(".post").each(function () {
        var $loveWidth = $(this).find(".post-meta .nectar-love").outerWidth();
        var $loveWrapWidth = $(this)
          .find(".post-meta  .nectar-love-wrap")
          .width();

        //center
        $(this)
          .find(".post-meta .nectar-love")
          .css("margin-left", $loveWrapWidth / 2 - $loveWidth / 2 + "px");
        $(this).find(".nectar-love-wrap").css("visibility", "visible");
      });
    }

    $(".nectar-love").on("click", function () {
      centerLove();
    });

    centerLove();

    //portfolio single comment order
    function portfolioCommentOrder() {
      if (
        $("body").hasClass("mobile") &&
        $("body").hasClass("single-portfolio") &&
        $("#respond").length > 0
      ) {
        $("#sidebar").insertBefore(".comments-section");
      } else if (
        $("body").hasClass("single-portfolio") &&
        $("#respond").length > 0
      ) {
        $("#sidebar").insertAfter("#post-area");
      }
    }

    portfolioCommentOrder();

    //portfolio sidebar follow

    var sidebarFollow = $(".single-portfolio #sidebar").attr(
      "data-follow-on-scroll"
    );

    function portfolioSidebarFollow() {
      sidebarFollow = $(".single-portfolio #sidebar").attr(
        "data-follow-on-scroll"
      );

      if (
        $("body.single-portfolio").length > 0 &&
        sidebarFollow == 1 &&
        !$("body").hasClass("mobile") &&
        parseInt($("#sidebar").height()) + 50 <=
          parseInt($("#post-area").height())
      ) {
        $("#sidebar").addClass("fixed-sidebar");

        var $footer =
          $(".comment-wrap.full-width-section").length == 0
            ? "#footer-outer"
            : ".comment-wrap";
        if ($("#call-to-action").length > 0) $footer = "#call-to-action";

        //convert width into px
        sidebarPxConversion();

        $("#sidebar").stickyMojo({
          footerID: $footer,
          contentID: "#post-area",
        });
      }
    }

    function sidebarPxConversion() {
      if (
        $("body.single-portfolio").length > 0 &&
        sidebarFollow == 1 &&
        !$("body").hasClass("mobile")
      ) {
        var $containerWidth = $(".main-content > .row").width();
        var $sidebarWidth = $containerWidth * 0.235;

        if (window.innerWidth > 1300) {
          $sidebarWidth = $containerWidth * 0.235;
        } else if (window.innerWidth < 1300 && window.innerWidth > 1000) {
          $sidebarWidth = $containerWidth * 0.273;
        }

        $("#sidebar").css("width", $sidebarWidth + "px");
      }
    }

    $(window).load(function () {
      setTimeout(portfolioSidebarFollow, 200);
    });

    //remove the portfolio filters that are not found in the current page
    function isotopeCatSelection() {
      $('.portfolio-items:not(".carousel")').each(function () {
        var isotopeCatArr = [];
        var $portfolioCatCount = 0;
        $(this)
          .parent()
          .parent()
          .find("div[class^=portfolio-filters] ul li")
          .each(function (i) {
            if ($(this).find("a").length > 0) {
              isotopeCatArr[$portfolioCatCount] = $(this)
                .find("a")
                .attr("data-filter")
                .substring(1);
              $portfolioCatCount++;
            }
          });

        ////ice the first (all)
        isotopeCatArr.shift();

        var itemCats = "";

        $(this)
          .find("> div")
          .each(function (i) {
            itemCats += $(this).attr("data-project-cat");
          });
        itemCats = itemCats.split(" ");

        ////remove the extra item on the end of blank space
        itemCats.pop();

        ////make sure the array has no duplicates
        itemCats = $.unique(itemCats);

        ////if user has chosen a set of filters to display - only show those
        if (
          $(this).attr("data-categories-to-show").length != 0 &&
          $(this).attr("data-categories-to-show") != "all"
        ) {
          $userSelectedCats = $(this)
            .attr("data-categories-to-show")
            .replace(/,/g, " ");
          $userSelectedCats = $userSelectedCats.split(" ");

          if (!$(this).hasClass("infinite_scroll"))
            $(this).removeAttr("data-categories-to-show");
        } else {
          $userSelectedCats = itemCats;
        }

        ////Find which categories are actually on the current page
        var notFoundCats = [];
        $.grep(isotopeCatArr, function (el) {
          if ($.inArray(el, itemCats) == -1) notFoundCats.push(el);
          if ($.inArray(el, $userSelectedCats) == -1) notFoundCats.push(el);
        });

        //manipulate the list
        if (notFoundCats.length != 0) {
          $(this)
            .parent()
            .parent()
            .find("div[class^=portfolio-filters] ul li")
            .each(function () {
              if ($(this).find("a").length > 0) {
                if (
                  $.inArray(
                    $(this).find("a").attr("data-filter").substring(1),
                    notFoundCats
                  ) != -1
                ) {
                  $(this).hide();
                } else {
                  $(this).show();
                }
              }
            });
        }
      });
    }

    isotopeCatSelection();

    //sharing buttons

    var completed = 0;
    var windowLocation = window.location.href.replace(window.location.hash, "");

    function facebookShare() {
      windowLocation = window.location.href.replace(window.location.hash, "");
      window.open(
        "https://www.facebook.com/sharer/sharer.php?u=" + windowLocation,
        "facebookWindow",
        "height=380,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0"
      );
      return false;
    }

    function googlePlusShare() {
      windowLocation = window.location.href.replace(window.location.hash, "");
      window.open(
        "https://plus.google.com/share?url=" + windowLocation,
        "googlePlusWindow",
        "height=380,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0"
      );
      return false;
    }

    function twitterShare() {
      windowLocation = window.location.href.replace(window.location.hash, "");
      if ($(".section-title h1").length > 0) {
        var $pageTitle = encodeURIComponent($(".section-title h1").text());
      } else {
        var $pageTitle = encodeURIComponent($(document).find("title").text());
      }
      window.open(
        "http://twitter.com/intent/tweet?text=" +
          $pageTitle +
          " " +
          windowLocation,
        "twitterWindow",
        "height=380,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0"
      );
      return false;
    }

    function wooTwitterShare() {
      windowLocation = window.location.href.replace(window.location.hash, "");
      window.open(
        "http://twitter.com/intent/tweet?text=" +
          $("h1.product_title").text() +
          " " +
          windowLocation,
        "twitterWindow",
        "height=380,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0"
      );
      return false;
    }

    function linkedInShare() {
      windowLocation = window.location.href.replace(window.location.hash, "");
      if ($(".section-title h1").length > 0) {
        var $pageTitle = encodeURIComponent($(".section-title h1").text());
      } else {
        var $pageTitle = encodeURIComponent($(document).find("title").text());
      }
      window.open(
        "http://www.linkedin.com/shareArticle?mini=true&url=" +
          windowLocation +
          "&title=" +
          $pageTitle +
          "",
        "linkedInWindow",
        "height=480,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0"
      );
      return false;
    }

    function woolinkedInShare() {
      windowLocation = window.location.href.replace(window.location.hash, "");
      window.open(
        "http://www.linkedin.com/shareArticle?mini=true&url=" +
          windowLocation +
          "&title=" +
          $("h1.product_title").text(),
        "twitterWindow",
        "height=380,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0"
      );
      return false;
    }

    function pinterestShare() {
      windowLocation = window.location.href.replace(window.location.hash, "");
      var $sharingImg =
        $(".single-portfolio").length > 0 &&
        $("div[data-featured-img]").attr("data-featured-img") != "empty"
          ? $("div[data-featured-img]").attr("data-featured-img")
          : $("#ajax-content-wrap img").first().attr("src");

      if ($(".section-title h1").length > 0) {
        var $pageTitle = encodeURIComponent($(".section-title h1").text());
      } else {
        var $pageTitle = encodeURIComponent($(document).find("title").text());
      }

      window.open(
        "http://pinterest.com/pin/create/button/?url=" +
          windowLocation +
          "&media=" +
          $sharingImg +
          "&description=" +
          $pageTitle,
        "pinterestWindow",
        "height=640,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0"
      );
      return false;
    }

    function wooPinterestShare() {
      $imgToShare =
        $("img.attachment-shop_single").length > 0
          ? $("img.attachment-shop_single").first().attr("src")
          : $(".single-product-main-image img").first().attr("src");
      windowLocation = window.location.href.replace(window.location.hash, "");
      window.open(
        "http://pinterest.com/pin/create/button/?url=" +
          windowLocation +
          "&media=" +
          $imgToShare +
          "&description=" +
          $("h1.product_title").text(),
        "pinterestWindow",
        "height=640,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0"
      );
      return false;
    }

    function socialFade() {
      if (
        completed == $("a.nectar-sharing").length &&
        $("a.nectar-sharing").parent().hasClass("in-sight")
      ) {
        //$timeout = ($('#page-header-bg[data-animate-in-effect="slide-down"] .nectar-social').length > 0 ) ? 500 : 1;
        //	setTimeout(function(){
        //$('.nectar-social > a').stop(true,true).transition({'padding-right':'15px'},350,'easeOutSine');

        //love fadein
        $(".nectar-social .nectar-love span").show(
          350,
          "easeOutSine",
          function () {
            $(this).stop().animate({ opacity: 1 }, 800);
          }
        );

        //sharing loadin
        $(".nectar-social > a").each(function (i) {
          var $that = $(this);

          $(this)
            .find("> span")
            .show(350, "easeOutSine", function () {
              $that.find("> span").stop().animate({ opacity: 1 }, 800);
            });
        });
        //},$timeout);

        //alt blog layout total share count
        var $totalShares = 0;
        $(".nectar-social > a .count").each(function () {
          $totalShares += parseInt($(this).html());
        });

        if ($totalShares != 1) {
          $(".single .meta-share-count .plural").css({
            opacity: "1",
            display: "inline",
          });
          $(".single .meta-share-count .singular").remove();
        } else {
          $(".single .meta-share-count .singular").css({
            opacity: "1",
            position: "relative",
            display: "inline",
          });
          $(".single .meta-share-count .plural").remove();
        }

        $(".meta-share-count .share-count-total")
          .html($totalShares)
          .css("opacity", 1);
      }
    }

    $("body").on("click", "#single-below-header .nectar-social a", function () {
      return false;
    });

    $("body").on("click", ".facebook-share:not(.inactive)", facebookShare);
    $("body").on("click", ".google-plus-share:not(.inactive)", googlePlusShare);
    $("body").on(
      "click",
      '.nectar-social:not(".woo") .twitter-share:not(.inactive)',
      twitterShare
    );
    $("body").on("click", ".nectar-social.woo .twitter-share", wooTwitterShare);
    $("body").on(
      "click",
      '.nectar-social:not(".woo") .linkedin-share:not(.inactive)',
      linkedInShare
    );
    $("body").on(
      "click",
      ".nectar-social.woo .linkedin-share",
      woolinkedInShare
    );
    $("body").on(
      "click",
      '.nectar-social:not(".woo") .pinterest-share:not(.inactive)',
      pinterestShare
    );
    $("body").on(
      "click",
      ".nectar-social.woo .pinterest-share",
      wooPinterestShare
    );
    $("body").on("click", ".nectar-social-sharing-fixed > a", function () {
      return false;
    });

    function socialSharingInit() {
      //mobile fullscreen blog class for click event fix
      if (
        $("body").hasClass("mobile") &&
        $(".single-post .fullscreen-header").length > 0
      ) {
        $(
          "#single-below-header .nectar-social .nectar-sharing, #single-below-header .nectar-social .nectar-sharing-alt"
        ).addClass("inactive");
      }

      completed = 0;

      if (
        $("a.facebook-share").length > 0 ||
        $("a.twitter-share").length > 0 ||
        $("a.google-plus-share").length > 0 ||
        $("a.linkedin-share").length > 0 ||
        $("a.pinterest-share").length > 0
      ) {
        ////facebook
        if (
          ($("a.facebook-share:not(.sharing-default-minimal a.facebook-share)")
            .length > 0 &&
            $('body[data-button-style="rounded"]').length == 0) ||
          $("#project-meta a.facebook-share").length > 0 ||
          $("#single-meta a.facebook-share").length > 0 ||
          $("#single-below-header .facebook-share").length > 0
        ) {
          //load share count on load
          $.getJSON(
            "https://graph.facebook.com/?id=" + windowLocation + "&callback=?",
            function (data) {
              if (
                data.share != undefined &&
                data.share.share_count != undefined &&
                data.share.share_count != 0 &&
                data.share.share_count != null
              ) {
                $(
                  ".facebook-share a span.count, a.facebook-share span.count"
                ).html(data.share.share_count);
              } else {
                $(
                  ".facebook-share a span.count, a.facebook-share span.count"
                ).html(0);
              }
              completed++;
              socialFade();
            }
          );
        } else if (
          ($("a.facebook-share").length > 0 &&
            $('body[data-button-style="rounded"]').length > 0) ||
          $(".sharing-default-minimal a.facebook-share").length > 0
        ) {
          completed++;
          socialFade();
        }

        ////twitter
        if (
          ($("a.twitter-share:not(.sharing-default-minimal a.twitter-share)")
            .length > 0 &&
            $('body[data-button-style="rounded"]').length == 0) ||
          $("#project-meta a.twitter-share").length > 0 ||
          $("#single-meta a.twitter-share").length > 0 ||
          $("#single-below-header .twitter-share").length > 0
        ) {
          //load tweet count on load
          //$.getJSON('https://cdn.api.twitter.com/1/urls/count.json?url='+windowLocation+'&callback=?', function(data) {
          //	if((data.count != 0) && (data.count != undefined) && (data.count != null)) {
          //	$('.twitter-share a span.count, a.twitter-share span.count').html( data.count );
          //}
          //else {
          $(".twitter-share a span.count, a.twitter-share span.count").html(0);
          //}
          completed++;
          socialFade();
          //});
        } else if (
          ($("a.twitter-share").length > 0 &&
            $('body[data-button-style="rounded"]').length > 0) ||
          $(".sharing-default-minimal a.twitter-share").length > 0
        ) {
          completed++;
          socialFade();
        }

        ////linkedIn
        if (
          ($("a.linkedin-share:not(.sharing-default-minimal a.linkedin-share)")
            .length > 0 &&
            $('body[data-button-style="rounded"]').length == 0) ||
          $("#project-meta a.linkedin-share").length > 0 ||
          $("#single-meta a.linkedin-share").length > 0 ||
          $("#single-below-header .linkedin-share").length > 0
        ) {
          //load share count on load
          //$.getJSON('https://www.linkedin.com/countserv/count/share?url='+windowLocation+'&callback=', function(data) {
          //	if((data.count != 0) && (data.count != undefined) && (data.count != null)) {
          //		$('.linkedin-share a span.count, a.linkedin-share span.count').html( data.count );
          //	}
          //	else {
          $(".linkedin-share a span.count, a.linkedin-share span.count").html(
            0
          );
          //	}
          completed++;
          socialFade();
          //});
        } else if (
          ($("a.linkedin-share").length > 0 &&
            $('body[data-button-style="rounded"]').length > 0) ||
          $(".sharing-default-minimal a.linkedin-share").length > 0
        ) {
          completed++;
          socialFade();
        }

        ////pinterest
        if (
          ($(
            "a.pinterest-share:not(.sharing-default-minimal a.pinterest-share)"
          ).length > 0 &&
            $('body[data-button-style="rounded"]').length == 0) ||
          $("#project-meta a.pinterest-share").length > 0 ||
          $("#single-meta a.pinterest-share").length > 0 ||
          $("#single-below-header .pinterest-share").length > 0
        ) {
          //load pin count on load
          $.getJSON(
            "https://api.pinterest.com/v1/urls/count.json?url=" +
              windowLocation +
              "&callback=?",
            function (data) {
              if (
                data.count != 0 &&
                data.count != undefined &&
                data.count != null
              ) {
                $(
                  ".pinterest-share a span.count, a.pinterest-share span.count"
                ).html(data.count);
              } else {
                $(
                  ".pinterest-share a span.count, a.pinterest-share span.count"
                ).html(0);
              }
              completed++;
              socialFade();
            }
          );
        } else if (
          ($("a.pinterest-share").length > 0 &&
            $('body[data-button-style="rounded"]').length > 0) ||
          $(".sharing-default-minimal a.pinterest-share").length > 0
        ) {
          completed++;
          socialFade();
        }

        //fadeIn
        $("a.nectar-sharing > span.count, a.nectar-sharing-alt > span.count")
          .hide()
          .css("width", "auto");

        //social light up

        $(".nectar-social").each(function () {
          if ($(this).parents(".custom-content").length == 0) {
            var $that = $(this);
            var waypoint = new Waypoint({
              element: $that,
              handler: function (direction) {
                $slide_timeout =
                  $(
                    '#page-header-bg[data-animate-in-effect="slide-down"] .nectar-social'
                  ).length > 0
                    ? 900
                    : 1;

                setTimeout(function () {
                  $that.addClass("in-sight");
                  socialFade();

                  if ($("#page-header-bg .nectar-social").length == 0) {
                    $that.find("> *").each(function (i) {
                      var $that = $(this);
                      var $timeout =
                        $('body[data-button-style="rounded"]').length > 0
                          ? 0
                          : 750;

                      setTimeout(function () {
                        $that.delay(i * 80).queue(function () {
                          var $that = $(this);
                          $(this).addClass("hovered");

                          setTimeout(function () {
                            $that.removeClass("hovered");
                          }, 300);
                        });
                      }, $timeout);
                    });
                  }
                }, $slide_timeout);

                $that.addClass("animated-in");
                waypoint.destroy();
              },
              offset: "bottom-in-view",
            });
          }
        });
      }
    }

    socialSharingInit();

    if (
      !navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
      )
    ) {
      var $socialTimeout;
      $("body").on(
        "mouseenter",
        "#single-meta .meta-share-count, #project-meta .meta-share-count",
        function () {
          clearTimeout($socialTimeout);

          if (
            $(this).parents('[id*="single-meta"]').length > 0 &&
            $('[data-tab-pos="fullwidth"]').length == 0
          )
            $(this)
              .find(".nectar-social")
              .show()
              .stop(true)
              .animate({ opacity: 1, right: "0px" }, 0);
          else
            $(this)
              .find(".nectar-social")
              .show()
              .stop(true)
              .animate({ opacity: 1, left: "0px" }, 0);

          $(this).parents('[id*="-meta"]').addClass("social-hovered");

          $(this)
            .parents('[id*="-meta"]')
            .find(
              ".n-shortcode a, .meta-comment-count a, .meta-share-count > a "
            )
            .stop(true)
            .animate({ opacity: 0 }, 250);
          $(this)
            .find(".nectar-social a")
            .each(function (i) {
              $(this)
                .stop(true)
                .delay(i * 40)
                .animate({ opacity: 1, left: "0px" }, 150);
            });
        }
      );

      $("body").on(
        "mouseleave",
        "#single-meta .meta-share-count, #project-meta .meta-share-count",
        function () {
          $(this).parents('[id*="-meta"]').removeClass("social-hovered");

          if (
            $(this).parents('[id*="single-meta"]').length > 0 &&
            $('[data-tab-pos="fullwidth"]').length == 0
          )
            $(this)
              .find(".nectar-social")
              .stop(true)
              .animate({ opacity: 0, right: "-20px" }, 200);
          else
            $(this)
              .find(".nectar-social")
              .stop(true)
              .animate({ opacity: 0, left: "-20px" }, 200);

          $(this)
            .parents('[id*="-meta"]')
            .find(
              ".n-shortcode a, .meta-comment-count a, .meta-share-count > a "
            )
            .stop(true)
            .animate({ opacity: 1 }, 250);

          var $that = $(this);

          $socialTimeout = setTimeout(function () {
            $that.find(".nectar-social").hide();
            if (
              $that.parents('[id*="single-meta"]').length > 0 &&
              $('[data-tab-pos="fullwidth"]').length == 0
            )
              $that
                .find(".nectar-social a")
                .stop(true)
                .animate({ opacity: 0, left: "20px" }, 0);
            else
              $that
                .find(".nectar-social a")
                .stop(true)
                .animate({ opacity: 0, left: "-20px" }, 0);
          }, 200);
        }
      );
    } else {
      var $socialTimeout;
      $("body").on(
        "click",
        "#single-meta .meta-share-count, #project-meta .meta-share-count",
        function () {
          clearTimeout($socialTimeout);

          if (
            $(this).parents('[id*="single-meta"]').length > 0 &&
            $('[data-tab-pos="fullwidth"]').length == 0
          )
            $(this)
              .find(".nectar-social")
              .show()
              .stop(true)
              .animate({ opacity: 1, right: "0px" }, 0);
          else
            $(this)
              .find(".nectar-social")
              .show()
              .stop(true)
              .animate({ opacity: 1, left: "0px" }, 0);

          $(this).parents('[id*="-meta"]').addClass("social-hovered");

          $(this)
            .parents('[id*="-meta"]')
            .find(
              ".n-shortcode a, .meta-comment-count a, .meta-share-count > a "
            )
            .stop(true)
            .animate({ opacity: 0 }, 250);
          $(this)
            .find(".nectar-social a")
            .each(function (i) {
              $(this)
                .stop(true)
                .delay(i * 40)
                .animate({ opacity: 1, left: "0px" }, 150);
            });

          return false;
        }
      );
    }

    $("body").on(
      "mouseenter",
      ".fullscreen-header  .meta-share-count",
      function () {
        $(this).find("> a, > i").stop(true).animate({ opacity: 0 }, 400);
        $(this)
          .find(".nectar-social > *")
          .each(function (i) {
            $(this)
              .stop(true)
              .delay(i * 50)
              .animate({ opacity: "1", top: "0px" }, 250, "easeOutCubic");
          });
        //allow clickable on mobile
        setTimeout(function () {
          $(
            ".meta-share-count .nectar-sharing, .meta-share-count .nectar-sharing-alt"
          ).removeClass("inactive");
        }, 300);
      }
    );

    if (
      !navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
      )
    ) {
      $("body").on(
        "mouseleave",
        ".fullscreen-header  .meta-share-count",
        function () {
          $(this)
            .find("> a, > i")
            .stop(true)
            .animate({ opacity: 1 }, 300, "easeInCubic");
          $(this)
            .find(".nectar-social > *")
            .each(function (i) {
              $(this)
                .stop(true)
                .animate({ opacity: "0", top: "10px" }, 200, "easeInCubic");
            });
        }
      );
    }

    //full width love center
    function nectarLoveFWCenter() {
      $(".nectar-social.full-width").each(function () {
        $(this)
          .find(".n-shortcode .nectar-love")
          .css("padding-top", $(this).find("> a").css("padding-top"));
      });
    }

    nectarLoveFWCenter();

    //-----------------------------------------------------------------
    // NectarLove
    //-----------------------------------------------------------------

    ////love iwth txt
    $(".fullscreen-header .nectar-love").each(function () {
      if ($(this).find(".nectar-love-count").text() == "1") {
        $(this)
          .find("span.love-txt.single")
          .css({ visibility: "visible", "text-indent": "0" });
        $(this)
          .find("span.love-txt.plural")
          .css({ visibility: "hidden", "text-indent": "-9999px" });
      } else {
        $(this)
          .find("span.love-txt.single")
          .css({ visibility: "hidden", "text-indent": "-9999px" });
        $(this)
          .find("span.love-txt.plural")
          .css({ visibility: "visible", "text-indent": "0" });
      }
    });

    $("body").on("click", ".nectar-love", function () {
      var $loveLink = $(this);
      var $id = $(this).attr("id");
      var $that = $(this);

      if ($loveLink.hasClass("loved")) return false;
      if ($(this).hasClass("inactive")) return false;

      var $dataToPass = {
        action: "nectar-love",
        loves_id: $id,
        love_nonce: nectarLove.loveNonce,
      };

      $.post(nectarLove.ajaxurl, $dataToPass, function (data) {
        $loveLink.find("span:not(.love-txt)").html(data);
        $loveLink.addClass("loved").attr("title", "You already love this!");
        $loveLink
          .find("span:not(.love-txt)")
          .css({ opacity: 1, width: "auto" });

        if ($(data).text() == "1") {
          $loveLink
            .find("span.love-txt.single")
            .css({ visibility: "visible", "text-indent": "0" });
          $loveLink
            .find("span.love-txt.plural")
            .css({ visibility: "hidden", "text-indent": "-9999px" });
        } else {
          $loveLink
            .find("span.love-txt.single")
            .css({ visibility: "hidden", "text-indent": "-9999px" });
          $loveLink
            .find("span.love-txt.plural")
            .css({ visibility: "visible", "text-indent": "0" });
        }

        //ascend
        if (
          $("body").hasClass("ascend") &&
          $that.parents(".classic_enhanced").length == 0
        ) {
          //$loveLink.find('.icon-salient-heart.loved').show().transition({ scale: 1 },800,'cubic-bezier(0.15, 0.84, 0.35, 1.5)');
          //setTimeout(function(){ $loveLink.find('.icon-salient-heart-2').css('opacity','0'); },400);
          //if($loveLink.parents('.sharing-default-minimal').length > 0 && $loveLink.parents('.bottom-meta').length >0 ) $loveLink.find('.icon-salient-heart-2').remove();
          $that.find(".icon-salient-heart-2").addClass("loved");
        } else if ($that.parents(".classic_enhanced").length > 0) {
          $that.find(".icon-salient-heart-2").addClass("loved");
        }
      });

      $(this).addClass("inactive");

      return false;
    });

    //infinite scroll
    function infiniteScrollInit() {
      if ($(".infinite_scroll").length > 0) {
        //portfolio
        $(".portfolio-items.infinite_scroll").infinitescroll(
          {
            navSelector: "div#pagination",
            nextSelector: "div#pagination a:first",
            itemSelector: ".portfolio-items.infinite_scroll .element",
            finishedMsg:
              "<em>Congratulations, you've reached the end of the internet.</em>",
            msgText: " ",
          },
          function (newElements) {
            var $container = $(
              ".portfolio-items.infinite_scroll:not(.carousel)"
            );
            //loading effect

            var $newElems = $(newElements).css("opacity", 0);
            //// ensure that images load before adding to masonry layout
            $newElems.imagesLoaded(function () {
              $(newElements).css("opacity", 1);

              $container.isotope("appended", $(newElements));

              $(newElements).find(".work-item").addClass("ajax-loaded");
              $(newElements).addClass("ajax-loaded");
              ///// show elems now they're ready

              $(newElements)
                .find(".work-meta, .nectar-love-wrap")
                .css({ opacity: 1 });

              //keep filtering
              if (
                $(".portfolio-filters-inline").length > 0 ||
                $(".portfolio-filters").length > 0
              ) {
                if ($(".portfolio-filters-inline").length > 0) {
                  var selector = $(".portfolio-filters-inline a.active").attr(
                    "data-filter"
                  );
                } else {
                  var selector = $(".portfolio-filters a.active").attr(
                    "data-filter"
                  );
                }

                $(".portfolio-filters-inline a.active").attr("data-filter");
                $container.isotope({ filter: selector });
              }

              //set width
              //portfolioItemWidths();
              reLayout();

              if ($(newElements).find(".work-item.style-5").length > 0)
                style6Img();

              if (
                $(newElements).find(".inner-wrap").attr("data-animation") ==
                "none"
              ) {
                $(".portfolio-items .col .inner-wrap").removeClass("animated");
              } else {
                masonryZindex();
                $(newElements).each(function (i) {
                  //not already visible
                  var $that = $(this);
                  var waypoint = new Waypoint({
                    element: $that,
                    handler: function (direction) {
                      var $portfolioAnimationDelay = $that.is(
                        '[data-masonry-type="photography"].masonry-items'
                      )
                        ? 85
                        : 115;

                      setTimeout(function () {
                        $that.addClass("animated-in");
                      }, $portfolioAnimationDelay *
                        $that.attr("data-delay-amount"));

                      waypoint.destroy();
                    },
                    offset: $portfolioOffsetPos,
                  }); //waypoint

                  /*$(this).delay(130*i).queue(function(next){
						    $(this).addClass("animated-in");
						    next();
						});*/
                }); //each
              }

              portfolioHoverEffects();
              portfolioAccentColor();

              //verify smooth scorlling
              if (
                $smoothCache == true &&
                $(window).width() > 690 &&
                $("body").outerHeight(true) > $(window).height() &&
                Modernizr.csstransforms3d &&
                !navigator.userAgent.match(
                  /(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/
                )
              ) {
                niceScrollInit();
                $(window).trigger("resize");
              }

              //Panr
              if (
                !$("body").hasClass("mobile") &&
                !navigator.userAgent.match(
                  /(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/
                )
              ) {
                $(
                  ".portfolio-items:not(.carousel) .work-item.style-3 img"
                ).panr({
                  scaleDuration: 0.28,
                });
                $(
                  ".portfolio-items:not(.carousel) .work-item.style-3-alt img"
                ).panr({
                  scaleDuration: 0.28,
                  sensitivity: 12.6,
                  scaleTo: 1.08,
                  panDuration: 3,
                });
              }

              //prettyphoto
              $(".portfolio-items").each(function () {
                var $unique_id = Math.floor(Math.random() * 10000);
                $(this)
                  .find('a[rel^="prettyPhoto"], a.pretty_photo')
                  .attr("rel", "prettyPhoto[" + $unique_id + "_gal]")
                  .removeClass("pretty_photo");
              });

              lightBoxInit();

              piVertCenter();

              setTimeout(function () {
                masonryZindex();
                reLayout();
                $(newElements).removeClass("ajax-loaded");
              }, 700);

              //recalc the filters
              isotopeCatSelection();

              parallaxRowsBGCals();
            });
          }
        );

        //blog
        $("#post-area.infinite_scroll .posts-container").infinitescroll(
          {
            navSelector: "div#pagination",
            nextSelector: "div#pagination a:first",
            itemSelector: "#post-area .posts-container .post",
            finishedMsg:
              "<em>Congratulations, you've reached the end of the internet.</em>",
            msgText: " ",
          },
          function (newElements) {
            if ($(".masonry.meta_overlaid").length == 0) {
              //reinit js
              centerLove();

              //gallery
              $(newElements)
                .find(".flex-gallery")
                .each(function () {
                  var $that = $(this);

                  $that.flexslider({
                    animation: "fade",
                    smoothHeight: false,
                    animationSpeed: 500,
                    useCSS: false,
                    touch: true,
                  });

                  ////gallery slider add arrows
                  $(".flex-gallery .flex-direction-nav li a.flex-next").html(
                    '<i class="fa fa-angle-right"></i>'
                  );
                  $(".flex-gallery .flex-direction-nav li a.flex-prev").html(
                    '<i class="fa fa-angle-left"></i>'
                  );
                });

              //media players
              if ($().mediaelementplayer)
                $(newElements)
                  .find(".wp-audio-shortcode, .wp-video-shortcode")
                  .mediaelementplayer();

              //lightbox
              lightBoxInit();

              //carousels
              if ($(".carousel").length > 0) {
                standardCarouselInit();
                clientsCarouselInit();
              }

              //iframes
              showLateIframes();

              //milestone
              $(newElements)
                .find(".nectar-milestone")
                .each(function () {
                  //symbol
                  if ($(this).has("[data-symbol]")) {
                    if ($(this).attr("data-symbol-pos") == "before") {
                      $(this)
                        .find(".number")
                        .prepend($(this).attr("data-symbol"));
                    } else {
                      $(this)
                        .find(".number")
                        .append($(this).attr("data-symbol"));
                    }
                  }
                });

              if (!$("body").hasClass("mobile")) {
                $(newElements)
                  .find(".nectar-milestone")
                  .each(function () {
                    //animation

                    var $that = $(this);
                    var waypoint = new Waypoint({
                      element: $that,
                      handler: function (direction) {
                        if (
                          ($that.parents(".wpb_tab").length > 0 &&
                            $that.parents(".wpb_tab").css("visibility") ==
                              "hidden") ||
                          $that.hasClass("animated-in")
                        ) {
                          waypoint.destroy();
                          return;
                        }

                        var $endNum = parseInt(
                          $that.find(".number span").text()
                        );

                        var countOptions = { easingFn: easeOutCubic };
                        var $countEle = $that.find(
                          ".number span:not(.symbol)"
                        )[0];
                        var numAnim = new CountUp(
                          $countEle,
                          0,
                          $endNum,
                          0,
                          2.2,
                          countOptions
                        );
                        numAnim.start();

                        $that.addClass("animated-in");
                        waypoint.destroy();
                      },
                      offset: "bottom-in-view",
                    });
                  });
              }

              //pie chart
              if ($().vcChat) $(newElements).find(".vc_pie_chart").vcChat();

              //fancy ul
              nectar_fancy_ul_init();

              //testimonial slider
              $(".testimonial_slider").animate({ opacity: "1" }, 800);
              createTestimonialControls();
              testimonialSliderHeight();
              testimonialHeightResize();

              //bar graph
              $(newElements)
                .find(".nectar-progress-bar")
                .each(function (i) {
                  var $that = $(this);
                  var waypoint = new Waypoint({
                    element: $that,
                    handler: function (direction) {
                      if (
                        ($that.parents(".wpb_tab").length > 0 &&
                          $that.parents(".wpb_tab").css("visibility") ==
                            "hidden") ||
                        $that.hasClass("animated-in")
                      ) {
                        waypoint.destroy();
                        return;
                      }

                      var percent = $that.find("span").attr("data-width");
                      var $endNum = parseInt(
                        $that.find("span strong i").text()
                      );

                      $that.find("span").transition(
                        {
                          width: percent + "%",
                        },
                        1600,
                        "easeInOutCirc",
                        function () {}
                      );

                      $that.find("span strong").transition(
                        {
                          opacity: 1,
                        },
                        1350
                      );

                      var countOptions = { useEasing: false };
                      var $countEle = $that.find("span strong i")[0];
                      var numAnim = new CountUp(
                        $countEle,
                        0,
                        $endNum,
                        0,
                        1.2,
                        countOptions
                      );
                      numAnim.start();

                      ////100% progress bar
                      if (percent == "100") {
                        $that.find("span strong").addClass("full");
                      }

                      $that.addClass("animated-in");
                      waypoint.destroy();
                    },
                    offset: "bottom-in-view",
                  });
                });

              //columns & images with animation
              colAndImgAnimations();
              splitLineHeadings();

              setTimeout(function () {
                videoshortcodeSize();
                responsiveVideoIframesInit();
                responsiveVideoIframes();
                $(window).trigger("resize");
              }, 500);

              parallaxRowsBGCals();

              $(window).trigger("resize");
            } //non meta overlaid style
            else {
              parallaxRowsBGCals();

              $(window).trigger("resize");
            }

            // trigger Masonry as a callback
            var $container = $(".posts-container");
            if ($container.parent().hasClass("masonry")) {
              $(newElements).addClass("masonry-blog-item");
              $(newElements).prepend('<span class="bottom-line"></span>');

              //move the meta to the bottom
              $(newElements).each(function () {
                var $metaClone = $(this).find(".post-meta").clone();

                $(this).find(".post-meta").remove();

                if ($("#post-area.meta_overlaid").length > 0) {
                  $(this).find(".post-header h2").after($metaClone);
                } else {
                  $(this).find(".content-inner").after($metaClone);
                }
              });
            } //if masonry

            //loading effect

            //// hide new items while they are loading
            var $newElems = $(newElements);
            //// ensure that images load before adding to masonry layout

            if ($newElems.find("img").length == 0) $newElems = $("body");

            $newElems.imagesLoaded(function () {
              $container.isotope("appended", $(newElements));

              flickityBlogInit();

              $(newElements).addClass("ajax-loaded");
              ///// show elems now they're ready

              //classic enhanced specific
              if ($container.parent().hasClass("classic_enhanced")) {
                $container
                  .find(
                    ".large_featured.has-post-thumbnail.ajax-loaded .post-featured-img, .wide_tall.has-post-thumbnail.ajax-loaded .post-featured-img"
                  )
                  .each(function () {
                    var $src = $(this).find("img").attr("src");
                    $(this).css("background-image", "url(" + $src + ")");
                  });

                $container
                  .find(
                    ".large_featured.ajax-loaded .nectar-flickity, .wide_tall.ajax-loaded .nectar-flickity"
                  )
                  .each(function () {
                    $(this)
                      .find(".cell")
                      .each(function () {
                        var $src = $(this).find("img").attr("src");
                        $(this).css("background-image", "url(" + $src + ")");
                      });
                  });
              }

              if (
                $(newElements)
                  .parents(".posts-container")
                  .attr("data-animation") == "none"
              ) {
                $(newElements).find(".inner-wrap").removeClass("animated");
              } else {
                blogMasonryZindex();
                $(newElements).each(function (i) {
                  var $that = $(this);
                  var waypoint = new Waypoint({
                    element: $that,
                    handler: function (direction) {
                      setTimeout(function () {
                        $that.addClass("animated-in");
                      }, 80 * $that.attr("data-delay-amount"));

                      waypoint.destroy();
                    },
                    offset: "90%",
                  });
                }); //each
              }

              setTimeout(function () {
                $(newElements).removeClass("ajax-loaded");
              }, 700);
            });
          }
        );
      }
    }

    infiniteScrollInit();

    function destroyInfiniteScroll() {
      $("#post-area.infinite_scroll .posts-container").infinitescroll(
        "destroy"
      );
      $(".portfolio-items.infinite_scroll").infinitescroll("destroy");
    }

    /*-------------------------------------------------------------------------*/
    /*	6.	Scroll to top
/*-------------------------------------------------------------------------*/

    var $scrollTop = $(window).scrollTop();

    //starting bind
    function toTopBind() {
      if (
        ($("#to-top").length > 0 && $(window).width() > 1020) ||
        ($("#to-top").length > 0 && $("#to-top.mobile-enabled").length > 0)
      ) {
        if ($scrollTop > 350) {
          $(window).on("scroll", hideToTop);
        } else {
          $(window).on("scroll", showToTop);
        }
      }
    }

    if ($(".nectar-social-sharing-fixed").length == 0) {
      toTopBind();
    } else {
      if ($(window).width() < 1000) {
        if ($scrollTop > 150) {
          $(window).on("scroll", hideFixedSharing);
        } else {
          $(window).on("scroll", showFixedSharing);
        }
      }

      $(window).smartresize(function () {
        if ($(window).width() > 1000) {
          $(".nectar-social-sharing-fixed").addClass("visible");
        } else if ($scrollTop < 150) {
          $(window).off("scroll", hideFixedSharing);
          $(window).on("scroll", showFixedSharing);
          $(".nectar-social-sharing-fixed").removeClass("visible");
        } else {
          $(window).off("scroll", showFixedSharing);
          $(window).on("scroll", hideFixedSharing);
        }
      });
    }

    function showFixedSharing() {
      if ($scrollTop > 150) {
        $(".nectar-social-sharing-fixed").addClass("visible");

        $(window).off("scroll", showFixedSharing);
        $(window).on("scroll", hideFixedSharing);
      }
    }

    function hideFixedSharing() {
      if ($scrollTop < 150) {
        $(".nectar-social-sharing-fixed").removeClass("visible");

        $(window).off("scroll", hideFixedSharing);
        $(window).on("scroll", showFixedSharing);
      }
    }

    function showToTop() {
      if (
        $scrollTop > 350 &&
        $("#slide-out-widget-area.fullscreen.open").length == 0
      ) {
        $("#to-top").stop().transition(
          {
            bottom: "17px",
          },
          350,
          "easeInOutCubic"
        );

        $(window).off("scroll", showToTop);
        $(window).on("scroll", hideToTop);
      }
    }

    function hideToTop() {
      if (
        $scrollTop < 350 ||
        $("#slide-out-widget-area.fullscreen.open").length > 0
      ) {
        $animationTiming =
          $("#slide-out-widget-area.fullscreen.open").length > 0 ? 1150 : 350;

        $("#to-top").stop().transition(
          {
            bottom: "-30px",
          },
          $animationTiming,
          "easeInOutQuint"
        );

        $(window).off("scroll", hideToTop);
        $(window).on("scroll", showToTop);
      }
    }

    //to top color
    if ($("#to-top").length > 0) {
      var $windowHeight, $pageHeight, $footerHeight, $ctaHeight;

      function calcToTopColor() {
        $scrollTop = $(window).scrollTop();
        $windowHeight = $(window).height();
        $pageHeight = $("body").height();
        $footerHeight = $("#footer-outer").height();
        $ctaHeight =
          $("#call-to-action").length > 0 ? $("#call-to-action").height() : 0;

        if (
          $scrollTop - 35 + $windowHeight >= $pageHeight - $footerHeight &&
          $("#boxed").length == 0
        ) {
          $("#to-top").addClass("dark");
        } else {
          $("#to-top").removeClass("dark");
        }
      }

      //calc on scroll
      $(window).scroll(calcToTopColor);

      //calc on resize
      $(window).resize(calcToTopColor);
    }

    //alt style
    if ($('body[data-button-style*="rounded"]').length > 0) {
      var $clone = $("#to-top .fa-angle-up").clone();
      $clone.addClass("top-icon");
      $("#to-top").prepend($clone);
    }

    //scroll up event
    $("body").on("click", '#to-top, a[href="#top"]', function () {
      $("body,html")
        .stop()
        .animate(
          {
            scrollTop: 0,
          },
          800,
          "easeOutQuad",
          function () {
            if ($(".nectar-box-roll").length > 0) {
              $("body").trigger("mousewheel", [1, 0, 0]);
            }
          }
        );
      return false;
    });

    /* one page scrolling */
    function scrollSpyInit() {
      var $headerNavSpace =
        $('body[data-header-format="left-header"]').length > 0 &&
        $(window).width() > 1000
          ? 0
          : $("#header-outer").outerHeight();

      if (
        $(".page-template-template-no-header-footer").length > 0 ||
        $(".page-template-template-no-header").length > 0
      ) {
        $headerNavSpace = 0;
      }

      //prevent jump to rop on empty items
      $('header#top .sf-menu li a[href="#"]').on("click", function (e) {
        e.preventDefault();
      });

      //remove full page URLs from hash if located on same page to fix current menu class
      //if(location.pathname.length > 1) {
      $("#header-outer a[href*='" + location.pathname + "']").each(function () {
        var $href = $(this).attr("href");

        //regular animated anchors
        if (
          $href.indexOf("#") != -1 &&
          $("div" + $href.substr($href.indexOf("#"))).length > 0
        ) {
          $(this).attr("href", $href.substr($href.indexOf("#")));
          $(this)
            .parent()
            .removeClass("current_page_item")
            .removeClass("current-menu-item");
        }

        //fullpage is a little different
        if (
          $(
            'div[data-fullscreen-anchor-id="' +
              $href.substr($href.indexOf("#") + 1) +
              '"]'
          ).length > 0
        ) {
          $(this)
            .parent()
            .removeClass("current_page_item")
            .removeClass("current-menu-item");
        }
      });
      //}

      $target =
        $('.page-submenu[data-sticky="true"]').length == 0
          ? "#header-outer nav"
          : ".page-submenu";
      $("body").scrollspy({
        target: $target,
        offset: $headerNavSpace + adminBarHeight + 40,
      });
    }

    function pageLoadHash() {
      var $hash = window.location.hash;
      var $hashSubstrng =
        $hash && $hash.length > 0 ? $hash.substring(1, $hash.length) : 0;

      if (
        ($hash && $($hash).length > 0) ||
        ($hash &&
          $('[data-fullscreen-anchor-id="' + $hashSubstrng + '"]').length > 0)
      ) {
        $hashObj =
          $($hash).length > 0
            ? $($hash)
            : $('div[data-fullscreen-anchor-id="' + $hashSubstrng + '"]');

        var $headerNavSpace =
          $('body[data-header-format="left-header"]').length > 0 &&
          $(window).width() > 1000
            ? 0
            : $("#header-space").outerHeight();
        if (
          $(".page-template-template-no-header-footer").length > 0 ||
          $(".page-template-template-no-header").length > 0
        ) {
          $headerNavSpace = 0;
        }

        $timeoutVar = 0;
        if (
          $(".nectar-box-roll").length > 0 &&
          $(".container-wrap.bottomBoxOut").length > 0
        ) {
          boxRoll(null, -1);
          $timeoutVar = 2050;
        }
        setTimeout(function () {
          if ($('body[data-permanent-transparent="1"]').length == 0) {
            if (!$("body").hasClass("mobile")) {
              $resize =
                $('#header-outer[data-header-resize="0"]').length > 0
                  ? 0
                  : parseInt(shrinkNum) + headerPadding2 * 2;
              if ($('#header-outer[data-remove-fixed="1"]').length > 0) {
                $headerNavSpace = 0;
              }
              var $scrollTopDistance =
                $hashObj.offset().top -
                parseInt($headerNavSpace) +
                $resize +
                3 -
                adminBarHeight;
            } else {
              var $scrollTopDistance =
                $('#header-outer[data-mobile-fixed="1"]').length > 0
                  ? $hashObj.offset().top + 2 - $headerNavSpace + adminBarHeight
                  : $hashObj.offset().top - adminBarHeight + 1;
            }
          } else {
            var $scrollTopDistance = $hashObj.offset().top - adminBarHeight + 1;
          }

          if (
            $('body[data-hhun="1"]').length > 0 &&
            $('#header-outer[data-remove-fixed="1"]').length == 0
          ) {
            //alter offset
            if ($("#header-outer.detached").length == 0)
              $scrollTopDistance = $scrollTopDistance + $headerNavSpace;
          }

          var $pageSubMenu =
            $('.page-submenu[data-sticky="true"]').length > 0
              ? $(".page-submenu").height()
              : 0;

          $("body,html")
            .stop()
            .animate(
              {
                scrollTop: $scrollTopDistance - $pageSubMenu,
              },
              800,
              "easeInOutCubic"
            );
        }, $timeoutVar);
      }
    }

    if ($('body[data-animated-anchors="true"]').length > 0) {
      +(function (t) {
        "use strict";

        function s(e, i) {
          var r = t.proxy(this.process, this);
          (this.$body = t("body")),
            (this.$scrollElement = t(t(e).is("body") ? window : e)),
            (this.options = t.extend({}, s.DEFAULTS, i)),
            (this.selector = (this.options.target || "") + " ul li > a"),
            (this.offsets = []),
            (this.targets = []),
            (this.activeTarget = null),
            (this.scrollHeight = 0),
            this.$scrollElement.on("scroll.bs.scrollspy", r),
            this.refresh(),
            this.process();
        }

        function e(e) {
          return this.each(function () {
            var i = t(this),
              r = i.data("bs.scrollspy"),
              o = "object" == typeof e && e;
            r || i.data("bs.scrollspy", (r = new s(this, o))),
              "string" == typeof e && r[e]();
          });
        }
        (s.VERSION = "3.2.0"),
          (s.DEFAULTS = {
            offset: 10,
          }),
          (s.prototype.getScrollHeight = function () {
            return (
              this.$scrollElement[0].scrollHeight ||
              Math.max(
                this.$body[0].scrollHeight,
                document.documentElement.scrollHeight
              )
            );
          }),
          (s.prototype.refresh = function () {
            var s = "offset",
              e = 0;
            t.isWindow(this.$scrollElement[0]) ||
              ((s = "position"), (e = this.$scrollElement.scrollTop())),
              (this.offsets = []),
              (this.targets = []),
              (this.scrollHeight = this.getScrollHeight());
            var i = this;
            this.$body
              .find(this.selector)
              .map(function () {
                var i = t(this),
                  r = i.data("target") || i.attr("href"),
                  o = /^#./.test(r) && t(r);
                return (
                  (o &&
                    o.length &&
                    o.is(":visible") && [[o[s]().top + e, r]]) ||
                  null
                );
              })
              .sort(function (t, s) {
                return t[0] - s[0];
              })
              .each(function () {
                i.offsets.push(this[0]), i.targets.push(this[1]);
              });
          }),
          (s.prototype.process = function () {
            var $pageSubMenu =
              ($('.page-submenu[data-sticky="true"]').length > 0 &&
                $('body[data-hhun="1"]').length == 0) ||
              ($('.page-submenu[data-sticky="true"]').length > 0 &&
                $('#header-outer[data-remove-fixed="1"]').length > 0)
                ? $(".page-submenu").height()
                : 0;

            var t,
              s =
                this.$scrollElement.scrollTop() +
                this.options.offset +
                $pageSubMenu,
              e = this.getScrollHeight(),
              i =
                this.options.offset +
                e -
                this.$scrollElement.height() -
                $pageSubMenu,
              r = this.offsets,
              o = this.targets,
              l = this.activeTarget;
            if ((this.scrollHeight != e && this.refresh(), s >= i))
              return l != (t = o[o.length - 1]) && this.activate(t);
            if (l && s <= r[0]) return l != (t = o[0]) && this.activate(t);
            for (t = r.length; t--; )
              l != o[t] &&
                s >= r[t] &&
                (!r[t + 1] || s <= r[t + 1]) &&
                this.activate(o[t]);
          }),
          (s.prototype.activate = function (s) {
            (this.activeTarget = s),
              t(this.selector)
                .parentsUntil(this.options.target, ".current-menu-item")
                .removeClass("current-menu-item")
                .removeClass("sfHover");
            var e =
                this.selector +
                '[data-target="' +
                s +
                '"],' +
                this.selector +
                '[href="' +
                s +
                '"]',
              i = t(e).parents("li").addClass("current-menu-item");
            i.parent(".dropdown-menu").length &&
              (i = i.closest("li.dropdown").addClass("current-menu-item")),
              i.trigger("activate.bs.scrollspy");
          });
        var i = t.fn.scrollspy;
        (t.fn.scrollspy = e),
          (t.fn.scrollspy.Constructor = s),
          (t.fn.scrollspy.noConflict = function () {
            return (t.fn.scrollspy = i), this;
          });
      })(jQuery);

      var shrinkNum = 6;
      if ($("#header-outer[data-shrink-num]").length > 0)
        shrinkNum = $("#header-outer").attr("data-shrink-num");
      headerPadding2 = headerPadding - headerPadding / 1.8;

      setTimeout(scrollSpyInit, 200);

      var $animatedScrollingTimeout;

      $("body").on(
        "click",
        "#header-outer nav .sf-menu a, #footer-outer .nectar-button, .container-wrap a:not(.wpb_tabs_nav a):not(.woocommerce-tabs a), .swiper-slide .button a, #slide-out-widget-area a, #mobile-menu .container ul li a, #slide-out-widget-area .inner div a",
        function (e) {
          var $hash = $(this).prop("hash");

          $("body").addClass("animated-scrolling");
          clearTimeout($animatedScrollingTimeout);
          $animatedScrollingTimeout = setTimeout(function () {
            $("body").removeClass("animated-scrolling");
          }, 850);
          var $headerNavSpace =
            $('body[data-header-format="left-header"]').length > 0 &&
            $(window).width() > 1000
              ? 0
              : $("#header-space").outerHeight();
          if (
            $(".page-template-template-no-header-footer").length > 0 ||
            $(".page-template-template-no-header").length > 0
          ) {
            $headerNavSpace = 0;
          }

          if (
            ($hash &&
              $($hash).length > 0 &&
              $hash != "#top" &&
              $hash != "" &&
              $(this)
                .attr("href")
                .indexOf(window.location.href.split("#")[0]) !== -1) ||
            ($(this).is('[href^="#"]') &&
              $hash != "" &&
              $($hash).length > 0 &&
              $hash != "#top")
          ) {
            //stop scrolling for certain elements
            //if($(this).parents('.tabbed').length > 0) return false;

            //update hash
            if (history.pushState) {
              history.pushState(null, null, $hash);
            } else {
              location.hash = $hash;
            }

            if ($(this).parents("ul").length > 0) {
              $(this).parents("ul").find("li").removeClass("current-menu-item");
              //$(this).parents('li').addClass('current-menu-item');
            }

            //side widget area click
            if ($(this).parents("#slide-out-widget-area").length > 0) {
              $("#slide-out-widget-area .slide_out_area_close").trigger(
                "click"
              );
            }

            //mobile menu click
            if ($(this).parents("#mobile-menu").length > 0)
              $("#toggle-nav").trigger("click");
            var $mobileMenuHeight =
              $(this).parents("#mobile-menu").length > 0
                ? $(this).parents("#mobile-menu").height()
                : null;

            $timeoutVar = 1;
            if (
              $(".nectar-box-roll").length > 0 &&
              $(".container-wrap.bottomBoxOut").length > 0
            ) {
              boxRoll(null, -1);
              $timeoutVar = 2050;
            }

            var $that = $(this);

            setTimeout(function () {
              //scrolling
              var $headerSpace =
                $('body[data-permanent-transparent="1"]').length > 0
                  ? 0
                  : parseInt($headerNavSpace);

              if ($('body[data-permanent-transparent="1"]').length == 0) {
                if (!$("body").hasClass("mobile")) {
                  $resize =
                    $('#header-outer[data-header-resize="0"]').length > 0
                      ? 0
                      : parseInt(shrinkNum) + headerPadding2 * 2;
                  if ($('#header-outer[data-remove-fixed="1"]').length > 0) {
                    $headerNavSpace = 0;
                  }
                  var $scrollTopDistance =
                    $($hash).offset().top -
                    $mobileMenuHeight -
                    parseInt($headerNavSpace) +
                    $resize +
                    3 -
                    adminBarHeight;
                } else {
                  var $scrollTopDistance =
                    $('#header-outer[data-mobile-fixed="1"]').length > 0
                      ? $($hash).offset().top +
                        2 -
                        $headerNavSpace +
                        adminBarHeight
                      : $($hash).offset().top -
                        $mobileMenuHeight -
                        adminBarHeight +
                        1;
                }
              } else {
                var $scrollTopDistance =
                  $($hash).offset().top - adminBarHeight + 1;
              }

              if (
                $('body[data-hhun="1"]').length > 0 &&
                $('#header-outer[data-remove-fixed="1"]').length == 0
              ) {
                //alter offset
                if (
                  $("#header-outer.detached").length == 0 ||
                  $that.parents('.page-submenu[data-sticky="true"]').length > 0
                )
                  $scrollTopDistance = $scrollTopDistance + $headerNavSpace;

                //hide top header
                if (
                  $that.parents('.page-submenu[data-sticky="true"]').length > 0
                ) {
                  $("#header-outer.detached").addClass("invisible");
                  $(".page-submenu")
                    .addClass("header-not-visible")
                    .css("transform", "translateY(0px)");
                }
              }

              var $pageSubMenu =
                $that.parents('.page-submenu[data-sticky="true"]').length > 0
                  ? $that.parents(".page-submenu").height()
                  : 0;

              $("body,html")
                .stop()
                .animate(
                  {
                    scrollTop: $scrollTopDistance - $pageSubMenu,
                  },
                  800,
                  "easeInOutCubic"
                );
            }, $timeoutVar);

            e.preventDefault();
          }

          if ($hash == "#top") {
            //side widget area click
            if ($(this).parents("#slide-out-widget-area").length > 0) {
              $("#slide-out-widget-area .slide_out_area_close").trigger(
                "click"
              );
            }
          }
        }
      );

      if (
        $(".nectar-box-roll").length == 0 &&
        $("#nectar_fullscreen_rows").length == 0
      )
        $(window).load(pageLoadHash);

      if (
        $('#nectar_fullscreen_rows[data-mobile-disable="on"]').length > 0 &&
        $(".nectar-box-roll").length == 0 &&
        $onMobileBrowser
      ) {
        $(window).load(pageLoadHash);
      }
    }

    //portfolio colors
    if (
      $(".portfolio-items .col .style-3-alt").length > 0 ||
      $(".portfolio-items .col .style-3").length > 0 ||
      $(".portfolio-items .col .style-2").length > 0 ||
      $(".portfolio-items .col .style-5").length > 0
    ) {
      var portfolioColorCss = "";
      $(".portfolio-items .col").each(function () {
        $titleColor = $(this).attr("data-title-color");
        $subTitleColor = $(this).attr("data-subtitle-color");

        if ($titleColor.length > 0) {
          portfolioColorCss +=
            '.col[data-title-color="' +
            $titleColor +
            '"] .vert-center h3, .portfolio-items[data-ps="6"] .col[data-title-color="' +
            $titleColor +
            '"] .work-meta h4 { color: ' +
            $titleColor +
            "; } ";
          portfolioColorCss +=
            ' .portfolio-items[data-ps="8"] .col[data-title-color="' +
            $titleColor +
            '"] .line { background-color: ' +
            $titleColor +
            "; }";
          portfolioColorCss +=
            '.portfolio-items[data-ps="8"] .col[data-title-color="' +
            $titleColor +
            '"] .next-arrow line { stroke: ' +
            $titleColor +
            "; } ";
        }
        if ($subTitleColor.length > 0)
          portfolioColorCss +=
            '.col[data-subtitle-color="' +
            $subTitleColor +
            '"] .vert-center p, .portfolio-items[data-ps="6"] .col[data-title-color="' +
            $titleColor +
            '"] .work-meta p { color: ' +
            $subTitleColor +
            "; } ";
      });

      var head = document.head || document.getElementsByTagName("head")[0];
      var style = document.createElement("style");

      style.type = "text/css";
      if (style.styleSheet) {
        style.styleSheet.cssText = portfolioColorCss;
      } else {
        style.appendChild(document.createTextNode(portfolioColorCss));
      }

      head.appendChild(style);
    }

    //bottom controls 2
    $("body").on(
      "mouseleave",
      '.container-wrap[data-nav-pos="after_project_2"] #portfolio-nav ul li',
      function () {
        $(this).addClass("mouse-leaving");
      }
    );

    // masonryPortfolio

    var $portfolio_containers = [];

    $(".portfolio-items:not(.carousel)").each(function (i) {
      $portfolio_containers[i] = $(this);
    });

    function masonryPortfolioInit() {
      $portfolio_containers = [];
      $(".portfolio-items:not(.carousel)").each(function (i) {
        $portfolio_containers[i] = $(this);
      });

      //// cache window
      var $window = jQuery(window);

      $.each($portfolio_containers, function (i) {
        //// start up isotope with default settings
        $portfolio_containers[i].imagesLoaded(function () {
          //verify smooth scorlling
          if (
            $smoothCache == true &&
            $(window).width() > 690 &&
            $("body").outerHeight(true) > $(window).height() &&
            Modernizr.csstransforms3d &&
            !navigator.userAgent.match(
              /(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/
            )
          ) {
            niceScrollInit();
            $(window).trigger("resize");
          }

          //transformns enabled logic
          var $isoUseTransforms = true;

          //Panr
          if (
            !$("body").hasClass("mobile") &&
            !navigator.userAgent.match(
              /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
            )
          ) {
            $(".portfolio-items:not(.carousel) .work-item.style-3 img").panr({
              scaleDuration: 0.28,
            });
            $(
              ".portfolio-items:not(.carousel) .work-item.style-3-alt img"
            ).panr({
              scaleDuration: 0.28,
              sensitivity: 20,
              scaleTo: 1.12,
              panDuration: 1,
            });

            $isoUseTransforms = true;
          }

          piVertCenter();

          //initial call to setup isotope
          var $layoutMode = $portfolio_containers[i].hasClass("masonry-items")
            ? "packery"
            : "fitRows";
          var $startingFilter =
            $portfolio_containers[i].attr("data-starting-filter") != "" &&
            $portfolio_containers[i].attr("data-starting-filter") != "default"
              ? "." + $portfolio_containers[i].attr("data-starting-filter")
              : "*";

          reLayout();

          $portfolio_containers[i]
            .isotope({
              itemSelector: ".element",
              filter: $startingFilter,
              layoutMode: $layoutMode,
              transitionDuration: "0.6s",
              packery: {
                gutter: 0,
              },
            })
            .isotope("layout");

          if ($startingFilter != "*") {
            $(
              '.portfolio-filters ul a[data-filter="' +
                $startingFilter +
                '"], .portfolio-filters-inline ul a[data-filter="' +
                $startingFilter +
                '"]'
            ).click();
          }

          //call the reLayout to get things rollin'
          masonryZindex();
          setTimeout(function () {
            masonryZindex();
          }, 800);
          $window.resize(reLayout);
          $window.smartresize(function () {
            setTimeout(masonryZindex, 700);
          });

          //inside fwc fix
          if (
            $portfolio_containers[i].parents(".full-width-content").length > 0
          ) {
            setTimeout(function () {
              fullWidthContentColumns();
            }, 200);
          }

          //fadeout the loading animation
          $(".portfolio-loading").stop(true, true).fadeOut(200);

          //fadeIn items one by one
          if (
            $portfolio_containers[i]
              .find(".inner-wrap")
              .attr("data-animation") == "none"
          ) {
            $portfolio_containers[i]
              .find(".inner-wrap")
              .removeClass("animated");
          } else {
            //portfolioLoadIn(); moved to waypoints
          }
        });
      }); //each
    }

    masonryPortfolioInit();

    function portfolioLoadIn() {
      $($fullscreenSelector + ".portfolio-items").each(function () {
        $portfolioOffsetPos =
          $("#nectar_fullscreen_rows").length > 0 ? "100%" : "90%";

        if ($(this).find(".inner-wrap").attr("data-animation") == "none")
          return;

        $(this)
          .find(".col")
          .each(function (i) {
            var $that = $(this);

            //loaded visible
            if (
              $(this).visible(true) ||
              $(this).parents("#nectar_fullscreen_rows").length > 0
            ) {
              var $portfolioAnimationDelay = $that.is(
                '[data-masonry-type="photography"].masonry-items'
              )
                ? 90
                : 115;
              $(this)
                .delay($portfolioAnimationDelay * i)
                .queue(function (next) {
                  $(this).addClass("animated-in");
                  next();
                });
            } else {
              //not already visible
              var waypoint = new Waypoint({
                element: $that,
                handler: function (direction) {
                  if (
                    ($that.parents(".wpb_tab").length > 0 &&
                      $that.parents(".wpb_tab").css("visibility") ==
                        "hidden") ||
                    $that.hasClass("animated-in")
                  ) {
                    waypoint.destroy();
                    return;
                  }

                  var $portfolioAnimationDelay = $that.is(
                    '[data-masonry-type="photography"].masonry-items'
                  )
                    ? 85
                    : 100;

                  setTimeout(function () {
                    $that.addClass("animated-in");
                  }, $portfolioAnimationDelay *
                    $that.attr("data-delay-amount"));

                  waypoint.destroy();
                },
                offset: $portfolioOffsetPos,
              }); //waypoint
            }
          }); //each
      }); //each
    }

    //perspective load in
    if (
      $('.portfolio-items .inner-wrap[data-animation="perspective"]').length >
        0 ||
      $('.posts-container[data-load-animation="perspective"]').length > 0
    ) {
      var lastScrollTop = $(window).scrollTop();

      $(
        '.portfolio-items, .posts-container[data-load-animation="perspective"]'
      ).css(
        "perspective-origin",
        "50% " + (lastScrollTop + $(window).height()) + "px"
      );

      requestAnimationFrame(updatePerspectiveOrigin);

      function updatePerspectiveOrigin() {
        var scrollTop = $(window).scrollTop();

        if (lastScrollTop === scrollTop) {
          requestAnimationFrame(updatePerspectiveOrigin);
          return;
        } else {
          lastScrollTop = scrollTop;
          $(
            '.portfolio-items,.posts-container[data-load-animation="perspective"]'
          ).css(
            "perspective-origin",
            "50% " + (lastScrollTop + $(window).height()) + "px"
          );
          requestAnimationFrame(updatePerspectiveOrigin);
        }
      }
    }

    var mediaQuerySize;
    function reLayout() {
      clearTimeout(clearIsoAnimation);
      $(".portfolio-items .col").addClass("no-transition");
      clearIsoAnimation = setTimeout(function () {
        $(".portfolio-items .col").removeClass("no-transition");
      }, 700);

      var windowSize = $window.width();
      var masonryObj;
      var masonryObjHolder = [];

      //remove double quotes for FF
      //if (navigator.userAgent.match('MSIE 8') == null) {
      //	mediaQuerySize = mediaQuerySize.replace(/"/g, '');
      //}

      //user defined cols
      var userDefinedColWidth;

      $.each($portfolio_containers, function (i, v) {
        if (
          $portfolio_containers[i].attr("data-user-defined-cols") == "span4"
        ) {
          userDefinedColWidth = 3;
        } else if (
          $portfolio_containers[i].attr("data-user-defined-cols") == "span3"
        ) {
          userDefinedColWidth = 4;
        }

        var isFullWidth =
          $portfolio_containers[i].attr("data-col-num") == "elastic";

        //chrome 33 approved method for getting column sizing
        if (window.innerWidth > 1600) {
          if ($portfolio_containers[i].hasClass("fullwidth-constrained")) {
            if (
              $portfolio_containers[i].is('[data-masonry-type="photography"]')
            ) {
              mediaQuerySize = "three";
            } else {
              mediaQuerySize = "four";
            }
          } else {
            if ($portfolio_containers[i].hasClass("constrain-max-cols")) {
              mediaQuerySize = "four";
            } else {
              mediaQuerySize = "five";
            }
          }
        } else if (window.innerWidth <= 1600 && window.innerWidth > 1300) {
          if ($portfolio_containers[i].hasClass("fullwidth-constrained")) {
            if (
              $portfolio_containers[i].is('[data-masonry-type="photography"]')
            ) {
              mediaQuerySize = "three";
            } else {
              mediaQuerySize = "four";
            }
          } else {
            mediaQuerySize = "four";
          }
        } else if (window.innerWidth <= 1300 && window.innerWidth > 990) {
          if ($portfolio_containers[i].hasClass("constrain-max-cols")) {
            mediaQuerySize = "four";
          } else {
            mediaQuerySize = "three";
          }
        } else if (window.innerWidth <= 990 && window.innerWidth > 470) {
          mediaQuerySize = "two";
        } else if (window.innerWidth <= 470) {
          mediaQuerySize = "one";
        }

        //boxed
        if ($("#boxed").length > 0) {
          if (window.innerWidth > 1300) {
            mediaQuerySize = "four";
          } else if (window.innerWidth < 1300 && window.innerWidth > 990) {
            if ($portfolio_containers[i].hasClass("constrain-max-cols")) {
              mediaQuerySize = "four";
            } else {
              mediaQuerySize = "three";
            }
          } else if (window.innerWidth < 990) {
            mediaQuerySize = "one";
          }
        }

        //change masonry columns depending on screen size
        switch (mediaQuerySize) {
          case "five":
            isFullWidth ? (colWidth = 5) : (colWidth = userDefinedColWidth);
            //change cols for photography
            if (
              isFullWidth &&
              $portfolio_containers[i].is('[data-masonry-type="photography"]')
            )
              colWidth = 6;

            masonryObj = {
              columnWidth: Math.floor(
                $portfolio_containers[i].width() / parseInt(colWidth)
              ),
            };
            break;

          case "four":
            isFullWidth ? (colWidth = 4) : (colWidth = userDefinedColWidth);
            //change cols for photography
            if (
              isFullWidth &&
              $portfolio_containers[i].is('[data-masonry-type="photography"]')
            )
              colWidth = 5;

            masonryObj = {
              columnWidth: Math.floor(
                $portfolio_containers[i].width() / parseInt(colWidth)
              ),
            };
            break;

          case "three":
            isFullWidth ? (colWidth = 3) : (colWidth = userDefinedColWidth);
            //change cols for photography
            if (
              isFullWidth &&
              $portfolio_containers[i].is('[data-masonry-type="photography"]')
            )
              colWidth = 4;

            masonryObj = {
              columnWidth: Math.floor(
                $portfolio_containers[i].width() / parseInt(colWidth)
              ),
            };
            break;

          case "two":
            masonryObj = {
              columnWidth: Math.floor($portfolio_containers[i].width() / 2),
            };
            break;

          case "one":
            masonryObj = {
              columnWidth: Math.floor($portfolio_containers[i].width() / 1),
            };
            break;
        }

        //set widths
        portfolioItemWidths(i, v);

        //sizing for large items
        if (
          $portfolio_containers[i].find(
            '.col.elastic-portfolio-item[class*="regular"]:visible'
          ).length > 0 ||
          $portfolio_containers[i].find(
            '.col.elastic-portfolio-item[class*="wide"]:visible'
          ).length > 0 ||
          $portfolio_containers[i].find(
            '.col.elastic-portfolio-item[class*="tall"]:visible'
          ).length > 0 ||
          $portfolio_containers[i].find(
            '.col.elastic-portfolio-item[class*="wide_tall"]:visible'
          ).length > 0
        ) {
          var $gutterSize =
            $portfolio_containers[i].is('[data-gutter*="px"]') &&
            $portfolio_containers[i].attr("data-gutter").length > 0 &&
            $portfolio_containers[i].attr("data-gutter") != "none"
              ? parseInt($portfolio_containers[i].attr("data-gutter"))
              : 0;
          var multipler = window.innerWidth > 470 ? 2 : 1;

          //reset height for calcs
          $itemClassForSizing = "regular";

          if (
            $portfolio_containers[i].find(
              '.col.elastic-portfolio-item[class*="regular"]:visible'
            ).length == 0 &&
            $portfolio_containers[i].find(
              ".col.elastic-portfolio-item.wide:visible"
            ).length > 0
          ) {
            $itemClassForSizing = "wide";
          } else if (
            $portfolio_containers[i].find(
              '.col.elastic-portfolio-item[class*="regular"]:visible'
            ).length == 0 &&
            $portfolio_containers[i].find(
              ".col.elastic-portfolio-item.wide_tall:visible"
            ).length > 0
          ) {
            $itemClassForSizing = "wide_tall";
            multipler = 1;
          } else if (
            $portfolio_containers[i].find(
              '.col.elastic-portfolio-item[class*="regular"]:visible'
            ).length == 0 &&
            $portfolio_containers[i].find(
              ".col.elastic-portfolio-item.tall:visible"
            ).length > 0
          ) {
            $itemClassForSizing = "tall";
            multipler = 1;
          }

          $portfolio_containers[i]
            .find(".col.elastic-portfolio-item." + $itemClassForSizing + " img")
            .css("height", "auto");

          var tallColHeight = $portfolio_containers[i]
            .find(
              ".col.elastic-portfolio-item." +
                $itemClassForSizing +
                ":visible img"
            )
            .height();

          $portfolio_containers[i]
            .find(
              '.col.elastic-portfolio-item[class*="tall"] img, .col.elastic-portfolio-item.wide img, .col.elastic-portfolio-item.regular img'
            )
            .removeClass("auto-height");
          $portfolio_containers[i]
            .find(
              '.col.elastic-portfolio-item[class*="tall"] img:not(.custom-thumbnail)'
            )
            .css("height", tallColHeight * multipler + $gutterSize * 2);

          if (
            $itemClassForSizing == "regular" ||
            $itemClassForSizing == "wide"
          ) {
            $portfolio_containers[i]
              .find(
                ".col.elastic-portfolio-item.wide img:not(.custom-thumbnail), .col.elastic-portfolio-item.regular img:not(.custom-thumbnail)"
              )
              .css("height", tallColHeight);
          } else {
            $portfolio_containers[i]
              .find(
                ".col.elastic-portfolio-item.wide img:not(.custom-thumbnail), .col.elastic-portfolio-item.regular img:not(.custom-thumbnail)"
              )
              .css("height", tallColHeight / 2 - $gutterSize * 2);
          }

          $portfolio_containers[i]
            .find('.col.elastic-portfolio-item[class*="tall"] .parallaxImg')
            .css(
              "height",
              tallColHeight * multipler +
                parseInt(
                  $portfolio_containers[i]
                    .find(".col.elastic-portfolio-item")
                    .css("padding-bottom")
                ) *
                  2
            );

          if (
            $itemClassForSizing == "regular" ||
            $itemClassForSizing == "wide"
          ) {
            $portfolio_containers[i]
              .find(
                ".col.elastic-portfolio-item.regular .parallaxImg, .col.elastic-portfolio-item.wide .parallaxImg"
              )
              .css("height", tallColHeight);
          } else {
            $portfolio_containers[i]
              .find(
                ".col.elastic-portfolio-item.regular .parallaxImg, .col.elastic-portfolio-item.wide .parallaxImg"
              )
              .css("height", tallColHeight / 2 - $gutterSize * 2);
          }
        } else {
          $portfolio_containers[i]
            .find(
              '.col.elastic-portfolio-item[class*="tall"] img, .col.elastic-portfolio-item.wide img, .col.elastic-portfolio-item.regular img'
            )
            .addClass("auto-height");
        }

        //non masonry

        if (
          $portfolio_containers[i].hasClass("no-masonry") &&
          $portfolio_containers[i].find(".col:first:visible").length > 0 &&
          $portfolio_containers[i].parents(".wpb_gallery").length == 0
        ) {
          //reset height for calcs
          $portfolio_containers[i].find(".col img").css("height", "auto");
          var tallColHeight = $portfolio_containers[i]
            .find(".col:first:visible img")
            .height();
          $portfolio_containers[i]
            .find(".col img:not(.custom-thumbnail)")
            .css("height", tallColHeight);
          $portfolio_containers[i]
            .find(".col .parallaxImg")
            .css("height", tallColHeight);
        }

        masonryObjHolder[i] = masonryObj;

        if ($portfolio_containers[i].isotope())
          $portfolio_containers[i].isotope("layout");
      }); //each
    }

    function portfolioItemWidths(i, v) {
      // passing each index value where function is called first to avoid nested loops
      // $.each($portfolio_containers,function(i,v){
      var isFullWidth =
        $portfolio_containers[i].attr("data-col-num") == "elastic";

      if (isFullWidth) {
        var $colSize = 4;
        var $mult = mediaQuerySize == "one" ? 1 : 2;
        if (mediaQuerySize == "five") $colSize = 5;
        if (mediaQuerySize == "four") $colSize = 4;
        if (mediaQuerySize == "three") $colSize = 3;
        if (mediaQuerySize == "two") $colSize = 2;
        if (mediaQuerySize == "one") $colSize = 1;
        if ($(v).is('[data-ps="6"]') && $colSize == 5) $colSize = 4;

        //photography
        if (
          isFullWidth &&
          $portfolio_containers[i].is('[data-masonry-type="photography"]') &&
          !$portfolio_containers[i].hasClass("no-masonry")
        ) {
          if (mediaQuerySize == "five") $colSize = 6;
          if (mediaQuerySize == "four") $colSize = 5;
          if (mediaQuerySize == "three") $colSize = 4;
        }

        if ($(v).width() % $colSize == 0) {
          $(v)
            .find(".elastic-portfolio-item:not(.wide):not(.wide_tall)")
            .css("width", Math.floor($(v).width() / $colSize) + "px");
          $(v)
            .find(
              ".elastic-portfolio-item.wide, .elastic-portfolio-item.wide_tall"
            )
            .css("width", Math.floor(($(v).width() / $colSize) * $mult) + "px");
        } else {
          var $loopEndNum = $(window).width() > 1000 ? 6 : 3;
          if (
            $portfolio_containers[i].hasClass("fullwidth-constrained") &&
            $(window).width() > 1000
          )
            $loopEndNum = 4;
          //find closest number to give 0
          for (var i = 1; i < $loopEndNum; i++) {
            if (($(v).width() - i) % $colSize == 0) {
              $(v)
                .find(".elastic-portfolio-item:not(.wide):not(.wide_tall)")
                .css("width", ($(v).width() - i) / $colSize + "px");
              $(v)
                .find(
                  ".elastic-portfolio-item.wide, .elastic-portfolio-item.wide_tall"
                )
                .css("width", (($(v).width() - i) / $colSize) * $mult + "px");
            }
          }
        }
      } // isFullWidth

      // });
    }

    //z-index for masonry
    function masonryZindex() {
      //escape if no browser support
      if (
        $('body .portfolio-items:not(".carousel") .elastic-portfolio-item')
          .length > 0 &&
        $(
          'body .portfolio-items:not(".carousel") .elastic-portfolio-item'
        ).offset().left
      ) {
        var $coords = {};
        var $zindexRelation = {};

        $(
          'body .portfolio-items:not(".carousel") .elastic-portfolio-item'
        ).each(function () {
          var $itemOffset = $(this).offset();
          $itemOffset = $itemOffset.left;

          $coords[$(this).index()] = $itemOffset;
          $(this).css(
            "z-index",
            Math.abs(Math.floor($(this).offset().left / 20))
          );
        });

        var $corrdsArr = $.map($coords, function (value) {
          return value;
        });

        $corrdsArr = removeDuplicates($corrdsArr);
        $corrdsArr.sort(function (a, b) {
          return a - b;
        });

        for (var i = 0; i < $corrdsArr.length; i++) {
          $zindexRelation[$corrdsArr[i]] = i;
        }

        $.each($coords, function (k, v) {
          var $zindex;
          var $coordCache = v;
          $.each($zindexRelation, function (k, v) {
            if ($coordCache == k) {
              $zindex = v;
            }
          });

          $(
            'body .portfolio-items:not(".carousel") .elastic-portfolio-item:eq(' +
              k +
              ")"
          ).attr("data-delay-amount", $zindex);
        });
      }
    }

    function blogMasonryZindex() {
      //escape if no browser support
      if (
        $("body #post-area .masonry-blog-item").length > 0 &&
        $("body #post-area .masonry-blog-item").offset().left
      ) {
        var $coords = {};
        var $zindexRelation = {};

        $("body #post-area .masonry-blog-item").each(function () {
          var $itemOffset = $(this).offset();
          $itemOffset = $itemOffset.left;

          $coords[$(this).index()] = $itemOffset;
        });

        var $corrdsArr = $.map($coords, function (value) {
          return value;
        });
        $corrdsArr = removeDuplicates($corrdsArr);
        $corrdsArr.sort(function (a, b) {
          return a - b;
        });

        for (var i = 0; i < $corrdsArr.length; i++) {
          $zindexRelation[$corrdsArr[i]] = i * 1;
        }

        $.each($coords, function (k, v) {
          var $zindex;
          var $coordCache = v;
          $.each($zindexRelation, function (k, v) {
            if ($coordCache == k) {
              $zindex = v;
            }
          });

          $("body #post-area .masonry-blog-item:eq(" + k + ")")
            .css("z-index", $zindex)
            .attr("data-delay-amount", $zindex);
        });
      }
    }

    function matrixToArray(matrix) {
      return matrix.substr(7, matrix.length - 8).split(", ");
    }

    function removeDuplicates(inputArray) {
      var i;
      var len = inputArray.length;
      var outputArray = [];
      var temp = {};

      for (i = 0; i < len; i++) {
        temp[inputArray[i]] = 0;
      }
      for (i in temp) {
        outputArray.push(i);
      }
      return outputArray;
    }

    //// filter items when filter link is clicked
    var clearIsoAnimation = null;
    var $checkForScrollBar = null;

    //number portfolios so multiple sortable ones can work easily on same page
    $('.portfolio-items:not(".carousel")').each(function (i) {
      $(this).attr("instance", i);
      $(this)
        .parent()
        .parent()
        .find("div[class^=portfolio-filters]")
        .attr("instance", i);
    });

    function isoClickFilter() {
      var $timeout;
      if (
        window.innerWidth > 690 &&
        !navigator.userAgent.match(
          /(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/
        )
      ) {
        clearTimeout($timeout);
        $timeout = setTimeout(function () {
          masonryZindex();
        }, 600);
      }

      var selector = $(this).attr("data-filter");
      var $instance = $(this)
        .parents("div[class^=portfolio-filters]")
        .attr("instance");

      $.each($portfolio_containers, function (i) {
        if ($portfolio_containers[i].attr("instance") == $instance) {
          $portfolio_containers[i]
            .isotope({ filter: selector })
            .attr("data-current-cat", selector);

          //fade in all incase user hasn't scrolled down yet
          if (
            $portfolio_containers[i].find('.inner-wrap[data-animation="none"]')
              .length == 0
          ) {
            $portfolio_containers[i].find(".col").addClass("animated-in");
          }
        }
      });

      //active classes
      $(this).parent().parent().find("li a").removeClass("active");
      $(this).addClass("active");

      //update pp
      if ($('.portfolio-items a[rel^="prettyPhoto"]').length > 0) {
        setTimeout(updatePrettyPhotoGallery, 170);
      } else {
        setTimeout(updateMagPrettyPhotoGallery, 170);
      }

      return false;
    }

    ////filter event
    $("body").on(
      "click",
      ".portfolio-filters ul li a, .portfolio-filters-inline ul li a",
      isoClickFilter
    );

    function updatePrettyPhotoGallery() {
      $(".portfolio-items").each(function () {
        if ($(this).find('a[rel^="prettyPhoto"]').length > 0) {
          var $unique_id = Math.floor(Math.random() * 10000);
          var $currentCat = $(this).attr("data-current-cat");
          $(this)
            .find(".col" + $currentCat)
            .find('a[rel^="prettyPhoto"]')
            .attr("rel", "prettyPhoto[" + $unique_id + "_sorted]");
        }
      });
    }

    function updateMagPrettyPhotoGallery() {
      $(".portfolio-items").each(function () {
        var $currentCat = $(this).attr("data-current-cat");

        $(this)
          .find(".col")
          .each(function () {
            $(this)
              .find("a.gallery")
              .removeClass("gallery")
              .removeClass("magnific");

            if ($(this).is($currentCat))
              $(this)
                .find(".work-info a")
                .addClass("gallery")
                .addClass("magnific");
          });
      });
    }

    function masonryBlogInit() {
      var $posts_container = $(".posts-container");

      if ($posts_container.parent().hasClass("masonry")) {
        $posts_container.find("article").addClass("masonry-blog-item");
        $posts_container
          .find("article")
          .prepend('<span class="bottom-line"></span>');

        //move the meta to the bottom
        $posts_container.find("article").each(function () {
          var $metaClone = $(this).find(".post-meta").clone();

          $(this).find(".post-meta").remove();

          if ($("#post-area.meta_overlaid").length > 0) {
            $(this).find(".post-header h2").after($metaClone);
          } else {
            $(this).find(".content-inner").after($metaClone);
          }
        });

        if (
          $posts_container.parent().hasClass("masonry") &&
          $posts_container.parent().hasClass("full-width-content")
        ) {
          $posts_container
            .parent()
            .wrap('<div class="full-width-content blog-fullwidth-wrap"> </div>')
            .removeClass("full-width-content")
            .css({ "margin-left": "0", width: "auto" });

          //page header animation fix
          if ($posts_container.parents(".wpb_row").length > 0)
            $posts_container.parents(".wpb_row").css("z-index", 100);

          if ($(".masonry.meta_overlaid").length == 0) {
            if ($(".masonry.classic_enhanced").length > 0) {
              $posts_container.parent().parents(".full-width-content").css({
                padding: "0px 0.2% 0px 2.4%",
              });
            } else {
              $posts_container.parent().parents(".full-width-content").css({
                padding: "0px 0.2% 0px 3.2%",
              });
            }
          } else {
            $posts_container
              .parent()
              .parents(".full-width-content")
              .addClass("meta-overlaid");
            $(".container-wrap").addClass("meta_overlaid_blog");
          }

          fullWidthSections();
        }

        var $cols = 3;
        var $element = $posts_container;

        if ($posts_container.find("img").length == 0) $element = $("<img />");

        imagesLoaded($element, function (instance) {
          if (
            $("body").hasClass("mobile") ||
            $("#post-area").hasClass("span_9")
          ) {
            $cols = 2;
          }

          //set img as BG if masonry classic enhanced
          if ($posts_container.parent().hasClass("classic_enhanced")) {
            $posts_container
              .find(
                ".large_featured.has-post-thumbnail .post-featured-img, .wide_tall.has-post-thumbnail .post-featured-img"
              )
              .each(function () {
                var $src = $(this).find("img").attr("src");
                $(this).css("background-image", "url(" + $src + ")");
              });

            $posts_container
              .find(
                ".large_featured .nectar-flickity, .wide_tall .nectar-flickity"
              )
              .each(function () {
                $(this)
                  .find(".cell")
                  .each(function () {
                    var $src = $(this).find("img").attr("src");
                    $(this).css("background-image", "url(" + $src + ")");
                  });
              });
          }

          $cols = blogColumnNumbCalcs();
          blogHeightCalcs($posts_container, $cols);

          if ($("#post-area.meta_overlaid").length > 0) {
            $posts_container
              .isotope({
                itemSelector: "article",
                transitionDuration: "0s",
                layoutMode: "packery",
                packery: {
                  gutter: 0,
                },
              })
              .isotope("layout");
          } else {
            if ($posts_container.parent().hasClass("classic_enhanced")) {
              if ($(".span_9.masonry").length == 0) {
                $multiplier = window.innerWidth >= 1600 ? 0.015 : 0.02;
              } else {
                $multiplier = 0.04;
              }
            } else {
              $multiplier = $(".span_9.masonry").length == 0 ? 0.02 : 0.04;
            }
            $posts_container
              .isotope({
                itemSelector: "article",
                transitionDuration: "0s",
                layoutMode: "packery",
                packery: {
                  gutter: $("#post-area").width() * $multiplier,
                },
              })
              .isotope("layout");
          }

          blogLoadIn();
          flickityBlogInit();

          $(window).trigger("resize");

          blogMasonryZindex();
          setTimeout(blogMasonryZindex, 700);
          $window.smartresize(function () {
            setTimeout(blogMasonryZindex, 700);
          });
        });

        jQuery(window).resize(function ($) {
          //size all items in grid
          //sizing for large items
          $cols = blogColumnNumbCalcs();
          blogHeightCalcs($posts_container, $cols);

          if ($("#post-area.meta_overlaid").length > 0) {
            $posts_container.isotope({
              layoutMode: "packery",
              packery: {
                gutter: 0,
              },
            });
          } else {
            if ($posts_container.parent().hasClass("classic_enhanced")) {
              if ($(".span_9.masonry").length == 0) {
                $multiplier = window.innerWidth >= 1600 ? 0.015 : 0.02;
              } else {
                $multiplier = 0.04;
              }
            } else {
              $multiplier = $(".span_9.masonry").length == 0 ? 0.02 : 0.04;
            }

            $posts_container.isotope({
              layoutMode: "packery",
              packery: {
                gutter: $("#post-area").width() * $multiplier,
              },
            });
          }
        });
      } else {
        blogLoadIn();
      }
    }

    masonryBlogInit();

    function blogLoadIn() {
      $(".posts-container").each(function () {
        if ($(this).attr("data-load-animation") == "none") {
          $(this).find(".inner-wrap").removeClass("animated");
        } else {
          $(this)
            .find("article")
            .each(function (i) {
              //loaded visible
              if ($(this).visible(true)) {
                $(this)
                  .delay(110 * i)
                  .queue(function (next) {
                    $(this).addClass("animated-in");
                    next();
                  });
              } else {
                //not already visible
                var $that = $(this);
                var waypoint = new Waypoint({
                  element: $that,
                  handler: function (direction) {
                    setTimeout(function () {
                      $that.addClass("animated-in");
                    }, 80 * $that.attr("data-delay-amount"));

                    waypoint.destroy();
                  },
                  offset: "90%",
                });
              }
            });
        }
      }); //each
    }

    function blogHeightCalcs($posts_container, cols) {
      if (
        $posts_container.parent().hasClass("meta_overlaid") &&
        $posts_container.find('article[class*="regular"]').length > 0
      ) {
        //widths
        $.each($posts_container, function (i, v) {
          var $colSize = 4;
          var $mult = cols == 1 ? 1 : 2;

          //check if higher than IE9 -- bugs out with width calc
          if ($("html.no-csstransitions").length == 0) {
            $(v)
              .find('article[class*="regular"]')
              .css("width", Math.floor($(v).width() / cols) + "px");
            $(v)
              .find('article[class*="tall"]')
              .css("width", Math.floor(($(v).width() / cols) * $mult) + "px");
          } else {
            $("#post-area.masonry").css("width", "100%");
          }
        });

        //reset height for calcs
        $posts_container
          .find('article[class*="regular"] img')
          .css("height", "auto");

        var tallColHeight = Math.ceil(
          $posts_container
            .find(
              'article[class*="regular"]:not(".format-link"):not(".format-quote") img'
            )
            .first()
            .height()
        );
        var multipler = window.innerWidth > 690 ? 2 : 1;
        $posts_container
          .find(
            'article[class*="tall"] img, .article.wide img, article.regular img'
          )
          .removeClass("auto-height");
        $posts_container
          .find('article[class*="tall"] img')
          .css("height", tallColHeight * multipler);
        $posts_container
          .find('article[class*="regular"] img')
          .css("height", tallColHeight);
        //quote/links
        $posts_container
          .find("article.regular.format-link,article.regular.format-quote")
          .each(function () {
            if (window.innerWidth > 690) {
              $(this).css({
                height: tallColHeight,
              });
            } else {
              $(this).css({
                height: "auto",
              });
            }
          });
      } else {
        $posts_container
          .find('article[class*="tall"] img, article.regular img')
          .addClass("auto-height");
      }

      if (
        $posts_container.parent().hasClass("classic_enhanced") &&
        $posts_container.find('article[class*="regular"]').length > 0
      ) {
        if ($(window).width() > 690)
          classicEnhancedSizing(
            $posts_container.find(
              "article:not(.large_featured):not(.wide_tall)"
            )
          );
        else
          classicEnhancedSizing(
            $posts_container.find("article:not(.wide_tall)")
          );

        var tallColHeight =
          $posts_container
            .find(
              'article[class*="regular"]:not(".format-link"):not(".format-quote").has-post-thumbnail'
            )
            .first().length > 0
            ? Math.ceil(
                $posts_container
                  .find(
                    'article[class*="regular"]:not(".format-link"):not(".format-quote").has-post-thumbnail'
                  )
                  .first()
                  .css("height", "auto")
                  .height()
              )
            : 600;

        if ($(window).width() > 690)
          $posts_container
            .find(
              'article.large_featured, article.regular, article[class*="wide_tall"]'
            )
            .css("height", tallColHeight);
        else
          $posts_container
            .find('article.regular, article[class*="wide_tall"]')
            .css("height", tallColHeight);

        //for when no regular articles exist
      } else if (
        $posts_container.parent().hasClass("classic_enhanced") &&
        $posts_container.find('article[class*="regular"]').length == 0
      ) {
        var tallColHeight =
          $posts_container
            .find(
              'article[class*="regular"]:not(".format-link"):not(".format-quote").has-post-thumbnail'
            )
            .first().length > 0
            ? Math.ceil(
                $posts_container
                  .find(
                    'article[class*="regular"]:not(".format-link"):not(".format-quote").has-post-thumbnail'
                  )
                  .first()
                  .css("height", "auto")
                  .height()
              )
            : 600;

        if ($(window).width() > 690)
          $posts_container
            .find(
              'article.large_featured, article.regular, article[class*="wide_tall"]'
            )
            .css("height", tallColHeight);
        else
          $posts_container
            .find('article.regular, article[class*="wide_tall"]')
            .css("height", tallColHeight);
      }

      //IE9 fix
      if ($("html.no-csstransitions").length > 0)
        $("#post-area.masonry").css("width", "100%");
    }

    function classicEnhancedSizing(elements) {
      var tallestCol = 0;
      elements.find(".article-content-wrap").css("height", "auto");
      elements.filter(".has-post-thumbnail").each(function () {
        $(this).find(".article-content-wrap").outerHeight(true) > tallestCol
          ? (tallestCol = $(this)
              .find(".article-content-wrap")
              .outerHeight(true))
          : (tallestCol = tallestCol);
      });

      elements
        .filter(".has-post-thumbnail")
        .find(".article-content-wrap")
        .css("height", tallestCol);
    }

    var blogMediaQuerySize;
    function blogColumnNumbCalcs() {
      if (
        ($("body").hasClass("mobile") && window.innerWidth < 990) ||
        ($("#post-area").hasClass("span_9") &&
          $("#post-area.meta_overlaid").length == 0)
      ) {
        $cols = 2;
      } else if (
        $("#post-area").hasClass("full-width-content") ||
        ($("#post-area").parent().hasClass("full-width-content") &&
          $("#boxed").length == 0) ||
        $("#post-area.meta_overlaid").length > 0
      ) {
        var windowSize = $(window).width();

        if (window.innerWidth >= 1600) {
          blogMediaQuerySize =
            $("#post-area.meta_overlaid").length > 0 ? "four" : "five";
        } else if (window.innerWidth < 1600 && window.innerWidth >= 1300) {
          blogMediaQuerySize = "four";
        } else if (window.innerWidth < 1300 && window.innerWidth >= 990) {
          blogMediaQuerySize =
            $("#post-area.meta_overlaid").length > 0 ? "four" : "three";
        } else if (window.innerWidth < 990 && window.innerWidth >= 470) {
          blogMediaQuerySize = "two";
        } else if (window.innerWidth < 470) {
          blogMediaQuerySize =
            $("#post-area.meta_overlaid").length > 0 ? "two" : "one";
        }

        //boxed
        if ($("#boxed").length > 0) {
          if (window.innerWidth > 1300) {
            blogMediaQuerySize = "four";
          } else if (window.innerWidth < 1300 && window.innerWidth > 990) {
            blogMediaQuerySize =
              $("#post-area.meta_overlaid").length > 0 ? "four" : "three";
          } else if (window.innerWidth < 990) {
            blogMediaQuerySize =
              $("#post-area.meta_overlaid").length > 0 ? "two" : "one";
          }
        }

        switch (blogMediaQuerySize) {
          case "five":
            $cols = 5;
            break;

          case "four":
            $cols = 4;
            break;

          case "three":
            $cols = 3;
            break;

          case "two":
            $cols = 2;
            break;

          case "one":
            $cols = 1;
            break;
        }
      } else {
        $cols = 3;
      }

      return $cols;
    }

    var shrinkNum = 6;

    if ($("#header-outer[data-shrink-num]").length > 0)
      shrinkNum = $("#header-outer").attr("data-shrink-num");

    headerPadding2 = headerPadding - headerPadding / 1.8;

    $("body").on("click", ".section-down-arrow", function () {
      if ($(this).parents(".nectar-box-roll").length > 0) return false;

      var $currentSection = $(this).parents("#page-header-bg");
      var $topDistance = $currentSection.attr("data-height");
      var $offset =
        $currentSection.parents(".first-section").length == 0 ||
        $('body[data-transparent-header="false"]').length > 0
          ? $currentSection.offset().top
          : 0;
      var $bodyBorderSize =
        $(".body-border-top").length > 0 && $(window).width() > 1000
          ? $(".body-border-top").height()
          : 0;
      var $headerNavSpace =
        $('body[data-header-format="left-header"]').length > 0
          ? 0
          : $("#header-space").height();
      if ($('body[data-permanent-transparent="1"]').length == 0) {
        //regular
        if (!$("body").hasClass("mobile")) {
          if (
            $('body[data-hhun="1"]').length > 0 &&
            $('#header-outer[data-remove-fixed="1"]').length == 0
          ) {
            $("body,html")
              .stop()
              .animate(
                {
                  scrollTop:
                    parseInt($topDistance) + $offset + 2 - $bodyBorderSize * 2,
                },
                1000,
                "easeInOutCubic"
              );
          } else {
            $resize =
              $('#header-outer[data-header-resize="0"]').length > 0
                ? 0
                : parseInt(shrinkNum) + headerPadding2 * 2;
            if ($('#header-outer[data-remove-fixed="1"]').length > 0) {
              $headerNavSpace = 0;
              $offset = 0;
            }
            $("body,html")
              .stop()
              .animate(
                {
                  scrollTop:
                    parseInt($topDistance - $headerNavSpace) +
                    $resize +
                    3 +
                    $offset,
                },
                1000,
                "easeInOutCubic"
              );
          }
        } else {
          $scrollPos =
            $('#header-outer[data-mobile-fixed="1"]').length > 0
              ? parseInt($topDistance) -
                $headerNavSpace +
                parseInt($currentSection.offset().top) +
                2
              : parseInt($topDistance) +
                parseInt($currentSection.offset().top) +
                2;
          $("body,html")
            .stop()
            .animate(
              {
                scrollTop: $scrollPos - $bodyBorderSize * 2,
              },
              1000,
              "easeInOutCubic"
            );
        }
      } else {
        //permanent transparent
        $("body,html")
          .stop()
          .animate(
            {
              scrollTop:
                parseInt($topDistance) +
                parseInt($currentSection.offset().top) +
                2 -
                $bodyBorderSize * 2,
            },
            1000,
            "easeInOutCubic"
          );
      }
      return false;
    });

    /*-------------------------------------------------------------------------*/
    /*	7.	Cross Browser Fixes
/*-------------------------------------------------------------------------*/

    function crossBrowserFixes() {
      //Fix current class in menu
      if (
        $("body").hasClass("single-portfolio") ||
        $("body").hasClass("error404") ||
        $("body").hasClass("search-results")
      ) {
        $("li")
          .removeClass("current_page_parent")
          .removeClass("current-menu-ancestor")
          .removeClass("current_page_ancestor");
      }

      //for users updating to 8 with a custom, old header template file
      if ($("html.js").length == 0) {
        $("html").removeClass("no-js").addClass("js");
      }

      //fix for IE8 nth-child
      $(
        ".recent_projects_widget div a:nth-child(3n+3), #sidebar #flickr div:nth-child(3n+3) a, #footer-outer #flickr div:nth-child(3n+3) a"
      ).css("margin-right", "0px");

      //remove br's from code tag
      $("code").find("br").remove();

      //if a clear is the last div, remove the padding
      if (
        $(".container.main-content > .row > div:last-child").hasClass("clear")
      ) {
        $(".container.main-content > .row > div:last-child").css(
          "padding-bottom",
          "0"
        );
      }

      //homepage recent blog for IE8
      $(".container-wrap .blog-recent > div:last-child").addClass("col_last");

      //blog ascend bottom padding
      if ($(".single .blog_next_prev_buttons").length > 0)
        $(".container-wrap").css("padding-bottom", 0);

      //contact form
      $(".wpcf7-form p:has(input[type=submit])").css("padding-bottom", "0px");

      $(".full-width-content .wpcf7-submit").on("click", function () {
        setTimeout(function () {
          fullWidthContentColumns();
        }, 1000);
        setTimeout(function () {
          fullWidthContentColumns();
        }, 2000);
      });

      //no caption home slider fix
      $("#featured article").each(function () {
        if ($(this).find("h2").attr("data-has-caption") == "0") {
          $(this).parents(".slide").addClass("no-caption");
        }
      });

      //add class for IE
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("Edge/");
      if (msie > 0) $("body").addClass("msie");

      //gravity form inside fw content row
      $(".gform_body").click(function () {
        setTimeout(function () {
          fullWidthContentColumns();
        }, 200);
      });

      //chat post format nth child color
      $("article.post.format-chat .content-inner dt:odd").css("color", "#333");

      //remove margin on last cols inside of full width sections
      $(".full-width-section").each(function () {
        $(this)
          .find("> .span_12 > div.col_last")
          .last()
          .css("margin-bottom", "0");
      });

      //remove p tags from extra content editor when warpping only an img
      $("#portfolio-extra p").each(function () {
        if ($(this).find("*").length == 1 && $(this).find("img").length == 1) {
          $(this).find("img").unwrap();
        }
      });

      //vc text_separator color
      $(".vc_text_separator").each(function () {
        if ($(this).parents(".full-width-section").length > 0)
          $(this)
            .find("div")
            .css(
              "background-color",
              $(this)
                .parents(".full-width-section")
                .find(".row-bg")
                .css("background-color")
            );
      });

      //carousel head button alignment
      $(".carousel-heading").each(function () {
        if ($(this).find("h2").length > 0)
          $(this).find(".carousel-prev, .carousel-next").css("top", "7px");
      });

      //remove carousel heading if not being used
      $(".carousel-wrap").each(function () {
        if ($(this).find(".carousel-heading .container:empty").length > 0)
          $(this).find(".carousel-heading").remove();
      });

      //woocommerce product thuimbnails
      $(
        ".woocommerce div.product div.images div.thumbnails a:nth-child(4n+4)"
      ).css("margin-right", "0px");

      //remove extra galleries when using the nectar gallery slider on projects and posts
      $(
        "article.post .gallery-slider .gallery,  article.post .gallery-slider .jetpack-slideshow, .single-portfolio .gallery-slider .gallery, .single-portfolio .gallery-slider .jetpack-slideshow"
      ).remove();

      $(
        ".woocommerce .span_9 .products.related .products li:nth-child(4), .woocommerce .span_9 .products.upsells .products li:nth-child(4)"
      ).remove();
      $(
        ".woocommerce .span_9 .products.related .products li:nth-child(3), .woocommerce .span_9 .products.upsells .products li:nth-child(3)"
      ).css("margin-right", "0");

      $(".cart-menu a, .widget_shopping_cart a").addClass("no-ajaxy");

      //clients no hover if no link
      $("div.clients").each(function () {
        $(this)
          .find("> div")
          .each(function () {
            if ($(this).find("a").length == 0) {
              $(this).addClass("no-link");
            }
          });
      });

      //remove ajaxy from single posts when using disqus
      if (nectarLove.disqusComments == "true")
        $(
          "#post-area article a, .blog_next_prev_buttons a, #portfolio-nav #prev-link a, #portfolio-nav #next-link a, .portfolio-items .col .work-item .work-info a"
        ).addClass("no-ajaxy");

      //blog next color bg only
      if (
        $(".blog_next_prev_buttons").find(".bg-color-only-indicator").length > 0
      )
        $(".blog_next_prev_buttons")
          .addClass("bg-color-only")
          .find(".bg-color-only-indicator")
          .remove();

      if (
        $("#single-below-header").hasClass("fullscreen-header") &&
        $(".blog_next_prev_buttons").length == 0
      )
        $("#author-bio, .comment-wrap").addClass("lighter-grey");

      //shop header parallax margin
      if ($("body.woocommerce").find("#page-header-bg").length > 0) {
        $(".container-wrap").css({
          "margin-top": "0px",
          "padding-top": "30px",
        });
      }

      //if using wooCommerce sitewide notice
      if ($(".demo_store").length > 0)
        $("#header-outer, #header-space").css("margin-top", "32px");

      //footer last column class for IE8
      $("#footer-widgets .container .row > div:last-child").addClass(
        "col_last"
      );

      //nectar slider external links
      $(".swiper-slide.external-button-1 .buttons > div:nth-child(1) a").attr(
        "target",
        "_blank"
      );
      $(".swiper-slide.external-button-2 .buttons > div:nth-child(2) a").attr(
        "target",
        "_blank"
      );

      //portfolio external links
      $(
        ".portfolio-items a[href*='http://']:not([href*='" +
          window.location.hostname +
          "']), .recent_projects_widget a[href*='http://']:not([href*='" +
          window.location.hostname +
          "'])"
      ).attr("target", "_blank");

      //remove excess inner content when empty row
      $(".container-wrap .row > .wpb_row").each(function () {
        if (
          $(this).find("> .span_12 > .wpb_column > .wpb_wrapper").length > 0 &&
          $(this).find("> .span_12 > .wpb_column > .wpb_wrapper").find("*")
            .length == 0
        )
          $(this).find("> .span_12 ").remove();
      });

      //remove boxed style from full width content
      $(".full-width-content .col.boxed").removeClass("boxed");

      //remove full width attribute on slider in full width content section
      $(
        '.full-width-content .wpb_column .nectar-slider-wrap[data-full-width="true"]'
      ).attr("data-full-width", "false");

      if (
        $(".nectar-slider-wrap.first-section").length == 0 &&
        $(
          ".full-width-section.first-section > .span_12 > .vc_span12 > .wpb_wrapper > .nectar-slider-wrap"
        ).length == 0 &&
        $(".parallax_slider_outer.first-section").length == 0 &&
        $(
          ".full-width-content.first-section .wpb_wrapper > .nectar-slider-wrap"
        ).length == 0 &&
        !(
          $(".wpb_row.first-section > .nectar-parallax-scene").length == 1 &&
          $('#header-outer[data-transparent-header="true"]').length == 1
        )
      ) {
        $("#header-outer .ns-loading-cover").remove();
      }

      //neg marg z-index
      $(".wpb_column.neg-marg").parents(".wpb_row").css("z-index", "110");

      //portfolio description remove on hover
      var $tmpTitle = null;
      $(".portfolio-items > .col a[title]").hover(
        function () {
          $tmpTitle = $(this).attr("title");
          $(this).attr("title", " ");
        },
        function () {
          $(this).attr("title", $tmpTitle);
        }
      );
      $(".portfolio-items > .col a[title]").click(function () {
        $(this).attr("title", $tmpTitle);
      });
    }

    crossBrowserFixes();

    jQuery(document.body).on("updated_cart_totals", function () {
      if ($(".plus").length == 0)
        $("div.quantity:not(.buttons_added), td.quantity:not(.buttons_added)")
          .addClass("buttons_added")
          .append('<input type="button" value="+" class="plus" />')
          .prepend('<input type="button" value="-" class="minus" />');
    });

    // Quantity buttons
    if ($(".plus").length == 0) {
      $("div.quantity:not(.buttons_added), td.quantity:not(.buttons_added)")
        .addClass("buttons_added")
        .append('<input type="button" value="+" class="plus" />')
        .prepend('<input type="button" value="-" class="minus" />');

      $(document).on("click", ".plus, .minus", function () {
        // Get values
        var $qty = $(this).closest(".quantity").find(".qty"),
          currentVal = parseFloat($qty.val()),
          max = parseFloat($qty.attr("max")),
          min = parseFloat($qty.attr("min")),
          step = $qty.attr("step");

        // Format values
        if (!currentVal || currentVal === "" || currentVal === "NaN")
          currentVal = 0;
        if (max === "" || max === "NaN") max = "";
        if (min === "" || min === "NaN") min = 0;
        if (
          step === "any" ||
          step === "" ||
          step === undefined ||
          parseFloat(step) === "NaN"
        )
          step = 1;

        // Change the value
        if ($(this).is(".plus")) {
          if (max && (max == currentVal || currentVal > max)) {
            $qty.val(max);
          } else {
            $qty.val(currentVal + parseFloat(step));
          }
        } else {
          if (min && (min == currentVal || currentVal < min)) {
            $qty.val(min);
          } else if (currentVal > 0) {
            $qty.val(currentVal - parseFloat(step));
          }
        }

        // Trigger change event
        $qty.trigger("change");
      });
    }

    function wooPriceSlider() {
      // woocommerce_price_slider_params is required to continue, ensure the object exists
      if (
        typeof woocommerce_price_slider_params === "undefined" ||
        !$("body").hasClass("woocommerce")
      ) {
        return false;
      }

      // Get markup ready for slider
      $("input#min_price, input#max_price").hide();
      $(".price_slider, .price_label").show();

      // Price slider uses jquery ui
      var min_price = $(".price_slider_amount #min_price").data("min"),
        max_price = $(".price_slider_amount #max_price").data("max");

      current_min_price = parseInt(min_price, 10);
      current_max_price = parseInt(max_price, 10);

      if (woocommerce_price_slider_params.min_price)
        current_min_price = parseInt(
          woocommerce_price_slider_params.min_price,
          10
        );
      if (woocommerce_price_slider_params.max_price)
        current_max_price = parseInt(
          woocommerce_price_slider_params.max_price,
          10
        );

      $("body").bind(
        "price_slider_create price_slider_slide",
        function (event, min, max) {
          if (woocommerce_price_slider_params.currency_pos === "left") {
            $(".price_slider_amount span.from").html(
              woocommerce_price_slider_params.currency_symbol + min
            );
            $(".price_slider_amount span.to").html(
              woocommerce_price_slider_params.currency_symbol + max
            );
          } else if (
            woocommerce_price_slider_params.currency_pos === "left_space"
          ) {
            $(".price_slider_amount span.from").html(
              woocommerce_price_slider_params.currency_symbol + " " + min
            );
            $(".price_slider_amount span.to").html(
              woocommerce_price_slider_params.currency_symbol + " " + max
            );
          } else if (woocommerce_price_slider_params.currency_pos === "right") {
            $(".price_slider_amount span.from").html(
              min + woocommerce_price_slider_params.currency_symbol
            );
            $(".price_slider_amount span.to").html(
              max + woocommerce_price_slider_params.currency_symbol
            );
          } else if (
            woocommerce_price_slider_params.currency_pos === "right_space"
          ) {
            $(".price_slider_amount span.from").html(
              min + " " + woocommerce_price_slider_params.currency_symbol
            );
            $(".price_slider_amount span.to").html(
              max + " " + woocommerce_price_slider_params.currency_symbol
            );
          }

          $("body").trigger("price_slider_updated", min, max);
        }
      );

      $(".price_slider").slider({
        range: true,
        animate: true,
        min: min_price,
        max: max_price,
        values: [current_min_price, current_max_price],
        create: function (event, ui) {
          $(".price_slider_amount #min_price").val(current_min_price);
          $(".price_slider_amount #max_price").val(current_max_price);

          $("body").trigger("price_slider_create", [
            current_min_price,
            current_max_price,
          ]);
        },
        slide: function (event, ui) {
          $("input#min_price").val(ui.values[0]);
          $("input#max_price").val(ui.values[1]);

          $("body").trigger("price_slider_slide", [ui.values[0], ui.values[1]]);
        },
        change: function (event, ui) {
          $("body").trigger("price_slider_change", [
            ui.values[0],
            ui.values[1],
          ]);
        },
      });
    }

    //vc col mobile fixes
    function vcMobileColumns() {
      $(".wpb_row").each(function () {
        if (typeof $(this).find(".span_12").offset() != "undefined") {
          $(this)
            .find('[class*="vc_col-"]')
            .each(function () {
              var $firstChildOffset = $(this).parents(".span_12").offset().left;

              $(this).removeClass("no-left-margin");
              if ($(this).offset().left < $firstChildOffset + 27) {
                $(this).addClass("no-left-margin");
              } else {
                $(this).removeClass("no-left-margin");
              }
            });
        }
      });
    }

    if (
      $('[class*="vc_col-xs-"], [class*="vc_col-md-"], [class*="vc_col-lg-"]')
        .length > 0
    )
      vcMobileColumns();

    /*-------------------------------------------------------------------------*/
    /*	8.	Form Styling
/*-------------------------------------------------------------------------*/

    if ($('body[data-form-style="minimal"]').length > 0) {
      //turn user set place holders into labels for effect
      function convertPlaceholders() {
        $(
          'form input[placeholder]:not([name="min_price"]):not([name="max_price"]), form textarea[placeholder]'
        ).each(function (i) {
          if ($(this).attr("placeholder").length > 1) {
            var $placeholder = $(this).attr("placeholder");
            var $inputID = $(this).is("[id]") ? $(this).attr("id") : "id-" + i;
            //add placeholder as label if label doesn't already exist

            //skip cf7                               //|| $(this).prev('label').length == 1 && $placeholder.length > $(this).prev('label').text().length
            if ($(this).parents(".wpcf7-form-control-wrap").length == 0) {
              if ($(this).prev("label").length == 0 || $(this).is("textarea")) {
                $(
                  '<label for="' + $inputID + '">' + $placeholder + "</label>"
                ).insertBefore($(this));
              }
            } else {
              if (
                $(this).parents(".wpcf7-form-control-wrap").find("label")
                  .length == 0
              ) {
                $(
                  '<label for="' + $inputID + '">' + $placeholder + "</label>"
                ).insertBefore($(this).parents(".wpcf7-form-control-wrap "));
              }
            }
            $(this).removeAttr("placeholder");
          }
        });
      }
      convertPlaceholders();
      setTimeout(convertPlaceholders, 500);

      //woocommerce placeholder fix
      $("#billing_country, #shipping_country, .country_to_state").on(
        "change",
        function () {
          convertPlaceholders();
          removeExcessLabels();
          var $wooDynamicPlaceholders = setInterval(function () {
            convertPlaceholders();
            convertToMinimalStyle("form label");
            removeExcessLabels();
          }, 30);
          setTimeout(function () {
            clearInterval($wooDynamicPlaceholders);
          }, 600);
        }
      );

      function convertToMinimalStyle(selector) {
        $(selector).each(function () {
          if (
            $(this)
              .parent()
              .find(
                'input:not([type="checkbox"]):not([type="hidden"]):not(#search-outer input):not(.adminbar-input):not([type="radio"]):not([type="submit"]):not([type="button"]):not([type="date"]):not([type="color"]):not([type="range"]):not([role="button"]):not([role="combobox"]):not(.select2-focusser):not([name="min_price"]):not([name="max_price"])'
              ).length == 1 ||
            $(this).parent().find("textarea").length == 1
          ) {
            if ($(this).parents(".minimal-form-input").length == 0) {
              //if there's a direct input next to label

              if ($(this).next("input").length == 1) {
                $(this)
                  .next("input")
                  .andSelf()
                  .wrapAll('<div class="minimal-form-input"/>');
              } else if ($(this).find(".wpcf7-form-control-wrap").length > 0) {
                var $cloneInput = $(this).find(".wpcf7-form-control-wrap");
                $(this).find(".wpcf7-form-control-wrap").remove();
                $cloneInput.insertAfter($(this));
                $(this)
                  .parent()
                  .wrapInner('<div class="minimal-form-input" />');
              } else {
                //if we need to traverse to parent instead
                $(this)
                  .parent()
                  .wrapInner('<div class="minimal-form-input" />');
              }
              $html = $(this).html();
              $(this)[0].innerHTML =
                '<span class="text"><span class="text-inner">' +
                $html +
                "</span></span>";

              if ($(this).parent().find("textarea").length == 1)
                $(this).parents(".minimal-form-input").addClass("textarea");
            }
          }
        });

        //for labels that changed that already have minimal form markup - just need to update content
        $(selector).each(function () {
          if (
            $(this).parents(".minimal-form-input").length == 1 &&
            $(this).find(".text").length == 0
          ) {
            $html = $(this).html();
            $(this)[0].innerHTML =
              '<span class="text"><span class="text-inner">' +
              $html +
              "</span></span>";
          }
        });
      }

      convertToMinimalStyle("form label");

      jQuery(document.body).on("updated_cart_totals", function () {
        convertToMinimalStyle("form label");
      });

      setTimeout(function () {
        convertToMinimalStyle("form label");
        removeExcessLabels();
        checkValueOnLoad();
      }, 501);

      //remove excess labels
      function removeExcessLabels() {
        $(".minimal-form-input").each(function () {
          if ($(this).find("label").length > 1) {
            $lngth = 0;
            $(this)
              .find("label")
              .each(function () {
                if ($(this).text().length >= $lngth) {
                  $lngth = $(this).text().length;
                  $(this)
                    .parents(".minimal-form-input")
                    .find("label")
                    .addClass("tbr");
                  $(this).removeClass("tbr");
                }
              });
            $(this).find("label.tbr").remove();
          }
        });
      }
      removeExcessLabels();

      //add labels to inputs that don't have them
      $(
        'input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not(#search-outer input):not([type="hidden"]):not([type="button"]):not([type="date"]):not([type="color"]):not([type="number"]):not([type="range"]):not([role="button"]):not([role="combobox"]):not(.select2-focusser):not([name="min_price"]):not([name="max_price"]), textarea'
      ).each(function () {
        if ($(this).parents(".minimal-form-input").length == 0) {
          $("<label></label>").insertBefore($(this));
          convertToMinimalStyle($(this).prev("label"));
        }
      });

      $("body").on(
        "focus",
        ".minimal-form-input input, .minimal-form-input textarea",
        function () {
          $(this)
            .parents(".minimal-form-input")
            .addClass("filled")
            .removeClass("no-text");
        }
      );
      $("body").on(
        "blur",
        ".minimal-form-input input, .minimal-form-input textarea",
        function () {
          if ($(this).val().length > 0)
            $(this)
              .parents(".minimal-form-input")
              .addClass("has-text")
              .removeClass("no-text");
          else
            $(this)
              .parents(".minimal-form-input")
              .removeClass("has-text")
              .addClass("no-text");
          $(this).parents(".minimal-form-input").removeClass("filled");
        }
      );

      //on load
      function checkValueOnLoad() {
        $(".minimal-form-input input, .minimal-form-input textarea").each(
          function () {
            if ($(this).val().length > 0)
              $(this)
                .parents(".minimal-form-input")
                .addClass("has-text")
                .removeClass("no-text");
          }
        );
      }
      checkValueOnLoad();

      // Textarea Auto Resize
      var hiddenDiv = $(".hiddendiv").first();
      if (!hiddenDiv.length) {
        hiddenDiv = $('<div class="textareahiddendiv common"></div>');
        $("body").append(hiddenDiv);
      }
      var text_area_selector = "textarea";

      function textareaAutoResize($textarea) {
        // Set font properties of hiddenDiv

        var fontFamily = $textarea.css("font-family");
        var fontSize = $textarea.css("font-size");

        if (fontSize) {
          hiddenDiv.css("font-size", fontSize);
        }
        if (fontFamily) {
          hiddenDiv.css("font-family", fontFamily);
        }

        if ($textarea.attr("wrap") === "off") {
          hiddenDiv.css("overflow-wrap", "normal").css("white-space", "pre");
        }

        hiddenDiv.text($textarea.val() + "\n");
        var content = hiddenDiv.html().replace(/\n/g, "<br>");
        hiddenDiv.html(content);

        // When textarea is hidden, width goes crazy.
        // Approximate with half of window size

        if ($textarea.is(":visible")) {
          hiddenDiv.css("width", $textarea.width());
        } else {
          hiddenDiv.css("width", $(window).width() / 2);
        }

        $textarea.css("height", hiddenDiv.height());
      }

      $(text_area_selector).each(function () {
        var $textarea = $(this);
        if ($textarea.val().length) {
          textareaAutoResize($textarea);
        }
      });

      $("body").on("keyup keydown autoresize", text_area_selector, function () {
        textareaAutoResize($(this));
      });
    }

    if ($('body[data-fancy-form-rcs="1"]').length > 0) {
      //radio / checkbox markup conversion

      ////default
      $('input[type="checkbox"]').each(function () {
        //check if for relationship exists
        $id = $(this).attr("id");
        if (
          typeof $id !== typeof undefined &&
          $id !== false &&
          $('label[for="' + $id + '"]').length > 0
        ) {
          $('label[for="' + $id + '"]').prepend("<span></span>");
        } else {
          if ($(this).parents(".wpcf7-checkbox").length == 0) {
            $(this).addClass("non-minimal");
          }
        }
      });

      ////for cf7
      $(".wpcf7-radio .wpcf7-list-item-label").each(function (i) {
        var $data = $(this).html();
        var $name = $(this).parent().find("input").attr("name") + i;
        $(this).parent().find("input").attr("id", $name);
        $(this).replaceWith('<label for="' + $name + '">' + $data + "</label>");
      });

      $(".wpcf7-checkbox .wpcf7-list-item-label").each(function () {
        var $data = $(this).html();
        var $name = $(this).parent().find("input").attr("value");
        $(this).parent().find("input").attr("id", $name);
        $(this).replaceWith(
          '<label for="' + $name + '"><span></span>' + $data + "</label>"
        );
      });

      //select
      $("select:not(.comment-form-rating #rating)").each(function () {
        //cf7
        if ($(this).parents(".wpcf7-form-control-wrap").length > 0) {
          //select 2 already initialized
          if (
            $(this)
              .parents(".wpcf7-form-control-wrap")
              .find(".select2-container").length > 0
          ) {
            $selector = $($(this).prev(".select2-container"));
          } else {
            $selector = $(this);
          }

          //if label is found
          if (
            $selector.parents(".wpcf7-form-control-wrap").parent().find("label")
              .length == 1
          ) {
            $selector
              .parents(".wpcf7-form-control-wrap")
              .parent()
              .wrapInner('<div class="fancy-select-wrap" />');
          } else {
            //default wrap
            $selector.wrap('<div class="fancy-select-wrap" />');
          }
        }
        //default
        else {
          //select 2 already initialized
          if ($(this).prev(".select2-container").length > 0) {
            $selector = $(this).prev(".select2-container");
          } else {
            $selector = $(this);
          }

          //if label is found
          if ($selector.prev("label").length == 1) {
            $selector
              .prev("label")
              .andSelf()
              .wrapAll('<div class="fancy-select-wrap" />');
          } else if ($selector.next("label").length == 1) {
            $selector
              .next("label")
              .andSelf()
              .wrapAll('<div class="fancy-select-wrap" />');
          } else {
            //default wrap
            $selector.wrap('<div class="fancy-select-wrap" />');
          }
        }
      });

      function select2Init() {
        $(
          "select:not(.state_select):not(.country_select):not(.comment-form-rating #rating)"
        ).each(function () {
          if ($(this).parents(".woocommerce-ordering").length == 0) {
            $(this).select2({
              minimumResultsForSearch: 7,
            });
          } else {
            $(this).select2({
              minimumResultsForSearch: 7,
              dropdownCssClass: "bigdrop",
              dropdownAutoWidth: true,
            });
          }
        });
      }

      select2Init();
    }

    if (
      $('body[data-ajax-transitions="true"]').length > 0 &&
      $('#ajax-loading-screen[data-method="ajax"]').length > 0 &&
      !navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
      ) &&
      $(window).width() > 690
    ) {
      $("#ajax-content-wrap").ajaxify({
        selector:
          '#ajax-content-wrap a:not(.no-ajaxy):not([target="_blank"]):not([href^="#"]):not(.comment-edit-link):not(#cancel-comment-reply-link):not(.comment-reply-link):not(#toggle-nav):not(.cart_list a):not(.logged-in-as a):not(.no-widget-added a):not(.add_to_cart_button):not(.product-wrap a):not(.section-down-arrow):not([data-filter]):not(.product_list_widget a):not(.pp):not([rel^="prettyPhoto"]):not(.pretty_photo), #header-outer li:not(.no-ajaxy) > a:not(.no-ajaxy), #header-outer #logo',
        verbosity: 0,
        requestDelay: 400,
        previewoff: true,
        memoryoff: true,
        turbo: false,
      });

      $(window)
        .on("pronto.render", initPage)
        .on("pronto.load", destroyPage)
        .on("pronto.request", transitionPage);

      if (
        $(".nectar-box-roll").length == 0 &&
        $('#ajax-loading-screen[data-effect="horizontal_swipe"]').length > 0
      )
        setTimeout(function () {
          waypoints();
        }, 750);
      else if ($(".nectar-box-roll").length == 0)
        setTimeout(function () {
          waypoints();
        }, 300);

      if (
        $('#ajax-loading-screen[data-effect="horizontal_swipe"]').length > 0
      ) {
        setTimeout(function () {
          $("#ajax-loading-screen").addClass("loaded");
        }, 30);
      }

      initPage();
    } else if (
      $('body[data-ajax-transitions="true"]').length > 0 &&
      $('#ajax-loading-screen[data-method="standard"]').length > 0
    ) {
      //chrome white BG flash fix
      $("html").addClass("page-trans-loaded");

      //fadeout loading animation
      if ($('#ajax-loading-screen[data-effect="standard"]').length > 0) {
        if ($(".nectar-particles").length == 0) {
          setTimeout(function () {
            $("#ajax-loading-screen").transition(
              { opacity: 0 },
              500,
              function () {
                $(this).css({ display: "none" });
              }
            );
            $("#ajax-loading-screen .loading-icon").transition(
              { opacity: 0 },
              500
            );
          }, 30);
        }

        //bind waypoints after loading screen has left
        if ($(".nectar-box-roll").length == 0)
          setTimeout(function () {
            waypoints();
          }, 750);

        //safari back/prev fix
        if (
          (navigator.userAgent.indexOf("Safari") != -1 &&
            navigator.userAgent.indexOf("Chrome") == -1) ||
          navigator.userAgent.match(/(iPod|iPhone|iPad)/)
        ) {
          window.onunload = function () {
            $("#ajax-loading-screen")
              .stop()
              .transition({ opacity: 0 }, 800, function () {
                $(this).css({ display: "none" });
              });
            $("#ajax-loading-screen .loading-icon").transition(
              { opacity: 0 },
              600
            );
          };
          window.onpageshow = function (event) {
            if (event.persisted) {
              $("#ajax-loading-screen")
                .stop()
                .transition({ opacity: 0 }, 800, function () {
                  $(this).css({ display: "none" });
                });
              $("#ajax-loading-screen .loading-icon").transition(
                { opacity: 0 },
                600
              );
            }
          };
        } else if (navigator.userAgent.indexOf("Firefox") != -1) {
          window.onunload = function () {};
        }
      } else {
        //for swipe trans add loaded immediately
        if (
          $('#ajax-loading-screen[data-effect="horizontal_swipe"]').length > 0
        ) {
          setTimeout(function () {
            $("#ajax-loading-screen").addClass("loaded");
          }, 60);
        }

        if (
          $(
            '#page-header-wrap #page-header-bg[data-animate-in-effect="zoom-out"] .nectar-video-wrap'
          ).length == 0 &&
          $(".parallax_slider_outer").length == 0 &&
          $(".first-nectar-slider").length == 0
        ) {
          setTimeout(function () {
            $("#ajax-loading-screen:not(.loaded)").addClass("loaded");
            setTimeout(function () {
              $("#ajax-loading-screen").addClass("hidden");
            }, 1000);
          }, 150);
        }

        //safari back/prev fix
        if (
          (navigator.userAgent.indexOf("Safari") != -1 &&
            navigator.userAgent.indexOf("Chrome") == -1) ||
          navigator.userAgent.match(/(iPod|iPhone|iPad)/)
        ) {
          window.onunload = function () {
            $("#ajax-loading-screen")
              .stop()
              .transition({ opacity: 0 }, 800, function () {
                $(this).css({ display: "none" });
              });
            $("#ajax-loading-screen .loading-icon").transition(
              { opacity: 0 },
              600
            );
          };
          window.onpageshow = function (event) {
            if (event.persisted) {
              $("#ajax-loading-screen")
                .stop()
                .transition({ opacity: 0 }, 800, function () {
                  $(this).css({ display: "none" });
                });
              $("#ajax-loading-screen .loading-icon").transition(
                { opacity: 0 },
                600
              );
            }
          };
        } else if (navigator.userAgent.indexOf("Firefox") != -1) {
          window.onunload = function () {};
        }

        //bind waypoints after loading screen has left
        if (
          $(".nectar-box-roll").length == 0 &&
          $('#ajax-loading-screen[data-effect="horizontal_swipe"]').length > 0
        ) {
          setTimeout(function () {
            waypoints();
          }, 850);
        } else if ($(".nectar-box-roll").length == 0)
          setTimeout(function () {
            waypoints();
          }, 350);
      }

      //remove excess loading images now
      $(".portfolio-loading, .nectar-slider-loading .loading-icon").remove();

      if (
        $('#ajax-loading-screen[data-disable-fade-on-click="1"]').length == 0
      ) {
        $(
          'a[href]:not(.no-ajaxy):not([target="_blank"]):not([href^="#"]):not([href^="mailto:"]):not(.comment-edit-link):not(.magnific-popup):not(.magnific):not(.meta-comment-count a):not(.comments-link):not(#cancel-comment-reply-link):not(.comment-reply-link):not(#toggle-nav):not(.logged-in-as a):not(.add_to_cart_button):not(.section-down-arrow):not([data-filter]):not(.pp):not([rel^="prettyPhoto"]):not(.pretty_photo)'
        ).click(function (e) {
          //need to check on click again if link is just [href^="#"] since URLs could have been shortended via JS in scrollSpyInit
          if ($(this).is('[href^="#"]')) return;

          var $windowCurrentLocation = window.location.href.split("#")[0];
          var $windowClickedLocation = $(this).attr("href").split("#")[0];

          if (
            $(this).parents('#header-outer[data-format="left-header"]').length >
              0 &&
            $(this).parent().hasClass("menu-item-has-children")
          )
            return;

          if (
            ($(this).parent(".menu-item-has-children").length > 0 &&
              $(this).parents(".off-canvas-menu-container").length > 0) ||
            $windowClickedLocation == $windowCurrentLocation
          ) {
          } else {
            if (!$(this).parent().hasClass("no-ajaxy")) {
              var $targetLocation = $(this).attr("href");
              var $timeOutDur = 0;
              if ($targetLocation != "") {
                $("#ajax-loading-screen").addClass("set-to-fade");

                transitionPageStandard();

                setTimeout(function () {
                  window.location = $targetLocation;
                }, $timeOutDur);

                return false;
              }
            }
          }
        });
      } // if disable fade out is not on
    } else {
      //bind waypoints regularly
      if ($(".nectar-box-roll").length == 0)
        setTimeout(function () {
          waypoints();
        }, 100);
    }

    function transitionPage(e) {
      if (
        $('#ajax-loading-screen[data-effect="horizontal_swipe"]').length > 0
      ) {
        if ($(window).scrollTop() > 0) {
          //stop nicescroll
          if ($().niceScroll && $("html").getNiceScroll()) {
            var nice = $("html").getNiceScroll();
            nice.stop();
          }

          $("body,html")
            .stop(true, true)
            .animate(
              {
                scrollTop: 0,
              },
              500,
              "easeOutQuad",
              function () {
                //close widget area
                setTimeout(function () {
                  if ($("#header-outer").hasClass("side-widget-open"))
                    $(".slide-out-widget-area-toggle a").trigger("click");
                }, 400);
                $("#ajax-loading-screen").removeClass("loaded");
                $("#ajax-loading-screen").addClass("in-from-right");
                setTimeout(function () {
                  $("#ajax-loading-screen").addClass("loaded");
                }, 30);
              }
            );
        } else {
          //close widget area
          setTimeout(function () {
            if ($("#header-outer").hasClass("side-widget-open"))
              $(".slide-out-widget-area-toggle a").trigger("click");
          }, 400);
          $("#ajax-loading-screen").removeClass("loaded");
          $("#ajax-loading-screen").addClass("in-from-right");
          setTimeout(function () {
            $("#ajax-loading-screen").addClass("loaded");
          }, 30);
        }
      } else {
        if ($(window).scrollTop() > 0) {
          //stop nicescroll
          if ($().niceScroll && $("html").getNiceScroll()) {
            var nice = $("html").getNiceScroll();
            nice.stop();
          }

          $("body,html")
            .stop(true, true)
            .animate(
              {
                scrollTop: 0,
              },
              500,
              "easeOutQuad",
              function () {
                $("#ajax-loading-screen").css({
                  opacity: "1",
                  display: "none",
                });
                $("#ajax-loading-screen")
                  .stop(true, true)
                  .fadeIn(600, function () {
                    $("#ajax-loading-screen .loading-icon").animate(
                      { opacity: 1 },
                      400
                    );
                    //close widget area
                    setTimeout(function () {
                      if ($("#header-outer").hasClass("side-widget-open"))
                        $(".slide-out-widget-area-toggle a").trigger("click");
                    }, 400);
                  });
              }
            );
        } else {
          $("#ajax-loading-screen")
            .css("opacity", "1")
            .stop()
            .fadeIn(600, function () {
              $("#ajax-loading-screen .loading-icon").animate(
                { opacity: 1 },
                400
              );
            });

          //close widget area
          setTimeout(function () {
            if ($("#header-outer").hasClass("side-widget-open"))
              $(".slide-out-widget-area-toggle a").trigger("click");
          }, 400);
        }
      }
    }

    function transitionPageStandard(e) {
      if (
        $('#ajax-loading-screen[data-effect="horizontal_swipe"]').length > 0
      ) {
        $("#ajax-loading-screen").removeClass("loaded");
        $("#ajax-loading-screen").addClass("in-from-right");
        setTimeout(function () {
          $("#ajax-loading-screen").addClass("loaded");
        }, 30);
      } else {
        if (
          $('#ajax-loading-screen[data-effect="center_mask_reveal"]').length > 0
        ) {
          $("#ajax-loading-screen")
            .css("opacity", "0")
            .css("display", "block")
            .transition({ opacity: "1" }, 450);
        } else {
          $("#ajax-loading-screen").show().transition({ opacity: "1" }, 450);
        }
      }

      //setTimeout(function(){ $('#ajax-loading-screen .loading-icon').animate({'opacity':1},500); },400);
    }

    function destroyPage(e) {
      $(window).off("scroll.appear");
      if ($("#nectar_fullscreen_rows").length > 0 && $().fullpage)
        $.fn.fullpage.destroy("all");
    }

    function initPage(e) {
      if (!$("body").hasClass("ajax-loaded")) return false;

      //init js
      lightBoxInit();
      addOrRemoveSF();

      if ($('body[data-header-format="left-header"]').length == 0)
        $(".sf-menu").superfish("destroy");

      $("#header-outer").removeClass("dark-slide");
      initSF();
      SFArrows();
      headerInit();
      var $effectTimeout = $("#ajax-loading-screen").length > 0 ? 800 : 0;
      pageHeaderTextEffectInit();
      if ($("#page-header-bg .nectar-video-wrap video").length == 0)
        setTimeout(pageHeaderTextEffect, $effectTimeout);
      coloredButtons();
      columnBGColors();
      fwCarouselLinkFix();
      if ($(".carousel").length > 0) {
        standardCarouselInit();
        clientsCarouselInit();
        carouselHeightCalcs();
      }
      if ($(".owl-carousel").length > 0) owlCarouselInit();
      if ($(".products-carousel").length > 0) productCarouselInit();
      if ($("#nectar_fullscreen_rows").length > 0 && $().fullpage) {
        setFPNames();
        initFullPageFooter();
        fullscreenRowLogic();
        initNectarFP();
      }
      flexsliderInit();
      accordionInit();
      tabbedInit();
      tabbbedDeepLinking();
      accordionDeepLinking();
      ulChecks();
      oneFourthClasses();
      carouselfGrabbingClass();
      cascadingImageBGSizing();
      fullWidthSections();
      fwsClasses();
      fullwidthImgOnlySizingInit();
      fullwidthImgOnlySizing();
      fullWidthRowPaddingAdjustInit();
      fullWidthRowPaddingAdjustCalc();
      boxRollInit();
      rowColorOverlay();
      setTimeout(function () {
        waypoints();
        flickityInit();
      }, 100);
      if ($('body[data-animated-anchors="true"]').length > 0)
        setTimeout(scrollSpyInit, 200);
      socialSharingInit();
      hotSpotHoverBind();
      pricingTableHeight();
      createTestimonialControls();
      imageWithHotspotClickEvents();
      testimonialSliderHeight();
      largeIconHover();
      fullscreenMenuInit();
      boxRollMouseWheelInit();
      midnightInit();
      responsiveVideoIframesInit();
      responsiveVideoIframes();
      fullWidthContentColumns();
      videoBGInit();
      $window
        .unbind("scroll.parallaxSections")
        .unbind("resize.parallaxSections");
      parallaxScrollInit();
      masonryBlogInit();
      masonryPortfolioInit();
      portfolioAccentColor();
      portfolioHoverEffects();
      portfolioFiltersInit();
      style6Img();
      isotopeCatSelection();
      $(window).unbind(".infscr");
      infiniteScrollInit();
      toTopBind();
      centerLove();
      postNextButtonEffect();
      pageLoadHash();
      slideOutWidgetAreaScrolling();

      //cf7
      if ($().wpcf7InitForm) $("div.wpcf7 > form").wpcf7InitForm();

      //woocommerce price slider
      wooPriceSlider();

      //twitter widget
      if (typeof twttr != "undefined") {
        twttr.widgets.load();
      }

      //Calendarize.it
      if (typeof init_rhc === "function") {
        init_rhc();
      }

      //unwrap post and protfolio videos
      $(".video-wrap iframe").unwrap();
      $("#sidebar iframe[src]").unwrap();

      $("video:not(.slider-video)").attr("width", "100%");
      $("video:not(.slider-video)").attr("height", "100%");

      $(".wp-video-shortcode.mejs-container").each(function () {
        $(this).attr(
          "data-aspectRatio",
          parseInt($(this).css("height")) / parseInt($(this).css("width"))
        );
      });

      //mediaElement
      $("video.wp-media-shortcode-ajax, audio.wp-media-shortcode-ajax").each(
        function () {
          if (
            !$(this).parent().hasClass("mejs-mediaelement") &&
            $().mediaelementplayer
          ) {
            $(this).mediaelementplayer();
          }
        }
      );

      $(".mejs-container").css({ height: "100%", width: "100%" });

      $("audio").attr("width", "100%");
      $("audio").attr("height", "100%");

      $("audio").css("visibility", "visible");

      if ($("body").hasClass("mobile")) {
        $("video").css("visibility", "hidden");
      } else {
        $("video").css("visibility", "visible");
      }

      $('.wpb_row:has(".nectar-video-wrap")').each(function (i) {
        $(this).css("z-index", 100 + i);
      });

      showLateIframes();

      mouseParallaxInit();

      //chrome self hosted slider bg video correct
      if (navigator.userAgent.indexOf("Chrome") > 0) {
        $(".swiper-wrapper .video-wrap").each(function (i) {
          var webmSource =
            jQuery(this).find('video source[type="video/webm"]').attr("src") +
            "?id=" +
            Math.ceil(Math.random() * 10000);
          var firstVideo = jQuery(this).find("video").get(0);
          firstVideo.src = webmSource;
          firstVideo.load();
        });
      }

      if ($(".nectar-video-bg").length > 0) {
        setTimeout(function () {
          resizeVideoToCover();
          $(".video-color-overlay").each(function () {
            $(this).css("background-color", $(this).attr("data-color"));
          });
          $(".nectar-video-wrap").transition({ opacity: "1" }, 0);
          $(".video-color-overlay").transition({ opacity: "0.7" }, 0);
        }, 400);
      }

      nectarPageHeader();

      //cart dropdown
      $("#header-outer div.cart-outer").hoverIntent(function () {
        $("#header-outer .widget_shopping_cart")
          .addClass("open")
          .stop(true, true)
          .fadeIn(400);
        $("#header-outer .cart_list").stop(true, true).fadeIn(400);
        clearTimeout(timeout);
        $("#header-outer .cart-notification").fadeOut(300);
      });

      //remove excess loading images now
      $(".portfolio-loading, .nectar-slider-loading .loading-icon").remove();

      setTimeout(portfolioSidebarFollow, 250);
      setTimeout(portfolioSidebarFollow, 500);
      setTimeout(portfolioSidebarFollow, 1000);

      crossBrowserFixes();

      $(window).trigger("resize");

      //fix admin bar
      $("#wpadminbar").show();

      //close widget area
      if ($("#header-outer").hasClass("side-widget-open"))
        $(".slide-out-widget-area-toggle a").trigger("click");

      if (
        $('#ajax-loading-screen[data-effect="horizontal_swipe"]').length > 0
      ) {
        closeSearch();
        $("#ajax-loading-screen")
          .removeClass("in-from-right")
          .removeClass("loaded");
        setTimeout(function () {
          $("#ajax-loading-screen").addClass("loaded");
        }, 30);
      } else {
        //fade in page
        setTimeout(function () {
          $("#ajax-loading-screen")
            .stop(true, true)
            .fadeOut(500, function () {
              $("#ajax-loading-screen .loading-icon").css({ opacity: 0 });
            });
          closeSearch();
        }, 200);
        setTimeout(function () {
          $("#ajax-loading-screen")
            .stop(true, true)
            .fadeOut(500, function () {
              $("#ajax-loading-screen .loading-icon").css({ opacity: 0 });
            });
          closeSearch();
        }, 900);
      }
    }

    /*
     * jQuery Textarea Characters Counter Plugin v 2.0
     * Examples and documentation at: http://roy-jin.appspot.com/jsp/textareaCounter.jsp
     * Copyright (c) 2010 Roy Jin
     * Version: 2.0 (11-JUN-2010)
     * Dual licensed under the MIT and GPL licenses:
     * http://www.opensource.org/licenses/mit-license.php
     * http://www.gnu.org/licenses/gpl.html
     * Requires: jQuery v1.4.2 or later
     */
    (function ($) {
      if (!$.fn.textareaCount) {
        $.fn.textareaCount = function (options, fn) {
          var defaults = {
            maxCharacterSize: -1,
            originalStyle: "originalTextareaInfo",
            warningStyle: "warningTextareaInfo",
            warningNumber: 20,
            displayFormat: "#input characters | #words words",
          };

          var options = $.extend(defaults, options);

          var container = $(this);

          $("<div class='charleft'>&nbsp;</div>").insertAfter(container);

          //create charleft css
          var charLeftCss = {
            width: container.width(),
          };

          var charLeftInfo = getNextCharLeftInformation(container);
          charLeftInfo.addClass(options.originalStyle);
          //charLeftInfo.css(charLeftCss);

          var numInput = 0;
          var maxCharacters = options.maxCharacterSize;
          var numLeft = 0;
          var numWords = 0;

          container
            .bind("keyup", function (event) {
              limitTextAreaByCharacterCount();
            })
            .bind("mouseover", function (event) {
              setTimeout(function () {
                limitTextAreaByCharacterCount();
              }, 10);
            })
            .bind("paste", function (event) {
              setTimeout(function () {
                limitTextAreaByCharacterCount();
              }, 10);
            });

          limitTextAreaByCharacterCount();

          function limitTextAreaByCharacterCount() {
            charLeftInfo.html(countByCharacters());

            //function call back
            if (typeof fn != "undefined") {
              fn.call(this, getInfo());
            }
            return true;
          }

          function countByCharacters() {
            var content = container.val();
            var contentLength = content.length;
            //Start Cut
            if (options.maxCharacterSize > 0) {
              //If copied content is already more than maxCharacterSize, chop it to maxCharacterSize.
              if (contentLength >= options.maxCharacterSize) {
                content = content.substring(0, options.maxCharacterSize);
              }

              var newlineCount = getNewlineCount(content);

              // newlineCount new line character. For windows, it occupies 2 characters
              var systemmaxCharacterSize =
                options.maxCharacterSize - newlineCount;
              if (!isWin()) {
                systemmaxCharacterSize = options.maxCharacterSize;
              }
              if (contentLength > systemmaxCharacterSize) {
                //avoid scroll bar moving
                var originalScrollTopPosition = this.scrollTop;
                container.val(content.substring(0, systemmaxCharacterSize));
                this.scrollTop = originalScrollTopPosition;
              }
              charLeftInfo.removeClass(options.warningStyle);
              if (
                systemmaxCharacterSize - contentLength <=
                options.warningNumber
              ) {
                charLeftInfo.addClass(options.warningStyle);
              }

              numInput = container.val().length + newlineCount;
              if (!isWin()) {
                numInput = container.val().length;
              }

              numWords = countWord(getCleanedWordString(container.val()));

              numLeft = maxCharacters - numInput;
            } else {
              //normal count, no cut
              var newlineCount = getNewlineCount(content);
              numInput = container.val().length + newlineCount;
              if (!isWin()) {
                numInput = container.val().length;
              }
              numWords = countWord(getCleanedWordString(container.val()));
            }

            return formatDisplayInfo();
          }

          function formatDisplayInfo() {
            var format = options.displayFormat;
            format = format.replace("#input", numInput);
            format = format.replace("#words", numWords);
            //When maxCharacters <= 0, #max, #left cannot be substituted.
            if (maxCharacters > 0) {
              format = format.replace("#max", maxCharacters);
              format = format.replace("#left", numLeft);
            }
            return format;
          }

          function getInfo() {
            var info = {
              input: numInput,
              max: maxCharacters,
              left: numLeft,
              words: numWords,
            };
            return info;
          }

          function getNextCharLeftInformation(container) {
            return container.next(".charleft");
          }

          function isWin() {
            var strOS = navigator.appVersion;
            if (strOS.toLowerCase().indexOf("win") != -1) {
              return true;
            }
            return false;
          }

          function getNewlineCount(content) {
            var newlineCount = 0;
            for (var i = 0; i < content.length; i++) {
              if (content.charAt(i) == "\n") {
                newlineCount++;
              }
            }
            return newlineCount;
          }

          function getCleanedWordString(content) {
            var fullStr = content + " ";
            var initial_whitespace_rExp = /^[^A-Za-z0-9]+/gi;
            var left_trimmedStr = fullStr.replace(initial_whitespace_rExp, "");
            var non_alphanumerics_rExp = (rExp = /[^A-Za-z0-9]+/gi);
            var cleanedStr = left_trimmedStr.replace(
              non_alphanumerics_rExp,
              " "
            );
            var splitString = cleanedStr.split(" ");
            return splitString;
          }

          function countWord(cleanedWordString) {
            var word_count = cleanedWordString.length - 1;
            return word_count;
          }
        };
      }
    })(jQuery);
  });
})(window.jQuery, window, document);

function resizeIframe() {
  var element = document
    .getElementById("pp_full_res")
    .getElementsByTagName("iframe");
  var height = element[0].contentWindow.document.body.scrollHeight;

  //iframe height
  element[0].style.height = height + "px";

  //pp height
  document.getElementsByClassName("pp_content_container")[0].style.height =
    height + 40 + "px";
  document.getElementsByClassName("pp_content")[0].style.height =
    height + 40 + "px";
}

//don't load if mobile
if (
  !navigator.userAgent.match(
    /(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/
  )
) {
  /*
	panr - v0.0.1 by Robert Bue (@robert_bue)
	*/
  (function ($, window, document, undefined) {
    // Create the defaults once

    var pluginName = "panr",
      defaults = {
        sensitivity: 22,
        moveTarget: "parent",
        scale: false,
        scaleOnHover: false,
        scaleTo: 1.1,
        scaleDuration: 0.28,
        panY: true,
        panX: true,
        panDuration: 0.7,
        resetPanOnMouseLeave: true,
        onEnter: function () {},
        onLeave: function () {},
      };
    // The actual plugin constructor
    function Plugin(element, options) {
      this.element = element;
      //console.log(element);
      this.settings = $.extend({}, defaults, options);
      this._defaults = defaults;
      this._name = pluginName;
      this.init();
    }
    Plugin.prototype = {
      init: function () {
        if (Modernizr.touch) {
          return;
        }
        // call them like so: this.yourOtherFunction(this.element, this.settings).
        //console.log(this.settings);
        var settings = this.settings,
          target = $(this.element),
          w = target.width(),
          targetWidth = target.width() - settings.sensitivity,
          cx = (w - targetWidth) / targetWidth,
          x,
          y,
          panVars,
          xPanVars,
          yPanVars,
          mouseleaveVars;
        //console.log(cx);
        if (settings.scale || (!settings.scaleOnHover && settings.scale)) {
          TweenMax.set(target, { scale: settings.scaleTo });
        }
        // If no target provided we'll use the hovered element
        if (!settings.moveTarget) {
          settings.moveTarget = $(this.element);
        }
        if (settings.moveTarget == "parent") {
          settings.moveTarget = $(this.element).parent();
        }
        if (settings.moveTarget == "parent parent") {
          settings.moveTarget = $(this.element).parent().parent();
        }
        if (settings.moveTarget == "parent parent parent") {
          settings.moveTarget = $(this.element).parent().parent().parent();
        }

        settings.moveTarget.on("mousemove", function (e) {
          x = e.pageX - target.offset().left - target.width() / 2; // mouse x coordinate relative to the container
          y = e.pageY - target.offset().top - target.height() / 2; // mouse x coordinate relative to the container
          if (settings.panX) {
            xPanVars = { x: -cx * x };
          }
          if (settings.panY) {
            yPanVars = { y: -cx * y };
          }
          panVars = $.extend({}, xPanVars, yPanVars);

          // Pan element
          TweenMax.to(target, settings.panDuration, panVars);
        });
        // On mouseover
        settings.moveTarget.on("mouseenter", function (e) {
          // Scale up element
          TweenMax.to(target, settings.scaleDuration, {
            scale: settings.scaleTo,
          });
          settings.onEnter(target);
        });
        if (!settings.scale || (!settings.scaleOnHover && !settings.scale)) {
          mouseleaveVars = { scale: 1.005, x: 0, y: 0 };
        } else {
          if (settings.resetPanOnMouseLeave) {
            mouseleaveVars = { x: 0, y: 0 };
          }
        }
        settings.moveTarget.on("mouseleave", function (e) {
          // Reset element
          TweenMax.to(target, 0.35, mouseleaveVars);
          settings.onLeave(target);
        });
      },
    };
    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
      return this.each(function () {
        if (!$.data(this, "plugin_" + pluginName)) {
          $.data(this, "plugin_" + pluginName, new Plugin(this, options));
        }
      });
    };
  })(jQuery, window, document);
}

/*!
 * hoverIntent r7 // 2013.03.11 // jQuery 1.9.1+
 * http://cherne.net/brian/resources/jquery.hoverIntent.html
 */
(function (e) {
  e.fn.hoverIntent = function (t, n, r) {
    var i = { interval: 100, sensitivity: 6, timeout: 0 };
    if (typeof t === "object") {
      i = e.extend(i, t);
    } else if (e.isFunction(n)) {
      i = e.extend(i, { over: t, out: n, selector: r });
    } else {
      i = e.extend(i, { over: t, out: t, selector: n });
    }
    var s, o, u, a;
    var f = function (e) {
      s = e.pageX;
      o = e.pageY;
    };
    var l = function (t, n) {
      n.hoverIntent_t = clearTimeout(n.hoverIntent_t);
      if (Math.abs(u - s) + Math.abs(a - o) < i.sensitivity) {
        e(n).off("mousemove.hoverIntent", f);
        n.hoverIntent_s = 1;
        return i.over.apply(n, [t]);
      } else {
        u = s;
        a = o;
        n.hoverIntent_t = setTimeout(function () {
          l(t, n);
        }, i.interval);
      }
    };
    var c = function (e, t) {
      t.hoverIntent_t = clearTimeout(t.hoverIntent_t);
      t.hoverIntent_s = 0;
      return i.out.apply(t, [e]);
    };
    var h = function (t) {
      var n = jQuery.extend({}, t);
      var r = this;
      if (r.hoverIntent_t) {
        r.hoverIntent_t = clearTimeout(r.hoverIntent_t);
      }
      if (t.type == "mouseenter") {
        u = n.pageX;
        a = n.pageY;
        e(r).on("mousemove.hoverIntent", f);
        if (r.hoverIntent_s != 1) {
          r.hoverIntent_t = setTimeout(function () {
            l(n, r);
          }, i.interval);
        }
      } else {
        e(r).off("mousemove.hoverIntent", f);
        if (r.hoverIntent_s == 1) {
          r.hoverIntent_t = setTimeout(function () {
            c(n, r);
          }, i.timeout);
        }
      }
    };
    return this.on(
      { "mouseenter.hoverIntent": h, "mouseleave.hoverIntent": h },
      i.selector
    );
  };
})(jQuery);
/*
 * Swiper 2.2 - Mobile Touch Slider
 * http://www.idangero.us/sliders/swiper/
 *
 * Copyright 2012-2013, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 *
 * Licensed under GPL & MIT
 *
 * Updated on: September 15, 2013
 */

if (!jQuery().swiper) {
  var Swiper = function (selector, params) {
    /*=========================
      A little bit dirty but required part for IE8 and old FF support
      ===========================*/
    if (document.body.__defineGetter__) {
      if (HTMLElement) {
        var element = HTMLElement.prototype;
        if (element.__defineGetter__) {
          element.__defineGetter__("outerHTML", function () {
            return new XMLSerializer().serializeToString(this);
          });
        }
      }
    }

    if (!window.getComputedStyle) {
      window.getComputedStyle = function (el, pseudo) {
        this.el = el;
        this.getPropertyValue = function (prop) {
          var re = /(\-([a-z]){1})/g;
          if (prop === "float") prop = "styleFloat";
          if (re.test(prop)) {
            prop = prop.replace(re, function () {
              return arguments[2].toUpperCase();
            });
          }
          return el.currentStyle[prop] ? el.currentStyle[prop] : null;
        };
        return this;
      };
    }
    if (!Array.prototype.indexOf) {
      Array.prototype.indexOf = function (obj, start) {
        for (var i = start || 0, j = this.length; i < j; i++) {
          if (this[i] === obj) {
            return i;
          }
        }
        return -1;
      };
    }
    if (!document.querySelectorAll) {
      if (!window.jQuery) return;
    }
    function $$(selector, context) {
      if (document.querySelectorAll)
        return (context || document).querySelectorAll(selector);
      else return jQuery(selector, context);
    }

    /*=========================
      Check for correct selector
      ===========================*/
    if (typeof selector === "undefined") return;

    if (!selector.nodeType) {
      if ($$(selector).length === 0) return;
    }

    /*=========================
      _this
      ===========================*/
    var _this = this;

    /*=========================
      Default Flags and vars
      ===========================*/
    _this.touches = {
      start: 0,
      startX: 0,
      startY: 0,
      current: 0,
      currentX: 0,
      currentY: 0,
      diff: 0,
      abs: 0,
    };
    _this.positions = {
      start: 0,
      abs: 0,
      diff: 0,
      current: 0,
    };
    _this.times = {
      start: 0,
      end: 0,
    };

    _this.id = new Date().getTime();
    _this.container = selector.nodeType ? selector : $$(selector)[0];
    _this.isTouched = false;
    _this.isMoved = false;
    _this.activeIndex = 0;
    _this.activeLoaderIndex = 0;
    _this.activeLoopIndex = 0;
    _this.previousIndex = null;
    _this.velocity = 0;
    _this.snapGrid = [];
    _this.slidesGrid = [];
    _this.imagesToLoad = [];
    _this.imagesLoaded = 0;
    _this.wrapperLeft = 0;
    _this.wrapperRight = 0;
    _this.wrapperTop = 0;
    _this.wrapperBottom = 0;
    var wrapper, slideSize, wrapperSize, direction, isScrolling, containerSize;

    /*=========================
      Default Parameters
      ===========================*/
    var defaults = {
      mode: "horizontal", // or 'vertical'
      touchRatio: 1,
      speed: 300,
      freeMode: false,
      freeModeFluid: false,
      momentumRatio: 1,
      momentumBounce: true,
      momentumBounceRatio: 1,
      slidesPerView: 1,
      slidesPerGroup: 1,
      simulateTouch: true,
      followFinger: true,
      shortSwipes: true,
      moveStartThreshold: false,
      autoplay: false,
      onlyExternal: false,
      createPagination: true,
      pagination: false,
      paginationElement: "span",
      paginationClickable: false,
      paginationAsRange: true,
      resistance: true, // or false or 100%
      scrollContainer: false,
      preventLinks: true,
      noSwiping: false, // or class
      noSwipingClass: "swiper-no-swiping", //:)
      initialSlide: 0,
      keyboardControl: false,
      mousewheelControl: false,
      mousewheelDebounce: 600,
      useCSS3Transforms: true,
      //Loop mode
      loop: false,
      loopAdditionalSlides: 0,
      //Auto Height
      calculateHeight: false,
      //Images Preloader
      updateOnImagesReady: true,
      //Form elements
      releaseFormElements: true,
      //Watch for active slide, useful when use effects on different slide states
      watchActiveIndex: false,
      //Slides Visibility Fit
      visibilityFullFit: false,
      //Slides Offset
      offsetPxBefore: 0,
      offsetPxAfter: 0,
      offsetSlidesBefore: 0,
      offsetSlidesAfter: 0,
      centeredSlides: false,
      //Queue callbacks
      queueStartCallbacks: false,
      queueEndCallbacks: false,
      //Auto Resize
      autoResize: true,
      resizeReInit: false,
      //DOMAnimation
      DOMAnimation: true,
      //Slides Loader
      loader: {
        slides: [], //array with slides
        slidesHTMLType: "inner", // or 'outer'
        surroundGroups: 1, //keep preloaded slides groups around view
        logic: "reload", //or 'change'
        loadAllSlides: false,
      },
      //Namespace
      slideElement: "div",
      slideClass: "swiper-slide",
      slideActiveClass: "swiper-slide-active",
      slideVisibleClass: "swiper-slide-visible",
      wrapperClass: "swiper-wrapper",
      paginationElementClass: "swiper-pagination-switch",
      paginationActiveClass: "swiper-active-switch",
      paginationVisibleClass: "swiper-visible-switch",
    };
    params = params || {};
    for (var prop in defaults) {
      if (prop in params && typeof params[prop] === "object") {
        for (var subProp in defaults[prop]) {
          if (!(subProp in params[prop])) {
            params[prop][subProp] = defaults[prop][subProp];
          }
        }
      } else if (!(prop in params)) {
        params[prop] = defaults[prop];
      }
    }
    _this.params = params;
    if (params.scrollContainer) {
      params.freeMode = true;
      params.freeModeFluid = true;
    }
    if (params.loop) {
      params.resistance = "100%";
    }
    var isH = params.mode === "horizontal";

    /*=========================
      Define Touch Events
      ===========================*/

    _this.touchEvents = {
      touchStart:
        _this.support.touch || !params.simulateTouch
          ? "touchstart"
          : _this.browser.ie10
          ? "MSPointerDown"
          : "mousedown",
      touchMove:
        _this.support.touch || !params.simulateTouch
          ? "touchmove"
          : _this.browser.ie10
          ? "MSPointerMove"
          : "mousemove",
      touchEnd:
        _this.support.touch || !params.simulateTouch
          ? "touchend"
          : _this.browser.ie10
          ? "MSPointerUp"
          : "mouseup",
    };

    /*=========================
      Wrapper
      ===========================*/
    for (var i = _this.container.childNodes.length - 1; i >= 0; i--) {
      if (_this.container.childNodes[i].className) {
        var _wrapperClasses =
          _this.container.childNodes[i].className.split(/\s+/);
        for (var j = 0; j < _wrapperClasses.length; j++) {
          if (_wrapperClasses[j] === params.wrapperClass) {
            wrapper = _this.container.childNodes[i];
          }
        }
      }
    }

    _this.wrapper = wrapper;
    /*=========================
      Slide API
      ===========================*/
    _this._extendSwiperSlide = function (el) {
      el.append = function () {
        if (params.loop) {
          el.insertAfter(_this.slides.length - _this.loopedSlides);
          _this.removeLoopedSlides();
          _this.calcSlides();
          _this.createLoop();
        } else {
          _this.wrapper.appendChild(el);
        }

        _this.reInit();
        return el;
      };
      el.prepend = function () {
        if (params.loop) {
          _this.wrapper.insertBefore(el, _this.slides[_this.loopedSlides]);
          _this.removeLoopedSlides();
          _this.calcSlides();
          _this.createLoop();
        } else {
          _this.wrapper.insertBefore(el, _this.wrapper.firstChild);
        }
        _this.reInit();
        return el;
      };
      el.insertAfter = function (index) {
        if (typeof index === "undefined") return false;
        var beforeSlide;

        if (params.loop) {
          beforeSlide = _this.slides[index + 1 + _this.loopedSlides];
          _this.wrapper.insertBefore(el, beforeSlide);
          _this.removeLoopedSlides();
          _this.calcSlides();
          _this.createLoop();
        } else {
          beforeSlide = _this.slides[index + 1];
          _this.wrapper.insertBefore(el, beforeSlide);
        }
        _this.reInit();
        return el;
      };
      el.clone = function () {
        return _this._extendSwiperSlide(el.cloneNode(true));
      };
      el.remove = function () {
        _this.wrapper.removeChild(el);
        _this.reInit();
      };
      el.html = function (html) {
        if (typeof html === "undefined") {
          return el.innerHTML;
        } else {
          el.innerHTML = html;
          return el;
        }
      };
      el.index = function () {
        var index;
        for (var i = _this.slides.length - 1; i >= 0; i--) {
          if (el === _this.slides[i]) index = i;
        }
        return index;
      };
      el.isActive = function () {
        if (el.index() === _this.activeIndex) return true;
        else return false;
      };
      if (!el.swiperSlideDataStorage) el.swiperSlideDataStorage = {};
      el.getData = function (name) {
        return el.swiperSlideDataStorage[name];
      };
      el.setData = function (name, value) {
        el.swiperSlideDataStorage[name] = value;
        return el;
      };
      el.data = function (name, value) {
        if (!value) {
          return el.getAttribute("data-" + name);
        } else {
          el.setAttribute("data-" + name, value);
          return el;
        }
      };
      el.getWidth = function (outer) {
        return _this.h.getWidth(el, outer);
      };
      el.getHeight = function (outer) {
        return _this.h.getHeight(el, outer);
      };
      el.getOffset = function () {
        return _this.h.getOffset(el);
      };
      return el;
    };

    //Calculate information about number of slides
    _this.calcSlides = function (forceCalcSlides) {
      var oldNumber = _this.slides ? _this.slides.length : false;
      _this.slides = [];
      _this.displaySlides = [];
      for (var i = 0; i < _this.wrapper.childNodes.length; i++) {
        if (_this.wrapper.childNodes[i].className) {
          var _className = _this.wrapper.childNodes[i].className;
          var _slideClasses = _className.split(" ");
          for (var j = 0; j < _slideClasses.length; j++) {
            if (_slideClasses[j] === params.slideClass) {
              _this.slides.push(_this.wrapper.childNodes[i]);
            }
          }
        }
      }
      for (i = _this.slides.length - 1; i >= 0; i--) {
        _this._extendSwiperSlide(_this.slides[i]);
      }
      if (!oldNumber) return;
      if (oldNumber !== _this.slides.length || forceCalcSlides) {
        // Number of slides has been changed
        removeSlideEvents();
        addSlideEvents();
        _this.updateActiveSlide();
        if (params.createPagination && _this.params.pagination)
          _this.createPagination();
        _this.callPlugins("numberOfSlidesChanged");
      }
    };

    //Create Slide
    _this.createSlide = function (html, slideClassList, el) {
      var slideClassList = slideClassList || _this.params.slideClass;
      var el = el || params.slideElement;
      var newSlide = document.createElement(el);
      newSlide.innerHTML = html || "";
      newSlide.className = slideClassList;
      return _this._extendSwiperSlide(newSlide);
    };

    //Append Slide
    _this.appendSlide = function (html, slideClassList, el) {
      if (!html) return;
      if (html.nodeType) {
        return _this._extendSwiperSlide(html).append();
      } else {
        return _this.createSlide(html, slideClassList, el).append();
      }
    };
    _this.prependSlide = function (html, slideClassList, el) {
      if (!html) return;
      if (html.nodeType) {
        return _this._extendSwiperSlide(html).prepend();
      } else {
        return _this.createSlide(html, slideClassList, el).prepend();
      }
    };
    _this.insertSlideAfter = function (index, html, slideClassList, el) {
      if (typeof index === "undefined") return false;
      if (html.nodeType) {
        return _this._extendSwiperSlide(html).insertAfter(index);
      } else {
        return _this.createSlide(html, slideClassList, el).insertAfter(index);
      }
    };
    _this.removeSlide = function (index) {
      if (_this.slides[index]) {
        if (params.loop) {
          if (!_this.slides[index + _this.loopedSlides]) return false;
          _this.slides[index + _this.loopedSlides].remove();
          _this.removeLoopedSlides();
          _this.calcSlides();
          _this.createLoop();
        } else _this.slides[index].remove();
        return true;
      } else return false;
    };
    _this.removeLastSlide = function () {
      if (_this.slides.length > 0) {
        if (params.loop) {
          _this.slides[_this.slides.length - 1 - _this.loopedSlides].remove();
          _this.removeLoopedSlides();
          _this.calcSlides();
          _this.createLoop();
        } else _this.slides[_this.slides.length - 1].remove();
        return true;
      } else {
        return false;
      }
    };
    _this.removeAllSlides = function () {
      for (var i = _this.slides.length - 1; i >= 0; i--) {
        _this.slides[i].remove();
      }
    };
    _this.getSlide = function (index) {
      return _this.slides[index];
    };
    _this.getLastSlide = function () {
      return _this.slides[_this.slides.length - 1];
    };
    _this.getFirstSlide = function () {
      return _this.slides[0];
    };

    //Currently Active Slide
    _this.activeSlide = function () {
      return _this.slides[_this.activeIndex];
    };

    /*=========================
      Plugins API
      ===========================*/
    var _plugins = [];
    for (var plugin in _this.plugins) {
      if (params[plugin]) {
        var p = _this.plugins[plugin](_this, params[plugin]);
        if (p) _plugins.push(p);
      }
    }
    _this.callPlugins = function (method, args) {
      if (!args) args = {};
      for (var i = 0; i < _plugins.length; i++) {
        if (method in _plugins[i]) {
          _plugins[i][method](args);
        }
      }
    };

    /*=========================

     Wrapper for Callbacks : Allows additive callbacks via function arrays

     ===========================*/

    _this.fireCallback = function () {
      var callback = arguments[0];

      if (Object.prototype.toString.call(callback) === "[object Array]") {
        for (var i = 0; i < callback.length; i++) {
          if (typeof callback[i] === "function") {
            callback[i](
              arguments[1],
              arguments[2],
              arguments[3],
              arguments[4],
              arguments[5]
            );
          }
        }
      } else {
        callback(
          arguments[1],
          arguments[2],
          arguments[3],
          arguments[4],
          arguments[5]
        );
      }
    };

    function isArray(obj) {
      "use strict";

      if (Object.prototype.toString.apply(obj) === "[object Array]")
        return true;

      return false;
    }

    /**

+     * Allows user to add callbacks, rather than replace them

+     * @param callback

+     * @param func

+     * @return {*}

+     */

    _this.addCallback = function (callback, func) {
      "use strict";

      var _this = this,
        tempFunc;

      if (_this.params["on" + callback]) {
        if (isArray(this.params["on" + callback])) {
          return this.params["on" + callback].push(func);
        } else if (typeof this.params["on" + callback] === "function") {
          tempFunc = this.params["on" + callback];

          this.params["on" + callback] = [];

          this.params["on" + callback].push(tempFunc);

          return this.params["on" + callback].push(func);
        }
      } else {
        this.params["on" + callback] = [];

        return this.params["on" + callback].push(func);
      }
    };

    _this.removeCallbacks = function (callback) {
      if (_this.params["on" + callback]) {
        return (_this.params["on" + callback] = null);
      }
    };

    /*=========================


    /*=========================
      WP8 Fix
      ===========================*/
    if (_this.browser.ie10 && !params.onlyExternal) {
      _this.wrapper.classList.add(
        "swiper-wp8-" + (isH ? "horizontal" : "vertical")
      );
    }

    /*=========================
      Free Mode Class
      ===========================*/
    if (params.freeMode) {
      _this.container.className += " swiper-free-mode";
    }

    /*==================================================
        Init/Re-init/Resize Fix
    ====================================================*/
    _this.initialized = false;
    _this.init = function (force, forceCalcSlides) {
      var _width = _this.h.getWidth(_this.container);
      var _height = _this.h.getHeight(_this.container);
      if (_width === _this.width && _height === _this.height && !force) return;
      _this.width = _width;
      _this.height = _height;

      containerSize = isH ? _width : _height;
      var wrapper = _this.wrapper;

      if (force) {
        _this.calcSlides(forceCalcSlides);
      }

      if (params.slidesPerView === "auto") {
        //Auto mode
        var slidesWidth = 0;
        var slidesHeight = 0;

        //Unset Styles
        if (params.slidesOffset > 0) {
          wrapper.style.paddingLeft = "";
          wrapper.style.paddingRight = "";
          wrapper.style.paddingTop = "";
          wrapper.style.paddingBottom = "";
        }
        wrapper.style.width = "";
        wrapper.style.height = "";
        if (params.offsetPxBefore > 0) {
          if (isH) _this.wrapperLeft = params.offsetPxBefore;
          else _this.wrapperTop = params.offsetPxBefore;
        }
        if (params.offsetPxAfter > 0) {
          if (isH) _this.wrapperRight = params.offsetPxAfter;
          else _this.wrapperBottom = params.offsetPxAfter;
        }

        if (params.centeredSlides) {
          if (isH) {
            _this.wrapperLeft =
              (containerSize - this.slides[0].getWidth(true)) / 2;
            _this.wrapperRight =
              (containerSize -
                _this.slides[_this.slides.length - 1].getWidth(true)) /
              2;
          } else {
            _this.wrapperTop =
              (containerSize - _this.slides[0].getHeight(true)) / 2;
            _this.wrapperBottom =
              (containerSize -
                _this.slides[_this.slides.length - 1].getHeight(true)) /
              2;
          }
        }

        if (isH) {
          if (_this.wrapperLeft >= 0)
            wrapper.style.paddingLeft = _this.wrapperLeft + "px";
          if (_this.wrapperRight >= 0)
            wrapper.style.paddingRight = _this.wrapperRight + "px";
        } else {
          if (_this.wrapperTop >= 0)
            wrapper.style.paddingTop = _this.wrapperTop + "px";
          if (_this.wrapperBottom >= 0)
            wrapper.style.paddingBottom = _this.wrapperBottom + "px";
        }
        var slideLeft = 0;
        var centeredSlideLeft = 0;
        _this.snapGrid = [];
        _this.slidesGrid = [];

        var slideMaxHeight = 0;
        for (var i = 0; i < _this.slides.length; i++) {
          var slideWidth = _this.slides[i].getWidth(true);
          var slideHeight = _this.slides[i].getHeight(true);
          if (params.calculateHeight) {
            slideMaxHeight = Math.max(slideMaxHeight, slideHeight);
          }
          var _slideSize = isH ? slideWidth : slideHeight;
          if (params.centeredSlides) {
            var nextSlideWidth =
              i === _this.slides.length - 1
                ? 0
                : _this.slides[i + 1].getWidth(true);
            var nextSlideHeight =
              i === _this.slides.length - 1
                ? 0
                : _this.slides[i + 1].getHeight(true);
            var nextSlideSize = isH ? nextSlideWidth : nextSlideHeight;
            if (_slideSize > containerSize) {
              for (
                var j = 0;
                j <=
                Math.floor(_slideSize / (containerSize + _this.wrapperLeft));
                j++
              ) {
                if (j === 0) _this.snapGrid.push(slideLeft + _this.wrapperLeft);
                else
                  _this.snapGrid.push(
                    slideLeft + _this.wrapperLeft + containerSize * j
                  );
              }
              _this.slidesGrid.push(slideLeft + _this.wrapperLeft);
            } else {
              _this.snapGrid.push(centeredSlideLeft);
              _this.slidesGrid.push(centeredSlideLeft);
            }

            centeredSlideLeft += _slideSize / 2 + nextSlideSize / 2;
          } else {
            if (_slideSize > containerSize) {
              for (
                var j = 0;
                j <= Math.floor(_slideSize / containerSize);
                j++
              ) {
                _this.snapGrid.push(slideLeft + containerSize * j);
              }
            } else {
              _this.snapGrid.push(slideLeft);
            }
            _this.slidesGrid.push(slideLeft);
          }

          slideLeft += _slideSize;

          slidesWidth += slideWidth;
          slidesHeight += slideHeight;
        }
        if (params.calculateHeight) _this.height = slideMaxHeight;
        if (isH) {
          wrapperSize = slidesWidth + _this.wrapperRight + _this.wrapperLeft;
          wrapper.style.width = slidesWidth + "px";
          wrapper.style.height = _this.height + "px";
        } else {
          wrapperSize = slidesHeight + _this.wrapperTop + _this.wrapperBottom;
          wrapper.style.width = _this.width + "px";
          wrapper.style.height = slidesHeight + "px";
        }
      } else if (params.scrollContainer) {
        //Scroll Container
        wrapper.style.width = "";
        wrapper.style.height = "";
        var wrapperWidth = _this.slides[0].getWidth(true);
        var wrapperHeight = _this.slides[0].getHeight(true);
        wrapperSize = isH ? wrapperWidth : wrapperHeight;
        wrapper.style.width = wrapperWidth + "px";
        wrapper.style.height = wrapperHeight + "px";
        slideSize = isH ? wrapperWidth : wrapperHeight;
      } else {
        //For usual slides
        if (params.calculateHeight) {
          var slideMaxHeight = 0;
          var wrapperHeight = 0;
          //ResetWrapperSize
          if (!isH) _this.container.style.height = "";
          wrapper.style.height = "";

          for (var i = 0; i < _this.slides.length; i++) {
            //ResetSlideSize
            _this.slides[i].style.height = "";
            slideMaxHeight = Math.max(
              _this.slides[i].getHeight(true),
              slideMaxHeight
            );
            if (!isH) wrapperHeight += _this.slides[i].getHeight(true);
          }
          var slideHeight = slideMaxHeight;
          _this.height = slideHeight;

          if (isH) wrapperHeight = slideHeight;
          else
            (containerSize = slideHeight),
              (_this.container.style.height = containerSize + "px");
        } else {
          var slideHeight = isH
            ? _this.height
            : _this.height / params.slidesPerView;
          var wrapperHeight = isH
            ? _this.height
            : _this.slides.length * slideHeight;
        }
        var slideWidth = isH ? _this.width / params.slidesPerView : _this.width;
        var wrapperWidth = isH ? _this.slides.length * slideWidth : _this.width;
        slideSize = isH ? slideWidth : slideHeight;

        if (params.offsetSlidesBefore > 0) {
          if (isH) _this.wrapperLeft = slideSize * params.offsetSlidesBefore;
          else _this.wrapperTop = slideSize * params.offsetSlidesBefore;
        }
        if (params.offsetSlidesAfter > 0) {
          if (isH) _this.wrapperRight = slideSize * params.offsetSlidesAfter;
          else _this.wrapperBottom = slideSize * params.offsetSlidesAfter;
        }
        if (params.offsetPxBefore > 0) {
          if (isH) _this.wrapperLeft = params.offsetPxBefore;
          else _this.wrapperTop = params.offsetPxBefore;
        }
        if (params.offsetPxAfter > 0) {
          if (isH) _this.wrapperRight = params.offsetPxAfter;
          else _this.wrapperBottom = params.offsetPxAfter;
        }
        if (params.centeredSlides) {
          if (isH) {
            _this.wrapperLeft = (containerSize - slideSize) / 2;
            _this.wrapperRight = (containerSize - slideSize) / 2;
          } else {
            _this.wrapperTop = (containerSize - slideSize) / 2;
            _this.wrapperBottom = (containerSize - slideSize) / 2;
          }
        }
        if (isH) {
          if (_this.wrapperLeft > 0)
            wrapper.style.paddingLeft = _this.wrapperLeft + "px";
          if (_this.wrapperRight > 0)
            wrapper.style.paddingRight = _this.wrapperRight + "px";
        } else {
          if (_this.wrapperTop > 0)
            wrapper.style.paddingTop = _this.wrapperTop + "px";
          if (_this.wrapperBottom > 0)
            wrapper.style.paddingBottom = _this.wrapperBottom + "px";
        }

        wrapperSize = isH
          ? wrapperWidth + _this.wrapperRight + _this.wrapperLeft
          : wrapperHeight + _this.wrapperTop + _this.wrapperBottom;
        if (!params.cssWidthAndHeight) {
          if (parseFloat(wrapperWidth) > 0) {
            wrapper.style.width = wrapperWidth + "px";
          }

          if (parseFloat(wrapperHeight) > 0) {
            wrapper.style.height = wrapperHeight + "px";
          }
        }
        var slideLeft = 0;
        _this.snapGrid = [];
        _this.slidesGrid = [];
        for (var i = 0; i < _this.slides.length; i++) {
          _this.snapGrid.push(slideLeft);
          _this.slidesGrid.push(slideLeft);
          slideLeft += slideSize;
          if (!params.cssWidthAndHeight) {
            if (parseFloat(slideWidth) > 0) {
              _this.slides[i].style.width = slideWidth + "px";
            }

            if (parseFloat(slideHeight) > 0) {
              _this.slides[i].style.height = slideHeight + "px";
            }
          }
        }
      }

      if (!_this.initialized) {
        _this.callPlugins("onFirstInit");
        if (params.onFirstInit) _this.fireCallback(params.onFirstInit, _this);
      } else {
        _this.callPlugins("onInit");
        if (params.onInit) _this.fireCallback(params.onInit, _this);
      }
      _this.initialized = true;
    };

    _this.reInit = function (forceCalcSlides) {
      _this.init(true, forceCalcSlides);
    };

    _this.resizeFix = function (reInit) {
      _this.callPlugins("beforeResizeFix");

      _this.init(params.resizeReInit || reInit);

      // swipe to active slide in fixed mode
      if (!params.freeMode) {
        _this.swipeTo(
          params.loop ? _this.activeLoopIndex : _this.activeIndex,
          0,
          false
        );
      }

      // move wrapper to the beginning in free mode
      else if (_this.getWrapperTranslate() < -maxWrapperPosition()) {
        _this.setWrapperTransition(0);
        _this.setWrapperTranslate(-maxWrapperPosition());
      }

      _this.callPlugins("afterResizeFix");
    };

    /*==========================================
        Max and Min Positions
    ============================================*/
    function maxWrapperPosition() {
      var a = wrapperSize - containerSize;
      if (params.freeMode) {
        a = wrapperSize - containerSize;
      }
      // if (params.loop) a -= containerSize;
      if (params.slidesPerView > _this.slides.length) a = 0;
      if (a < 0) a = 0;
      return a;
    }
    function minWrapperPosition() {
      var a = 0;
      // if (params.loop) a = containerSize;
      return a;
    }

    /*==========================================
        Event Listeners
    ============================================*/
    function initEvents() {
      var bind = _this.h.addEventListener;

      //Touch Events
      if (!_this.browser.ie10) {
        if (_this.support.touch) {
          bind(_this.wrapper, "touchstart", onTouchStart);
          bind(_this.wrapper, "touchmove", onTouchMove);
          bind(_this.wrapper, "touchend", onTouchEnd);
        }
        if (params.simulateTouch) {
          bind(_this.wrapper, "mousedown", onTouchStart);
          bind(document, "mousemove", onTouchMove);
          bind(document, "mouseup", onTouchEnd);
        }
      } else {
        bind(_this.wrapper, _this.touchEvents.touchStart, onTouchStart);
        bind(document, _this.touchEvents.touchMove, onTouchMove);
        bind(document, _this.touchEvents.touchEnd, onTouchEnd);
      }

      //Resize Event
      if (params.autoResize) {
        bind(window, "resize", _this.resizeFix);
      }
      //Slide Events
      addSlideEvents();
      //Mousewheel
      _this._wheelEvent = false;
      if (params.mousewheelControl) {
        if (document.onmousewheel !== undefined) {
          _this._wheelEvent = "mousewheel";
        }
        try {
          WheelEvent("wheel");
          _this._wheelEvent = "wheel";
        } catch (e) {}
        if (!_this._wheelEvent) {
          _this._wheelEvent = "DOMMouseScroll";
        }

        if (_this._wheelEvent) {
          bind(_this.container, _this._wheelEvent, handleMousewheel);
        }
      }

      //Keyboard
      if (params.keyboardControl) {
        bind(document, "keydown", handleKeyboardKeys);
      }
      if (params.updateOnImagesReady) {
        _this.imagesToLoad = $$("img", _this.container);

        for (var i = 0; i < _this.imagesToLoad.length; i++) {
          _loadImage(_this.imagesToLoad[i].getAttribute("src"));
        }
      }
      function _loadImage(src) {
        var image = new Image();
        image.onload = function () {
          _this.imagesLoaded++;
          if (_this.imagesLoaded == _this.imagesToLoad.length) {
            _this.reInit();
            if (params.onImagesReady)
              _this.fireCallback(params.onImagesReady, _this);
          }
        };
        image.src = src;
      }
    }

    //Remove Event Listeners
    _this.destroy = function (removeResizeFix) {
      var unbind = _this.h.removeEventListener;

      //Touch Events
      if (!_this.browser.ie10) {
        if (_this.support.touch) {
          unbind(_this.wrapper, "touchstart", onTouchStart);
          unbind(_this.wrapper, "touchmove", onTouchMove);
          unbind(_this.wrapper, "touchend", onTouchEnd);
        }
        if (params.simulateTouch) {
          unbind(_this.wrapper, "mousedown", onTouchStart);
          unbind(document, "mousemove", onTouchMove);
          unbind(document, "mouseup", onTouchEnd);
        }
      } else {
        unbind(_this.wrapper, _this.touchEvents.touchStart, onTouchStart);
        unbind(document, _this.touchEvents.touchMove, onTouchMove);
        unbind(document, _this.touchEvents.touchEnd, onTouchEnd);
      }

      //Resize Event
      if (params.autoResize) {
        unbind(window, "resize", _this.resizeFix);
      }

      //Init Slide Events
      removeSlideEvents();

      //Pagination
      if (params.paginationClickable) {
        removePaginationEvents();
      }

      //Mousewheel
      if (params.mousewheelControl && _this._wheelEvent) {
        unbind(_this.container, _this._wheelEvent, handleMousewheel);
      }

      //Keyboard
      if (params.keyboardControl) {
        unbind(document, "keydown", handleKeyboardKeys);
      }

      //Stop autoplay
      if (params.autoplay) {
        _this.stopAutoplay();
      }
      _this.callPlugins("onDestroy");

      //Destroy variable
      _this = null;
    };
    function addSlideEvents() {
      var bind = _this.h.addEventListener,
        i;

      //Prevent Links Events
      if (params.preventLinks) {
        var links = $$("a", _this.container);
        for (i = 0; i < links.length; i++) {
          bind(links[i], "click", preventClick);
        }
      }
      //Release Form Elements
      if (params.releaseFormElements) {
        var formElements = $$("input, textarea, select", _this.container);
        for (i = 0; i < formElements.length; i++) {
          bind(
            formElements[i],
            _this.touchEvents.touchStart,
            releaseForms,
            true
          );
        }
      }

      //Slide Clicks & Touches
      if (params.onSlideClick) {
        for (i = 0; i < _this.slides.length; i++) {
          bind(_this.slides[i], "click", slideClick);
        }
      }
      if (params.onSlideTouch) {
        for (i = 0; i < _this.slides.length; i++) {
          bind(_this.slides[i], _this.touchEvents.touchStart, slideTouch);
        }
      }
    }
    function removeSlideEvents() {
      var unbind = _this.h.removeEventListener,
        i;

      //Slide Clicks & Touches
      if (params.onSlideClick) {
        for (i = 0; i < _this.slides.length; i++) {
          unbind(_this.slides[i], "click", slideClick);
        }
      }
      if (params.onSlideTouch) {
        for (i = 0; i < _this.slides.length; i++) {
          unbind(_this.slides[i], _this.touchEvents.touchStart, slideTouch);
        }
      }
      //Release Form Elements
      if (params.releaseFormElements) {
        var formElements = $$("input, textarea, select", _this.container);
        for (i = 0; i < formElements.length; i++) {
          unbind(
            formElements[i],
            _this.touchEvents.touchStart,
            releaseForms,
            true
          );
        }
      }
      //Prevent Links Events
      if (params.preventLinks) {
        var links = $$("a", _this.container);
        for (i = 0; i < links.length; i++) {
          unbind(links[i], "click", preventClick);
        }
      }
    }
    /*==========================================
        Keyboard Control
    ============================================*/
    function handleKeyboardKeys(e) {
      var kc = e.keyCode || e.charCode;
      if (kc == 37 || kc == 39 || kc == 38 || kc == 40) {
        var inView = false;
        //Check that swiper should be inside of visible area of window
        var swiperOffset = _this.h.getOffset(_this.container);
        var scrollLeft = _this.h.windowScroll().left;
        var scrollTop = _this.h.windowScroll().top;
        var windowWidth = _this.h.windowWidth();
        var windowHeight = _this.h.windowHeight();
        var swiperCoord = [
          [swiperOffset.left, swiperOffset.top],
          [swiperOffset.left + _this.width, swiperOffset.top],
          [swiperOffset.left, swiperOffset.top + _this.height],
          [swiperOffset.left + _this.width, swiperOffset.top + _this.height],
        ];
        for (var i = 0; i < swiperCoord.length; i++) {
          var point = swiperCoord[i];
          if (
            point[0] >= scrollLeft &&
            point[0] <= scrollLeft + windowWidth &&
            point[1] >= scrollTop &&
            point[1] <= scrollTop + windowHeight
          ) {
            inView = true;
          }
        }
        if (!inView) return;
      }
      if (isH) {
        if (kc == 37 || kc == 39) {
          if (e.preventDefault) e.preventDefault();
          else e.returnValue = false;
        }
        if (kc == 39) _this.swipeNext();
        if (kc == 37) _this.swipePrev();
      } else {
        if (kc == 38 || kc == 40) {
          if (e.preventDefault) e.preventDefault();
          else e.returnValue = false;
        }
        if (kc == 40) _this.swipeNext();
        if (kc == 38) _this.swipePrev();
      }
    }

    /*==========================================
        Mousewheel Control
    ============================================*/
    var allowScrollChange = true;
    var lastScrollTime = new Date().getTime();
    function handleMousewheel(e) {
      var we = _this._wheelEvent;
      var delta = 0;
      //Opera & IE
      if (e.detail) delta = -e.detail;
      //WebKits
      else if (we == "mousewheel") delta = e.wheelDelta;
      //Old FireFox
      else if (we == "DOMMouseScroll") delta = -e.detail;
      //New FireFox
      else if (we == "wheel") {
        delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? -e.deltaX : -e.deltaY;
      }
      if (!params.freeMode) {
        if (delta < 0) _this.swipeNext();
        else _this.swipePrev();
      } else {
        //Freemode or scrollContainer:
        var position = _this.getWrapperTranslate() + delta;

        if (position > 0) position = 0;
        if (position < -maxWrapperPosition()) position = -maxWrapperPosition();

        _this.setWrapperTransition(0);
        _this.setWrapperTranslate(position);
        _this.updateActiveSlide(position);
      }
      if (params.autoplay) _this.stopAutoplay();

      if (e.preventDefault) e.preventDefault();
      else e.returnValue = false;
      return false;
    }

    /*=========================
      Grab Cursor
      ===========================*/
    if (params.grabCursor) {
      var containerStyle = _this.container.style;
      containerStyle.cursor = "move";
      containerStyle.cursor = "grab";
      containerStyle.cursor = "-moz-grab";
      containerStyle.cursor = "-webkit-grab";
    }

    /*=========================
      Slides Events Handlers
      ===========================*/

    _this.allowSlideClick = true;
    function slideClick(event) {
      if (_this.allowSlideClick) {
        setClickedSlide(event);
        this.fireCallback(params.onSlideClick, _this, event);
      }
    }

    function slideTouch(event) {
      setClickedSlide(event);
      _this.fireCallback(params.onSlideTouch, _this, event);
    }

    function setClickedSlide(event) {
      // IE 6-8 support
      if (!event.currentTarget) {
        var element = event.srcElement;
        do {
          if (element.className.indexOf(params.slideClass) > -1) {
            break;
          }
        } while ((element = element.parentNode));
        _this.clickedSlide = element;
      } else {
        _this.clickedSlide = event.currentTarget;
      }

      _this.clickedSlideIndex = _this.slides.indexOf(_this.clickedSlide);
      _this.clickedSlideLoopIndex =
        _this.clickedSlideIndex - (_this.loopedSlides || 0);
    }

    _this.allowLinks = true;
    function preventClick(e) {
      if (!_this.allowLinks) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
      }
    }
    function releaseForms(e) {
      if (e.stopPropagation) e.stopPropagation();
      else e.returnValue = false;
      return false;
    }

    /*==================================================
        Event Handlers
    ====================================================*/
    var isTouchEvent = false;
    var allowThresholdMove;
    var allowMomentumBounce = true;
    function onTouchStart(event) {
      //vc gallery when using lightbox fix
      if (
        jQuery(event.target)
          .parents(".swiper-container")
          .attr("data-desktop-swipe") == "false" &&
        !Modernizr.touch
      )
        return false;

      //deactivate touch if only one slide
      if (
        jQuery(event.target).parents(".swiper-container").find(".swiper-slide")
          .length == 1
      )
        return false;

      //deactivate touch for duplicate transitions
      if (
        jQuery(event.target)
          .parents(".swiper-container")
          .find(".swiper-slide.duplicate-transition").length > 0
      )
        return false;

      if (params.preventLinks) _this.allowLinks = true;
      //Exit if slider is already was touched
      if (_this.isTouched || params.onlyExternal) {
        return false;
      }

      if (
        params.noSwiping &&
        (event.target || event.srcElement) &&
        noSwipingSlide(event.target || event.srcElement)
      )
        return false;
      allowMomentumBounce = false;

      //Check For Nested Swipers
      _this.isTouched = true;
      isTouchEvent = event.type == "touchstart";

      if (!isTouchEvent || event.targetTouches.length == 1) {
        _this.callPlugins("onTouchStartBegin");

        if (!isTouchEvent) {
          if (event.preventDefault) event.preventDefault();
          else event.returnValue = false;
        }

        var pageX = isTouchEvent
          ? event.targetTouches[0].pageX
          : event.pageX || event.clientX;
        var pageY = isTouchEvent
          ? event.targetTouches[0].pageY
          : event.pageY || event.clientY;

        //Start Touches to check the scrolling
        _this.touches.startX = _this.touches.currentX = pageX;
        _this.touches.startY = _this.touches.currentY = pageY;

        _this.touches.start = _this.touches.current = isH ? pageX : pageY;

        //Set Transition Time to 0
        _this.setWrapperTransition(0);

        //Get Start Translate Position
        _this.positions.start = _this.positions.current =
          _this.getWrapperTranslate();

        //Set Transform
        _this.setWrapperTranslate(_this.positions.start);

        //TouchStartTime
        _this.times.start = new Date().getTime();

        //Unset Scrolling
        isScrolling = undefined;

        //Set Treshold
        if (params.moveStartThreshold > 0) allowThresholdMove = false;

        //CallBack
        if (params.onTouchStart) _this.fireCallback(params.onTouchStart, _this);
        _this.callPlugins("onTouchStartEnd");
      }
    }
    var velocityPrevPosition, velocityPrevTime;
    function onTouchMove(event) {
      // If slider is not touched - exit
      if (!_this.isTouched || params.onlyExternal) return;
      if (isTouchEvent && event.type == "mousemove") return;

      var pageX = isTouchEvent
        ? event.targetTouches[0].pageX
        : event.pageX || event.clientX;
      var pageY = isTouchEvent
        ? event.targetTouches[0].pageY
        : event.pageY || event.clientY;

      //check for scrolling
      if (typeof isScrolling === "undefined" && isH) {
        isScrolling = !!(
          isScrolling ||
          Math.abs(pageY - _this.touches.startY) >
            Math.abs(pageX - _this.touches.startX)
        );
      }
      if (typeof isScrolling === "undefined" && !isH) {
        isScrolling = !!(
          isScrolling ||
          Math.abs(pageY - _this.touches.startY) <
            Math.abs(pageX - _this.touches.startX)
        );
      }
      if (isScrolling) {
        _this.isTouched = false;
        return;
      }

      //Check For Nested Swipers
      if (event.assignedToSwiper) {
        _this.isTouched = false;
        return;
      }
      event.assignedToSwiper = true;

      //Block inner links
      if (params.preventLinks) {
        _this.allowLinks = false;
      }
      if (params.onSlideClick) {
        _this.allowSlideClick = false;
      }

      //Stop AutoPlay if exist
      if (params.autoplay) {
        _this.stopAutoplay();
      }
      if (!isTouchEvent || event.touches.length == 1) {
        //Moved Flag
        if (!_this.isMoved) {
          _this.callPlugins("onTouchMoveStart");

          if (params.loop) {
            _this.fixLoop();
            _this.positions.start = _this.getWrapperTranslate();
          }
          if (params.onTouchMoveStart)
            _this.fireCallback(params.onTouchMoveStart, _this);
        }
        _this.isMoved = true;

        // cancel event
        if (event.preventDefault) event.preventDefault();
        else event.returnValue = false;

        _this.touches.current = isH ? pageX : pageY;

        _this.positions.current =
          (_this.touches.current - _this.touches.start) * params.touchRatio +
          _this.positions.start;

        //Resistance Callbacks
        if (_this.positions.current > 0 && params.onResistanceBefore) {
          _this.fireCallback(
            params.onResistanceBefore,
            _this,
            _this.positions.current
          );
        }
        if (
          _this.positions.current < -maxWrapperPosition() &&
          params.onResistanceAfter
        ) {
          _this.fireCallback(
            params.onResistanceAfter,
            _this,
            Math.abs(_this.positions.current + maxWrapperPosition())
          );
        }
        //Resistance
        if (params.resistance && params.resistance != "100%") {
          //Resistance for Negative-Back sliding
          if (_this.positions.current > 0) {
            var resistance = 1 - _this.positions.current / containerSize / 2;
            if (resistance < 0.5) _this.positions.current = containerSize / 2;
            else _this.positions.current = _this.positions.current * resistance;
          }
          //Resistance for After-End Sliding
          if (_this.positions.current < -maxWrapperPosition()) {
            var diff =
              (_this.touches.current - _this.touches.start) *
                params.touchRatio +
              (maxWrapperPosition() + _this.positions.start);
            var resistance = (containerSize + diff) / containerSize;
            var newPos =
              _this.positions.current - (diff * (1 - resistance)) / 2;
            var stopPos = -maxWrapperPosition() - containerSize / 2;

            if (newPos < stopPos || resistance <= 0)
              _this.positions.current = stopPos;
            else _this.positions.current = newPos;
          }
        }
        if (params.resistance && params.resistance == "100%") {
          //Resistance for Negative-Back sliding
          if (
            _this.positions.current > 0 &&
            !(params.freeMode && !params.freeModeFluid)
          ) {
            _this.positions.current = 0;
          }
          //Resistance for After-End Sliding
          if (
            _this.positions.current < -maxWrapperPosition() &&
            !(params.freeMode && !params.freeModeFluid)
          ) {
            _this.positions.current = -maxWrapperPosition();
          }
        }
        //Move Slides
        if (!params.followFinger) return;

        if (!params.moveStartThreshold) {
          _this.setWrapperTranslate(_this.positions.current);
        } else {
          if (
            Math.abs(_this.touches.current - _this.touches.start) >
              params.moveStartThreshold ||
            allowThresholdMove
          ) {
            allowThresholdMove = true;
            _this.setWrapperTranslate(_this.positions.current);
          } else {
            _this.positions.current = _this.positions.start;
          }
        }

        if (params.freeMode || params.watchActiveIndex) {
          _this.updateActiveSlide(_this.positions.current);
        }

        //Grab Cursor
        //Grab Cursor
        if (params.grabCursor) {
          _this.container.style.cursor = "move";
          _this.container.style.cursor = "grabbing";
          _this.container.style.cursor = "-moz-grabbing";
          _this.container.style.cursor = "-webkit-grabbing";
        }
        //Velocity
        if (!velocityPrevPosition) velocityPrevPosition = _this.touches.current;
        if (!velocityPrevTime) velocityPrevTime = new Date().getTime();
        _this.velocity =
          (_this.touches.current - velocityPrevPosition) /
          (new Date().getTime() - velocityPrevTime) /
          2;

        if (Math.abs(_this.touches.current - velocityPrevPosition) < 2)
          _this.velocity = 0;
        velocityPrevPosition = _this.touches.current;
        velocityPrevTime = new Date().getTime();
        //Callbacks
        _this.callPlugins("onTouchMoveEnd");
        if (params.onTouchMove) _this.fireCallback(params.onTouchMove, _this);

        return false;
      }
    }
    function onTouchEnd(event) {
      //Check For scrolling
      if (isScrolling) {
        _this.swipeReset();
      }
      // If slider is not touched exit
      if (params.onlyExternal || !_this.isTouched) return;
      _this.isTouched = false;

      //Return Grab Cursor
      if (params.grabCursor) {
        _this.container.style.cursor = "move";
        _this.container.style.cursor = "grab";
        _this.container.style.cursor = "-moz-grab";
        _this.container.style.cursor = "-webkit-grab";
      }

      //Check for Current Position
      if (!_this.positions.current && _this.positions.current !== 0) {
        _this.positions.current = _this.positions.start;
      }

      //For case if slider touched but not moved
      if (params.followFinger) {
        _this.setWrapperTranslate(_this.positions.current);
      }

      // TouchEndTime
      _this.times.end = new Date().getTime();

      //Difference
      _this.touches.diff = _this.touches.current - _this.touches.start;
      _this.touches.abs = Math.abs(_this.touches.diff);

      _this.positions.diff = _this.positions.current - _this.positions.start;
      _this.positions.abs = Math.abs(_this.positions.diff);

      var diff = _this.positions.diff;
      var diffAbs = _this.positions.abs;
      var timeDiff = _this.times.end - _this.times.start;

      if (diffAbs < 5 && timeDiff < 300 && _this.allowLinks == false) {
        if (!params.freeMode && diffAbs != 0) _this.swipeReset();
        //Release inner links
        if (params.preventLinks) {
          _this.allowLinks = true;
        }
        if (params.onSlideClick) {
          _this.allowSlideClick = true;
        }
      }

      setTimeout(function () {
        //Release inner links
        if (params.preventLinks) {
          _this.allowLinks = true;
        }
        if (params.onSlideClick) {
          _this.allowSlideClick = true;
        }
      }, 100);

      var maxPosition = maxWrapperPosition();

      //Not moved or Prevent Negative Back Sliding/After-End Sliding
      if (!_this.isMoved && params.freeMode) {
        _this.isMoved = false;
        if (params.onTouchEnd) _this.fireCallback(params.onTouchEnd, _this);
        _this.callPlugins("onTouchEnd");
        return;
      }
      if (
        !_this.isMoved ||
        _this.positions.current > 0 ||
        _this.positions.current < -maxPosition
      ) {
        _this.swipeReset();
        if (params.onTouchEnd) _this.fireCallback(params.onTouchEnd, _this);
        _this.callPlugins("onTouchEnd");
        return;
      }

      _this.isMoved = false;

      //Free Mode
      if (params.freeMode) {
        if (params.freeModeFluid) {
          var momentumDuration = 1000 * params.momentumRatio;
          var momentumDistance = _this.velocity * momentumDuration;
          var newPosition = _this.positions.current + momentumDistance;
          var doBounce = false;
          var afterBouncePosition;
          var bounceAmount =
            Math.abs(_this.velocity) * 20 * params.momentumBounceRatio;
          if (newPosition < -maxPosition) {
            if (params.momentumBounce && _this.support.transitions) {
              if (newPosition + maxPosition < -bounceAmount)
                newPosition = -maxPosition - bounceAmount;
              afterBouncePosition = -maxPosition;
              doBounce = true;
              allowMomentumBounce = true;
            } else newPosition = -maxPosition;
          }
          if (newPosition > 0) {
            if (params.momentumBounce && _this.support.transitions) {
              if (newPosition > bounceAmount) newPosition = bounceAmount;
              afterBouncePosition = 0;
              doBounce = true;
              allowMomentumBounce = true;
            } else newPosition = 0;
          }
          //Fix duration
          if (_this.velocity != 0)
            momentumDuration = Math.abs(
              (newPosition - _this.positions.current) / _this.velocity
            );

          _this.setWrapperTranslate(newPosition);

          _this.setWrapperTransition(momentumDuration);

          if (params.momentumBounce && doBounce) {
            _this.wrapperTransitionEnd(function () {
              if (!allowMomentumBounce) return;

              if (params.onMomentumBounce) params.onMomentumBounce(_this);

              _this.setWrapperTranslate(afterBouncePosition);
              _this.setWrapperTransition(300);
            });
          }

          _this.updateActiveSlide(newPosition);
        }
        if (!params.freeModeFluid || timeDiff >= 300)
          _this.updateActiveSlide(_this.positions.current);

        if (params.onTouchEnd) params.onTouchEnd(_this);
        _this.callPlugins("onTouchEnd");
        return;
      }

      //Direction
      direction = diff < 0 ? "toNext" : "toPrev";

      //Short Touches
      if (direction == "toNext" && timeDiff <= 300) {
        if (diffAbs < 30 || !params.shortSwipes) _this.swipeReset();
        else _this.swipeNext(true);
      }

      if (direction == "toPrev" && timeDiff <= 300) {
        if (diffAbs < 30 || !params.shortSwipes) _this.swipeReset();
        else _this.swipePrev(true);
      }

      //Long Touches
      var targetSlideSize = 0;
      if (params.slidesPerView == "auto") {
        //Define current slide's width
        var currentPosition = Math.abs(_this.getWrapperTranslate());
        var slidesOffset = 0;
        var _slideSize;
        for (var i = 0; i < _this.slides.length; i++) {
          _slideSize = isH
            ? _this.slides[i].getWidth(true)
            : _this.slides[i].getHeight(true);
          slidesOffset += _slideSize;
          if (slidesOffset > currentPosition) {
            targetSlideSize = _slideSize;
            break;
          }
        }
        if (targetSlideSize > containerSize) targetSlideSize = containerSize;
      } else {
        targetSlideSize = slideSize * params.slidesPerView;
      }
      if (direction == "toNext" && timeDiff > 300) {
        if (diffAbs >= targetSlideSize * 0.5) {
          _this.swipeNext(true);
        } else {
          _this.swipeReset();
        }
      }
      if (direction == "toPrev" && timeDiff > 300) {
        if (diffAbs >= targetSlideSize * 0.5) {
          _this.swipePrev(true);
        } else {
          _this.swipeReset();
        }
      }
      if (params.onTouchEnd) params.onTouchEnd(_this);
      _this.callPlugins("onTouchEnd");
    }

    /*==================================================
        noSwiping Bubble Check by Isaac Strack
    ====================================================*/
    function noSwipingSlide(el) {
      /*This function is specifically designed to check the parent elements for the noSwiping class, up to the wrapper.
        We need to check parents because while onTouchStart bubbles, _this.isTouched is checked in onTouchStart, which stops the bubbling.
        So, if a text box, for example, is the initial target, and the parent slide container has the noSwiping class, the _this.isTouched
        check will never find it, and what was supposed to be noSwiping is able to be swiped.
        This function will iterate up and check for the noSwiping class in parents, up through the wrapperClass.*/

      // First we create a truthy variable, which is that swiping is allowd (noSwiping = false)
      var noSwiping = false;

      // Now we iterate up (parentElements) until we reach the node with the wrapperClass.
      do {
        // Each time, we check to see if there's a 'swiper-no-swiping' class (noSwipingClass).
        if (el.className.indexOf(params.noSwipingClass) > -1) {
          noSwiping = true; // If there is, we set noSwiping = true;
        }

        el = el.parentElement; // now we iterate up (parent node)
      } while (
        !noSwiping &&
        el.parentElement &&
        el.className.indexOf(params.wrapperClass) == -1
      ); // also include el.parentElement truthy, just in case.

      // because we didn't check the wrapper itself, we do so now, if noSwiping is false:
      if (
        !noSwiping &&
        el.className.indexOf(params.wrapperClass) > -1 &&
        el.className.indexOf(params.noSwipingClass) > -1
      )
        noSwiping = true; // if the wrapper has the noSwipingClass, we set noSwiping = true;

      return noSwiping;
    }

    /*==================================================
        Swipe Functions
    ====================================================*/
    _this.swipeNext = function (internal) {
      if (!internal && params.loop) _this.fixLoop();
      _this.callPlugins("onSwipeNext");
      var currentPosition = _this.getWrapperTranslate();
      var newPosition = currentPosition;
      if (params.slidesPerView == "auto") {
        for (var i = 0; i < _this.snapGrid.length; i++) {
          if (
            -currentPosition >= _this.snapGrid[i] &&
            -currentPosition < _this.snapGrid[i + 1]
          ) {
            newPosition = -_this.snapGrid[i + 1];
            break;
          }
        }
      } else {
        var groupSize = slideSize * params.slidesPerGroup;
        newPosition = -(
          Math.floor(Math.abs(currentPosition) / Math.floor(groupSize)) *
            groupSize +
          groupSize
        );
      }
      if (newPosition < -maxWrapperPosition()) {
        newPosition = -maxWrapperPosition();
      }

      if (newPosition == currentPosition) return false;

      swipeToPosition(newPosition, "next");
      return true;
    };
    _this.swipePrev = function (internal) {
      if (!internal && params.loop) _this.fixLoop();
      if (!internal && params.autoplay) _this.stopAutoplay();
      _this.callPlugins("onSwipePrev");

      var currentPosition = Math.ceil(_this.getWrapperTranslate());
      var newPosition;
      if (params.slidesPerView == "auto") {
        newPosition = 0;
        for (var i = 1; i < _this.snapGrid.length; i++) {
          if (-currentPosition == _this.snapGrid[i]) {
            newPosition = -_this.snapGrid[i - 1];
            break;
          }
          if (
            -currentPosition > _this.snapGrid[i] &&
            -currentPosition < _this.snapGrid[i + 1]
          ) {
            newPosition = -_this.snapGrid[i];
            break;
          }
        }
      } else {
        var groupSize = slideSize * params.slidesPerGroup;
        newPosition =
          -(Math.ceil(-currentPosition / groupSize) - 1) * groupSize;
      }

      if (newPosition > 0) newPosition = 0;

      if (newPosition == currentPosition) return false;
      swipeToPosition(newPosition, "prev");
      return true;
    };
    _this.swipeReset = function () {
      _this.callPlugins("onSwipeReset");
      var currentPosition = _this.getWrapperTranslate();
      var groupSize = slideSize * params.slidesPerGroup;
      var newPosition;
      var maxPosition = -maxWrapperPosition();
      if (params.slidesPerView == "auto") {
        newPosition = 0;
        for (var i = 0; i < _this.snapGrid.length; i++) {
          if (-currentPosition === _this.snapGrid[i]) return;
          if (
            -currentPosition >= _this.snapGrid[i] &&
            -currentPosition < _this.snapGrid[i + 1]
          ) {
            if (_this.positions.diff > 0) newPosition = -_this.snapGrid[i + 1];
            else newPosition = -_this.snapGrid[i];
            break;
          }
        }
        if (-currentPosition >= _this.snapGrid[_this.snapGrid.length - 1])
          newPosition = -_this.snapGrid[_this.snapGrid.length - 1];
        if (currentPosition <= -maxWrapperPosition())
          newPosition = -maxWrapperPosition();
      } else {
        newPosition =
          currentPosition < 0
            ? Math.round(currentPosition / groupSize) * groupSize
            : 0;
      }
      if (params.scrollContainer) {
        newPosition = currentPosition < 0 ? currentPosition : 0;
      }
      if (newPosition < -maxWrapperPosition()) {
        newPosition = -maxWrapperPosition();
      }
      if (params.scrollContainer && containerSize > slideSize) {
        newPosition = 0;
      }

      if (newPosition == currentPosition) return false;

      swipeToPosition(newPosition, "reset");
      return true;
    };

    _this.swipeTo = function (index, speed, runCallbacks) {
      index = parseInt(index, 10);
      _this.callPlugins("onSwipeTo", { index: index, speed: speed });
      if (params.loop) index = index + _this.loopedSlides;
      var currentPosition = _this.getWrapperTranslate();
      if (index > _this.slides.length - 1 || index < 0) return;
      var newPosition;
      if (params.slidesPerView == "auto") {
        newPosition = -_this.slidesGrid[index];
      } else {
        newPosition = -index * slideSize;
      }
      if (newPosition < -maxWrapperPosition()) {
        newPosition = -maxWrapperPosition();
      }

      if (newPosition == currentPosition) return false;

      runCallbacks = runCallbacks === false ? false : true;
      swipeToPosition(newPosition, "to", {
        index: index,
        speed: speed,
        runCallbacks: runCallbacks,
      });
      return true;
    };

    function swipeToPosition(newPosition, action, toOptions) {
      var speed =
        action == "to" && toOptions.speed >= 0 ? toOptions.speed : params.speed;

      var timeOld = +new Date();
      if (_this.support.transitions || !params.DOMAnimation) {
        _this.setWrapperTranslate(newPosition);
        _this.setWrapperTransition(speed);
      } else {
        //Try the DOM animation
        var currentPosition = _this.getWrapperTranslate();
        var animationStep = Math.ceil(
          ((newPosition - currentPosition) / speed) * (1000 / 60)
        );
        var direction = currentPosition > newPosition ? "toNext" : "toPrev";
        var condition =
          direction == "toNext"
            ? currentPosition > newPosition
            : currentPosition < newPosition;
        if (_this._DOMAnimating) return;

        anim();
      }
      function anim() {
        var timeNew = +new Date();
        var time = timeNew - timeOld;
        currentPosition += (animationStep * time) / (1000 / 60);

        condition =
          direction == "toNext"
            ? currentPosition > newPosition
            : currentPosition < newPosition;
        if (condition) {
          _this.setWrapperTranslate(Math.round(currentPosition));
          _this._DOMAnimating = true;
          window.setTimeout(function () {
            anim();
          }, 1000 / 60);
        } else {
          if (params.onSlideChangeEnd)
            _this.fireCallback(params.onSlideChangeEnd, _this);
          _this.setWrapperTranslate(newPosition);
          _this._DOMAnimating = false;
        }
      }

      //Update Active Slide Index
      _this.updateActiveSlide(newPosition);

      //Callbacks
      if (params.onSlideNext && action == "next") {
        _this.fireCallback(params.onSlideNext, _this, newPosition);
      }
      if (params.onSlidePrev && action == "prev") {
        _this.fireCallback(params.onSlidePrev, _this, newPosition);
      }
      //"Reset" Callback
      if (params.onSlideReset && action == "reset") {
        _this.fireCallback(params.onSlideReset, _this, newPosition);
      }

      //"Next", "Prev" and "To" Callbacks
      if (
        action == "next" ||
        action == "prev" ||
        (action == "to" && toOptions.runCallbacks == true)
      )
        slideChangeCallbacks(action);
    }
    /*==================================================
        Transition Callbacks
    ====================================================*/
    //Prevent Multiple Callbacks
    _this._queueStartCallbacks = false;
    _this._queueEndCallbacks = false;
    function slideChangeCallbacks(direction) {
      //Transition Start Callback
      _this.callPlugins("onSlideChangeStart");
      if (params.onSlideChangeStart) {
        if (params.queueStartCallbacks && _this.support.transitions) {
          if (_this._queueStartCallbacks) return;
          _this._queueStartCallbacks = true;
          _this.fireCallback(params.onSlideChangeStart, _this, direction);
          _this.wrapperTransitionEnd(function () {
            _this._queueStartCallbacks = false;
          });
        } else _this.fireCallback(params.onSlideChangeStart, _this, direction);
      }
      //Transition End Callback
      if (params.onSlideChangeEnd) {
        if (_this.support.transitions) {
          if (params.queueEndCallbacks) {
            if (_this._queueEndCallbacks) return;
            _this._queueEndCallbacks = true;
            _this.wrapperTransitionEnd(function (swiper) {
              setTimeout(function () {
                if (params.loop) _this.fixLoop();
              }, 50);
              _this.fireCallback(params.onSlideChangeEnd, swiper, direction);
            });
          } else
            _this.wrapperTransitionEnd(function (swiper) {
              setTimeout(function () {
                if (params.loop) _this.fixLoop();
              }, 50);
              _this.fireCallback(params.onSlideChangeEnd, swiper, direction);
            });
        } else {
          if (!params.DOMAnimation) {
            setTimeout(function () {
              _this.fireCallback(params.onSlideChangeStart, _this, direction);
            }, 10);
          }
        }
      }
    }

    /*==================================================
        Update Active Slide Index
    ====================================================*/
    _this.updateActiveSlide = function (position) {
      if (!_this.initialized) return;
      if (_this.slides.length == 0) return;
      _this.previousIndex = _this.activeIndex;
      if (typeof position == "undefined")
        position = _this.getWrapperTranslate();
      if (position > 0) position = 0;

      if (params.slidesPerView == "auto") {
        var slidesOffset = 0;
        _this.activeIndex = _this.slidesGrid.indexOf(-position);
        if (_this.activeIndex < 0) {
          for (var i = 0; i < _this.slidesGrid.length - 1; i++) {
            if (
              -position > _this.slidesGrid[i] &&
              -position < _this.slidesGrid[i + 1]
            ) {
              break;
            }
          }
          var leftDistance = Math.abs(_this.slidesGrid[i] + position);
          var rightDistance = Math.abs(_this.slidesGrid[i + 1] + position);
          if (leftDistance <= rightDistance) _this.activeIndex = i;
          else _this.activeIndex = i + 1;
        }
      } else {
        _this.activeIndex = Math[params.visibilityFullFit ? "ceil" : "round"](
          -position / slideSize
        );
      }

      if (_this.activeIndex == _this.slides.length)
        _this.activeIndex = _this.slides.length - 1;
      if (_this.activeIndex < 0) _this.activeIndex = 0;

      // Check for slide
      if (!_this.slides[_this.activeIndex]) return;

      // Calc Visible slides
      _this.calcVisibleSlides(position);

      // Mark visible and active slides with additonal classes
      var activeClassRegexp = new RegExp("\\s*" + params.slideActiveClass);
      var inViewClassRegexp = new RegExp("\\s*" + params.slideVisibleClass);

      for (var i = 0; i < _this.slides.length; i++) {
        _this.slides[i].className = _this.slides[i].className
          .replace(activeClassRegexp, "")
          .replace(inViewClassRegexp, "");
        if (_this.visibleSlides.indexOf(_this.slides[i]) >= 0) {
          _this.slides[i].className += " " + params.slideVisibleClass;
        }
      }
      _this.slides[_this.activeIndex].className +=
        " " + params.slideActiveClass;

      //Update loop index
      if (params.loop) {
        var ls = _this.loopedSlides;
        _this.activeLoopIndex = _this.activeIndex - ls;
        if (_this.activeLoopIndex >= _this.slides.length - ls * 2) {
          _this.activeLoopIndex =
            _this.slides.length - ls * 2 - _this.activeLoopIndex;
        }
        if (_this.activeLoopIndex < 0) {
          _this.activeLoopIndex =
            _this.slides.length - ls * 2 + _this.activeLoopIndex;
        }
      } else {
        _this.activeLoopIndex = _this.activeIndex;
      }
      //Update Pagination
      if (params.pagination) {
        _this.updatePagination(position);
      }
    };
    /*==================================================
        Pagination
    ====================================================*/
    _this.createPagination = function (firstInit) {
      if (params.paginationClickable && _this.paginationButtons) {
        removePaginationEvents();
      }
      var paginationHTML = "";
      var numOfSlides = _this.slides.length;
      var numOfButtons = numOfSlides;
      if (params.loop) numOfButtons -= _this.loopedSlides * 2;
      for (var i = 0; i < numOfButtons; i++) {
        paginationHTML +=
          "<" +
          params.paginationElement +
          ' class="' +
          params.paginationElementClass +
          '"></' +
          params.paginationElement +
          ">";
      }
      _this.paginationContainer = params.pagination.nodeType
        ? params.pagination
        : $$(params.pagination)[0];
      _this.paginationContainer.innerHTML = paginationHTML;
      _this.paginationButtons = $$(
        "." + params.paginationElementClass,
        _this.paginationContainer
      );
      if (!firstInit) _this.updatePagination();
      _this.callPlugins("onCreatePagination");
      if (params.paginationClickable) {
        addPaginationEvents();
      }
    };
    function removePaginationEvents() {
      var pagers = _this.paginationButtons;
      for (var i = 0; i < pagers.length; i++) {
        _this.h.removeEventListener(pagers[i], "click", paginationClick);
      }
    }
    function addPaginationEvents() {
      var pagers = _this.paginationButtons;
      for (var i = 0; i < pagers.length; i++) {
        _this.h.addEventListener(pagers[i], "click", paginationClick);
      }
    }
    function paginationClick(e) {
      var index;
      var target = e.target || e.srcElement;
      var pagers = _this.paginationButtons;
      for (var i = 0; i < pagers.length; i++) {
        if (target === pagers[i]) index = i;
      }
      _this.swipeTo(index);
    }
    _this.updatePagination = function (position) {
      if (!params.pagination) return;
      if (_this.slides.length < 1) return;

      var activePagers = $$(
        "." + params.paginationActiveClass,
        _this.paginationContainer
      );
      if (!activePagers) return;

      //Reset all Buttons' class to not active
      var pagers = _this.paginationButtons;
      if (pagers.length == 0) return;
      for (var i = 0; i < pagers.length; i++) {
        pagers[i].className = params.paginationElementClass;
      }

      var indexOffset = params.loop ? _this.loopedSlides : 0;
      if (params.paginationAsRange) {
        if (!_this.visibleSlides) _this.calcVisibleSlides(position);
        //Get Visible Indexes
        var visibleIndexes = [];
        for (var i = 0; i < _this.visibleSlides.length; i++) {
          var visIndex =
            _this.slides.indexOf(_this.visibleSlides[i]) - indexOffset;

          if (params.loop && visIndex < 0) {
            visIndex = _this.slides.length - _this.loopedSlides * 2 + visIndex;
          }
          if (
            params.loop &&
            visIndex >= _this.slides.length - _this.loopedSlides * 2
          ) {
            visIndex = _this.slides.length - _this.loopedSlides * 2 - visIndex;
            visIndex = Math.abs(visIndex);
          }
          visibleIndexes.push(visIndex);
        }

        for (i = 0; i < visibleIndexes.length; i++) {
          if (pagers[visibleIndexes[i]])
            pagers[visibleIndexes[i]].className +=
              " " + params.paginationVisibleClass;
        }

        if (params.loop) {
          pagers[_this.activeLoopIndex].className +=
            " " + params.paginationActiveClass;
        } else {
          pagers[_this.activeIndex].className +=
            " " + params.paginationActiveClass;
        }
      } else {
        if (params.loop) {
          pagers[_this.activeLoopIndex].className +=
            " " +
            params.paginationActiveClass +
            " " +
            params.paginationVisibleClass;
        } else {
          pagers[_this.activeIndex].className +=
            " " +
            params.paginationActiveClass +
            " " +
            params.paginationVisibleClass;
        }
      }
    };
    _this.calcVisibleSlides = function (position) {
      var visibleSlides = [];
      var _slideLeft = 0,
        _slideSize = 0,
        _slideRight = 0;
      if (isH && _this.wrapperLeft > 0) position = position + _this.wrapperLeft;
      if (!isH && _this.wrapperTop > 0) position = position + _this.wrapperTop;

      for (var i = 0; i < _this.slides.length; i++) {
        _slideLeft += _slideSize;
        if (params.slidesPerView == "auto")
          _slideSize = isH
            ? _this.h.getWidth(_this.slides[i], true)
            : _this.h.getHeight(_this.slides[i], true);
        else _slideSize = slideSize;

        _slideRight = _slideLeft + _slideSize;
        var isVisibile = false;
        if (params.visibilityFullFit) {
          if (
            _slideLeft >= -position &&
            _slideRight <= -position + containerSize
          )
            isVisibile = true;
          if (
            _slideLeft <= -position &&
            _slideRight >= -position + containerSize
          )
            isVisibile = true;
        } else {
          if (
            _slideRight > -position &&
            _slideRight <= -position + containerSize
          )
            isVisibile = true;
          if (_slideLeft >= -position && _slideLeft < -position + containerSize)
            isVisibile = true;
          if (_slideLeft < -position && _slideRight > -position + containerSize)
            isVisibile = true;
        }

        if (isVisibile) visibleSlides.push(_this.slides[i]);
      }
      if (visibleSlides.length == 0)
        visibleSlides = [_this.slides[_this.activeIndex]];

      _this.visibleSlides = visibleSlides;
    };

    /*==========================================
        Autoplay
    ============================================*/
    _this.autoPlayIntervalId = undefined;
    _this.startAutoplay = function () {
      if (typeof _this.autoPlayIntervalId !== "undefined") return false;
      if (params.autoplay && !params.loop) {
        _this.autoPlayIntervalId = setInterval(function () {
          if (!_this.swipeNext(true)) _this.swipeTo(0);
        }, params.autoplay);
      }
      if (params.autoplay && params.loop) {
        _this.autoPlayIntervalId = setInterval(function () {
          _this.swipeNext();
        }, params.autoplay);
      }
      _this.callPlugins("onAutoplayStart");
    };
    _this.stopAutoplay = function () {
      if (_this.autoPlayIntervalId) clearInterval(_this.autoPlayIntervalId);
      _this.autoPlayIntervalId = undefined;
      _this.callPlugins("onAutoplayStop");
    };

    /*==================================================
        Loop
    ====================================================*/
    _this.loopCreated = false;
    _this.removeLoopedSlides = function () {
      if (_this.loopCreated) {
        for (var i = 0; i < _this.slides.length; i++) {
          if (_this.slides[i].getData("looped") === true)
            _this.wrapper.removeChild(_this.slides[i]);
        }
      }
    };

    _this.createLoop = function () {
      if (_this.slides.length == 0) return;

      _this.loopedSlides = params.slidesPerView + params.loopAdditionalSlides;
      if (_this.loopedSlides > _this.slides.length) {
        _this.loopedSlides = _this.slides.length;
      }

      var slideFirstHTML = "",
        slideLastHTML = "",
        i;

      //Grab First Slides
      for (i = 0; i < _this.loopedSlides; i++) {
        slideFirstHTML += _this.slides[i].outerHTML;
      }
      //Grab Last Slides
      for (
        i = _this.slides.length - _this.loopedSlides;
        i < _this.slides.length;
        i++
      ) {
        slideLastHTML += _this.slides[i].outerHTML;
      }
      wrapper.innerHTML = slideLastHTML + wrapper.innerHTML + slideFirstHTML;

      _this.loopCreated = true;
      _this.calcSlides();

      //Update Looped Slides with special class
      for (i = 0; i < _this.slides.length; i++) {
        if (
          i < _this.loopedSlides ||
          i >= _this.slides.length - _this.loopedSlides
        )
          _this.slides[i].setData("looped", true);
      }
      _this.callPlugins("onCreateLoop");
    };

    _this.fixLoop = function () {
      if (_this.params.loop == true) {
        var newIndex;
        //Fix For Negative Oversliding
        if (_this.activeIndex < _this.loopedSlides) {
          newIndex =
            _this.slides.length - _this.loopedSlides * 3 + _this.activeIndex;
          _this.swipeTo(newIndex, 0, false);
        }
        //Fix For Positive Oversliding
        else if (
          _this.activeIndex >
          _this.slides.length - params.slidesPerView * 2
        ) {
          newIndex =
            -_this.slides.length + _this.activeIndex + _this.loopedSlides;
          _this.swipeTo(newIndex, 0, false);
        }
      }
    };

    /*==================================================
        Slides Loader
    ====================================================*/
    _this.loadSlides = function () {
      var slidesHTML = "";
      _this.activeLoaderIndex = 0;
      var slides = params.loader.slides;
      var slidesToLoad = params.loader.loadAllSlides
        ? slides.length
        : params.slidesPerView * (1 + params.loader.surroundGroups);
      for (var i = 0; i < slidesToLoad; i++) {
        if (params.loader.slidesHTMLType == "outer") slidesHTML += slides[i];
        else {
          slidesHTML +=
            "<" +
            params.slideElement +
            ' class="' +
            params.slideClass +
            '" data-swiperindex="' +
            i +
            '">' +
            slides[i] +
            "</" +
            params.slideElement +
            ">";
        }
      }
      _this.wrapper.innerHTML = slidesHTML;
      _this.calcSlides(true);
      //Add permanent transitionEnd callback
      if (!params.loader.loadAllSlides) {
        _this.wrapperTransitionEnd(_this.reloadSlides, true);
      }
    };

    _this.reloadSlides = function () {
      var slides = params.loader.slides;
      var newActiveIndex = parseInt(
        _this.activeSlide().data("swiperindex"),
        10
      );
      if (newActiveIndex < 0 || newActiveIndex > slides.length - 1) return; //<-- Exit
      _this.activeLoaderIndex = newActiveIndex;
      var firstIndex = Math.max(
        0,
        newActiveIndex - params.slidesPerView * params.loader.surroundGroups
      );
      var lastIndex = Math.min(
        newActiveIndex +
          params.slidesPerView * (1 + params.loader.surroundGroups) -
          1,
        slides.length - 1
      );
      //Update Transforms
      if (newActiveIndex > 0) {
        var newTransform = -slideSize * (newActiveIndex - firstIndex);
        _this.setWrapperTranslate(newTransform);
        _this.setWrapperTransition(0);
      }
      //New Slides
      if (params.loader.logic === "reload") {
        _this.wrapper.innerHTML = "";
        var slidesHTML = "";
        for (var i = firstIndex; i <= lastIndex; i++) {
          slidesHTML +=
            params.loader.slidesHTMLType == "outer"
              ? slides[i]
              : "<" +
                params.slideElement +
                ' class="' +
                params.slideClass +
                '" data-swiperindex="' +
                i +
                '">' +
                slides[i] +
                "</" +
                params.slideElement +
                ">";
        }
        _this.wrapper.innerHTML = slidesHTML;
      } else {
        var minExistIndex = 1000;
        var maxExistIndex = 0;
        for (var i = 0; i < _this.slides.length; i++) {
          var index = _this.slides[i].data("swiperindex");
          if (index < firstIndex || index > lastIndex) {
            _this.wrapper.removeChild(_this.slides[i]);
          } else {
            minExistIndex = Math.min(index, minExistIndex);
            maxExistIndex = Math.max(index, maxExistIndex);
          }
        }
        for (var i = firstIndex; i <= lastIndex; i++) {
          if (i < minExistIndex) {
            var newSlide = document.createElement(params.slideElement);
            newSlide.className = params.slideClass;
            newSlide.setAttribute("data-swiperindex", i);
            newSlide.innerHTML = slides[i];
            _this.wrapper.insertBefore(newSlide, _this.wrapper.firstChild);
          }
          if (i > maxExistIndex) {
            var newSlide = document.createElement(params.slideElement);
            newSlide.className = params.slideClass;
            newSlide.setAttribute("data-swiperindex", i);
            newSlide.innerHTML = slides[i];
            _this.wrapper.appendChild(newSlide);
          }
        }
      }
      //reInit
      _this.reInit(true);
    };

    /*==================================================
        Make Swiper
    ====================================================*/
    function makeSwiper() {
      _this.calcSlides();
      if (params.loader.slides.length > 0 && _this.slides.length == 0) {
        _this.loadSlides();
      }
      if (params.loop) {
        _this.createLoop();
      }
      _this.init();
      initEvents();
      if (params.pagination && params.createPagination) {
        _this.createPagination(true);
      }
      if (params.loop || params.initialSlide > 0) {
        _this.swipeTo(params.initialSlide, 0, false);
      } else {
        _this.updateActiveSlide(0);
      }
      if (params.autoplay) {
        _this.startAutoplay();
      }
    }

    makeSwiper();
  };

  Swiper.prototype = {
    plugins: {},

    /*==================================================
        Wrapper Operations
    ====================================================*/
    wrapperTransitionEnd: function (callback, permanent) {
      var a = this,
        el = a.wrapper,
        events = [
          "webkitTransitionEnd",
          "transitionend",
          "oTransitionEnd",
          "MSTransitionEnd",
          "msTransitionEnd",
        ],
        i;

      function fireCallBack() {
        callback(a);
        if (a.params.queueEndCallbacks) a._queueEndCallbacks = false;
        if (!permanent) {
          for (i = 0; i < events.length; i++) {
            a.h.removeEventListener(el, events[i], fireCallBack);
          }
        }
      }

      if (callback) {
        for (i = 0; i < events.length; i++) {
          a.h.addEventListener(el, events[i], fireCallBack);
        }
      }
    },

    getWrapperTranslate: function (axis) {
      var el = this.wrapper,
        matrix,
        curTransform,
        curStyle,
        transformMatrix;

      // automatic axis detection
      if (typeof axis == "undefined") {
        axis = this.params.mode == "horizontal" ? "x" : "y";
      }

      curStyle = window.getComputedStyle(el, null);

      if (window.WebKitCSSMatrix) {
        transformMatrix = new WebKitCSSMatrix(curStyle.webkitTransform);
      } else {
        transformMatrix =
          curStyle.MozTransform ||
          curStyle.OTransform ||
          curStyle.MsTransform ||
          curStyle.msTransform ||
          curStyle.transform ||
          curStyle
            .getPropertyValue("transform")
            .replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
      }

      if (this.support.transforms && this.params.useCSS3Transforms) {
        if (axis == "x") {
          //Latest Chrome and webkits Fix
          if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41;
          //Crazy IE10 Matrix
          else if (matrix.length == 16) curTransform = parseFloat(matrix[12]);
          //Normal Browsers
          else curTransform = parseFloat(matrix[4]);
        }
        if (axis == "y") {
          //Latest Chrome and webkits Fix
          if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42;
          //Crazy IE10 Matrix
          else if (matrix.length == 16) curTransform = parseFloat(matrix[13]);
          //Normal Browsers
          else curTransform = parseFloat(matrix[5]);
        }
      } else {
        if (axis == "x") curTransform = parseFloat(el.style.left, 10) || 0;
        if (axis == "y") curTransform = parseFloat(el.style.top, 10) || 0;
      }
      return curTransform || 0;
    },

    setWrapperTranslate: function (x, y, z) {
      var es = this.wrapper.style,
        coords = { x: 0, y: 0, z: 0 },
        translate;

      // passed all coordinates
      if (arguments.length == 3) {
        coords.x = x;
        coords.y = y;
        coords.z = z;
      }

      // passed one coordinate and optional axis
      else {
        if (typeof y == "undefined") {
          y = this.params.mode == "horizontal" ? "x" : "y";
        }
        coords[y] = x;
      }

      if (this.support.transforms && this.params.useCSS3Transforms) {
        translate = this.support.transforms3d
          ? "translate3d(" +
            coords.x +
            "px, " +
            coords.y +
            "px, " +
            coords.z +
            "px)"
          : "translate(" + coords.x + "px, " + coords.y + "px)";
        es.webkitTransform =
          es.MsTransform =
          es.msTransform =
          es.MozTransform =
          es.OTransform =
          es.transform =
            translate;
      } else {
        es.left = coords.x + "px";
        es.top = coords.y + "px";
      }
      this.callPlugins("onSetWrapperTransform", coords);
      if (this.params.onSetWrapperTransform)
        this.fireCallback(this.params.onSetWrapperTransform, this, coords);
    },

    setWrapperTransition: function (duration) {
      var es = this.wrapper.style;
      es.webkitTransitionDuration =
        es.MsTransitionDuration =
        es.msTransitionDuration =
        es.MozTransitionDuration =
        es.OTransitionDuration =
        es.transitionDuration =
          duration / 1000 + "s";
      this.callPlugins("onSetWrapperTransition", { duration: duration });
      if (this.params.onSetWrapperTransition)
        this.fireCallback(this.params.onSetWrapperTransition, this, duration);
    },

    /*==================================================
        Helpers
    ====================================================*/
    h: {
      getWidth: function (el, outer) {
        var width = window.getComputedStyle(el, null).getPropertyValue("width");
        var returnWidth = parseFloat(width);
        //IE Fixes
        if (isNaN(returnWidth) || width.indexOf("%") > 0) {
          returnWidth =
            el.offsetWidth -
            parseFloat(
              window.getComputedStyle(el, null).getPropertyValue("padding-left")
            ) -
            parseFloat(
              window
                .getComputedStyle(el, null)
                .getPropertyValue("padding-right")
            );
        }
        if (outer)
          returnWidth +=
            parseFloat(
              window.getComputedStyle(el, null).getPropertyValue("padding-left")
            ) +
            parseFloat(
              window
                .getComputedStyle(el, null)
                .getPropertyValue("padding-right")
            );

        return returnWidth;
      },
      getHeight: function (el, outer) {
        if (outer) return el.offsetHeight;

        var height = window
          .getComputedStyle(el, null)
          .getPropertyValue("height");
        var returnHeight = parseFloat(height);
        //IE Fixes
        if (isNaN(returnHeight) || height.indexOf("%") > 0) {
          returnHeight =
            el.offsetHeight -
            parseFloat(
              window.getComputedStyle(el, null).getPropertyValue("padding-top")
            ) -
            parseFloat(
              window
                .getComputedStyle(el, null)
                .getPropertyValue("padding-bottom")
            );
        }
        if (outer)
          returnHeight +=
            parseFloat(
              window.getComputedStyle(el, null).getPropertyValue("padding-top")
            ) +
            parseFloat(
              window
                .getComputedStyle(el, null)
                .getPropertyValue("padding-bottom")
            );
        return returnHeight;
      },
      getOffset: function (el) {
        var box = el.getBoundingClientRect();
        var body = document.body;
        var clientTop = el.clientTop || body.clientTop || 0;
        var clientLeft = el.clientLeft || body.clientLeft || 0;
        var scrollTop = window.pageYOffset || el.scrollTop;
        var scrollLeft = window.pageXOffset || el.scrollLeft;
        if (document.documentElement && !window.pageYOffset) {
          //IE7-8
          scrollTop = document.documentElement.scrollTop;
          scrollLeft = document.documentElement.scrollLeft;
        }
        return {
          top: box.top + scrollTop - clientTop,
          left: box.left + scrollLeft - clientLeft,
        };
      },
      windowWidth: function () {
        if (window.innerWidth) return window.innerWidth;
        else if (
          document.documentElement &&
          document.documentElement.clientWidth
        )
          return document.documentElement.clientWidth;
      },
      windowHeight: function () {
        if (window.innerHeight) return window.innerHeight;
        else if (
          document.documentElement &&
          document.documentElement.clientHeight
        )
          return document.documentElement.clientHeight;
      },
      windowScroll: function () {
        var left = 0,
          top = 0;
        if (typeof pageYOffset != "undefined") {
          return {
            left: window.pageXOffset,
            top: window.pageYOffset,
          };
        } else if (document.documentElement) {
          return {
            left: document.documentElement.scrollLeft,
            top: document.documentElement.scrollTop,
          };
        }
      },

      addEventListener: function (el, event, listener, useCapture) {
        if (typeof useCapture == "undefined") {
          useCapture = false;
        }

        if (el.addEventListener) {
          el.addEventListener(event, listener, useCapture);
        } else if (el.attachEvent) {
          el.attachEvent("on" + event, listener);
        }
      },

      removeEventListener: function (el, event, listener, useCapture) {
        if (typeof useCapture == "undefined") {
          useCapture = false;
        }

        if (el.removeEventListener) {
          el.removeEventListener(event, listener, useCapture);
        } else if (el.detachEvent) {
          el.detachEvent("on" + event, listener);
        }
      },
    },
    setTransform: function (el, transform) {
      var es = el.style;
      es.webkitTransform =
        es.MsTransform =
        es.msTransform =
        es.MozTransform =
        es.OTransform =
        es.transform =
          transform;
    },
    setTranslate: function (el, translate) {
      var es = el.style;
      var pos = {
        x: translate.x || 0,
        y: translate.y || 0,
        z: translate.z || 0,
      };
      var transformString = this.support.transforms3d
        ? "translate3d(" + pos.x + "px," + pos.y + "px," + pos.z + "px)"
        : "translate(" + pos.x + "px," + pos.y + "px)";
      es.webkitTransform =
        es.MsTransform =
        es.msTransform =
        es.MozTransform =
        es.OTransform =
        es.transform =
          transformString;
      if (!this.support.transforms) {
        es.left = pos.x + "px";
        es.top = pos.y + "px";
      }
    },
    setTransition: function (el, duration) {
      var es = el.style;
      es.webkitTransitionDuration =
        es.MsTransitionDuration =
        es.msTransitionDuration =
        es.MozTransitionDuration =
        es.OTransitionDuration =
        es.transitionDuration =
          duration + "ms";
    },
    /*==================================================
        Feature Detection
    ====================================================*/
    support: {
      touch:
        (window.Modernizr && Modernizr.touch === true) ||
        (function () {
          return !!(
            "ontouchstart" in window ||
            (window.DocumentTouch && document instanceof DocumentTouch)
          );
        })(),

      transforms3d:
        (window.Modernizr && Modernizr.csstransforms3d === true) ||
        (function () {
          var div = document.createElement("div").style;
          return (
            "webkitPerspective" in div ||
            "MozPerspective" in div ||
            "OPerspective" in div ||
            "MsPerspective" in div ||
            "perspective" in div
          );
        })(),

      transforms:
        (window.Modernizr && Modernizr.csstransforms === true) ||
        (function () {
          var div = document.createElement("div").style;
          return (
            "transform" in div ||
            "WebkitTransform" in div ||
            "MozTransform" in div ||
            "msTransform" in div ||
            "MsTransform" in div ||
            "OTransform" in div
          );
        })(),

      transitions:
        (window.Modernizr && Modernizr.csstransitions === true) ||
        (function () {
          var div = document.createElement("div").style;
          return (
            "transition" in div ||
            "WebkitTransition" in div ||
            "MozTransition" in div ||
            "msTransition" in div ||
            "MsTransition" in div ||
            "OTransition" in div
          );
        })(),
    },

    browser: {
      ie8: (function () {
        var rv = -1; // Return value assumes failure.
        if (navigator.appName == "Microsoft Internet Explorer") {
          var ua = navigator.userAgent;
          var re = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");
          if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
        }
        return rv != -1 && rv < 9;
      })(),

      ie10: window.navigator.msPointerEnabled,
    },
  };

  /*=========================
  jQuery & Zepto Plugins
  ===========================*/
  if (window.jQuery || window.Zepto) {
    (function ($) {
      if (!jQuery().swiper) {
        $.fn.swiper = function (params) {
          var s = new Swiper($(this)[0], params);
          $(this).data("swiper", s);
          return s;
        };
      }
    })(window.jQuery || window.Zepto);
  }

  // component
  if (typeof module !== "undefined") {
    module.exports = Swiper;
  }
}

/*
 * Swiper Smooth Progress 1.1.0
 * Smooth progress plugin for Swiper
 *
 * http://www.idangero.us/sliders/swiper/plugins/progress.php
 *
 * Copyright 2010-2014, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 *
 * Licensed under GPL & MIT
 *
 * Released on: January 29, 2014
 */
Swiper.prototype.plugins.progress = function (a) {
  function b() {
    for (var b = 0; b < a.slides.length; b++) {
      var c = a.slides[b];
      (c.progressSlideSize = e ? a.h.getWidth(c) : a.h.getHeight(c)),
        (c.progressSlideOffset =
          "offsetLeft" in c
            ? e
              ? c.offsetLeft
              : c.offsetTop
            : e
            ? c.getOffset().left - a.h.getOffset(a.container).left
            : c.getOffset().top - a.h.getOffset(a.container).top);
    }
    d = e
      ? a.h.getWidth(a.wrapper) + a.wrapperLeft + a.wrapperRight - a.width
      : a.h.getHeight(a.wrapper) + a.wrapperTop + a.wrapperBottom - a.height;
  }
  function c(b) {
    var c,
      b = b || { x: 0, y: 0, z: 0 };
    c =
      1 == a.params.centeredSlides
        ? e
          ? -b.x + a.width / 2
          : -b.y + a.height / 2
        : e
        ? -b.x
        : -b.y;
    for (var f = 0; f < a.slides.length; f++) {
      var g = a.slides[f],
        h = 1 == a.params.centeredSlides ? g.progressSlideSize / 2 : 0,
        i = (c - g.progressSlideOffset - h) / g.progressSlideSize;
      g.progress = i;
    }
    (a.progress = e ? -b.x / d : -b.y / d),
      a.params.onProgressChange && a.fireCallback(a.params.onProgressChange, a);
  }
  var d,
    e = "horizontal" == a.params.mode,
    f = {
      onFirstInit: function () {
        b(),
          c({ x: a.getWrapperTranslate("x"), y: a.getWrapperTranslate("y") });
      },
      onInit: function () {
        b();
      },
      onSetWrapperTransform: function (a) {
        c(a);
      },
    };
  return f;
};

jQuery(document).ready(function ($) {
  Array.prototype.getKeyByValue = function (value) {
    for (var prop in this) {
      if (this.hasOwnProperty(prop)) {
        if (this[prop] === value) return prop;
      }
    }
  };

  var doneVideoInit = false;
  var $captionTrans = 0;
  var $loading_bg_storage = $(".first-section .nectar-slider-loading").css(
    "background-image"
  );

  function transparentheaderLoadingCalcs() {
    //handle slider loading pos when trasparent header is being used
    if ($('body #header-outer[data-transparent-header="true"]').length > 0) {
      if ($("#page-header-bg").length == 0) {
        $(
          ".nectar-slider-wrap.first-section .swiper-container .swiper-wrapper .swiper-slide"
        ).addClass("not-loaded");

        if (
          $(".container-wrap .main-content > .row > div").find(
            ".nectar-slider-wrap.first-section"
          ).length > 0
        ) {
          $(".container-wrap .main-content > .row > div")
            .first()
            .css("padding-top", "0");
        }

        $(
          'body #header-outer[data-transparent-header="true"] .ns-loading-cover'
        ).show();

        if ($('#header-outer[data-remove-border="true"]').length == 0) {
          //if not using flexible/fullscreen height - calculate the loading / bg pos early (if using the option calculates later)
          if (
            $('.first-section .nectar-slider-wrap[data-flexible-height="true"]')
              .length == 0 &&
            $('.first-section .nectar-slider-wrap[data-fullscreen="true"]')
              .length == 0
          ) {
            $(".first-section .nectar-slider-loading").css({
              top: $("#header-space").height(),
              "background-position":
                "center " +
                ($(".first-section .swiper-container").height() / 2 +
                  15 -
                  $("#header-space").height()) +
                "px",
            });

            $(
              ".first-section .nectar-slider-wrap .nectar-slider-loading .loading-icon"
            ).css({
              opacity: "1",
              height:
                $(".first-section .swiper-container").height() -
                $("#header-space").height() +
                "px",
            });
          } else {
            var $loading_bg_storage = $(
              ".first-section .nectar-slider-loading"
            ).css("background-image");

            $(".first-section .nectar-slider-loading").css({
              top: $("#header-space").height(),
              "background-image": "none",
            });
          }
        }
      }
    }
  }
  transparentheaderLoadingCalcs();

  //move parallax sliders to correct dom location
  var parallaxSlider = $(".parallax_slider_outer.first-section");

  //ajaxify
  $(window).on("pronto.request", function () {
    //remove window resize events
    $(window).off("resize.nsSliderContent");
    $(window).off("resize.dynamicHeights");
    $(window).off("resize.nsHeightUpdate");

    //clear all autoplay intervals
    $(".nectar-slider-wrap").each(function () {
      if (
        $(this).attr("data-autorotate") &&
        $(this).attr("data-autorotate").length > 1
      ) {
        var $autoplayVal = $("#" + $(this).attr("id")).attr("data-autorotate");
        if (
          typeof $autoplayVal != "undefined" &&
          $autoplayVal.length != "0" &&
          parseInt($autoplayVal)
        ) {
          clearInterval(
            autoplay[$("#" + $(this).attr("id")).attr("autoplay-id")]
          );
        }
      }
    });
  });

  $(window).on("pronto.render", function () {
    if ($(".nectar-slider-wrap").length > 0) {
      $(window).on("resize.nsSliderContent", nsSliderContentResize);

      parallaxSlider = $(".parallax_slider_outer.first-section");
      $(window).unbind("resize.nsHeightUpdate");

      transparentheaderLoadingCalcs();

      ////remove parallax if using page header on projects/posts
      if ($("body.single #page-header-bg").length > 0)
        $(".parallax_slider_outer")
          .removeClass("parallax_slider_outer")
          .addClass("no-left-margin");
      parallaxSliderPos();

      nectarSliderMainInit();
      setTimeout(function () {
        initialSlideLoad();
        dynamicHeightSliders();
        $(window).on("resize.dynamicHeights", dynamicHeightSliders);
        sliderSize();
        resizeToCover();
        parallaxCheck();
        sliderbuttonHoverEffect();
      }, 150);
    }
  }); //pronto render

  function parallaxSliderPos() {
    if (parallaxSlider.parent().attr("class") == "wpb_wrapper") {
      //give the slider the custom row ID if assigned
      if (parallaxSlider.parents(".wpb_row").length > 0) {
        if (parallaxSlider.parents(".wpb_row").not('[id^="fws_"]').length > 0)
          parallaxSlider.attr(
            "id",
            parallaxSlider.parents(".wpb_row").attr("id")
          );
      }
      //remove the row
      parallaxSlider.parents(".wpb_row").remove();
    }
    //alter the DOM pos
    parallaxSlider.insertBefore(".container-wrap");
  }

  ////remove parallax if using page header on projects/posts
  if ($("body.single #page-header-bg").length > 0)
    $(".parallax_slider_outer")
      .removeClass("parallax_slider_outer")
      .addClass("no-left-margin");

  parallaxSliderPos();

  //initial cals
  var $smoothSrollWidth =
    $("body").attr("data-smooth-scrolling") == "1" ? 0 : 0;

  /*=========================
     Begin Nectar Slider Main Construction
     ===========================*/
  var $nectarSliders = [];

  function nectarSliderMainInit() {
    $nectarSliders = [];

    //remove boxed full width attr when not needed
    $('.nectar-slider-wrap[data-full-width="boxed-full-width"]').each(
      function () {
        if (
          $(this).parents(".wpb_column").length > 0 &&
          $(this).parents(".full-width-content").length > 0
        )
          $(this).attr("data-full-width", "false");
      }
    );
    var $leftHeaderSize =
      $('#header-outer[data-format="left-header"]').length > 0 &&
      window.innerWidth >= 1000
        ? parseInt($('#header-outer[data-format="left-header"]').width())
        : 0;
    var $windowWidth = $(window).width() - $leftHeaderSize;

    if (
      $("body > #boxed").length == 0 &&
      $('.nectar-slider-wrap[data-full-width="true"]').parent().attr("id") !=
        "portfolio-extra" &&
      $('.nectar-slider-wrap[data-full-width="true"]').parents(
        '#post-area:not(".span_12")'
      ).length == 0
    ) {
      $(
        '.nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .nectar-slider-wrap'
      ).css(
        "left",
        -(
          ($windowWidth - $smoothSrollWidth) / 2 -
          $(".main-content").width() / 2
        )
      ) + "px";
      $(
        '.nectar-slider-wrap[data-full-width="true"] .swiper-container, .nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .swiper-container, .parallax_slider_outer.first-section .nectar-slider-wrap'
      ).css("width", $windowWidth);
    } else if (
      $('.nectar-slider-wrap[data-full-width="true"]').parent().attr("id") ==
        "portfolio-extra" &&
      $("#full_width_portfolio").length != 0
    ) {
      $(
        '.nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .nectar-slider-wrap'
      ).css(
        "left",
        -(
          ($windowWidth - $smoothSrollWidth) / 2 -
          $(".main-content").width() / 2
        )
      ) + "px";
      $(
        '.nectar-slider-wrap[data-full-width="true"] .swiper-container, .nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .swiper-container, .parallax_slider_outer.first-section .nectar-slider-wrap'
      ).css("width", $windowWidth);
    } else {
      var $container =
        $("body > #boxed").length == 0 ? "#post-area" : ".container-wrap";
      //backup incase only slider is used with nothing else in boxed mode
      if ($($container).width() == "0" && $("body > #boxed").length > 0)
        $container = "#boxed";
      $(
        '.nectar-slider-wrap[data-full-width="true"] .swiper-container, .nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .swiper-container, .parallax_slider_outer.first-section .nectar-slider-wrap'
      ).css("width", $($container).width());
    }

    //show slider once full width calcs have taken place
    $(".nectar-slider-wrap").show();

    //set bg colors / textures after js has made the slider fullwidth
    $(".swiper-container, .swiper-slide").css("background-color", "#000");
    $(".video-texture").css("opacity", "1");

    $(".nectar-slider-wrap").each(function (i) {
      var $arrows = $(this).find(".swiper-container").attr("data-arrows");
      var $bullets = $(this).find(".swiper-container").attr("data-bullets");
      var $swipe = $(this).find(".swiper-container").attr("data-desktop-swipe");
      var $loop = $(this).find(".swiper-container").attr("data-loop");

      //swipe
      if (
        $swipe == "true" &&
        $("#" + $(this).attr("id") + " .swiper-wrapper > div").length > 1 &&
        $(this).attr("data-overall_style") != "directional"
      ) {
        var $grab = 1;
        var $desktopSwipe = 1;
      } else {
        var $grab = 0;
        var $desktopSwipe = 0;
      }

      ////set swipe as true for mobile
      if (
        $("body").hasClass("mobile") &&
        $(this).attr("data-overall_style") != "directional"
      )
        $desktopSwipe = 1;

      //bullets
      if (
        $bullets == "true" &&
        $(this).find(".swiper-wrapper > div").length > 1 &&
        $(this).attr("data-overall_style") != "directional"
      ) {
        $bullets = "#" + $(this).attr("id") + " .slider-pagination";
      } else {
        $bullets = null;
      }

      //loop
      $useLoop =
        ($loop == "true" &&
          $(this).find(".swiper-wrapper > div").length > 1 &&
          !$("html").hasClass("no-video")) ||
        ($(this).attr("data-overall_style") == "directional" &&
          $(this).find(".swiper-wrapper > div").length > 1 &&
          !$("html").hasClass("no-video"))
          ? true
          : false;
      if ($useLoop == false)
        $(this).find(".swiper-container").attr("data-loop", "false");

      //obj config

      if (
        $(this).attr("data-transition") == "fade" &&
        $(this).attr("data-overall_style") != "directional" &&
        $(this).attr("data-button-styling") != "btn_with_preview"
      ) {
        var progressVar = true;
        var touchRatio = 1.3;

        $sliderOptions = {
          loop: $useLoop,
          grabCursor: $grab,
          touchRatio: touchRatio,
          speed: 900,
          pagination: $bullets,
          simulateTouch: $desktopSwipe,
          onSlideChangeEnd: captionTransition,
          onTouchEnd: captionTransition,
          onSlideChangeStart: onChangeStart,
          onTouchMove: clearAutoplay,
          onFirstInit: nectarInit,
          progress: progressVar,
          onProgressChange: function (swiper) {
            if (
              $(swiper.container)
                .parents(".nectar-slider-wrap")
                .hasClass("loaded")
            ) {
              for (var i = 0; i < swiper.slides.length; i++) {
                var slide = swiper.slides[i];
                var progress = slide.progress;
                var translate = progress * swiper.width;
                var opacity = 1 - Math.min(Math.abs(progress), 1);
                slide.style.opacity = opacity;
                swiper.setTransform(
                  slide,
                  "translate3d(" + translate + "px,0,0)"
                );
              }
            }
          },
          onTouchStart: function (swiper) {
            for (var i = 0; i < swiper.slides.length; i++) {
              swiper.setTransition(swiper.slides[i], 0);
            }
          },
          onSetWrapperTransition: function (swiper, speed) {
            for (var i = 0; i < swiper.slides.length; i++) {
              swiper.setTransition(swiper.slides[i], speed);
            }
          },
        };
      } else {
        var touchRatio = 0.6;
        var css3Trans =
          $(
            "#" +
              $(this).attr("id") +
              '.nectar-slider-wrap[data-overall_style="directional"]'
          ).length == 1
            ? false
            : true;
        $sliderOptions = {
          loop: $useLoop,
          grabCursor: $grab,
          touchRatio: touchRatio,
          speed: 550,
          useCSS3Transforms: css3Trans,
          pagination: $bullets,
          simulateTouch: $desktopSwipe,
          onSlideChangeEnd: captionTransition,
          onSlideChangeStart: onChangeStart,
          onTouchMove: clearAutoplay,
          onFirstInit: nectarInit,
        };
      }

      $nectarSliders[i] = new Swiper(
        "#" + $(this).attr("id") + " .swiper-container",
        $sliderOptions
      );
      $nectarSliders[i].swipeReset();

      //webkit looped slider first video fix
      if (
        navigator.userAgent.indexOf("Chrome") > 0 &&
        !/Edge\/12./i.test(navigator.userAgent) &&
        !/Edge\/\d./i.test(navigator.userAgent)
      ) {
        if (
          jQuery(this).find(
            '.swiper-slide:nth-child(2) video source[type="video/webm"]'
          ).length > 0 &&
          jQuery(this).find(".swiper-container").attr("data-loop") == "true"
        ) {
          var webmSource =
            jQuery(this)
              .find(
                '.swiper-slide:nth-child(2) video source[type="video/webm"]'
              )
              .attr("src") +
            "?id=" +
            Math.ceil(Math.random() * 10000);
          var firstVideo = jQuery(this)
            .find(".swiper-slide:nth-child(2) video")
            .get(0);
          firstVideo.src = webmSource;
          firstVideo.load();

          var webmSource2 =
            jQuery(this)
              .find('.swiper-slide:last-child video source[type="video/webm"]')
              .attr("src") +
            "?id=" +
            Math.ceil(Math.random() * 10000);
          var lastVideo = jQuery(this)
            .find(".swiper-slide:last-child video")
            .get(0);
          lastVideo.src = webmSource2;
          lastVideo.load();
        }

        if (
          jQuery(this).find(
            '.swiper-slide:eq(-2) video source[type="video/webm"]'
          ).length > 0 &&
          jQuery(this).find(".swiper-container").attr("data-loop") == "true"
        ) {
          var webmSource =
            jQuery(this)
              .find('.swiper-slide:eq(-2) video source[type="video/webm"]')
              .attr("src") +
            "?id=" +
            Math.ceil(Math.random() * 10000);
          var firstVideo = jQuery(this)
            .find(".swiper-slide:eq(-2) video")
            .get(0);
          firstVideo.src = webmSource;
          firstVideo.load();

          var webmSource2 =
            jQuery(this)
              .find(
                '.swiper-slide:nth-child(1) video source[type="video/webm"]'
              )
              .attr("src") +
            "?id=" +
            Math.ceil(Math.random() * 10000);
          var lastVideo = jQuery(this)
            .find(".swiper-slide:nth-child(1) video")
            .get(0);
          lastVideo.src = webmSource2;
          lastVideo.load();
        }
      }

      //Navigation arrows

      ////default arrows
      if (
        $arrows == "true" &&
        $("#" + $(this).attr("id") + " .swiper-wrapper > div").length > 1 &&
        $(
          "#" +
            $(this).attr("id") +
            '.nectar-slider-wrap[data-button-styling="btn_with_preview"]'
        ).length == 0 &&
        $(
          "#" +
            $(this).attr("id") +
            '.nectar-slider-wrap[data-overall_style="directional"]'
        ).length == 0
      ) {
        $(".slide-count i").transition({ scale: 0.5, opacity: 0 });

        //hover event
        $("body").on(
          "mouseenter",
          '.nectar-slider-wrap[data-button-styling="btn_with_count"][data-overall_style="classic"]  .swiper-container .slider-prev, .nectar-slider-wrap[data-button-styling="btn_with_count"] .swiper-container .slider-next',
          function () {
            $(this)
              .find(".slide-count i")
              .clearQueue()
              .stop(true, true)
              .delay(110)
              .transition({ scale: 1, opacity: 1 }, 200);

            $(this).stop(true, true).animate(
              {
                width: "100px",
              },
              300,
              "easeOutCubic"
            );
            $(this)
              .find(".slide-count span")
              .clearQueue()
              .stop()
              .delay(100)
              .animate(
                {
                  opacity: "1",
                },
                225,
                "easeOutCubic"
              );
          }
        );

        $("body").on(
          "mouseleave",
          '.nectar-slider-wrap[data-button-styling="btn_with_count"][data-overall_style="classic"] .swiper-container .slider-prev, .nectar-slider-wrap[data-button-styling="btn_with_count"] .swiper-container .slider-next',
          function () {
            $(".slide-count i")
              .stop(true, true)
              .transition({ scale: 0, opacity: 0 }, 200);

            $(this).stop().delay(150).animate(
              {
                width: "50px",
              },
              300,
              "easeOutCubic"
            );
            $(this).find(".slide-count span").stop(true, true).animate(
              {
                opacity: "0",
              },
              200,
              "easeOutCubic"
            );
          }
        );

        //add slide counts
        var $slideCount =
          $(this).find(".swiper-container").attr("data-loop") != "true"
            ? $("#" + $(this).attr("id") + " .swiper-wrapper > div").length
            : $("#" + $(this).attr("id") + " .swiper-wrapper > div").length - 2;

        //ie8
        if ($("html").hasClass("no-video"))
          $slideCount = $(
            "#" + $(this).attr("id") + " .swiper-wrapper > div"
          ).length;

        $(
          "#" + $(this).attr("id") + " .slider-prev .slide-count .slide-total"
        ).html($slideCount);
        $(
          "#" + $(this).attr("id") + " .slider-next .slide-count .slide-total"
        ).html($slideCount);

        //prev

        function prevArrowAnimation(e) {
          if ($(this).hasClass("inactive")) return false;

          var $that = $(this);

          //non looped slider
          if (
            $(this).parents(".swiper-container").attr("data-loop") != "true"
          ) {
            if (
              $(this)
                .parents(".swiper-container")
                .find(".swiper-slide-active")
                .index() +
                1 ==
                1 &&
              !$("html").hasClass("no-video")
            ) {
              //make sure the animation is complete
              var $timeout;

              clearTimeout($timeout);
              $timeout = setTimeout(function () {
                $that.removeClass("inactive");
              }, 700);

              if (
                $(this)
                  .parents(".nectar-slider-wrap ")
                  .attr("data-transition") != "fade"
              ) {
                var $that = $(this);

                $(this)
                  .parents(".swiper-container")
                  .animate(
                    {
                      left: 25 + "px",
                    },
                    250,
                    function () {
                      //$(this).parents('.swiper-container').find('.swiper-wrapper').stop(true,false).css('transition','left,top');
                      //$nectarSliders[i].swipeReset();
                      $that
                        .parents(".swiper-container")
                        .stop()
                        .animate(
                          {
                            left: 0 + "px",
                          },
                          250
                        );
                    }
                  );
              }

              $(this).addClass("inactive");
            }
          }

          e.preventDefault();
          $nectarSliders[i].swipePrev();

          if (
            $(this).parents(".nectar-slider-wrap ").attr("data-transition") ==
            "fade"
          ) {
            var $timeout;

            clearTimeout($timeout);
            $timeout = setTimeout(function () {
              $that.removeClass("inactive");
            }, 800);

            $(this).addClass("inactive");
          }
        }

        $("body").off(
          "click",
          "#" + $(this).attr("id") + " .slider-prev",
          prevArrowAnimation
        );
        $("body").on(
          "click",
          "#" + $(this).attr("id") + " .slider-prev",
          prevArrowAnimation
        );

        function nextArrowAnimation(e) {
          if ($(this).hasClass("inactive")) return false;

          var $that = $(this);
          var $slideNum = $(this)
            .parents(".swiper-container")
            .find(".swiper-wrapper > div").length;

          //non looped slider
          if (
            $(this).parents(".swiper-container").attr("data-loop") != "true"
          ) {
            if (
              $(this)
                .parents(".swiper-container")
                .find(".swiper-slide-active")
                .index() +
                1 ==
                $slideNum &&
              !$("html").hasClass("no-video")
            ) {
              //make sure the animation is complete
              var $timeout;

              clearTimeout($timeout);
              $timeout = setTimeout(function () {
                $that.removeClass("inactive");
              }, 700);

              if (
                $(this)
                  .parents(".nectar-slider-wrap ")
                  .attr("data-transition") != "fade"
              ) {
                var $that = $(this);

                $(this)
                  .parents(".swiper-container")
                  .animate(
                    {
                      left: -25 + "px",
                    },
                    250,
                    function () {
                      $that
                        .parents(".swiper-container")
                        .stop()
                        .animate(
                          {
                            left: 0 + "px",
                          },
                          250
                        );
                    }
                  );
              }
              $(this).addClass("inactive");
            }
          }

          e.preventDefault();
          $nectarSliders[i].swipeNext();

          if (
            $(this).parents(".nectar-slider-wrap ").attr("data-transition") ==
            "fade"
          ) {
            var $timeout;

            clearTimeout($timeout);
            $timeout = setTimeout(function () {
              $that.removeClass("inactive");
            }, 800);

            $(this).addClass("inactive");
          }
        }

        //next
        $("body").off(
          "click",
          "#" + $(this).attr("id") + " .slider-next",
          nextArrowAnimation
        );
        $("body").on(
          "click",
          "#" + $(this).attr("id") + " .slider-next",
          nextArrowAnimation
        );
      }
      ////button with preview on hover
      else if (
        $arrows == "true" &&
        $("#" + $(this).attr("id") + " .swiper-wrapper > div").length > 1 &&
        $(
          "#" +
            $(this).attr("id") +
            '.nectar-slider-wrap[data-button-styling="btn_with_preview"]'
        ).length == 1 &&
        $(
          "#" +
            $(this).attr("id") +
            '.nectar-slider-wrap[data-overall_style="directional"]'
        ).length == 0
      ) {
        function prevArrowAnimationWithPreview(e) {
          if ($(this).hasClass("inactive")) return false;
          var $that = $(this);

          //make sure the animation is complete
          var $timeout;

          clearTimeout($timeout);
          $timeout = setTimeout(function () {
            $that.removeClass("inactive");
          }, 1000);

          var $timeout2;

          clearTimeout($timeout2);
          $timeout2 = setTimeout(function () {
            $that.removeClass("stophover");
          }, 500);

          $(this).addClass("inactive").addClass("stophover");

          $(this)
            .parents(".nectar-slider-wrap")
            .find(".swiper-slide-active")
            .prev(".swiper-slide")
            .removeClass("prev-high-z-index");
          $(this)
            .parents(".nectar-slider-wrap")
            .find(".swiper-slide-active")
            .stop()
            .removeClass("prev-move");

          e.preventDefault();
          $nectarSliders[i].swipePrev();
        }

        function nextArrowAnimationWithPreview(e) {
          if ($(this).hasClass("inactive")) return false;
          var $that = $(this);

          //make sure the animation is complete
          var $timeout;

          clearTimeout($timeout);
          $timeout = setTimeout(function () {
            $that.removeClass("inactive");
          }, 1000);

          var $timeout2;

          clearTimeout($timeout2);
          $timeout2 = setTimeout(function () {
            $that.removeClass("stophover");
          }, 500);

          $(this).addClass("inactive").addClass("stophover");

          $(this)
            .parents(".nectar-slider-wrap")
            .find(".swiper-slide-active")
            .next(".swiper-slide")
            .removeClass("high-z-index");
          $(this)
            .parents(".nectar-slider-wrap")
            .find(".swiper-slide-active")
            .stop()
            .removeClass("next-move");

          e.preventDefault();
          $nectarSliders[i].swipeNext();
        }

        function darkSlideNextMouseOver(currentSlider, activeIndex) {
          var $indexAdd =
            $(currentSlider).find(".swiper-container").attr("data-loop") ==
            "true"
              ? 2
              : 2;

          if (
            $(currentSlider)
              .find(".swiper-slide:nth-child(" + (activeIndex + 1) + ")")
              .attr("data-color-scheme") == "dark"
          ) {
            if (
              $(currentSlider)
                .find(
                  ".swiper-slide:nth-child(" + (activeIndex + $indexAdd) + ")"
                )
                .attr("data-color-scheme") == "dark"
            ) {
              $(currentSlider)
                .find(
                  ".swiper-slide:nth-child(" +
                    (activeIndex + $indexAdd) +
                    ") .video-texture"
                )
                .addClass("half-light-overlay")
                .addClass("no-trans");
            } else {
              $(currentSlider)
                .find(
                  ".swiper-slide:nth-child(" +
                    (activeIndex + $indexAdd) +
                    ") .video-texture"
                )
                .addClass("light-overlay")
                .addClass("no-trans");
            }
          } else {
            if (
              $(currentSlider)
                .find(
                  ".swiper-slide:nth-child(" + (activeIndex + $indexAdd) + ")"
                )
                .attr("data-color-scheme") == "light"
            ) {
              $(currentSlider)
                .find(
                  ".swiper-slide:nth-child(" +
                    (activeIndex + $indexAdd) +
                    ") .video-texture"
                )
                .addClass("half-dark-overlay")
                .addClass("no-trans");
            } else {
              $(currentSlider)
                .find(
                  ".swiper-slide:nth-child(" +
                    (activeIndex + $indexAdd) +
                    ") .video-texture"
                )
                .addClass("dark-overlay")
                .addClass("no-trans");
            }
          }
        }
        function darkSlidePrevMouseOver(currentSlider, activeIndex) {
          var $indexAdd =
            $(currentSlider).find(".swiper-container").attr("data-loop") ==
            "true"
              ? 0
              : 0;

          if (
            $(currentSlider)
              .find(".swiper-slide:nth-child(" + (activeIndex + 1) + ")")
              .attr("data-color-scheme") == "dark"
          ) {
            if (
              $(currentSlider)
                .find(
                  ".swiper-slide:nth-child(" + (activeIndex - $indexAdd) + ")"
                )
                .attr("data-color-scheme") == "dark"
            ) {
              $(currentSlider)
                .find(
                  ".swiper-slide:nth-child(" +
                    (activeIndex - $indexAdd) +
                    ") .video-texture"
                )
                .addClass("half-light-overlay")
                .addClass("no-trans");
            } else {
              $(currentSlider)
                .find(
                  ".swiper-slide:nth-child(" +
                    (activeIndex - $indexAdd) +
                    ") .video-texture"
                )
                .addClass("light-overlay")
                .addClass("no-trans");
            }
          } else {
            if (
              $(currentSlider)
                .find(
                  ".swiper-slide:nth-child(" + (activeIndex - $indexAdd) + ")"
                )
                .attr("data-color-scheme") == "light"
            ) {
              $(currentSlider)
                .find(
                  ".swiper-slide:nth-child(" +
                    (activeIndex - $indexAdd) +
                    ") .video-texture"
                )
                .addClass("half-dark-overlay")
                .addClass("no-trans");
            } else {
              $(currentSlider)
                .find(
                  ".swiper-slide:nth-child(" +
                    (activeIndex - $indexAdd) +
                    ") .video-texture"
                )
                .addClass("dark-overlay")
                .addClass("no-trans");
            }
          }
        }

        $("body").off(
          "click",
          "#" + $(this).attr("id") + " .slider-prev",
          prevArrowAnimationWithPreview
        );
        $("body").on(
          "click",
          "#" + $(this).attr("id") + " .slider-prev",
          prevArrowAnimationWithPreview
        );

        //next
        $("body").off(
          "click",
          "#" + $(this).attr("id") + " .slider-next",
          nextArrowAnimationWithPreview
        );
        $("body").on(
          "click",
          "#" + $(this).attr("id") + " .slider-next",
          nextArrowAnimationWithPreview
        );

        //hover event
        $("body").on(
          "mouseenter",
          '.nectar-slider-wrap[data-button-styling="btn_with_preview"] .swiper-container .slider-next:not(.stophover)',
          function () {
            $(this)
              .parents(".nectar-slider-wrap")
              .find(".swiper-slide-active")
              .next(".swiper-slide")
              .addClass("high-z-index");
            $(this)
              .parents(".nectar-slider-wrap")
              .find(".swiper-slide-active")
              .stop()
              .addClass("next-move");
            $(this).stop().addClass("next-arrow-move");
            darkSlideNextMouseOver(
              $(this).parents(".nectar-slider-wrap"),
              $(this)
                .parents(".nectar-slider-wrap")
                .find(".swiper-slide-active")
                .index()
            );
          }
        );

        $("body").on(
          "mouseleave",
          '.nectar-slider-wrap[data-button-styling="btn_with_preview"] .swiper-container .slider-next',
          function () {
            $(this)
              .parents(".nectar-slider-wrap")
              .find(".swiper-slide-active")
              .next(".swiper-slide")
              .removeClass("high-z-index");
            $(this)
              .parents(".nectar-slider-wrap")
              .find(".swiper-slide-active")
              .stop()
              .removeClass("next-move");
            $(this).stop().removeClass("next-arrow-move");
          }
        );

        $("body").on(
          "mouseenter",
          '.nectar-slider-wrap[data-button-styling="btn_with_preview"] .swiper-container .slider-prev:not(.stophover)',
          function () {
            $(this)
              .parents(".nectar-slider-wrap")
              .find(".swiper-slide-active")
              .prev(".swiper-slide")
              .addClass("prev-high-z-index");
            $(this)
              .parents(".nectar-slider-wrap")
              .find(".swiper-slide-active")
              .stop()
              .addClass("prev-move");
            $(this).stop().addClass("prev-arrow-move");
            darkSlidePrevMouseOver(
              $(this).parents(".nectar-slider-wrap"),
              $(this)
                .parents(".nectar-slider-wrap")
                .find(".swiper-slide-active")
                .index()
            );
          }
        );

        $("body").on(
          "mouseleave",
          '.nectar-slider-wrap[data-button-styling="btn_with_preview"] .swiper-container .slider-prev',
          function () {
            $(this)
              .parents(".nectar-slider-wrap")
              .find(".swiper-slide-active")
              .prev(".swiper-slide")
              .removeClass("prev-high-z-index");
            $(this)
              .parents(".nectar-slider-wrap")
              .find(".swiper-slide-active")
              .stop()
              .removeClass("prev-move");
            $(this).stop().removeClass("prev-arrow-move");
          }
        );
      } else if (
        $(
          "#" +
            $(this).attr("id") +
            '.nectar-slider-wrap[data-overall_style="directional"]'
        ).length == 1
      ) {
        function prevArrowAnimationDirectional(e) {
          if (
            $(this).hasClass("inactive") ||
            $(this)
              .parents(".swiper-container")
              .find(".slider-next")
              .hasClass("inactive")
          )
            return false;
          var $that = $(this);

          //cache the widths
          if ($("#header-outer.transparent").length > 0) {
            $(
              "#header-outer nav > ul.sf-menu > li > a, #header-outer nav > ul.buttons > li#search-btn a, #header-outer nav > ul.buttons > li.slide-out-widget-area-toggle a > span, #header-outer .cart-icon-wrap, header#top #logo"
            ).each(function () {
              var $extraWidth =
                $(this).find(".original .sf-sub-indicator").length > 0 ? 14 : 1;
              $(this)
                .find(".original")
                .attr(
                  "data-w",
                  $(this).find("span.original").width() + $extraWidth
                );
            });
          }

          //make sure the animation is complete
          var $timeout;

          clearTimeout($timeout);
          $timeout = setTimeout(function () {
            $that
              .parents(".swiper-container")
              .removeClass("directional-trans-prev");
            $that
              .parents(".swiper-container")
              .find(".swiper-wrapper")
              .transition(
                {
                  x: 0,
                  left:
                    parseInt(
                      $that
                        .parents(".swiper-container")
                        .find(".swiper-wrapper")
                        .css("left")
                    ) + $that.parents(".swiper-container").width(),
                },
                0
              );
            setTimeout(function () {
              $nectarSliders[i].updateActiveSlide();
              $nectarSliders[i].fixLoop();
              $that.removeClass("inactive");
            }, 50);

            resetContentPos();
          }, 1100);

          //call the dark/light slide coloring half way through transition
          var $timeout2;

          clearTimeout($timeout2);
          $timeout2 = setTimeout(function () {
            if (
              $that.parents(".swiper-container").attr("data-loop") != "true"
            ) {
              if (
                $that
                  .parents(".swiper-container")
                  .find(".swiper-slide-active")
                  .index() +
                  1 !=
                1
              ) {
                onChangeStart($nectarSliders[i]);
              }
            } else {
              onChangeStart($nectarSliders[i]);
            }
          }, 100);

          //non looped slider
          if (
            $(this).parents(".swiper-container").attr("data-loop") != "true"
          ) {
            /* if( $(this).parents('.swiper-container').find('.swiper-slide-active').index()+1 == 1 && !$('html').hasClass('no-video')){

                             if( $(this).parents('.nectar-slider-wrap ').attr('data-transition') != 'fade') {

                                 $(this).parents('.swiper-container').find('.swiper-wrapper').stop(true,false).css('transition','none').animate({
                                    'left' : parseInt($(this).parents('.swiper-container').find('.swiper-wrapper').css('left')) + 20
                                 },200,function(){
                                    $(this).parents('.swiper-container').find('.swiper-wrapper').stop(true,false).css('transition','left,top');
                                    $nectarSliders[i].swipeReset();
                                 });
                             } 
                       }  else { */

            $(this)
              .parents(".swiper-container")
              .find(".swiper-wrapper")
              .find(".swiper-slide-active .content")
              .children()
              .each(function (i) {
                $(this)
                  .stop()
                  .delay(i * 50)
                  .transition(
                    {
                      x:
                        $that.parents(".swiper-container").width() / 2.5 + "px",
                    },
                    950,
                    "easeInOutQuart"
                  );
              });
            //}
          }

          $(this).addClass("inactive");

          //move the slide with eaising
          $(this)
            .parents(".swiper-container")
            .find(".swiper-wrapper")
            .transition(
              { x: $(this).parents(".swiper-container").width() + "px" },
              1100,
              "easeInOutQuart"
            );

          if (
            $(this).parents(".swiper-container").attr("data-loop") == "true"
          ) {
            $(this)
              .parents(".swiper-container")
              .find(".swiper-wrapper")
              .find(".swiper-slide-active .content > *")
              .each(function (i) {
                $(this)
                  .stop()
                  .delay(i * 50)
                  .transition(
                    {
                      x:
                        $that.parents(".swiper-container").width() / 2.5 + "px",
                    },
                    950,
                    "easeInOutQuart"
                  );
              });
          }

          $that
            .parents(".swiper-container")
            .find(".swiper-wrapper")
            .find(".swiper-slide-active")
            .prev(".swiper-slide")
            .find(".content > *")
            .transition(
              {
                x: "-" + $that.parents(".swiper-container").width() + "px",
              },
              0
            );

          setTimeout(function () {
            $that
              .parents(".swiper-container")
              .find(".swiper-wrapper")
              .find(".swiper-slide-active")
              .prev(".swiper-slide")
              .find(".content > *")
              .each(function (i) {
                $(this)
                  .stop()
                  .delay(i * 50)
                  .transition(
                    {
                      x: "0px",
                    },
                    750,
                    "easeInOutQuart"
                  );
              });
          }, 200);

          $that.parents(".swiper-container").addClass("directional-trans-prev");

          e.preventDefault();
        }

        function nextArrowAnimationDirectional(e) {
          if (
            $(this).hasClass("inactive") ||
            $(this)
              .parents(".swiper-container")
              .find(".slider-prev")
              .hasClass("inactive")
          )
            return false;
          var $that = $(this);

          //cache the widths
          if ($("#header-outer.transparent").length > 0) {
            $(
              "#header-outer nav > ul.sf-menu > li > a, #header-outer nav > ul.buttons > li#search-btn a, #header-outer nav > ul.buttons > li.slide-out-widget-area-toggle a > span, #header-outer .cart-icon-wrap, header#top #logo"
            ).each(function () {
              var $extraWidth =
                $(this).find(".original .sf-sub-indicator").length > 0 ? 14 : 1;
              $(this)
                .find(".original")
                .attr(
                  "data-w",
                  $(this).find("span.original").width() + $extraWidth
                );
            });
          }

          //make sure the animation is complete
          var $timeout;

          clearTimeout($timeout);
          $timeout = setTimeout(function () {
            $that
              .parents(".swiper-container")
              .removeClass("directional-trans-next");
            $that
              .parents(".swiper-container")
              .find(".swiper-wrapper")
              .transition(
                {
                  x: 0,
                  left:
                    parseInt(
                      $that
                        .parents(".swiper-container")
                        .find(".swiper-wrapper")
                        .css("left")
                    ) - $that.parents(".swiper-container").width(),
                },
                0
              );
            setTimeout(function () {
              $nectarSliders[i].updateActiveSlide();
              $nectarSliders[i].fixLoop();
              $that.removeClass("inactive");
            }, 50);
            resetContentPos();
          }, 1100);

          //call the dark/light slide coloring half way through transition
          var $timeout2;

          clearTimeout($timeout2);
          $timeout2 = setTimeout(function () {
            if (
              $that.parents(".swiper-container").attr("data-loop") != "true"
            ) {
              if (
                $that
                  .parents(".swiper-container")
                  .find(".swiper-slide-active")
                  .index() +
                  1 !=
                $slideNum
              ) {
                onChangeStart($nectarSliders[i]);
              }
            } else {
              onChangeStart($nectarSliders[i]);
            }
          }, 100);

          var $slideNum = $(this)
            .parents(".swiper-container")
            .find(".swiper-wrapper > div").length;

          //non looped slider
          if (
            $(this).parents(".swiper-container").attr("data-loop") != "true"
          ) {
            if (
              $(this)
                .parents(".swiper-container")
                .find(".swiper-slide-active")
                .index() +
                1 ==
                $slideNum &&
              !$("html").hasClass("no-video")
            ) {
              if (
                $(this)
                  .parents(".nectar-slider-wrap ")
                  .attr("data-transition") != "fade"
              ) {
                $(this)
                  .parents(".swiper-container")
                  .find(".swiper-wrapper")
                  .stop(true, false)
                  .css("transition", "none")
                  .animate(
                    {
                      left:
                        parseInt(
                          $(this)
                            .parents(".swiper-container")
                            .find(".swiper-wrapper")
                            .css("left")
                        ) - 20,
                    },
                    200,
                    function () {
                      $(this)
                        .parents(".swiper-container")
                        .find(".swiper-wrapper")
                        .stop(true, false)
                        .css("transition", "left,top");
                      $nectarSliders[i].swipeReset();
                    }
                  );
              }
            } else {
              $(this)
                .parents(".swiper-container")
                .find(".swiper-wrapper")
                .find(".swiper-slide-active .content > *")
                .each(function (i) {
                  $(this)
                    .stop()
                    .delay(i * 50)
                    .transition(
                      {
                        x:
                          "-" +
                          $that.parents(".swiper-container").width() / 2.5 +
                          "px",
                      },
                      950,
                      "easeInOutQuart"
                    );
                });
            }
          }

          $(this).addClass("inactive");

          //move the slide with eaising
          $(this)
            .parents(".swiper-container")
            .find(".swiper-wrapper")
            .transition(
              { x: -$(this).parents(".swiper-container").width() + "px" },
              1100,
              "easeInOutQuart"
            );

          if (
            $(this).parents(".swiper-container").attr("data-loop") == "true"
          ) {
            $(this)
              .parents(".swiper-container")
              .find(".swiper-wrapper")
              .find(".swiper-slide-active .content > *")
              .each(function (i) {
                $(this)
                  .stop()
                  .delay(i * 50)
                  .transition(
                    {
                      x:
                        "-" +
                        $that.parents(".swiper-container").width() / 2.5 +
                        "px",
                    },
                    950,
                    "easeInOutQuart"
                  );
              });
          }

          $that
            .parents(".swiper-container")
            .find(".swiper-wrapper")
            .find(".swiper-slide-active")
            .next(".swiper-slide")
            .find(".content > *")
            .transition(
              {
                x: $that.parents(".swiper-container").width() + "px",
              },
              0
            );

          setTimeout(function () {
            $that
              .parents(".swiper-container")
              .find(".swiper-wrapper")
              .find(".swiper-slide-active")
              .next(".swiper-slide")
              .find(".content > *")
              .each(function (i) {
                $(this)
                  .stop()
                  .delay(i * 50)
                  .transition(
                    {
                      x: "0px",
                    },
                    750,
                    "easeInOutQuart"
                  );
              });
          }, 200);

          $that.parents(".swiper-container").addClass("directional-trans-next");

          e.preventDefault();
        }

        //prev
        $("body").off(
          "click",
          "#" + $(this).attr("id") + " .slider-prev",
          prevArrowAnimationDirectional
        );
        $("body").on(
          "click",
          "#" + $(this).attr("id") + " .slider-prev",
          prevArrowAnimationDirectional
        );

        //next
        $("body").off(
          "click",
          "#" + $(this).attr("id") + " .slider-next",
          nextArrowAnimationDirectional
        );
        $("body").on(
          "click",
          "#" + $(this).attr("id") + " .slider-next",
          nextArrowAnimationDirectional
        );

        function resetContentPos() {
          $($nectarSliders[i].container)
            .find(".swiper-slide .content > *")
            .transition({ x: "0px" }, 0);
        }
      }

      //scale pagination style
      if (
        $("#" + $(this).attr("id") + " .swiper-container").attr(
          "data-bullet_style"
        ) == "scale"
      ) {
        $(
          "#" +
            $(this).attr("id") +
            " .slider-pagination .swiper-pagination-switch"
        ).append("<i />");
      }
      //Clickable pagination
      if (
        $bullets != null &&
        $("#" + $(this).attr("id") + " .swiper-wrapper > div").length > 1
      ) {
        $(
          "#" +
            $(this).attr("id") +
            " .slider-pagination .swiper-pagination-switch"
        ).click(function () {
          $nectarSliders[i].swipeTo($(this).index());
        });
      }
    });
  }

  nectarSliderMainInit();

  function darkFirstSlide(slider) {
    if (
      slider.parents(".parallax_slider_outer").length > 0 &&
      slider.find('.swiper-slide-active[data-color-scheme="dark"]').length > 0
    ) {
      $("#header-outer").addClass("dark-slide");
    } else if (
      slider.parents(".parallax_slider_outer").length > 0 ||
      slider.parents(".first-section").length > 0
    ) {
      $("#header-outer").removeClass("dark-slide");
    }
  }

  function directionalNavColorInit(slider) {
    if (
      slider.attr("data-overall_style") == "directional" &&
      slider.find('.swiper-slide[data-color-scheme="dark"]').length > 0 &&
      $('#header-outer[data-transparent-header="true"]').length > 0
    ) {
      if (
        slider.parents(".parallax_slider_outer").length > 0 ||
        slider.parents(".first-section").length > 0
      ) {
        $("#header-outer").addClass("directional-nav-effect");

        $selector =
          $('#header-outer[data-permanent-transparent="1"]').length == 0
            ? "#header-outer"
            : "#header-outer .midnightHeader.nectar-slider";

        $(
          $selector +
            " nav > ul.sf-menu > li > a, " +
            $selector +
            " nav > ul.buttons > li.slide-out-widget-area-toggle a span, " +
            $selector +
            " nav > ul.buttons > li#search-btn a"
        ).each(function () {
          var $text = $(this).html();
          $(this).html(" ");
          $(this).append(
            '<span class="dark"><span>' + $text + "</span></span>"
          );
          $(this).append(
            '<span class="light"><span>' + $text + "</span></span>"
          );
          $(this).append(
            '<span class="original"><span>' + $text + "</span></span>"
          );
        });

        $($selector + " .cart-outer .cart-icon-wrap").each(function () {
          $(this).find("> i").remove();
          $(this).append(
            '<span class="dark"><span><i class="icon-salient-cart"></i></span></span>'
          );
          $(this).append(
            '<span class="light"><span><i class="icon-salient-cart"></i></span></span>'
          );
          $(this).append(
            '<span class="original"><span><i class="icon-salient-cart"></i></span></span>'
          );
        });
        setTimeout(function () {
          $($selector + " .cart-outer .cart-icon-wrap").each(function () {
            $(this).find("> i, > span").remove();
            $(this).append(
              '<span class="dark"><span><i class="icon-salient-cart"></i></span></span>'
            );
            $(this).append(
              '<span class="light"><span><i class="icon-salient-cart"></i></span></span>'
            );
            $(this).append(
              '<span class="original"><span><i class="icon-salient-cart"></i></span></span>'
            );
          });
        }, 1000);

        //logo
        if ($($selector + " header#top #logo img").length > 0) {
          $($selector + " header#top #logo").append(
            '<span class="dark"><span></span></span>'
          );
          $($selector + " header#top #logo").append(
            '<span class="light"><span></span></span>'
          );
          $($selector + " header#top #logo").append(
            '<span class="original"><span></span></span>'
          );
          $($selector + " header#top #logo img:first")
            .clone()
            .appendTo($($selector + " header#top #logo .original span"));
          if ($($selector + " header#top #logo img.starting-logo").length > 0)
            $(
              $selector +
                " header#top #logo img.starting-logo:not(.dark-version)"
            )
              .clone()
              .appendTo($($selector + " header#top #logo .light span"));
          if (
            $($selector + " header#top #logo img.starting-logo.retina.logo")
              .length > 0
          )
            $(
              $selector +
                " header#top #logo img.starting-logo.retina-logo:not(.dark-version)"
            )
              .clone()
              .appendTo($($selector + " header#top #logo .light span"));
          if (
            $($selector + " header#top #logo img.starting-logo.dark-version")
              .length > 0
          )
            $($selector + " header#top #logo img.starting-logo.dark-version")
              .clone()
              .appendTo($($selector + " header#top #logo .dark span"));
          if (
            $(
              $selector +
                " header#top #logo img.starting-logo.dark-version.retina.logo"
            ).length > 0
          )
            $(
              $selector +
                " header#top #logo img.starting-logo.dark-version.retina-logo"
            )
              .clone()
              .appendTo($($selector + " header#top #logo .dark span"));
          $($selector + " header#top #logo > img").remove();
        } else {
          var $logoText = $("header#top #logo").text();
          $($selector + " header#top #logo").html(" ");
          $($selector + " header#top #logo").append(
            '<span class="dark"><span>' + $logoText + "</span></span>"
          );
          $($selector + " header#top #logo").append(
            '<span class="light"><span>' + $logoText + "</span></span>"
          );
          $($selector + " header#top #logo").append(
            '<span class="original"><span>' + $logoText + "</span></span>"
          );
        }

        //retina logo fix
        if ($(".retina-logo:visible").length > 0)
          $($selector + " header#top #logo").css(
            "width",
            $(".retina-logo").width()
          );

        //cache the widths
        $(
          $selector +
            " nav > ul.sf-menu > li > a, " +
            $selector +
            " nav > ul.buttons > li#search-btn a, " +
            $selector +
            " nav > ul.buttons > li.slide-out-widget-area-toggle a > span, " +
            $selector +
            " .cart-icon-wrap, " +
            $selector +
            " header#top #logo"
        ).each(function () {
          var $extraWidth =
            $(this).find(".original .sf-sub-indicator").length > 0 ? 14 : 1;
          $(this)
            .find(".original")
            .attr(
              "data-w",
              $(this).find("span.original").width() + $extraWidth
            );
        });
      }
    }
  }

  //initial slide load
  var $animating = false;

  //responsive slider
  var $sliderHeights = [];
  var $existingSliders = [];

  function initialSlideLoad() {
    $animating = false;

    $sliderHeights = [];
    $existingSliders = [];

    //add class to first video slide
    $(".swiper-wrapper").each(function () {
      if ($(this).find(".swiper-slide:nth-child(2) video").length > 0)
        $(this)
          .find(".swiper-slide:nth-child(2)")
          .addClass("first_video_slide");
    });

    $(".nectar-slider-wrap").each(function (i) {
      var $sliderWrapCount = $(".nectar-slider-wrap").length;
      var $that = $(this);

      if ($(this).find(".swiper-slide-active video").length > 0) {
        if (
          !$("html").hasClass("no-video") &&
          !navigator.userAgent.match(
            /(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/
          )
        ) {
          var videoReady = setInterval(function () {
            if (
              $that.find(".swiper-slide-active:first video").get(0).readyState >
              3
            ) {
              showSliderControls();
              resizeToCover();
              slideContentPos();
              sliderLoadIn($that, i);

              var $timeout = 0;
              if (
                ($('#ajax-loading-screen[data-effect="center_mask_reveal"]')
                  .length > 0 &&
                  $that.parents(".parallax_slider_outer").length > 0) ||
                ($('#ajax-loading-screen[data-effect="center_mask_reveal"]')
                  .length > 0 &&
                  $that.hasClass("first-nectar-slider"))
              ) {
                $timeout = 450;
              }

              setTimeout(function () {
                captionTransition($nectarSliders[i]);
              }, $timeout);
              darkFirstSlide($that);
              clearInterval(videoReady);

              $that.addClass("loaded");
              if (
                $that.parents(".parallax_slider_outer").length > 0 ||
                $that.hasClass("first-nectar-slider")
              ) {
                $("#ajax-loading-screen").addClass("loaded");
                setTimeout(function () {
                  $("#ajax-loading-screen").addClass("hidden");
                }, 1000);
              }
            }
          }, 60);
        }
        //ie8
        else {
          showSliderControls();
          resizeToCover();
          slideContentPos();
          sliderLoadIn($that, i);
          captionTransition($nectarSliders[i]);
          darkFirstSlide($that);
        }
      } else {
        var $firstBg = $(this)
          .find(".swiper-slide-active .image-bg")
          .attr("style");
        var pattern = /url\(["']?([^'")]+)['"]?\)/;
        var match = pattern.exec($firstBg);

        if (match) {
          var slideImg = new Image();
          slideImg.src = match[1];

          $(slideImg).load(function () {
            showSliderControls();
            resizeToCover();
            slideContentPos();
            sliderLoadIn($that, i);
            var $timeout = 0;
            if (
              ($('#ajax-loading-screen[data-effect="center_mask_reveal"]')
                .length > 0 &&
                $that.parents(".parallax_slider_outer").length > 0) ||
              ($('#ajax-loading-screen[data-effect="center_mask_reveal"]')
                .length > 0 &&
                $that.hasClass("first-nectar-slider"))
            ) {
              $timeout = 450;
            }

            setTimeout(function () {
              captionTransition($nectarSliders[i]);
            }, $timeout);

            darkFirstSlide($that);

            $that.addClass("loaded");
            if (
              $that.parents(".parallax_slider_outer").length > 0 ||
              $that.hasClass("first-nectar-slider")
            ) {
              $("#ajax-loading-screen").addClass("loaded");
              setTimeout(function () {
                $("#ajax-loading-screen").addClass("hidden");
              }, 1000);
            }
          });
        }
      }

      //mobile check
      if (
        navigator.userAgent.match(
          /(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/
        )
      ) {
        captionTransition($nectarSliders[i]);
        showSliderControls();
        resizeToCover();
        slideContentPos();
        darkFirstSlide($that);

        setTimeout(function () {
          resizeToCover();
          slideContentPos();
        }, 400);

        $(".nectar-slider-wrap")
          .find(".nectar-slider-loading")
          .fadeOut(800, "easeInOutExpo");
        $(
          'body #header-outer[data-transparent-header="true"] .ns-loading-cover'
        ).fadeOut(800, "easeInOutExpo", function () {
          $(this).remove();
          $(
            ".nectar-slider-wrap.first-section .swiper-container .swiper-wrapper .swiper-slide"
          ).removeClass("not-loaded");
        });

        $(".nectar-slider-wrap .mobile-video-image").show();
        $(".nectar-slider-wrap .video-wrap").remove();

        $(this).addClass("loaded");

        if (
          $that.parents(".parallax_slider_outer").length > 0 ||
          $that.hasClass("first-nectar-slider")
        ) {
          $("#ajax-loading-screen").addClass("loaded");
          setTimeout(function () {
            $("#ajax-loading-screen").addClass("hidden");
          }, 1000);
        }

        autorotateInit($(this), i);
      }

      if ($("header#top #logo img").length > 0) {
        var logoImg = new Image();
        logoImg.src = $("header#top #logo img:first").attr("src");

        $(logoImg).load(function () {
          directionalNavColorInit($that);
          if ($that.attr("data-overall_style") == "directional") {
            $that
              .find(".swiper-container")
              .addClass("directional-trans-current");
            onChangeStart($nectarSliders[i]);
          }
        });
      } else {
        directionalNavColorInit($that);
        if ($that.attr("data-overall_style") == "directional") {
          $that.find(".swiper-container").addClass("directional-trans-current");
          onChangeStart($nectarSliders[i]);
        }
      }
    });

    ////get slider heights
    $(".swiper-container").each(function (i) {
      $sliderHeights[i] = parseInt($(this).attr("data-height"));
      $existingSliders[i] = $(this).parent().attr("id");
    });
  }

  function nectarInit() {
    if (doneVideoInit == true) return;

    //videos
    /*$('.swiper-slide .slider-video').mediaelementplayer({
            enableKeyboard: false,
            iPadUseNativeControls: false,
            pauseOtherPlayers: false,
            // force iPhone's native controls
            iPhoneUseNativeControls: false,
            // force Android's native controls
            AndroidUseNativeControls: false
        });*/

    //if using pp - init it after slide loads
    if ($().prettyPhoto) prettyPhotoInit();

    $(".swiper-slide iframe[data-aspectRatio]").each(function () {
      var newWidth = $(this).parent().width();

      var $el = $(this);

      //in nectar slider
      if ($(this).parents(".swiper-slide").length > 0) {
        if ($(this).is(":visible"))
          $el.width(newWidth).height(newWidth * $el.attr("data-aspectRatio"));
      }
      //all others
      else {
        $el.width(newWidth).height(newWidth * $el.attr("data-aspectRatio"));
      }
    });

    doneVideoInit = true;
  }

  //autoplay - set vars before init call
  var autoplay = [];
  var sliderAutoplayCount = -1;

  initialSlideLoad();

  var headerPadding = parseInt($("#header-outer").attr("data-padding"));
  var shrinkNum = 8;
  if ($("#header-outer[data-shrink-num]").length > 0)
    shrinkNum = $("#header-outer").attr("data-shrink-num");

  //dynamic height sliders
  dynamicHeightSliders();
  function dynamicHeightSliders() {
    var $adminBarHeight = $("#wpadminbar").length > 0 ? 28 : 0;

    $(".nectar-slider-wrap").each(function () {
      var $heightCalc;
      var $minHeight = $(".swiper-container").attr("data-min-height");

      //fullscreen
      if (
        ($(this).attr("data-fullscreen") == "true" &&
          $(this).attr("data-full-width") == "true") ||
        ($(this).attr("data-fullscreen") == "true" &&
          $(this).attr("data-full-width") == "boxed-full-width")
      ) {
        if ($(this).parents("#nectar_fullscreen_rows").length == 0) {
          //first slider on page
          if (
            ($(this).hasClass("first-section") && $(this).index() == 0) ||
            ($(this).parents(".wpb_row").length > 0 &&
              $(this).parents(".wpb_row").hasClass("first-section") &&
              $(this).index() == 0 &&
              $(this).parents(".parallax_slider_outer").length == 0)
          ) {
            //min height
            $heightCal =
              $(window).height() - $(this).offset().top + 2 <= $minHeight
                ? $minHeight
                : $(window).height() - $(this).offset().top + 2;
            $(this).find(".swiper-container").attr("data-height", $heightCal);
          }
          //first parallax slider on page
          else if (
            $(this).parents(".parallax_slider_outer").length > 0 &&
            $(this).parents("#full_width_portfolio").length == 0
          ) {
            //min height
            $heightCal =
              $(window).height() - $(this).parent().offset().top + 2 <=
              $minHeight
                ? $minHeight
                : $(window).height() - $(this).parent().offset().top + 2;
            $(this).find(".swiper-container").attr("data-height", $heightCal);
          }
          //first portfolio slider on page
          else if (
            $(this).parents("#full_width_portfolio").length > 0 &&
            $(this).attr("data-parallax") != "true" &&
            $(this).index() == 0
          ) {
            //min height
            $heightCal =
              $(window).height() - $(this).offset().top + 2 <= $minHeight
                ? $minHeight
                : $(window).height() - $(this).offset().top + 2;
            $(this).find(".swiper-container").attr("data-height", $heightCal);
          }
          //first portfolio parallax slider on page
          else if (
            $(this).parents("#full_width_portfolio").length > 0 &&
            $(this).attr("data-parallax") == "true"
          ) {
            //min height
            $heightCal =
              $(window).height() - $(this).offset().top + 2 <= $minHeight
                ? $minHeight
                : $(window).height() - $(this).offset().top + 2;
            $(this).find(".swiper-container").attr("data-height", $heightCal);
          }
          //all others
          else {
            $resize =
              $('#header-outer[data-header-resize="0"]').length > 0
                ? 0
                : parseInt(shrinkNum) + headerPadding * 2;
            $headerSize =
              $('#header-outer[data-permanent-transparent="false"]').length > 0
                ? $("#header-space").height() - $resize - 3
                : -3;
            if (
              $("#nectar_fullscreen_rows").length > 0 ||
              ($('body[data-header-format="left-header"]').length > 0 &&
                window.innerWidth >= 1000)
            )
              $headerSize = $adminBarHeight;
            //min height
            $heightCal =
              $(window).height() - $headerSize <= $minHeight
                ? $minHeight
                : $(window).height() - $headerSize;
            $(this).find(".swiper-container").attr("data-height", $heightCal);
          }

          //transparent header loading icon center
          if ($('#header-outer[data-remove-border="true"]').length == 0) {
            if (
              $('body #header-outer[data-transparent-header="true"]').length >
                0 &&
              $('.first-section .nectar-slider-wrap[data-fullscreen="true"]')
                .length > 0 &&
              $("#page-header-bg").length == 0
            ) {
              $(".first-section .nectar-slider-loading").css({
                "background-image": $loading_bg_storage,
                "background-position":
                  "center " +
                  ($(window).height() / 2 + 15 - $("#header-space").height()) +
                  "px",
              });

              $(
                ".first-section .nectar-slider-wrap .nectar-slider-loading .loading-icon"
              ).css({
                opacity: "1",
                height: $(window).height() - $("#header-space").height() + "px",
              });
            }
          }
        }
      }

      //flexible height
      if (
        $(this).attr("data-flexible-height") == "true" &&
        $(this).attr("data-fullscreen") != "true"
      ) {
        //escape if not placed in a flexible ready position
        if (
          $(this).parents(".wpb_row.full-width-content").length == 0 &&
          $(this).attr("data-full-width") == "false"
        ) {
          $(this).attr("data-flexible-height", "false");
          return false;
        }

        var $minHeight = $(".swiper-container").attr("data-min-height");

        var currentKey = $existingSliders.getKeyByValue($(this).attr("id"));
        var $windowWidth = $(window).width();
        var $definedHeight = $sliderHeights[currentKey];

        var dif = $(window).width() / 1600;

        if (window.innerWidth > 1000 && $("#boxed").length == 0) {
          $(this)
            .find(".swiper-container")
            .attr("data-height", Math.ceil($definedHeight * dif));
        } else {
          //column sliders
          var $parentCol =
            $(this).parents(".wpb_column").length > 0
              ? $(this).parents(".wpb_column")
              : $(this).parents(".col");
          if ($parentCol.length == 0) $parentCol = $(".main-content");

          if (
            !$parentCol.hasClass("vc_span12") &&
            !$parentCol.hasClass("main-content") &&
            !$parentCol.hasClass("span_12") &&
            !$parentCol.hasClass("vc_col-sm-12")
          ) {
            var $parentColWidth = sliderColumnDesktopWidth($parentCol);
            var $parentColRatio = 1100 / $parentColWidth;

            //min height
            if ($definedHeight * dif <= $minHeight) {
              $(this).find(".swiper-container").attr("data-height", $minHeight);
            } else {
              $(this)
                .find(".swiper-container")
                .attr(
                  "data-height",
                  Math.ceil($parentColRatio * $definedHeight * dif)
                );
            }
          }

          //boxed
          else if ($("#boxed").length > 0) {
            var dif = $("#boxed").width() / 1600;

            if (window.innerWidth > 1300) {
              if ($('body[data-ext-responsive="true"]').length > 0) {
                if ($(this).has('[data-full-width="boxed-full-width"]')) {
                  $("#boxed").width() < 1400
                    ? $(this)
                        .find(".swiper-container")
                        .attr("data-height", Math.ceil($definedHeight * dif))
                    : $(this)
                        .find(".swiper-container")
                        .attr("data-height", $definedHeight * (1400 / 1600));
                }
              } else {
                if ($(this).has('[data-full-width="boxed-full-width"]'))
                  $(this)
                    .find(".swiper-container")
                    .attr(
                      "data-height",
                      Math.ceil($definedHeight * (1200 / 1600))
                    );
              }
            } else if (window.innerWidth <= 1300 && window.innerWidth >= 1000) {
              if ($('body[data-ext-responsive="true"]').length > 0) {
                $(this)
                  .find(".swiper-container")
                  .attr("data-height", Math.ceil($definedHeight * dif));
              } else {
                if ($(this).has('[data-full-width="boxed-full-width"]'))
                  $(this)
                    .find(".swiper-container")
                    .attr(
                      "data-height",
                      Math.ceil($definedHeight * (980 / 1600))
                    );
              }
            } else if (window.innerWidth < 1000 && window.innerWidth > 690) {
              var $heightCalc =
                $definedHeight * (679 / 1600) <= $minHeight
                  ? $minHeight
                  : $definedHeight * (679 / 1600);
              if ($(this).has('[data-full-width="boxed-full-width"]'))
                $(this)
                  .find(".swiper-container")
                  .attr("data-height", $minHeight);
            } else if (window.innerWidth <= 690 && window.innerWidth >= 470) {
              var $heightCalc =
                $definedHeight * (410 / 1600) <= $minHeight
                  ? $minHeight
                  : $definedHeight * (410 / 1600);
              if ($(this).has('[data-full-width="boxed-full-width"]'))
                $(this)
                  .find(".swiper-container")
                  .attr("data-height", $heightCalc);
            } else if (window.innerWidth < 470) {
              var $heightCalc =
                $definedHeight * (318 / 1600) <= $minHeight
                  ? $minHeight
                  : $definedHeight * (318 / 1600);
              if ($(this).has('[data-full-width="boxed-full-width"]'))
                $(this)
                  .find(".swiper-container")
                  .attr("data-height", $heightCalc);
            }
          }

          //regular
          else {
            //min height
            if ($definedHeight * dif <= $minHeight) {
              $(this).find(".swiper-container").attr("data-height", $minHeight);
            } else {
              $(this)
                .find(".swiper-container")
                .attr("data-height", Math.ceil($definedHeight * dif));
            }
          }
        }

        //transparent header loading icon center
        if (
          $('body #header-outer[data-transparent-header="true"]').length > 0 &&
          $('.first-section .nectar-slider-wrap[data-flexible-height="true"]')
            .length > 0
        ) {
          $(".first-section .nectar-slider-loading").css({
            "background-image": $loading_bg_storage,
            "background-position":
              "center " +
              (($definedHeight * dif) / 2 + 15 - $("#header-space").height()) +
              "px",
          });

          $(
            ".first-section .nectar-slider-wrap .nectar-slider-loading .loading-icon"
          ).css({
            opacity: "1",
            height: $definedHeight * dif - $("#header-space").height() + "px",
          });
        }
      }
    });
  }

  if (window.innerWidth > 690) {
    $(window).on("resize.dynamicHeights", dynamicHeightSliders);
  } else {
    //stop mobile browsers from firing the resize event on scroll (when toolbar hides)
    var $windowWidth = $(window).width(),
      $windowHeight = $(window).height();
    var $orientationChange = 0;

    window.addEventListener("orientationchange", function () {
      $orientationChange = 1;
    });

    jQuery(window).resize(function ($) {
      if (
        ($(window).width() != $windowWidth &&
          $(window).height != $windowHeight) ||
        $orientationChange == 1
      ) {
        dynamicHeightSliders();
        $orientationChange = 0;
      }
    });
  }

  setTimeout(function () {
    dynamicHeightSliders();
  }, 100);

  ////helper function
  function sliderColumnDesktopWidth(parentCol) {
    var $parentColWidth = 1100;
    var $columnNumberParsed = $(parentCol).attr("class").match(/\d+/);

    if ($columnNumberParsed == "2") {
      $parentColWidth = 170;
    } else if ($columnNumberParsed == "3") {
      $parentColWidth = 260;
    } else if ($columnNumberParsed == "4") {
      $parentColWidth = 340;
    } else if ($columnNumberParsed == "6") {
      $parentColWidth = 530;
    } else if ($columnNumberParsed == "8") {
      $parentColWidth = 700;
    } else if ($columnNumberParsed == "9") {
      $parentColWidth = 805;
    } else if ($columnNumberParsed == "10") {
      $parentColWidth = 916.3;
    } else if ($columnNumberParsed == "12") {
      $parentColWidth = 1100;
    }

    return $parentColWidth;
  }

  sliderSize();
  $(window).resize(sliderSize);

  function sliderSize() {
    //check for mobile first
    if (window.innerWidth < 1000 && window.innerWidth > 690) {
      //fullwidth sliders
      $(
        '.nectar-slider-wrap[data-full-width="true"]:not([data-fullscreen="true"],[data-flexible-height="true"])'
      ).each(function (i) {
        currentKey = $existingSliders.getKeyByValue($(this).attr("id"));
        $(this)
          .find(".swiper-container")
          .attr("data-height", $sliderHeights[currentKey] / 1.4);
      });

      //column sliders
      $(
        '.nectar-slider-wrap[data-full-width="false"]:not([data-flexible-height="true"])'
      ).each(function (i) {
        currentKey = $existingSliders.getKeyByValue($(this).attr("id"));

        var $currentSliderHeight = $sliderHeights[currentKey];
        var $parentCol =
          $(this).parents(".wpb_column").length > 0
            ? $(this).parents(".wpb_column")
            : $(this).parents(".col");

        //fullwidth but inside the span_9 post area
        if (
          $(this).parents("#post-area").length > 0 &&
          $(this).parents(".vc_span12").length > 0
        )
          $parentCol = $(this).parents("#post-area");

        //last resort
        if ($parentCol.length == 0) $parentCol = $(".main-content");

        var $parentColWidth = sliderColumnDesktopWidth($parentCol);

        var $aspectRatio = $currentSliderHeight / $parentColWidth;

        $(this)
          .find(".swiper-container")
          .attr("data-height", $aspectRatio * $parentCol.width());
      });

      //boxed sliders
      $(
        '.nectar-slider-wrap[data-full-width="boxed-full-width"]:not([data-flexible-height="true"]):not([data-fullscreen="true"])'
      ).each(function (i) {
        currentKey = $existingSliders.getKeyByValue($(this).attr("id"));
        $(this)
          .find(".swiper-container")
          .attr("data-height", $sliderHeights[currentKey] / 1.9);
      });
    } else if (window.innerWidth <= 690) {
      //fullwidth sliders
      $(
        '.nectar-slider-wrap[data-full-width="true"]:not([data-fullscreen="true"],[data-flexible-height="true"])'
      ).each(function (i) {
        currentKey = $existingSliders.getKeyByValue($(this).attr("id"));
        $(this)
          .find(".swiper-container")
          .attr("data-height", $sliderHeights[currentKey] / 2.7);
      });

      //column sliders
      $(
        '.nectar-slider-wrap[data-full-width="false"]:not([data-flexible-height="true"])'
      ).each(function (i) {
        currentKey = $existingSliders.getKeyByValue($(this).attr("id"));

        var $currentSliderHeight = $sliderHeights[currentKey];
        var $parentCol =
          $(this).parents(".wpb_column").length > 0
            ? $(this).parents(".wpb_column")
            : $(this).parents(".col");

        //fullwidth but inside the span_9 post area
        if (
          $(this).parents("#post-area").length > 0 &&
          $(this).parents(".vc_span12").length > 0
        )
          $parentCol = $(this).parents("#post-area");

        //last resort
        if ($parentCol.length == 0) $parentCol = $(".main-content");

        var $parentColWidth = sliderColumnDesktopWidth($parentCol);

        var $aspectRatio = $currentSliderHeight / $parentColWidth;

        $(this)
          .find(".swiper-container")
          .attr("data-height", $aspectRatio * $parentCol.width());
      });

      //boxed sliders
      $(
        '.nectar-slider-wrap[data-full-width="boxed-full-width"]:not([data-flexible-height="true"]):not([data-fullscreen="true"])'
      ).each(function (i) {
        currentKey = $existingSliders.getKeyByValue($(this).attr("id"));
        $(this)
          .find(".swiper-container")
          .attr("data-height", $sliderHeights[currentKey] / 2.9);
      });
    } else if (window.innerWidth < 1300 && window.innerWidth >= 1000) {
      //fullwidth sliders
      $(
        '.nectar-slider-wrap[data-full-width="true"]:not([data-fullscreen="true"],[data-flexible-height="true"])'
      ).each(function (i) {
        currentKey = $existingSliders.getKeyByValue($(this).attr("id"));
        $(this)
          .find(".swiper-container")
          .attr("data-height", $sliderHeights[currentKey] / 1.2);
      });

      //column sliders
      $(
        '.nectar-slider-wrap[data-full-width="false"]:not([data-flexible-height="true"])'
      ).each(function (i) {
        currentKey = $existingSliders.getKeyByValue($(this).attr("id"));

        var $currentSliderHeight = $sliderHeights[currentKey];
        var $parentCol =
          $(this).parents(".wpb_column").length > 0
            ? $(this).parents(".wpb_column")
            : $(this).parents(".col");

        //fullwidth but inside the span_9 post area
        if (
          $(this).parents("#post-area").length > 0 &&
          $(this).parents(".vc_span12").length > 0
        )
          $parentCol = $(this).parents("#post-area");

        //last resort
        if ($parentCol.length == 0) $parentCol = $(".main-content");

        var $parentColWidth = sliderColumnDesktopWidth($parentCol);

        var $aspectRatio = $currentSliderHeight / $parentColWidth;

        $(this)
          .find(".swiper-container")
          .attr("data-height", $aspectRatio * $parentCol.width());
      });

      //boxed sliders
      $(
        '.nectar-slider-wrap[data-full-width="boxed-full-width"]:not([data-flexible-height="true"]):not([data-fullscreen="true"])'
      ).each(function (i) {
        currentKey = $existingSliders.getKeyByValue($(this).attr("id"));
        $(this)
          .find(".swiper-container")
          .attr("data-height", $sliderHeights[currentKey] / 1.2);
      });
    } else {
      //fullwidth sliders
      $(
        '.nectar-slider-wrap[data-full-width="true"]:not([data-fullscreen="true"],[data-flexible-height="true"])'
      ).each(function (i) {
        currentKey = $existingSliders.getKeyByValue($(this).attr("id"));
        if ($(this).attr("data-flexible-height") != "true")
          $(this)
            .find(".swiper-container")
            .attr("data-height", $sliderHeights[currentKey]);
      });

      //boxed sliders
      $(
        '.nectar-slider-wrap[data-full-width="false"], .nectar-slider-wrap[data-full-width="boxed-full-width"]:not([data-flexible-height="true"]):not([data-fullscreen="true"])'
      ).each(function (i) {
        currentKey = $existingSliders.getKeyByValue($(this).attr("id"));
        if ($(this).attr("data-flexible-height") != "true")
          $(this)
            .find(".swiper-container")
            .attr("data-height", $sliderHeights[currentKey]);
      });
    }
  }

  //remove transform if single slide
  $(".nectar-slider-wrap").each(function () {
    if ($(this).find(".swiper-wrapper .swiper-slide").length == 1) {
      $(this).find(".swiper-slide").addClass("no-transform");
      $(this).find(".swiper-wrapper").addClass("no-transform");
    }
  });

  //slider height

  var min_w = 1500; // minimum video width allowed
  var vid_w_orig; // original video dimensions
  var vid_h_orig;

  vid_w_orig = 1280;
  vid_h_orig = 720;
  var $headerHeight = $("header").height() - 1;

  function nsSliderContentResize(e) {
    resizeToCover();
    slideContentPos();

    for (var i = 0; i < $nectarSliders.length; i++) {
      //make sure the parent is not hidden
      if (
        $($nectarSliders[i].container).parent().attr("data-transition") &&
        $($nectarSliders[i].container).parent().attr("data-transition") ==
          "fade"
      ) {
        for (var k = 0; k < $nectarSliders[i].slides.length; k++) {
          $nectarSliders[i].setTransition($nectarSliders[i].slides[k], 0);
        }

        $(".swiper-wrapper").stop(true, true).css("transition-duration", "0s");

        if ($(".nectar-slider-loading").css("display") == "none") {
          $(
            ".swiper-wrapper .swiper-slide.swiper-slide-active .content > *"
          ).css({
            opacity: 1,
            "padding-top": 0,
          });
        }
      }

      $nectarSliders[i].reInit();
      $nectarSliders[i].resizeFix();
    }
  }

  // $(window).off('resize.nsSliderContent');
  $(window).on("resize.nsSliderContent", nsSliderContentResize);
  //if(!$('body').hasClass('ajax-loaded')) $(window).trigger('resize');

  function resizeToCover() {
    $(".nectar-slider-wrap").each(function (i) {
      if ($(this).css("visibility") != "hidden") {
        var $leftHeaderSize =
          $('#header-outer[data-format="left-header"]').length > 0 &&
          window.innerWidth >= 1000
            ? parseInt($('#header-outer[data-format="left-header"]').width())
            : 0;
        var $windowWidth = $(window).width() - $leftHeaderSize;

        //width resize
        if (
          $("body > #boxed").length == 0 &&
          $('.nectar-slider-wrap[data-full-width="true"]')
            .parent()
            .attr("id") != "portfolio-extra" &&
          $(this).parents('#post-area:not(".span_12")').length == 0
        ) {
          $(
            '.nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .nectar-slider-wrap'
          ).css(
            "left",
            -(
              ($windowWidth - $smoothSrollWidth) / 2 -
              $(".main-content").width() / 2
            )
          ) + "px";
          $(
            '.nectar-slider-wrap[data-full-width="true"] .swiper-container, .nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .swiper-container, .parallax_slider_outer.first-section .nectar-slider-wrap'
          ).css("width", $windowWidth);
        } else if (
          $('.nectar-slider-wrap[data-full-width="true"]')
            .parent()
            .attr("id") == "portfolio-extra" &&
          $("#full_width_portfolio").length != 0
        ) {
          $(
            '.nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .nectar-slider-wrap'
          ).css(
            "left",
            -(
              ($windowWidth - $smoothSrollWidth) / 2 -
              $(".main-content").width() / 2
            )
          ) + "px";
          $(
            '.nectar-slider-wrap[data-full-width="true"] .swiper-container, .nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .swiper-container, .parallax_slider_outer.first-section .nectar-slider-wrap'
          ).css("width", $windowWidth);
        } else {
          var $container =
            $("body > #boxed").length == 0 ? "#post-area" : ".container-wrap";
          //backup incase only slider is used with nothing else in boxed mode
          if ($($container).width() == "0" && $("body > #boxed").length > 0)
            $container = "#boxed";
          $(
            '.nectar-slider-wrap[data-full-width="true"] .swiper-container, .nectar-slider-wrap[data-full-width="true"], .parallax_slider_outer.first-section .swiper-container, .parallax_slider_outer.first-section .nectar-slider-wrap'
          ).css("width", $($container).width());
        }

        var $sliderHeight = parseInt(
          $(this).find(".swiper-container").attr("data-height")
        );
        var isFullWidthCompatible =
          $(this).attr("data-full-width") == "true" ? "true" : "false";

        if (
          ($(this).parent().attr("id") == "portfolio-extra" &&
            $("#full_width_portfolio").length == 0) ||
          $(this).parents("#post-area").length > 0
        ) {
          isFullWidthCompatible = "false";
        }

        var $sliderWidth =
          isFullWidthCompatible == "true"
            ? $windowWidth - $smoothSrollWidth
            : $(this).width();

        $(this).parents(".parallax_slider_outer").css("height", $sliderHeight);
        $(this).css("height", $sliderHeight);
        $(this)
          .find(".swiper-container, .swiper-slide")
          .css({ height: $sliderHeight + 2, top: "-1px" });
        $(this).find(".swiper-container").css("width", $sliderWidth);
        //$(this).find('.swiper-slide').css('width', $sliderWidth);

        // set the video viewport to the window size
        $(this)
          .find(".video-wrap")
          .width($sliderWidth + 2);
        $(this)
          .find(".video-wrap")
          .height($sliderHeight + 2);

        //handle left header
        if ($('body[data-header-format="left-header"]').length > 0) {
          $(
            ".parallax_slider_outer.first-section .nectar-slider-wrap, .parallax_slider_outer.first-section .nectar-slider-wrap .swiper-container"
          ).css("width", $("#ajax-content-wrap").width());
          if (
            $(this).parents(".parallax_slider_outer.first-section").length > 0
          ) {
            $sliderWidth =
              isFullWidthCompatible == "true"
                ? $(window).width() -
                  $smoothSrollWidth -
                  $("#header-outer").width()
                : $(this).width() - $("#header-outer").width();
            $(this)
              .find(".video-wrap")
              .width($sliderWidth + 2);
          }
        }

        // use largest scale factor of horizontal/vertical
        var scale_h = $sliderWidth / vid_w_orig;
        var scale_v = ($sliderHeight - $headerHeight) / vid_h_orig;
        var scale = scale_h > scale_v ? scale_h : scale_v;

        //update minium width to never allow excess space
        min_w = (1280 / 720) * ($sliderHeight + 20);

        // don't allow scaled width < minimum video width
        if (scale * vid_w_orig < min_w) {
          scale = min_w / vid_w_orig;
        }

        // now scale the video
        $(this)
          .find("video, .mejs-overlay, .mejs-poster")
          .width(Math.ceil(scale * vid_w_orig + 2));
        $(this)
          .find("video, .mejs-overlay, .mejs-poster")
          .height(Math.ceil(scale * vid_h_orig + 2));

        // and center it by scrolling the video viewport
        $(this)
          .find(".video-wrap")
          .scrollLeft(($(this).find("video").width() - $sliderWidth) / 2);

        $(this)
          .find(".swiper-slide")
          .each(function () {
            //video alignment
            if ($(this).find(".video-wrap").length > 0) {
              //align  middle
              if ($(this).attr("data-bg-alignment") == "center") {
                $(this)
                  .find(".video-wrap, .mejs-overlay, .mejs-poster")
                  .scrollTop(
                    ($(this).find("video").height() - $sliderHeight) / 2
                  );
              }
              //align bottom
              else if ($(this).attr("data-bg-alignment") == "bottom") {
                $(this)
                  .find(".video-wrap")
                  .scrollTop(
                    $(this).find("video").height() - ($sliderHeight + 2)
                  );
              }
              //align top
              else {
                $(this).find(".video-wrap").scrollTop(0);
              }
            }
          });
      } //if visible
    });
  }

  ////initial call
  resizeToCover();

  //caption transitions
  function captionTransition(obj) {
    resizeToCover();

    var $containerClass;

    typeof obj == "undefined"
      ? ($containerClass = "div[id^=ns-id-]")
      : ($containerClass =
          "#" + $(obj.container).parents(".nectar-slider-wrap").attr("id"));

    var fromLeft = Math.abs(
      parseInt($($containerClass + " .swiper-wrapper").css("left"))
    );
    var currentSlide = Math.round(
      fromLeft / $($containerClass + " .swiper-slide").width()
    );
    var $slideNum = $($containerClass + ":first .swiper-wrapper > div").length;

    currentSlide = $($containerClass + " .swiper-slide-active").index();

    //if(isNaN(currentSlide)) currentSlide = 0;

    //make sure user isn't going back to same slide
    if (
      $(
        $containerClass + " .swiper-slide:nth-child(" + (currentSlide + 1) + ")"
      ).find(".content *").length > 0
    ) {
      if (
        $(
          $containerClass +
            " .swiper-slide:nth-child(" +
            (currentSlide + 1) +
            ")"
        )
          .find(".content *")
          .css("opacity") != "0" &&
        !$("html").hasClass("no-video")
      ) {
        //play video if there's one
        playVideoBG(currentSlide + 1, $containerClass);

        if (
          !$(
            $containerClass +
              " .swiper-slide:nth-child(" +
              (currentSlide + 1) +
              ")"
          ).hasClass("autorotate-shown")
        ) {
          return false;
        } else {
          $($containerClass + " .swiper-slide").removeClass("autorotate-shown");
        }
      }
    }

    //hide all
    if (!$("html").hasClass("no-video")) {
      $(
        $containerClass +
          " .swiper-slide .content p, " +
          $containerClass +
          " .swiper-slide .content h2, " +
          $containerClass +
          " .swiper-slide .content .buttons"
      )
        .stop(true, true)
        .css({ opacity: 0, "padding-top": 55 });
    }

    //pause video if there's one
    $($containerClass + " .swiper-slide").each(function () {
      if (
        $(this).find(".video-wrap video").length > 0 &&
        !$("html").hasClass("no-video")
      ) {
        $(this).find(".video-wrap video").get(0).pause();
      }
    });
    $($containerClass + ' .swiper-slide:not(".swiper-slide-active")').each(
      function () {
        if ($(this).find(".video-wrap video").length > 0) {
          if ($(this).find(".video-wrap video").get(0).currentTime != 0)
            $(this).find(".video-wrap video").get(0).currentTime = 0;
        }
      }
    );

    if ($($containerClass + " .swiper-container").attr("data-loop") == "true") {
      //webkit video fix
      if (
        $($containerClass + " .swiper-slide-active").index() + 1 == 2 &&
        $($containerClass + " .swiper-slide-active video").length > 0 &&
        !$("html").hasClass("no-video")
      ) {
        $($containerClass + " .swiper-slide:last-child")
          .find(".video-wrap video")
          .get(0)
          .play();
        $($containerClass + " .swiper-slide:last-child")
          .find(".video-wrap video")
          .get(0)
          .pause();
      }
      if (
        $($containerClass + " .swiper-slide-active").index() + 1 ==
          $slideNum - 1 &&
        $($containerClass + " .swiper-slide-active video").length > 0 &&
        !$("html").hasClass("no-video")
      ) {
        $($containerClass + " .swiper-slide:first-child")
          .find(".video-wrap video")
          .get(0)
          .play();
        $($containerClass + " .swiper-slide:first-child")
          .find(".video-wrap video")
          .get(0)
          .pause();
      }
      if (
        $($containerClass + " .swiper-slide-active").index() + 1 != 2 &&
        $($containerClass + " .swiper-slide:nth-child(2) video").length > 0 &&
        !$("html").hasClass("no-video")
      ) {
        $($containerClass + " .swiper-slide:last-child")
          .find(".video-wrap video")
          .get(0)
          .play();
        $($containerClass + " .swiper-slide:last-child")
          .find(".video-wrap video")
          .get(0)
          .pause();

        $($containerClass + " .swiper-slide:nth-child(2) video")
          .get(0)
          .pause();
        if (
          $($containerClass + " .swiper-slide:nth-child(2) video").get(0)
            .currentTime != 0
        )
          $($containerClass + " .swiper-slide:nth-child(2) video").get(
            0
          ).currentTime = 0;
      }

      //also show duplicate slide if applicable
      if ($($containerClass).attr("data-overall_style") != "directional") {
        ////first
        if (
          $($containerClass + " .swiper-slide-active").index() + 1 ==
          $slideNum - 1
        ) {
          $($containerClass + " .swiper-slide:nth-child(1)")
            .find(".content")
            .children()
            .each(function (i) {
              $(this)
                .stop()
                .delay(i * 95)
                .transition(
                  {
                    opacity: 1,
                    "padding-top": 0,
                  },
                  600,
                  "easeOutQuart"
                );
            });
        }

        ////last
        if ($($containerClass + " .swiper-slide-active").index() + 1 == 2) {
          $($containerClass + " .swiper-slide:nth-child(" + $slideNum + ")")
            .find(".content")
            .children()
            .each(function (i) {
              $(this)
                .stop()
                .delay(i * 95)
                .transition(
                  {
                    opacity: 1,
                    "padding-top": 0,
                  },
                  600,
                  "easeOutQuart"
                );
            });
        }

        //looped last going to first
        if (
          $($containerClass + " .swiper-slide-active").index() + 1 ==
          $slideNum
        ) {
          $($containerClass + " .swiper-slide:nth-child(2)")
            .find(".content")
            .children()
            .each(function (i) {
              $(this)
                .stop()
                .delay(i * 95)
                .transition(
                  {
                    opacity: 1,
                    "padding-top": 0,
                  },
                  600,
                  "easeOutQuart"
                );
            });
        }

        //looped first going to last
        if ($($containerClass + " .swiper-slide-active").index() + 1 == 1) {
          $($containerClass + " .swiper-slide:eq(-2)")
            .find(".content")
            .children()
            .each(function (i) {
              $(this)
                .stop()
                .delay(i * 95)
                .transition(
                  {
                    opacity: 1,
                    "padding-top": 0,
                  },
                  600,
                  "easeOutQuart"
                );
            });
        }
      }
    } //if using loop

    //play video if there's one
    setTimeout(function () {
      playVideoBG(
        $($containerClass + " .swiper-slide-active").index() + 1,
        $containerClass
      );
    }, 50);

    //fadeIn active slide
    if ($($containerClass).attr("data-overall_style") != "directional") {
      $(
        $containerClass + " .swiper-slide:nth-child(" + (currentSlide + 1) + ")"
      )
        .find(".content")
        .children()
        .each(function (i) {
          $(this)
            .stop()
            .delay(i * 95)
            .transition(
              {
                opacity: 1,
                "padding-top": 0,
              },
              600,
              "easeOutQuart"
            );
        });
    }

    $captionTrans++;
    if ($captionTrans == $(".swiper-wrapper").length) {
      $("div.first_video_slide").addClass("nulled");
    }

    //slider arrows with preview effect
    setTimeout(function () {
      if ($(".slider-next").hasClass("next-arrow-move")) {
        $(
          '.nectar-slider-wrap[data-button-styling="btn_with_preview"] .swiper-container .slider-next'
        ).trigger("mouseenter");
      } else if ($(".slider-prev").hasClass("prev-arrow-move")) {
        $(
          '.nectar-slider-wrap[data-button-styling="btn_with_preview"] .swiper-container .slider-prev'
        ).trigger("mouseenter");
      }

      if (
        $($containerClass).attr("data-button-styling") == "btn_with_preview"
      ) {
        $($containerClass + " .swiper-slide").addClass(
          "prev-high-z-index-static"
        );
        $($containerClass + " .swiper-slide.swiper-slide-active").removeClass(
          "prev-high-z-index-static"
        );
      }
    }, 175);
  }

  //used in caption transition
  function playVideoBG(nthChild, containerClass) {
    if (
      $(containerClass + " .swiper-slide:nth-child(" + nthChild + ")").find(
        ".video-wrap video"
      ).length > 0
    ) {
      if (!$("html").hasClass("no-video"))
        $(containerClass + " .swiper-slide:nth-child(" + nthChild + ")")
          .find(".video-wrap video")
          .get(0)
          .play();

      if (
        !$(containerClass + " .swiper-slide:nth-child(" + nthChild + ")")
          .find(".mejs-overlay.mejs-overlay-play")
          .hasClass("playing") &&
        $(containerClass + " .swiper-slide:nth-child(" + nthChild + ")")
          .find(".mejs-overlay.mejs-overlay-play")
          .hasClass("mobile-played")
      ) {
        $(containerClass + " .swiper-slide:nth-child(" + nthChild + ")")
          .find(".mejs-overlay.mejs-overlay-play")
          .addClass("playing");
      }
      if (
        !$(containerClass + " .swiper-slide:nth-child(" + nthChild + ")")
          .find(".mejs-poster")
          .hasClass("playing") &&
        $(containerClass + " .swiper-slide:nth-child(" + nthChild + ")")
          .find(".mejs-poster")
          .hasClass("mobile-played")
      )
        $(containerClass + " .swiper-slide:nth-child(" + nthChild + ")")
          .find(".mejs-poster")
          .addClass("playing");

      var $that = $(
        containerClass + " .swiper-slide:nth-child(" + nthChild + ")"
      ).find(".mejs-overlay.mejs-overlay-play");
      var $that2 = $(
        containerClass + " .swiper-slide:nth-child(" + nthChild + ")"
      ).find(".mejs-poster");

      if ($that.hasClass("playing") && $that.hasClass("mobile-played")) {
        setTimeout(function () {
          $that.addClass("behind-buttons");
          $that2.addClass("behind-buttons");
        }, 200);
      } else {
        $that.removeClass("behind-buttons");
        $that2.removeClass("behind-buttons");
      }
    }
  }

  var $startingSlide = null;

  function slideContentPos() {
    $(".swiper-wrapper").each(function () {
      //etxra space if first slider in section
      var $extraHeight =
        $(this).parents(".nectar-slider-wrap").hasClass("first-section") ||
        $(this).parents(".parallax_slider_outer").hasClass("first-section")
          ? 30
          : 0;

      var $sliderHeight = parseInt(
        $(this).parents(".swiper-container").attr("data-height")
      );

      var $transparentHeader =
        $('#header-outer[data-transparent-header="true"]').length > 0
          ? $("#header-space").height()
          : 0;
      if (
        $(this).parents(".first-section").length == 0 ||
        window.innerWidth < 1000
      ) {
        $transparentHeader = null;
      } else if (
        $transparentHeader != 0 &&
        $('#header-outer[data-remove-border="true"]').length > 0
      ) {
        $transparentHeader = $transparentHeader / 2;
      }

      $(this)
        .find(".swiper-slide")
        .each(function () {
          var $contentHeight = $(this).find(".content").height();
          var $contentItems = $(this).find(".content > *").length;

          $contentHeight2 = 0;
          $(this)
            .find(".content > *")
            .each(function () {
              $contentHeight2 +=
                $(this).height() +
                parseInt($(this).css("margin-bottom")) +
                parseInt($(this).css("padding-bottom"));
            });

          if ($(this).find(".content > *").css("padding-top") == "25px")
            $contentHeight = $contentHeight - 25 * $contentItems;

          if ($(this).attr("data-y-pos") == "top") {
            var $topHeight =
              $contentHeight2 / 2 <
              ($sliderHeight + $transparentHeader) / 4 - 30
                ? ($sliderHeight + $transparentHeader) / 4 -
                  $contentHeight2 / 2 +
                  20
                : ($sliderHeight + $transparentHeader) / 8;
            $(this)
              .find(".content")
              .css("top", $topHeight + "px");
          } else if ($(this).attr("data-y-pos") == "middle") {
            $(this)
              .find(".content")
              .css(
                "top",
                ($sliderHeight + $transparentHeader) / 2 -
                  $contentHeight2 / 2 +
                  "px"
              );
          } else {
            if ($contentHeight2 > 180) {
              $(this)
                .find(".content")
                .css(
                  "top",
                  ($sliderHeight + $transparentHeader) / 2 -
                    $contentHeight2 / 10 +
                    "px"
                );
            } else {
              $(this)
                .find(".content")
                .css(
                  "top",
                  ($sliderHeight + $transparentHeader) / 2 +
                    $contentHeight2 / 9 +
                    "px"
                );
            }
          }
        });
    });
  }

  function showSliderControls() {
    $(
      ".swiper-container .slider-prev, .swiper-container .slider-next, .slider-pagination"
    ).animate({ opacity: 1 }, 550, "easeOutSine");
  }

  var sliderLength = $(".swiper-container").length;
  var sliderLoadedLength = 0;

  function sliderLoadIn(slider, index) {
    slider.find(".nectar-slider-loading").fadeOut(800, "easeInOutExpo");
    $(
      'body #header-outer[data-transparent-header="true"] .ns-loading-cover'
    ).fadeOut(800, "easeInOutExpo", function () {
      $(this).remove();
      $(
        ".nectar-slider-wrap.first-section .swiper-container .swiper-wrapper .swiper-slide"
      ).removeClass("not-loaded");
    });

    slider.find("span.ie-fix").remove();

    ///make sure to init smooth scrolling after slider height exists
    var $smoothActive = $("body").attr("data-smooth-scrolling");
    if (
      $smoothActive == 1 &&
      $(window).width() > 690 &&
      $("body").outerHeight(true) > $(window).height() &&
      $("#ascrail2000").length == 0 &&
      !navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/
      )
    ) {
      niceScrollInit();
      resizeToCover();
    }

    //check for sliders in tabbed
    sliderLoadedLength++;
    if (
      $(".tabbed").find(".swiper-container").length > 0 &&
      sliderLoadedLength == sliderLength
    ) {
      setTimeout(function () {
        $(".tabbed > ul li:first-child a").click();
      }, 200);
    }

    if (
      !navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/
      )
    )
      autorotateInit(slider, index);
  }

  //play video user is hovering over
  $("body").on("mouseover", ".swiper-slide", function () {
    if (
      $(this).find("video").length > 0 &&
      $(this).find("video").get(0).paused == true &&
      $animating == false
    ) {
      $(this).find("video").get(0).play();
    }
  });

  //mobile play event
  $("body").on("click", ".mejs-overlay.mejs-overlay-play", function () {
    $(this).toggleClass("playing");
    $(this).addClass("mobile-played");

    $(this).parent().find(".mejs-poster").toggleClass("playing");
    $(this).parent().find(".mejs-poster").addClass("mobile-played");

    var $that = $(this);
    var $that2 = $(this).parent().find(".mejs-poster");

    if ($(this).hasClass("playing") && $(this).hasClass("mobile-played")) {
      setTimeout(function () {
        $that.addClass("behind-buttons");
        $that2.addClass("behind-buttons");
      }, 200);
    } else {
      setTimeout(function () {
        $that.removeClass("behind-buttons");
        $that2.removeClass("behind-buttons");
      }, 1);
    }
  });

  var $sliderHeight = parseInt(
    $(this).find(".swiper-container").attr("data-height")
  );
  var portfolioHeaderHeight =
    $(".project-title.parallax-effect").length > 0 ? 100 : 0;

  function autorotateInit(slider, num) {
    //$('.nectar-slider-wrap').each(function(i){
    var $autoplayVal = slider.attr("data-autorotate");
    var $that = slider;
    var $sliderNum = num;

    if (
      typeof $autoplayVal != "undefined" &&
      $autoplayVal.length != "0" &&
      parseInt($autoplayVal)
    ) {
      nectarSlideRotateInit(slider, $autoplayVal, $sliderNum);
    }

    //});
  }

  function nectarSlideRotateInit(slider, interval, sliderNum) {
    autoplay[sliderAutoplayCount] = setInterval(function () {
      nectarSlideRotate(slider, sliderNum);
    }, interval);

    $("#" + slider.attr("id")).attr("autoplay-id", sliderAutoplayCount);

    $(
      "#" +
        slider.attr("id") +
        " a.slider-prev, #" +
        slider.attr("id") +
        " a.slider-next, #" +
        slider.attr("id") +
        " .slider-pagination span"
    ).click(function (e) {
      if (typeof e.clientY != "undefined") {
        clearInterval(autoplay[$("#" + slider.attr("id")).attr("autoplay-id")]);

        //class for directional
        if (
          $("#" + slider.attr("id"))
            .parent()
            .hasClass("parallax_slider_outer") &&
          $("#" + slider.attr("id")).attr("data-overall_style") == "directional"
        ) {
          $("#" + slider.attr("id"))
            .parent()
            .addClass("user-stopped");
        }
      }
    });

    sliderAutoplayCount++;
  }

  function nectarSlideRotate(slider, sliderNum) {
    if ($("#nectar_fullscreen_rows").length > 0) {
      if ($(slider).parents(".wpb_row.active").length == 0) {
        return true;
      }
    }
    //non looped
    if (
      $nectarSliders[sliderNum].activeIndex + 1 <
      $(slider).find(".swiper-wrapper > div.swiper-slide").length
    ) {
      //btn with preview hover effect clear
      if ($(slider).attr("data-button-styling") == "btn_with_preview") {
        $(slider)
          .find(".swiper-slide")
          .removeClass("high-z-index")
          .removeClass("prev-high-z-index");
        $(slider)
          .find(".swiper-slide")
          .removeClass("next-move")
          .removeClass("prev-move");
      }

      //classic style
      if ($(slider).attr("data-overall_style") != "directional") {
        $nectarSliders[sliderNum].swipeNext();
      } else {
        //directional based
        $($nectarSliders[sliderNum].container)
          .find(".slider-next")
          .trigger("click");
      }
    } else {
      //looped sliders
      if (
        $(slider).find(".swiper-container").is("[data-loop]") &&
        $(slider).find(".swiper-container").attr("data-loop") == "true"
      ) {
        //classic style
        if ($(slider).attr("data-overall_style") != "directional") {
          $nectarSliders[sliderNum].swipeNext();
        } else {
          //directional based
          $($nectarSliders[sliderNum].container)
            .find(".slider-next")
            .trigger("click");
        }
      }
      //regular sliders
      else {
        if ($(slider).attr("data-overall_style") != "directional") {
          $nectarSliders[sliderNum].swipeTo(0, 800);
        } else {
          $(slider)
            .find(".swiper-container")
            .addClass("directional-trans-prev");
          $nectarSliders[sliderNum].swipeTo(0, 800);
          //call the dark/light slide coloring half way through transition
          var $timeout2;
          clearTimeout($timeout2);
          $timeout2 = setTimeout(function () {
            onChangeStart($nectarSliders[sliderNum]);
          }, 100);
        }
      }
    }
  }

  function clearAutoplay(e) {
    var $autoplayVal = $("#" + $(e.container).parent().attr("id")).attr(
      "data-autorotate"
    );

    if (
      typeof $autoplayVal != "undefined" &&
      $autoplayVal.length != "0" &&
      parseInt($autoplayVal)
    ) {
      clearInterval(
        autoplay[
          $("#" + $(e.container).parent().attr("id")).attr("autoplay-id")
        ]
      );
    }
  }

  var animationQueue = null;

  function onChangeStart(e) {
    //performance
    //$('.swiper-wrapper').css('will-change','transform');

    //cache slider obj
    var $obj = e;

    $animating = true;

    var $slideNum = $($obj.container).find(".swiper-wrapper > div").length;

    //one for effects and one for basic slide arrow count
    $activeIndex =
      $($obj.container).attr("data-loop") == "true"
        ? $obj.activeIndex + 1
        : $obj.activeIndex + 1;
    $activeIndex2 =
      $($obj.container).attr("data-loop") == "true"
        ? $obj.activeIndex
        : $obj.activeIndex + 1;

    //dark slide header
    if (
      $($obj.container).parent().attr("data-overall_style") != "directional"
    ) {
      if (
        ($($obj.container).parents(".parallax_slider_outer").length > 0 &&
          $($obj.container).find(
            '.swiper-slide-active[data-color-scheme="dark"]'
          ).length > 0) ||
        ($($obj.container).parents(".first-section").length > 0 &&
          $($obj.container).find(
            '.swiper-slide-active[data-color-scheme="dark"]'
          ).length > 0)
      ) {
        $("#header-outer").addClass("dark-slide");
      } else if (
        $($obj.container).parents(".parallax_slider_outer").length > 0 ||
        $($obj.container).parents(".first-section").length > 0
      ) {
        $("#header-outer").removeClass("dark-slide");
      }
    }
    ////directional trans - will be called early so need to adjust the slide being looked for
    else {
      if ($($obj.container).hasClass("directional-trans-next")) {
        if (
          ($($obj.container).parents(".parallax_slider_outer").length > 0 &&
            $($obj.container)
              .find(".swiper-slide-active")
              .next(".swiper-slide")
              .is('[data-color-scheme="dark"]')) ||
          ($($obj.container).parents(".first-section").length > 0 &&
            $($obj.container)
              .find(".swiper-slide-active")
              .next(".swiper-slide")
              .is('[data-color-scheme="dark"]'))
        ) {
          $("#header-outer").addClass("dark-slide");
          //nav items animation
          if ($("body.mobile").length == 0) {
            $(
              "#header-outer nav > ul.sf-menu > li > a, #header-outer nav > ul.buttons > li#search-btn a, #header-outer nav > ul.buttons > li.slide-out-widget-area-toggle a > span, #header-outer .cart-icon-wrap, header#top #logo"
            ).each(function () {
              var $itemWidth = parseInt(
                $(this).find("span.original").attr("data-w")
              );

              $(this)
                .find("span.dark")
                .css("display", "inline")
                .transition({ "margin-left": "0" }, 0)
                .transition({ width: $itemWidth }, 325, "easeInOutQuart");
              $(this)
                .find("span.dark > span")
                .transition({ "margin-left": "0" }, 0);
              $(this)
                .find("span.light")
                .css("display", "inline-block")
                .transition(
                  { "margin-left": $itemWidth, width: "0" },
                  325,
                  "easeInOutQuart"
                );
              $(this)
                .find("span.light > span")
                .transition(
                  { "margin-left": "-" + $itemWidth + "px", width: $itemWidth },
                  325,
                  "easeInOutQuart"
                );
            });
          }
        } else {
          $("#header-outer").removeClass("dark-slide");
          //nav items animation
          if ($("body.mobile").length == 0) {
            $(
              "#header-outer nav > ul.sf-menu > li > a, #header-outer nav > ul.buttons > li#search-btn a, #header-outer nav > ul.buttons > li.slide-out-widget-area-toggle a > span, #header-outer .cart-icon-wrap, header#top #logo"
            ).each(function () {
              var $itemWidth = parseInt(
                $(this).find("span.original").attr("data-w")
              );

              $(this)
                .find("span.light")
                .css("display", "inline")
                .transition({ "margin-left": "0" }, 0)
                .css("display", "inline")
                .transition({ width: $itemWidth }, 325, "easeInOutQuart");
              $(this)
                .find("span.light > span")
                .transition({ "margin-left": "0" }, 0);
              $(this)
                .find("span.dark")
                .css("display", "inline-block")
                .transition(
                  { "margin-left": $itemWidth, width: "0" },
                  325,
                  "easeInOutQuart"
                );
              $(this)
                .find("span.dark > span")
                .transition(
                  { "margin-left": "-" + $itemWidth + "px", width: $itemWidth },
                  325,
                  "easeInOutQuart"
                );
            });
          }
        }
      } else if ($($obj.container).hasClass("directional-trans-prev")) {
        if (
          ($($obj.container).parents(".parallax_slider_outer").length > 0 &&
            $($obj.container)
              .find(".swiper-slide-active")
              .prev(".swiper-slide")
              .is('[data-color-scheme="dark"]')) ||
          ($($obj.container).parents(".first-section").length > 0 &&
            $($obj.container)
              .find(".swiper-slide-active")
              .prev(".swiper-slide")
              .is('[data-color-scheme="dark"]'))
        ) {
          $("#header-outer").addClass("dark-slide");
          //nav items animation
          if ($("body.mobile").length == 0) {
            $(
              "#header-outer nav > ul.sf-menu > li > a, #header-outer nav > ul.buttons > li#search-btn a, #header-outer nav > ul.buttons > li.slide-out-widget-area-toggle a > span, #header-outer .cart-icon-wrap, header#top #logo"
            ).each(function () {
              var $itemWidth = parseInt(
                $(this).find("span.original").attr("data-w")
              );

              $(this)
                .find("span.dark")
                .css("display", "inline")
                .transition({ "margin-left": "0" }, 0)
                .transition({ width: $itemWidth }, 325, "easeInOutQuart");
              $(this)
                .find("span.dark > span")
                .transition({ "margin-left": "0" }, 0);
              $(this)
                .find("span.light")
                .css("display", "inline-block")
                .transition(
                  { "margin-left": $itemWidth, width: "0" },
                  325,
                  "easeInOutQuart"
                );
              $(this)
                .find("span.light > span")
                .transition(
                  { "margin-left": "-" + $itemWidth + "px", width: $itemWidth },
                  325,
                  "easeInOutQuart"
                );
            });
          }
        } else {
          $("#header-outer").removeClass("dark-slide");
          //nav items animation
          if ($("body.mobile").length == 0) {
            $(
              "#header-outer nav > ul.sf-menu > li > a, #header-outer nav > ul.buttons > li#search-btn a, #header-outer nav > ul.buttons > li.slide-out-widget-area-toggle a > span, #header-outer .cart-icon-wrap, header#top #logo"
            ).each(function () {
              var $itemWidth = parseInt(
                $(this).find("span.original").attr("data-w")
              );

              $(this)
                .find("span.light")
                .css("display", "inline")
                .transition({ "margin-left": "0" }, 0)
                .transition({ width: $itemWidth }, 325, "easeInOutQuart");
              $(this)
                .find("span.light > span")
                .transition({ "margin-left": "0" }, 0);
              $(this)
                .find("span.dark")
                .css("display", "inline-block")
                .transition(
                  { "margin-left": $itemWidth, width: "0" },
                  325,
                  "easeInOutQuart"
                );
              $(this)
                .find("span.dark > span")
                .transition(
                  { "margin-left": "-" + $itemWidth + "px", width: $itemWidth },
                  325,
                  "easeInOutQuart"
                );
            });
          }
        }
      } else if ($($obj.container).hasClass("directional-trans-current")) {
        if (
          ($($obj.container).parents(".parallax_slider_outer").length > 0 &&
            $($obj.container)
              .find(".swiper-slide-active")
              .is('[data-color-scheme="dark"]')) ||
          ($($obj.container).parents(".first-section").length > 0 &&
            $($obj.container)
              .find(".swiper-slide-active")
              .is('[data-color-scheme="dark"]'))
        ) {
          $("#header-outer").addClass("dark-slide");
          //nav items animation
          if ($("body.mobile").length == 0) {
            $(
              "#header-outer nav > ul.sf-menu > li > a, #header-outer nav > ul.buttons > li#search-btn a, #header-outer nav > ul.buttons > li.slide-out-widget-area-toggle a > span, #header-outer .cart-icon-wrap, header#top #logo"
            ).each(function () {
              var $itemWidth = parseInt(
                $(this).find("span.original").attr("data-w")
              );

              $(this)
                .find("span.dark")
                .css("display", "inline")
                .transition({ "margin-left": "0" }, 0)
                .transition({ width: $itemWidth }, 325, "easeInOutQuart");
              $(this)
                .find("span.dark > span")
                .transition({ "margin-left": "0" }, 0);
              $(this)
                .find("span.light")
                .css("display", "inline-block")
                .transition(
                  { "margin-left": $itemWidth, width: "0" },
                  325,
                  "easeInOutQuart"
                );
              $(this)
                .find("span.light > span")
                .transition(
                  { "margin-left": "-" + $itemWidth + "px", width: $itemWidth },
                  325,
                  "easeInOutQuart"
                );
            });
          }
        } else {
          $("#header-outer").removeClass("dark-slide");
          //nav items animation
          if ($("body.mobile").length == 0) {
            $(
              "#header-outer nav > ul.sf-menu > li > a, #header-outer nav > ul.buttons > li#search-btn a, #header-outer nav > ul.buttons > li.slide-out-widget-area-toggle a > span, #header-outer .cart-icon-wrap, header#top #logo"
            ).each(function () {
              var $itemWidth = parseInt(
                $(this).find("span.original").attr("data-w")
              );

              $(this)
                .find("span.light")
                .css("display", "inline")
                .transition({ "margin-left": "0" }, 0)
                .transition({ width: $itemWidth }, 325, "easeInOutQuart");
              $(this)
                .find("span.light > span")
                .transition({ "margin-left": "0" }, 0);
              $(this)
                .find("span.dark")
                .css("display", "inline-block")
                .transition(
                  { "margin-left": $itemWidth, width: "0" },
                  325,
                  "easeInOutQuart"
                );
              $(this)
                .find("span.dark > span")
                .transition(
                  { "margin-left": "-" + $itemWidth + "px", width: $itemWidth },
                  325,
                  "easeInOutQuart"
                );
            });
          }
        }
      }
    }

    //light and dark controls
    if (
      $($obj.container).parent().attr("data-overall_style") != "directional"
    ) {
      if (
        $($obj.container)
          .find(".swiper-slide:nth-child(" + $activeIndex + ")")
          .attr("data-color-scheme") == "dark"
      ) {
        $($obj.container).find(".slider-pagination").addClass("dark-cs");
        $($obj.container)
          .find(".slider-prev, .slider-next")
          .addClass("dark-cs");
      } else {
        $($obj.container).find(".slider-pagination").removeClass("dark-cs");
        $($obj.container)
          .find(".slider-prev, .slider-next")
          .removeClass("dark-cs");
      }
    }
    ////directional trans - will be called early so need to adjust the slide being looked for
    else {
      if ($($obj.container).hasClass("directional-trans-next")) {
        if (
          $($obj.container)
            .find(".swiper-slide:nth-child(" + ($activeIndex + 1) + ")")
            .attr("data-color-scheme") == "dark"
        ) {
          $($obj.container).find(".slider-pagination").addClass("dark-cs");
          $($obj.container)
            .find(".slider-prev, .slider-next")
            .addClass("dark-cs");
        } else {
          $($obj.container).find(".slider-pagination").removeClass("dark-cs");
          $($obj.container)
            .find(".slider-prev, .slider-next")
            .removeClass("dark-cs");
        }
      } else if ($($obj.container).hasClass("directional-trans-prev")) {
        if (
          $($obj.container)
            .find(".swiper-slide:nth-child(" + ($activeIndex - 1) + ")")
            .attr("data-color-scheme") == "dark"
        ) {
          $($obj.container).find(".slider-pagination").addClass("dark-cs");
          $($obj.container)
            .find(".slider-prev, .slider-next")
            .addClass("dark-cs");
        } else {
          $($obj.container).find(".slider-pagination").removeClass("dark-cs");
          $($obj.container)
            .find(".slider-prev, .slider-next")
            .removeClass("dark-cs");
        }
      } else if ($($obj.container).hasClass("directional-trans-current")) {
        if (
          $($obj.container)
            .find(".swiper-slide:nth-child(" + $activeIndex + ")")
            .attr("data-color-scheme") == "dark"
        ) {
          $($obj.container).find(".slider-pagination").addClass("dark-cs");
          $($obj.container)
            .find(".slider-prev, .slider-next")
            .addClass("dark-cs");
        } else {
          $($obj.container).find(".slider-pagination").removeClass("dark-cs");
          $($obj.container)
            .find(".slider-prev, .slider-next")
            .removeClass("dark-cs");
        }
      }
    }

    $($obj.container)
      .find(".swiper-slide .video-texture")
      .removeClass("no-trans")
      .removeClass("light-overlay")
      .removeClass("dark-overlay")
      .removeClass("half-dark-overlay")
      .removeClass("half-light-overlay");

    //add slide counts
    $($obj.container)
      .find(".slider-prev .slide-count .slide-current")
      .html($activeIndex2);
    $($obj.container)
      .find(".slider-next .slide-count .slide-current")
      .html($activeIndex2);

    if ($($obj.container).attr("data-loop") == "true") {
      //duplicate first slide
      if ($($obj.container).find(".swiper-slide-active").index() + 1 == 1) {
        $($obj.container)
          .find(
            ".slider-next .slide-count .slide-current, .slider-prev .slide-count .slide-current"
          )
          .html($slideNum - 2);
      }
      //duplicate last slide
      else if (
        $($obj.container).find(".swiper-slide-active").index() + 1 ==
        $slideNum
      ) {
        $($obj.container)
          .find(
            ".slider-next .slide-count .slide-current, .slider-prev .slide-count .slide-current"
          )
          .html(1);
      }
    }

    if ($obj.activeIndex >= 10) {
      $($obj.container)
        .find(".slider-next .slide-count .slide-current")
        .addClass("double-digits");
    } else {
      $($obj.container)
        .find(".slider-next .slide-count .slide-current")
        .removeClass("double-digits");
    }

    $($obj.container)
      .find('.swiper-slide:not(".swiper-slide-active")')
      .each(function () {
        if ($(this).find(".video-wrap video").length > 0) {
          //if($(this).find('.video-wrap video').get(0).currentTime != 0 ) $(this).find('.video-wrap video').get(0).currentTime = 0;
        }
      });

    //don't allow swiping on duplicate transition
    if ($($obj.container).attr("data-loop") == "true") {
      if (
        ($obj.previousIndex == 1 && $obj.activeIndex == 0) ||
        ($obj.previousIndex == $slideNum - 2 &&
          $obj.activeIndex == $slideNum - 1)
      ) {
        $(".swiper-slide").addClass("duplicate-transition");
      }
    }

    clearTimeout(animationQueue);
    animationQueue = setTimeout(function () {
      $animating = false;
      $(".swiper-slide").removeClass("duplicate-transition");
    }, 800);
  }

  //functions to add or remove slider for webkit parallax fix
  function hideSlider() {
    if (
      $(window).scrollTop() / ($sliderHeight + portfolioHeaderHeight + 125) >=
      1
    ) {
      $(
        ".parallax_slider_outer .nectar-slider-wrap, .project-title.parallax-effect"
      )
        .css("visibility", "hidden")
        .hide();
      $(".parallax_slider_outer")
        .removeClass("element-in-view")
        .addClass("element-out-of-view");

      //directional slider autorotate clear
      if (
        $(
          '.parallax_slider_outer .nectar-slider-wrap[data-overall_style="directional"]'
        ).length > 0
      ) {
        var $autoplayVal = $(
          '.parallax_slider_outer .nectar-slider-wrap[data-overall_style="directional"]'
        ).attr("data-autorotate");
        if (
          typeof $autoplayVal != "undefined" &&
          $autoplayVal.length != "0" &&
          parseInt($autoplayVal)
        ) {
          clearInterval(
            autoplay[
              $(".parallax_slider_outer .nectar-slider-wrap").attr(
                "autoplay-id"
              )
            ]
          );
        }
      }

      $(window).on("scroll", showSlider);
      $(window).off("scroll", hideSlider);
    }
  }

  function showSlider() {
    if (
      $(window).scrollTop() / ($sliderHeight + portfolioHeaderHeight + 125) <=
      1
    ) {
      $(
        ".parallax_slider_outer .nectar-slider-wrap, .project-title.parallax-effect"
      )
        .css("visibility", "visible")
        .show();
      $(".parallax_slider_outer").addClass("element-in-view");

      //directional slider autorotate restart
      if (
        $(
          '.parallax_slider_outer .nectar-slider-wrap[data-overall_style="directional"]'
        ).length > 0 &&
        $(".parallax_slider_outer.element-out-of-view").length > 0 &&
        $(".parallax_slider_outer.user-stopped").length == 0
      ) {
        var $autoplayVal = $(
          '.parallax_slider_outer .nectar-slider-wrap[data-overall_style="directional"]'
        ).attr("data-autorotate");
        if (
          typeof $autoplayVal != "undefined" &&
          $autoplayVal.length != "0" &&
          parseInt($autoplayVal)
        ) {
          nectarSlideRotateInit(
            $(".parallax_slider_outer .nectar-slider-wrap"),
            $autoplayVal,
            0
          );
        }
      }

      $(".parallax_slider_outer").removeClass("element-out-of-view");

      //resize iframes incase user resized window when out of view
      $(".swiper-slide iframe[data-aspectRatio]").each(function () {
        var newWidth = $(this).parent().width();
        var $el = $(this);
        if ($(this).is(":visible"))
          $el.width(newWidth).height(newWidth * $el.attr("data-aspectRatio"));
      });

      nsSliderContentResize();

      //show content on current slide - could have been hidden from autorotate when slider was hidden
      if ($(".parallax_slider_outer").length > 0) {
        var fromLeft = Math.abs(
          parseInt(
            $(".parallax_slider_outer .nectar-slider-wrap .swiper-wrapper").css(
              "left"
            )
          )
        );
        var currentSlide = Math.round(
          fromLeft /
            $(
              ".parallax_slider_outer .nectar-slider-wrap .swiper-slide"
            ).width()
        );

        $(
          ".parallax_slider_outer .swiper-wrapper .swiper-slide:eq(" +
            currentSlide +
            ")"
        )
          .find(".content")
          .children()
          .each(function (i) {
            $(this).stop(true, true).css({ opacity: 1, "padding-top": 0 });
          });

        $(
          ".parallax_slider_outer .swiper-wrapper .swiper-slide:eq(" +
            currentSlide +
            ")"
        ).addClass("autorotate-shown");
      }

      $(window).on("scroll", hideSlider);
      $(window).off("scroll", showSlider);
    }
  }

  function sliderCorrectDisplayCheck() {
    if (
      $(window).scrollTop() / ($sliderHeight + portfolioHeaderHeight + 125) >=
      1
    ) {
      hideSlider();
    }
    $(window).unbind("scroll", sliderCorrectDisplayCheck);
  }

  var $smoothActive = $("body").attr("data-smooth-scrolling");

  // Create cross browser requestAnimationFrame method:
  window.requestAnimationFrame =
    window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    function (f) {
      setTimeout(f, 1000 / 60);
    };

  var lastPosition = -1;
  var $headerRemoveStickyness =
    $('body[data-hhun="1"]').length > 0 &&
    $('#header-outer[data-remove-fixed="1"]').length > 0
      ? 1
      : 0;

  if ($headerRemoveStickyness) {
    var $multiplier1 = 0.55;
    var $multiplier2 = 0.45;
  } else {
    var $multiplier1 = $('body[data-hhun="1"]').length > 0 ? 0.4 : 0.2;
    var $multiplier2 = $('body[data-hhun="1"]').length > 0 ? 0.09 : 0.14;
  }

  var $parallaxHeaderHUN =
    $('#header-outer[data-transparency-option="1"]').length > 0 ? 0.49 : 0.4;

  function parallaxScroll() {
    var $scrollTop = $(window).scrollTop();

    // Avoid calculations if not needed
    if (
      lastPosition == $scrollTop ||
      $(".parallax_slider_outer.element-in-view").length == 0
    ) {
      // window.requestAnimationFrame(parallaxScroll);
      return false;
    } else lastPosition = $scrollTop;

    if (
      $smoothActive == 1 &&
      navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1
    ) {
      return false;
    }

    if (
      $('body[data-hhun="1"]').length > 0 &&
      !$("#header-outer").hasClass("side-widget-open") &&
      !$("#header-outer .slide-out-widget-area-toggle a").hasClass("animating")
    ) {
      $("#header-outer.parallax-contained").css({
        transform: "translateY(" + $scrollTop * -$parallaxHeaderHUN + "px)",
      });
    }
    $(
      '.parallax_slider_outer.first-section .nectar-slider-wrap[data-parallax="true"]'
    ).css({ transform: "translateY(" + $scrollTop * -$multiplier1 + "px)" });

    $(
      '.parallax_slider_outer.first-section .swiper-slide:not(".static"):not(".caption-no-fade") .content, .parallax_slider_outer.first-section .nectar-slider-wrap[data-parallax="true"] .swiper-container .slider-next, .parallax_slider_outer.first-section .nectar-slider-wrap[data-parallax="true"] .swiper-container .slider-prev, .swiper-wrapper .slider-down-arrow'
    ).css({ transform: "translateY(" + $scrollTop * -$multiplier2 + "px)" });
    if (!$headerRemoveStickyness) {
      $(
        '.parallax_slider_outer.first-section .swiper-slide:not(".static"):not(".caption-no-fade") .content, .parallax_slider_outer.first-section .nectar-slider-wrap[data-parallax="true"] .swiper-container .slider-next, .parallax_slider_outer.first-section .nectar-slider-wrap[data-parallax="true"] .swiper-container .slider-prev, .swiper-wrapper .slider-down-arrow'
      ).css({ opacity: 1 - $scrollTop / ($sliderHeight - 120) });
    }

    $("#full_width_portfolio .project-title.parallax-effect").css({
      transform: "translateY(" + $scrollTop * -$multiplier1 + "px)",
    });

    //$('.parallax_slider_outer.first-section .swiper-slide:not(".caption-no-fade") .content, .parallax_slider_outer.first-section .nectar-slider-wrap[data-parallax="true"] .swiper-container .slider-next, .parallax_slider_outer.first-section .nectar-slider-wrap[data-parallax="true"] .swiper-container .slider-prev, .swiper-wrapper .slider-down-arrow').css('opacity', 1-($scrollTop/($sliderHeight-120)) );

    //window.requestAnimationFrame(parallaxScroll);
  }

  function sliderParallaxUpdateHeight() {
    $sliderHeight = parseInt(
      $(".parallax_slider_outer.first-section .swiper-container").attr(
        "data-height"
      )
    );

    $(".project-title").css({
      top: $headerNavSpace + $adminBarHeight + "px",
      width: $("#ajax-content-wrap").width(),
    });
  }

  var $sliderHeight = parseInt(
    $(".parallax_slider_outer.first-section .swiper-container").attr(
      "data-height"
    )
  );
  var $adminBarHeight = $("#wpadminbar").length > 0 ? 28 : 0;
  var $headerNavSpace =
    $('body[data-header-format="left-header"]').length > 0 &&
    $(window).width() > 1000
      ? 0
      : $("#header-space").height();

  function sliderParallaxInit() {
    if (
      $("#portfolio-extra").length > 0 &&
      $("#full_width_portfolio").length == 0
    ) {
      return false;
    }

    //$(window).on('scroll.nsParallaxScroll',parallaxScroll);
    $(".parallax_slider_outer").addClass("element-in-view");

    window.addEventListener(
      "scroll",
      function () {
        window.requestAnimationFrame(parallaxScroll);
      },
      false
    );
    parallaxScroll();

    //hide slider to not mess up parallax section
    var portfolioHeaderHeight =
      $(".project-title.parallax-effect").length > 0 ? 100 : 0;

    function displayParallaxSliderInit() {
      if (
        $(window).scrollTop() / ($sliderHeight + portfolioHeaderHeight + 90) >=
        1
      ) {
        $(window).off("scroll.nsVisibilityHide");
        $(window).on("scroll.nsVisibilityHide", hideSlider);
        $(window).on("scroll", showSlider);
      } else {
        $(window).off("scroll.nsVisibilityShow");
        $(window).on("scroll.nsVisibilityShow", showSlider);
        $(window).off("scroll", hideSlider);
      }
    }

    displayParallaxSliderInit();

    $(window).off("scroll.nsCorrectDisplayCheck");
    $(window).on("scroll.nsCorrectDisplayCheck", sliderCorrectDisplayCheck);

    $(
      'body:not(".single") .page-header-no-bg, body:not(".single") #page-header-wrap, body:not(".single") #page-header-bg'
    ).remove();

    $(".project-title")
      .addClass("parallax-effect")
      .css({
        top: $headerNavSpace + $adminBarHeight + "px",
        width: $("#ajax-content-wrap").width(),
      });

    //caption alignment if portfolio fullwidth parallax
    if ($(".project-title.parallax-effect").length > 0) {
      $(
        ".parallax_slider_outer.first-section .swiper-slide .content, .nectar-slider-wrap.first-section .swiper-slide .content"
      ).css("margin-top", "0px");
      $(".swiper-container .slider-prev, .swiper-container .slider-next").css(
        "margin-top",
        "-28px"
      );
    }

    //if using wooCommerce sitewide notice
    if ($(".demo_store").length > 0)
      $(".project-title.parallax-effect").css("margin-top", "-25px");

    if ($("#full_width_portfolio").length > 0) {
      $(".parallax_slider_outer.first-section").css("margin-top", "93px");
    }

    $(window).off("resize.nsHeightUpdate");
    $(window).on("resize.nsHeightUpdate", sliderParallaxUpdateHeight);
  }

  //parallax
  function parallaxCheck() {
    $(window).off("scroll.nsParallaxScroll");

    if (
      $(".parallax_slider_outer").length > 0 &&
      !navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/
      )
    ) {
      sliderParallaxInit();
      if (
        $('body[data-hhun="1"]').length > 0 &&
        !$('#header-outer[data-remove-fixed="1"]').length > 0
      )
        $("#header-outer").addClass("parallax-contained");
    } else if (
      $(".parallax_slider_outer").length > 0 &&
      navigator.userAgent.match(
        /(Android|iPod|iPhone|iPad|IEMobile|Opera Mini)/
      )
    ) {
      $(".project-title")
        .addClass("parallax-effect")
        .css({
          top: $headerNavSpace + $adminBarHeight + "px",
          width: $("#ajax-content-wrap").width(),
        });

      $(
        'body:not(".single") .page-header-no-bg, body:not(".single") #page-header-wrap, body:not(".single") #page-header-bg'
      ).remove();
    } else {
      $(".project-title").css({ top: "0" });
    }
  }
  parallaxCheck();

  function niceScrollInit() {
    $("html").niceScroll({
      scrollspeed: 60,
      mousescrollstep: 40,
      cursorwidth: 15,
      cursorborder: 0,
      cursorcolor: "#303030",
      cursorborderradius: 6,
      autohidemode: false,
      horizrailenabled: false,
    });

    if ($("#boxed").length == 0) {
      $(
        "body, body #header-outer, body #header-secondary-outer, body #search-outer"
      ).css("padding-right", "16px");
    }

    $("html").addClass("no-overflow-y");
  }

  //pause video backgrounds if popup video player is started
  $(
    ".portfolio-items a.pp:contains(Video), .swiper-container .buttons a.pp"
  ).click(function () {
    $(".swiper-slide").each(function () {
      if ($(this).find(".video-wrap video").length > 0) {
        $(this).find(".video-wrap video").get(0).pause();
      }
    });
  });

  //solid button hover effect
  $.cssHooks.backgroundColor = {
    get: function (elem) {
      if (elem.currentStyle) var bg = elem.currentStyle["backgroundColor"];
      else if (window.getComputedStyle)
        var bg = document.defaultView
          .getComputedStyle(elem, null)
          .getPropertyValue("background-color");
      if (bg.search("rgb") == -1) return bg;
      else {
        bg = bg.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        function hex(x) {
          return ("0" + parseInt(x).toString(16)).slice(-2);
        }
        if (bg) {
          return "#" + hex(bg[1]) + hex(bg[2]) + hex(bg[3]);
        }
      }
    },
  };

  function shadeColor(color, shade) {
    var colorInt = parseInt(color.substring(1), 16);

    var R = (colorInt & 0xff0000) >> 16;
    var G = (colorInt & 0x00ff00) >> 8;
    var B = (colorInt & 0x0000ff) >> 0;

    R = R + Math.floor((shade / 255) * R);
    G = G + Math.floor((shade / 255) * G);
    B = B + Math.floor((shade / 255) * B);

    var newColorInt = (R << 16) + (G << 8) + B;
    var newColorStr = "#" + newColorInt.toString(16);

    return newColorStr;
  }

  function sliderbuttonHoverEffect() {
    $(".swiper-slide").each(function () {
      $(this)
        .find(".solid_color")
        .each(function () {
          var $currentColor = $(this).find("a").css("background-color");
          var $hoverColor = shadeColor($currentColor, -16);
          $(this)
            .find("a")
            .hover(
              function () {
                $(this).attr(
                  "style",
                  "background-color:" + $hoverColor + "!important;"
                );
              },
              function () {
                $(this).attr("style", "");
              }
            );
        });
    });
  }
  sliderbuttonHoverEffect();

  function sliderFontOverrides() {
    var $overrideCSS = "";

    $(".nectar-slider-wrap").each(function (i) {
      if ($(this).find(".swiper-container[data-tho]").length > 0) {
        $tho = $(this).find(".swiper-container").attr("data-tho");
        $tco = $(this).find(".swiper-container").attr("data-tco");
        $pho = $(this).find(".swiper-container").attr("data-pho");
        $pco = $(this).find(".swiper-container").attr("data-pco");

        //tablet
        if ($tho != "auto" || $tco != "auto") {
          $overrideCSS +=
            "@media only screen and (max-width: 1000px) and (min-width: 690px) {";
          if ($tho != "auto")
            $overrideCSS +=
              "#" +
              $(this).attr("id") +
              '.nectar-slider-wrap[data-full-width="false"] .swiper-slide .content h2, #boxed .nectar-slider-wrap#' +
              $(this).attr("id") +
              " .swiper-slide .content h2, body .nectar-slider-wrap#" +
              $(this).attr("id") +
              '[data-full-width="true"] .swiper-slide .content h2, body .nectar-slider-wrap#' +
              $(this).attr("id") +
              '[data-full-width="boxed-full-width"] .swiper-slide .content h2, body .full-width-content .vc_span12 .nectar-slider-wrap#' +
              $(this).attr("id") +
              " .swiper-slide .content h2 { font-size:" +
              $tho +
              "px!important; line-height:" +
              (parseInt($tho) + 10) +
              "px!important;  }";
          if ($pho != "auto")
            $overrideCSS +=
              "#" +
              $(this).attr("id") +
              '.nectar-slider-wrap[data-full-width="false"] .swiper-slide .content p, #boxed .nectar-slider-wrap#' +
              $(this).attr("id") +
              " .swiper-slide .content p, body .nectar-slider-wrap#" +
              $(this).attr("id") +
              '[data-full-width="true"] .swiper-slide .content p, body .nectar-slider-wrap#' +
              $(this).attr("id") +
              '[data-full-width="boxed-full-width"] .swiper-slide .content p, body .full-width-content .vc_span12 .nectar-slider-wrap#' +
              $(this).attr("id") +
              " .swiper-slide .content p { font-size:" +
              $tco +
              "px!important; line-height:" +
              (parseInt($tco) + 10) +
              "px!important;  }";
          $overrideCSS += "}";
        }

        //phone
        if ($pho != "auto" || $pco != "auto") {
          $overrideCSS += "@media only screen and (max-width: 690px) {";
          if ($pho != "auto")
            $overrideCSS +=
              "#" +
              $(this).attr("id") +
              '.nectar-slider-wrap[data-full-width="false"] .swiper-slide .content h2, #boxed .nectar-slider-wrap#' +
              $(this).attr("id") +
              " .swiper-slide .content h2, body .nectar-slider-wrap#" +
              $(this).attr("id") +
              '[data-full-width="true"] .swiper-slide .content h2, body .nectar-slider-wrap#' +
              $(this).attr("id") +
              '[data-full-width="boxed-full-width"] .swiper-slide .content h2, body .full-width-content .vc_span12 .nectar-slider-wrap#' +
              $(this).attr("id") +
              " .swiper-slide .content h2 { font-size:" +
              $pho +
              "px!important; line-height:" +
              (parseInt($pho) + 10) +
              "px!important;  }";
          if ($pho != "auto")
            $overrideCSS +=
              "#" +
              $(this).attr("id") +
              '.nectar-slider-wrap[data-full-width="false"] .swiper-slide .content p, #boxed .nectar-slider-wrap#' +
              $(this).attr("id") +
              " .swiper-slide .content p,  body .nectar-slider-wrap#" +
              $(this).attr("id") +
              '[data-full-width="true"] .swiper-slide .content p, body .nectar-slider-wrap#' +
              $(this).attr("id") +
              '[data-full-width="boxed-full-width"] .swiper-slide .content p, body .full-width-content .vc_span12 .nectar-slider-wrap#' +
              $(this).attr("id") +
              " .swiper-slide .content p { font-size:" +
              $pco +
              "px!important; line-height:" +
              (parseInt($pco) + 10) +
              "px!important;  }";
          $overrideCSS += "}";
        }
      }
    });

    if ($overrideCSS.length > 1) {
      var head = document.head || document.getElementsByTagName("head")[0];
      var style = document.createElement("style");

      style.type = "text/css";
      if (style.styleSheet) {
        style.styleSheet.cssText = $overrideCSS;
      } else {
        style.appendChild(document.createTextNode($overrideCSS));
      }

      head.appendChild(style);
    }
  }
  sliderFontOverrides();

  //slider down arrow
  var logoHeight = parseInt($("#header-outer").attr("data-logo-height"));
  //headerPadding/shinkNum moved up before fullscreen calcs

  headerPadding = headerPadding - headerPadding / 1.8;

  $("body").on("click", ".slider-down-arrow", function () {
    var $currentSlider = $(this).parents(".swiper-container");
    var $topDistance = $currentSlider.attr("data-height");
    var $offset =
      $currentSlider.parents(".first-section").length == 0 ||
      $('body[data-transparent-header="false"]').length > 0
        ? $currentSlider.offset().top
        : 0;

    if ($('body[data-permanent-transparent="1"]').length == 0) {
      //regular
      if (!$("body").hasClass("mobile")) {
        //hhun
        if ($('body[data-hhun="1"]').length > 0) {
          $("body,html")
            .stop()
            .animate(
              {
                scrollTop: parseInt($topDistance) + $offset + 2,
              },
              1000,
              "easeInOutCubic"
            );
        } else {
          $("body,html")
            .stop()
            .animate(
              {
                scrollTop:
                  parseInt($topDistance - $("#header-space").height()) +
                  parseInt(shrinkNum) +
                  headerPadding * 2 +
                  $offset +
                  2,
              },
              1000,
              "easeInOutCubic"
            );
        }
      } else {
        $scrollPos =
          $('#header-outer[data-mobile-fixed="1"]').length > 0
            ? parseInt($topDistance) -
              $("#header-space").height() +
              parseInt($currentSlider.offset().top) +
              2
            : parseInt($topDistance) +
              parseInt($currentSlider.offset().top) +
              2;
        $("body,html").stop().animate(
          {
            scrollTop: $scrollPos,
          },
          1000,
          "easeInOutCubic"
        );
      }
    } else {
      //permanent transparent
      $("body,html")
        .stop()
        .animate(
          {
            scrollTop:
              parseInt($topDistance) +
              parseInt($currentSlider.offset().top) +
              2,
          },
          1000,
          "easeInOutCubic"
        );
    }
    return false;
  });

  function prettyPhotoInit() {
    var loading_animation =
      $("body[data-loading-animation]").attr("data-loading-animation") != "none"
        ? $("body").attr("data-loading-animation")
        : null;
    var ascend_loader = $("body").hasClass("ascend")
      ? '<span class="default-loading-icon spin"></span>'
      : "";
    var ascend_loader_class = $("body").hasClass("ascend")
      ? "default_loader "
      : "";

    $(".nectar-slider-wrap a[rel^='prettyPhoto']").prettyPhoto({
      theme: "dark_rounded",
      allow_resize: true,
      default_width: 690,
      opacity: 0.85,
      animation_speed: "normal",
      default_height: 388,
      social_tools: "",
      markup:
        '<div class="pp_pic_holder"> \
						   <div class="ppt">&nbsp;</div> \
							<div class="pp_details"> \
								<div class="pp_nav"> \
								    <a href="#" class="pp_arrow_previous"> <i class="icon-salient-left-arrow-thin icon-default-style"></i> </a> \
									<a href="#" class="pp_arrow_next"> <i class="icon-salient-right-arrow-thin icon-default-style"></i> </a> \
									<p class="currentTextHolder">0/0</p> \
								</div> \
								<a class="pp_close" href="#"><span class="icon-salient-x icon-default-style"></span></a> \
							</div> \
							<div class="pp_content_container"> \
								<div class="pp_left"> \
								<div class="pp_right"> \
									<div class="pp_content"> \
										<div class="pp_fade"> \
											<div class="pp_hoverContainer"> \
											</div> \
											<div id="pp_full_res"></div> \
                                            <p class="pp_description"></p> \
										</div> \
									</div> \
								</div> \
								</div> \
							</div> \
						</div> \
						<div class="pp_loaderIcon ' +
        ascend_loader_class +
        loading_animation +
        '"> ' +
        ascend_loader +
        ' </div> \
						<div class="pp_overlay"></div>',
    });
  }
});

/* Touch swipe */
(function (d) {
  var m = "left",
    l = "right",
    c = "up",
    s = "down",
    b = "in",
    t = "out",
    j = "none",
    o = "auto",
    i = "swipe",
    p = "pinch",
    u = "tap",
    x = "horizontal",
    q = "vertical",
    g = "all",
    e = "start",
    h = "move",
    f = "end",
    n = "cancel",
    a = "ontouchstart" in window,
    v = "TouchSwipe";
  var k = {
    fingers: 1,
    threshold: 75,
    cancelThreshold: 25,
    pinchThreshold: 20,
    maxTimeThreshold: null,
    fingerReleaseThreshold: 250,
    swipe: null,
    swipeLeft: null,
    swipeRight: null,
    swipeUp: null,
    swipeDown: null,
    swipeStatus: null,
    pinchIn: null,
    pinchOut: null,
    pinchStatus: null,
    click: null,
    tap: null,
    triggerOnTouchEnd: true,
    triggerOnTouchLeave: false,
    allowPageScroll: "auto",
    fallbackToMouseEvents: true,
    excludedElements: "button, input, select, textarea, a, .noSwipe",
  };
  d.fn.swipe = function (A) {
    var z = d(this),
      y = z.data(v);
    if (y && typeof A === "string") {
      if (y[A]) {
        return y[A].apply(this, Array.prototype.slice.call(arguments, 1));
      } else {
        d.error("Method " + A + " does not exist on jQuery.swipe");
      }
    } else {
      if (!y && (typeof A === "object" || !A)) {
        return r.apply(this, arguments);
      }
    }
    return z;
  };
  d.fn.swipe.defaults = k;
  d.fn.swipe.phases = {
    PHASE_START: e,
    PHASE_MOVE: h,
    PHASE_END: f,
    PHASE_CANCEL: n,
  };
  d.fn.swipe.directions = { LEFT: m, RIGHT: l, UP: c, DOWN: s, IN: b, OUT: t };
  d.fn.swipe.pageScroll = { NONE: j, HORIZONTAL: x, VERTICAL: q, AUTO: o };
  d.fn.swipe.fingers = { ONE: 1, TWO: 2, THREE: 3, ALL: g };
  function r(y) {
    if (
      y &&
      y.allowPageScroll === undefined &&
      (y.swipe !== undefined || y.swipeStatus !== undefined)
    ) {
      y.allowPageScroll = j;
    }
    if (y.click !== undefined && y.tap === undefined) {
      y.tap = y.click;
    }
    if (!y) {
      y = {};
    }
    y = d.extend({}, d.fn.swipe.defaults, y);
    return this.each(function () {
      var A = d(this);
      var z = A.data(v);
      if (!z) {
        z = new w(this, y);
        A.data(v, z);
      }
    });
  }
  function w(S, ag) {
    var aJ = a || !ag.fallbackToMouseEvents,
      az = aJ ? "touchstart" : "mousedown",
      U = aJ ? "touchmove" : "mousemove",
      av = aJ ? "touchend" : "mouseup",
      D = aJ ? null : "mouseleave",
      R = "touchcancel";
    var ad = 0,
      N = null,
      ah = 0,
      aF = 0,
      A = 0,
      aj = 1,
      aA = 0,
      aN = 0,
      Z = null;
    var H = d(S);
    var O = "start";
    var aI = 0;
    var ai = null;
    var I = 0,
      Y = 0,
      aD = 0,
      aP = 0;
    try {
      H.bind(az, at);
      H.bind(R, L);
    } catch (aG) {
      d.error("events not supported " + az + "," + R + " on jQuery.swipe");
    }
    this.enable = function () {
      H.bind(az, at);
      H.bind(R, L);
      return H;
    };
    this.disable = function () {
      Q();
      return H;
    };
    this.destroy = function () {
      Q();
      H.data(v, null);
      return H;
    };
    this.option = function (aR, aQ) {
      if (ag[aR] !== undefined) {
        if (aQ === undefined) {
          return ag[aR];
        } else {
          ag[aR] = aQ;
        }
      } else {
        d.error("Option " + aR + " does not exist on jQuery.swipe.options");
      }
    };
    function at(aS) {
      if (X()) {
        return;
      }
      if (d(aS.target).closest(ag.excludedElements, H).length > 0) {
        return;
      }
      var aT = aS.originalEvent ? aS.originalEvent : aS;
      var aR,
        aQ = a ? aT.touches[0] : aT;
      O = e;
      if (a) {
        aI = aT.touches.length;
      } else {
        aS.preventDefault();
      }
      ad = 0;
      N = null;
      aN = null;
      ah = 0;
      aF = 0;
      A = 0;
      aj = 1;
      aA = 0;
      ai = T();
      Z = aE();
      z();
      if (!a || aI === ag.fingers || ag.fingers === g || ap()) {
        aO(0, aQ);
        I = B();
        if (aI == 2) {
          aO(1, aT.touches[1]);
          aF = A = aa(ai[0].start, ai[1].start);
        }
        if (ag.swipeStatus || ag.pinchStatus) {
          aR = aH(aT, O);
        }
      } else {
        aR = false;
      }
      if (aR === false) {
        O = n;
        aH(aT, O);
        return aR;
      } else {
        ak(true);
      }
    }
    function P(aT) {
      var aW = aT.originalEvent ? aT.originalEvent : aT;
      if (O === f || O === n || af()) {
        return;
      }
      var aS,
        aR = a ? aW.touches[0] : aW;
      var aU = V(aR);
      Y = B();
      if (a) {
        aI = aW.touches.length;
      }
      O = h;
      if (aI == 2) {
        if (aF == 0) {
          aO(1, aW.touches[1]);
          aF = A = aa(ai[0].start, ai[1].start);
        } else {
          V(aW.touches[1]);
          A = aa(ai[0].end, ai[1].end);
          aN = ao(ai[0].end, ai[1].end);
        }
        aj = y(aF, A);
        aA = Math.abs(aF - A);
      }
      if (aI === ag.fingers || ag.fingers === g || !a || ap()) {
        N = ar(aU.start, aU.end);
        C(aT, N);
        ad = G(aU.start, aU.end);
        ah = K();
        aK(N, ad);
        if (ag.swipeStatus || ag.pinchStatus) {
          aS = aH(aW, O);
        }
        if (!ag.triggerOnTouchEnd || ag.triggerOnTouchLeave) {
          var aQ = true;
          if (ag.triggerOnTouchLeave) {
            var aV = au(this);
            aQ = aC(aU.end, aV);
          }
          if (!ag.triggerOnTouchEnd && aQ) {
            O = aM(h);
          } else {
            if (ag.triggerOnTouchLeave && !aQ) {
              O = aM(f);
            }
          }
          if (O == n || O == f) {
            aH(aW, O);
          }
        }
      } else {
        O = n;
        aH(aW, O);
      }
      if (aS === false) {
        O = n;
        aH(aW, O);
      }
    }
    function ab(aS) {
      var aU = aS.originalEvent;
      if (a) {
        if (aU.touches.length > 0) {
          aw();
          return true;
        }
      }
      if (af()) {
        aI = aP;
      }
      aS.preventDefault();
      Y = B();
      if (ag.triggerOnTouchEnd || (ag.triggerOnTouchEnd == false && O === h)) {
        O = f;
        var aR = aI === ag.fingers || ag.fingers === g || !a;
        var aQ = ai[0].end.x !== 0;
        var aT = aR && aQ && (an() || aB());
        if (aT) {
          aH(aU, O);
        } else {
          O = n;
          aH(aU, O);
        }
      } else {
        if (!ag.triggerOnTouchEnd && ay()) {
          O = f;
          am(aU, O, u);
        } else {
          if (O === h) {
            O = n;
            aH(aU, O);
          }
        }
      }
      ak(false);
    }
    function L() {
      aI = 0;
      Y = 0;
      I = 0;
      aF = 0;
      A = 0;
      aj = 1;
      z();
      ak(false);
    }
    function W(aQ) {
      var aR = aQ.originalEvent;
      if (ag.triggerOnTouchLeave) {
        O = aM(f);
        aH(aR, O);
      }
    }
    function Q() {
      H.unbind(az, at);
      H.unbind(R, L);
      H.unbind(U, P);
      H.unbind(av, ab);
      if (D) {
        H.unbind(D, W);
      }
      ak(false);
    }
    function aM(aT) {
      var aS = aT;
      var aR = aq();
      var aQ = ae();
      if (!aR) {
        aS = n;
      } else {
        if (
          aQ &&
          aT == h &&
          (!ag.triggerOnTouchEnd || ag.triggerOnTouchLeave)
        ) {
          aS = f;
        } else {
          if (!aQ && aT == f && ag.triggerOnTouchLeave) {
            aS = n;
          }
        }
      }
      return aS;
    }
    function aH(aS, aQ) {
      var aR = undefined;
      if (ac()) {
        aR = am(aS, aQ, i);
      }
      if (ap() && aR !== false) {
        aR = am(aS, aQ, p);
      }
      if (ay() && aR !== false) {
        aR = am(aS, aQ, u);
      }
      if (aQ === n) {
        L(aS);
      }
      if (aQ === f) {
        if (a) {
          if (aS.touches.length == 0) {
            L(aS);
          }
        } else {
          L(aS);
        }
      }
      return aR;
    }
    function am(aT, aQ, aS) {
      var aR = undefined;
      if (aS == i) {
        H.trigger("swipeStatus", [aQ, N || null, ad || 0, ah || 0, aI]);
        if (ag.swipeStatus) {
          aR = ag.swipeStatus.call(H, aT, aQ, N || null, ad || 0, ah || 0, aI);
          if (aR === false) {
            return false;
          }
        }
        if (aQ == f && aB()) {
          H.trigger("swipe", [N, ad, ah, aI]);
          if (ag.swipe) {
            aR = ag.swipe.call(H, aT, N, ad, ah, aI);
            if (aR === false) {
              return false;
            }
          }
          switch (N) {
            case m:
              H.trigger("swipeLeft", [N, ad, ah, aI]);
              if (ag.swipeLeft) {
                aR = ag.swipeLeft.call(H, aT, N, ad, ah, aI);
              }
              break;
            case l:
              H.trigger("swipeRight", [N, ad, ah, aI]);
              if (ag.swipeRight) {
                aR = ag.swipeRight.call(H, aT, N, ad, ah, aI);
              }
              break;
            case c:
              H.trigger("swipeUp", [N, ad, ah, aI]);
              if (ag.swipeUp) {
                aR = ag.swipeUp.call(H, aT, N, ad, ah, aI);
              }
              break;
            case s:
              H.trigger("swipeDown", [N, ad, ah, aI]);
              if (ag.swipeDown) {
                aR = ag.swipeDown.call(H, aT, N, ad, ah, aI);
              }
              break;
          }
        }
      }
      if (aS == p) {
        H.trigger("pinchStatus", [aQ, aN || null, aA || 0, ah || 0, aI, aj]);
        if (ag.pinchStatus) {
          aR = ag.pinchStatus.call(
            H,
            aT,
            aQ,
            aN || null,
            aA || 0,
            ah || 0,
            aI,
            aj
          );
          if (aR === false) {
            return false;
          }
        }
        if (aQ == f && an()) {
          switch (aN) {
            case b:
              H.trigger("pinchIn", [aN || null, aA || 0, ah || 0, aI, aj]);
              if (ag.pinchIn) {
                aR = ag.pinchIn.call(
                  H,
                  aT,
                  aN || null,
                  aA || 0,
                  ah || 0,
                  aI,
                  aj
                );
              }
              break;
            case t:
              H.trigger("pinchOut", [aN || null, aA || 0, ah || 0, aI, aj]);
              if (ag.pinchOut) {
                aR = ag.pinchOut.call(
                  H,
                  aT,
                  aN || null,
                  aA || 0,
                  ah || 0,
                  aI,
                  aj
                );
              }
              break;
          }
        }
      }
      if (aS == u) {
        if (aQ === n || aQ === f) {
          if ((aI === 1 || !a) && (isNaN(ad) || ad === 0)) {
            H.trigger("tap", [aT.target]);
            if (ag.tap) {
              aR = ag.tap.call(H, aT, aT.target);
            }
          }
        }
      }
      return aR;
    }
    function ae() {
      var aQ = true;
      if (ag.threshold !== null) {
        aQ = ad >= ag.threshold;
      }
      if (aQ && ag.cancelThreshold !== null) {
        aQ = M(N) - ad < ag.cancelThreshold;
      }
      return aQ;
    }
    function al() {
      if (ag.pinchThreshold !== null) {
        return aA >= ag.pinchThreshold;
      }
      return true;
    }
    function aq() {
      var aQ;
      if (ag.maxTimeThreshold) {
        if (ah >= ag.maxTimeThreshold) {
          aQ = false;
        } else {
          aQ = true;
        }
      } else {
        aQ = true;
      }
      return aQ;
    }
    function C(aQ, aR) {
      if (ag.allowPageScroll === j || ap()) {
        aQ.preventDefault();
      } else {
        var aS = ag.allowPageScroll === o;
        switch (aR) {
          case m:
            if ((ag.swipeLeft && aS) || (!aS && ag.allowPageScroll != x)) {
              aQ.preventDefault();
            }
            break;
          case l:
            if ((ag.swipeRight && aS) || (!aS && ag.allowPageScroll != x)) {
              aQ.preventDefault();
            }
            break;
          case c:
            if ((ag.swipeUp && aS) || (!aS && ag.allowPageScroll != q)) {
              aQ.preventDefault();
            }
            break;
          case s:
            if ((ag.swipeDown && aS) || (!aS && ag.allowPageScroll != q)) {
              aQ.preventDefault();
            }
            break;
        }
      }
    }
    function an() {
      return al();
    }
    function ap() {
      return !!(ag.pinchStatus || ag.pinchIn || ag.pinchOut);
    }
    function ax() {
      return !!(an() && ap());
    }
    function aB() {
      var aQ = aq();
      var aS = ae();
      var aR = aS && aQ;
      return aR;
    }
    function ac() {
      return !!(
        ag.swipe ||
        ag.swipeStatus ||
        ag.swipeLeft ||
        ag.swipeRight ||
        ag.swipeUp ||
        ag.swipeDown
      );
    }
    function E() {
      return !!(aB() && ac());
    }
    function ay() {
      return !!ag.tap;
    }
    function aw() {
      aD = B();
      aP = event.touches.length + 1;
    }
    function z() {
      aD = 0;
      aP = 0;
    }
    function af() {
      var aQ = false;
      if (aD) {
        var aR = B() - aD;
        if (aR <= ag.fingerReleaseThreshold) {
          aQ = true;
        }
      }
      return aQ;
    }
    function X() {
      return !!(H.data(v + "_intouch") === true);
    }
    function ak(aQ) {
      if (aQ === true) {
        H.bind(U, P);
        H.bind(av, ab);
        if (D) {
          H.bind(D, W);
        }
      } else {
        H.unbind(U, P, false);
        H.unbind(av, ab, false);
        if (D) {
          H.unbind(D, W, false);
        }
      }
      H.data(v + "_intouch", aQ === true);
    }
    function aO(aR, aQ) {
      var aS = aQ.identifier !== undefined ? aQ.identifier : 0;
      ai[aR].identifier = aS;
      ai[aR].start.x = ai[aR].end.x = aQ.pageX || aQ.clientX;
      ai[aR].start.y = ai[aR].end.y = aQ.pageY || aQ.clientY;
      return ai[aR];
    }
    function V(aQ) {
      var aS = aQ.identifier !== undefined ? aQ.identifier : 0;
      var aR = J(aS);
      aR.end.x = aQ.pageX || aQ.clientX;
      aR.end.y = aQ.pageY || aQ.clientY;
      return aR;
    }
    function J(aR) {
      for (var aQ = 0; aQ < ai.length; aQ++) {
        if (ai[aQ].identifier == aR) {
          return ai[aQ];
        }
      }
    }
    function T() {
      var aQ = [];
      for (var aR = 0; aR <= 5; aR++) {
        aQ.push({ start: { x: 0, y: 0 }, end: { x: 0, y: 0 }, identifier: 0 });
      }
      return aQ;
    }
    function aK(aQ, aR) {
      aR = Math.max(aR, M(aQ));
      Z[aQ].distance = aR;
    }
    function M(aQ) {
      return Z[aQ].distance;
    }
    function aE() {
      var aQ = {};
      aQ[m] = aL(m);
      aQ[l] = aL(l);
      aQ[c] = aL(c);
      aQ[s] = aL(s);
      return aQ;
    }
    function aL(aQ) {
      return { direction: aQ, distance: 0 };
    }
    function K() {
      return Y - I;
    }
    function aa(aT, aS) {
      var aR = Math.abs(aT.x - aS.x);
      var aQ = Math.abs(aT.y - aS.y);
      return Math.round(Math.sqrt(aR * aR + aQ * aQ));
    }
    function y(aQ, aR) {
      var aS = (aR / aQ) * 1;
      return aS.toFixed(2);
    }
    function ao() {
      if (aj < 1) {
        return t;
      } else {
        return b;
      }
    }
    function G(aR, aQ) {
      return Math.round(
        Math.sqrt(Math.pow(aQ.x - aR.x, 2) + Math.pow(aQ.y - aR.y, 2))
      );
    }
    function F(aT, aR) {
      var aQ = aT.x - aR.x;
      var aV = aR.y - aT.y;
      var aS = Math.atan2(aV, aQ);
      var aU = Math.round((aS * 180) / Math.PI);
      if (aU < 0) {
        aU = 360 - Math.abs(aU);
      }
      return aU;
    }
    function ar(aR, aQ) {
      var aS = F(aR, aQ);
      if (aS <= 45 && aS >= 0) {
        return m;
      } else {
        if (aS <= 360 && aS >= 315) {
          return m;
        } else {
          if (aS >= 135 && aS <= 225) {
            return l;
          } else {
            if (aS > 45 && aS < 135) {
              return s;
            } else {
              return c;
            }
          }
        }
      }
    }
    function B() {
      var aQ = new Date();
      return aQ.getTime();
    }
    function au(aQ) {
      aQ = d(aQ);
      var aS = aQ.offset();
      var aR = {
        left: aS.left,
        right: aS.left + aQ.outerWidth(),
        top: aS.top,
        bottom: aS.top + aQ.outerHeight(),
      };
      return aR;
    }
    function aC(aQ, aR) {
      return (
        aQ.x > aR.left && aQ.x < aR.right && aQ.y > aR.top && aQ.y < aR.bottom
      );
    }
  }
})(jQuery);

var epdofitvids =
  epdofitvids ||
  function (a) {
    a.fn.fitVidsEP = function (b) {
      if (_EPYT_.epresponsiveselector.constructor !== Array) {
        _EPYT_.epresponsiveselector = JSON.parse(_EPYT_.epresponsiveselector);
      }
      var c = { customSelector: null };
      if (!document.getElementById("fit-vids-style")) {
        var f = document.createElement("div"),
          d =
            document.getElementsByTagName("base")[0] ||
            document.getElementsByTagName("script")[0],
          e =
            "&shy;<style>.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}</style>";
        f.className = "fit-vids-style";
        f.id = "fit-vids-style";
        f.style.display = "none";
        f.innerHTML = e;
        d.parentNode.insertBefore(f, d);
      }
      if (b) {
        a.extend(c, b);
      }
      return this.each(function () {
        var g = _EPYT_.epresponsiveselector;
        if (c.customSelector) {
          g.push(c.customSelector);
        }
        var h = a(this).find(g.join(","));
        h = h.not("object object");
        h.each(function () {
          var o = a(this);
          if (
            (this.tagName.toLowerCase() === "embed" &&
              o.parent("object").length) ||
            o.parent(".fluid-width-video-wrapper").length
          ) {
            return;
          }
          var i =
              this.tagName.toLowerCase() === "object" ||
              (o.attr("height") && !isNaN(parseInt(o.attr("height"), 10)))
                ? parseInt(o.attr("height"), 10)
                : o.height(),
            l = !isNaN(parseInt(o.attr("width"), 10))
              ? parseInt(o.attr("width"), 10)
              : o.width(),
            m = i / l;
          if (!o.attr("id")) {
            var n = "fitvid" + Math.floor(Math.random() * 999999);
            o.attr("id", n);
          }
          var k = document.createElement("div");
          k.className = "fluid-width-video-wrapper";
          try {
            o.wrap(k)
              .parent(".fluid-width-video-wrapper")
              .attr("style", "padding-top: " + m * 100 + "% !important;");
            o.removeAttr("height").removeAttr("width");
          } catch (j) {}
        });
      });
    };
    a(document).ready(function () {
      a("body").fitVidsEP();
      a(document).ajaxSuccess(function (c, d, b) {
        if (d && d.responseText && d.responseText.indexOf("<iframe ") !== -1) {
          a("body").fitVidsEP();
        }
      });
    });
    return true;
  };
try {
  epdofitvids(window.jQuery);
} catch (err) {}
!(function (d, l) {
  "use strict";
  var e = !1,
    o = !1;
  if (l.querySelector) if (d.addEventListener) e = !0;
  if (((d.wp = d.wp || {}), !d.wp.receiveEmbedMessage))
    if (
      ((d.wp.receiveEmbedMessage = function (e) {
        var t = e.data;
        if (t)
          if (t.secret || t.message || t.value)
            if (!/[^a-zA-Z0-9]/.test(t.secret)) {
              var r,
                a,
                i,
                s,
                n,
                o = l.querySelectorAll(
                  'iframe[data-secret="' + t.secret + '"]'
                ),
                c = l.querySelectorAll(
                  'blockquote[data-secret="' + t.secret + '"]'
                );
              for (r = 0; r < c.length; r++) c[r].style.display = "none";
              for (r = 0; r < o.length; r++)
                if (((a = o[r]), e.source === a.contentWindow)) {
                  if ((a.removeAttribute("style"), "height" === t.message)) {
                    if (1e3 < (i = parseInt(t.value, 10))) i = 1e3;
                    else if (~~i < 200) i = 200;
                    a.height = i;
                  }
                  if ("link" === t.message)
                    if (
                      ((s = l.createElement("a")),
                      (n = l.createElement("a")),
                      (s.href = a.getAttribute("src")),
                      (n.href = t.value),
                      n.host === s.host)
                    )
                      if (l.activeElement === a) d.top.location.href = t.value;
                }
            }
      }),
      e)
    )
      d.addEventListener("message", d.wp.receiveEmbedMessage, !1),
        l.addEventListener("DOMContentLoaded", t, !1),
        d.addEventListener("load", t, !1);
  function t() {
    if (!o) {
      o = !0;
      var e,
        t,
        r,
        a,
        i = -1 !== navigator.appVersion.indexOf("MSIE 10"),
        s = !!navigator.userAgent.match(/Trident.*rv:11\./),
        n = l.querySelectorAll("iframe.wp-embedded-content");
      for (t = 0; t < n.length; t++) {
        if (!(r = n[t]).getAttribute("data-secret"))
          (a = Math.random().toString(36).substr(2, 10)),
            (r.src += "#?secret=" + a),
            r.setAttribute("data-secret", a);
        if (i || s)
          (e = r.cloneNode(!0)).removeAttribute("security"),
            r.parentNode.replaceChild(e, r);
      }
    }
  }
})(window, document);
function countdown_wpdevart_timer(main_div_id) {
  var days_left = parseInt(jQuery("#" + main_div_id + " .days").text());
  var hours_left = parseInt(jQuery("#" + main_div_id + " .hourse").text());
  var minutes_left = parseInt(jQuery("#" + main_div_id + " .minutes").text());
  var secondes_left = parseInt(jQuery("#" + main_div_id + " .secondes").text());
  var all_time =
    days_left * 24 * 3600 +
    hours_left * 3600 +
    minutes_left * 60 +
    secondes_left;
  all_time--;
  console.log(all_time);
  days_left = parseInt(all_time / (3600 * 24));
  hours_left = parseInt((all_time - days_left * 3600 * 24) / 3600);
  minutes_left = parseInt(
    (all_time - days_left * 3600 * 24 - hours_left * 3600) / 60
  );
  secondes_left = parseInt(
    all_time - days_left * 3600 * 24 - hours_left * 3600 - minutes_left * 60
  );
  if (("" + days_left + "").length > 1)
    jQuery("#" + main_div_id + " .days").html(days_left);
  else jQuery("#" + main_div_id + " .days").html("0" + days_left);
  if (("" + hours_left + "").length > 1)
    jQuery("#" + main_div_id + " .hourse").html(hours_left);
  else jQuery("#" + main_div_id + " .hourse").html("0" + hours_left);
  if (("" + minutes_left + "").length > 1)
    jQuery("#" + main_div_id + " .minutes").html(minutes_left);
  else jQuery("#" + main_div_id + " .minutes").html("0" + minutes_left);
  if (("" + secondes_left + "").length > 1)
    jQuery("#" + main_div_id + " .secondes").html(secondes_left);
  else jQuery("#" + main_div_id + " .secondes").html("0" + secondes_left);
  if (
    days_left <= 0 &&
    hours_left <= 0 &&
    minutes_left <= 0 &&
    secondes_left <= 0
  ) {
    window.location = curen_site_home_page;
  }
}
function wpdevart_countdown_animated_element(animation, element_id) {
  jQuery("#" + element_id).ready(function (e) {
    if (
      !jQuery(jQuery("#" + element_id)).hasClass("animated") &&
      wpdevart_countdown_isScrolledIntoView(jQuery("#" + element_id))
    ) {
      jQuery(jQuery("#" + element_id)).css("visibility", "visible");
      jQuery(jQuery("#" + element_id)).addClass("animated");
      jQuery(jQuery("#" + element_id)).addClass(animation);
    }
  });
}
function wpdevart_countdown_isScrolledIntoView(elem) {
  var eelem = jQuery(elem);
  if (eelem.length == 0) {
    return true;
  }
  var $window = jQuery(window);
  var docViewTop = $window.scrollTop();
  var docViewBottom = docViewTop + $window.height();
  var elemTop = jQuery(elem).offset().top;
  var elemBottom = elemTop + parseInt(jQuery(elem).css("height"));
  return (
    (docViewTop <= elemTop && elemTop <= docViewBottom) ||
    (docViewTop <= elemBottom && elemBottom <= docViewBottom)
  );
}
/*
 * Thickbox 3.1 - One Box To Rule Them All.
 * By Cody Lindley (http://www.codylindley.com)
 * Copyright (c) 2007 cody lindley
 * Licensed under the MIT License: http://www.opensource.org/licenses/mit-license.php
 */

if (typeof tb_pathToImage != "string") {
  var tb_pathToImage = thickboxL10n.loadingAnimation;
}

/*!!!!!!!!!!!!!!!!! edit below this line at your own risk !!!!!!!!!!!!!!!!!!!!!!!*/

//on page load call tb_init
jQuery(document).ready(function () {
  tb_init("a.thickbox, area.thickbox, input.thickbox"); //pass where to apply thickbox
  imgLoader = new Image(); // preload image
  imgLoader.src = tb_pathToImage;
});

/*
 * Add thickbox to href & area elements that have a class of .thickbox.
 * Remove the loading indicator when content in an iframe has loaded.
 */
function tb_init(domChunk) {
  jQuery("body")
    .on("click", domChunk, tb_click)
    .on("thickbox:iframe:loaded", function () {
      jQuery("#TB_window").removeClass("thickbox-loading");
    });
}

function tb_click() {
  var t = this.title || this.name || null;
  var a = this.href || this.alt;
  var g = this.rel || false;
  tb_show(t, a, g);
  this.blur();
  return false;
}

function tb_show(caption, url, imageGroup) {
  //function called when the user clicks on a thickbox link

  var $closeBtn;

  try {
    if (typeof document.body.style.maxHeight === "undefined") {
      //if IE 6
      jQuery("body", "html").css({ height: "100%", width: "100%" });
      jQuery("html").css("overflow", "hidden");
      if (document.getElementById("TB_HideSelect") === null) {
        //iframe to hide select elements in ie6
        jQuery("body").append(
          "<iframe id='TB_HideSelect'>" +
            thickboxL10n.noiframes +
            "</iframe><div id='TB_overlay'></div><div id='TB_window' class='thickbox-loading'></div>"
        );
        jQuery("#TB_overlay").click(tb_remove);
      }
    } else {
      //all others
      if (document.getElementById("TB_overlay") === null) {
        jQuery("body").append(
          "<div id='TB_overlay'></div><div id='TB_window' class='thickbox-loading'></div>"
        );
        jQuery("#TB_overlay").click(tb_remove);
        jQuery("body").addClass("modal-open");
      }
    }

    if (tb_detectMacXFF()) {
      jQuery("#TB_overlay").addClass("TB_overlayMacFFBGHack"); //use png overlay so hide flash
    } else {
      jQuery("#TB_overlay").addClass("TB_overlayBG"); //use background and opacity
    }

    if (caption === null) {
      caption = "";
    }
    jQuery("body").append(
      "<div id='TB_load'><img src='" + imgLoader.src + "' width='208' /></div>"
    ); //add loader to the page
    jQuery("#TB_load").show(); //show loader

    var baseURL;
    if (url.indexOf("?") !== -1) {
      //ff there is a query string involved
      baseURL = url.substr(0, url.indexOf("?"));
    } else {
      baseURL = url;
    }

    var urlString = /\.jpg$|\.jpeg$|\.png$|\.gif$|\.bmp$/;
    var urlType = baseURL.toLowerCase().match(urlString);

    if (
      urlType == ".jpg" ||
      urlType == ".jpeg" ||
      urlType == ".png" ||
      urlType == ".gif" ||
      urlType == ".bmp"
    ) {
      //code to show images

      TB_PrevCaption = "";
      TB_PrevURL = "";
      TB_PrevHTML = "";
      TB_NextCaption = "";
      TB_NextURL = "";
      TB_NextHTML = "";
      TB_imageCount = "";
      TB_FoundURL = false;
      if (imageGroup) {
        TB_TempArray = jQuery("a[rel=" + imageGroup + "]").get();
        for (
          TB_Counter = 0;
          TB_Counter < TB_TempArray.length && TB_NextHTML === "";
          TB_Counter++
        ) {
          var urlTypeTemp = TB_TempArray[TB_Counter].href
            .toLowerCase()
            .match(urlString);
          if (!(TB_TempArray[TB_Counter].href == url)) {
            if (TB_FoundURL) {
              TB_NextCaption = TB_TempArray[TB_Counter].title;
              TB_NextURL = TB_TempArray[TB_Counter].href;
              TB_NextHTML =
                "<span id='TB_next'>&nbsp;&nbsp;<a href='#'>" +
                thickboxL10n.next +
                "</a></span>";
            } else {
              TB_PrevCaption = TB_TempArray[TB_Counter].title;
              TB_PrevURL = TB_TempArray[TB_Counter].href;
              TB_PrevHTML =
                "<span id='TB_prev'>&nbsp;&nbsp;<a href='#'>" +
                thickboxL10n.prev +
                "</a></span>";
            }
          } else {
            TB_FoundURL = true;
            TB_imageCount =
              thickboxL10n.image +
              " " +
              (TB_Counter + 1) +
              " " +
              thickboxL10n.of +
              " " +
              TB_TempArray.length;
          }
        }
      }

      imgPreloader = new Image();
      imgPreloader.onload = function () {
        imgPreloader.onload = null;

        // Resizing large images - original by Christian Montoya edited by me.
        var pagesize = tb_getPageSize();
        var x = pagesize[0] - 150;
        var y = pagesize[1] - 150;
        var imageWidth = imgPreloader.width;
        var imageHeight = imgPreloader.height;
        if (imageWidth > x) {
          imageHeight = imageHeight * (x / imageWidth);
          imageWidth = x;
          if (imageHeight > y) {
            imageWidth = imageWidth * (y / imageHeight);
            imageHeight = y;
          }
        } else if (imageHeight > y) {
          imageWidth = imageWidth * (y / imageHeight);
          imageHeight = y;
          if (imageWidth > x) {
            imageHeight = imageHeight * (x / imageWidth);
            imageWidth = x;
          }
        }
        // End Resizing

        TB_WIDTH = imageWidth + 30;
        TB_HEIGHT = imageHeight + 60;
        jQuery("#TB_window").append(
          "<a href='' id='TB_ImageOff'><span class='screen-reader-text'>" +
            thickboxL10n.close +
            "</span><img id='TB_Image' src='" +
            url +
            "' width='" +
            imageWidth +
            "' height='" +
            imageHeight +
            "' alt='" +
            caption +
            "'/></a>" +
            "<div id='TB_caption'>" +
            caption +
            "<div id='TB_secondLine'>" +
            TB_imageCount +
            TB_PrevHTML +
            TB_NextHTML +
            "</div></div><div id='TB_closeWindow'><button type='button' id='TB_closeWindowButton'><span class='screen-reader-text'>" +
            thickboxL10n.close +
            "</span><span class='tb-close-icon'></span></button></div>"
        );

        jQuery("#TB_closeWindowButton").click(tb_remove);

        if (!(TB_PrevHTML === "")) {
          function goPrev() {
            if (jQuery(document).unbind("click", goPrev)) {
              jQuery(document).unbind("click", goPrev);
            }
            jQuery("#TB_window").remove();
            jQuery("body").append("<div id='TB_window'></div>");
            tb_show(TB_PrevCaption, TB_PrevURL, imageGroup);
            return false;
          }
          jQuery("#TB_prev").click(goPrev);
        }

        if (!(TB_NextHTML === "")) {
          function goNext() {
            jQuery("#TB_window").remove();
            jQuery("body").append("<div id='TB_window'></div>");
            tb_show(TB_NextCaption, TB_NextURL, imageGroup);
            return false;
          }
          jQuery("#TB_next").click(goNext);
        }

        jQuery(document).bind("keydown.thickbox", function (e) {
          if (e.which == 27) {
            // close
            tb_remove();
          } else if (e.which == 190) {
            // display previous image
            if (!(TB_NextHTML == "")) {
              jQuery(document).unbind("thickbox");
              goNext();
            }
          } else if (e.which == 188) {
            // display next image
            if (!(TB_PrevHTML == "")) {
              jQuery(document).unbind("thickbox");
              goPrev();
            }
          }
          return false;
        });

        tb_position();
        jQuery("#TB_load").remove();
        jQuery("#TB_ImageOff").click(tb_remove);
        jQuery("#TB_window").css({ visibility: "visible" }); //for safari using css instead of show
      };

      imgPreloader.src = url;
    } else {
      //code to show html

      var queryString = url.replace(/^[^\?]+\??/, "");
      var params = tb_parseQuery(queryString);

      TB_WIDTH = params["width"] * 1 + 30 || 630; //defaults to 630 if no parameters were added to URL
      TB_HEIGHT = params["height"] * 1 + 40 || 440; //defaults to 440 if no parameters were added to URL
      ajaxContentW = TB_WIDTH - 30;
      ajaxContentH = TB_HEIGHT - 45;

      if (url.indexOf("TB_iframe") != -1) {
        // either iframe or ajax window
        urlNoQuery = url.split("TB_");
        jQuery("#TB_iframeContent").remove();
        if (params["modal"] != "true") {
          //iframe no modal
          jQuery("#TB_window").append(
            "<div id='TB_title'><div id='TB_ajaxWindowTitle'>" +
              caption +
              "</div><div id='TB_closeAjaxWindow'><button type='button' id='TB_closeWindowButton'><span class='screen-reader-text'>" +
              thickboxL10n.close +
              "</span><span class='tb-close-icon'></span></button></div></div><iframe frameborder='0' hspace='0' allowtransparency='true' src='" +
              urlNoQuery[0] +
              "' id='TB_iframeContent' name='TB_iframeContent" +
              Math.round(Math.random() * 1000) +
              "' onload='tb_showIframe()' style='width:" +
              (ajaxContentW + 29) +
              "px;height:" +
              (ajaxContentH + 17) +
              "px;' >" +
              thickboxL10n.noiframes +
              "</iframe>"
          );
        } else {
          //iframe modal
          jQuery("#TB_overlay").unbind();
          jQuery("#TB_window").append(
            "<iframe frameborder='0' hspace='0' allowtransparency='true' src='" +
              urlNoQuery[0] +
              "' id='TB_iframeContent' name='TB_iframeContent" +
              Math.round(Math.random() * 1000) +
              "' onload='tb_showIframe()' style='width:" +
              (ajaxContentW + 29) +
              "px;height:" +
              (ajaxContentH + 17) +
              "px;'>" +
              thickboxL10n.noiframes +
              "</iframe>"
          );
        }
      } else {
        // not an iframe, ajax
        if (jQuery("#TB_window").css("visibility") != "visible") {
          if (params["modal"] != "true") {
            //ajax no modal
            jQuery("#TB_window").append(
              "<div id='TB_title'><div id='TB_ajaxWindowTitle'>" +
                caption +
                "</div><div id='TB_closeAjaxWindow'><button type='button' id='TB_closeWindowButton'><span class='screen-reader-text'>" +
                thickboxL10n.close +
                "</span><span class='tb-close-icon'></span></button></div></div><div id='TB_ajaxContent' style='width:" +
                ajaxContentW +
                "px;height:" +
                ajaxContentH +
                "px'></div>"
            );
          } else {
            //ajax modal
            jQuery("#TB_overlay").unbind();
            jQuery("#TB_window").append(
              "<div id='TB_ajaxContent' class='TB_modal' style='width:" +
                ajaxContentW +
                "px;height:" +
                ajaxContentH +
                "px;'></div>"
            );
          }
        } else {
          //this means the window is already up, we are just loading new content via ajax
          jQuery("#TB_ajaxContent")[0].style.width = ajaxContentW + "px";
          jQuery("#TB_ajaxContent")[0].style.height = ajaxContentH + "px";
          jQuery("#TB_ajaxContent")[0].scrollTop = 0;
          jQuery("#TB_ajaxWindowTitle").html(caption);
        }
      }

      jQuery("#TB_closeWindowButton").click(tb_remove);

      if (url.indexOf("TB_inline") != -1) {
        jQuery("#TB_ajaxContent").append(
          jQuery("#" + params["inlineId"]).children()
        );
        jQuery("#TB_window").bind("tb_unload", function () {
          jQuery("#" + params["inlineId"]).append(
            jQuery("#TB_ajaxContent").children()
          ); // move elements back when you're finished
        });
        tb_position();
        jQuery("#TB_load").remove();
        jQuery("#TB_window").css({ visibility: "visible" });
      } else if (url.indexOf("TB_iframe") != -1) {
        tb_position();
        jQuery("#TB_load").remove();
        jQuery("#TB_window").css({ visibility: "visible" });
      } else {
        var load_url = url;
        load_url += -1 === url.indexOf("?") ? "?" : "&";
        jQuery("#TB_ajaxContent").load(
          (load_url += "random=" + new Date().getTime()),
          function () {
            //to do a post change this load method
            tb_position();
            jQuery("#TB_load").remove();
            tb_init("#TB_ajaxContent a.thickbox");
            jQuery("#TB_window").css({ visibility: "visible" });
          }
        );
      }
    }

    if (!params["modal"]) {
      jQuery(document).bind("keydown.thickbox", function (e) {
        if (e.which == 27) {
          // close
          tb_remove();
          return false;
        }
      });
    }

    $closeBtn = jQuery("#TB_closeWindowButton");
    /*
     * If the native Close button icon is visible, move focus on the button
     * (e.g. in the Network Admin Themes screen).
     * In other admin screens is hidden and replaced by a different icon.
     */
    if ($closeBtn.find(".tb-close-icon").is(":visible")) {
      $closeBtn.focus();
    }
  } catch (e) {
    //nothing here
  }
}

//helper functions below
function tb_showIframe() {
  jQuery("#TB_load").remove();
  jQuery("#TB_window")
    .css({ visibility: "visible" })
    .trigger("thickbox:iframe:loaded");
}

function tb_remove() {
  jQuery("#TB_imageOff").unbind("click");
  jQuery("#TB_closeWindowButton").unbind("click");
  jQuery("#TB_window").fadeOut("fast", function () {
    jQuery("#TB_window, #TB_overlay, #TB_HideSelect")
      .trigger("tb_unload")
      .unbind()
      .remove();
    jQuery("body").trigger("thickbox:removed");
  });
  jQuery("body").removeClass("modal-open");
  jQuery("#TB_load").remove();
  if (typeof document.body.style.maxHeight == "undefined") {
    //if IE 6
    jQuery("body", "html").css({ height: "auto", width: "auto" });
    jQuery("html").css("overflow", "");
  }
  jQuery(document).unbind(".thickbox");
  return false;
}

function tb_position() {
  var isIE6 = typeof document.body.style.maxHeight === "undefined";
  jQuery("#TB_window").css({
    marginLeft: "-" + parseInt(TB_WIDTH / 2, 10) + "px",
    width: TB_WIDTH + "px",
  });
  if (!isIE6) {
    // take away IE6
    jQuery("#TB_window").css({
      marginTop: "-" + parseInt(TB_HEIGHT / 2, 10) + "px",
    });
  }
}

function tb_parseQuery(query) {
  var Params = {};
  if (!query) {
    return Params;
  } // return empty object
  var Pairs = query.split(/[;&]/);
  for (var i = 0; i < Pairs.length; i++) {
    var KeyVal = Pairs[i].split("=");
    if (!KeyVal || KeyVal.length != 2) {
      continue;
    }
    var key = unescape(KeyVal[0]);
    var val = unescape(KeyVal[1]);
    val = val.replace(/\+/g, " ");
    Params[key] = val;
  }
  return Params;
}

function tb_getPageSize() {
  var de = document.documentElement;
  var w =
    window.innerWidth ||
    self.innerWidth ||
    (de && de.clientWidth) ||
    document.body.clientWidth;
  var h =
    window.innerHeight ||
    self.innerHeight ||
    (de && de.clientHeight) ||
    document.body.clientHeight;
  arrayPageSize = [w, h];
  return arrayPageSize;
}

function tb_detectMacXFF() {
  var userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf("mac") != -1 && userAgent.indexOf("firefox") != -1) {
    return true;
  }
}

/*!
 * jQuery ClassyCountdown
 * www.class.pm
 *
 * Written by Marius Stanciu - Sergiu <marius@class.pm>
 * Licensed under the MIT license www.class.pm/LICENSE-MIT
 * Version 1.0.0
 *
 */

(function ($) {
  $.fn.ClassyCountdown = function (options, callback) {
    var element = $(this);
    var DaysLeft, HoursLeft, MinutesLeft, SecondsLeft;
    var secondsLeft;
    var isFired = false;
    var settings = {
      end: undefined,
      now: $.now(),
      labels: true,
      labelsOptions: {
        lang: {
          days: "Days",
          hours: "Hours",
          minutes: "Minutes",
          seconds: "Seconds",
        },
        style: "font-size: 0.5em;",
      },
      style: {
        element: "",
        labels: false,
        textResponsive: 0.5,
        days: {
          gauge: {
            thickness: 0.02,
            bgColor: "rgba(0, 0, 0, 0)",
            fgColor: "rgba(0, 0, 0, 1)",
            lineCap: "butt",
          },
          textCSS: "",
        },
        hours: {
          gauge: {
            thickness: 0.02,
            bgColor: "rgba(0, 0, 0, 0)",
            fgColor: "rgba(0, 0, 0, 1)",
            lineCap: "butt",
          },
          textCSS: "",
        },
        minutes: {
          gauge: {
            thickness: 0.02,
            bgColor: "rgba(0, 0, 0, 0)",
            fgColor: "rgba(0, 0, 0, 1)",
            lineCap: "butt",
          },
          textCSS: "",
        },
        seconds: {
          gauge: {
            thickness: 0.02,
            bgColor: "rgba(0, 0, 0, 0)",
            fgColor: "rgba(0, 0, 0, 1)",
            lineCap: "butt",
          },
          textCSS: "",
        },
      },
      onEndCallback: function () {},
    };
    if (options.theme) {
      settings = $.extend(true, settings, getPreset(options.theme));
    }
    settings = $.extend(true, settings, options);
    prepare();
    doTick();
    setInterval(doTick, 1000);
    doResponsive();

    function prepare() {
      element.append(
        '<div class="ClassyCountdown-wrapper">' +
          '<div class="ClassyCountdown-days">' +
          '<input type="text" />' +
          '<span class="ClassyCountdown-value"><div></div><span></span></span>' +
          "</div>" +
          '<div class="ClassyCountdown-hours">' +
          '<input type="text" />' +
          '<span class="ClassyCountdown-value"><div></div><span></span></span>' +
          "</div>" +
          '<div class="ClassyCountdown-minutes">' +
          '<input type="text" />' +
          '<span class="ClassyCountdown-value"><div></div><span></span></span>' +
          "</div>" +
          '<div class="ClassyCountdown-seconds">' +
          '<input type="text" />' +
          '<span class="ClassyCountdown-value"><div></div><span></span></span>' +
          "</div>" +
          "</div>"
      );
      element.find(".ClassyCountdown-days input").knob(
        $.extend(
          {
            width: "100%",
            displayInput: false,
            readOnly: true,
            max: 365,
          },
          settings.style.days.gauge
        )
      );
      element.find(".ClassyCountdown-hours input").knob(
        $.extend(
          {
            width: "100%",
            displayInput: false,
            readOnly: true,
            max: 24,
          },
          settings.style.hours.gauge
        )
      );
      element.find(".ClassyCountdown-minutes input").knob(
        $.extend(
          {
            width: "100%",
            displayInput: false,
            readOnly: true,
            max: 60,
          },
          settings.style.minutes.gauge
        )
      );
      element.find(".ClassyCountdown-seconds input").knob(
        $.extend(
          {
            width: "100%",
            displayInput: false,
            readOnly: true,
            max: 60,
          },
          settings.style.seconds.gauge
        )
      );
      element
        .find(".ClassyCountdown-wrapper > div")
        .attr("style", settings.style.element);
      element
        .find(".ClassyCountdown-days .ClassyCountdown-value")
        .attr("style", settings.style.days.textCSS);
      element
        .find(".ClassyCountdown-hours .ClassyCountdown-value")
        .attr("style", settings.style.hours.textCSS);
      element
        .find(".ClassyCountdown-minutes .ClassyCountdown-value")
        .attr("style", settings.style.minutes.textCSS);
      element
        .find(".ClassyCountdown-seconds .ClassyCountdown-value")
        .attr("style", settings.style.seconds.textCSS);
      element.find(".ClassyCountdown-value").each(function () {
        $(this).css(
          "margin-top",
          Math.floor(0 - parseInt($(this).height()) / 2) + "px"
        );
      });
      if (settings.labels) {
        element
          .find(".ClassyCountdown-days .ClassyCountdown-value > span")
          .html(settings.labelsOptions.lang.days);
        element
          .find(".ClassyCountdown-hours .ClassyCountdown-value > span")
          .html(settings.labelsOptions.lang.hours);
        element
          .find(".ClassyCountdown-minutes .ClassyCountdown-value > span")
          .html(settings.labelsOptions.lang.minutes);
        element
          .find(".ClassyCountdown-seconds .ClassyCountdown-value > span")
          .html(settings.labelsOptions.lang.seconds);
        element
          .find(".ClassyCountdown-value > span")
          .attr("style", settings.labelsOptions.style);
      }
      secondsLeft = settings.end - settings.now;
      secondsToDHMS();
    }

    function secondsToDHMS() {
      DaysLeft = Math.floor(secondsLeft / 86400);
      HoursLeft = Math.floor((secondsLeft % 86400) / 3600);
      MinutesLeft = Math.floor(((secondsLeft % 86400) % 3600) / 60);
      SecondsLeft = Math.floor((((secondsLeft % 86400) % 3600) % 60) % 60);
    }

    function doTick() {
      secondsLeft--;
      secondsToDHMS();
      if (secondsLeft <= 0) {
        if (!isFired) {
          isFired = true;
          settings.onEndCallback();
        }
        DaysLeft = 0;
        HoursLeft = 0;
        MinutesLeft = 0;
        SecondsLeft = 0;
      }
      element
        .find(".ClassyCountdown-days input")
        .val(365 - DaysLeft)
        .trigger("change");
      element
        .find(".ClassyCountdown-hours input")
        .val(24 - HoursLeft)
        .trigger("change");
      element
        .find(".ClassyCountdown-minutes input")
        .val(60 - MinutesLeft)
        .trigger("change");
      element
        .find(".ClassyCountdown-seconds input")
        .val(60 - SecondsLeft)
        .trigger("change");
      element
        .find(".ClassyCountdown-days .ClassyCountdown-value > div")
        .html(DaysLeft);
      element
        .find(".ClassyCountdown-hours .ClassyCountdown-value > div")
        .html(HoursLeft);
      element
        .find(".ClassyCountdown-minutes .ClassyCountdown-value > div")
        .html(MinutesLeft);
      element
        .find(".ClassyCountdown-seconds .ClassyCountdown-value > div")
        .html(SecondsLeft);
    }

    function doResponsive() {
      element.find(".ClassyCountdown-wrapper > div").each(function () {
        $(this).css("height", $(this).width() + "px");
      });

      if (settings.style.textResponsive) {
        element
          .find(".ClassyCountdown-value")
          .css(
            "font-size",
            Math.floor(
              (element.find("> div > div").eq(0).width() *
                settings.style.textResponsive) /
                10
            ) + "px"
          );
        element.find(".ClassyCountdown-value").each(function () {
          $(this).css(
            "margin-top",
            Math.floor(0 - parseInt($(this).height()) / 2) + "px"
          );
        });
      }
      $(window).trigger("resize");
      $(window).resize($.throttle(50, onResize));
    }

    function onResize() {
      element.find(".ClassyCountdown-wrapper > div").each(function () {
        $(this).css("height", $(this).width() + "px");
      });
      if (settings.style.textResponsive) {
        element
          .find(".ClassyCountdown-value")
          .css(
            "font-size",
            Math.floor(
              (element.find("> div > div").eq(0).width() *
                settings.style.textResponsive) /
                10
            ) + "px"
          );
      }
      element.find(".ClassyCountdown-value").each(function () {
        $(this).css(
          "margin-top",
          Math.floor(0 - parseInt($(this).height()) / 2) + "px"
        );
      });
      element.find(".ClassyCountdown-days input").trigger("change");
      element.find(".ClassyCountdown-hours input").trigger("change");
      element.find(".ClassyCountdown-minutes input").trigger("change");
      element.find(".ClassyCountdown-seconds input").trigger("change");
    }
  };
})(jQuery);
/**
 * Downward compatible, touchable dial
 *
 * Version: 1.2.11
 * Requires: jQuery v1.7+
 *
 * Copyright (c) 2012 Anthony Terrien
 * Under MIT License (http://www.opensource.org/licenses/mit-license.php)
 *
 * Thanks to vor, eskimoblood, spiffistan, FabrizioC
 */
(function (e) {
  if (typeof exports === "object") {
    module.exports = e(require("jquery"));
  } else if (typeof define === "function" && define.amd) {
    define(["jquery"], e);
  } else {
    e(jQuery);
  }
})(function (e) {
  "use strict";
  var t = {},
    n = Math.max,
    r = Math.min;
  t.c = {};
  t.c.d = e(document);
  t.c.t = function (e) {
    return e.originalEvent.touches.length - 1;
  };
  t.o = function () {
    var n = this;
    this.o = null;
    this.$ = null;
    this.i = null;
    this.g = null;
    this.v = null;
    this.cv = null;
    this.x = 0;
    this.y = 0;
    this.w = 0;
    this.h = 0;
    this.$c = null;
    this.c = null;
    this.t = 0;
    this.isInit = false;
    this.fgColor = null;
    this.pColor = null;
    this.dH = null;
    this.cH = null;
    this.eH = null;
    this.rH = null;
    this.scale = 1;
    this.relative = false;
    this.relativeWidth = false;
    this.relativeHeight = false;
    this.$div = null;
    this.run = function () {
      var t = function (e, t) {
        var r;
        for (r in t) {
          n.o[r] = t[r];
        }
        n._carve().init();
        n._configure()._draw();
      };
      if (this.$.data("kontroled")) return;
      this.$.data("kontroled", true);
      this.extend();
      this.o = e.extend(
        {
          min: this.$.data("min") !== undefined ? this.$.data("min") : 0,
          max: this.$.data("max") !== undefined ? this.$.data("max") : 100,
          stopper: true,
          readOnly:
            this.$.data("readonly") || this.$.attr("readonly") === "readonly",
          cursor:
            (this.$.data("cursor") === true && 30) ||
            this.$.data("cursor") ||
            0,
          thickness:
            (this.$.data("thickness") &&
              Math.max(Math.min(this.$.data("thickness"), 1), 0.01)) ||
            0.35,
          lineCap: this.$.data("linecap") || "butt",
          width: this.$.data("width") || 200,
          height: this.$.data("height") || 200,
          displayInput:
            this.$.data("displayinput") == null || this.$.data("displayinput"),
          displayPrevious: this.$.data("displayprevious"),
          fgColor: this.$.data("fgcolor") || "#87CEEB",
          inputColor: this.$.data("inputcolor"),
          font: this.$.data("font") || "Arial",
          fontWeight: this.$.data("font-weight") || "bold",
          inline: false,
          step: this.$.data("step") || 1,
          rotation: this.$.data("rotation"),
          draw: null,
          change: null,
          cancel: null,
          release: null,
          format: function (e) {
            return e;
          },
          parse: function (e) {
            return parseFloat(e);
          },
        },
        this.o
      );
      this.o.flip =
        this.o.rotation === "anticlockwise" || this.o.rotation === "acw";
      if (!this.o.inputColor) {
        this.o.inputColor = this.o.fgColor;
      }
      if (this.$.is("fieldset")) {
        this.v = {};
        this.i = this.$.find("input");
        this.i.each(function (t) {
          var r = e(this);
          n.i[t] = r;
          n.v[t] = n.o.parse(r.val());
          r.bind("change blur", function () {
            var e = {};
            e[t] = r.val();
            n.val(n._validate(e));
          });
        });
        this.$.find("legend").remove();
      } else {
        this.i = this.$;
        this.v = this.o.parse(this.$.val());
        this.v === "" && (this.v = this.o.min);
        this.$.bind("change blur", function () {
          n.val(n._validate(n.o.parse(n.$.val())));
        });
      }
      !this.o.displayInput && this.$.hide();
      this.$c = e(document.createElement("canvas")).attr({
        width: this.o.width,
        height: this.o.height,
      });
      this.$div = e(
        '<div style="' +
          (this.o.inline ? "display:inline;" : "") +
          "width:" +
          this.o.width +
          "px;height:" +
          this.o.height +
          "px;" +
          '"></div>'
      );
      this.$.wrap(this.$div).before(this.$c);
      this.$div = this.$.parent();
      if (typeof G_vmlCanvasManager !== "undefined") {
        G_vmlCanvasManager.initElement(this.$c[0]);
      }
      this.c = this.$c[0].getContext ? this.$c[0].getContext("2d") : null;
      if (!this.c) {
        throw {
          name: "CanvasNotSupportedException",
          message: "Canvas not supported. Please use excanvas on IE8.0.",
          toString: function () {
            return this.name + ": " + this.message;
          },
        };
      }
      this.scale =
        (window.devicePixelRatio || 1) /
        (this.c.webkitBackingStorePixelRatio ||
          this.c.mozBackingStorePixelRatio ||
          this.c.msBackingStorePixelRatio ||
          this.c.oBackingStorePixelRatio ||
          this.c.backingStorePixelRatio ||
          1);
      this.relativeWidth = this.o.width % 1 !== 0 && this.o.width.indexOf("%");
      this.relativeHeight =
        this.o.height % 1 !== 0 && this.o.height.indexOf("%");
      this.relative = this.relativeWidth || this.relativeHeight;
      this._carve();
      if (this.v instanceof Object) {
        this.cv = {};
        this.copy(this.v, this.cv);
      } else {
        this.cv = this.v;
      }
      this.$.bind("configure", t).parent().bind("configure", t);
      this._listen()._configure()._xy().init();
      this.isInit = true;
      this.$.val(this.o.format(this.v));
      this._draw();
      return this;
    };
    this._carve = function () {
      if (this.relative) {
        var e = this.relativeWidth
            ? (this.$div.parent().width() * parseInt(this.o.width)) / 100
            : this.$div.parent().width(),
          t = this.relativeHeight
            ? (this.$div.parent().height() * parseInt(this.o.height)) / 100
            : this.$div.parent().height();
        this.w = this.h = Math.min(e, t);
      } else {
        this.w = this.o.width;
        this.h = this.o.height;
      }
      this.$div.css({ width: this.w + "px", height: this.h + "px" });
      this.$c.attr({ width: this.w, height: this.h });
      if (this.scale !== 1) {
        this.$c[0].width = this.$c[0].width * this.scale;
        this.$c[0].height = this.$c[0].height * this.scale;
        this.$c.width(this.w);
        this.$c.height(this.h);
      }
      return this;
    };
    this._draw = function () {
      var e = true;
      n.g = n.c;
      n.clear();
      n.dH && (e = n.dH());
      e !== false && n.draw();
    };
    this._touch = function (e) {
      var r = function (e) {
        var t = n.xy2val(
          e.originalEvent.touches[n.t].pageX,
          e.originalEvent.touches[n.t].pageY
        );
        if (t == n.cv) return;
        if (n.cH && n.cH(t) === false) return;
        n.change(n._validate(t));
        n._draw();
      };
      this.t = t.c.t(e);
      r(e);
      t.c.d.bind("touchmove.k", r).bind("touchend.k", function () {
        t.c.d.unbind("touchmove.k touchend.k");
        n.val(n.cv);
      });
      return this;
    };
    this._mouse = function (e) {
      var r = function (e) {
        var t = n.xy2val(e.pageX, e.pageY);
        if (t == n.cv) return;
        if (n.cH && n.cH(t) === false) return;
        n.change(n._validate(t));
        n._draw();
      };
      r(e);
      t.c.d
        .bind("mousemove.k", r)
        .bind("keyup.k", function (e) {
          if (e.keyCode === 27) {
            t.c.d.unbind("mouseup.k mousemove.k keyup.k");
            if (n.eH && n.eH() === false) return;
            n.cancel();
          }
        })
        .bind("mouseup.k", function (e) {
          t.c.d.unbind("mousemove.k mouseup.k keyup.k");
          n.val(n.cv);
        });
      return this;
    };
    this._xy = function () {
      var e = this.$c.offset();
      this.x = e.left;
      this.y = e.top;
      return this;
    };
    this._listen = function () {
      if (!this.o.readOnly) {
        this.$c
          .bind("mousedown", function (e) {
            e.preventDefault();
            n._xy()._mouse(e);
          })
          .bind("touchstart", function (e) {
            e.preventDefault();
            n._xy()._touch(e);
          });
        this.listen();
      } else {
        this.$.attr("readonly", "readonly");
      }
      if (this.relative) {
        e(window).resize(
          e.debounce(50, function () {
            n._carve().init();
            n._draw();
          })
        );
      }
      return this;
    };
    this._configure = function () {
      if (this.o.draw) this.dH = this.o.draw;
      if (this.o.change) this.cH = this.o.change;
      if (this.o.cancel) this.eH = this.o.cancel;
      if (this.o.release) this.rH = this.o.release;
      if (this.o.displayPrevious) {
        this.pColor = this.h2rgba(this.o.fgColor, "0.4");
        this.fgColor = this.h2rgba(this.o.fgColor, "0.6");
      } else {
        this.fgColor = this.o.fgColor;
      }
      return this;
    };
    this._clear = function () {
      this.$c[0].width = this.$c[0].width;
    };
    this._validate = function (e) {
      var t = ~~((e < 0 ? -0.5 : 0.5) + e / this.o.step) * this.o.step;
      return Math.round(t * 100) / 100;
    };
    this.listen = function () {};
    this.extend = function () {};
    this.init = function () {};
    this.change = function (e) {};
    this.val = function (e) {};
    this.xy2val = function (e, t) {};
    this.draw = function () {};
    this.clear = function () {
      this._clear();
    };
    this.h2rgba = function (e, t) {
      var n;
      e = e.substring(1, 7);
      n = [
        parseInt(e.substring(0, 2), 16),
        parseInt(e.substring(2, 4), 16),
        parseInt(e.substring(4, 6), 16),
      ];
      return "rgba(" + n[0] + "," + n[1] + "," + n[2] + "," + t + ")";
    };
    this.copy = function (e, t) {
      for (var n in e) {
        t[n] = e[n];
      }
    };
  };
  t.Dial = function () {
    t.o.call(this);
    this.startAngle = null;
    this.xy = null;
    this.radius = null;
    this.lineWidth = null;
    this.cursorExt = null;
    this.w2 = null;
    this.PI2 = 2 * Math.PI;
    this.extend = function () {
      this.o = e.extend(
        {
          bgColor: this.$.data("bgcolor") || "#EEEEEE",
          angleOffset: this.$.data("angleoffset") || 0,
          angleArc: this.$.data("anglearc") || 360,
          inline: true,
        },
        this.o
      );
    };
    this.val = function (e, t) {
      if (null != e) {
        e = this.o.parse(e);
        if (t !== false && e != this.v && this.rH && this.rH(e) === false) {
          return;
        }
        this.cv = this.o.stopper ? n(r(e, this.o.max), this.o.min) : e;
        this.v = this.cv;
        this.$.val(this.o.format(this.v));
        this._draw();
      } else {
        return this.v;
      }
    };
    this.xy2val = function (e, t) {
      var i, s;
      i =
        Math.atan2(e - (this.x + this.w2), -(t - this.y - this.w2)) -
        this.angleOffset;
      if (this.o.flip) {
        i = this.angleArc - i - this.PI2;
      }
      if (this.angleArc != this.PI2 && i < 0 && i > -0.5) {
        i = 0;
      } else if (i < 0) {
        i += this.PI2;
      }
      s = (i * (this.o.max - this.o.min)) / this.angleArc + this.o.min;
      this.o.stopper && (s = n(r(s, this.o.max), this.o.min));
      return s;
    };
    this.listen = function () {
      var t = this,
        i,
        s,
        o = function (e) {
          e.preventDefault();
          var o = e.originalEvent,
            u = o.detail || o.wheelDeltaX,
            a = o.detail || o.wheelDeltaY,
            f =
              t._validate(t.o.parse(t.$.val())) +
              (u > 0 || a > 0 ? t.o.step : u < 0 || a < 0 ? -t.o.step : 0);
          f = n(r(f, t.o.max), t.o.min);
          t.val(f, false);
          if (t.rH) {
            clearTimeout(i);
            i = setTimeout(function () {
              t.rH(f);
              i = null;
            }, 100);
            if (!s) {
              s = setTimeout(function () {
                if (i) t.rH(f);
                s = null;
              }, 200);
            }
          }
        },
        u,
        a,
        f = 1,
        l = { 37: -t.o.step, 38: t.o.step, 39: t.o.step, 40: -t.o.step };
      this.$.bind("keydown", function (i) {
        var s = i.keyCode;
        if (s >= 96 && s <= 105) {
          s = i.keyCode = s - 48;
        }
        u = parseInt(String.fromCharCode(s));
        if (isNaN(u)) {
          s !== 13 &&
            s !== 8 &&
            s !== 9 &&
            s !== 189 &&
            (s !== 190 || t.$.val().match(/\./)) &&
            i.preventDefault();
          if (e.inArray(s, [37, 38, 39, 40]) > -1) {
            i.preventDefault();
            var o = t.o.parse(t.$.val()) + l[s] * f;
            t.o.stopper && (o = n(r(o, t.o.max), t.o.min));
            t.change(t._validate(o));
            t._draw();
            a = window.setTimeout(function () {
              f *= 2;
            }, 30);
          }
        }
      }).bind("keyup", function (e) {
        if (isNaN(u)) {
          if (a) {
            window.clearTimeout(a);
            a = null;
            f = 1;
            t.val(t.$.val());
          }
        } else {
          (t.$.val() > t.o.max && t.$.val(t.o.max)) ||
            (t.$.val() < t.o.min && t.$.val(t.o.min));
        }
      });
      this.$c.bind("mousewheel DOMMouseScroll", o);
      this.$.bind("mousewheel DOMMouseScroll", o);
    };
    this.init = function () {
      if (this.v < this.o.min || this.v > this.o.max) {
        this.v = this.o.min;
      }
      this.$.val(this.v);
      this.w2 = this.w / 2;
      this.cursorExt = this.o.cursor / 100;
      this.xy = this.w2 * this.scale;
      this.lineWidth = this.xy * this.o.thickness;
      this.lineCap = this.o.lineCap;
      this.radius = this.xy - this.lineWidth / 2;
      this.o.angleOffset &&
        (this.o.angleOffset = isNaN(this.o.angleOffset)
          ? 0
          : this.o.angleOffset);
      this.o.angleArc &&
        (this.o.angleArc = isNaN(this.o.angleArc) ? this.PI2 : this.o.angleArc);
      this.angleOffset = (this.o.angleOffset * Math.PI) / 180;
      this.angleArc = (this.o.angleArc * Math.PI) / 180;
      this.startAngle = 1.5 * Math.PI + this.angleOffset;
      this.endAngle = 1.5 * Math.PI + this.angleOffset + this.angleArc;
      var e =
        n(
          String(Math.abs(this.o.max)).length,
          String(Math.abs(this.o.min)).length,
          2
        ) + 2;
      (this.o.displayInput &&
        this.i.css({
          width: ((this.w / 2 + 4) >> 0) + "px",
          height: ((this.w / 3) >> 0) + "px",
          position: "absolute",
          "vertical-align": "middle",
          "margin-top": ((this.w / 3) >> 0) + "px",
          "margin-left": "-" + (((this.w * 3) / 4 + 2) >> 0) + "px",
          border: 0,
          background: "none",
          font:
            this.o.fontWeight + " " + ((this.w / e) >> 0) + "px " + this.o.font,
          "text-align": "center",
          color: this.o.inputColor || this.o.fgColor,
          padding: "0px",
          "-webkit-appearance": "none",
        })) ||
        this.i.css({ width: "0px", visibility: "hidden" });
    };
    this.change = function (e) {
      this.cv = e;
      this.$.val(this.o.format(e));
    };
    this.angle = function (e) {
      return ((e - this.o.min) * this.angleArc) / (this.o.max - this.o.min);
    };
    this.arc = function (e) {
      var t, n;
      e = this.angle(e);
      if (this.o.flip) {
        t = this.endAngle + 1e-5;
        n = t - e - 1e-5;
      } else {
        t = this.startAngle - 1e-5;
        n = t + e + 1e-5;
      }
      this.o.cursor && (t = n - this.cursorExt) && (n = n + this.cursorExt);
      return { s: t, e: n, d: this.o.flip && !this.o.cursor };
    };
    this.draw = function () {
      var e = this.g,
        t = this.arc(this.cv),
        n,
        r = 1;
      e.lineWidth = this.lineWidth;
      e.lineCap = this.lineCap;
      if (this.o.bgColor !== "none") {
        e.beginPath();
        e.strokeStyle = this.o.bgColor;
        e.arc(
          this.xy,
          this.xy,
          this.radius,
          this.endAngle - 1e-5,
          this.startAngle + 1e-5,
          true
        );
        e.stroke();
      }
      if (this.o.displayPrevious) {
        n = this.arc(this.v);
        e.beginPath();
        e.strokeStyle = this.pColor;
        e.arc(this.xy, this.xy, this.radius, n.s, n.e, n.d);
        e.stroke();
        r = this.cv == this.v;
      }
      e.beginPath();
      e.strokeStyle = r ? this.o.fgColor : this.fgColor;
      e.arc(this.xy, this.xy, this.radius, t.s, t.e, t.d);
      e.stroke();
    };
    this.cancel = function () {
      this.val(this.v);
    };
  };
  e.fn.dial = e.fn.knob = function (n) {
    return this.each(function () {
      var r = new t.Dial();
      r.o = n;
      r.$ = e(this);
      r.run();
    }).parent();
  };
})(
  /*
   * jQuery throttle / debounce - v1.1 - 3/7/2010
   * http://benalman.com/projects/jquery-throttle-debounce-plugin/
   *
   * Copyright (c) 2010 "Cowboy" Ben Alman
   * Dual licensed under the MIT and GPL licenses.
   * http://benalman.com/about/license/
   */
  function (b, c) {
    var $ = b.jQuery || b.Cowboy || (b.Cowboy = {}),
      a;
    $.throttle = a = function (e, f, j, i) {
      var h,
        d = 0;
      if (typeof f !== "boolean") {
        i = j;
        j = f;
        f = c;
      }
      function g() {
        var o = this,
          m = +new Date() - d,
          n = arguments;
        function l() {
          d = +new Date();
          j.apply(o, n);
        }
        function k() {
          h = c;
        }
        if (i && !h) {
          l();
        }
        h && clearTimeout(h);
        if (i === c && m > e) {
          l();
        } else {
          if (f !== true) {
            h = setTimeout(i ? k : l, i === c ? e - m : e);
          }
        }
      }
      if ($.guid) {
        g.guid = j.guid = j.guid || $.guid++;
      }
      return g;
    };
    $.debounce = function (d, e, f) {
      return f === c ? a(d, e, false) : a(d, f, e !== false);
    };
  }
)(this);
/**
 * TimeTo jQuery plug-in
 * Show countdown timer or realtime clock
 *
 * @author Alexey Teterin <altmoc@gmail.com>
 * @version 1.0.15
 * @license MIT http://opensource.org/licenses/MIT
 * @date 2014-01-17
 */
(function ($) {
  var defaults = {
    callback: null, // callback function for exec when timer out
    captionSize: 0, // font-size by pixels for captions, if 0 then calculate automaticaly
    countdown: true, // is countdown or real clock
    countdownAlertLimit: 10, // limit in seconds when display red background
    displayCaptions: false, // display captions under digit groups
    displayDays: 0, // display day timer, count of days digits
    displayHours: true, // display hours
    fontFamily: "Verdana, sans-serif",
    fontSize: 28, // font-size of a digit by pixels
    lang: { days: "days", hours: "hours", min: "minutes", sec: "secondes" }, // language of caption
    seconds: 0, // timer's countdown value in seconds
    start: true, // true to start timer immediately
    theme: "white", // 'white' or 'black' theme fo timer's view

    vals: [0, 0, 0, 0, 0, 0, 0, 0, 0], // private, current value of each digit
    limits: [9, 9, 9, 2, 9, 5, 9, 5, 9], // private, max value of each digit
    iSec: 8, // private, index of second digit
    iHour: 4, // private, index of hour digit
    tickTimeout: 1000, // timeout betweet each timer tick in miliseconds
    intervalId: null, // private
  };

  var methods = {
    start: function (sec) {
      if (sec) init.call(this, sec);
      var me = this,
        intervalId = setTimeout(function () {
          tick.call(me);
        }, 1000);

      // save start time
      this.data("ttStartTime", new Date().getTime());
      this.data("intervalId", intervalId);
    },

    stop: function () {
      var data = this.data();

      if (data.intervalId) {
        clearTimeout(data.intervalId);
        this.data("intervalId", null);
      }
      return data;
    },

    reset: function (sec) {
      var data = methods.stop.call(this);

      this.find("div").css({ backgroundPosition: "left center" });
      this.find("ul").parent().removeClass("timeTo-alert");

      if (typeof sec === "undefined") {
        sec = data.value;
      }
      init.call(this, sec, true);
    },
  };
  if (typeof $.support.transition === "undefined") {
    $.support.transition = (function () {
      var thisBody = document.body || document.documentElement,
        thisStyle = thisBody.style,
        support =
          thisStyle.transition !== undefined ||
          thisStyle.WebkitTransition !== undefined ||
          thisStyle.MozTransition !== undefined ||
          thisStyle.MsTransition !== undefined ||
          thisStyle.OTransition !== undefined;

      return support;
    })();
  }

  $.fn.timeTo = function () {
    var method,
      options = {};

    for (var i = 0, arg; (arg = arguments[i]); ++i) {
      if (i == 0 && typeof arg === "string") {
        method = arg;
      } else {
        if (typeof arg === "object") {
          if (typeof arg.getTime === "function") {
            options.timeTo = arg;
          } else {
            options = $.extend(options, arg);
          }
        } else {
          if (typeof arg === "function") {
            options.callback = arg;
          } else {
            var v = parseInt(arg, 10);
            if (!isNaN(v)) {
              options.seconds = v;
            }
          }
        }
      }
    }

    // set time for countdown to
    if (options.timeTo) {
      var time,
        now = new Date().getTime();

      if (options.timeTo.getTime) {
        // set time as date object
        time = options.timeTo.getTime();
      } else if (typeof options.timeTo === "number") {
        // set time as integer in millisec
        time = options.timeTo;
      }
      if (options.timeTo > now) {
        options.seconds = Math.floor((time - now) / 1000);
      }
    } else if (options.time || !options.seconds) {
      var time = options.time;

      if (!time) time = new Date();

      if (typeof time === "object" && time.getTime) {
        options.seconds =
          time.getHours() * 3600 + time.getMinutes() * 60 + time.getSeconds();
        options.countdown = false;
      } else if (typeof time === "string") {
        var tt = time.split(":"),
          sec = 0,
          m = 1,
          t;

        while ((t = tt.pop())) {
          sec += t * m;
          m *= 60;
        }
        options.seconds = sec;
        options.countdown = false;
      }
    }

    if (
      options.countdown !== false &&
      options.seconds > 86400 &&
      typeof options.displayDays === "undefined"
    ) {
      var days = Math.floor(options.seconds / 86400);
      options.displayDays = (days < 10 && 1) || (days < 100 && 2) || 3;
    } else if (options.displayDays === true) {
      options.displayDays = 3;
    } else if (options.displayDays) {
      options.displayDays =
        options.displayDays > 0 ? Math.floor(options.displayDays) : 3;
    }

    return this.each(function () {
      var $this = $(this),
        data = $this.data(),
        i;

      if (data.intervalId) {
        clearInterval(data.intervalId);
        data.intervalId = null;
      }

      if (!data.vals || method === "reset") {
        // new clock
        if (data.options) {
          options = data.options;
        }
        data = $.extend(defaults, options);
        data.options = options;

        data.height = Math.round((data.fontSize * 100) / 93);
        data.width = Math.round(data.fontSize * 0.8 + data.height * 0.13);
        data.displayHours = !!(data.displayDays || data.displayHours);

        $this
          .addClass("timeTo")
          .addClass("timeTo-" + data.theme)
          .css({
            fontFamily: data.fontFamily,
            fontSize: data.fontSize + "px",
          });

        var left = Math.round(data.height / 10),
          ulhtml =
            '<ul style="left:' +
            left +
            "px; top:-" +
            data.height +
            'px"><li>0</li><li>0</li></ul></div>',
          style =
            ' style="width:' +
            data.width +
            "px; height:" +
            data.height +
            'px;"',
          dhtml1 = '<div class="first"' + style + ">" + ulhtml,
          dhtml2 = "<div" + style + ">" + ulhtml,
          dot2 = "<span> </span>",
          maxWidth = Math.round(data.width * 2 + 3),
          captionSize = data.captionSize || Math.round(data.fontSize * 0.43),
          thtml = (
            data.displayCaptions
              ? (data.displayHours
                  ? '<figure style="max-width:' +
                    maxWidth +
                    'px">$1<figcaption style="font-size:' +
                    captionSize +
                    'px">' +
                    data.lang.hours +
                    "</figcaption></figure>" +
                    dot2
                  : "") +
                '<figure style="max-width:' +
                maxWidth +
                'px">$1<figcaption style="font-size:' +
                captionSize +
                'px">' +
                data.lang.min +
                "</figcaption></figure>" +
                dot2 +
                '<figure style="max-width:' +
                maxWidth +
                'px">$1<figcaption style="font-size:' +
                captionSize +
                'px">' +
                data.lang.sec +
                "</figcaption></figure>" +
                '<span style="width: 8px;  display: inline-block;"> </span>'
              : (data.displayHours ? "$1" + dot2 : "") + "$1" + dot2 + "$1"
          ).replace(/\$1/g, dhtml1 + dhtml2);

        if (data.displayDays > 0) {
          var marginRight = data.fontSize * 0.4,
            dhtml = dhtml1;
          for (i = data.displayDays - 1; i > 0; i--) {
            dhtml +=
              i === 1
                ? dhtml2.replace(
                    '">',
                    " margin-right:" + Math.round(marginRight) + 'px">'
                  )
                : dhtml2;
          }
          thtml =
            (data.displayCaptions
              ? '<figure style="width:' +
                Math.round(data.width * data.displayDays + marginRight + 4) +
                'px">$1<figcaption style="font-size:' +
                captionSize +
                "px; padding-right:" +
                Math.round(marginRight) +
                'px">' +
                data.lang.days +
                "</figcaption></figure>"
              : "$1"
            ).replace(/\$1/, dhtml) + thtml;
        }
        $this.html(thtml);
      } else {
        // exists clock
        $.extend(data, options);
      }

      var $digits = $this.find("div");

      if ($digits.length < data.vals.length) {
        var dif = data.vals.length - $digits.length,
          vals = data.vals,
          limits = data.limits;

        data.vals = [];
        data.limits = [];
        for (i = 0; i < $digits.length; i++) {
          data.vals[i] = vals[dif + i];
          data.limits[i] = limits[dif + i];
        }
        data.iSec = data.vals.length - 1;
        data.iHour = data.vals.length - 5;
      }
      data.sec = data.seconds;
      $this.data(data);

      if (method && methods[method]) {
        methods[method].call($this, data.seconds);
      } else if (data.start) {
        methods.start.call($this, data.seconds);
      } else {
        init.call($this, data.seconds);
      }
    });
  };

  function init(sec, force) {
    var data = this.data(),
      $digits = this.find("ul"),
      isInterval = false;

    if (!data.vals || $digits.length === 0) {
      return;
    }

    if (!sec) {
      sec = data.seconds;
    }

    if (data.intervalId) {
      isInterval = true;
      clearTimeout(data.intervalId);
    }

    var days = Math.floor(sec / 86400),
      rest = days * 86400,
      h = Math.floor((sec - rest) / 3600);

    rest += h * 3600;

    var m = Math.floor((sec - rest) / 60);

    rest += m * 60;

    var s = sec - rest,
      str =
        (days < 100 ? "0" + (days < 10 ? "0" : "") : "") +
        days +
        (h < 10 ? "0" : "") +
        h +
        (m < 10 ? "0" : "") +
        m +
        (s < 10 ? "0" : "") +
        s;

    for (
      var i = data.vals.length - 1, j = str.length - 1, v;
      i >= 0;
      i--, j--
    ) {
      v = parseInt(str.substr(j, 1));
      data.vals[i] = v;
      $digits.eq(i).children().html(v);
    }
    if (isInterval || force) {
      var me = this;
      data.ttStartTime = Date.now();
      data.intervalId = setTimeout(function () {
        tick.call(me);
      }, 1000);
      this.data("intervalId", data.intervalId);
    }
  }

  /**
   * Switch specified digit by digit index
   * @param {number} - digit index
   */
  function tick(digit) {
    var $digits = this.find("ul"),
      data = this.data();

    if (!data.vals || $digits.length == 0) {
      if (data.intervalId) {
        clearTimeout(data.intervalId);
        this.data("intervalId", null);
      }
      if (data.callback) {
        data.callback();
      }

      return;
    }
    if (digit == undefined) {
      digit = data.iSec;
    }

    var n = data.vals[digit],
      $ul = $digits.eq(digit),
      $li = $ul.children(),
      step = data.countdown ? -1 : 1;

    $li.eq(1).html(n);
    n += step;

    if (digit == data.iSec) {
      var tickTimeout = data.tickTimeout,
        timeDiff = new Date().getTime() - data.ttStartTime;

      data.sec += step;

      tickTimeout += Math.abs(data.seconds - data.sec) * tickTimeout - timeDiff;

      data.intervalId = setTimeout(function () {
        tick.call(me);
      }, tickTimeout);
    }

    if (n < 0 || n > data.limits[digit]) {
      if (n < 0) {
        n = data.limits[digit];
        if (
          digit == data.iHour &&
          data.displayDays > 0 &&
          digit > 0 &&
          data.vals[digit - 1] == 0
        )
          // fix for hours when day changing
          n = 3;
      } else {
        n = 0;
      }

      if (digit > 0) {
        tick.call(this, digit - 1);
      }
    }
    //$ul.removeClass('transition');
    //$ul.css({top:"-" + data.height + "px"});
    $li.eq(0).html(n);

    var me = this;

    if ($.support.transition) {
      $ul.addClass("transition");
      $ul.css({ top: 0 });

      setTimeout(function () {
        $ul.removeClass("transition");
        $li.eq(1).html(n);
        $ul.css({ top: "-" + data.height + "px" });

        if (step > 0 || digit != data.iSec) {
          return;
        }

        if (data.sec == data.countdownAlertLimit) {
          $digits.parent().addClass("timeTo-alert");
        }

        if (data.sec === 0) {
          $digits.parent().removeClass("timeTo-alert");

          if (data.intervalId) {
            clearTimeout(data.intervalId);
            me.data("intervalId", null);
          }

          if (typeof data.callback === "function") {
            data.callback();
          }
        }
      }, 410);
    } else {
      $ul.stop().animate(
        { top: 0 },
        400,
        digit != data.iSec
          ? null
          : function () {
              $li.eq(1).html(n);
              $ul.css({ top: "-" + data.height + "px" });
              if (step > 0 || digit != data.iSec) {
                return;
              }

              if (data.sec == data.countdownAlertLimit) {
                $digits.parent().addClass("timeTo-alert");
              } else if (data.sec == 0) {
                $digits.parent().removeClass("timeTo-alert");

                if (data.intervalId) {
                  clearTimeout(data.intervalId);
                  me.data("intervalId", null);
                }

                if (typeof data.callback === "function") {
                  data.callback();
                }
              }
            }
      );
    }
    data.vals[digit] = n;
    //this.data('vals', data.vals);
  }

  return jQuery;
})(jQuery);

function vc_js() {
  /* nectar addition */
  /*
    vc_toggleBehaviour(), vc_tabsBehaviour(), vc_accordionBehaviour(), vc_teaserGrid(), vc_carouselBehaviour(), vc_slidersBehaviour(), vc_prettyPhoto(), vc_googleplus(), vc_pinterest(), vc_progress_bar(), vc_plugin_flexslider(), vc_google_fonts(), vc_gridBehaviour(), vc_rowBehaviour(), vc_googleMapsPointer(), vc_ttaActivation();
    jQuery(document).trigger("vc_js"), window.setTimeout(vc_waypoints, 500)*/
  /* nectar addition end */
}

function getSizeName() {
  var screen_w = jQuery(window).width();
  return 1170 < screen_w
    ? "desktop_wide"
    : 960 < screen_w && 1169 > screen_w
    ? "desktop"
    : 768 < screen_w && 959 > screen_w
    ? "tablet"
    : 300 < screen_w && 767 > screen_w
    ? "mobile"
    : 300 > screen_w
    ? "mobile_portrait"
    : "";
}

function loadScript(url, $obj, callback) {
  var script = document.createElement("script");
  (script.type = "text/javascript"),
    script.readyState &&
      (script.onreadystatechange = function () {
        ("loaded" !== script.readyState && "complete" !== script.readyState) ||
          ((script.onreadystatechange = null), callback());
      }),
    (script.src = url),
    $obj.get(0).appendChild(script);
}

function vc_ttaActivation() {
  jQuery("[data-vc-accordion]").on("show.vc.accordion", function (e) {
    var $ = window.jQuery,
      ui = {};
    (ui.newPanel = $(this).data("vc.accordion").getTarget()),
      window.wpb_prepare_tab_content(e, ui);
  });
}

function vc_accordionActivate(event, ui) {
  if (ui.newPanel.length && ui.newHeader.length) {
    var $pie_charts = ui.newPanel.find(".vc_pie_chart:not(.vc_ready)"),
      $round_charts = ui.newPanel.find(".vc_round-chart"),
      $line_charts = ui.newPanel.find(".vc_line-chart"),
      $carousel = ui.newPanel.find('[data-ride="vc_carousel"]');
    "undefined" != typeof jQuery.fn.isotope &&
      ui.newPanel.find(".isotope, .wpb_image_grid_ul").isotope("layout"),
      ui.newPanel.find(".vc_masonry_media_grid, .vc_masonry_grid").length &&
        ui.newPanel
          .find(".vc_masonry_media_grid, .vc_masonry_grid")
          .each(function () {
            var grid = jQuery(this).data("vcGrid");
            grid &&
              grid.gridBuilder &&
              grid.gridBuilder.setMasonry &&
              grid.gridBuilder.setMasonry();
          }),
      vc_carouselBehaviour(ui.newPanel),
      vc_plugin_flexslider(ui.newPanel),
      $pie_charts.length && jQuery.fn.vcChat && $pie_charts.vcChat(),
      $round_charts.length &&
        jQuery.fn.vcRoundChart &&
        $round_charts.vcRoundChart({
          reload: !1,
        }),
      $line_charts.length &&
        jQuery.fn.vcLineChart &&
        $line_charts.vcLineChart({
          reload: !1,
        }),
      $carousel.length &&
        jQuery.fn.carousel &&
        $carousel.carousel("resizeAction"),
      ui.newPanel.parents(".isotope").length &&
        ui.newPanel.parents(".isotope").each(function () {
          jQuery(this).isotope("layout");
        });
  }
}

function initVideoBackgrounds() {
  return (
    window.console &&
      window.console.warn &&
      window.console.warn(
        "this function is deprecated use vc_initVideoBackgrounds"
      ),
    vc_initVideoBackgrounds()
  );
}

function vc_initVideoBackgrounds() {
  jQuery("[data-vc-video-bg]").each(function () {
    var youtubeUrl,
      youtubeId,
      $element = jQuery(this);
    $element.data("vcVideoBg")
      ? ((youtubeUrl = $element.data("vcVideoBg")),
        (youtubeId = vcExtractYoutubeId(youtubeUrl)),
        youtubeId &&
          ($element.find(".vc_video-bg").remove(),
          insertYoutubeVideoAsBackground($element, youtubeId)),
        jQuery(window).on("grid:items:added", function (event, $grid) {
          $element.has($grid).length && vcResizeVideoBackground($element);
        }))
      : $element.find(".vc_video-bg").remove();
  });
}

function insertYoutubeVideoAsBackground($element, youtubeId, counter) {
  if ("undefined" == typeof YT || "undefined" == typeof YT.Player)
    return (
      (counter = "undefined" == typeof counter ? 0 : counter),
      100 < counter
        ? void console.warn("Too many attempts to load YouTube api")
        : void setTimeout(function () {
            insertYoutubeVideoAsBackground($element, youtubeId, counter++);
          }, 100)
    );
  var $container = $element
    .prepend(
      '<div class="vc_video-bg vc_hidden-xs"><div class="inner"></div></div>'
    )
    .find(".inner");
  new YT.Player($container[0], {
    width: "100%",
    height: "100%",
    videoId: youtubeId,
    playerVars: {
      playlist: youtubeId,
      iv_load_policy: 3,
      enablejsapi: 1,
      disablekb: 1,
      autoplay: 1,
      controls: 0,
      showinfo: 0,
      rel: 0,
      loop: 1,
      wmode: "transparent",
    },
    events: {
      onReady: function (event) {
        event.target.mute().setLoop(!0);
      },
    },
  }),
    vcResizeVideoBackground($element),
    jQuery(window).bind("resize", function () {
      vcResizeVideoBackground($element);
    });
}

function vcResizeVideoBackground($element) {
  var iframeW,
    iframeH,
    marginLeft,
    marginTop,
    containerW = $element.innerWidth(),
    containerH = $element.innerHeight(),
    ratio1 = 16,
    ratio2 = 9;
  containerW / containerH < ratio1 / ratio2
    ? ((iframeW = containerH * (ratio1 / ratio2)),
      (iframeH = containerH),
      (marginLeft = -Math.round((iframeW - containerW) / 2) + "px"),
      (marginTop = -Math.round((iframeH - containerH) / 2) + "px"),
      (iframeW += "px"),
      (iframeH += "px"))
    : ((iframeW = containerW),
      (iframeH = containerW * (ratio2 / ratio1)),
      (marginTop = -Math.round((iframeH - containerH) / 2) + "px"),
      (marginLeft = -Math.round((iframeW - containerW) / 2) + "px"),
      (iframeW += "px"),
      (iframeH += "px")),
    $element.find(".vc_video-bg iframe").css({
      maxWidth: "1000%",
      marginLeft: marginLeft,
      marginTop: marginTop,
      width: iframeW,
      height: iframeH,
    });
}

function vcExtractYoutubeId(url) {
  if ("undefined" == typeof url) return !1;
  var id = url.match(
    /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/
  );
  return null !== id && id[1];
}

function vc_googleMapsPointer() {
  var $ = window.jQuery,
    $wpbGmapsWidget = $(".wpb_gmaps_widget");
  $wpbGmapsWidget.click(function () {
    $("iframe", this).css("pointer-events", "auto");
  }),
    $wpbGmapsWidget.mouseleave(function () {
      $("iframe", this).css("pointer-events", "none");
    }),
    $(".wpb_gmaps_widget iframe").css("pointer-events", "none");
}
(document.documentElement.className += " js_active "),
  (document.documentElement.className +=
    "ontouchstart" in document.documentElement
      ? " vc_mobile "
      : " vc_desktop "),
  (function () {
    for (
      var prefix = ["-webkit-", "-moz-", "-ms-", "-o-", ""], i = 0;
      i < prefix.length;
      i++
    )
      prefix[i] + "transform" in document.documentElement.style &&
        (document.documentElement.className += " vc_transform ");
  })(),
  "function" != typeof window.vc_plugin_flexslider &&
    (window.vc_plugin_flexslider = function ($parent) {
      var $slider = $parent
        ? $parent.find(".wpb_flexslider")
        : jQuery(".wpb_flexslider");
      $slider.each(function () {
        var this_element = jQuery(this),
          sliderSpeed = 800,
          sliderTimeout = 1e3 * parseInt(this_element.attr("data-interval")),
          sliderFx = this_element.attr("data-flex_fx"),
          slideshow = !0;
        0 === sliderTimeout && (slideshow = !1),
          this_element.is(":visible") &&
            this_element.flexslider({
              animation: sliderFx,
              slideshow: slideshow,
              slideshowSpeed: sliderTimeout,
              sliderSpeed: sliderSpeed,
              smoothHeight: !0,
            });
      });
    }),
  "function" != typeof window.vc_googleplus &&
    (window.vc_googleplus = function () {
      0 < jQuery(".wpb_googleplus").length &&
        !(function () {
          var po = document.createElement("script");
          (po.type = "text/javascript"),
            (po.async = !0),
            (po.src = "//apis.google.com/js/plusone.js");
          var s = document.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(po, s);
        })();
    }),
  "function" != typeof window.vc_pinterest &&
    (window.vc_pinterest = function () {
      0 < jQuery(".wpb_pinterest").length &&
        !(function () {
          var po = document.createElement("script");
          (po.type = "text/javascript"),
            (po.async = !0),
            (po.src = "//assets.pinterest.com/js/pinit.js");
          var s = document.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(po, s);
        })();
    }),
  "function" != typeof window.vc_progress_bar &&
    (window.vc_progress_bar = function () {
      "undefined" != typeof jQuery.fn.waypoint &&
        jQuery(".vc_progress_bar").waypoint(
          function () {
            jQuery(this)
              .find(".vc_single_bar")
              .each(function (index) {
                var $this = jQuery(this),
                  bar = $this.find(".vc_bar"),
                  val = bar.data("percentage-value");
                setTimeout(function () {
                  bar.css({
                    width: val + "%",
                  });
                }, 200 * index);
              });
          },
          {
            offset: "85%",
          }
        );
    }),
  "function" != typeof window.vc_waypoints &&
    (window.vc_waypoints = function () {
      "undefined" != typeof jQuery.fn.waypoint &&
        jQuery(
          ".wpb_animate_when_almost_visible:not(.wpb_start_animation)"
        ).waypoint(
          function () {
            jQuery(this).addClass("wpb_start_animation animated");
          },
          {
            offset: "85%",
          }
        );
    }),
  "function" != typeof window.vc_toggleBehaviour &&
    (window.vc_toggleBehaviour = function ($el) {
      function event(e) {
        e && e.preventDefault && e.preventDefault();
        var title = jQuery(this),
          element = title.closest(".vc_toggle"),
          content = element.find(".vc_toggle_content");
        element.hasClass("vc_toggle_active")
          ? content.slideUp({
              duration: 300,
              complete: function () {
                element.removeClass("vc_toggle_active");
              },
            })
          : content.slideDown({
              duration: 300,
              complete: function () {
                element.addClass("vc_toggle_active");
              },
            });
      }
      $el
        ? $el.hasClass("vc_toggle_title")
          ? $el.unbind("click").click(event)
          : $el.find(".vc_toggle_title").unbind("click").click(event)
        : jQuery(".vc_toggle_title").unbind("click").on("click", event);
    }),
  "function" != typeof window.vc_tabsBehaviour &&
    (window.vc_tabsBehaviour = function ($tab) {
      if (jQuery.ui) {
        var $call = $tab || jQuery(".wpb_tabs, .wpb_tour"),
          ver =
            jQuery.ui && jQuery.ui.version
              ? jQuery.ui.version.split(".")
              : "1.10",
          old_version = 1 === parseInt(ver[0]) && 9 > parseInt(ver[1]);
        $call.each(function (index) {
          var $tabs,
            interval = jQuery(this).attr("data-interval"),
            tabs_array = [];
          if (
            (($tabs = jQuery(this)
              .find(".wpb_tour_tabs_wrapper")
              .tabs({
                show: function (event, ui) {
                  wpb_prepare_tab_content(event, ui);
                },
                beforeActivate: function (event, ui) {
                  1 !== ui.newPanel.index() &&
                    ui.newPanel.find(".vc_pie_chart:not(.vc_ready)");
                },
                activate: function (event, ui) {
                  wpb_prepare_tab_content(event, ui);
                },
              })),
            interval && 0 < interval)
          )
            try {
              $tabs.tabs("rotate", 1e3 * interval);
            } catch (e) {
              window.console && window.console.log && console.log(e);
            }
          jQuery(this)
            .find(".wpb_tab")
            .each(function () {
              tabs_array.push(this.id);
            }),
            jQuery(this)
              .find(".wpb_tabs_nav li")
              .click(function (e) {
                return (
                  e.preventDefault(),
                  old_version
                    ? $tabs.tabs("select", jQuery("a", this).attr("href"))
                    : $tabs.tabs("option", "active", jQuery(this).index()),
                  !1
                );
              }),
            jQuery(this)
              .find(".wpb_prev_slide a, .wpb_next_slide a")
              .click(function (e) {
                if ((e.preventDefault(), old_version)) {
                  var index = $tabs.tabs("option", "selected");
                  jQuery(this).parent().hasClass("wpb_next_slide")
                    ? index++
                    : index--,
                    0 > index
                      ? (index = $tabs.tabs("length") - 1)
                      : index >= $tabs.tabs("length") && (index = 0),
                    $tabs.tabs("select", index);
                } else {
                  var index = $tabs.tabs("option", "active"),
                    length = $tabs.find(".wpb_tab").length;
                  (index = jQuery(this).parent().hasClass("wpb_next_slide")
                    ? index + 1 >= length
                      ? 0
                      : index + 1
                    : 0 > index - 1
                    ? length - 1
                    : index - 1),
                    $tabs.tabs("option", "active", index);
                }
              });
        });
      }
    }),
  "function" != typeof window.vc_accordionBehaviour &&
    (window.vc_accordionBehaviour = function () {
      jQuery(".wpb_accordion").each(function (index) {
        var $tabs,
          $this = jQuery(this),
          active_tab =
            ($this.attr("data-interval"),
            !isNaN(jQuery(this).data("active-tab")) &&
              0 < parseInt($this.data("active-tab")) &&
              parseInt($this.data("active-tab")) - 1),
          collapsible =
            !1 === active_tab || "yes" === $this.data("collapsible");
        ($tabs = $this.find(".wpb_accordion_wrapper").accordion({
          header: "> div > h3",
          autoHeight: !1,
          heightStyle: "content",
          active: active_tab,
          collapsible: collapsible,
          navigation: !0,
          activate: vc_accordionActivate,
          change: function (event, ui) {
            "undefined" != typeof jQuery.fn.isotope &&
              ui.newContent.find(".isotope").isotope("layout"),
              vc_carouselBehaviour(ui.newPanel);
          },
        })),
          !0 === $this.data("vcDisableKeydown") &&
            ($tabs.data("uiAccordion")._keydown = function () {});
      });
    }),
  "function" != typeof window.vc_teaserGrid &&
    (window.vc_teaserGrid = function () {
      var layout_modes = {
        fitrows: "fitRows",
        masonry: "masonry",
      };
      jQuery(
        ".wpb_grid .teaser_grid_container:not(.wpb_carousel), .wpb_filtered_grid .teaser_grid_container:not(.wpb_carousel)"
      ).each(function () {
        var $container = jQuery(this),
          $thumbs = $container.find(".wpb_thumbnails"),
          layout_mode = $thumbs.attr("data-layout-mode");
        $thumbs.isotope({
          itemSelector: ".isotope-item",
          layoutMode:
            "undefined" == typeof layout_modes[layout_mode]
              ? "fitRows"
              : layout_modes[layout_mode],
        }),
          $container
            .find(".categories_filter a")
            .data("isotope", $thumbs)
            .click(function (e) {
              e.preventDefault();
              var $thumbs = jQuery(this).data("isotope");
              jQuery(this)
                .parent()
                .parent()
                .find(".active")
                .removeClass("active"),
                jQuery(this).parent().addClass("active"),
                $thumbs.isotope({
                  filter: jQuery(this).attr("data-filter"),
                });
            }),
          jQuery(window).bind("load resize", function () {
            $thumbs.isotope("layout");
          });
      });
    }),
  "function" != typeof window.vc_carouselBehaviour &&
    (window.vc_carouselBehaviour = function ($parent) {
      var $carousel = $parent
        ? $parent.find(".wpb_carousel")
        : jQuery(".wpb_carousel");
      $carousel.each(function () {
        var $this = jQuery(this);
        if (!0 !== $this.data("carousel_enabled") && $this.is(":visible")) {
          $this.data("carousel_enabled", !0);
          var carousel_speed = (getColumnsCount(jQuery(this)), 500);
          jQuery(this).hasClass("columns_count_1") && (carousel_speed = 900);
          var carousele_li = jQuery(this).find(".wpb_thumbnails-fluid li");
          carousele_li.css({
            "margin-right": carousele_li.css("margin-left"),
            "margin-left": 0,
          });
          var fluid_ul = jQuery(this).find("ul.wpb_thumbnails-fluid");
          fluid_ul.width(fluid_ul.width() + 300),
            jQuery(window).resize(function () {
              var before_resize = screen_size;
              (screen_size = getSizeName()),
                before_resize != screen_size &&
                  window.setTimeout("location.reload()", 20);
            });
        }
      });
    }),
  "function" != typeof window.vc_slidersBehaviour &&
    (window.vc_slidersBehaviour = function () {
      jQuery(".wpb_gallery_slides").each(function (index) {
        var $imagesGrid,
          this_element = jQuery(this);
        if (this_element.hasClass("wpb_slider_nivo")) {
          var sliderSpeed = 800,
            sliderTimeout = 1e3 * this_element.attr("data-interval");
          0 === sliderTimeout && (sliderTimeout = 9999999999),
            this_element.find(".nivoSlider").nivoSlider({
              effect: "boxRainGrow,boxRain,boxRainReverse,boxRainGrowReverse",
              slices: 15,
              boxCols: 8,
              boxRows: 4,
              animSpeed: sliderSpeed,
              pauseTime: sliderTimeout,
              startSlide: 0,
              directionNav: !0,
              directionNavHide: !0,
              controlNav: !0,
              keyboardNav: !1,
              pauseOnHover: !0,
              manualAdvance: !1,
              prevText: "Prev",
              nextText: "Next",
            });
        } else
          this_element.hasClass("wpb_image_grid") &&
            (jQuery.fn.imagesLoaded
              ? ($imagesGrid = this_element
                  .find(".wpb_image_grid_ul")
                  .imagesLoaded(function () {
                    $imagesGrid.isotope({
                      itemSelector: ".isotope-item",
                      layoutMode: "fitRows",
                    });
                  }))
              : this_element.find(".wpb_image_grid_ul").isotope({
                  itemSelector: ".isotope-item",
                  layoutMode: "fitRows",
                }));
      });
    }),
  "function" != typeof window.vc_prettyPhoto &&
    (window.vc_prettyPhoto = function () {
      try {
        jQuery &&
          jQuery.fn &&
          jQuery.fn.prettyPhoto &&
          jQuery('a.prettyphoto, .gallery-icon a[href*=".jpg"]').prettyPhoto({
            animationSpeed: "normal",
            hook: "data-rel",
            padding: 15,
            opacity: 0.7,
            showTitle: !0,
            allowresize: !0,
            counter_separator_label: "/",
            hideflash: !1,
            deeplinking: !1,
            modal: !1,
            callback: function () {
              var url = location.href;
              url.indexOf("#!prettyPhoto") > -1 && (location.hash = "");
            },
            social_tools: "",
          });
      } catch (err) {
        window.console && window.console.log && console.log(err);
      }
    }),
  "function" != typeof window.vc_google_fonts &&
    (window.vc_google_fonts = function () {
      return !1;
    }),
  (window.vcParallaxSkroll = !1),
  "function" != typeof window.vc_rowBehaviour &&
    (window.vc_rowBehaviour = function () {
      function fullWidthRow() {
        var $elements = $('[data-vc-full-width="true"]');
        $.each($elements, function (key, item) {
          var $el = $(this);
          $el.addClass("vc_hidden");
          var $el_full = $el.next(".vc_row-full-width");
          if (
            ($el_full.length ||
              ($el_full = $el.parent().next(".vc_row-full-width")),
            $el_full.length)
          ) {
            var el_margin_left = parseInt($el.css("margin-left"), 10),
              el_margin_right = parseInt($el.css("margin-right"), 10),
              offset = 0 - $el_full.offset().left - el_margin_left,
              width = $(window).width();
            if (
              ($el.css({
                position: "relative",
                left: offset,
                "box-sizing": "border-box",
                width: $(window).width(),
              }),
              !$el.data("vcStretchContent"))
            ) {
              var padding = -1 * offset;
              0 > padding && (padding = 0);
              var paddingRight =
                width -
                padding -
                $el_full.width() +
                el_margin_left +
                el_margin_right;
              0 > paddingRight && (paddingRight = 0),
                $el.css({
                  "padding-left": padding + "px",
                  "padding-right": paddingRight + "px",
                });
            }
            $el.attr("data-vc-full-width-init", "true"),
              $el.removeClass("vc_hidden"),
              $(document).trigger("vc-full-width-row-single", {
                el: $el,
                offset: offset,
                marginLeft: el_margin_left,
                marginRight: el_margin_right,
                elFull: $el_full,
                width: width,
              });
          }
        }),
          $(document).trigger("vc-full-width-row", $elements);
      }

      function parallaxRow() {
        var vcSkrollrOptions,
          callSkrollInit = !1;
        return (
          window.vcParallaxSkroll && window.vcParallaxSkroll.destroy(),
          $(".vc_parallax-inner").remove(),
          $("[data-5p-top-bottom]").removeAttr(
            "data-5p-top-bottom data-30p-top-bottom"
          ),
          $("[data-vc-parallax]").each(function () {
            var skrollrSpeed,
              skrollrSize,
              skrollrStart,
              skrollrEnd,
              $parallaxElement,
              parallaxImage,
              youtubeId;
            (callSkrollInit = !0),
              "on" === $(this).data("vcParallaxOFade") &&
                $(this)
                  .children()
                  .attr("data-5p-top-bottom", "opacity:0;")
                  .attr("data-30p-top-bottom", "opacity:1;"),
              (skrollrSize = 100 * $(this).data("vcParallax")),
              ($parallaxElement = $("<div />")
                .addClass("vc_parallax-inner")
                .appendTo($(this))),
              $parallaxElement.height(skrollrSize + "%"),
              (parallaxImage = $(this).data("vcParallaxImage")),
              (youtubeId = vcExtractYoutubeId(parallaxImage)),
              youtubeId
                ? insertYoutubeVideoAsBackground($parallaxElement, youtubeId)
                : "undefined" != typeof parallaxImage &&
                  $parallaxElement.css(
                    "background-image",
                    "url(" + parallaxImage + ")"
                  ),
              (skrollrSpeed = skrollrSize - 100),
              (skrollrStart = -skrollrSpeed),
              (skrollrEnd = 0),
              $parallaxElement
                .attr("data-bottom-top", "top: " + skrollrStart + "%;")
                .attr("data-top-bottom", "top: " + skrollrEnd + "%;");
          }),
          !(!callSkrollInit || !window.skrollr) &&
            ((vcSkrollrOptions = {
              forceHeight: !1,
              smoothScrolling: !1,
              mobileCheck: function () {
                return !1;
              },
            }),
            (window.vcParallaxSkroll = skrollr.init(vcSkrollrOptions)),
            window.vcParallaxSkroll)
        );
      }

      function fullHeightRow() {
        var $element = $(".vc_row-o-full-height:first");
        if ($element.length) {
          var $window, windowHeight, offsetTop, fullHeight;
          ($window = $(window)),
            (windowHeight = $window.height()),
            (offsetTop = $element.offset().top),
            offsetTop < windowHeight &&
              ((fullHeight = 100 - offsetTop / (windowHeight / 100)),
              $element.css("min-height", fullHeight + "vh"));
        }
        $(document).trigger("vc-full-height-row", $element);
      }

      function fixIeFlexbox() {
        var ua = window.navigator.userAgent,
          msie = ua.indexOf("MSIE ");
        (msie > 0 || navigator.userAgent.match(/Trident.*rv\:11\./)) &&
          $(".vc_row-o-full-height").each(function () {
            "flex" === $(this).css("display") &&
              $(this).wrap('<div class="vc_ie-flexbox-fixer"></div>');
          });
      }
      var $ = window.jQuery;
      $(window)
        .off("resize.vcRowBehaviour")
        .on("resize.vcRowBehaviour", fullWidthRow)
        .on("resize.vcRowBehaviour", fullHeightRow),
        fullWidthRow(),
        fullHeightRow(),
        fixIeFlexbox(),
        vc_initVideoBackgrounds(),
        parallaxRow();
    }),
  "function" != typeof window.vc_gridBehaviour &&
    (window.vc_gridBehaviour = function () {
      jQuery.fn.vcGrid && jQuery("[data-vc-grid]").vcGrid();
    }),
  "function" != typeof window.getColumnsCount &&
    (window.getColumnsCount = function (el) {
      for (var find = !1, i = 1; !1 === find; ) {
        if (el.hasClass("columns_count_" + i)) return (find = !0), i;
        i++;
      }
    });
var screen_size = getSizeName();
"function" != typeof window.wpb_prepare_tab_content &&
  (window.wpb_prepare_tab_content = function (event, ui) {
    var $ui_panel,
      $google_maps,
      panel = ui.panel || ui.newPanel,
      $pie_charts = panel.find(".vc_pie_chart:not(.vc_ready)"),
      $round_charts = panel.find(".vc_round-chart"),
      $line_charts = panel.find(".vc_line-chart"),
      $carousel = panel.find('[data-ride="vc_carousel"]');
    if (
      (vc_carouselBehaviour(),
      vc_plugin_flexslider(panel),
      ui.newPanel.find(".vc_masonry_media_grid, .vc_masonry_grid").length &&
        ui.newPanel
          .find(".vc_masonry_media_grid, .vc_masonry_grid")
          .each(function () {
            var grid = jQuery(this).data("vcGrid");
            grid &&
              grid.gridBuilder &&
              grid.gridBuilder.setMasonry &&
              grid.gridBuilder.setMasonry();
          }),
      panel.find(".vc_masonry_media_grid, .vc_masonry_grid").length &&
        panel
          .find(".vc_masonry_media_grid, .vc_masonry_grid")
          .each(function () {
            var grid = jQuery(this).data("vcGrid");
            grid &&
              grid.gridBuilder &&
              grid.gridBuilder.setMasonry &&
              grid.gridBuilder.setMasonry();
          }),
      $pie_charts.length && jQuery.fn.vcChat && $pie_charts.vcChat(),
      $round_charts.length &&
        jQuery.fn.vcRoundChart &&
        $round_charts.vcRoundChart({
          reload: !1,
        }),
      $line_charts.length &&
        jQuery.fn.vcLineChart &&
        $line_charts.vcLineChart({
          reload: !1,
        }),
      $carousel.length &&
        jQuery.fn.carousel &&
        $carousel.carousel("resizeAction"),
      ($ui_panel = panel.find(".isotope, .wpb_image_grid_ul")),
      ($google_maps = panel.find(".wpb_gmaps_widget")),
      0 < $ui_panel.length && $ui_panel.isotope("layout"),
      $google_maps.length && !$google_maps.is(".map_ready"))
    ) {
      var $frame = $google_maps.find("iframe");
      $frame.attr("src", $frame.attr("src")),
        $google_maps.addClass("map_ready");
    }
    panel.parents(".isotope").length &&
      panel.parents(".isotope").each(function () {
        jQuery(this).isotope("layout");
      });
  }),
  "function" != typeof window.vc_googleMapsPointer,
  jQuery(document).ready(function ($) {
    window.vc_js();
  });
jQuery(document).ready(function (t) {
  "undefined" == typeof t.easing.easeInOutQuad &&
    t.extend(t.easing, {
      easeInOutBack: function (t, s, i, e, r, n) {
        return (
          void 0 === n && (n = 1.70158),
          (s /= r / 2) < 1
            ? (e / 2) * (s * s * (((n *= 1.525) + 1) * s - n)) + i
            : (e / 2) * ((s -= 2) * s * (((n *= 1.525) + 1) * s + n) + 2) + i
        );
      },
    });
}),
  (function (t, s, i, e) {
    function r(s, i) {
      (this.element = s),
        "undefined" == typeof i && (i = t(this.element).data()),
        (this.settings = t.extend({}, a, i)),
        (this.settings.splitBorder =
          this.settings.splitBorder === !0 ||
          "true" === this.settings.splitBorder ||
          "1" === this.settings.splitBorder),
        (this.settings.returnValue =
          this.settings.returnValue === !0 ||
          "true" === this.settings.returnValue ||
          "1" === this.settings.returnValue),
        (this._defaults = a),
        (this._name = n),
        this.init();
    }
    var n = "gambitBeforeAfter",
      a = {
        width: 400,
        height: 300,
        direction: "vertical",
        slideOn: "hover",
        rotation: 0,
        start: 0.5,
        returnValue: !0,
        returnDelay: 5e3,
        returnDuration: 1e3,
        arrows: !0,
        arrowColor: "#fff",
        arrowSize: 7,
        arrowGap: 0,
        arrowOffset: 0,
        splitBorder: !0,
        splitBorderColor: "#fff",
        splitBorderWidth: 2,
        slider: !1,
        sliderLocation: "bottom",
        sliderBarColor: "rgba(255,255,255,.3)",
        sliderBarThickness: 8,
        sliderButtonColor: "rgba(255,255,255,.8)",
        sliderThickness: 30,
        complete: function () {},
      };
    t.extend(r.prototype, {
      init: function () {
        this.setup(), this.settings.complete();
      },
      setup: function () {
        var i = t(this.element);
        (this.settings.arrowSize = 7),
          i.css({
            maxWidth: this.settings.width,
            height: this.settings.height,
          }),
          "undefined" == typeof i.attr("id") &&
            i.attr("id", "gambit_baa_" + parseInt(1e5 * Math.random(), 10)),
          t(this.element)
            .find("> *:eq(0)")
            .addClass("image_after")
            .wrap('<div class="image_after_container"></div>')
            .find("> *:eq(0)")
            .addClass("image_after_content"),
          this.settings.splitBorder === !0 &&
            i
              .find(".image_after_container")
              .css({
                boxShadow:
                  "0 0 0 " +
                  this.settings.splitBorderWidth +
                  "px " +
                  this.settings.splitBorderColor +
                  ", inset 0 0 0 .1px " +
                  this.settings.splitBorderColor,
              }),
          this.settings.slider !== !0 ||
            navigator.userAgent.match(/Mobi/) ||
            this.createSlider(),
          this.settings.arrows &&
            ("vertical" === this.settings.direction
              ? (i.append('<div class="gambit_baa_arrow_left"></div>'),
                i.append('<div class="gambit_baa_arrow_right"></div>'))
              : (i.append('<div class="gambit_baa_arrow_up"></div>'),
                i.append('<div class="gambit_baa_arrow_down"></div>')),
            i
              .find("[class^=gambit_baa_arrow]")
              .css("borderWidth", this.settings.arrowSize),
            i
              .find("[class^=gambit_baa_arrow]")
              .css("borderColor", this.settings.arrowColor)),
          t(s).resize(t.proxy(this.adjustStartingPosition, this)),
          t(s).resize(t.proxy(this.resizeContainerAspectRatio, this)),
          this.resizeContainerAspectRatio(),
          this.adjustStartingPosition(),
          i.addClass("slide_on_" + this.settings.slideOn),
          "hover" === this.settings.slideOn || navigator.userAgent.match(/Mobi/)
            ? t("body").on(
                "mousemove touchmove touchstart",
                "#" + i.attr("id"),
                t.proxy(this.moveHandler, this)
              )
            : "click" === this.settings.slideOn &&
              t("body").on(
                "mousedown",
                "#" + i.attr("id"),
                t.proxy(this.slideDragStartHandler, this)
              ),
          (this.returnTimeout = null),
          (this.returnAnimating = !1);
      },
      resizeContainerAspectRatio: function () {
        var s = t(this.element);
        s.height((this.settings.height / this.settings.width) * s.width());
      },
      adjustStartingPosition: function () {
        this.move(this.settings.start);
      },
      createSlider: function () {
        var i = t(this.element),
          e =
            "bottom" === this.settings.sliderLocation ||
            "top" === this.settings.sliderLocation
              ? "height"
              : "width",
          r =
            "bottom" === this.settings.sliderLocation ||
            "top" === this.settings.sliderLocation
              ? "width"
              : "height",
          n = t("<div></div>").addClass("gambit_baa_slider");
        n.css({ backgroundColor: this.settings.sliderBarColor })
          .css(e, this.settings.sliderBarThickness)
          .appendTo(i);
        var a = t("<div></div>").addClass("gambit_baa_slider_button");
        a
          .css({ backgroundColor: this.settings.sliderButtonColor })
          .css(e, this.settings.sliderBarThickness)
          .css(r, this.settings.sliderButtonThickness)
          .appendTo(n),
          t("body").on(
            "mousedown",
            "#" + i.attr("id") + " .gambit_baa_slider",
            t.proxy(this.sliderAreaDragStartHandler, this)
          ),
          t("body").on(
            "mousedown",
            "#" + i.attr("id") + " .gambit_baa_slider_button",
            t.proxy(this.sliderDragStartHandler, this)
          ),
          this.sliderAdjustLocation(this.settings.start),
          t(s).resize(t.proxy(this.sliderAdjustLocation, this));
      },
      sliderAdjustLocation: function (s) {
        "undefined" == typeof s && (s = this.settings.start);
        var i = t(this.element).find(".gambit_baa_slider"),
          e = t(this.element).find(".gambit_baa_slider_button");
        if (
          "top" === this.settings.sliderLocation ||
          "bottom" === this.settings.sliderLocation
        ) {
          var r = 0,
            n = i.width() - e.width(),
            a = n * s + r;
          e.css("left", a);
        } else {
          var o = 0,
            d = i.height() - e.height(),
            h = d * s + o;
          e.css("top", h);
        }
      },
      sliderAreaDragStartHandler: function (t) {
        t.preventDefault(),
          this.sliderDragStartHandler(t),
          this.sliderDragMoveHandler(t);
      },
      sliderDragStartHandler: function (s) {
        return (
          s.preventDefault(),
          this.returnAnimating
            ? !1
            : t(this.element)
                .find(".gambit_baa_slider_button")
                .hasClass("gambit_dragging")
            ? !1
            : void t(this.element)
                .find(".gambit_baa_slider_button")
                .addClass("gambit_dragging")
                .parents()
                .on("mousemove", t.proxy(this.sliderDragMoveHandler, this))
                .on("mouseup", t.proxy(this.sliderDragEndHandler, this))
        );
      },
      sliderDragMoveHandler: function (s) {
        if ((s.preventDefault(), this.returnAnimating)) return !1;
        var i = t(this.element).find(".gambit_baa_slider"),
          e = t(this.element).find(".gambit_baa_slider_button"),
          r = 0;
        if (
          "top" === this.settings.sliderLocation ||
          "bottom" === this.settings.sliderLocation
        ) {
          var n = 0,
            a = i.width() - e.width(),
            o = s.pageX - i.offset().left - e.width() / 2;
          n > o ? (o = n) : o > a && (o = a),
            (r = o / (a - n)),
            e.css("left", o);
        } else {
          var d = 0,
            h = i.height() - e.height(),
            g = s.pageY - i.offset().top - e.height() / 2;
          d > g ? (g = d) : g > h && (g = h),
            (r = g / (h - d)),
            e.css("top", g);
        }
        this.move(r);
      },
      sliderDragEndHandler: function (s) {
        s.preventDefault(),
          t(this.element)
            .find(".gambit_baa_slider_button")
            .removeClass("gambit_dragging")
            .parents()
            .off("mousemove", t.proxy(this.sliderDragMoveHandler, this))
            .off("mouseup", t.proxy(this.sliderDragEndHandler, this));
      },
      slideDragStartHandler: function (s) {
        return (
          s.preventDefault(),
          this.returnAnimating
            ? !1
            : t(this.element).hasClass("gambit_dragging")
            ? !1
            : void t(this.element)
                .addClass("gambit_dragging")
                .parents()
                .on("mousemove", t.proxy(this.slideDragHandler, this))
                .on("mouseup", t.proxy(this.slideDragEndHandler, this))
        );
      },
      slideDragHandler: function (s) {
        if ((s.preventDefault(), this.returnAnimating)) return !1;
        var i,
          e = t(this.element);
        (i =
          "vertical" === this.settings.direction
            ? (s.pageX - e.offset().left) / e.width()
            : (s.pageY - e.offset().top) / e.height()),
          this.move(i);
      },
      slideDragEndHandler: function (s) {
        s.preventDefault(),
          t(this.element)
            .removeClass("gambit_dragging")
            .parents()
            .off("mousemove", t.proxy(this.slideDragHandler, this))
            .off("mouseup", t.proxy(this.slideDragEndHandler, this));
      },
      moveHandler: function (s) {
        if ((s.preventDefault(), !this.returnAnimating)) {
          var i,
            e = t(this.element);
          (i =
            "vertical" === this.settings.direction
              ? "undefined" != typeof s.pageX
                ? (s.pageX - e.offset().left) / e.width()
                : (s.originalEvent.touches[0].pageX - e.offset().left) /
                  e.width()
              : "undefined" != typeof s.pageY
              ? (s.pageY - e.offset().top) / e.height()
              : (s.originalEvent.touches[0].pageY - e.offset().top) /
                e.height()),
            this.move(i);
        }
      },
      move: function (s) {
        var i = t(this.element),
          e = i.width(),
          r = i.height(),
          n = (this.settings.rotation * Math.PI) / 180,
          a = Math.tan(n),
          o = Math.cos(n),
          d = e * a,
          h = r * a,
          g = e / o - (e / 2 + (r / 2) * a),
          l = g + e + h,
          f = r / o - (r / 2 + (e / 2) * a),
          m = f + r + d;
        if (this.settings.splitBorder) {
          var u = 2 * (this.settings.splitBorderWidth + 2) * a + 1;
          (l += u), (m += u);
        }
        this.settings.rotation < 0 && ((g += h), (l -= h), (f += d), (m -= d));
        var p, c, b, _, v, w, x, T, y, D, B;
        "vertical" === this.settings.direction
          ? ((p = -s * (l - g) + l),
            (c =
              "translateX(" +
              -p +
              "px) rotate(" +
              this.settings.rotation +
              "deg) translateZ(0)"),
            (b =
              "rotate(" +
              -this.settings.rotation +
              "deg)  translateX(" +
              p +
              "px) translateZ(0)"),
            (_ =
              "translateX(" +
              -p +
              "px) rotate(" +
              this.settings.rotation +
              "deg)"),
            (v =
              "rotate(" +
              -this.settings.rotation +
              "deg)  translateX(" +
              p +
              "px)"),
            i
              .find(".image_after_container")
              .css({
                top: "-" + (r / 2) * 5 + "px",
                bottom: "-" + (r / 2) * 5 + "px",
                left: "-" + e / 2 + "px",
                right: "-" + e / 2 + "px",
                webkitTransform: c,
                mozTransform: c,
                msTransform: _,
                otransform: c,
                transform: c,
              }),
            i
              .find(".image_after")
              .css({
                top: (r / 2) * 5 + "px",
                bottom: (r / 2) * 5 + "px",
                left: e / 2 + "px",
                right: e / 2 + "px",
                webkitTransform: b,
                mozTransform: b,
                msTransform: v,
                oTransform: b,
                transform: b,
              }),
            this.settings.arrows &&
              ((w = a * this.settings.splitBorderWidth),
              (T =
                this.settings.splitBorderWidth /
                Math.sin(((90 - this.settings.rotation) * Math.PI) / 180)),
              (y =
                this.settings.arrowSize /
                Math.sin(((90 - this.settings.rotation) * Math.PI) / 180)),
              (x =
                s * (e + a * (r / 2) * 2 + T + y / 2) -
                a * (r / 2) -
                T / 2 -
                y / 2),
              (D =
                "translateY(-50%) translateX(" +
                (x - y - w - this.settings.arrowGap + 1) +
                "px) rotate(" +
                this.settings.rotation +
                "deg) translateY(" +
                -this.settings.arrowOffset +
                "px)"),
              (B =
                "translateY(-50%) translateX(" +
                (x - w + T + this.settings.arrowGap) +
                "px) rotate(" +
                this.settings.rotation +
                "deg) translateY(" +
                this.settings.arrowOffset +
                "px)"),
              i
                .find(".gambit_baa_arrow_left")
                .css({
                  webkitTransform: D,
                  mozTransform: D,
                  msTransform: D,
                  oTransform: D,
                  transform: D,
                }),
              i
                .find(".gambit_baa_arrow_right")
                .css({
                  webkitTransform: B,
                  mozTransform: B,
                  msTransform: B,
                  oTransform: B,
                  transform: B,
                })))
          : ((p = -s * (m - f) + m),
            (c =
              "translateY(" +
              -p +
              "px) rotate(" +
              this.settings.rotation +
              "deg) translateZ(0)"),
            (b =
              "rotate(" +
              -this.settings.rotation +
              "deg)  translateY(" +
              p +
              "px) translateZ(0)"),
            (_ =
              "translateY(" +
              -p +
              "px) rotate(" +
              this.settings.rotation +
              "deg)"),
            (v =
              "rotate(" +
              -this.settings.rotation +
              "deg)  translateY(" +
              p +
              "px)"),
            i
              .find(".image_after_container")
              .css({
                top: "-" + r / 2 + "px",
                bottom: "-" + r / 2 + "px",
                left: "-" + (e / 2) * 5 + "px",
                right: "-" + (e / 2) * 5 + "px",
                webkitTransform: c,
                mozTransform: c,
                msTransform: _,
                oTransform: c,
                transform: c,
              }),
            i
              .find(".image_after")
              .css({
                top: r / 2 + "px",
                bottom: r / 2 + "px",
                left: (e / 2) * 5 + "px",
                right: (e / 2) * 5 + "px",
                webkitTransform: b,
                mozTransform: b,
                msTransform: v,
                oTransform: b,
                transform: b,
              }),
            this.settings.arrows &&
              ((w = a * this.settings.splitBorderWidth),
              (T =
                this.settings.splitBorderWidth /
                Math.sin(((90 - this.settings.rotation) * Math.PI) / 180)),
              (y =
                this.settings.arrowSize /
                Math.sin(((90 - this.settings.rotation) * Math.PI) / 180)),
              (x =
                s * (r + a * (e / 2) * 2 + T + y / 2) -
                a * (e / 2) -
                T / 2 -
                y / 2),
              (D =
                "translateX(-50%) translateY(" +
                (x - y - w - this.settings.arrowGap + 1) +
                "px) rotate(" +
                this.settings.rotation +
                "deg) translateX(" +
                -this.settings.arrowOffset +
                "px)"),
              (B =
                "translateX(-50%) translateY(" +
                (x - w + T + this.settings.arrowGap) +
                "px) rotate(" +
                this.settings.rotation +
                "deg) translateX(" +
                this.settings.arrowOffset +
                "px)"),
              i
                .find(".gambit_baa_arrow_up")
                .css({
                  webkitTransform: D,
                  mozTransform: D,
                  msTransform: D,
                  oTransform: D,
                  transform: D,
                }),
              i
                .find(".gambit_baa_arrow_down")
                .css({
                  webkitTransform: B,
                  mozTransform: B,
                  msTransform: B,
                  oTransform: B,
                  transform: B,
                }))),
          this.sliderAdjustLocation(s),
          this.settings.returnValue &&
            ((this.position = s),
            null !== this.returnTimeout &&
              (clearTimeout(this.returnTimeout), (this.returnTimeout = null)),
            (this.returnTimeout = setTimeout(
              t.proxy(this.returnPosition, this),
              this.settings.returnDelay
            )));
      },
      returnPosition: function () {
        t({ z: this.position }).animate(
          { z: this.settings.start },
          {
            duration: this.settings.returnDuration,
            easing: "easeInOutBack",
            step: t.proxy(this._returnPositionStep, this),
            start: t.proxy(this._returnPositionStart, this),
            complete: t.proxy(this._returnPositionComplete, this),
          }
        );
      },
      _returnPositionStart: function () {
        this.returnAnimating = !0;
      },
      _returnPositionComplete: function () {
        this.returnAnimating = !1;
      },
      _returnPositionStep: function (t) {
        this.move(t);
      },
    }),
      (t.fn[n] = function (s) {
        return (
          this.each(function () {
            t.data(this, "plugin_" + n) ||
              t.data(this, "plugin_" + n, new r(this, s));
          }),
          this
        );
      });
  })(jQuery, window, document),
  document.addEventListener("DOMContentLoaded", function () {
    var t = document.querySelectorAll(".vc_tta-tab");
    Array.prototype.forEach.call(t, function (t) {
      t.addEventListener("mouseup", function () {
        setTimeout(function () {
          window.dispatchEvent(new Event("resize"));
        }, 1);
      });
    });
  }),
  jQuery(document).ready(function (t) {
    t(".gambit_baa").gambitBeforeAfter();
  });
